import styled, { keyframes, createGlobalStyle, css } from 'styled-components';
import PropTypes__default, { func, string } from 'prop-types';
import { Flex, IconAction, withColors, withMargins, Link as Link$2, withFlex, Container as Container$7, Text, Alertbox, ErrorLink, Divider as Divider$2, Button, Modal as Modal$1, TextInput as TextInput$1, ToggleSwitch, Radio, LogoOLX, Spinner, Checkbox } from '@olxbr/ds-web';
import React, { useState, useEffect, useRef, Component as Component$2, forwardRef, createContext, useContext } from 'react';
import axiosBase from 'axios';
import { encode, decode } from 'base-64';
import GoogleLogin from 'react-google-login';
import { Google, Facebook, AlertTriangle, CheckCircle, Phone } from '@olxbr/ds-icons';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import Icons, { System } from '@olxbr/olx-icons';
import TurnstileCaptcha from 'react-turnstile';
import { ErrorMsg, View as View$1, Text as Text$1, Button as Button$1, SuccessMessage, theme, ToastMessage, Card, LoadingBackdrop as LoadingBackdrop$1, Link as Link$3, Title as Title$9, Paper as Paper$1, UserAvatar } from '@olxbr/design-system';
import { conformToMask } from 'text-mask-core';
import Trash from '@olxbr/olx-icons/dist/System/Trash';
import { CSSTransition } from 'react-transition-group';
import { BottomSheet as BottomSheet$1 } from 'react-spring-bottom-sheet';
import CreditCard from '@olxbr/olx-icons/dist/System/CreditCard';
import Shield from '@olxbr/olx-icons/dist/System/Shield';
import Clipboard from '@olxbr/olx-icons/dist/System/Clipboard';
import Bell from '@olxbr/olx-icons/dist/System/Bell';
import Award from '@olxbr/olx-icons/dist/System/Award';
import TimeAgo from 'javascript-time-ago';
import pt from 'javascript-time-ago/locale/pt';
import Reaptcha from 'reaptcha';
import { useForm, Controller } from 'react-hook-form';
import { termosDeUso, politicaDePrivacidade } from '@olxbr/design-system/web/config/staticUrl';
import MailCheck$1 from 'react-mailcheck';
import httpStatus from 'http-status';
import { View as View$2 } from '@olxbr/design-system/web';
import Lock from '@olxbr/olx-icons/dist/System/Lock';
import { AlertTriangle as AlertTriangle$1, ArrowLeft } from '@olxbr/olx-icons/dist/System';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;
var sizes = {
  label: {
    width: '30%'
  },
  input: {
    height: 'var(--font-size-xxxl)',
    radius: 'var(--border-radius-xs)'
  },
  title: {
    width: '40%',
    height: 'var(--font-size-lg)'
  },
  button: {
    width: '40%',
    height: 'var(--font-size-xxxl)',
    radius: 'var(--border-radius-lg)'
  },
  "default": {
    width: '100%',
    height: 'var(--font-size-md)'
  }
};
var units = ['px', '%', 'rem', 'em', 'var'];

var handleUnit = function handleUnit(value) {
  if (!value) return '100%';
  if (units.find(function (x) {
    return value.indexOf(x) > -1;
  })) return value;
  return value + "px";
};

var handleSize = function handleSize(prop, props) {
  var value = sizes["default"][prop];

  if (props.type === 'custom') {
    if (props[prop]) {
      value = handleUnit(props[prop]);
    }
  } else if (sizes[props.type][prop]) {
    value = sizes[props.type][prop];
  }

  return value;
};

var Skeleton = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  background-color: var(--color-neutral-light);\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n"])), function (props) {
  return handleSize('width', props);
}, function (props) {
  return handleSize('height', props);
}, function (props) {
  return handleSize('radius', props);
});
Skeleton.propTypes = {
  type: PropTypes__default.oneOf(['custom', 'label', 'input', 'title', 'button'])
};
Skeleton.defaultProps = {
  type: 'custom'
};

var _excluded = ["children"];

var _templateObject$1;
var StyledIcon = styled(IconAction)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  & > .ds-link-icon-wrapper {\n    background-color: ", ";\n  }\n"])), withColors, withMargins, function (_ref) {
  var customBgColor = _ref.customBgColor,
      bgColor = _ref.bgColor;
  return customBgColor || "var(" + bgColor + ")";
});

var IconButton = function IconButton(_ref2) {
  var children = _ref2.children,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    className: "interactive",
    color: "--color-neutral-70",
    icon: children
  }, restProps));
};

IconButton.propTypes = {
  onClick: func.isRequired,
  customBgColor: string
};

var white = [{
  d: 'M457.732 216.625c2.628 14.041 4.063 28.743 4.063 44.098C461.796 380.688 381.481 466 260.204 466c-116.023 0-210-93.977-210-210s93.977-210 210-210c56.704 0 104.077 20.867 140.44 54.73l-59.204 59.197v-.135c-22.046-21.002-50-31.762-81.236-31.762-69.297 0-125.604 58.537-125.604 127.841 0 69.29 56.306 127.968 125.604 127.968 62.87 0 105.653-35.965 114.46-85.312h-114.46v-81.902h197.528z',
  fill: '#ffff'
}];

var colored = [{
  fill: '#fbbb00',
  d: 'M113.47 309.408L95.648 375.94l-65.139 1.378C11.042 341.211 0 299.9 0 256c0-42.451 10.324-82.483 28.624-117.732h.014L86.63 148.9l25.404 57.644c-5.317 15.501-8.215 32.141-8.215 49.456.002 18.792 3.406 36.797 9.651 53.408z'
}, {
  fill: '#518ef8',
  d: 'M507.527 208.176C510.467 223.662 512 239.655 512 256c0 18.328-1.927 36.206-5.598 53.451-12.462 58.683-45.025 109.925-90.134 146.187l-.014-.014-73.044-3.727-10.338-64.535c29.932-17.554 53.324-45.025 65.646-77.911h-136.89V208.176h245.899z'
}, {
  fill: '#28b446',
  d: 'M416.253 455.624l.014.014C372.396 490.901 316.666 512 256 512c-97.491 0-182.252-54.491-225.491-134.681l82.961-67.91c21.619 57.698 77.278 98.771 142.53 98.771 28.047 0 54.323-7.582 76.87-20.818l83.383 68.262z'
}, {
  fill: '#f14336',
  d: 'M419.404 58.936l-82.933 67.896C313.136 112.246 285.552 103.82 256 103.82c-66.729 0-123.429 42.957-143.965 102.724l-83.397-68.276h-.014C71.23 56.123 157.06 0 256 0c62.115 0 119.068 22.126 163.404 58.936z'
}];

var variants = {
  gray: {
    background: '#ececec',
    text: '--color-neutral-darkest',
    icon: colored
  },
  blue: {
    background: '#4285f4',
    text: '--color-neutral-70',
    icon: white
  },
  red: {
    background: '#d43427',
    text: '--color-neutral-70',
    icon: white
  }
};

var kongProdUrl = 'https://apigw.olx.com.br';
axiosBase.defaults.baseURL = process.env.REACT_APP_KONG_URL || kongProdUrl;
axiosBase.defaults.headers.post['Content-Type'] = 'application/json';
axiosBase.defaults.withCredentials = true;
axiosBase.defaults.timeout = 10000;
var setDefaultUrl = function setDefaultUrl(baseUrl) {
  axios.defaults.baseURL = baseUrl;
};
var setAuthHeader = function setAuthHeader(accessToken) {
  axios.defaults.headers.common.Authorization = accessToken;
};
var removeAuthHeader = function removeAuthHeader() {
  axios.defaults.headers.common.Authorization = undefined;
};
var axios = axiosBase.create({
  headers: {
    'X-OLX-TEAM-KEY': '5XzjuCgmYE7qMlYpsLZbTvm98ik4CS4a'
  }
});

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

// Asynchronously await a promise and pass the result to a finally continuation
function _finallyRethrows(body, finalizer) {
	try {
		var result = body();
	} catch (e) {
		return finalizer(true, e);
	}
	if (result && result.then) {
		return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
	}
	return finalizer(false, result);
}

function set(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (ex) {}
}
function get(key) {
  try {
    return Promise.resolve(localStorage.getItem(key));
  } catch (ex) {
    return Promise.resolve();
  }
}
function remove(key) {
  try {
    return Promise.resolve(localStorage.removeItem(key));
  } catch (ex) {
    return Promise.resolve();
  }
}
var storage = {
  get: get,
  set: set,
  remove: remove
};

var KEY = 'ACC_LL';
var EMAIL = '0';
var FACEBOOK = '1';
var GOOGLE = '2';

var saveEmailLogin = function saveEmailLogin(_ref) {
  var email = _ref.email;

  if (email) {
    set(KEY, EMAIL + "|" + encode(email));
  }
};

var saveFacebookLogin = function saveFacebookLogin(_ref2) {
  var facebookId = _ref2.facebookId;

  if (facebookId) {
    set(KEY, FACEBOOK + "|" + encode(facebookId));
  }
};

var saveGoogleLogin = function saveGoogleLogin(_ref3) {
  var googleId = _ref3.googleId;

  if (googleId) {
    set(KEY, GOOGLE + "|" + encode(googleId));
  }
};

var getLastLogin = function getLastLogin() {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(get(KEY)).then(function (value) {
        var _ref4 = value ? value.split('|') : [undefined, undefined],
            type = _ref4[0],
            data = _ref4[1];

        switch (type) {
          case EMAIL:
            return {
              type: 'email',
              id: decode(data)
            };

          case FACEBOOK:
            return {
              type: 'facebook',
              id: decode(data)
            };

          case GOOGLE:
            return {
              type: 'google',
              id: decode(data)
            };

          default:
            return {
              type: 'login'
            };
        }
      });
    }, function () {
      return {
        type: 'login'
      };
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var removeLastLogin = function removeLastLogin() {
  return remove(KEY);
};

var lastLoginStorage = {
  saveEmailLogin: saveEmailLogin,
  saveFacebookLogin: saveFacebookLogin,
  saveGoogleLogin: saveGoogleLogin,
  getLastLogin: getLastLogin,
  removeLastLogin: removeLastLogin
};

var platform = 'WEB';

var googleLoginApiCall = (function (idToken) {
  return axios.post('/v1/user/google', {
    idToken: idToken,
    platform: platform
  }, {
    withCredentials: true
  }).then(function (response) {
    var data = response.data;
    lastLoginStorage.saveGoogleLogin(data);
    return response;
  });
});

var GoogleSignIn = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GoogleSignIn, _React$Component);

  function GoogleSignIn(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onFailure = function (_ref) {
      var _ref$error = _ref.error,
          error = _ref$error === void 0 ? 'unknown' : _ref$error,
          _ref$details = _ref.details,
          details = _ref$details === void 0 ? 'unknown' : _ref$details;
      var _this$props = _this.props,
          onCancel = _this$props.onCancel,
          onError = _this$props.onError;
      var message = error + ": " + details;

      switch (error) {
        case 'popup_closed_by_user':
          if (typeof onCancel === 'function') {
            onCancel(message);
          }

          break;

        case 'idpiframe_initialization_failed':
          _this.setState({
            initializationErrorCode: 'google_initialization_error',
            initializationErrorMessage: details || 'unknown'
          });

          break;

        default:
          if (typeof onError === 'function') {
            onError({
              code: 'google_unexpected_error',
              message: message
            });
          }

      }
    };

    _this.onClick = function (callback) {
      return function () {
        var onError = _this.props.onError;
        var _this$state = _this.state,
            initializationErrorCode = _this$state.initializationErrorCode,
            initializationErrorMessage = _this$state.initializationErrorMessage;

        if (initializationErrorCode) {
          if (typeof onError === 'function') {
            onError({
              code: initializationErrorCode,
              message: initializationErrorMessage
            });
          }

          return;
        }

        callback.apply(void 0, arguments);
      };
    };

    _this.state = {
      initializationErrorCode: '',
      initializationErrorMessage: ''
    };
    return _this;
  }

  var _proto = GoogleSignIn.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        _render = _this$props2.render,
        onSuccess = _this$props2.onSuccess,
        clientId = _this$props2.clientId;
    return /*#__PURE__*/React.createElement(GoogleLogin, {
      clientId: clientId,
      onSuccess: onSuccess,
      onFailure: this.onFailure,
      cookiePolicy: "single_host_origin",
      render: function render(_ref2) {
        var callback = _ref2.onClick;
        return _render({
          onClick: _this2.onClick(callback)
        });
      }
    });
  };

  return GoogleSignIn;
}(React.Component);

GoogleSignIn.propTypes = {
  onCancel: PropTypes__default.func,
  onError: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  render: PropTypes__default.func.isRequired,
  clientId: PropTypes__default.string.isRequired
};

var CLIENT_ID = '478370423031-748nbrdqm97onrnabd504u24bdd3nim1.apps.googleusercontent.com';

var GoogleSignIn$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GoogleSignIn$1, _React$Component);

  function GoogleSignIn$1() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.onSuccess = function (_ref) {
      var tokenId = _ref.tokenId;
      var _this$props = _this.props,
          onSuccess = _this$props.onSuccess,
          onError = _this$props.onError;
      googleLoginApiCall(tokenId).then(function (_ref2) {
        var data = _ref2.data;
        var remoteAddress = data.remoteAddress,
            accountJustCreated = data.accountJustCreated;

        if (accountJustCreated) {
          if (window) {
            var _window2 = window,
                dataLayer = _window2.dataLayer;

            if (dataLayer) {
              dataLayer.push({
                event: 'gg_signup_success'
              });
            }
          }

          _this.viewMessageEvt('google_signup_success', {
            remote_addr: remoteAddress
          });

          _this.sendTrackerEvent('sign_up_google', {
            remote_addr: remoteAddress
          });
        } else {
          _this.viewMessageEvt('google_login_success', {
            remote_addr: remoteAddress
          });
        }

        if (typeof onSuccess === 'function') {
          onSuccess(data);
        }
      })["catch"](function (error) {
        var _error$response = error.response,
            _error$response2 = _error$response === void 0 ? {} : _error$response,
            status = _error$response2.status,
            _error$message = error.message,
            message = _error$message === void 0 ? 'unknown' : _error$message;

        if (status) {
          _this.viewMessageEvt('error', {
            accounts_reason: 'google_unexpected_status_code',
            accounts_status_code: status
          });
        } else {
          _this.viewMessageEvt('error', {
            accounts_reason: 'google_unexpected_error',
            accounts_error_message: message
          });
        }

        if (typeof onError === 'function') {
          onError('api_error');
        }
      });
    };

    _this.onFailure = function (error) {
      var _error$code = error.code,
          code = _error$code === void 0 ? 'unknown' : _error$code,
          _error$message2 = error.message,
          message = _error$message2 === void 0 ? 'unknown' : _error$message2;
      var onError = _this.props.onError;

      _this.viewMessageEvt('error', {
        accounts_reason: code,
        accounts_error_message: message
      });

      if (typeof onError === 'function') {
        onError(code);
      }
    };

    _this.onCancel = function (error) {
      if (error === void 0) {
        error = 'unknown';
      }

      var onCancel = _this.props.onCancel;

      _this.viewMessageEvt('error', {
        accounts_reason: 'google_cancelled_by_user',
        accounts_error_message: error
      });

      if (typeof onCancel === 'function') {
        onCancel();
      }
    };

    _this.onClick = function (callback) {
      var onSubmit = _this.props.onSubmit;
      return function () {
        _this.clickEvt('google');

        if (typeof onSubmit === 'function') {
          onSubmit();
        }

        callback.apply(void 0, arguments);
      };
    };

    _this.viewMessageEvt = function (objectDetail, data) {
      var lurker = _this.props.lurker;

      if (lurker && typeof lurker.viewMessageEvt === 'function') {
        lurker.viewMessageEvt(objectDetail, data);
      }
    };

    _this.sendTrackerEvent = function (event, data) {
      var tracker = _this.props.tracker;

      if (tracker && typeof tracker.viewMessageEvt === 'function') {
        tracker.viewMessageEvt(event, data);
      }
    };

    _this.clickEvt = function (objectDetail) {
      var lurker = _this.props.lurker;

      if (lurker && typeof lurker.clickEvt === 'function') {
        lurker.clickEvt(objectDetail);
      }
    };

    return _this;
  }

  var _proto = GoogleSignIn$1.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _render = this.props.render;
    return /*#__PURE__*/React.createElement(GoogleSignIn, {
      onSuccess: this.onSuccess,
      onError: this.onFailure,
      onCancel: this.onCancel,
      clientId: CLIENT_ID,
      render: function render(_ref3) {
        var callback = _ref3.onClick;
        return _render({
          onClick: _this2.onClick(callback)
        });
      }
    });
  };

  return GoogleSignIn$1;
}(React.Component);

GoogleSignIn$1.propTypes = {
  onCancel: PropTypes__default.func,
  onError: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  render: PropTypes__default.func.isRequired,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object
};

var _excluded$1 = ["variant", "onSubmit", "onError", "onCancel", "onUserLoggedIn", "lurker", "tracker"];

var GoogleIconButton = function GoogleIconButton(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'blue' : _ref$variant,
      onSubmit = _ref.onSubmit,
      onError = _ref.onError,
      onCancel = _ref.onCancel,
      onUserLoggedIn = _ref.onUserLoggedIn,
      lurker = _ref.lurker,
      tracker = _ref.tracker,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement(GoogleSignIn$1, {
    onCancel: onCancel,
    onError: onError,
    onSubmit: onSubmit,
    onSuccess: onUserLoggedIn,
    lurker: lurker,
    tracker: tracker,
    render: function render(_ref2) {
      var onClick = _ref2.onClick;
      return /*#__PURE__*/React.createElement(IconButton, _extends({
        onClick: onClick,
        color: variants[variant].text,
        customBgColor: variants[variant].background,
        size: "large",
        "aria-label": "Login Google"
      }, restProps), /*#__PURE__*/React.createElement(Google, null));
    }
  });
};

GoogleIconButton.propTypes = {
  onCancel: PropTypes__default.func,
  onError: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onUserLoggedIn: PropTypes__default.func,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object
};

var facebookLoginApiCall = (function (accessToken, email, nickname) {
  return axios.post('/v1/user/facebook', {
    accessToken: accessToken,
    email: email,
    nickname: nickname,
    platform: platform,
    mktApp: true
  }, {
    withCredentials: true
  }).then(function (response) {
    var data = response.data;
    lastLoginStorage.saveFacebookLogin(data);
    return response;
  });
});

var APP_ID = '106401512762894';

var FacebookSignIn = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FacebookSignIn, _React$Component);

  function FacebookSignIn() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onFailure = function (error) {
      var _this$props = _this.props,
          onCancel = _this$props.onCancel,
          onError = _this$props.onError;

      if (error && error.status) {
        if (typeof onCancel === 'function') {
          onCancel(error.status);
        }

        return;
      }

      if (typeof onError === 'function') {
        onError({
          code: 'facebook_unexpected_error',
          message: JSON.stringify(error)
        });
      }
    };

    return _this;
  }

  var _proto = FacebookSignIn.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        _render = _this$props2.render,
        onSuccess = _this$props2.onSuccess,
        facebookAppId = _this$props2.facebookAppId;
    var appId = facebookAppId || APP_ID;
    return /*#__PURE__*/React.createElement(FacebookLogin, {
      appId: appId,
      autoLoad: false,
      disableMobileRedirect: true,
      callback: onSuccess,
      onFailure: this.onFailure,
      render: function render(_ref) {
        var onClick = _ref.onClick;
        return _render({
          onClick: onClick
        });
      }
    });
  };

  return FacebookSignIn;
}(React.Component);

FacebookSignIn.propTypes = {
  onCancel: PropTypes__default.func,
  onError: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  render: PropTypes__default.func.isRequired
};

var FacebookSignIn$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FacebookSignIn$1, _React$Component);

  function FacebookSignIn$1() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.onSuccess = function (_ref) {
      var accessToken = _ref.accessToken,
          name = _ref.name,
          userID = _ref.userID;
      var _this$props = _this.props,
          onSuccess = _this$props.onSuccess,
          onError = _this$props.onError,
          onRequireEmail = _this$props.onRequireEmail;

      if (accessToken) {
        facebookLoginApiCall(accessToken, null, null).then(function (_ref2) {
          var data = _ref2.data;
          var remoteAddress = data.remoteAddress,
              accountJustCreated = data.accountJustCreated;

          if (accountJustCreated) {
            _this.viewMessageEvt('facebook_signup_success', {
              remote_addr: remoteAddress
            });

            _this.sendTrackerEvent('sign_up_facebook', {
              remote_addr: remoteAddress
            });
          } else {
            _this.viewMessageEvt('facebook_login_success', {
              remote_addr: remoteAddress
            });
          }

          if (typeof onSuccess === 'function') {
            onSuccess(data);
          }
        })["catch"](function (error) {
          var _error$response = error.response,
              _error$response2 = _error$response === void 0 ? {} : _error$response,
              status = _error$response2.status,
              _error$message = error.message,
              message = _error$message === void 0 ? 'unknown' : _error$message;

          if (status === 422) {
            _this.viewMessageEvt('error', {
              accounts_reason: 'facebook_no_email_provided',
              accounts_error_code: status
            });

            if (typeof onRequireEmail === 'function') {
              onRequireEmail(userID, accessToken, name);
              return;
            }
          } else if (status) {
            _this.viewMessageEvt('error', {
              accounts_reason: 'facebook_unexpected_status_code',
              accounts_status_code: status
            });
          } else {
            _this.viewMessageEvt('error', {
              accounts_reason: 'facebook_unexpected_error',
              accounts_error_message: message
            });
          }

          if (typeof onError === 'function') {
            onError('api_error');
          }
        });
      }
    };

    _this.onFailure = function (error) {
      var _error$code = error.code,
          code = _error$code === void 0 ? 'unknown' : _error$code,
          _error$message2 = error.message,
          message = _error$message2 === void 0 ? 'unknown' : _error$message2;
      var onError = _this.props.onError;

      _this.viewMessageEvt('error', {
        accounts_reason: code,
        accounts_error_message: message
      });

      if (typeof onError === 'function') {
        onError(code);
      }
    };

    _this.onCancel = function (error) {
      if (error === void 0) {
        error = 'unknown';
      }

      var onCancel = _this.props.onCancel;

      _this.viewMessageEvt('error', {
        accounts_reason: 'facebook_cancelled_by_user',
        accounts_error_message: error
      });

      if (typeof onCancel === 'function') {
        onCancel();
      }
    };

    _this.onClick = function (callback) {
      var onSubmit = _this.props.onSubmit;
      return function () {
        _this.clickEvt('facebook');

        if (typeof onSubmit === 'function') {
          onSubmit();
        }

        callback.apply(void 0, arguments);
      };
    };

    _this.viewMessageEvt = function (objectDetail, data) {
      var lurker = _this.props.lurker;

      if (lurker && typeof lurker.viewMessageEvt === 'function') {
        lurker.viewMessageEvt(objectDetail, data);
      }
    };

    _this.sendTrackerEvent = function (event, data) {
      var tracker = _this.props.tracker;

      if (tracker && typeof tracker.viewMessageEvt === 'function') {
        tracker.viewMessageEvt(event, data);
      }
    };

    _this.clickEvt = function (objectDetail) {
      var lurker = _this.props.lurker;

      if (lurker && typeof lurker.clickEvt === 'function') {
        lurker.clickEvt(objectDetail);
      }
    };

    return _this;
  }

  var _proto = FacebookSignIn$1.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        _render = _this$props2.render,
        facebookAppId = _this$props2.facebookAppId;
    return /*#__PURE__*/React.createElement(FacebookSignIn, {
      facebookAppId: facebookAppId,
      onSuccess: this.onSuccess,
      onError: this.onFailure,
      onCancel: this.onCancel,
      render: function render(_ref3) {
        var callback = _ref3.onClick;
        return _render({
          onClick: _this2.onClick(callback)
        });
      }
    });
  };

  return FacebookSignIn$1;
}(React.Component);

FacebookSignIn$1.propTypes = {
  facebookAppId: PropTypes__default.string,
  onCancel: PropTypes__default.func,
  onError: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  render: PropTypes__default.func.isRequired,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object
};

var _excluded$2 = ["onCancel", "onError", "onRequireEmail", "onSubmit", "onUserLoggedIn", "lurker", "tracker", "facebookAppId"];

var FacebookIconButton = function FacebookIconButton(_ref) {
  var onCancel = _ref.onCancel,
      onError = _ref.onError,
      onRequireEmail = _ref.onRequireEmail,
      onSubmit = _ref.onSubmit,
      onUserLoggedIn = _ref.onUserLoggedIn,
      lurker = _ref.lurker,
      tracker = _ref.tracker,
      facebookAppId = _ref.facebookAppId,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement(FacebookSignIn$1, {
    onCancel: onCancel,
    facebookAppId: facebookAppId,
    onError: onError,
    onRequireEmail: onRequireEmail,
    onSubmit: onSubmit,
    onSuccess: onUserLoggedIn,
    lurker: lurker,
    tracker: tracker,
    render: function render(_ref2) {
      var onClick = _ref2.onClick;
      return /*#__PURE__*/React.createElement(IconButton, _extends({
        onClick: onClick,
        color: "--color-neutral-70",
        customBgColor: "#3a5998",
        size: "large",
        "aria-label": "Login Facebook"
      }, restProps), /*#__PURE__*/React.createElement(Facebook, null));
    }
  });
};

FacebookIconButton.propTypes = {
  onCancel: PropTypes__default.func,
  onError: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onUserLoggedIn: PropTypes__default.func,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object
};

var Separator = function Separator(_ref) {
  var turns = _ref.turns,
      style = _ref.style;
  return /*#__PURE__*/React.createElement(Flex, {
    style: {
      position: 'absolute',
      height: '100%',
      transform: "rotate(" + turns + "turn)"
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    style: style
  }));
};

var RadialProgressSeparator = function RadialProgressSeparator(_ref2) {
  var count = _ref2.count,
      style = _ref2.style;
  var turns = 1 / count;
  var separators = [];

  for (var i = 1; i <= count; i++) {
    separators.push( /*#__PURE__*/React.createElement(Separator, {
      key: i,
      turns: i * turns,
      style: style
    }));
  }

  return separators;
};
RadialProgressSeparator.propTypes = {
  count: PropTypes__default.number,
  style: PropTypes__default.object
};
RadialProgressSeparator.defaultProps = {
  count: 4,
  style: {
    background: '#fff',
    width: '3px',
    height: '6%'
  }
};

var _templateObject$2;
var Container = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  .CircularProgressbar {\n    width: 100%;\n    vertical-align: middle;\n  }\n\n  .CircularProgressbar .CircularProgressbar-path {\n    stroke: #3e98c7;\n    stroke-linecap: round;\n    transition: stroke-dashoffset 0.5s ease 0s;\n  }\n\n  .CircularProgressbar .CircularProgressbar-trail {\n    stroke: #d6d6d6;\n    stroke-linecap: round;\n  }\n\n  .CircularProgressbar .CircularProgressbar-text {\n    fill: #3e98c7;\n    font-size: 20px;\n    dominant-baseline: middle;\n    text-anchor: middle;\n  }\n\n  .CircularProgressbar .CircularProgressbar-background {\n    fill: #d6d6d6;\n  }\n\n  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-background {\n    fill: #3e98c7;\n  }\n\n  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-text {\n    fill: #fff;\n  }\n\n  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-path {\n    stroke: #fff;\n  }\n\n  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-trail {\n    stroke: transparent;\n  }\n"])));
var CircularIntegerProgress = function CircularIntegerProgress(_ref) {
  var styles = _ref.styles,
      steps = _ref.steps,
      stepsCompleted = _ref.stepsCompleted,
      strokeWidth = _ref.strokeWidth,
      children = _ref.children;
  var completed = stepsCompleted > steps ? steps : stepsCompleted;
  var percentage = Math.round(completed / steps * 100);
  var hasChildren = !!children;
  var text = !hasChildren ? percentage + "%" : '';
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    value: percentage,
    text: text,
    strokeWidth: strokeWidth,
    styles: _extends({
      strokeLinecap: 'butt'
    }, styles)
  }, hasChildren && children, /*#__PURE__*/React.createElement(RadialProgressSeparator, {
    count: steps,
    style: {
      background: '#fff',
      width: '3px',
      height: strokeWidth + 1 + "%"
    }
  })));
};
CircularIntegerProgress.propTypes = {
  styles: PropTypes__default.object,
  steps: PropTypes__default.number.isRequired,
  stepsCompleted: PropTypes__default.number.isRequired,
  strokeWidth: PropTypes__default.number,
  children: PropTypes__default.element
};
CircularIntegerProgress.defaultProps = {
  steps: 4,
  stepsCompleted: 2,
  strokeWidth: 1
};

var _templateObject$3, _templateObject2, _templateObject3;
var IconFlex = styled(Flex)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n"])), function (_ref) {
  var done = _ref.done;
  return done ? 'var(--color-feedback-success-lightest)' : 'var(--color-neutral-80)';
});
var CheckFlex = styled(Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n  margin-right: 0;\n"])));
var LinkWithFlex = styled(Link$2)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), withFlex);
var StepButton = function StepButton(_ref2) {
  var icon = _ref2.icon,
      title = _ref2.title,
      titleDone = _ref2.titleDone,
      description = _ref2.description,
      done = _ref2.done,
      path = _ref2.path,
      onClick = _ref2.onClick;
  var Icon = icon;
  var container = /*#__PURE__*/React.createElement(Container$7, {
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconFlex, {
    marginRight: "--spacing-inline-xxxs",
    alignItems: "center",
    justifyContent: "center",
    done: done
  }, /*#__PURE__*/React.createElement(Icon, {
    color: done ? 'var(--color-feedback-success-light)' : 'var(--color-neutral-darker)',
    size: "18"
  })), /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Text.Caption, {
    weight: "semibold",
    color: "--color-neutral-darkest"
  }, done ? titleDone : title), /*#__PURE__*/React.createElement(Text.Caption, {
    weight: "regular",
    color: "--color-neutral-darker"
  }, description)), /*#__PURE__*/React.createElement(CheckFlex, null, done ? /*#__PURE__*/React.createElement(System.Check, {
    color: "var(--color-feedback-success-light)"
  }) : /*#__PURE__*/React.createElement(System.ChevronRight, {
    color: "var(--color-neutral-darker)"
  })));
  return done ? /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "stretch"
  }, container) : /*#__PURE__*/React.createElement(LinkWithFlex, {
    flexDirection: "column",
    alignItems: "stretch",
    href: path,
    onClick: onClick
  }, container);
};
StepButton.propTypes = {
  icon: PropTypes__default.func,
  title: PropTypes__default.string,
  titleDone: PropTypes__default.string,
  description: PropTypes__default.string,
  done: PropTypes__default.bool,
  path: PropTypes__default.string,
  onClick: PropTypes__default.func
};
StepButton.defaultProps = {};

var _templateObject$4;
var IconFlex$1 = styled(Flex)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  background-color: var(--color-neutral-lighter);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n"])));
var StepButtonSkeleton = function StepButtonSkeleton() {
  return /*#__PURE__*/React.createElement(Container$7, {
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconFlex$1, {
    marginRight: "--spacing-inline-xxxs",
    alignItems: "center",
    justifyContent: "center"
  }));
};

var _templateObject$5, _templateObject2$1, _templateObject3$1, _templateObject4;

var _excluded$3 = ["color"];

var containerColor = function containerColor(props) {
  return props.color;
};

var coloredFlex = function coloredFlex(props) {
  var otherProps = _objectWithoutPropertiesLoose(props, _excluded$3);

  return /*#__PURE__*/React.createElement(Flex, otherProps, props.children);
};

var CustomizedFlex = styled(coloredFlex)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n"])), containerColor);
var ItemsFlex = styled(Flex)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  z-index: 0;\n"])));
var progressAnimation = keyframes(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n  0% { background-position: -160px 0; }\n  100% { background-position: calc(160px + 100%) 0; }\n"])));
var WaveFlex = styled(coloredFlex)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  animation: ", ";\n  animation-iteration-count: infinite;\n  animation-duration: 1s;\n  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  background-image: linear-gradient(90deg, transparent, ", ", transparent);\n  opacity: 0.36;\n  background-size: 160px 100%;\n  background-repeat: no-repeat;\n"])), progressAnimation, containerColor);
var SkeletonAnimation = function SkeletonAnimation(props) {
  return /*#__PURE__*/React.createElement(CustomizedFlex, {
    color: props.color,
    className: props.className
  }, /*#__PURE__*/React.createElement(ItemsFlex, {
    flex: "1"
  }, props.children), /*#__PURE__*/React.createElement(WaveFlex, {
    color: props.color
  }));
};
SkeletonAnimation.propTypes = {
  color: PropTypes__default.string
};
SkeletonAnimation.defaultProps = {
  color: 'var(--color-neutral-lightest)'
};

var faleConosco = 'https://ajuda.olx.com.br/fale-conosco';
var home = 'https://www.olx.com.br/';
var login = 'https://www3.olx.com.br/account/form_login';
var deactivateAccount = 'https://conta.olx.com.br/desativacao-conta';
var confirmarTelefone = '/confirmacao-telefone/';
var trocaSenha = '/nova-senha';
var cadastroLink = '/cadastro';
var accountReactivationLink = '/reativacao-conta';
var emailChangeConfirmationLink = '/confirmar-alteracao-email';
var security = 'https://www.olx.com.br/seguranca/';
var changePassword = 'https://conta.olx.com.br/nova-senha';
var deleteAccount = 'https://conta.olx.com.br/exclusao-conta';
var downloadAccountData = 'https://conta.olx.com.br/download-dados';
var myAccount = 'https://conta.olx.com.br/meu-cadastro';

var _templateObject$6, _templateObject2$2;

var getHref = function getHref(_ref) {
  var showAccountNotFoundError = _ref.showAccountNotFoundError,
      showInactiveError = _ref.showInactiveError,
      contactUsLink = _ref.contactUsLink;
  if (showAccountNotFoundError) return cadastroLink;
  if (showInactiveError) return accountReactivationLink;
  return contactUsLink || faleConosco;
};

var ErrorWrapper = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  a {\n    display: inline;\n    font-size: var(--font-size-xxs);\n  }\n"])));
var ErrorMessage = styled(Text.BodySmall)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n  display: inline;\n  color: inherit;\n"])));

var getGenericInfo = function getGenericInfo(_ref2) {
  var showContactUs = _ref2.showContactUs,
      showAccountNotFoundError = _ref2.showAccountNotFoundError,
      showPasswordMismatchError = _ref2.showPasswordMismatchError,
      showGoogleInitializationError = _ref2.showGoogleInitializationError,
      showEmailNotFoundError = _ref2.showEmailNotFoundError,
      showBiometryError = _ref2.showBiometryError,
      showRateLimitMagicLink = _ref2.showRateLimitMagicLink,
      showDeleteAccount = _ref2.showDeleteAccount,
      showInactiveError = _ref2.showInactiveError;

  if (showAccountNotFoundError) {
    return {
      showInfo: true,
      info: 'Não tem conta? ',
      linkText: 'Cadastre-se.'
    };
  }

  if (showRateLimitMagicLink) {
    return {
      showInfo: true,
      info: 'Podemos enviar um e-mail para ajudar a acessar sua conta. ',
      linkText: 'Enviar acesso rápido'
    };
  }

  if (showPasswordMismatchError) {
    return {
      showInfo: true,
      info: 'Esqueceu sua senha? ',
      linkText: 'Crie uma nova senha.'
    };
  }

  if (showGoogleInitializationError) {
    return {
      showInfo: true,
      info: 'Tente outra opcão ou ',
      linkText: 'fale conosco.'
    };
  }

  if (showEmailNotFoundError) {
    return {
      showInfo: true,
      info: 'Digite novamente ou tente outro e-mail.',
      linkText: ''
    };
  }

  if (showBiometryError) {
    return {
      showInfo: true,
      info: 'Tente novamente com a senha.',
      linkText: ''
    };
  }

  if (showDeleteAccount) {
    return {
      showInfo: true,
      info: 'Para excluir sua conta, ',
      linkText: 'fale conosco.'
    };
  }

  if (showInactiveError) {
    return {
      showInfo: true,
      info: 'Precisa de ajuda? ',
      linkText: 'Reative a sua conta'
    };
  }

  if (showContactUs) {
    return {
      showInfo: true,
      info: 'Em caso de dúvidas, ',
      linkText: 'Fale com a gente.'
    };
  }

  return {
    showInfo: false
  };
};

var GenericErrorBox = function GenericErrorBox(props) {
  var contactUsLink = props.contactUsLink,
      errorAction = props.errorAction,
      info = props.info,
      linkText = props.linkText,
      showAccountNotFoundError = props.showAccountNotFoundError,
      showBiometryError = props.showBiometryError,
      showContactUs = props.showContactUs,
      showDeleteAccount = props.showDeleteAccount,
      showEmailNotFoundError = props.showEmailNotFoundError,
      showGoogleInitializationError = props.showGoogleInitializationError,
      showInactiveError = props.showInactiveError,
      showPasswordMismatchError = props.showPasswordMismatchError,
      showRateLimitMagicLink = props.showRateLimitMagicLink,
      text = props.text;
  var showInfo = false;
  var customInfo = '';
  var customLinkText = '';
  var href = '';

  if (info || linkText) {
    showInfo = true;
    customInfo = info;
    customLinkText = linkText;
  } else {
    var _getGenericInfo2 = getGenericInfo({
      showContactUs: showContactUs,
      showAccountNotFoundError: showAccountNotFoundError,
      showPasswordMismatchError: showPasswordMismatchError,
      showGoogleInitializationError: showGoogleInitializationError,
      showEmailNotFoundError: showEmailNotFoundError,
      showBiometryError: showBiometryError,
      showRateLimitMagicLink: showRateLimitMagicLink,
      showDeleteAccount: showDeleteAccount,
      showInactiveError: showInactiveError
    }),
        _showInfo = _getGenericInfo2.showInfo,
        _info = _getGenericInfo2.info,
        _linkText = _getGenericInfo2.linkText;

    showInfo = _showInfo;
    customInfo = _info;
    customLinkText = _linkText;
    href = getHref({
      showAccountNotFoundError: showAccountNotFoundError,
      showInactiveError: showInactiveError,
      contactUsLink: contactUsLink
    });
  }

  return /*#__PURE__*/React.createElement(Alertbox, {
    variant: "error",
    title: text,
    role: "Alert",
    icon: /*#__PURE__*/React.createElement(AlertTriangle, null)
  }, /*#__PURE__*/React.createElement(ErrorWrapper, null, showInfo && /*#__PURE__*/React.createElement(ErrorMessage, {
    tag: "p"
  }, customInfo, /*#__PURE__*/React.createElement(ErrorLink, {
    href: href,
    onClick: errorAction
  }, customLinkText))));
};
GenericErrorBox.defaultProps = {
  info: '',
  linkText: '',
  showContactUs: true
};
GenericErrorBox.propTypes = {
  contactUsLink: PropTypes__default.string,
  errorAction: PropTypes__default.func,
  info: PropTypes__default.string,
  linkText: PropTypes__default.string,
  showAccountNotFoundError: PropTypes__default.bool,
  showBiometryError: PropTypes__default.bool,
  showContactUs: PropTypes__default.bool,
  showDeleteAccount: PropTypes__default.bool,
  showEmailNotFoundError: PropTypes__default.bool,
  showGoogleInitializationError: PropTypes__default.bool,
  showInactiveError: PropTypes__default.bool,
  showPasswordMismatchError: PropTypes__default.bool,
  showRateLimitMagicLink: PropTypes__default.bool,
  text: PropTypes__default.string.isRequired
};

var _templateObject$7, _templateObject2$3;
var TurnstileArea = styled(Flex)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 8px;\n  justify-content: center;\n"])));
var TurnstileContent = styled(Flex)(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  width: 300px;\n  flex-direction: column;\n"])));
var Turnstile = function Turnstile(_ref) {
  var onLoad = _ref.onLoad,
      onVerify = _ref.onVerify,
      hasError = _ref.hasError;
  var turnstileSiteKey = '0x4AAAAAAADmGIS5l8Nlxuco';

  var _useState = useState(false),
      error = _useState[0],
      setError = _useState[1];

  useEffect(function () {
    setError(hasError);
  }, [hasError]);

  var onTurnstileLoad = function onTurnstileLoad() {
    if (onLoad) {
      onLoad();
    }
  };

  var onTurnstileVerify = function onTurnstileVerify(token) {
    if (onVerify) {
      onVerify(token);
    }
  };

  return /*#__PURE__*/React.createElement(TurnstileArea, null, /*#__PURE__*/React.createElement(TurnstileContent, null, /*#__PURE__*/React.createElement(TurnstileCaptcha, {
    sitekey: turnstileSiteKey,
    theme: "light",
    onVerify: onTurnstileVerify,
    onLoad: onTurnstileLoad
  }), error && /*#__PURE__*/React.createElement(ErrorMsg, null, "Captcha n\xE3o preenchido")));
};
Turnstile.propTypes = {
  onLoad: PropTypes__default.func,
  onVerify: PropTypes__default.func,
  hasError: PropTypes__default.bool
};

var CONFIRM_PHONE_PATH = '/confirmacao-telefone';
var CONFIRM_EMAIL_PATH = '/confirmacao-email-enviado';
var WALLET_URL = 'https://wallet.olx.com.br';
var PROFILE_URL = 'https://www.olx.com.br/perfil';

var _templateObject$8, _templateObject2$4;
var ProgressCircleWrapper = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  width: var(--spacing-inline-lg);\n  height: var(--spacing-inline-lg);\n"])));
var strokeColor = {
  1: 'var(--color-feedback-error-light)',
  2: 'var(--color-primary-light)',
  3: 'var(--color-feedback-attention-light)',
  4: 'var(--color-feedback-success-light)'
};
var AwardIcon = styled(System.Award)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
var LevelProgress = function LevelProgress(_ref2) {
  var stepsCompleted = _ref2.stepsCompleted,
      steps = _ref2.steps,
      publicAccountId = _ref2.publicAccountId;
  var stepsLeft = steps - stepsCompleted;
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ProgressCircleWrapper, null, /*#__PURE__*/React.createElement(CircularIntegerProgress, {
    strokeWidth: 8,
    steps: steps,
    stepsCompleted: stepsCompleted,
    styles: {
      path: {
        strokeLinecap: 'butt',
        stroke: strokeColor[stepsCompleted]
      }
    }
  }, /*#__PURE__*/React.createElement(AwardIcon, {
    color: strokeColor[stepsCompleted]
  }))), stepsLeft === 0 ? /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: "--spacing-inline-xxs"
  }, /*#__PURE__*/React.createElement(Text.BodyMedium, {
    weight: "semibold"
  }, "Parab\xE9ns! Voc\xEA alcan\xE7ou o n\xEDvel m\xE1ximo."), /*#__PURE__*/React.createElement(Link$2, {
    size: "small",
    href: PROFILE_URL + "/" + publicAccountId
  }, "Ver meu perfil")) : /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: "--spacing-inline-xxs"
  }, /*#__PURE__*/React.createElement(Text.BodyMedium, {
    weight: "semibold"
  }, stepsLeft > 1 ? 'Restam' : 'Resta', " apenas ", stepsLeft, ' ', stepsLeft > 1 ? 'etapas' : 'etapa', "!"), /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: "regular"
  }, "Complete as etapas para atingir o n\xEDvel m\xE1ximo de confian\xE7a.")));
};
LevelProgress.propTypes = {
  stepsCompleted: PropTypes__default.number.isRequired,
  steps: PropTypes__default.number.isRequired,
  publicAccountId: PropTypes__default.string.isRequired
};
LevelProgress.defaultProps = {};

var _templateObject$9, _templateObject2$5;
var ProgressCircleWrapper$1 = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n  width: var(--spacing-inline-lg);\n  height: var(--spacing-inline-lg);\n"])));
var AwardIcon$1 = styled(System.Award)(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
var LevelProgressSkeleton = function LevelProgressSkeleton() {
  return /*#__PURE__*/React.createElement(SkeletonAnimation, null, /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ProgressCircleWrapper$1, null, /*#__PURE__*/React.createElement(CircularIntegerProgress, {
    strokeWidth: 8,
    steps: 4,
    stepsCompleted: 4,
    styles: {
      path: {
        strokeLinecap: 'butt',
        stroke: 'var(--color-neutral-medium)'
      }
    }
  }, /*#__PURE__*/React.createElement(AwardIcon$1, {
    color: 'var(--color-neutral-medium)'
  }))), /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: "--spacing-inline-xxs"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    type: "label"
  }), /*#__PURE__*/React.createElement(Divider$2, {
    inverted: true,
    marginBottom: "--spacing-stack-quarck"
  }), /*#__PURE__*/React.createElement(Skeleton, null))));
};

var client = {
  Severity: {
    Info: 'INFO'
  },
  scope: {
    extra: [],
    tags: [],
    setTag: function setTag(name, value) {
      this.tags.push({
        name: name,
        value: value
      });
    },
    setExtra: function setExtra(name, value) {
      this.extra.push({
        name: name,
        value: value
      });
    }
  },
  withScope: function withScope(fn) {
    if (typeof fn !== 'function') return;
    fn(this.scope);
    console.log('[SENTRY] withScope', this.scope);
  },
  configureScope: function configureScope(fn) {
    if (typeof fn !== 'function') return;
    fn(this.scope);
    console.log('[SENTRY] configureScope', this.scope);
  },
  componentDidCatch: function componentDidCatch(error, errorInfo) {
    console.log('[SENTRY] componentDidCatch', error, errorInfo);
  },
  captureException: function captureException() {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (_console = console).log.apply(_console, ['[SENTRY] captureException'].concat(args));
  },
  addBreadcrumb: function addBreadcrumb(category, message) {
    console.log('[SENTRY] addBreadcrumb', category, message);
  }
};
var SentryWrapper = /*#__PURE__*/function () {
  function SentryWrapper() {}

  SentryWrapper.initialize = function initialize(sentry) {
    client = sentry;
  };

  SentryWrapper.componentDidCatch = function componentDidCatch(error, errorInfo) {
    client.withScope(function (scope) {
      Object.keys(errorInfo).forEach(function (key) {
        scope.setExtra(key, errorInfo[key]);
      });
      client.captureException(error);
    });
  };

  SentryWrapper.captureException = function captureException() {
    var _client;

    (_client = client).captureException.apply(_client, arguments);
  };

  SentryWrapper.setTag = function setTag(name, value) {
    client.configureScope(function (scope) {
      scope.setTag(name, value);
    });
  };

  SentryWrapper.addBreadcrumb = function addBreadcrumb(category, message) {
    var data = null;

    if (typeof message === 'object') {
      data = message;
      message = null;
    }

    client.addBreadcrumb({
      category: category,
      message: message,
      data: data,
      level: client.Severity.Info
    });
  };

  return SentryWrapper;
}();

var lurkerSend = function lurkerSend(payload) {
  SentryWrapper.addBreadcrumb('lurker', payload);

  try {
    if (window.Lurker) {
      window.Lurker.send(payload);
    } else {
      console.log('LURKER EVENT: ', payload);
    }
  } catch (error) {
    console.error("Error on send Lurker event: " + error);
  }
};

var setDataToString = function setDataToString(extraData) {
  if (extraData === void 0) {
    extraData = {};
  }

  var data = {};
  Object.keys(extraData).forEach(function (k) {
    if (typeof extraData[k] === 'object') {
      data[k] = JSON.stringify(extraData[k]);
    } else if (typeof extraData[k] !== 'undefined') {
      data[k] = "" + extraData[k];
    }
  });
  return data;
};

var round = function round(number) {
  return Math.round(number * 1000) / 1000;
};

var Lurker = function Lurker(_pageName) {
  var _this = this;

  this.getElapsedTime = function () {
    return _this.initialLoadTime && round((new Date().getTime() - _this.initialLoadTime) / 1000);
  };

  this.pageLoadEvt = function (pageName) {
    if (pageName) {
      _this.pageName = pageName;
    }

    _this.initialLoadTime = new Date().getTime();
    lurkerSend({
      event_type: 'page_view',
      object_detail: 'load',
      object_name: _this.pageName
    });
  };

  this.clickEvt = function (detail, extraData) {
    return lurkerSend(setDataToString(_extends({}, extraData, {
      event_type: 'click',
      object_detail: detail,
      object_name: _this.pageName,
      accounts_elapsed_time: _this.getElapsedTime()
    })));
  };

  this.viewMessageEvt = function (detail, extraData) {
    return lurkerSend(setDataToString(_extends({}, extraData, {
      event_type: 'message_view',
      object_detail: detail,
      object_name: _this.pageName,
      accounts_elapsed_time: _this.getElapsedTime()
    })));
  };

  this.errorMessageEvt = function (objectName, extraData) {
    return lurkerSend(setDataToString(_extends({}, extraData, {
      event_type: 'message_view',
      object_detail: 'error',
      object_name: objectName,
      accounts_elapsed_time: _this.getElapsedTime()
    })));
  };

  this.pageName = _pageName;
};

var lurker = new Lurker('level_page');
var LevelSteps = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LevelSteps, _React$Component);

  function LevelSteps() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onClickEmailVerificationTask = function () {
      lurker.clickEvt('email_verification');
    };

    _this.renderEmailVerificationTask = function () {
      var _this$props = _this.props,
          email = _this$props.email,
          emailVerified = _this$props.emailVerified;
      return /*#__PURE__*/React.createElement(Flex, {
        flexDirection: "column",
        alignItems: "stretch",
        marginBottom: "--spacing-stack-xxxs"
      }, /*#__PURE__*/React.createElement(StepButton, {
        icon: System.Mail,
        title: "Verifique seu e-mail",
        titleDone: "E-mail verificado",
        description: "Receba as comunica\xE7\xF5es da conta e alertas de seguran\xE7a.",
        done: emailVerified,
        path: CONFIRM_EMAIL_PATH + "?email=" + email,
        onClick: _this.onClickEmailVerificationTask
      }));
    };

    _this.onClickPhoneVerificationTask = function () {
      lurker.clickEvt('phone_verification');
    };

    _this.renderPhoneVerificationTask = function () {
      var phoneVerified = _this.props.phoneVerified;
      return /*#__PURE__*/React.createElement(Flex, {
        flexDirection: "column",
        alignItems: "stretch",
        marginBottom: "--spacing-stack-xxxs"
      }, /*#__PURE__*/React.createElement(StepButton, {
        icon: System.Phone,
        title: "Verifique seu telefone",
        titleDone: "Telefone verificado",
        description: "Conta segura para anunciar e interagir com outros usu\xE1rios.",
        done: phoneVerified,
        path: CONFIRM_PHONE_PATH,
        onClick: _this.onClickPhoneVerificationTask
      }));
    };

    _this.onClickOlxPayTask = function () {
      lurker.clickEvt('olx_pay');
    };

    _this.renderOlxPayTask = function () {
      var hasWallet = _this.props.hasWallet;
      return /*#__PURE__*/React.createElement(Flex, {
        flexDirection: "column",
        alignItems: "stretch",
        marginBottom: "--spacing-stack-xxxs"
      }, /*#__PURE__*/React.createElement(StepButton, {
        icon: System.Wallet,
        title: "Ative a OLX Pay",
        titleDone: "OLX Pay ativada",
        description: "Compre e venda com mais seguran\xE7a e praticidade.",
        done: hasWallet,
        path: WALLET_URL,
        onClick: _this.onClickOlxPayTask
      }));
    };

    _this.renderProfileCreationTask = function () {
      var profileCreated = _this.props.profileCreated;
      return /*#__PURE__*/React.createElement(Flex, {
        flexDirection: "column",
        alignItems: "stretch"
      }, /*#__PURE__*/React.createElement(StepButton, {
        icon: System.User,
        title: "Criar meu perfil",
        titleDone: "Meu perfil criado",
        description: "Informa\xE7\xF5es para outros usu\xE1rios negociarem com maior seguran\xE7a.",
        done: profileCreated,
        path: "#"
      }));
    };

    return _this;
  }

  var _proto = LevelSteps.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column",
      alignItems: "stretch"
    }, /*#__PURE__*/React.createElement(Text.BodyLarge, {
      weight: "semibold",
      marginBottom: "--spacing-stack-xxs"
    }, "Etapas para aumentar seu n\xEDvel"), this.renderEmailVerificationTask(), this.renderPhoneVerificationTask(), this.renderOlxPayTask(), this.renderProfileCreationTask());
  };

  return LevelSteps;
}(React.Component);
LevelSteps.propTypes = {
  profileCreated: PropTypes__default.bool,
  hasWallet: PropTypes__default.bool,
  phoneVerified: PropTypes__default.bool,
  emailVerified: PropTypes__default.bool,
  email: PropTypes__default.string
};
LevelSteps.defaultProps = {
  profileCreated: true
};

var renderTaskSkeleton = function renderTaskSkeleton(last) {
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "stretch",
    marginBottom: last ? null : '--spacing-stack-xxxs'
  }, /*#__PURE__*/React.createElement(StepButtonSkeleton, null));
};

var LevelStepsSkeleton = function LevelStepsSkeleton() {
  return /*#__PURE__*/React.createElement(SkeletonAnimation, null, /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    flexDirection: "column",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    type: "title"
  }), /*#__PURE__*/React.createElement(Divider$2, {
    inverted: true,
    marginBottom: "--spacing-stack-xxs"
  }), renderTaskSkeleton(), renderTaskSkeleton(), renderTaskSkeleton(true)));
};

var _templateObject$a;

var FORM = function FORM(props) {
  return /*#__PURE__*/React.createElement("form", props);
};

var Form = styled(FORM)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose([""])));

var _templateObject$b, _templateObject2$6;
var Content = styled(View$1)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var InputSkeleton = styled(Skeleton)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));

var formItemSkeleton = function formItemSkeleton(props) {
  return /*#__PURE__*/React.createElement(Content, {
    className: props.className
  }, /*#__PURE__*/React.createElement(Skeleton, {
    type: "label"
  }), /*#__PURE__*/React.createElement(InputSkeleton, {
    type: "input"
  }));
};

formItemSkeleton.propTypes = {
  className: PropTypes__default.string
};

var _templateObject$c, _templateObject2$7, _templateObject3$2, _templateObject4$1;

var _excluded$4 = ["color"];

var containerColor$1 = function containerColor(props) {
  return props.color;
};

var coloredView = function coloredView(props) {
  var otherProps = _objectWithoutPropertiesLoose(props, _excluded$4);

  return /*#__PURE__*/React.createElement(View$1, otherProps, props.children);
};

var Content$1 = styled(coloredView)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n"])), containerColor$1);
var ItemsContainer = styled(View$1)(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n  z-index: 0;\n"])));
var progressAnimation$1 = keyframes(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n  0% { background-position: -160px 0; }\n  100% { background-position: calc(160px + 100%) 0; }\n"])));
var WaveContainer = styled(coloredView)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  animation: ", ";\n  animation-iteration-count: infinite;\n  animation-duration: 1s;\n  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  background-image: linear-gradient(90deg, transparent, ", ", transparent);\n  opacity: 0.36;\n  background-size: 160px 100%;\n  background-repeat: no-repeat;\n"])), progressAnimation$1, containerColor$1);

var SkeletonContainer = function SkeletonContainer(props) {
  return /*#__PURE__*/React.createElement(Content$1, {
    color: props.color,
    className: props.className
  }, /*#__PURE__*/React.createElement(ItemsContainer, null, props.children), /*#__PURE__*/React.createElement(WaveContainer, {
    color: props.color
  }));
};

SkeletonContainer.propTypes = {
  color: PropTypes__default.string
};
SkeletonContainer.defaultProps = {
  color: '#ffffff'
};

var _templateObject$d, _templateObject2$8, _templateObject3$3, _templateObject4$2;
var Content$2 = styled(SkeletonContainer)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var TitleSkeleton = styled(Skeleton)(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 24px;\n"])));
var StyledFormItemSkeleton = styled(formItemSkeleton)(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 32px;\n"])));
var DefaultContent = styled(Content$2)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), function (props) {
  return !props.height && "\n    &:first-child > :first-child > *+* {\n      margin-top: 24px;\n    }\n  ";
}, function (props) {
  return props.height && "\n    &:first-child > :first-child {\n      display: flex;\n      flex-direction: column;\n      height: " + props.height + "px;\n      justify-content: space-around;\n    }\n  ";
});

var formSkeleton = function formSkeleton(props, size) {
  var items = [];

  for (var i = 0; i < size; ++i) {
    items.push( /*#__PURE__*/React.createElement(StyledFormItemSkeleton, {
      key: i
    }));
  }

  return /*#__PURE__*/React.createElement(Content$2, null, /*#__PURE__*/React.createElement(TitleSkeleton, {
    type: "title"
  }), items, /*#__PURE__*/React.createElement(Skeleton, {
    type: "button"
  }));
};

var defaultSkeleton = function defaultSkeleton(props, size) {
  var items = [];

  for (var i = 0; i < size; ++i) {
    items.push( /*#__PURE__*/React.createElement(Skeleton, {
      key: i
    }));
  }

  return /*#__PURE__*/React.createElement(DefaultContent, {
    height: props.height
  }, items);
};

var FormSkeleton = function FormSkeleton(props) {
  var size = parseInt(props.size, 10);

  if (!size || size <= 0) {
    size = FormSkeleton.defaultProps.size;
  }

  var type = props.type;

  switch (type) {
    case 'form':
      return formSkeleton(props, size);

    default:
      return defaultSkeleton(props, size);
  }
};

FormSkeleton.propTypes = {
  type: PropTypes__default.oneOf(['default', 'form']),
  size: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  height: PropTypes__default.number
};
FormSkeleton.defaultProps = {
  type: 'default',
  size: 3
};

var _templateObject$e;
var GenericBox = styled(View$1)(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  min-height: 73px;\n  border-radius: 4px;\n  background-color: ", ";\n  padding: 16px;\n"])), function (props) {
  return "" + (props.direction ? props.direction : 'row');
}, function (props) {
  return "" + (props.color ? props.color : '#F6F6F6');
});

var locationSvgPath = 'M15.0445 20.7948C14.0342 21.9239 12.9539 22.9532 11.8734 23.8642C11.4948 24.1834 11.1427 24.4654 10.8258 24.7077C10.6335 24.8548 10.4939 24.9571 10.416 25.0121C10.1641 25.1899 9.8359 25.1899 9.58397 25.0121C9.50606 24.9571 9.36654 24.8548 9.17416 24.7077C8.85729 24.4654 8.50517 24.1834 8.12655 23.8642C7.04608 22.9532 5.96584 21.9239 4.95554 20.7948C2.02368 17.5182 0.25 14.0754 0.25 10.5875C0.25 4.88636 4.61522 0.264648 10 0.264648C15.3848 0.264648 19.75 4.88636 19.75 10.5875C19.75 14.0754 17.9763 17.5182 15.0445 20.7948ZM10.9391 22.6218C11.968 21.7543 12.9971 20.7737 13.9555 19.7026C16.6487 16.6928 18.25 13.5845 18.25 10.5875C18.25 5.76346 14.5563 1.85278 10 1.85278C5.44365 1.85278 1.75 5.76346 1.75 10.5875C1.75 13.5845 3.35132 16.6928 6.04446 19.7026C7.00291 20.7737 8.03205 21.7543 9.06095 22.6218C9.39969 22.9074 9.71518 23.1609 10 23.38C10.2848 23.1609 10.6003 22.9074 10.9391 22.6218ZM10 14.5579C7.92893 14.5579 6.25 12.7803 6.25 10.5875C6.25 8.39477 7.92893 6.61719 10 6.61719C12.0711 6.61719 13.75 8.39477 13.75 10.5875C13.75 12.7803 12.0711 14.5579 10 14.5579ZM10 12.9697C11.2426 12.9697 12.25 11.9032 12.25 10.5875C12.25 9.27187 11.2426 8.20532 10 8.20532C8.75736 8.20532 7.75 9.27187 7.75 10.5875C7.75 11.9032 8.75736 12.9697 10 12.9697Z';

var _templateObject$f;
var StyledSVGEl = styled.svg(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  cursor: ", ";\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.onClick ? 'pointer' : 'unset';
}, function (props) {
  return props.width && "\n    width: " + props.width + " !important\n  ";
}, function (props) {
  return props.height && "\n    height: " + props.height + " !important\n  ";
});

var SVG = function SVG(_ref) {
  var color = _ref.color,
      width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox,
      svgPath = _ref.svgPath,
      onClick = _ref.onClick,
      className = _ref.className;
  var widthParam = width ? width + "px" : undefined;
  var heightParam = height ? height + "px" : undefined;
  return /*#__PURE__*/React.createElement(StyledSVGEl, {
    onClick: onClick,
    className: className,
    width: widthParam,
    height: heightParam,
    viewBox: viewBox
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: svgPath
  }));
};

SVG.propTypes = {
  className: PropTypes__default.string,
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  width: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  height: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  viewBox: PropTypes__default.string.isRequired,
  svgPath: PropTypes__default.string.isRequired
};

var LocationSymbol = function LocationSymbol(props) {
  return /*#__PURE__*/React.createElement(SVG, {
    viewBox: "0 0 24 26",
    width: props.width,
    height: props.height,
    svgPath: locationSvgPath,
    color: props.color
  });
};

LocationSymbol.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number,
  color: PropTypes__default.string
};
LocationSymbol.defaultProps = {
  width: 24,
  height: 26,
  color: '#4a4a4a'
};

var _templateObject$g, _templateObject2$9, _templateObject3$4, _templateObject4$3, _templateObject5;
var Wrapper = styled(View$1)(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 0;\n  margin-bottom: 8px;\n"])));
var Arrow = styled(View$1)(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 0;\n  height: 0;\n  left: 10px;\n  border-width: 10px;\n  border-style: solid;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: #f6f6f6;\n  border-left-color: transparent;\n"])));
var DetailColumn = styled(View$1)(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin-left: 14px;\n"])));
var Description = styled(Text$1)(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  color: #4a4a4a;\n  line-height: 24px;\n  font-weight: normal;\n"])));
var GenericAddressBox = styled(GenericBox)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  border-radius: 8px;\n  min-height: 56px;\n"])));

var AddressBox = function AddressBox(_ref) {
  var neighbourhood = _ref.neighbourhood,
      city = _ref.city,
      state = _ref.state;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Arrow, null), /*#__PURE__*/React.createElement(GenericAddressBox, {
    color: "#F6F6F6"
  }, /*#__PURE__*/React.createElement(LocationSymbol, null), /*#__PURE__*/React.createElement(DetailColumn, null, /*#__PURE__*/React.createElement(Description, null, (neighbourhood || 'Sem bairro') + ", " + city + ", " + state))));
};

AddressBox.propTypes = {
  neighbourhood: PropTypes__default.string,
  city: PropTypes__default.string.isRequired,
  state: PropTypes__default.string.isRequired
};

var _templateObject$h;
var Row = styled(View$1)(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
Row.displayName = 'Row';

var _templateObject$i;
var Col = styled(View$1)(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"])), function (_ref) {
  var size = _ref.size;
  return size ? "\n    width: " + size + "%;\n  " : "\n    flex-grow: 1;\n  ";
});
Col.displayName = 'Col';

var _templateObject$j, _templateObject2$a;
var StyledLabel = styled(Text$1)(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  font-weight: ", ";\n  color: #4a4a4a;\n"])), function (props) {
  return props.labelweight;
});

var Label = function Label(props) {
  return /*#__PURE__*/React.createElement(StyledLabel, props);
};

Label.defaultProps = {
  labelweight: 'bold'
};
Label.propTypes = {
  labelweight: PropTypes__default.string
};
var Label$1 = styled(Label)(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose([""])));

var API_ENDPOINT = function API_ENDPOINT(id) {
  return id ? "/v1.1/addresses/" + id : '/v1.1/addresses';
};

var createAddress = function createAddress(data) {
  return axios.post(API_ENDPOINT(), data);
};
var updateAddress = function updateAddress(id, data) {
  return axios.put(API_ENDPOINT(id), data);
};
var getAddresses = function getAddresses() {
  return axios.get(API_ENDPOINT());
};
var setAddressAsDefault = function setAddressAsDefault(id) {
  return axios.patch(API_ENDPOINT(id), {
    main: true
  });
};
var deleteAddress = function deleteAddress(id) {
  return axios["delete"](API_ENDPOINT(id));
};

var API_ENDPOINT$1 = function API_ENDPOINT(zipcode) {
  return "https://busca-cep.olx.com.br/cep/" + zipcode;
};

var getLocationInfo = (function (zipcode) {
  return axios.get(API_ENDPOINT$1(zipcode.replace('-', ''))).then(function (response) {
    return response.data.result === '{}' ? Promise.reject(response) : response.data;
  });
});

var fixBackspace = function fixBackspace(currentValue, previousValue, mask) {
  if (typeof currentValue === 'string' && typeof previousValue === 'string' && previousValue.length - currentValue.length === 1 && previousValue.substr(0, currentValue.length) === currentValue) {
    var index = previousValue.length - 1;

    if (previousValue.substr(index, 1) === mask[index]) {
      return currentValue.substr(0, index - 1);
    }
  }

  return currentValue;
};

var truncate = function truncate(email) {
  var allowedEmailSize = 35;

  if (email.length > allowedEmailSize) {
    var fields = email.split('@');
    var emailSize = allowedEmailSize - fields[1].length - 4;
    var trunc = fields[0].slice(0, emailSize);
    return trunc.concat('...@', fields[1]);
  }

  return email;
};

var applyMask = (function (currentValue, previousValue, mask) {
  if (!currentValue) return null;
  var current = typeof currentValue === 'number' ? String(currentValue) : currentValue;
  var previous = typeof previousValue === 'number' ? String(previousValue) : previousValue;

  if (typeof previous === 'string') {
    current = fixBackspace(current, previous, mask);
  }

  return conformToMask(current, mask, {
    guide: false
  }).conformedValue;
});

var DeleteAddress = function DeleteAddress(props) {
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Button, {
    variant: "link-button",
    icon: /*#__PURE__*/React.createElement(Trash, null),
    onClick: props.onClick
  }, "Excluir"));
};

DeleteAddress.propTypes = {
  onClick: PropTypes__default.func.isRequired
};

var _templateObject$k;
var Title = styled(Text$1)(_templateObject$k || (_templateObject$k = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n  font-size: 20px;\n  text-align: center;\n  font-weight: 600;\n"])));

var _templateObject$l;
var Subtitle = styled(Text.BodyMedium)(_templateObject$l || (_templateObject$l = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));

var _templateObject$m, _templateObject2$b, _templateObject3$5;
var TitleWrapper = styled(Title)(_templateObject$m || (_templateObject$m = _taggedTemplateLiteralLoose(["\n  text-align: left;\n  font-weight: 600;\n  margin-left: 9px;\n"])));
var SubtitleWrapper = styled(Subtitle)(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose(["\n  margin: 8px 0 16px 9px;\n  text-align: left;\n"])));
var RowWrapper = styled(View$1)(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  justify-content: center;\n  margin: 0 35px 22px 35px;\n"])));

var ModalSmall = function ModalSmall(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      textButtonCancel = _ref.textButtonCancel,
      onCancel = _ref.onCancel,
      textButtonSuccess = _ref.textButtonSuccess,
      onSuccess = _ref.onSuccess,
      open = _ref.open,
      closeCallback = _ref.closeCallback;
  return /*#__PURE__*/React.createElement(Modal$1, {
    open: open,
    closeCallback: closeCallback,
    maxWidth: "400px"
  }, title && /*#__PURE__*/React.createElement(TitleWrapper, null, title), subtitle && /*#__PURE__*/React.createElement(SubtitleWrapper, null, subtitle), /*#__PURE__*/React.createElement(RowWrapper, null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "link-button",
    onClick: onCancel,
    marginRight: "--spacing-1"
  }, textButtonCancel), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    onClick: onSuccess
  }, textButtonSuccess)));
};

ModalSmall.defaultProps = {
  textButtonCancel: 'Cancelar',
  textButtonSuccess: 'Salvar'
};
ModalSmall.propTypes = {
  onSuccess: PropTypes__default.func.isRequired,
  onCancel: PropTypes__default.func,
  textButtonCancel: PropTypes__default.string,
  textButtonSuccess: PropTypes__default.string
};

var MyAccountAddressExitModalTemplate = function MyAccountAddressExitModalTemplate(_ref) {
  var open = _ref.open,
      closeCallback = _ref.closeCallback,
      onCancel = _ref.onCancel,
      onSuccess = _ref.onSuccess;
  return /*#__PURE__*/React.createElement(ModalSmall, {
    title: "Deseja realmente sair agora?",
    subtitle: "As informa\xE7\xF5es n\xE3o ser\xE3o salvas.",
    onCancel: onCancel,
    textButtonCancel: "Cancelar",
    onSuccess: onSuccess,
    textButtonSuccess: "Sair sem salvar",
    open: open,
    closeCallback: closeCallback
  });
};

MyAccountAddressExitModalTemplate.propTypes = {
  onSuccess: PropTypes__default.func.isRequired,
  onCancel: PropTypes__default.func
};

var _templateObject$n, _templateObject2$c, _templateObject3$6, _templateObject4$4, _templateObject5$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var lurker$1 = new Lurker('meu_cadastro');
var Content$3 = styled(View$1)(_templateObject$n || (_templateObject$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var FormWrapper = styled(Form)(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-top: 24px;\n"])));
var ZipCodeFormItemWrapper = styled.div(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 0;\n  position: relative;\n\n  & > a {\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n"])));
var RowWrapper$1 = styled(Row)(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"])));
var ButtonRowWebWrapper = styled(View$1)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 60%;\n  margin-top: 32px;\n\n  & > button {\n    max-width: 193px;\n  }\n"])));
var ButtonRowWebComponentWrapper = styled(View$1)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 32px;\n"])));
var ButtonRowWebComponentNewAddressWrapper = styled(View$1)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  justify-content: center;\n  margin-top: 32px;\n"])));
var WebLink = styled(Link$2)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  font-size: 16px;\n"])));
var ToggleWrapper = styled(View$1)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  margin-left: 4px;\n  align-items: center;\n  justify-content: space-between;\n"])));
var ErrorMsgWrapper = styled(View$1)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var AddressForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AddressForm, _React$Component);

  function AddressForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onSuccessLocation = function (result) {
      var fields = _this.state.fields;
      var value = fields.zipcode.value;

      _this.setState(function (prevState) {
        return _extends({}, prevState, {
          locationBoxLoading: false,
          fields: _extends({}, fields, {
            neighbourhood: _extends({}, fields.neighbourhood, {
              value: result.bairro_distrito,
              valid: true,
              updated: true,
              visible: !result.bairro_distrito
            }),
            state: _extends({}, fields.state, {
              value: result.sigla_uf,
              valid: true,
              updated: true
            }),
            city: _extends({}, fields.city, {
              value: result.localidade,
              valid: true,
              updated: true
            }),
            street: _extends({}, fields.street, {
              valid: true,
              value: typeof result.logradouro === 'string' ? result.logradouro.substring(0, 200) : ''
            }),
            zipcode: _extends({}, fields.zipcode, {
              lastValidValue: value
            })
          })
        });
      });
    };

    _this.onErrorLocation = function (error) {
      var fields = _this.state.fields;
      var value = fields.zipcode.value;

      _this.setState(function (prevState) {
        return {
          locationBoxLoading: false,
          fields: _extends({}, prevState.fields, {
            zipcode: _extends({}, fields.zipcode, {
              value: value,
              valid: false,
              msg: prevState.validators.zipcode.message
            }),
            city: {
              value: '',
              valid: false
            },
            state: {
              value: '',
              valid: false
            },
            neighbourhood: {
              value: '',
              valid: false
            }
          })
        };
      });
    };

    _this.onInputDataChanged = function () {
      return _this.setState({
        hasUpdatedAnyField: true
      });
    };

    _this.dismissCancelModal = function () {
      return _this.setState({
        showCancelModal: false
      });
    };

    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.doUpdateAddress = _this.doUpdateAddress.bind(_assertThisInitialized(_this));
    _this.getDataToSubmit = _this.getDataToSubmit.bind(_assertThisInitialized(_this));
    _this.sendRequest = _this.sendRequest.bind(_assertThisInitialized(_this));
    _this.updateField = _this.updateField.bind(_assertThisInitialized(_this));
    _this.onFieldChange = _this.onFieldChange.bind(_assertThisInitialized(_this));
    _this.onFieldBlur = _this.onFieldBlur.bind(_assertThisInitialized(_this));
    _this.onZipCodeBlur = _this.onZipCodeBlur.bind(_assertThisInitialized(_this));
    _this.onZipCodeBeforeSend = _this.onZipCodeBeforeSend.bind(_assertThisInitialized(_this));
    _this.state = {
      isSubmitting: false,
      showGenericError: false,
      showRateLimitError: false,
      locationBoxLoading: false,
      hasUpdatedAnyField: false,
      showCancelModal: false,
      validators: {
        zipcode: {
          action: function action(zipcode) {
            return /^(\d{5}-\d{3})$/.test(zipcode);
          },
          mask: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
          message: 'Informe um CEP válido'
        },
        number: {
          action: function action(number) {
            return /^\d+$/.test(number);
          },
          message: 'Obrigatório'
        },
        street: {
          action: function action(street) {
            return typeof street === 'string' && street.length > 0 && street.length <= 200;
          },
          message: 'Obrigatório'
        },
        neighbourhood: {
          action: function action(neighbourhood) {
            return typeof neighbourhood === 'string' && neighbourhood.length > 0 && neighbourhood.length <= 90;
          },
          message: 'Obrigatório'
        }
      },
      onBlur: {
        zipcode: _this.onZipCodeBlur
      },
      fields: {
        zipcode: {
          value: '',
          pristine: true,
          valid: true,
          lastValidValue: null
        },
        neighbourhood: {
          value: '',
          pristine: true,
          valid: true,
          updated: false
        },
        street: {
          value: '',
          pristine: true,
          valid: true
        },
        number: {
          value: '',
          pristine: true,
          valid: true
        },
        complement: {
          value: '',
          pristine: true,
          valid: true
        },
        reference: {
          value: '',
          pristine: true,
          valid: true
        },
        state: {
          value: '',
          pristine: true,
          valid: true,
          updated: false
        },
        city: {
          value: '',
          pristine: true,
          valid: true,
          updated: false
        },
        main: {
          value: false,
          pristine: true,
          valid: true,
          updated: false
        }
      }
    };
    _this.inputs = {};
    return _this;
  }

  AddressForm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var fields = state.fields;
    var fieldsToPopulates = Object.keys(fields).reduce(function (obj, field) {
      if (fields[field].pristine && !fields[field].updated) {
        var _extends2;

        var value = props[field] ? props[field] : fields[field].value;

        if (field === 'zipcode') {
          fields[field].lastValidValue = value;
        }

        if (typeof value === 'string') {
          var _state$validators$fie2 = _extends({}, state.validators[field]),
              mask = _state$validators$fie2.mask;

          if (mask && value) value = applyMask(value, null, mask);
        }

        var id = props.id;
        var fieldContent = fields[field];

        if (id) {
          if (field === 'zipcode' || field === 'number' || field === 'street' || field === 'neighbourhood') {
            fieldContent = _extends({}, fieldContent, {
              pristine: false,
              valid: !!value,
              msg: 'Obrigatório'
            });
          }
        }

        return _extends({}, obj, (_extends2 = {}, _extends2[field] = _extends({}, fieldContent, {
          value: value
        }), _extends2));
      }

      return obj;
    }, {});
    return {
      fields: _extends({}, fields, fieldsToPopulates)
    };
  };

  var _proto = AddressForm.prototype;

  _proto.onFieldChange = function onFieldChange(event, field) {
    var newValue = event.target.value;

    var _this$state$fields$fi = _extends({}, this.state.fields[field]),
        value = _this$state$fields$fi.value;

    var _this$state$validator = _extends({}, this.state.validators[field]),
        mask = _this$state$validator.mask;

    if (mask) newValue = applyMask(newValue, value, mask);
    this.onInputDataChanged();
    this.updateField(field, newValue, true, false);
  };

  _proto.onFieldBlur = function onFieldBlur(event, field) {
    var value = event.target.value;

    var _this$state$validator2 = _extends({}, this.state.validators[field]),
        action = _this$state$validator2.action,
        message = _this$state$validator2.message;

    var onBlurHandler = this.state.onBlur[field];
    var valid = true;
    var msg = null;

    if (typeof action === 'function') {
      valid = action(value);
      if (!valid) msg = message;
    }

    this.updateField(field, value, valid, false, msg, function () {
      if (typeof onBlurHandler === 'function') {
        onBlurHandler();
      }
    });
  };

  _proto.onZipCodeBlur = function onZipCodeBlur() {
    var _this2 = this;

    var fields = this.state.fields;
    var _fields$zipcode = fields.zipcode,
        value = _fields$zipcode.value,
        valid = _fields$zipcode.valid,
        pristine = _fields$zipcode.pristine,
        lastValidValue = _fields$zipcode.lastValidValue;
    if (lastValidValue.replace('-', '') === value.replace('-', '')) return;

    if (valid && !pristine) {
      this.setState({
        locationBoxLoading: true
      });
      getLocationInfo(value).then(function (_ref) {
        var _ref$result = _ref.result,
            result = _ref$result === void 0 ? {} : _ref$result;
        return _this2.onSuccessLocation(result);
      })["catch"](function () {
        return _this2.onErrorLocation();
      });
    }
  };

  _proto.getDataToSubmit = function getDataToSubmit() {
    var fields = this.state.fields;
    return Object.keys(fields).reduce(function (obj, field) {
      var _extends3;

      var fieldValue = fields[field].value;

      if (typeof fieldValue === 'string') {
        fieldValue = fieldValue.trim();
      }

      if (field === 'zipcode') {
        fieldValue = fieldValue.replace('-', '');
      }

      if (field === 'number') {
        fieldValue = Number(fieldValue);
      }

      return _extends({}, obj, (_extends3 = {}, _extends3[field] = fieldValue !== '' ? fieldValue : null, _extends3));
    }, {});
  };

  _proto.sendRequest = function sendRequest() {
    var _this3 = this;

    this.setState({
      showGenericError: false
    });

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }

    var formData = this.getDataToSubmit();
    var addressApiCall = this.props.id ? updateAddress(this.props.id, formData) : createAddress(formData);
    addressApiCall.then(function (data) {
      _this3.setState({
        showGenericError: false,
        showRateLimitError: false
      }, function () {
        if (_this3.props.onSuccess) {
          _this3.props.onSuccess(data);
        }

        if (_this3.props.goBack) {
          _this3.props.goBack();
        }
      });
    })["catch"](function (data) {
      if (_this3.props.onError) {
        _this3.props.onError();
      }

      if (data && data.response && data.response.status === 429) {
        lurker$1.errorMessageEvt('edition_olx_pay_address_form_exceeded_limit');

        _this3.setState({
          showRateLimitError: true
        });
      } else {
        lurker$1.errorMessageEvt('edition_olx_pay_address_form_generic', {
          statusError: data.response.status
        });

        _this3.setState({
          showGenericError: true
        });
      }
    })["finally"](function () {
      _this3.setState({
        isSubmitting: false
      });
    });
  };

  _proto.checkFormIsValid = function checkFormIsValid() {
    var _this4 = this;

    return new Promise(function (resolve, reject) {
      var allValid = true;
      var _this4$state = _this4.state,
          fields = _this4$state.fields,
          validators = _this4$state.validators;
      var updatedFields = Object.keys(fields).reduce(function (obj, field) {
        var _extends4;

        var newField = _extends({}, fields[field], {
          pristine: false
        });

        var _fields$field = fields[field],
            value = _fields$field.value,
            valid = _fields$field.valid;

        var _validators$field = _extends({}, validators[field]),
            action = _validators$field.action,
            message = _validators$field.message;

        if (typeof action === 'function') {
          var isValid = action(value);

          if (!isValid) {
            newField.valid = isValid;
            newField.msg = message;
            allValid = false;
          }
        } else if (!valid) {
          allValid = false;
        }

        return _extends({}, obj, (_extends4 = {}, _extends4[field] = newField, _extends4));
      }, {});

      if (allValid) {
        resolve();
      } else {
        _this4.setState({
          fields: updatedFields,
          isSubmitting: false
        }, reject);
      }
    });
  };

  _proto.doUpdateAddress = function doUpdateAddress() {
    var _this5 = this;

    this.checkFormIsValid().then(this.sendRequest)["catch"](function () {
      return _this5.setState({
        isSubmitting: false
      });
    });
  };

  _proto.onZipCodeBeforeSend = function onZipCodeBeforeSend() {
    var _this6 = this;

    return new Promise(function (resolve, reject) {
      var fields = _this6.state.fields;
      var _fields$zipcode2 = fields.zipcode,
          value = _fields$zipcode2.value,
          lastValidValue = _fields$zipcode2.lastValidValue;
      if (lastValidValue.replace('-', '') === value.replace('-', '')) return resolve();

      _this6.setState({
        locationBoxLoading: true
      });

      getLocationInfo(value).then(function (_ref2) {
        var _ref2$result = _ref2.result,
            result = _ref2$result === void 0 ? {} : _ref2$result;

        _this6.setState({
          isSubmitting: false
        }, _this6.onSuccessLocation(result));

        return resolve();
      })["catch"](function () {
        _this6.setState({
          isSubmitting: false
        }, _this6.onErrorLocation());

        return reject();
      });
    });
  };

  _proto.handleSubmit = function handleSubmit(event) {
    var _this7 = this;

    event.preventDefault();
    lurker$1.clickEvt('salvar_endereco');
    this.setState({
      isSubmitting: true
    }, function () {
      _this7.onZipCodeBeforeSend().then(function () {
        return _this7.doUpdateAddress();
      })["catch"](function () {
        lurker$1.viewMessageEvt('error', {
          accounts_reason: 'invalid_zipcode'
        });
      });
    });
  };

  _proto.updateField = function updateField(field, value, valid, pristine, message, callback, updated) {
    var _extends5;

    var fields = _extends({}, this.state.fields);

    var newField = _extends({}, fields[field], {
      value: value
    });

    if (typeof valid === 'boolean') {
      newField.valid = valid;
    }

    if (typeof pristine === 'boolean') {
      newField.pristine = pristine;

      if (this.props.savePristineState) {
        this.props.savePristineState(pristine);
      }
    }

    if (typeof message === 'string') {
      newField.msg = message;
    }

    if (typeof updated === 'boolean') {
      newField.updated = updated;
    }

    this.setState({
      fields: _extends({}, fields, (_extends5 = {}, _extends5[field] = newField, _extends5))
    }, callback);
  };

  _proto.updateFocus = function updateFocus(input) {
    if (this.inputs && this.inputs[input] && this.inputs[input].focus) {
      this.inputs[input].focus();
    }
  };

  _proto.handleCancel = function handleCancel() {
    var hasUpdatedAnyField = this.state.hasUpdatedAnyField;
    if (hasUpdatedAnyField) this.setState({
      showCancelModal: true
    });else {
      this.props.goBack();
    }
  };

  _proto.renderLocationBox = function renderLocationBox() {
    var _this$state = this.state,
        fields = _this$state.fields,
        locationBoxLoading = _this$state.locationBoxLoading;
    var neighbourhood = fields.neighbourhood,
        city = fields.city,
        state = fields.state,
        zipcode = fields.zipcode;

    if (zipcode.valid && city.value && state.value && !locationBoxLoading) {
      return /*#__PURE__*/React.createElement(AddressBox, {
        neighbourhood: neighbourhood.value,
        city: city.value,
        state: state.value
      });
    }

    return null;
  };

  _proto.renderWebComponentOnAdInsertion = function renderWebComponentOnAdInsertion(isFormDisabled, isSubmitting) {
    var _this$props = this.props,
        main = _this$props.main,
        id = _this$props.id,
        onDeleteClick = _this$props.onDeleteClick;

    if (main || !id) {
      return /*#__PURE__*/React.createElement(ButtonRowWebComponentNewAddressWrapper, null, /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        size: "large",
        disabled: isFormDisabled,
        isLoading: isSubmitting,
        onClick: this.handleSubmit
      }, "Salvar endere\xE7o"));
    }

    return /*#__PURE__*/React.createElement(ButtonRowWebComponentWrapper, null, /*#__PURE__*/React.createElement(DeleteAddress, {
      onClick: function onClick(event) {
        return onDeleteClick(event);
      }
    }), /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      disabled: isFormDisabled,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, "Salvar endere\xE7o"));
  };

  _proto.render = function render() {
    var _this8 = this;

    var _this$state2 = this.state,
        isSubmitting = _this$state2.isSubmitting,
        showGenericError = _this$state2.showGenericError,
        showRateLimitError = _this$state2.showRateLimitError,
        fields = _this$state2.fields,
        locationBoxLoading = _this$state2.locationBoxLoading;
    var zipcode = fields.zipcode,
        street = fields.street,
        number = fields.number,
        complement = fields.complement,
        reference = fields.reference,
        main = fields.main,
        neighbourhood = fields.neighbourhood;
    var zipcodeError = !zipcode.valid && !zipcode.pristine;
    var streetError = !street.valid && !street.pristine;
    var neighbourhoodError = !neighbourhood.valid && !neighbourhood.pristine;
    var numberError = !number.valid && !number.pristine;
    var complementError = !complement.valid && !complement.pristine;
    var referenceError = !reference.valid && !reference.pristine;
    var isFormDisabled = isSubmitting || this.props.disabled;
    var _this$props2 = this.props,
        loading = _this$props2.loading,
        isMain = _this$props2.main,
        isFirstAddress = _this$props2.isFirstAddress;

    if (loading) {
      return /*#__PURE__*/React.createElement(Content$3, null, /*#__PURE__*/React.createElement(FormSkeleton, {
        type: "form",
        size: "4"
      }));
    }

    return /*#__PURE__*/React.createElement(Content$3, null, showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel salvar seu endere\xE7o."
    })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
    })), /*#__PURE__*/React.createElement(FormWrapper, {
      noValidate: true
    }, /*#__PURE__*/React.createElement(RowWrapper$1, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ZipCodeFormItemWrapper, null, /*#__PURE__*/React.createElement(Link$2, {
      target: "_blank",
      href: "http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm",
      size: "small"
    }, "n\xE3o sei meu CEP"), /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-zipcode",
      label: "CEP *",
      maxLength: 9,
      onChange: function onChange(event) {
        return _this8.onFieldChange(event, 'zipcode');
      },
      onBlur: function onBlur(event) {
        return _this8.onFieldBlur(event, 'zipcode');
      },
      value: zipcode.value,
      disabled: isFormDisabled,
      "aria-required": true,
      state: locationBoxLoading && 'loading' || zipcodeError && 'error',
      stateMessage: locationBoxLoading && 'Carregando...' || zipcodeError && zipcode.msg
    })), this.renderLocationBox())), neighbourhood.visible && /*#__PURE__*/React.createElement(RowWrapper$1, null, /*#__PURE__*/React.createElement(Col, {
      size: "100"
    }, /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-neighbourhood",
      label: "Bairro *",
      maxLength: 90,
      onChange: function onChange(event) {
        return _this8.onFieldChange(event, 'neighbourhood');
      },
      onBlur: function onBlur(event) {
        return _this8.onFieldBlur(event, 'neighbourhood');
      },
      value: neighbourhood.value,
      disabled: isFormDisabled,
      ref: function ref(x) {
        _this8.inputs.neighbourhood = x;
      },
      "aria-required": true,
      state: neighbourhoodError ? 'error' : '',
      stateMessage: neighbourhoodError && neighbourhood.msg
    }))), /*#__PURE__*/React.createElement(RowWrapper$1, null, /*#__PURE__*/React.createElement(Col, {
      size: "100"
    }, /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-street",
      label: "Rua *",
      maxLength: 200,
      onChange: function onChange(event) {
        return _this8.onFieldChange(event, 'street');
      },
      onBlur: function onBlur(event) {
        return _this8.onFieldBlur(event, 'street');
      },
      value: street.value,
      disabled: isFormDisabled,
      "aria-required": true,
      state: streetError ? 'error' : '',
      stateMessage: streetError && street.msg,
      ref: function ref(x) {
        _this8.inputs.street = x;
      }
    }))), /*#__PURE__*/React.createElement(RowWrapper$1, null, /*#__PURE__*/React.createElement(Col, {
      size: "30"
    }, /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-number",
      label: "N\xFAmero *",
      onChange: function onChange(event) {
        return _this8.onFieldChange(event, 'number');
      },
      onBlur: function onBlur(event) {
        return _this8.onFieldBlur(event, 'number');
      },
      value: typeof number.value === 'number' ? String(number.value) : number.value,
      "aria-required": true,
      disabled: isFormDisabled,
      ref: function ref(x) {
        _this8.inputs.number = x;
      },
      state: numberError ? 'error' : '',
      stateMessage: numberError && number.msg
    })), /*#__PURE__*/React.createElement(Col, {
      size: "64"
    }, /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-complement",
      label: "Complemento",
      maxLength: 50,
      onChange: function onChange(event) {
        return _this8.onFieldChange(event, 'complement');
      },
      onBlur: function onBlur(event) {
        return _this8.onFieldBlur(event, 'complement');
      },
      value: complement.value,
      disabled: isFormDisabled,
      ref: function ref(x) {
        _this8.inputs.complement = x;
      },
      state: complementError ? 'error' : '',
      stateMessage: complementError && complement.msg
    }))), /*#__PURE__*/React.createElement(RowWrapper$1, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-reference",
      label: "Ponto de refer\xEAncia",
      onBlur: function onBlur(event) {
        return _this8.onFieldBlur(event, 'reference');
      },
      onChange: function onChange(event) {
        return _this8.onFieldChange(event, 'reference');
      },
      value: reference.value,
      disabled: isFormDisabled,
      ref: function ref(x) {
        _this8.inputs.reference = x;
      },
      state: referenceError ? 'error' : '',
      stateMessage: referenceError && reference.msg
    }))), !isMain && !isFirstAddress && /*#__PURE__*/React.createElement(RowWrapper$1, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ToggleWrapper, null, /*#__PURE__*/React.createElement(Label$1, null, "Usar como endere\xE7o principal"), /*#__PURE__*/React.createElement(ToggleSwitch, {
      "aria-label": "Usar como endere\xE7o principal",
      checked: Boolean(main.value),
      disabled: isFormDisabled,
      onChange: function onChange() {
        return _this8.updateField('main', !main.value, true, false, null, null, true);
      }
    })))), this.props.isOnAdInsertion ? this.renderWebComponentOnAdInsertion(isFormDisabled, isSubmitting) : /*#__PURE__*/React.createElement(ButtonRowWebWrapper, null, /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      disabled: isFormDisabled,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, "Salvar"), /*#__PURE__*/React.createElement(WebLink, {
      size: "small",
      onClick: function onClick() {
        return _this8.handleCancel();
      }
    }, "Cancelar"), this.state.showCancelModal && /*#__PURE__*/React.createElement(MyAccountAddressExitModalTemplate, {
      open: this.state.showCancelModal,
      closeCallback: function closeCallback() {
        return _this8.dismissCancelModal();
      },
      onSuccess: function onSuccess() {
        return _this8.props.goBack();
      },
      onCancel: function onCancel() {
        return _this8.dismissCancelModal();
      }
    }))));
  };

  return AddressForm;
}(React.Component);
AddressForm.propTypes = {
  onSubmit: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  zipcode: PropTypes__default.string,
  neighbourhood: PropTypes__default.string,
  street: PropTypes__default.string,
  number: PropTypes__default.number,
  complement: PropTypes__default.string,
  reference: PropTypes__default.string,
  state: PropTypes__default.string,
  city: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  loading: PropTypes__default.bool,
  goBack: PropTypes__default.func,
  onDeleteClick: PropTypes__default.func,
  isOnAdInsertion: PropTypes__default.bool,
  main: PropTypes__default.bool,
  isFirstAddress: PropTypes__default.bool,
  id: PropTypes__default.string,
  savePristineState: PropTypes__default.func
};
AddressForm.defaultProps = {
  loading: false
};

var _templateObject$o;
var Backdrop = styled(View$1)(_templateObject$o || (_templateObject$o = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.55);\n  z-index: 9999;\n  ", "\n\n  &.fade-enter {\n    opacity: 0;\n  }\n  &.fade-enter-active {\n    opacity: 1;\n    transition: opacity 300ms;\n  }\n  &.fade-exit {\n    opacity: 1;\n  }\n  &.fade-exit-active {\n    opacity: 0;\n    transition: opacity 500ms;\n  }\n"])), function (props) {
  return !props.open ? 'display: none;' : '';
});

var Cross = function Cross() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 1000 1000"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M585.8 500l385.9-385.9c24.5-24.5 24.5-61.3 0-85.8s-61.3-24.5-85.8 0L500 414.3 114.1 28.4c-24.5-24.5-61.2-24.5-85.8 0-24.5 24.5-24.5 61.3 0 85.8L411.2 500 28.4 885.9c-24.5 24.5-24.5 61.3 0 85.8 9.2 12.3 27.6 18.4 42.9 18.4 15.3 0 30.6-6.1 42.9-18.4L500 585.8l385.9 385.9c12.3 12.3 27.6 18.4 42.9 18.4s30.6-6.1 42.9-18.4c24.5-24.5 24.5-61.3 0-85.8L585.8 500z",
    fill: "#a2a2a2"
  }));
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var scheduler_production_min = createCommonjsModule(function (module, exports) {
var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()};}else {var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q};}
if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null;}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0));};g=function(a,b){u=setTimeout(a,b);};h=function(){clearTimeout(u);};exports.unstable_shouldYield=function(){return !1};k=exports.unstable_forceFrameRate=function(){};}else {var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5;};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null);}catch(b){throw G.postMessage(null),b;}}else A=!1;};f=function(a){B=a;A||(A=!0,G.postMessage(null));};g=function(a,b){C=
x(function(){a(exports.unstable_now());},b);};h=function(){y(C);C=-1;};}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M);}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else {var b=J(M);null!==b&&g(U,b.startTime-a);}}
function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b);}else K(L);O=J(L);}if(null!==O)var m=!0;else {var n=J(M);null!==n&&g(U,n.startTime-b);m=!1;}return m}finally{O=null,P=c,Q=!1;}}var W=k;exports.unstable_IdlePriority=5;
exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null;};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V));};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P;}var c=P;P=b;try{return a()}finally{P=c;}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3;}var c=P;P=a;try{return b()}finally{P=c;}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3;}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c;}}};
});

var scheduler_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

var enableSchedulerDebugging = false;
var enableProfiling = false;

var requestHostCallback;
var requestHostTimeout;
var cancelHostTimeout;
var requestPaint;
var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';

if (hasPerformanceNow) {
  var localPerformance = performance;

  exports.unstable_now = function () {
    return localPerformance.now();
  };
} else {
  var localDate = Date;
  var initialTime = localDate.now();

  exports.unstable_now = function () {
    return localDate.now() - initialTime;
  };
}

if ( // If Scheduler runs in a non-DOM environment, it falls back to a naive
// implementation using setTimeout.
typeof window === 'undefined' || // Check if MessageChannel is supported, too.
typeof MessageChannel !== 'function') {
  // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
  // fallback to a naive implementation.
  var _callback = null;
  var _timeoutID = null;

  var _flushCallback = function () {
    if (_callback !== null) {
      try {
        var currentTime = exports.unstable_now();
        var hasRemainingTime = true;

        _callback(hasRemainingTime, currentTime);

        _callback = null;
      } catch (e) {
        setTimeout(_flushCallback, 0);
        throw e;
      }
    }
  };

  requestHostCallback = function (cb) {
    if (_callback !== null) {
      // Protect against re-entrancy.
      setTimeout(requestHostCallback, 0, cb);
    } else {
      _callback = cb;
      setTimeout(_flushCallback, 0);
    }
  };

  requestHostTimeout = function (cb, ms) {
    _timeoutID = setTimeout(cb, ms);
  };

  cancelHostTimeout = function () {
    clearTimeout(_timeoutID);
  };

  exports.unstable_shouldYield = function () {
    return false;
  };

  requestPaint = exports.unstable_forceFrameRate = function () {};
} else {
  // Capture local references to native APIs, in case a polyfill overrides them.
  var _setTimeout = window.setTimeout;
  var _clearTimeout = window.clearTimeout;

  if (typeof console !== 'undefined') {
    // TODO: Scheduler no longer requires these methods to be polyfilled. But
    // maybe we want to continue warning if they don't exist, to preserve the
    // option to rely on it in the future?
    var requestAnimationFrame = window.requestAnimationFrame;
    var cancelAnimationFrame = window.cancelAnimationFrame;

    if (typeof requestAnimationFrame !== 'function') {
      // Using console['error'] to evade Babel and ESLint
      console['error']("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
    }

    if (typeof cancelAnimationFrame !== 'function') {
      // Using console['error'] to evade Babel and ESLint
      console['error']("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
    }
  }

  var isMessageLoopRunning = false;
  var scheduledHostCallback = null;
  var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
  // thread, like user events. By default, it yields multiple times per frame.
  // It does not attempt to align with frame boundaries, since most tasks don't
  // need to be frame aligned; for those that do, use requestAnimationFrame.

  var yieldInterval = 5;
  var deadline = 0; // TODO: Make this configurable

  {
    // `isInputPending` is not available. Since we have no way of knowing if
    // there's pending input, always yield at the end of the frame.
    exports.unstable_shouldYield = function () {
      return exports.unstable_now() >= deadline;
    }; // Since we yield every frame regardless, `requestPaint` has no effect.


    requestPaint = function () {};
  }

  exports.unstable_forceFrameRate = function (fps) {
    if (fps < 0 || fps > 125) {
      // Using console['error'] to evade Babel and ESLint
      console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing frame rates higher than 125 fps is not supported');
      return;
    }

    if (fps > 0) {
      yieldInterval = Math.floor(1000 / fps);
    } else {
      // reset the framerate
      yieldInterval = 5;
    }
  };

  var performWorkUntilDeadline = function () {
    if (scheduledHostCallback !== null) {
      var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
      // cycle. This means there's always time remaining at the beginning of
      // the message event.

      deadline = currentTime + yieldInterval;
      var hasTimeRemaining = true;

      try {
        var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);

        if (!hasMoreWork) {
          isMessageLoopRunning = false;
          scheduledHostCallback = null;
        } else {
          // If there's more work, schedule the next message event at the end
          // of the preceding one.
          port.postMessage(null);
        }
      } catch (error) {
        // If a scheduler task throws, exit the current browser task so the
        // error can be observed.
        port.postMessage(null);
        throw error;
      }
    } else {
      isMessageLoopRunning = false;
    } // Yielding to the browser will give it a chance to paint, so we can
  };

  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = performWorkUntilDeadline;

  requestHostCallback = function (callback) {
    scheduledHostCallback = callback;

    if (!isMessageLoopRunning) {
      isMessageLoopRunning = true;
      port.postMessage(null);
    }
  };

  requestHostTimeout = function (callback, ms) {
    taskTimeoutID = _setTimeout(function () {
      callback(exports.unstable_now());
    }, ms);
  };

  cancelHostTimeout = function () {
    _clearTimeout(taskTimeoutID);

    taskTimeoutID = -1;
  };
}

function push(heap, node) {
  var index = heap.length;
  heap.push(node);
  siftUp(heap, node, index);
}
function peek(heap) {
  var first = heap[0];
  return first === undefined ? null : first;
}
function pop(heap) {
  var first = heap[0];

  if (first !== undefined) {
    var last = heap.pop();

    if (last !== first) {
      heap[0] = last;
      siftDown(heap, last, 0);
    }

    return first;
  } else {
    return null;
  }
}

function siftUp(heap, node, i) {
  var index = i;

  while (true) {
    var parentIndex = index - 1 >>> 1;
    var parent = heap[parentIndex];

    if (parent !== undefined && compare(parent, node) > 0) {
      // The parent is larger. Swap positions.
      heap[parentIndex] = node;
      heap[index] = parent;
      index = parentIndex;
    } else {
      // The parent is smaller. Exit.
      return;
    }
  }
}

function siftDown(heap, node, i) {
  var index = i;
  var length = heap.length;

  while (index < length) {
    var leftIndex = (index + 1) * 2 - 1;
    var left = heap[leftIndex];
    var rightIndex = leftIndex + 1;
    var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

    if (left !== undefined && compare(left, node) < 0) {
      if (right !== undefined && compare(right, left) < 0) {
        heap[index] = right;
        heap[rightIndex] = node;
        index = rightIndex;
      } else {
        heap[index] = left;
        heap[leftIndex] = node;
        index = leftIndex;
      }
    } else if (right !== undefined && compare(right, node) < 0) {
      heap[index] = right;
      heap[rightIndex] = node;
      index = rightIndex;
    } else {
      // Neither child is smaller. Exit.
      return;
    }
  }
}

function compare(a, b) {
  // Compare sort index first, then task id.
  var diff = a.sortIndex - b.sortIndex;
  return diff !== 0 ? diff : a.id - b.id;
}

// TODO: Use symbols?
var ImmediatePriority = 1;
var UserBlockingPriority = 2;
var NormalPriority = 3;
var LowPriority = 4;
var IdlePriority = 5;

function markTaskErrored(task, ms) {
}

/* eslint-disable no-var */
// Math.pow(2, 30) - 1
// 0b111111111111111111111111111111

var maxSigned31BitInt = 1073741823; // Times out immediately

var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
var NORMAL_PRIORITY_TIMEOUT = 5000;
var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap

var taskQueue = [];
var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
var currentTask = null;
var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

var isPerformingWork = false;
var isHostCallbackScheduled = false;
var isHostTimeoutScheduled = false;

function advanceTimers(currentTime) {
  // Check for tasks that are no longer delayed and add them to the queue.
  var timer = peek(timerQueue);

  while (timer !== null) {
    if (timer.callback === null) {
      // Timer was cancelled.
      pop(timerQueue);
    } else if (timer.startTime <= currentTime) {
      // Timer fired. Transfer to the task queue.
      pop(timerQueue);
      timer.sortIndex = timer.expirationTime;
      push(taskQueue, timer);
    } else {
      // Remaining timers are pending.
      return;
    }

    timer = peek(timerQueue);
  }
}

function handleTimeout(currentTime) {
  isHostTimeoutScheduled = false;
  advanceTimers(currentTime);

  if (!isHostCallbackScheduled) {
    if (peek(taskQueue) !== null) {
      isHostCallbackScheduled = true;
      requestHostCallback(flushWork);
    } else {
      var firstTimer = peek(timerQueue);

      if (firstTimer !== null) {
        requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
      }
    }
  }
}

function flushWork(hasTimeRemaining, initialTime) {


  isHostCallbackScheduled = false;

  if (isHostTimeoutScheduled) {
    // We scheduled a timeout but it's no longer needed. Cancel it.
    isHostTimeoutScheduled = false;
    cancelHostTimeout();
  }

  isPerformingWork = true;
  var previousPriorityLevel = currentPriorityLevel;

  try {
    if (enableProfiling) {
      try {
        return workLoop(hasTimeRemaining, initialTime);
      } catch (error) {
        if (currentTask !== null) {
          var currentTime = exports.unstable_now();
          markTaskErrored(currentTask, currentTime);
          currentTask.isQueued = false;
        }

        throw error;
      }
    } else {
      // No catch in prod code path.
      return workLoop(hasTimeRemaining, initialTime);
    }
  } finally {
    currentTask = null;
    currentPriorityLevel = previousPriorityLevel;
    isPerformingWork = false;
  }
}

function workLoop(hasTimeRemaining, initialTime) {
  var currentTime = initialTime;
  advanceTimers(currentTime);
  currentTask = peek(taskQueue);

  while (currentTask !== null && !(enableSchedulerDebugging )) {
    if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || exports.unstable_shouldYield())) {
      // This currentTask hasn't expired, and we've reached the deadline.
      break;
    }

    var callback = currentTask.callback;

    if (typeof callback === 'function') {
      currentTask.callback = null;
      currentPriorityLevel = currentTask.priorityLevel;
      var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;

      var continuationCallback = callback(didUserCallbackTimeout);
      currentTime = exports.unstable_now();

      if (typeof continuationCallback === 'function') {
        currentTask.callback = continuationCallback;
      } else {

        if (currentTask === peek(taskQueue)) {
          pop(taskQueue);
        }
      }

      advanceTimers(currentTime);
    } else {
      pop(taskQueue);
    }

    currentTask = peek(taskQueue);
  } // Return whether there's additional work


  if (currentTask !== null) {
    return true;
  } else {
    var firstTimer = peek(timerQueue);

    if (firstTimer !== null) {
      requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
    }

    return false;
  }
}

function unstable_runWithPriority(priorityLevel, eventHandler) {
  switch (priorityLevel) {
    case ImmediatePriority:
    case UserBlockingPriority:
    case NormalPriority:
    case LowPriority:
    case IdlePriority:
      break;

    default:
      priorityLevel = NormalPriority;
  }

  var previousPriorityLevel = currentPriorityLevel;
  currentPriorityLevel = priorityLevel;

  try {
    return eventHandler();
  } finally {
    currentPriorityLevel = previousPriorityLevel;
  }
}

function unstable_next(eventHandler) {
  var priorityLevel;

  switch (currentPriorityLevel) {
    case ImmediatePriority:
    case UserBlockingPriority:
    case NormalPriority:
      // Shift down to normal priority
      priorityLevel = NormalPriority;
      break;

    default:
      // Anything lower than normal priority should remain at the current level.
      priorityLevel = currentPriorityLevel;
      break;
  }

  var previousPriorityLevel = currentPriorityLevel;
  currentPriorityLevel = priorityLevel;

  try {
    return eventHandler();
  } finally {
    currentPriorityLevel = previousPriorityLevel;
  }
}

function unstable_wrapCallback(callback) {
  var parentPriorityLevel = currentPriorityLevel;
  return function () {
    // This is a fork of runWithPriority, inlined for performance.
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = parentPriorityLevel;

    try {
      return callback.apply(this, arguments);
    } finally {
      currentPriorityLevel = previousPriorityLevel;
    }
  };
}

function unstable_scheduleCallback(priorityLevel, callback, options) {
  var currentTime = exports.unstable_now();
  var startTime;

  if (typeof options === 'object' && options !== null) {
    var delay = options.delay;

    if (typeof delay === 'number' && delay > 0) {
      startTime = currentTime + delay;
    } else {
      startTime = currentTime;
    }
  } else {
    startTime = currentTime;
  }

  var timeout;

  switch (priorityLevel) {
    case ImmediatePriority:
      timeout = IMMEDIATE_PRIORITY_TIMEOUT;
      break;

    case UserBlockingPriority:
      timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
      break;

    case IdlePriority:
      timeout = IDLE_PRIORITY_TIMEOUT;
      break;

    case LowPriority:
      timeout = LOW_PRIORITY_TIMEOUT;
      break;

    case NormalPriority:
    default:
      timeout = NORMAL_PRIORITY_TIMEOUT;
      break;
  }

  var expirationTime = startTime + timeout;
  var newTask = {
    id: taskIdCounter++,
    callback: callback,
    priorityLevel: priorityLevel,
    startTime: startTime,
    expirationTime: expirationTime,
    sortIndex: -1
  };

  if (startTime > currentTime) {
    // This is a delayed task.
    newTask.sortIndex = startTime;
    push(timerQueue, newTask);

    if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
      // All tasks are delayed, and this is the task with the earliest delay.
      if (isHostTimeoutScheduled) {
        // Cancel an existing timeout.
        cancelHostTimeout();
      } else {
        isHostTimeoutScheduled = true;
      } // Schedule a timeout.


      requestHostTimeout(handleTimeout, startTime - currentTime);
    }
  } else {
    newTask.sortIndex = expirationTime;
    push(taskQueue, newTask);
    // wait until the next time we yield.


    if (!isHostCallbackScheduled && !isPerformingWork) {
      isHostCallbackScheduled = true;
      requestHostCallback(flushWork);
    }
  }

  return newTask;
}

function unstable_pauseExecution() {
}

function unstable_continueExecution() {

  if (!isHostCallbackScheduled && !isPerformingWork) {
    isHostCallbackScheduled = true;
    requestHostCallback(flushWork);
  }
}

function unstable_getFirstCallbackNode() {
  return peek(taskQueue);
}

function unstable_cancelCallback(task) {
  // remove from the queue because you can't remove arbitrary nodes from an
  // array based heap, only the first one.)


  task.callback = null;
}

function unstable_getCurrentPriorityLevel() {
  return currentPriorityLevel;
}

var unstable_requestPaint = requestPaint;
var unstable_Profiling =  null;

exports.unstable_IdlePriority = IdlePriority;
exports.unstable_ImmediatePriority = ImmediatePriority;
exports.unstable_LowPriority = LowPriority;
exports.unstable_NormalPriority = NormalPriority;
exports.unstable_Profiling = unstable_Profiling;
exports.unstable_UserBlockingPriority = UserBlockingPriority;
exports.unstable_cancelCallback = unstable_cancelCallback;
exports.unstable_continueExecution = unstable_continueExecution;
exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
exports.unstable_next = unstable_next;
exports.unstable_pauseExecution = unstable_pauseExecution;
exports.unstable_requestPaint = unstable_requestPaint;
exports.unstable_runWithPriority = unstable_runWithPriority;
exports.unstable_scheduleCallback = unstable_scheduleCallback;
exports.unstable_wrapCallback = unstable_wrapCallback;
  })();
}
});

var scheduler = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = scheduler_production_min;
} else {
  module.exports = scheduler_development;
}
});

function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!React)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b);}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a]);}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return !0;if(ia.call(ja,a))return !1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return !1}function ma(a,b,c,d){if(null!==c&&0===c.type)return !1;switch(typeof b){case "function":case "symbol":return !0;case "boolean":if(d)return !1;if(null!==c)return !c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return "data-"!==a&&"aria-"!==a;default:return !1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return !0;if(d)return !1;if(null!==c)switch(c.type){case 3:return !b;case 4:return !1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return !1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g;}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1);});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1);});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1);});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1);});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1);});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1);});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);D[b]=new B(b,1,!1,a,null,!1,!1);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1);});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1);});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0);});
function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))));}
var ra=React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden");}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return "function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||"";}return "\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return "";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[]);}catch(k){var d=k;}Reflect.construct(a,[],b);}else {try{b.call();}catch(k){d=k;}a.call(b.prototype);}else {try{throw Error();}catch(k){d=k;}a();}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return "\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c;}return (a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return ""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return "Fragment";case ta:return "Portal";case xa:return "Profiler";case wa:return "StrictMode";case Ba:return "Suspense";case Ca:return "SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return (a.displayName||"Context")+".Consumer";case ya:return (a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return ""}}function Ta(a){var b=a.type;return (a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a);}});Object.defineProperty(a,b,{enumerable:c.enumerable});return {getValue:function(){return d},setValue:function(a){d=""+a;},stopTracking:function(){a._valueTracker=
null;delete a[b];}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a));}function Wa(a){if(!a)return !1;var b=a._valueTracker;if(!b)return !0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return objectAssign({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value};}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1);}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c;}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked);}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b;}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c);}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c);}function db(a){var b="";React.Children.forEach(a,function(a){null!=a&&(b+=a);});return b}function eb(a,b){a=objectAssign({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0);}else {c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e]);}null!==b&&(b.selected=!0);}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return objectAssign({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0];}b=c;}null==b&&(b="");c=b;}a._wrapperState={initialValue:Sa(c)};}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d);}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b);}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return "http://www.w3.org/2000/svg";case "math":return "http://www.w3.org/1998/Math/MathML";default:return "http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return "undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)});}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else {nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild);}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b;}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a];});});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e;}}var ub=objectAssign({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return "string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return !1;default:return !0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b));}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a;}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a]);}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb();}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb();}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1;}if(a)return null;if(c&&"function"!==
typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0;}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb);}catch(a){Pb=!1;}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l);}catch(n){this.onError(n);}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a;}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments);}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null;}else throw Error(y(198));Ub||(Ub=!0,Vb=l);}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else {a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling;}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else {for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling;}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling;}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else {if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return;}b.sibling.return=b.return;b=b.sibling;}}return null}
var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a,b,c,d,e){return {blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId);}}
function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return !0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return !1}
function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){scheduler.unstable_runWithPriority(a.priority,function(){gc(c);});});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null;}
function xc(a){if(null!==a.blockedOn)return !1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift();}return !0}function zc(a,b,c){xc(a)&&c.delete(b);}
function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift();}null===a.blockedOn&&jc.shift();}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc);}
function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,scheduler.unstable_scheduleCallback(scheduler.unstable_NormalPriority,Ac)));}
function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null);}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift();}
function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d]);}}var Qc=scheduler.unstable_now;Qc();var F=8;
function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F));}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e;}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c;}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=scheduler.unstable_UserBlockingPriority,ed=scheduler.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d);}finally{(Kb=f)||Mb();}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d));}
function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else {var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else {if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d);}jd(a,b,d,null,c);}}}}
function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else {var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null;}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null;}else f!==e&&(e=null);}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return !0}function qd(){return !1}
function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}objectAssign(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=pd);},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd);},persist:function(){},isPersistent:pd});return b}
var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=objectAssign({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=objectAssign({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return "movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=objectAssign({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=objectAssign({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=objectAssign({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=objectAssign({},sd,{clipboardData:function(a){return "clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=objectAssign({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
var Qd=objectAssign({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return "keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return "keypress"===a.type?od(a):0},keyCode:function(a){return "keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return "keypress"===
a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=objectAssign({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=objectAssign({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=objectAssign({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=objectAssign({},Ad,{deltaX:function(a){return "deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return "deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
function ge(a,b){switch(a){case "keyup":return -1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return !0;default:return !1}}function he(a){a=a.detail;return "object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
function ke(a,b){if(ie)return "compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return "input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}));}var pe=null,qe=null;function re(a){se(a,0);}function te(a){var b=ue(a);if(Wa(b))return a}
function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput;}xe=ye;}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode);}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null);}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else {Kb=!0;try{Gb(a,b);}finally{Kb=!1,Mb();}}}}
function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae();}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
function Je(a,b){if(He(a,b))return !0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return !1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return !1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return !1;return !0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return {node:c,offset:b-a};a=d;}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode;}c=void 0;}c=Ke(c);}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href;}catch(d){c=!1;}if(c)a=b.contentWindow;else break;b=Xa(a.document);}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)));}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null;}
function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k;}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k;}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d));}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null);}));}
function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d;}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h));}
function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd;}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1);}
function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return;}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode;}}d=d.return;}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td;}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return;}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}));}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null;}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u);}w=null;}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0);}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else {J=De;var K=Ce;}else (k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
K.controlled&&"number"===h.type&&bb(h,"number",h.value);}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e);}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
case "compositionupdate":L="onCompositionUpdate";break b}L=void 0;}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q);}se(g,b);});}function ef(a,b,c){return {instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return;}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return;}0!==g.length&&a.push({event:b,listeners:g});}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return !!b.autoFocus}return !1}
function nf(a,b){return "textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""));}
function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--;}else "/$"===c&&b++;}a=a.previousSibling;}return null}var tf=0;function uf(a){return {$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a);}return b}a=c;c=a.parentNode;}return null}function Cb(a){a=a[wf]||a[ff];return !a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return {current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--);}function I(a,b){Af++;zf[Af]=a.current;a.current=b;}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M);}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c);}
function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return objectAssign({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return !0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c);}
var Lf=null,Mf=null,Nf=scheduler.unstable_runWithPriority,Of=scheduler.unstable_scheduleCallback,Pf=scheduler.unstable_cancelCallback,Qf=scheduler.unstable_shouldYield,Rf=scheduler.unstable_requestPaint,Sf=scheduler.unstable_now,Tf=scheduler.unstable_getCurrentPriorityLevel,Uf=scheduler.unstable_ImmediatePriority,Vf=scheduler.unstable_UserBlockingPriority,Wf=scheduler.unstable_NormalPriority,Xf=scheduler.unstable_LowPriority,Yf=scheduler.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a);}jg();}
function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null;}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1;}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=objectAssign({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null;}
function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b;}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return;}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null);}
function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null};}else og=og.next=b;}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null};}
function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects});}function zg(a,b){return {eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b;}}
function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next;}while(null!==c);null===f?e=f=b:f=f.next=b;}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b;}
function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k);}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=objectAssign({},A,h);break a;case 2:wg=!0;}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f));}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null;}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A;}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d);}}}var Fg=(new React.Component).refs;
function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:objectAssign({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c);}
var Kg={isMounted:function(a){return (a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d);},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d);},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Ag(a,e);Jg(a,d,c);}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return "function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null);}
function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4);}var Pg=Array.isArray;
function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode;}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a;};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8;}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
a.mode,c,null),b.return=a,b;Rg(a,b);}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c);}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d);}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q;}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q;}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling;}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h);}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else {c(a,d);break}else b(a,d);d=d.sibling;}d=
Wg(f,a.mode,h);d.return=a;a=d;}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a);}H(ah);I(ah,b);}function fh(){H(ah);H(bh);H(ch);}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c));}function hh(a){bh.current===a&&(H(ah),H(bh));}var P=Bf(0);
function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return;}b.sibling.return=b.return;b=b.sibling;}return null}var jh=null,kh=null,lh=!1;
function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c;}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return !1;default:return !1}}
function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c);}jh=a;kh=rf(b.firstChild);}else a.flags=a.flags&-1025|2,lh=!1,jh=a;}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a;}
function rh(a){if(a!==jh)return !1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--;}else "$"!==c&&"$!"!==c&&"$?"!==c||b++;}a=a.nextSibling;}kh=null;}}else kh=jh?rf(a.stateNode.nextSibling):null;return !0}
function sh(){kh=jh=null;lh=!1;}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0;}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return !1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return !1;return !0}
function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e);}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null;}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else {if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a;}return T}function Jh(a,b){return "function"===typeof b?b(a):b}
function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g;}d.baseQueue=e=f;c.pending=null;}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else {var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l;}k=k.next;}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d;}return [b.memoizedState,c.dispatch]}
function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f;}return [f,d]}
function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v;}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes;}catch(q){c(function(){throw q;});}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return [b.memoizedState,a]}
function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d);}
function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d);}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null);};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null;}}
function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0);});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b();}finally{wh.transition=c;}});}
function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else {if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d);}}
var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return [d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
wh.transition=1;try{d(a);}finally{wh.transition=b;}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return [a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36));},
void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a);}finally{wh.transition=b;}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return [Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a);}finally{wh.transition=b;}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return [Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d);}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128;}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b);}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1);}else {g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1);}return qi(a,b,c,d,f,e)}
function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo);}
var si={dehydrated:null,retryLane:0};
function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b);}
function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f);}
function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else {if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return;}a.sibling.return=a.return;a=a.sibling;}d&=1;}I(P,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a;}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null;}return b.child}
function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null;}return b.child}return null}var Bi,Ci,Di,Ei;
Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;}c.sibling.return=c.return;c=c.sibling;}};Ci=function(){};
Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=objectAssign({},e,{value:void 0});d=objectAssign({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf);}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="");}else "dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g]);}else c||(f||(f=[]),f.push(l,c)),c=k;else "dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k));}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4;}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4);};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null;}}
function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else {if(!d){if(null===
b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d);}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
jf);}d=a;b.updateQueue=d;null!==d&&(b.flags|=4);}else {g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=objectAssign({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);G("invalid",a);break;default:e=d;}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g));}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf);}mf(c,d)&&(b.flags|=4);}null!==b.ref&&(b.flags|=128);}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else {if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d);}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else {if(0===V||3===V)V=
4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W);}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else {if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling;}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432);}else {if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g);}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c;}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack;}return {value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value);}catch(c){setTimeout(function(){throw c;});}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b);};return c}
function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)};}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""});});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null);}catch(c){Wi(a,c);}else b.current=null;}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b;}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d();}a=a.next;}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d;}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode;}Eg(c,b,a);}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else {d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e);}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return;}c.sibling.return=c.return;c=c.sibling;}}
function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b);}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else {d=b;try{e();}catch(f){Wi(d,f);}}c=c.next;}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount();}catch(f){Wi(b,
f);}break;case 5:Vi(b);break;case 4:cj(a,b);}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null;}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return;}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return;}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child;}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b);}
function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling;}
function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling;}
function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return;}d=!0;}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else {if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return;}k.sibling.return=k.return;k=k.sibling;}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode);}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1);}c.sibling.return=c.return;c=c.sibling;}}
function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b);}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1));}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d));});}}
var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500;}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a;}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1;}}else l<=b&&(a.expiredLanes|=k);g&=~k;}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else {if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c);}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c;}}
function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h);}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f;}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d;}}
function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b));}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O());});}ig();}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig());}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig());}}function ni(a,b){I(rj,qj);qj|=b;tj|=b;}function Ki(){qj=rj.current;H(rj);}
function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki();}c=c.return;}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0;}
function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next;}yh=!1;}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null);}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else {var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0;}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u;}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else {var t=zg(-1,1);t.tag=2;Ag(h,t);}h.lanes|=1;break a}k=
void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v);}p.flags|=4096;p.lanes=b;break a}p=p.return;}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");}5!==V&&(V=2);k=Mi(k,h);p=
g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return;}while(null!==p)}Zj(c);}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e);}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y);}function Rj(){for(;null!==Y&&!Qf();)bk(Y);}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null;}
function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d;}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b));}else {c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048);}b=b.sibling;if(null!==b){Y=b;return}Y=b=a;}while(null!==b);0===V&&(V=5);}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l;}null!==
Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType;}catch(va){h=null;
break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u;}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode;}w=u;}h=-1===A||-1===p?null:{start:A,end:p};}else h=null;h=h||{start:0,end:0};}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Z=d;do try{ek();}catch(va){if(null===
Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect;}while(null!==Z);Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null);}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
J&&dj(J);}Z=Z.nextEffect;}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect;}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top;}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L;}"function"===typeof Q?Q(q):Q.current=q;}}Z=Z.nextEffect;}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect;}while(null!==Z);Z=null;$f();X=e;}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64));}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
function ek(){for(;null!==Z;){var a=Z.alternate;var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect;}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return !1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}));}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}));}
function fk(){if(null===yj)return !1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g();}catch(k){if(null===f)throw Error(y(330));Wi(f,k);}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h();}catch(k){if(null===f)throw Error(y(330));Wi(f,k);}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;X=b;ig();return !0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b));}
function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a);}catch(f){}break}}c=c.return;}}
function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b);}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c));}var ck;
ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else {ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64;}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b);}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c);}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else {e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling;}else fi(a,b,d,c),sh();b=b.child;}return b;case 5:return gh(b),null===a&&
ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next;}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return;}h=g;}fi(a,b,e.children,c);b=b.child;}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null;}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return !(!a||!a.isReactComponent)}
function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null;}
function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return {$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return;}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h;}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b;}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b);}function pk(){return null}
function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e);}this._internalRoot=c;}
qk.prototype.render=function(a){lk(a,this._internalRoot,null,null);};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null;});};function rk(a){return !(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a);};}lk(b,g,a,e);}else {f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a);};}Xj(function(){lk(b,g,a,e);});}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4);}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864);}};
gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c);}};hc=function(a,b){return b()};
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e);}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1);}};Gb=Wj;
Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig());}};Ib=function(){0===(X&49)&&(Vj(),Oj());};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig());}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.2",rendererPackageName:"react-dom"};
var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk;}catch(a){}}var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;var createPortal=uk;
var findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};var flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig();}};var hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
var render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};var unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null;});}),!0):!1};var unstable_batchedUpdates=Wj;var unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
var unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};var version="17.0.2";

var reactDom_production_min = {
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
	createPortal: createPortal,
	findDOMNode: findDOMNode,
	flushSync: flushSync,
	hydrate: hydrate,
	render: render,
	unmountComponentAtNode: unmountComponentAtNode,
	unstable_batchedUpdates: unstable_batchedUpdates,
	unstable_createPortal: unstable_createPortal,
	unstable_renderSubtreeIntoContainer: unstable_renderSubtreeIntoContainer,
	version: version
};

/** @license React v0.20.2
 * scheduler-tracing.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=0;var __interactionsRef=null;var __subscriberRef=null;var unstable_clear=function(a){return a()};var unstable_getCurrent=function(){return null};var unstable_getThreadID=function(){return ++b};var unstable_subscribe=function(){};var unstable_trace=function(a,d,c){return c()};var unstable_unsubscribe=function(){};var unstable_wrap=function(a){return a};

var schedulerTracing_production_min = {
	__interactionsRef: __interactionsRef,
	__subscriberRef: __subscriberRef,
	unstable_clear: unstable_clear,
	unstable_getCurrent: unstable_getCurrent,
	unstable_getThreadID: unstable_getThreadID,
	unstable_subscribe: unstable_subscribe,
	unstable_trace: unstable_trace,
	unstable_unsubscribe: unstable_unsubscribe,
	unstable_wrap: unstable_wrap
};

var schedulerTracing_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.

var interactionIDCounter = 0;
var threadIDCounter = 0; // Set of currently traced interactions.
// Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.

exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.

exports.__subscriberRef = null;

{
  exports.__interactionsRef = {
    current: new Set()
  };
  exports.__subscriberRef = {
    current: null
  };
}
function unstable_clear(callback) {

  var prevInteractions = exports.__interactionsRef.current;
  exports.__interactionsRef.current = new Set();

  try {
    return callback();
  } finally {
    exports.__interactionsRef.current = prevInteractions;
  }
}
function unstable_getCurrent() {
  {
    return exports.__interactionsRef.current;
  }
}
function unstable_getThreadID() {
  return ++threadIDCounter;
}
function unstable_trace(name, timestamp, callback) {
  var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;

  var interaction = {
    __count: 1,
    id: interactionIDCounter++,
    name: name,
    timestamp: timestamp
  };
  var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
  // To do that, clone the current interactions.
  // The previous set will be restored upon completion.

  var interactions = new Set(prevInteractions);
  interactions.add(interaction);
  exports.__interactionsRef.current = interactions;
  var subscriber = exports.__subscriberRef.current;
  var returnValue;

  try {
    if (subscriber !== null) {
      subscriber.onInteractionTraced(interaction);
    }
  } finally {
    try {
      if (subscriber !== null) {
        subscriber.onWorkStarted(interactions, threadID);
      }
    } finally {
      try {
        returnValue = callback();
      } finally {
        exports.__interactionsRef.current = prevInteractions;

        try {
          if (subscriber !== null) {
            subscriber.onWorkStopped(interactions, threadID);
          }
        } finally {
          interaction.__count--; // If no async work was scheduled for this interaction,
          // Notify subscribers that it's completed.

          if (subscriber !== null && interaction.__count === 0) {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          }
        }
      }
    }
  }

  return returnValue;
}
function unstable_wrap(callback) {
  var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;

  var wrappedInteractions = exports.__interactionsRef.current;
  var subscriber = exports.__subscriberRef.current;

  if (subscriber !== null) {
    subscriber.onWorkScheduled(wrappedInteractions, threadID);
  } // Update the pending async work count for the current interactions.
  // Update after calling subscribers in case of error.


  wrappedInteractions.forEach(function (interaction) {
    interaction.__count++;
  });
  var hasRun = false;

  function wrapped() {
    var prevInteractions = exports.__interactionsRef.current;
    exports.__interactionsRef.current = wrappedInteractions;
    subscriber = exports.__subscriberRef.current;

    try {
      var returnValue;

      try {
        if (subscriber !== null) {
          subscriber.onWorkStarted(wrappedInteractions, threadID);
        }
      } finally {
        try {
          returnValue = callback.apply(undefined, arguments);
        } finally {
          exports.__interactionsRef.current = prevInteractions;

          if (subscriber !== null) {
            subscriber.onWorkStopped(wrappedInteractions, threadID);
          }
        }
      }

      return returnValue;
    } finally {
      if (!hasRun) {
        // We only expect a wrapped function to be executed once,
        // But in the event that it's executed more than once–
        // Only decrement the outstanding interaction counts once.
        hasRun = true; // Update pending async counts for all wrapped interactions.
        // If this was the last scheduled async work for any of them,
        // Mark them as completed.

        wrappedInteractions.forEach(function (interaction) {
          interaction.__count--;

          if (subscriber !== null && interaction.__count === 0) {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          }
        });
      }
    }
  }

  wrapped.cancel = function cancel() {
    subscriber = exports.__subscriberRef.current;

    try {
      if (subscriber !== null) {
        subscriber.onWorkCanceled(wrappedInteractions, threadID);
      }
    } finally {
      // Update pending async counts for all wrapped interactions.
      // If this was the last scheduled async work for any of them,
      // Mark them as completed.
      wrappedInteractions.forEach(function (interaction) {
        interaction.__count--;

        if (subscriber && interaction.__count === 0) {
          subscriber.onInteractionScheduledWorkCompleted(interaction);
        }
      });
    }
  };

  return wrapped;
}

var subscribers = null;

{
  subscribers = new Set();
}

function unstable_subscribe(subscriber) {
  {
    subscribers.add(subscriber);

    if (subscribers.size === 1) {
      exports.__subscriberRef.current = {
        onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
        onInteractionTraced: onInteractionTraced,
        onWorkCanceled: onWorkCanceled,
        onWorkScheduled: onWorkScheduled,
        onWorkStarted: onWorkStarted,
        onWorkStopped: onWorkStopped
      };
    }
  }
}
function unstable_unsubscribe(subscriber) {
  {
    subscribers.delete(subscriber);

    if (subscribers.size === 0) {
      exports.__subscriberRef.current = null;
    }
  }
}

function onInteractionTraced(interaction) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onInteractionTraced(interaction);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onInteractionScheduledWorkCompleted(interaction) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onInteractionScheduledWorkCompleted(interaction);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkScheduled(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkScheduled(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkStarted(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkStarted(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkStopped(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkStopped(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkCanceled(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkCanceled(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

exports.unstable_clear = unstable_clear;
exports.unstable_getCurrent = unstable_getCurrent;
exports.unstable_getThreadID = unstable_getThreadID;
exports.unstable_subscribe = unstable_subscribe;
exports.unstable_trace = unstable_trace;
exports.unstable_unsubscribe = unstable_unsubscribe;
exports.unstable_wrap = unstable_wrap;
  })();
}
});

var tracing = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = schedulerTracing_production_min;
} else {
  module.exports = schedulerTracing_development;
}
});

var reactDom_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

var React$1 = React;
var _assign = objectAssign;
var Scheduler = scheduler;
var tracing$1 = tracing;

var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

if (!React$1) {
  {
    throw Error( "ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM." );
  }
}

var FunctionComponent = 0;
var ClassComponent = 1;
var IndeterminateComponent = 2; // Before we know whether it is function or class

var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

var HostComponent = 5;
var HostText = 6;
var Fragment = 7;
var Mode = 8;
var ContextConsumer = 9;
var ContextProvider = 10;
var ForwardRef = 11;
var Profiler = 12;
var SuspenseComponent = 13;
var MemoComponent = 14;
var SimpleMemoComponent = 15;
var LazyComponent = 16;
var IncompleteClassComponent = 17;
var DehydratedFragment = 18;
var SuspenseListComponent = 19;
var FundamentalComponent = 20;
var ScopeComponent = 21;
var Block = 22;
var OffscreenComponent = 23;
var LegacyHiddenComponent = 24;

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableProfilerTimer = true; // Record durations for commit and passive effects phases.

var enableFundamentalAPI = false; // Experimental Scope support.
var enableNewReconciler = false; // Errors that are thrown while unmounting (or after in the case of passive effects)
var warnAboutStringRefs = false;

var allNativeEvents = new Set();
/**
 * Mapping from registration name to event name
 */


var registrationNameDependencies = {};
/**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */

var possibleRegistrationNames =  {} ; // Trust the developer to only use possibleRegistrationNames in true

function registerTwoPhaseEvent(registrationName, dependencies) {
  registerDirectEvent(registrationName, dependencies);
  registerDirectEvent(registrationName + 'Capture', dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
  {
    if (registrationNameDependencies[registrationName]) {
      error('EventRegistry: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName);
    }
  }

  registrationNameDependencies[registrationName] = dependencies;

  {
    var lowerCasedName = registrationName.toLowerCase();
    possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      possibleRegistrationNames.ondblclick = registrationName;
    }
  }

  for (var i = 0; i < dependencies.length; i++) {
    allNativeEvents.add(dependencies[i]);
  }
}

var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
/* eslint-enable max-len */

var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
var hasOwnProperty = Object.prototype.hasOwnProperty;
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
  if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
    return true;
  }

  if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
    return false;
  }

  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }

  illegalAttributeNameCache[attributeName] = true;

  {
    error('Invalid attribute name: `%s`', attributeName);
  }

  return false;
}
function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
  if (propertyInfo !== null) {
    return propertyInfo.type === RESERVED;
  }

  if (isCustomComponentTag) {
    return false;
  }

  if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
    return true;
  }

  return false;
}
function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
  if (propertyInfo !== null && propertyInfo.type === RESERVED) {
    return false;
  }

  switch (typeof value) {
    case 'function': // $FlowIssue symbol is perfectly valid here

    case 'symbol':
      // eslint-disable-line
      return true;

    case 'boolean':
      {
        if (isCustomComponentTag) {
          return false;
        }

        if (propertyInfo !== null) {
          return !propertyInfo.acceptsBooleans;
        } else {
          var prefix = name.toLowerCase().slice(0, 5);
          return prefix !== 'data-' && prefix !== 'aria-';
        }
      }

    default:
      return false;
  }
}
function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
  if (value === null || typeof value === 'undefined') {
    return true;
  }

  if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
    return true;
  }

  if (isCustomComponentTag) {
    return false;
  }

  if (propertyInfo !== null) {

    switch (propertyInfo.type) {
      case BOOLEAN:
        return !value;

      case OVERLOADED_BOOLEAN:
        return value === false;

      case NUMERIC:
        return isNaN(value);

      case POSITIVE_NUMERIC:
        return isNaN(value) || value < 1;
    }
  }

  return false;
}
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var name = _ref[0],
      attributeName = _ref[1];
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function (token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

// and any newline or tab are filtered out as if they're not part of the URL.
// https://url.spec.whatwg.org/#url-parsing
// Tab or newline are defined as \r\n\t:
// https://infra.spec.whatwg.org/#ascii-tab-or-newline
// A C0 control is a code point in the range \u0000 NULL to \u001F
// INFORMATION SEPARATOR ONE, inclusive:
// https://infra.spec.whatwg.org/#c0-control-or-space

/* eslint-disable max-len */

var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
var didWarn = false;

function sanitizeURL(url) {
  {
    if (!didWarn && isJavaScriptProtocol.test(url)) {
      didWarn = true;

      error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
    }
  }
}

/**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */
function getValueForProperty(node, name, expected, propertyInfo) {
  {
    if (propertyInfo.mustUseProperty) {
      var propertyName = propertyInfo.propertyName;
      return node[propertyName];
    } else {
      if ( propertyInfo.sanitizeURL) {
        // If we haven't fully disabled javascript: URLs, and if
        // the hydration is successful of a javascript: URL, we
        // still want to warn on the client.
        sanitizeURL('' + expected);
      }

      var attributeName = propertyInfo.attributeName;
      var stringValue = null;

      if (propertyInfo.type === OVERLOADED_BOOLEAN) {
        if (node.hasAttribute(attributeName)) {
          var value = node.getAttribute(attributeName);

          if (value === '') {
            return true;
          }

          if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
            return value;
          }

          if (value === '' + expected) {
            return expected;
          }

          return value;
        }
      } else if (node.hasAttribute(attributeName)) {
        if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
          // We had an attribute but shouldn't have had one, so read it
          // for the error message.
          return node.getAttribute(attributeName);
        }

        if (propertyInfo.type === BOOLEAN) {
          // If this was a boolean, it doesn't matter what the value is
          // the fact that we have it is the same as the expected.
          return expected;
        } // Even if this property uses a namespace we use getAttribute
        // because we assume its namespaced name is the same as our config.
        // To use getAttributeNS we need the local name which we don't have
        // in our config atm.


        stringValue = node.getAttribute(attributeName);
      }

      if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
        return stringValue === null ? expected : stringValue;
      } else if (stringValue === '' + expected) {
        return expected;
      } else {
        return stringValue;
      }
    }
  }
}
/**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */

function getValueForAttribute(node, name, expected) {
  {
    if (!isAttributeNameSafe(name)) {
      return;
    } // If the object is an opaque reference ID, it's expected that
    // the next prop is different than the server value, so just return
    // expected


    if (isOpaqueHydratingObject(expected)) {
      return expected;
    }

    if (!node.hasAttribute(name)) {
      return expected === undefined ? undefined : null;
    }

    var value = node.getAttribute(name);

    if (value === '' + expected) {
      return expected;
    }

    return value;
  }
}
/**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */

function setValueForProperty(node, name, value, isCustomComponentTag) {
  var propertyInfo = getPropertyInfo(name);

  if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
    return;
  }

  if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
    value = null;
  } // If the prop isn't in the special list, treat it as a simple attribute.


  if (isCustomComponentTag || propertyInfo === null) {
    if (isAttributeNameSafe(name)) {
      var _attributeName = name;

      if (value === null) {
        node.removeAttribute(_attributeName);
      } else {
        node.setAttribute(_attributeName,  '' + value);
      }
    }

    return;
  }

  var mustUseProperty = propertyInfo.mustUseProperty;

  if (mustUseProperty) {
    var propertyName = propertyInfo.propertyName;

    if (value === null) {
      var type = propertyInfo.type;
      node[propertyName] = type === BOOLEAN ? false : '';
    } else {
      // Contrary to `setAttribute`, object properties are properly
      // `toString`ed by IE8/9.
      node[propertyName] = value;
    }

    return;
  } // The rest are treated as attributes with special cases.


  var attributeName = propertyInfo.attributeName,
      attributeNamespace = propertyInfo.attributeNamespace;

  if (value === null) {
    node.removeAttribute(attributeName);
  } else {
    var _type = propertyInfo.type;
    var attributeValue;

    if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
      // If attribute type is boolean, we know for sure it won't be an execution sink
      // and we won't require Trusted Type here.
      attributeValue = '';
    } else {
      // `setAttribute` with objects becomes only `[object]` in IE8/9,
      // ('' + value) makes it output the correct toString()-value.
      {
        attributeValue = '' + value;
      }

      if (propertyInfo.sanitizeURL) {
        sanitizeURL(attributeValue.toString());
      }
    }

    if (attributeNamespace) {
      node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
    } else {
      node.setAttribute(attributeName, attributeValue);
    }
  }
}

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}

function describeClassComponentFrame(ctor, source, ownerFn) {
  {
    return describeNativeComponentFrame(ctor, true);
  }
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

function describeFiber(fiber) {

  switch (fiber.tag) {
    case HostComponent:
      return describeBuiltInComponentFrame(fiber.type);

    case LazyComponent:
      return describeBuiltInComponentFrame('Lazy');

    case SuspenseComponent:
      return describeBuiltInComponentFrame('Suspense');

    case SuspenseListComponent:
      return describeBuiltInComponentFrame('SuspenseList');

    case FunctionComponent:
    case IndeterminateComponent:
    case SimpleMemoComponent:
      return describeFunctionComponentFrame(fiber.type);

    case ForwardRef:
      return describeFunctionComponentFrame(fiber.type.render);

    case Block:
      return describeFunctionComponentFrame(fiber.type._render);

    case ClassComponent:
      return describeClassComponentFrame(fiber.type);

    default:
      return '';
  }
}

function getStackByFiberInDevAndProd(workInProgress) {
  try {
    var info = '';
    var node = workInProgress;

    do {
      info += describeFiber(node);
      node = node.return;
    } while (node);

    return info;
  } catch (x) {
    return '\nError generating stack: ' + x.message + '\n' + x.stack;
  }
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
var current = null;
var isRendering = false;
function getCurrentFiberOwnerNameInDevOrNull() {
  {
    if (current === null) {
      return null;
    }

    var owner = current._debugOwner;

    if (owner !== null && typeof owner !== 'undefined') {
      return getComponentName(owner.type);
    }
  }

  return null;
}

function getCurrentFiberStackInDev() {
  {
    if (current === null) {
      return '';
    } // Safe because if current fiber exists, we are reconciling,
    // and it is guaranteed to be the work-in-progress version.


    return getStackByFiberInDevAndProd(current);
  }
}

function resetCurrentFiber() {
  {
    ReactDebugCurrentFrame.getCurrentStack = null;
    current = null;
    isRendering = false;
  }
}
function setCurrentFiber(fiber) {
  {
    ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
    current = fiber;
    isRendering = false;
  }
}
function setIsRendering(rendering) {
  {
    isRendering = rendering;
  }
}
function getIsRendering() {
  {
    return isRendering;
  }
}

// Flow does not allow string concatenation of most non-string types. To work
// around this limitation, we use an opaque type that can only be obtained by
// passing the value through getToStringValue first.
function toString(value) {
  return '' + value;
}
function getToStringValue(value) {
  switch (typeof value) {
    case 'boolean':
    case 'number':
    case 'object':
    case 'string':
    case 'undefined':
      return value;

    default:
      // function, symbol are assigned as empty strings
      return '';
  }
}

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};
function checkControlledValueProps(tagName, props) {
  {
    if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
      error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
    }

    if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
      error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
    }
  }
}

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(node) {
  return node._valueTracker;
}

function detachTracker(node) {
  node._valueTracker = null;
}

function getValueFromNode(node) {
  var value = '';

  if (!node) {
    return value;
  }

  if (isCheckable(node)) {
    value = node.checked ? 'true' : 'false';
  } else {
    value = node.value;
  }

  return value;
}

function trackValueOnNode(node) {
  var valueField = isCheckable(node) ? 'checked' : 'value';
  var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
  var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
  // and don't track value will cause over reporting of changes,
  // but it's better then a hard failure
  // (needed for certain tests that spyOn input values and Safari)

  if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
    return;
  }

  var get = descriptor.get,
      set = descriptor.set;
  Object.defineProperty(node, valueField, {
    configurable: true,
    get: function () {
      return get.call(this);
    },
    set: function (value) {
      currentValue = '' + value;
      set.call(this, value);
    }
  }); // We could've passed this the first time
  // but it triggers a bug in IE11 and Edge 14/15.
  // Calling defineProperty() again should be equivalent.
  // https://github.com/facebook/react/issues/11768

  Object.defineProperty(node, valueField, {
    enumerable: descriptor.enumerable
  });
  var tracker = {
    getValue: function () {
      return currentValue;
    },
    setValue: function (value) {
      currentValue = '' + value;
    },
    stopTracking: function () {
      detachTracker(node);
      delete node[valueField];
    }
  };
  return tracker;
}

function track(node) {
  if (getTracker(node)) {
    return;
  } // TODO: Once it's just Fiber we can move this to node._wrapperState


  node._valueTracker = trackValueOnNode(node);
}
function updateValueIfChanged(node) {
  if (!node) {
    return false;
  }

  var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
  // that trying again will succeed

  if (!tracker) {
    return true;
  }

  var lastValue = tracker.getValue();
  var nextValue = getValueFromNode(node);

  if (nextValue !== lastValue) {
    tracker.setValue(nextValue);
    return true;
  }

  return false;
}

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}
/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */


function getHostProps(element, props) {
  var node = element;
  var checked = props.checked;

  var hostProps = _assign({}, props, {
    defaultChecked: undefined,
    defaultValue: undefined,
    value: undefined,
    checked: checked != null ? checked : node._wrapperState.initialChecked
  });

  return hostProps;
}
function initWrapperState(element, props) {
  {
    checkControlledValueProps('input', props);

    if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
      error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);

      didWarnCheckedDefaultChecked = true;
    }

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
      error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);

      didWarnValueDefaultValue = true;
    }
  }

  var node = element;
  var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
  node._wrapperState = {
    initialChecked: props.checked != null ? props.checked : props.defaultChecked,
    initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
    controlled: isControlled(props)
  };
}
function updateChecked(element, props) {
  var node = element;
  var checked = props.checked;

  if (checked != null) {
    setValueForProperty(node, 'checked', checked, false);
  }
}
function updateWrapper(element, props) {
  var node = element;

  {
    var controlled = isControlled(props);

    if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
      error('A component is changing an uncontrolled input to be controlled. ' + 'This is likely caused by the value changing from undefined to ' + 'a defined value, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');

      didWarnUncontrolledToControlled = true;
    }

    if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
      error('A component is changing a controlled input to be uncontrolled. ' + 'This is likely caused by the value changing from a defined to ' + 'undefined, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');

      didWarnControlledToUncontrolled = true;
    }
  }

  updateChecked(element, props);
  var value = getToStringValue(props.value);
  var type = props.type;

  if (value != null) {
    if (type === 'number') {
      if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
      // eslint-disable-next-line
      node.value != value) {
        node.value = toString(value);
      }
    } else if (node.value !== toString(value)) {
      node.value = toString(value);
    }
  } else if (type === 'submit' || type === 'reset') {
    // Submit/reset inputs need the attribute removed completely to avoid
    // blank-text buttons.
    node.removeAttribute('value');
    return;
  }

  {
    // When syncing the value attribute, the value comes from a cascade of
    // properties:
    //  1. The value React property
    //  2. The defaultValue React property
    //  3. Otherwise there should be no change
    if (props.hasOwnProperty('value')) {
      setDefaultValue(node, props.type, value);
    } else if (props.hasOwnProperty('defaultValue')) {
      setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
    }
  }

  {
    // When syncing the checked attribute, it only changes when it needs
    // to be removed, such as transitioning from a checkbox into a text input
    if (props.checked == null && props.defaultChecked != null) {
      node.defaultChecked = !!props.defaultChecked;
    }
  }
}
function postMountWrapper(element, props, isHydrating) {
  var node = element; // Do not assign value if it is already set. This prevents user text input
  // from being lost during SSR hydration.

  if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
    var type = props.type;
    var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
    // default value provided by the browser. See: #12872

    if (isButton && (props.value === undefined || props.value === null)) {
      return;
    }

    var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
    // from being lost during SSR hydration.

    if (!isHydrating) {
      {
        // When syncing the value attribute, the value property should use
        // the wrapperState._initialValue property. This uses:
        //
        //   1. The value React property when present
        //   2. The defaultValue React property when present
        //   3. An empty string
        if (initialValue !== node.value) {
          node.value = initialValue;
        }
      }
    }

    {
      // Otherwise, the value attribute is synchronized to the property,
      // so we assign defaultValue to the same thing as the value property
      // assignment step above.
      node.defaultValue = initialValue;
    }
  } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
  // this is needed to work around a chrome bug where setting defaultChecked
  // will sometimes influence the value of checked (even after detachment).
  // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
  // We need to temporarily unset name to avoid disrupting radio button groups.


  var name = node.name;

  if (name !== '') {
    node.name = '';
  }

  {
    // When syncing the checked attribute, both the checked property and
    // attribute are assigned at the same time using defaultChecked. This uses:
    //
    //   1. The checked React property when present
    //   2. The defaultChecked React property when present
    //   3. Otherwise, false
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !!node._wrapperState.initialChecked;
  }

  if (name !== '') {
    node.name = name;
  }
}
function restoreControlledState(element, props) {
  var node = element;
  updateWrapper(node, props);
  updateNamedCousins(node, props);
}

function updateNamedCousins(rootNode, props) {
  var name = props.name;

  if (props.type === 'radio' && name != null) {
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    } // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form. It might not even be in the
    // document. Let's just use the local `querySelectorAll` to ensure we don't
    // miss anything.


    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];

      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      } // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.


      var otherProps = getFiberCurrentPropsFromNode(otherNode);

      if (!otherProps) {
        {
          throw Error( "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported." );
        }
      } // We need update the tracked value on the named cousin since the value
      // was changed but the input saw no event or value set


      updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.

      updateWrapper(otherNode, otherProps);
    }
  }
} // In Chrome, assigning defaultValue to certain input types triggers input validation.
// For number inputs, the display value loses trailing decimal points. For email inputs,
// Chrome raises "The specified value <x> is not a valid email address".
//
// Here we check to see if the defaultValue has actually changed, avoiding these problems
// when the user is inputting text
//
// https://github.com/facebook/react/issues/7253


function setDefaultValue(node, type, value) {
  if ( // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
  type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
    if (value == null) {
      node.defaultValue = toString(node._wrapperState.initialValue);
    } else if (node.defaultValue !== toString(value)) {
      node.defaultValue = toString(value);
    }
  }
}

var didWarnSelectedSetOnOption = false;
var didWarnInvalidChild = false;

function flattenChildren(children) {
  var content = ''; // Flatten children. We'll warn if they are invalid
  // during validateProps() which runs for hydration too.
  // Note that this would throw on non-element objects.
  // Elements are stringified (which is normally irrelevant
  // but matters for <fbt>).

  React$1.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }

    content += child; // Note: we don't warn about invalid children here.
    // Instead, this is done separately below so that
    // it happens during the hydration code path too.
  });
  return content;
}
/**
 * Implements an <option> host component that warns when `selected` is set.
 */


function validateProps(element, props) {
  {
    // This mirrors the code path above, but runs for hydration too.
    // Warn about invalid children here so that client and hydration are consistent.
    // TODO: this seems like it could cause a DEV-only throw for hydration
    // if children contains a non-element object. We should try to avoid that.
    if (typeof props.children === 'object' && props.children !== null) {
      React$1.Children.forEach(props.children, function (child) {
        if (child == null) {
          return;
        }

        if (typeof child === 'string' || typeof child === 'number') {
          return;
        }

        if (typeof child.type !== 'string') {
          return;
        }

        if (!didWarnInvalidChild) {
          didWarnInvalidChild = true;

          error('Only strings and numbers are supported as <option> children.');
        }
      });
    } // TODO: Remove support for `selected` in <option>.


    if (props.selected != null && !didWarnSelectedSetOnOption) {
      error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');

      didWarnSelectedSetOnOption = true;
    }
  }
}
function postMountWrapper$1(element, props) {
  // value="" should make a value attribute (#6219)
  if (props.value != null) {
    element.setAttribute('value', toString(getToStringValue(props.value)));
  }
}
function getHostProps$1(element, props) {
  var hostProps = _assign({
    children: undefined
  }, props);

  var content = flattenChildren(props.children);

  if (content) {
    hostProps.children = content;
  }

  return hostProps;
}

var didWarnValueDefaultValue$1;

{
  didWarnValueDefaultValue$1 = false;
}

function getDeclarationErrorAddendum() {
  var ownerName = getCurrentFiberOwnerNameInDevOrNull();

  if (ownerName) {
    return '\n\nCheck the render method of `' + ownerName + '`.';
  }

  return '';
}

var valuePropNames = ['value', 'defaultValue'];
/**
 * Validation function for `value` and `defaultValue`.
 */

function checkSelectPropTypes(props) {
  {
    checkControlledValueProps('select', props);

    for (var i = 0; i < valuePropNames.length; i++) {
      var propName = valuePropNames[i];

      if (props[propName] == null) {
        continue;
      }

      var isArray = Array.isArray(props[propName]);

      if (props.multiple && !isArray) {
        error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
      } else if (!props.multiple && isArray) {
        error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
      }
    }
  }
}

function updateOptions(node, multiple, propValue, setDefaultSelected) {
  var options = node.options;

  if (multiple) {
    var selectedValues = propValue;
    var selectedValue = {};

    for (var i = 0; i < selectedValues.length; i++) {
      // Prefix to avoid chaos with special keys.
      selectedValue['$' + selectedValues[i]] = true;
    }

    for (var _i = 0; _i < options.length; _i++) {
      var selected = selectedValue.hasOwnProperty('$' + options[_i].value);

      if (options[_i].selected !== selected) {
        options[_i].selected = selected;
      }

      if (selected && setDefaultSelected) {
        options[_i].defaultSelected = true;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    var _selectedValue = toString(getToStringValue(propValue));

    var defaultSelected = null;

    for (var _i2 = 0; _i2 < options.length; _i2++) {
      if (options[_i2].value === _selectedValue) {
        options[_i2].selected = true;

        if (setDefaultSelected) {
          options[_i2].defaultSelected = true;
        }

        return;
      }

      if (defaultSelected === null && !options[_i2].disabled) {
        defaultSelected = options[_i2];
      }
    }

    if (defaultSelected !== null) {
      defaultSelected.selected = true;
    }
  }
}
/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */


function getHostProps$2(element, props) {
  return _assign({}, props, {
    value: undefined
  });
}
function initWrapperState$1(element, props) {
  var node = element;

  {
    checkSelectPropTypes(props);
  }

  node._wrapperState = {
    wasMultiple: !!props.multiple
  };

  {
    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
      error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');

      didWarnValueDefaultValue$1 = true;
    }
  }
}
function postMountWrapper$2(element, props) {
  var node = element;
  node.multiple = !!props.multiple;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  } else if (props.defaultValue != null) {
    updateOptions(node, !!props.multiple, props.defaultValue, true);
  }
}
function postUpdateWrapper(element, props) {
  var node = element;
  var wasMultiple = node._wrapperState.wasMultiple;
  node._wrapperState.wasMultiple = !!props.multiple;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  } else if (wasMultiple !== !!props.multiple) {
    // For simplicity, reapply `defaultValue` if `multiple` is toggled.
    if (props.defaultValue != null) {
      updateOptions(node, !!props.multiple, props.defaultValue, true);
    } else {
      // Revert the select back to its default unselected state.
      updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
    }
  }
}
function restoreControlledState$1(element, props) {
  var node = element;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  }
}

var didWarnValDefaultVal = false;

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
function getHostProps$3(element, props) {
  var node = element;

  if (!(props.dangerouslySetInnerHTML == null)) {
    {
      throw Error( "`dangerouslySetInnerHTML` does not make sense on <textarea>." );
    }
  } // Always set children to the same thing. In IE9, the selection range will
  // get reset if `textContent` is mutated.  We could add a check in setTextContent
  // to only set the value if/when the value differs from the node value (which would
  // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
  // solution. The value can be a boolean or object so that's why it's forced
  // to be a string.


  var hostProps = _assign({}, props, {
    value: undefined,
    defaultValue: undefined,
    children: toString(node._wrapperState.initialValue)
  });

  return hostProps;
}
function initWrapperState$2(element, props) {
  var node = element;

  {
    checkControlledValueProps('textarea', props);

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
      error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');

      didWarnValDefaultVal = true;
    }
  }

  var initialValue = props.value; // Only bother fetching default value if we're going to use it

  if (initialValue == null) {
    var children = props.children,
        defaultValue = props.defaultValue;

    if (children != null) {
      {
        error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
      }

      {
        if (!(defaultValue == null)) {
          {
            throw Error( "If you supply `defaultValue` on a <textarea>, do not pass children." );
          }
        }

        if (Array.isArray(children)) {
          if (!(children.length <= 1)) {
            {
              throw Error( "<textarea> can only have at most one child." );
            }
          }

          children = children[0];
        }

        defaultValue = children;
      }
    }

    if (defaultValue == null) {
      defaultValue = '';
    }

    initialValue = defaultValue;
  }

  node._wrapperState = {
    initialValue: getToStringValue(initialValue)
  };
}
function updateWrapper$1(element, props) {
  var node = element;
  var value = getToStringValue(props.value);
  var defaultValue = getToStringValue(props.defaultValue);

  if (value != null) {
    // Cast `value` to a string to ensure the value is set correctly. While
    // browsers typically do this as necessary, jsdom doesn't.
    var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed

    if (newValue !== node.value) {
      node.value = newValue;
    }

    if (props.defaultValue == null && node.defaultValue !== newValue) {
      node.defaultValue = newValue;
    }
  }

  if (defaultValue != null) {
    node.defaultValue = toString(defaultValue);
  }
}
function postMountWrapper$3(element, props) {
  var node = element; // This is in postMount because we need access to the DOM node, which is not
  // available until after the component has mounted.

  var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
  // initial value. In IE10/IE11 there is a bug where the placeholder attribute
  // will populate textContent as well.
  // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/

  if (textContent === node._wrapperState.initialValue) {
    if (textContent !== '' && textContent !== null) {
      node.value = textContent;
    }
  }
}
function restoreControlledState$2(element, props) {
  // DOM component is still mounted; update
  updateWrapper$1(element, props);
}

var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var Namespaces = {
  html: HTML_NAMESPACE,
  mathml: MATH_NAMESPACE,
  svg: SVG_NAMESPACE
}; // Assumes there is no parent namespace.

function getIntrinsicNamespace(type) {
  switch (type) {
    case 'svg':
      return SVG_NAMESPACE;

    case 'math':
      return MATH_NAMESPACE;

    default:
      return HTML_NAMESPACE;
  }
}
function getChildNamespace(parentNamespace, type) {
  if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
    // No (or default) parent namespace: potential entry point.
    return getIntrinsicNamespace(type);
  }

  if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
    // We're leaving SVG.
    return HTML_NAMESPACE;
  } // By default, pass namespace below.


  return parentNamespace;
}

/* globals MSApp */

/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */
var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

var reusableSVGContainer;
/**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */

var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  if (node.namespaceURI === Namespaces.svg) {

    if (!('innerHTML' in node)) {
      // IE does not have innerHTML for SVG nodes, so instead we inject the
      // new markup in a temp node and then move the child nodes across into
      // the target node
      reusableSVGContainer = reusableSVGContainer || document.createElement('div');
      reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
      var svgNode = reusableSVGContainer.firstChild;

      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }

      while (svgNode.firstChild) {
        node.appendChild(svgNode.firstChild);
      }

      return;
    }
  }

  node.innerHTML = html;
});

/**
 * HTML nodeType values that represent the type of the node
 */
var ELEMENT_NODE = 1;
var TEXT_NODE = 3;
var COMMENT_NODE = 8;
var DOCUMENT_NODE = 9;
var DOCUMENT_FRAGMENT_NODE = 11;

/**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */

var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
      firstChild.nodeValue = text;
      return;
    }
  }

  node.textContent = text;
};

// List derived from Gecko source code:
// https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
var shorthandToLonghand = {
  animation: ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction'],
  background: ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize'],
  backgroundPosition: ['backgroundPositionX', 'backgroundPositionY'],
  border: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTopColor', 'borderTopStyle', 'borderTopWidth'],
  borderBlockEnd: ['borderBlockEndColor', 'borderBlockEndStyle', 'borderBlockEndWidth'],
  borderBlockStart: ['borderBlockStartColor', 'borderBlockStartStyle', 'borderBlockStartWidth'],
  borderBottom: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth'],
  borderColor: ['borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor'],
  borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
  borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndStyle', 'borderInlineEndWidth'],
  borderInlineStart: ['borderInlineStartColor', 'borderInlineStartStyle', 'borderInlineStartWidth'],
  borderLeft: ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth'],
  borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
  borderRight: ['borderRightColor', 'borderRightStyle', 'borderRightWidth'],
  borderStyle: ['borderBottomStyle', 'borderLeftStyle', 'borderRightStyle', 'borderTopStyle'],
  borderTop: ['borderTopColor', 'borderTopStyle', 'borderTopWidth'],
  borderWidth: ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth'],
  columnRule: ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth'],
  columns: ['columnCount', 'columnWidth'],
  flex: ['flexBasis', 'flexGrow', 'flexShrink'],
  flexFlow: ['flexDirection', 'flexWrap'],
  font: ['fontFamily', 'fontFeatureSettings', 'fontKerning', 'fontLanguageOverride', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontWeight', 'lineHeight'],
  fontVariant: ['fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition'],
  gap: ['columnGap', 'rowGap'],
  grid: ['gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
  gridArea: ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart'],
  gridColumn: ['gridColumnEnd', 'gridColumnStart'],
  gridColumnGap: ['columnGap'],
  gridGap: ['columnGap', 'rowGap'],
  gridRow: ['gridRowEnd', 'gridRowStart'],
  gridRowGap: ['rowGap'],
  gridTemplate: ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
  listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
  margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
  marker: ['markerEnd', 'markerMid', 'markerStart'],
  mask: ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPositionX', 'maskPositionY', 'maskRepeat', 'maskSize'],
  maskPosition: ['maskPositionX', 'maskPositionY'],
  outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
  overflow: ['overflowX', 'overflowY'],
  padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
  placeContent: ['alignContent', 'justifyContent'],
  placeItems: ['alignItems', 'justifyItems'],
  placeSelf: ['alignSelf', 'justifySelf'],
  textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle'],
  textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
  transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
  wordWrap: ['overflowWrap']
};

/**
 * CSS properties which accept numbers but are not in units of "px".
 */
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */

function dangerousStyleValue(name, value, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901
  var isEmpty = value == null || typeof value === 'boolean' || value === '';

  if (isEmpty) {
    return '';
  }

  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return ('' + value).trim();
}

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */

function hyphenateStyleName(name) {
  return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

var warnValidStyle = function () {};

{
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
  var msPattern$1 = /^-ms-/;
  var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

  var badStyleValueWithSemicolonPattern = /;\s*$/;
  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;
  var warnedForInfinityValue = false;

  var camelize = function (string) {
    return string.replace(hyphenPattern, function (_, character) {
      return character.toUpperCase();
    });
  };

  var warnHyphenatedStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;

    error('Unsupported style property %s. Did you mean %s?', name, // As Andi Smith suggests
    // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
    // is converted to lowercase `ms`.
    camelize(name.replace(msPattern$1, 'ms-')));
  };

  var warnBadVendoredStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;

    error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
  };

  var warnStyleValueWithSemicolon = function (name, value) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;

    error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
  };

  var warnStyleValueIsNaN = function (name, value) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;

    error('`NaN` is an invalid value for the `%s` css style property.', name);
  };

  var warnStyleValueIsInfinity = function (name, value) {
    if (warnedForInfinityValue) {
      return;
    }

    warnedForInfinityValue = true;

    error('`Infinity` is an invalid value for the `%s` css style property.', name);
  };

  warnValidStyle = function (name, value) {
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value);
    }

    if (typeof value === 'number') {
      if (isNaN(value)) {
        warnStyleValueIsNaN(name, value);
      } else if (!isFinite(value)) {
        warnStyleValueIsInfinity(name, value);
      }
    }
  };
}

var warnValidStyle$1 = warnValidStyle;

/**
 * Operations for dealing with CSS properties.
 */

/**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */

function createDangerousStringForStyles(styles) {
  {
    var serialized = '';
    var delimiter = '';

    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }

      var styleValue = styles[styleName];

      if (styleValue != null) {
        var isCustomProperty = styleName.indexOf('--') === 0;
        serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
        delimiter = ';';
      }
    }

    return serialized || null;
  }
}
/**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */

function setValueForStyles(node, styles) {
  var style = node.style;

  for (var styleName in styles) {
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }

    var isCustomProperty = styleName.indexOf('--') === 0;

    {
      if (!isCustomProperty) {
        warnValidStyle$1(styleName, styles[styleName]);
      }
    }

    var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

    if (styleName === 'float') {
      styleName = 'cssFloat';
    }

    if (isCustomProperty) {
      style.setProperty(styleName, styleValue);
    } else {
      style[styleName] = styleValue;
    }
  }
}

function isValueEmpty(value) {
  return value == null || typeof value === 'boolean' || value === '';
}
/**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */


function expandShorthandMap(styles) {
  var expanded = {};

  for (var key in styles) {
    var longhands = shorthandToLonghand[key] || [key];

    for (var i = 0; i < longhands.length; i++) {
      expanded[longhands[i]] = key;
    }
  }

  return expanded;
}
/**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */


function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
  {
    if (!nextStyles) {
      return;
    }

    var expandedUpdates = expandShorthandMap(styleUpdates);
    var expandedStyles = expandShorthandMap(nextStyles);
    var warnedAbout = {};

    for (var key in expandedUpdates) {
      var originalKey = expandedUpdates[key];
      var correctOriginalKey = expandedStyles[key];

      if (correctOriginalKey && originalKey !== correctOriginalKey) {
        var warningKey = originalKey + ',' + correctOriginalKey;

        if (warnedAbout[warningKey]) {
          continue;
        }

        warnedAbout[warningKey] = true;

        error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + "avoid this, don't mix shorthand and non-shorthand properties " + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
      }
    }
  }
}

// For HTML, certain tags should omit their close tag. We keep a list for
// those special-case tags.
var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.

};

// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

var HTML = '__html';

function assertValidProps(tag, props) {
  if (!props) {
    return;
  } // Note the use of `==` which checks for null or undefined.


  if (voidElementTags[tag]) {
    if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
      {
        throw Error( tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." );
      }
    }
  }

  if (props.dangerouslySetInnerHTML != null) {
    if (!(props.children == null)) {
      {
        throw Error( "Can only set one of `children` or `props.dangerouslySetInnerHTML`." );
      }
    }

    if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
      {
        throw Error( "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information." );
      }
    }
  }

  {
    if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
      error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
    }
  }

  if (!(props.style == null || typeof props.style === 'object')) {
    {
      throw Error( "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." );
    }
  }
}

function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this list too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;

    default:
      return true;
  }
}

// When adding attributes to the HTML or SVG allowed attribute list, be sure to
// also add them to this module to ensure casing and incorrect name
// warnings.
var possibleStandardNames = {
  // HTML
  accept: 'accept',
  acceptcharset: 'acceptCharset',
  'accept-charset': 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  alt: 'alt',
  as: 'as',
  async: 'async',
  autocapitalize: 'autoCapitalize',
  autocomplete: 'autoComplete',
  autocorrect: 'autoCorrect',
  autofocus: 'autoFocus',
  autoplay: 'autoPlay',
  autosave: 'autoSave',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  challenge: 'challenge',
  charset: 'charSet',
  checked: 'checked',
  children: 'children',
  cite: 'cite',
  class: 'className',
  classid: 'classID',
  classname: 'className',
  cols: 'cols',
  colspan: 'colSpan',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  controlslist: 'controlsList',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defaultchecked: 'defaultChecked',
  defaultvalue: 'defaultValue',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  disablepictureinpicture: 'disablePictureInPicture',
  disableremoteplayback: 'disableRemotePlayback',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  enterkeyhint: 'enterKeyHint',
  for: 'htmlFor',
  form: 'form',
  formmethod: 'formMethod',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  htmlfor: 'htmlFor',
  httpequiv: 'httpEquiv',
  'http-equiv': 'httpEquiv',
  icon: 'icon',
  id: 'id',
  innerhtml: 'innerHTML',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  itemid: 'itemID',
  itemprop: 'itemProp',
  itemref: 'itemRef',
  itemscope: 'itemScope',
  itemtype: 'itemType',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginwidth: 'marginWidth',
  marginheight: 'marginHeight',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  nomodule: 'noModule',
  nonce: 'nonce',
  novalidate: 'noValidate',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  playsinline: 'playsInline',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  referrerpolicy: 'referrerPolicy',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rows: 'rows',
  rowspan: 'rowSpan',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',
  // SVG
  about: 'about',
  accentheight: 'accentHeight',
  'accent-height': 'accentHeight',
  accumulate: 'accumulate',
  additive: 'additive',
  alignmentbaseline: 'alignmentBaseline',
  'alignment-baseline': 'alignmentBaseline',
  allowreorder: 'allowReorder',
  alphabetic: 'alphabetic',
  amplitude: 'amplitude',
  arabicform: 'arabicForm',
  'arabic-form': 'arabicForm',
  ascent: 'ascent',
  attributename: 'attributeName',
  attributetype: 'attributeType',
  autoreverse: 'autoReverse',
  azimuth: 'azimuth',
  basefrequency: 'baseFrequency',
  baselineshift: 'baselineShift',
  'baseline-shift': 'baselineShift',
  baseprofile: 'baseProfile',
  bbox: 'bbox',
  begin: 'begin',
  bias: 'bias',
  by: 'by',
  calcmode: 'calcMode',
  capheight: 'capHeight',
  'cap-height': 'capHeight',
  clip: 'clip',
  clippath: 'clipPath',
  'clip-path': 'clipPath',
  clippathunits: 'clipPathUnits',
  cliprule: 'clipRule',
  'clip-rule': 'clipRule',
  color: 'color',
  colorinterpolation: 'colorInterpolation',
  'color-interpolation': 'colorInterpolation',
  colorinterpolationfilters: 'colorInterpolationFilters',
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorprofile: 'colorProfile',
  'color-profile': 'colorProfile',
  colorrendering: 'colorRendering',
  'color-rendering': 'colorRendering',
  contentscripttype: 'contentScriptType',
  contentstyletype: 'contentStyleType',
  cursor: 'cursor',
  cx: 'cx',
  cy: 'cy',
  d: 'd',
  datatype: 'datatype',
  decelerate: 'decelerate',
  descent: 'descent',
  diffuseconstant: 'diffuseConstant',
  direction: 'direction',
  display: 'display',
  divisor: 'divisor',
  dominantbaseline: 'dominantBaseline',
  'dominant-baseline': 'dominantBaseline',
  dur: 'dur',
  dx: 'dx',
  dy: 'dy',
  edgemode: 'edgeMode',
  elevation: 'elevation',
  enablebackground: 'enableBackground',
  'enable-background': 'enableBackground',
  end: 'end',
  exponent: 'exponent',
  externalresourcesrequired: 'externalResourcesRequired',
  fill: 'fill',
  fillopacity: 'fillOpacity',
  'fill-opacity': 'fillOpacity',
  fillrule: 'fillRule',
  'fill-rule': 'fillRule',
  filter: 'filter',
  filterres: 'filterRes',
  filterunits: 'filterUnits',
  floodopacity: 'floodOpacity',
  'flood-opacity': 'floodOpacity',
  floodcolor: 'floodColor',
  'flood-color': 'floodColor',
  focusable: 'focusable',
  fontfamily: 'fontFamily',
  'font-family': 'fontFamily',
  fontsize: 'fontSize',
  'font-size': 'fontSize',
  fontsizeadjust: 'fontSizeAdjust',
  'font-size-adjust': 'fontSizeAdjust',
  fontstretch: 'fontStretch',
  'font-stretch': 'fontStretch',
  fontstyle: 'fontStyle',
  'font-style': 'fontStyle',
  fontvariant: 'fontVariant',
  'font-variant': 'fontVariant',
  fontweight: 'fontWeight',
  'font-weight': 'fontWeight',
  format: 'format',
  from: 'from',
  fx: 'fx',
  fy: 'fy',
  g1: 'g1',
  g2: 'g2',
  glyphname: 'glyphName',
  'glyph-name': 'glyphName',
  glyphorientationhorizontal: 'glyphOrientationHorizontal',
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphorientationvertical: 'glyphOrientationVertical',
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphref: 'glyphRef',
  gradienttransform: 'gradientTransform',
  gradientunits: 'gradientUnits',
  hanging: 'hanging',
  horizadvx: 'horizAdvX',
  'horiz-adv-x': 'horizAdvX',
  horizoriginx: 'horizOriginX',
  'horiz-origin-x': 'horizOriginX',
  ideographic: 'ideographic',
  imagerendering: 'imageRendering',
  'image-rendering': 'imageRendering',
  in2: 'in2',
  in: 'in',
  inlist: 'inlist',
  intercept: 'intercept',
  k1: 'k1',
  k2: 'k2',
  k3: 'k3',
  k4: 'k4',
  k: 'k',
  kernelmatrix: 'kernelMatrix',
  kernelunitlength: 'kernelUnitLength',
  kerning: 'kerning',
  keypoints: 'keyPoints',
  keysplines: 'keySplines',
  keytimes: 'keyTimes',
  lengthadjust: 'lengthAdjust',
  letterspacing: 'letterSpacing',
  'letter-spacing': 'letterSpacing',
  lightingcolor: 'lightingColor',
  'lighting-color': 'lightingColor',
  limitingconeangle: 'limitingConeAngle',
  local: 'local',
  markerend: 'markerEnd',
  'marker-end': 'markerEnd',
  markerheight: 'markerHeight',
  markermid: 'markerMid',
  'marker-mid': 'markerMid',
  markerstart: 'markerStart',
  'marker-start': 'markerStart',
  markerunits: 'markerUnits',
  markerwidth: 'markerWidth',
  mask: 'mask',
  maskcontentunits: 'maskContentUnits',
  maskunits: 'maskUnits',
  mathematical: 'mathematical',
  mode: 'mode',
  numoctaves: 'numOctaves',
  offset: 'offset',
  opacity: 'opacity',
  operator: 'operator',
  order: 'order',
  orient: 'orient',
  orientation: 'orientation',
  origin: 'origin',
  overflow: 'overflow',
  overlineposition: 'overlinePosition',
  'overline-position': 'overlinePosition',
  overlinethickness: 'overlineThickness',
  'overline-thickness': 'overlineThickness',
  paintorder: 'paintOrder',
  'paint-order': 'paintOrder',
  panose1: 'panose1',
  'panose-1': 'panose1',
  pathlength: 'pathLength',
  patterncontentunits: 'patternContentUnits',
  patterntransform: 'patternTransform',
  patternunits: 'patternUnits',
  pointerevents: 'pointerEvents',
  'pointer-events': 'pointerEvents',
  points: 'points',
  pointsatx: 'pointsAtX',
  pointsaty: 'pointsAtY',
  pointsatz: 'pointsAtZ',
  prefix: 'prefix',
  preservealpha: 'preserveAlpha',
  preserveaspectratio: 'preserveAspectRatio',
  primitiveunits: 'primitiveUnits',
  property: 'property',
  r: 'r',
  radius: 'radius',
  refx: 'refX',
  refy: 'refY',
  renderingintent: 'renderingIntent',
  'rendering-intent': 'renderingIntent',
  repeatcount: 'repeatCount',
  repeatdur: 'repeatDur',
  requiredextensions: 'requiredExtensions',
  requiredfeatures: 'requiredFeatures',
  resource: 'resource',
  restart: 'restart',
  result: 'result',
  results: 'results',
  rotate: 'rotate',
  rx: 'rx',
  ry: 'ry',
  scale: 'scale',
  security: 'security',
  seed: 'seed',
  shaperendering: 'shapeRendering',
  'shape-rendering': 'shapeRendering',
  slope: 'slope',
  spacing: 'spacing',
  specularconstant: 'specularConstant',
  specularexponent: 'specularExponent',
  speed: 'speed',
  spreadmethod: 'spreadMethod',
  startoffset: 'startOffset',
  stddeviation: 'stdDeviation',
  stemh: 'stemh',
  stemv: 'stemv',
  stitchtiles: 'stitchTiles',
  stopcolor: 'stopColor',
  'stop-color': 'stopColor',
  stopopacity: 'stopOpacity',
  'stop-opacity': 'stopOpacity',
  strikethroughposition: 'strikethroughPosition',
  'strikethrough-position': 'strikethroughPosition',
  strikethroughthickness: 'strikethroughThickness',
  'strikethrough-thickness': 'strikethroughThickness',
  string: 'string',
  stroke: 'stroke',
  strokedasharray: 'strokeDasharray',
  'stroke-dasharray': 'strokeDasharray',
  strokedashoffset: 'strokeDashoffset',
  'stroke-dashoffset': 'strokeDashoffset',
  strokelinecap: 'strokeLinecap',
  'stroke-linecap': 'strokeLinecap',
  strokelinejoin: 'strokeLinejoin',
  'stroke-linejoin': 'strokeLinejoin',
  strokemiterlimit: 'strokeMiterlimit',
  'stroke-miterlimit': 'strokeMiterlimit',
  strokewidth: 'strokeWidth',
  'stroke-width': 'strokeWidth',
  strokeopacity: 'strokeOpacity',
  'stroke-opacity': 'strokeOpacity',
  suppresscontenteditablewarning: 'suppressContentEditableWarning',
  suppresshydrationwarning: 'suppressHydrationWarning',
  surfacescale: 'surfaceScale',
  systemlanguage: 'systemLanguage',
  tablevalues: 'tableValues',
  targetx: 'targetX',
  targety: 'targetY',
  textanchor: 'textAnchor',
  'text-anchor': 'textAnchor',
  textdecoration: 'textDecoration',
  'text-decoration': 'textDecoration',
  textlength: 'textLength',
  textrendering: 'textRendering',
  'text-rendering': 'textRendering',
  to: 'to',
  transform: 'transform',
  typeof: 'typeof',
  u1: 'u1',
  u2: 'u2',
  underlineposition: 'underlinePosition',
  'underline-position': 'underlinePosition',
  underlinethickness: 'underlineThickness',
  'underline-thickness': 'underlineThickness',
  unicode: 'unicode',
  unicodebidi: 'unicodeBidi',
  'unicode-bidi': 'unicodeBidi',
  unicoderange: 'unicodeRange',
  'unicode-range': 'unicodeRange',
  unitsperem: 'unitsPerEm',
  'units-per-em': 'unitsPerEm',
  unselectable: 'unselectable',
  valphabetic: 'vAlphabetic',
  'v-alphabetic': 'vAlphabetic',
  values: 'values',
  vectoreffect: 'vectorEffect',
  'vector-effect': 'vectorEffect',
  version: 'version',
  vertadvy: 'vertAdvY',
  'vert-adv-y': 'vertAdvY',
  vertoriginx: 'vertOriginX',
  'vert-origin-x': 'vertOriginX',
  vertoriginy: 'vertOriginY',
  'vert-origin-y': 'vertOriginY',
  vhanging: 'vHanging',
  'v-hanging': 'vHanging',
  videographic: 'vIdeographic',
  'v-ideographic': 'vIdeographic',
  viewbox: 'viewBox',
  viewtarget: 'viewTarget',
  visibility: 'visibility',
  vmathematical: 'vMathematical',
  'v-mathematical': 'vMathematical',
  vocab: 'vocab',
  widths: 'widths',
  wordspacing: 'wordSpacing',
  'word-spacing': 'wordSpacing',
  writingmode: 'writingMode',
  'writing-mode': 'writingMode',
  x1: 'x1',
  x2: 'x2',
  x: 'x',
  xchannelselector: 'xChannelSelector',
  xheight: 'xHeight',
  'x-height': 'xHeight',
  xlinkactuate: 'xlinkActuate',
  'xlink:actuate': 'xlinkActuate',
  xlinkarcrole: 'xlinkArcrole',
  'xlink:arcrole': 'xlinkArcrole',
  xlinkhref: 'xlinkHref',
  'xlink:href': 'xlinkHref',
  xlinkrole: 'xlinkRole',
  'xlink:role': 'xlinkRole',
  xlinkshow: 'xlinkShow',
  'xlink:show': 'xlinkShow',
  xlinktitle: 'xlinkTitle',
  'xlink:title': 'xlinkTitle',
  xlinktype: 'xlinkType',
  'xlink:type': 'xlinkType',
  xmlbase: 'xmlBase',
  'xml:base': 'xmlBase',
  xmllang: 'xmlLang',
  'xml:lang': 'xmlLang',
  xmlns: 'xmlns',
  'xml:space': 'xmlSpace',
  xmlnsxlink: 'xmlnsXlink',
  'xmlns:xlink': 'xmlnsXlink',
  xmlspace: 'xmlSpace',
  y1: 'y1',
  y2: 'y2',
  y: 'y',
  ychannelselector: 'yChannelSelector',
  z: 'z',
  zoomandpan: 'zoomAndPan'
};

var ariaProperties = {
  'aria-current': 0,
  // state
  'aria-details': 0,
  'aria-disabled': 0,
  // state
  'aria-hidden': 0,
  // state
  'aria-invalid': 0,
  // state
  'aria-keyshortcuts': 0,
  'aria-label': 0,
  'aria-roledescription': 0,
  // Widget Attributes
  'aria-autocomplete': 0,
  'aria-checked': 0,
  'aria-expanded': 0,
  'aria-haspopup': 0,
  'aria-level': 0,
  'aria-modal': 0,
  'aria-multiline': 0,
  'aria-multiselectable': 0,
  'aria-orientation': 0,
  'aria-placeholder': 0,
  'aria-pressed': 0,
  'aria-readonly': 0,
  'aria-required': 0,
  'aria-selected': 0,
  'aria-sort': 0,
  'aria-valuemax': 0,
  'aria-valuemin': 0,
  'aria-valuenow': 0,
  'aria-valuetext': 0,
  // Live Region Attributes
  'aria-atomic': 0,
  'aria-busy': 0,
  'aria-live': 0,
  'aria-relevant': 0,
  // Drag-and-Drop Attributes
  'aria-dropeffect': 0,
  'aria-grabbed': 0,
  // Relationship Attributes
  'aria-activedescendant': 0,
  'aria-colcount': 0,
  'aria-colindex': 0,
  'aria-colspan': 0,
  'aria-controls': 0,
  'aria-describedby': 0,
  'aria-errormessage': 0,
  'aria-flowto': 0,
  'aria-labelledby': 0,
  'aria-owns': 0,
  'aria-posinset': 0,
  'aria-rowcount': 0,
  'aria-rowindex': 0,
  'aria-rowspan': 0,
  'aria-setsize': 0
};

var warnedProperties = {};
var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

function validateProperty(tagName, name) {
  {
    if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
      return true;
    }

    if (rARIACamel.test(name)) {
      var ariaName = 'aria-' + name.slice(4).toLowerCase();
      var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
      // DOM properties, then it is an invalid aria-* attribute.

      if (correctName == null) {
        error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);

        warnedProperties[name] = true;
        return true;
      } // aria-* attributes should be lowercase; suggest the lowercase version.


      if (name !== correctName) {
        error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);

        warnedProperties[name] = true;
        return true;
      }
    }

    if (rARIA.test(name)) {
      var lowerCasedName = name.toLowerCase();
      var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
      // DOM properties, then it is an invalid aria-* attribute.

      if (standardName == null) {
        warnedProperties[name] = true;
        return false;
      } // aria-* attributes should be lowercase; suggest the lowercase version.


      if (name !== standardName) {
        error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);

        warnedProperties[name] = true;
        return true;
      }
    }
  }

  return true;
}

function warnInvalidARIAProps(type, props) {
  {
    var invalidProps = [];

    for (var key in props) {
      var isValid = validateProperty(type, key);

      if (!isValid) {
        invalidProps.push(key);
      }
    }

    var unknownPropString = invalidProps.map(function (prop) {
      return '`' + prop + '`';
    }).join(', ');

    if (invalidProps.length === 1) {
      error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
    } else if (invalidProps.length > 1) {
      error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
    }
  }
}

function validateProperties(type, props) {
  if (isCustomComponent(type, props)) {
    return;
  }

  warnInvalidARIAProps(type, props);
}

var didWarnValueNull = false;
function validateProperties$1(type, props) {
  {
    if (type !== 'input' && type !== 'textarea' && type !== 'select') {
      return;
    }

    if (props != null && props.value === null && !didWarnValueNull) {
      didWarnValueNull = true;

      if (type === 'select' && props.multiple) {
        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
      } else {
        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
      }
    }
  }
}

var validateProperty$1 = function () {};

{
  var warnedProperties$1 = {};
  var _hasOwnProperty = Object.prototype.hasOwnProperty;
  var EVENT_NAME_REGEX = /^on./;
  var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
  var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
  var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

  validateProperty$1 = function (tagName, name, value, eventRegistry) {
    if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
      return true;
    }

    var lowerCasedName = name.toLowerCase();

    if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
      error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');

      warnedProperties$1[name] = true;
      return true;
    } // We can't rely on the event system being injected on the server.


    if (eventRegistry != null) {
      var registrationNameDependencies = eventRegistry.registrationNameDependencies,
          possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

      if (registrationNameDependencies.hasOwnProperty(name)) {
        return true;
      }

      var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

      if (registrationName != null) {
        error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);

        warnedProperties$1[name] = true;
        return true;
      }

      if (EVENT_NAME_REGEX.test(name)) {
        error('Unknown event handler property `%s`. It will be ignored.', name);

        warnedProperties$1[name] = true;
        return true;
      }
    } else if (EVENT_NAME_REGEX.test(name)) {
      // If no event plugins have been injected, we are in a server environment.
      // So we can't tell if the event name is correct for sure, but we can filter
      // out known bad ones like `onclick`. We can't suggest a specific replacement though.
      if (INVALID_EVENT_NAME_REGEX.test(name)) {
        error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
      }

      warnedProperties$1[name] = true;
      return true;
    } // Let the ARIA attribute hook validate ARIA attributes


    if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
      return true;
    }

    if (lowerCasedName === 'innerhtml') {
      error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');

      warnedProperties$1[name] = true;
      return true;
    }

    if (lowerCasedName === 'aria') {
      error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');

      warnedProperties$1[name] = true;
      return true;
    }

    if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
      error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);

      warnedProperties$1[name] = true;
      return true;
    }

    if (typeof value === 'number' && isNaN(value)) {
      error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);

      warnedProperties$1[name] = true;
      return true;
    }

    var propertyInfo = getPropertyInfo(name);
    var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

    if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
      var standardName = possibleStandardNames[lowerCasedName];

      if (standardName !== name) {
        error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);

        warnedProperties$1[name] = true;
        return true;
      }
    } else if (!isReserved && name !== lowerCasedName) {
      // Unknown attributes should have lowercase casing since that's how they
      // will be cased anyway with server rendering.
      error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);

      warnedProperties$1[name] = true;
      return true;
    }

    if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
      if (value) {
        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
      } else {
        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
      }

      warnedProperties$1[name] = true;
      return true;
    } // Now that we've validated casing, do not validate
    // data types for reserved props


    if (isReserved) {
      return true;
    } // Warn when a known attribute is a bad type


    if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
      warnedProperties$1[name] = true;
      return false;
    } // Warn when passing the strings 'false' or 'true' into a boolean prop


    if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
      error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);

      warnedProperties$1[name] = true;
      return true;
    }

    return true;
  };
}

var warnUnknownProperties = function (type, props, eventRegistry) {
  {
    var unknownProps = [];

    for (var key in props) {
      var isValid = validateProperty$1(type, key, props[key], eventRegistry);

      if (!isValid) {
        unknownProps.push(key);
      }
    }

    var unknownPropString = unknownProps.map(function (prop) {
      return '`' + prop + '`';
    }).join(', ');

    if (unknownProps.length === 1) {
      error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
    } else if (unknownProps.length > 1) {
      error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
    }
  }
};

function validateProperties$2(type, props, eventRegistry) {
  if (isCustomComponent(type, props)) {
    return;
  }

  warnUnknownProperties(type, props, eventRegistry);
}

var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
var IS_NON_DELEGATED = 1 << 1;
var IS_CAPTURE_PHASE = 1 << 2;
var IS_REPLAYED = 1 << 4;
// set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
// we call willDeferLaterForLegacyFBSupport, thus not bailing out
// will result in endless cycles like an infinite loop.
// We also don't want to defer during event replaying.

var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;

/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  // Fallback to nativeEvent.srcElement for IE9
  // https://github.com/facebook/react/issues/12506
  var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963

  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  } // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html


  return target.nodeType === TEXT_NODE ? target.parentNode : target;
}

var restoreImpl = null;
var restoreTarget = null;
var restoreQueue = null;

function restoreStateOfTarget(target) {
  // We perform this translation at the end of the event loop so that we
  // always receive the correct fiber here
  var internalInstance = getInstanceFromNode(target);

  if (!internalInstance) {
    // Unmounted
    return;
  }

  if (!(typeof restoreImpl === 'function')) {
    {
      throw Error( "setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.

  if (stateNode) {
    var _props = getFiberCurrentPropsFromNode(stateNode);

    restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
  }
}

function setRestoreImplementation(impl) {
  restoreImpl = impl;
}
function enqueueStateRestore(target) {
  if (restoreTarget) {
    if (restoreQueue) {
      restoreQueue.push(target);
    } else {
      restoreQueue = [target];
    }
  } else {
    restoreTarget = target;
  }
}
function needsStateRestore() {
  return restoreTarget !== null || restoreQueue !== null;
}
function restoreStateIfNeeded() {
  if (!restoreTarget) {
    return;
  }

  var target = restoreTarget;
  var queuedTargets = restoreQueue;
  restoreTarget = null;
  restoreQueue = null;
  restoreStateOfTarget(target);

  if (queuedTargets) {
    for (var i = 0; i < queuedTargets.length; i++) {
      restoreStateOfTarget(queuedTargets[i]);
    }
  }
}

// the renderer. Such as when we're dispatching events or if third party
// libraries need to call batchedUpdates. Eventually, this API will go away when
// everything is batched by default. We'll then have a similar API to opt-out of
// scheduled work and instead do synchronous work.
// Defaults

var batchedUpdatesImpl = function (fn, bookkeeping) {
  return fn(bookkeeping);
};

var discreteUpdatesImpl = function (fn, a, b, c, d) {
  return fn(a, b, c, d);
};

var flushDiscreteUpdatesImpl = function () {};

var batchedEventUpdatesImpl = batchedUpdatesImpl;
var isInsideEventHandler = false;
var isBatchingEventUpdates = false;

function finishEventHandler() {
  // Here we wait until all updates have propagated, which is important
  // when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  // Then we restore state of any controlled component.
  var controlledComponentsHavePendingUpdates = needsStateRestore();

  if (controlledComponentsHavePendingUpdates) {
    // If a controlled event was fired, we may need to restore the state of
    // the DOM node back to the controlled value. This is necessary when React
    // bails out of the update without touching the DOM.
    flushDiscreteUpdatesImpl();
    restoreStateIfNeeded();
  }
}

function batchedUpdates(fn, bookkeeping) {
  if (isInsideEventHandler) {
    // If we are currently inside another batch, we need to wait until it
    // fully completes before restoring state.
    return fn(bookkeeping);
  }

  isInsideEventHandler = true;

  try {
    return batchedUpdatesImpl(fn, bookkeeping);
  } finally {
    isInsideEventHandler = false;
    finishEventHandler();
  }
}
function batchedEventUpdates(fn, a, b) {
  if (isBatchingEventUpdates) {
    // If we are currently inside another batch, we need to wait until it
    // fully completes before restoring state.
    return fn(a, b);
  }

  isBatchingEventUpdates = true;

  try {
    return batchedEventUpdatesImpl(fn, a, b);
  } finally {
    isBatchingEventUpdates = false;
    finishEventHandler();
  }
}
function discreteUpdates(fn, a, b, c, d) {
  var prevIsInsideEventHandler = isInsideEventHandler;
  isInsideEventHandler = true;

  try {
    return discreteUpdatesImpl(fn, a, b, c, d);
  } finally {
    isInsideEventHandler = prevIsInsideEventHandler;

    if (!isInsideEventHandler) {
      finishEventHandler();
    }
  }
}
function flushDiscreteUpdatesIfNeeded(timeStamp) {
  {
    if (!isInsideEventHandler) {
      flushDiscreteUpdatesImpl();
    }
  }
}
function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
  batchedUpdatesImpl = _batchedUpdatesImpl;
  discreteUpdatesImpl = _discreteUpdatesImpl;
  flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
  batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
    case 'onMouseEnter':
      return !!(props.disabled && isInteractive(type));

    default:
      return false;
  }
}
/**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */


function getListener(inst, registrationName) {
  var stateNode = inst.stateNode;

  if (stateNode === null) {
    // Work in progress (ex: onload events in incremental mode).
    return null;
  }

  var props = getFiberCurrentPropsFromNode(stateNode);

  if (props === null) {
    // Work in progress.
    return null;
  }

  var listener = props[registrationName];

  if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
    return null;
  }

  if (!(!listener || typeof listener === 'function')) {
    {
      throw Error( "Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type." );
    }
  }

  return listener;
}

var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support

if (canUseDOM) {
  try {
    var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value

    Object.defineProperty(options, 'passive', {
      get: function () {
        passiveBrowserEventsSupported = true;
      }
    });
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (e) {
    passiveBrowserEventsSupported = false;
  }
}

function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
  var funcArgs = Array.prototype.slice.call(arguments, 3);

  try {
    func.apply(context, funcArgs);
  } catch (error) {
    this.onError(error);
  }
}

var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;

{
  // In DEV mode, we swap out invokeGuardedCallback for a special version
  // that plays more nicely with the browser's DevTools. The idea is to preserve
  // "Pause on exceptions" behavior. Because React wraps all user-provided
  // functions in invokeGuardedCallback, and the production version of
  // invokeGuardedCallback uses a try-catch, all user exceptions are treated
  // like caught exceptions, and the DevTools won't pause unless the developer
  // takes the extra step of enabling pause on caught exceptions. This is
  // unintuitive, though, because even though React has caught the error, from
  // the developer's perspective, the error is uncaught.
  //
  // To preserve the expected "Pause on exceptions" behavior, we don't use a
  // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
  // DOM node, and call the user-provided callback from inside an event handler
  // for that fake event. If the callback throws, the error is "captured" using
  // a global event handler. But because the error happens in a different
  // event loop context, it does not interrupt the normal program flow.
  // Effectively, this gives us try-catch behavior without actually using
  // try-catch. Neat!
  // Check that the browser supports the APIs we need to implement our special
  // DEV version of invokeGuardedCallback
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');

    invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
      // If document doesn't exist we know for sure we will crash in this method
      // when we call document.createEvent(). However this can cause confusing
      // errors: https://github.com/facebookincubator/create-react-app/issues/3482
      // So we preemptively throw with a better message instead.
      if (!(typeof document !== 'undefined')) {
        {
          throw Error( "The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous." );
        }
      }

      var evt = document.createEvent('Event');
      var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
      // set this to true at the beginning, then set it to false right after
      // calling the function. If the function errors, `didError` will never be
      // set to false. This strategy works even if the browser is flaky and
      // fails to call our global error handler, because it doesn't rely on
      // the error event at all.

      var didError = true; // Keeps track of the value of window.event so that we can reset it
      // during the callback to let user code access window.event in the
      // browsers that support it.

      var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
      // dispatching: https://github.com/facebook/react/issues/13688

      var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');

      function restoreAfterDispatch() {
        // We immediately remove the callback from event listeners so that
        // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
        // nested call would trigger the fake event handlers of any call higher
        // in the stack.
        fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
        // window.event assignment in both IE <= 10 as they throw an error
        // "Member not found" in strict mode, and in Firefox which does not
        // support window.event.

        if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
          window.event = windowEvent;
        }
      } // Create an event handler for our fake event. We will synchronously
      // dispatch our fake event using `dispatchEvent`. Inside the handler, we
      // call the user-provided callback.


      var funcArgs = Array.prototype.slice.call(arguments, 3);

      function callCallback() {
        didCall = true;
        restoreAfterDispatch();
        func.apply(context, funcArgs);
        didError = false;
      } // Create a global error event handler. We use this to capture the value
      // that was thrown. It's possible that this error handler will fire more
      // than once; for example, if non-React code also calls `dispatchEvent`
      // and a handler for that event throws. We should be resilient to most of
      // those cases. Even if our error event handler fires more than once, the
      // last error event is always used. If the callback actually does error,
      // we know that the last error event is the correct one, because it's not
      // possible for anything else to have happened in between our callback
      // erroring and the code that follows the `dispatchEvent` call below. If
      // the callback doesn't error, but the error event was fired, we know to
      // ignore it because `didError` will be false, as described above.


      var error; // Use this to track whether the error event is ever called.

      var didSetError = false;
      var isCrossOriginError = false;

      function handleWindowError(event) {
        error = event.error;
        didSetError = true;

        if (error === null && event.colno === 0 && event.lineno === 0) {
          isCrossOriginError = true;
        }

        if (event.defaultPrevented) {
          // Some other error handler has prevented default.
          // Browsers silence the error report if this happens.
          // We'll remember this to later decide whether to log it or not.
          if (error != null && typeof error === 'object') {
            try {
              error._suppressLogging = true;
            } catch (inner) {// Ignore.
            }
          }
        }
      } // Create a fake event type.


      var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

      window.addEventListener('error', handleWindowError);
      fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
      // errors, it will trigger our global error handler.

      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);

      if (windowEventDescriptor) {
        Object.defineProperty(window, 'event', windowEventDescriptor);
      }

      if (didCall && didError) {
        if (!didSetError) {
          // The callback errored, but the error event never fired.
          error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
        } else if (isCrossOriginError) {
          error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://reactjs.org/link/crossorigin-error for more information.');
        }

        this.onError(error);
      } // Remove our event listeners


      window.removeEventListener('error', handleWindowError);

      if (!didCall) {
        // Something went really wrong, and our event was not dispatched.
        // https://github.com/facebook/react/issues/16734
        // https://github.com/facebook/react/issues/16585
        // Fall back to the production implementation.
        restoreAfterDispatch();
        return invokeGuardedCallbackProd.apply(this, arguments);
      }
    };
  }
}

var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;

var hasError = false;
var caughtError = null; // Used by event system to capture/rethrow the first error.

var hasRethrowError = false;
var rethrowError = null;
var reporter = {
  onError: function (error) {
    hasError = true;
    caughtError = error;
  }
};
/**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */

function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
  hasError = false;
  caughtError = null;
  invokeGuardedCallbackImpl$1.apply(reporter, arguments);
}
/**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */

function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
  invokeGuardedCallback.apply(this, arguments);

  if (hasError) {
    var error = clearCaughtError();

    if (!hasRethrowError) {
      hasRethrowError = true;
      rethrowError = error;
    }
  }
}
/**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */

function rethrowCaughtError() {
  if (hasRethrowError) {
    var error = rethrowError;
    hasRethrowError = false;
    rethrowError = null;
    throw error;
  }
}
function hasCaughtError() {
  return hasError;
}
function clearCaughtError() {
  if (hasError) {
    var error = caughtError;
    hasError = false;
    caughtError = null;
    return error;
  } else {
    {
      {
        throw Error( "clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }
}

/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */
function get(key) {
  return key._reactInternals;
}
function has(key) {
  return key._reactInternals !== undefined;
}
function set(key, value) {
  key._reactInternals = value;
}

// Don't change these two values. They're used by React Dev Tools.
var NoFlags =
/*                      */
0;
var PerformedWork =
/*                */
1; // You can change the rest (and add more).

var Placement =
/*                    */
2;
var Update =
/*                       */
4;
var PlacementAndUpdate =
/*           */
6;
var Deletion =
/*                     */
8;
var ContentReset =
/*                 */
16;
var Callback =
/*                     */
32;
var DidCapture =
/*                   */
64;
var Ref =
/*                          */
128;
var Snapshot =
/*                     */
256;
var Passive =
/*                      */
512; // TODO (effects) Remove this bit once the new reconciler is synced to the old.

var PassiveUnmountPendingDev =
/*     */
8192;
var Hydrating =
/*                    */
1024;
var HydratingAndUpdate =
/*           */
1028; // Passive & Update & Callback & Ref & Snapshot

var LifecycleEffectMask =
/*          */
932; // Union of all host effects

var HostEffectMask =
/*               */
2047; // These are not really side effects, but we still reuse this field.

var Incomplete =
/*                   */
2048;
var ShouldCapture =
/*                */
4096;
var ForceUpdateForLegacySuspense =
/* */
16384; // Static tags describe aspects of a fiber that are not specific to a render,

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
function getNearestMountedFiber(fiber) {
  var node = fiber;
  var nearestMounted = fiber;

  if (!fiber.alternate) {
    // If there is no alternate, this might be a new tree that isn't inserted
    // yet. If it is, then it will have a pending insertion effect on it.
    var nextNode = node;

    do {
      node = nextNode;

      if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
        // This is an insertion or in-progress hydration. The nearest possible
        // mounted fiber is the parent but we need to continue to figure out
        // if that one is still mounted.
        nearestMounted = node.return;
      }

      nextNode = node.return;
    } while (nextNode);
  } else {
    while (node.return) {
      node = node.return;
    }
  }

  if (node.tag === HostRoot) {
    // TODO: Check if this was a nested HostRoot when used with
    // renderContainerIntoSubtree.
    return nearestMounted;
  } // If we didn't hit the root, that means that we're in an disconnected tree
  // that has been unmounted.


  return null;
}
function getSuspenseInstanceFromFiber(fiber) {
  if (fiber.tag === SuspenseComponent) {
    var suspenseState = fiber.memoizedState;

    if (suspenseState === null) {
      var current = fiber.alternate;

      if (current !== null) {
        suspenseState = current.memoizedState;
      }
    }

    if (suspenseState !== null) {
      return suspenseState.dehydrated;
    }
  }

  return null;
}
function getContainerFromFiber(fiber) {
  return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
}
function isFiberMounted(fiber) {
  return getNearestMountedFiber(fiber) === fiber;
}
function isMounted(component) {
  {
    var owner = ReactCurrentOwner.current;

    if (owner !== null && owner.tag === ClassComponent) {
      var ownerFiber = owner;
      var instance = ownerFiber.stateNode;

      if (!instance._warnedAboutRefsInRender) {
        error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component');
      }

      instance._warnedAboutRefsInRender = true;
    }
  }

  var fiber = get(component);

  if (!fiber) {
    return false;
  }

  return getNearestMountedFiber(fiber) === fiber;
}

function assertIsMounted(fiber) {
  if (!(getNearestMountedFiber(fiber) === fiber)) {
    {
      throw Error( "Unable to find node on an unmounted component." );
    }
  }
}

function findCurrentFiberUsingSlowPath(fiber) {
  var alternate = fiber.alternate;

  if (!alternate) {
    // If there is no alternate, then we only need to check if it is mounted.
    var nearestMounted = getNearestMountedFiber(fiber);

    if (!(nearestMounted !== null)) {
      {
        throw Error( "Unable to find node on an unmounted component." );
      }
    }

    if (nearestMounted !== fiber) {
      return null;
    }

    return fiber;
  } // If we have two possible branches, we'll walk backwards up to the root
  // to see what path the root points to. On the way we may hit one of the
  // special cases and we'll deal with them.


  var a = fiber;
  var b = alternate;

  while (true) {
    var parentA = a.return;

    if (parentA === null) {
      // We're at the root.
      break;
    }

    var parentB = parentA.alternate;

    if (parentB === null) {
      // There is no alternate. This is an unusual case. Currently, it only
      // happens when a Suspense component is hidden. An extra fragment fiber
      // is inserted in between the Suspense fiber and its children. Skip
      // over this extra fragment fiber and proceed to the next parent.
      var nextParent = parentA.return;

      if (nextParent !== null) {
        a = b = nextParent;
        continue;
      } // If there's no parent, we're at the root.


      break;
    } // If both copies of the parent fiber point to the same child, we can
    // assume that the child is current. This happens when we bailout on low
    // priority: the bailed out fiber's child reuses the current child.


    if (parentA.child === parentB.child) {
      var child = parentA.child;

      while (child) {
        if (child === a) {
          // We've determined that A is the current branch.
          assertIsMounted(parentA);
          return fiber;
        }

        if (child === b) {
          // We've determined that B is the current branch.
          assertIsMounted(parentA);
          return alternate;
        }

        child = child.sibling;
      } // We should never have an alternate for any mounting node. So the only
      // way this could possibly happen is if this was unmounted, if at all.


      {
        {
          throw Error( "Unable to find node on an unmounted component." );
        }
      }
    }

    if (a.return !== b.return) {
      // The return pointer of A and the return pointer of B point to different
      // fibers. We assume that return pointers never criss-cross, so A must
      // belong to the child set of A.return, and B must belong to the child
      // set of B.return.
      a = parentA;
      b = parentB;
    } else {
      // The return pointers point to the same fiber. We'll have to use the
      // default, slow path: scan the child sets of each parent alternate to see
      // which child belongs to which set.
      //
      // Search parent A's child set
      var didFindChild = false;
      var _child = parentA.child;

      while (_child) {
        if (_child === a) {
          didFindChild = true;
          a = parentA;
          b = parentB;
          break;
        }

        if (_child === b) {
          didFindChild = true;
          b = parentA;
          a = parentB;
          break;
        }

        _child = _child.sibling;
      }

      if (!didFindChild) {
        // Search parent B's child set
        _child = parentB.child;

        while (_child) {
          if (_child === a) {
            didFindChild = true;
            a = parentB;
            b = parentA;
            break;
          }

          if (_child === b) {
            didFindChild = true;
            b = parentB;
            a = parentA;
            break;
          }

          _child = _child.sibling;
        }

        if (!didFindChild) {
          {
            throw Error( "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue." );
          }
        }
      }
    }

    if (!(a.alternate === b)) {
      {
        throw Error( "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  } // If the root is not a host container, we're in a disconnected tree. I.e.
  // unmounted.


  if (!(a.tag === HostRoot)) {
    {
      throw Error( "Unable to find node on an unmounted component." );
    }
  }

  if (a.stateNode.current === a) {
    // We've determined that A is the current branch.
    return fiber;
  } // Otherwise B has to be current branch.


  return alternate;
}
function findCurrentHostFiber(parent) {
  var currentParent = findCurrentFiberUsingSlowPath(parent);

  if (!currentParent) {
    return null;
  } // Next we'll drill down this component to find the first HostComponent/Text.


  var node = currentParent;

  while (true) {
    if (node.tag === HostComponent || node.tag === HostText) {
      return node;
    } else if (node.child) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === currentParent) {
      return null;
    }

    while (!node.sibling) {
      if (!node.return || node.return === currentParent) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  } // Flow needs the return null here, but ESLint complains about it.
  // eslint-disable-next-line no-unreachable


  return null;
}
function findCurrentHostFiberWithNoPortals(parent) {
  var currentParent = findCurrentFiberUsingSlowPath(parent);

  if (!currentParent) {
    return null;
  } // Next we'll drill down this component to find the first HostComponent/Text.


  var node = currentParent;

  while (true) {
    if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI ) {
      return node;
    } else if (node.child && node.tag !== HostPortal) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === currentParent) {
      return null;
    }

    while (!node.sibling) {
      if (!node.return || node.return === currentParent) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  } // Flow needs the return null here, but ESLint complains about it.
  // eslint-disable-next-line no-unreachable


  return null;
}

var attemptUserBlockingHydration;
function setAttemptUserBlockingHydration(fn) {
  attemptUserBlockingHydration = fn;
}
var attemptContinuousHydration;
function setAttemptContinuousHydration(fn) {
  attemptContinuousHydration = fn;
}
var attemptHydrationAtCurrentPriority;
function setAttemptHydrationAtCurrentPriority(fn) {
  attemptHydrationAtCurrentPriority = fn;
}
var attemptHydrationAtPriority;
function setAttemptHydrationAtPriority(fn) {
  attemptHydrationAtPriority = fn;
} // TODO: Upgrade this definition once we're on a newer version of Flow that
var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.

var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
// if the last target was dehydrated.

var queuedFocus = null;
var queuedDrag = null;
var queuedMouse = null; // For pointer events there can be one latest event per pointerId.

var queuedPointers = new Map();
var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.

var queuedExplicitHydrationTargets = [];
function hasQueuedDiscreteEvents() {
  return queuedDiscreteEvents.length > 0;
}
var discreteReplayableEvents = ['mousedown', 'mouseup', 'touchcancel', 'touchend', 'touchstart', 'auxclick', 'dblclick', 'pointercancel', 'pointerdown', 'pointerup', 'dragend', 'dragstart', 'drop', 'compositionend', 'compositionstart', 'keydown', 'keypress', 'keyup', 'input', 'textInput', // Intentionally camelCase
'copy', 'cut', 'paste', 'click', 'change', 'contextmenu', 'reset', 'submit'];
function isReplayableDiscreteEvent(eventType) {
  return discreteReplayableEvents.indexOf(eventType) > -1;
}

function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  return {
    blockedOn: blockedOn,
    domEventName: domEventName,
    eventSystemFlags: eventSystemFlags | IS_REPLAYED,
    nativeEvent: nativeEvent,
    targetContainers: [targetContainer]
  };
}

function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
  queuedDiscreteEvents.push(queuedEvent);
} // Resets the replaying for this type of continuous event to no event.

function clearIfContinuousEvent(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'focusin':
    case 'focusout':
      queuedFocus = null;
      break;

    case 'dragenter':
    case 'dragleave':
      queuedDrag = null;
      break;

    case 'mouseover':
    case 'mouseout':
      queuedMouse = null;
      break;

    case 'pointerover':
    case 'pointerout':
      {
        var pointerId = nativeEvent.pointerId;
        queuedPointers.delete(pointerId);
        break;
      }

    case 'gotpointercapture':
    case 'lostpointercapture':
      {
        var _pointerId = nativeEvent.pointerId;
        queuedPointerCaptures.delete(_pointerId);
        break;
      }
  }
}

function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
    var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);

    if (blockedOn !== null) {
      var _fiber2 = getInstanceFromNode(blockedOn);

      if (_fiber2 !== null) {
        // Attempt to increase the priority of this target.
        attemptContinuousHydration(_fiber2);
      }
    }

    return queuedEvent;
  } // If we have already queued this exact event, then it's because
  // the different event systems have different DOM event listeners.
  // We can accumulate the flags, and the targetContainers, and
  // store a single event to be replayed.


  existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
  var targetContainers = existingQueuedEvent.targetContainers;

  if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) {
    targetContainers.push(targetContainer);
  }

  return existingQueuedEvent;
}

function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  // These set relatedTarget to null because the replayed event will be treated as if we
  // moved from outside the window (no target) onto the target once it hydrates.
  // Instead of mutating we could clone the event.
  switch (domEventName) {
    case 'focusin':
      {
        var focusEvent = nativeEvent;
        queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
        return true;
      }

    case 'dragenter':
      {
        var dragEvent = nativeEvent;
        queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
        return true;
      }

    case 'mouseover':
      {
        var mouseEvent = nativeEvent;
        queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
        return true;
      }

    case 'pointerover':
      {
        var pointerEvent = nativeEvent;
        var pointerId = pointerEvent.pointerId;
        queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
        return true;
      }

    case 'gotpointercapture':
      {
        var _pointerEvent = nativeEvent;
        var _pointerId2 = _pointerEvent.pointerId;
        queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
        return true;
      }
  }

  return false;
} // Check if this target is unblocked. Returns true if it's unblocked.

function attemptExplicitHydrationTarget(queuedTarget) {
  // TODO: This function shares a lot of logic with attemptToDispatchEvent.
  // Try to unify them. It's a bit tricky since it would require two return
  // values.
  var targetInst = getClosestInstanceFromNode(queuedTarget.target);

  if (targetInst !== null) {
    var nearestMounted = getNearestMountedFiber(targetInst);

    if (nearestMounted !== null) {
      var tag = nearestMounted.tag;

      if (tag === SuspenseComponent) {
        var instance = getSuspenseInstanceFromFiber(nearestMounted);

        if (instance !== null) {
          // We're blocked on hydrating this boundary.
          // Increase its priority.
          queuedTarget.blockedOn = instance;
          attemptHydrationAtPriority(queuedTarget.lanePriority, function () {
            Scheduler.unstable_runWithPriority(queuedTarget.priority, function () {
              attemptHydrationAtCurrentPriority(nearestMounted);
            });
          });
          return;
        }
      } else if (tag === HostRoot) {
        var root = nearestMounted.stateNode;

        if (root.hydrate) {
          queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
          // a root other than sync.

          return;
        }
      }
    }
  }

  queuedTarget.blockedOn = null;
}

function attemptReplayContinuousQueuedEvent(queuedEvent) {
  if (queuedEvent.blockedOn !== null) {
    return false;
  }

  var targetContainers = queuedEvent.targetContainers;

  while (targetContainers.length > 0) {
    var targetContainer = targetContainers[0];
    var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);

    if (nextBlockedOn !== null) {
      // We're still blocked. Try again later.
      var _fiber3 = getInstanceFromNode(nextBlockedOn);

      if (_fiber3 !== null) {
        attemptContinuousHydration(_fiber3);
      }

      queuedEvent.blockedOn = nextBlockedOn;
      return false;
    } // This target container was successfully dispatched. Try the next.


    targetContainers.shift();
  }

  return true;
}

function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
  if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
    map.delete(key);
  }
}

function replayUnblockedEvents() {
  hasScheduledReplayAttempt = false; // First replay discrete events.

  while (queuedDiscreteEvents.length > 0) {
    var nextDiscreteEvent = queuedDiscreteEvents[0];

    if (nextDiscreteEvent.blockedOn !== null) {
      // We're still blocked.
      // Increase the priority of this boundary to unblock
      // the next discrete event.
      var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);

      if (_fiber4 !== null) {
        attemptUserBlockingHydration(_fiber4);
      }

      break;
    }

    var targetContainers = nextDiscreteEvent.targetContainers;

    while (targetContainers.length > 0) {
      var targetContainer = targetContainers[0];
      var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);

      if (nextBlockedOn !== null) {
        // We're still blocked. Try again later.
        nextDiscreteEvent.blockedOn = nextBlockedOn;
        break;
      } // This target container was successfully dispatched. Try the next.


      targetContainers.shift();
    }

    if (nextDiscreteEvent.blockedOn === null) {
      // We've successfully replayed the first event. Let's try the next one.
      queuedDiscreteEvents.shift();
    }
  } // Next replay any continuous events.


  if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
    queuedFocus = null;
  }

  if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
    queuedDrag = null;
  }

  if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
    queuedMouse = null;
  }

  queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
  queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}

function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
  if (queuedEvent.blockedOn === unblocked) {
    queuedEvent.blockedOn = null;

    if (!hasScheduledReplayAttempt) {
      hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
      // now unblocked. This first might not actually be unblocked yet.
      // We could check it early to avoid scheduling an unnecessary callback.

      Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
    }
  }
}

function retryIfBlockedOn(unblocked) {
  // Mark anything that was blocked on this as no longer blocked
  // and eligible for a replay.
  if (queuedDiscreteEvents.length > 0) {
    scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
    // worth it because we expect very few discrete events to queue up and once
    // we are actually fully unblocked it will be fast to replay them.

    for (var i = 1; i < queuedDiscreteEvents.length; i++) {
      var queuedEvent = queuedDiscreteEvents[i];

      if (queuedEvent.blockedOn === unblocked) {
        queuedEvent.blockedOn = null;
      }
    }
  }

  if (queuedFocus !== null) {
    scheduleCallbackIfUnblocked(queuedFocus, unblocked);
  }

  if (queuedDrag !== null) {
    scheduleCallbackIfUnblocked(queuedDrag, unblocked);
  }

  if (queuedMouse !== null) {
    scheduleCallbackIfUnblocked(queuedMouse, unblocked);
  }

  var unblock = function (queuedEvent) {
    return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
  };

  queuedPointers.forEach(unblock);
  queuedPointerCaptures.forEach(unblock);

  for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
    var queuedTarget = queuedExplicitHydrationTargets[_i];

    if (queuedTarget.blockedOn === unblocked) {
      queuedTarget.blockedOn = null;
    }
  }

  while (queuedExplicitHydrationTargets.length > 0) {
    var nextExplicitTarget = queuedExplicitHydrationTargets[0];

    if (nextExplicitTarget.blockedOn !== null) {
      // We're still blocked.
      break;
    } else {
      attemptExplicitHydrationTarget(nextExplicitTarget);

      if (nextExplicitTarget.blockedOn === null) {
        // We're unblocked.
        queuedExplicitHydrationTargets.shift();
      }
    }
  }
}

var DiscreteEvent = 0;
var UserBlockingEvent = 1;
var ContinuousEvent = 2;

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */

function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  return prefixes;
}
/**
 * A list of event names to a configurable list of vendor prefixes.
 */


var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};
/**
 * Event names that have already been detected and prefixed (if applicable).
 */

var prefixedEventNames = {};
/**
 * Element to check for prefixes on.
 */

var style = {};
/**
 * Bootstrap if a DOM exists.
 */

if (canUseDOM) {
  style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.

  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  } // Same as above


  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}
/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */


function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return eventName;
}

var ANIMATION_END = getVendorPrefixedEventName('animationend');
var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
var ANIMATION_START = getVendorPrefixedEventName('animationstart');
var TRANSITION_END = getVendorPrefixedEventName('transitionend');

var topLevelEventsToReactNames = new Map();
var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
// the code required to apply the same logic for event prioritization and that of the
// SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
// duplication (for which there would be quite a bit). For the events that are not needed
// for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
// array of top level events.
// Lastly, we ignore prettier so we can keep the formatting sane.
// prettier-ignore

var discreteEventPairsForSimpleEventPlugin = ['cancel', 'cancel', 'click', 'click', 'close', 'close', 'contextmenu', 'contextMenu', 'copy', 'copy', 'cut', 'cut', 'auxclick', 'auxClick', 'dblclick', 'doubleClick', // Careful!
'dragend', 'dragEnd', 'dragstart', 'dragStart', 'drop', 'drop', 'focusin', 'focus', // Careful!
'focusout', 'blur', // Careful!
'input', 'input', 'invalid', 'invalid', 'keydown', 'keyDown', 'keypress', 'keyPress', 'keyup', 'keyUp', 'mousedown', 'mouseDown', 'mouseup', 'mouseUp', 'paste', 'paste', 'pause', 'pause', 'play', 'play', 'pointercancel', 'pointerCancel', 'pointerdown', 'pointerDown', 'pointerup', 'pointerUp', 'ratechange', 'rateChange', 'reset', 'reset', 'seeked', 'seeked', 'submit', 'submit', 'touchcancel', 'touchCancel', 'touchend', 'touchEnd', 'touchstart', 'touchStart', 'volumechange', 'volumeChange'];
var otherDiscreteEvents = ['change', 'selectionchange', 'textInput', 'compositionstart', 'compositionend', 'compositionupdate'];


var userBlockingPairsForSimpleEventPlugin = ['drag', 'drag', 'dragenter', 'dragEnter', 'dragexit', 'dragExit', 'dragleave', 'dragLeave', 'dragover', 'dragOver', 'mousemove', 'mouseMove', 'mouseout', 'mouseOut', 'mouseover', 'mouseOver', 'pointermove', 'pointerMove', 'pointerout', 'pointerOut', 'pointerover', 'pointerOver', 'scroll', 'scroll', 'toggle', 'toggle', 'touchmove', 'touchMove', 'wheel', 'wheel']; // prettier-ignore

var continuousPairsForSimpleEventPlugin = ['abort', 'abort', ANIMATION_END, 'animationEnd', ANIMATION_ITERATION, 'animationIteration', ANIMATION_START, 'animationStart', 'canplay', 'canPlay', 'canplaythrough', 'canPlayThrough', 'durationchange', 'durationChange', 'emptied', 'emptied', 'encrypted', 'encrypted', 'ended', 'ended', 'error', 'error', 'gotpointercapture', 'gotPointerCapture', 'load', 'load', 'loadeddata', 'loadedData', 'loadedmetadata', 'loadedMetadata', 'loadstart', 'loadStart', 'lostpointercapture', 'lostPointerCapture', 'playing', 'playing', 'progress', 'progress', 'seeking', 'seeking', 'stalled', 'stalled', 'suspend', 'suspend', 'timeupdate', 'timeUpdate', TRANSITION_END, 'transitionEnd', 'waiting', 'waiting'];
/**
 * Turns
 * ['abort', ...]
 *
 * into
 *
 * topLevelEventsToReactNames = new Map([
 *   ['abort', 'onAbort'],
 * ]);
 *
 * and registers them.
 */

function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
  // As the event types are in pairs of two, we need to iterate
  // through in twos. The events are in pairs of two to save code
  // and improve init perf of processing this array, as it will
  // result in far fewer object allocations and property accesses
  // if we only use three arrays to process all the categories of
  // instead of tuples.
  for (var i = 0; i < eventTypes.length; i += 2) {
    var topEvent = eventTypes[i];
    var event = eventTypes[i + 1];
    var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
    var reactName = 'on' + capitalizedEvent;
    eventPriorities.set(topEvent, priority);
    topLevelEventsToReactNames.set(topEvent, reactName);
    registerTwoPhaseEvent(reactName, [topEvent]);
  }
}

function setEventPriorities(eventTypes, priority) {
  for (var i = 0; i < eventTypes.length; i++) {
    eventPriorities.set(eventTypes[i], priority);
  }
}

function getEventPriorityForPluginSystem(domEventName) {
  var priority = eventPriorities.get(domEventName); // Default to a ContinuousEvent. Note: we might
  // want to warn if we can't detect the priority
  // for the event.

  return priority === undefined ? ContinuousEvent : priority;
}
function registerSimpleEvents() {
  registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
  registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
  registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
  setEventPriorities(otherDiscreteEvents, DiscreteEvent);
}

var Scheduler_now = Scheduler.unstable_now;

{
  // Provide explicit error message when production+profiling bundle of e.g.
  // react-dom is used with production (non-profiling) bundle of
  // scheduler/tracing
  if (!(tracing$1.__interactionsRef != null && tracing$1.__interactionsRef.current != null)) {
    {
      throw Error( "It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling" );
    }
  }
}
// ascending numbers so we can compare them like numbers. They start at 90 to
// avoid clashing with Scheduler's priorities.

var ImmediatePriority = 99;
var UserBlockingPriority = 98;
var NormalPriority = 97;
var LowPriority = 96;
var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.

var NoPriority = 90;
var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.

var SyncLanePriority = 15;
var SyncBatchedLanePriority = 14;
var InputDiscreteHydrationLanePriority = 13;
var InputDiscreteLanePriority = 12;
var InputContinuousHydrationLanePriority = 11;
var InputContinuousLanePriority = 10;
var DefaultHydrationLanePriority = 9;
var DefaultLanePriority = 8;
var TransitionHydrationPriority = 7;
var TransitionPriority = 6;
var RetryLanePriority = 5;
var SelectiveHydrationLanePriority = 4;
var IdleHydrationLanePriority = 3;
var IdleLanePriority = 2;
var OffscreenLanePriority = 1;
var NoLanePriority = 0;
var TotalLanes = 31;
var NoLanes =
/*                        */
0;
var NoLane =
/*                          */
0;
var SyncLane =
/*                        */
1;
var SyncBatchedLane =
/*                 */
2;
var InputDiscreteHydrationLane =
/*      */
4;
var InputDiscreteLanes =
/*                    */
24;
var InputContinuousHydrationLane =
/*           */
32;
var InputContinuousLanes =
/*                  */
192;
var DefaultHydrationLane =
/*            */
256;
var DefaultLanes =
/*                   */
3584;
var TransitionHydrationLane =
/*                */
4096;
var TransitionLanes =
/*                       */
4186112;
var RetryLanes =
/*                            */
62914560;
var SomeRetryLane =
/*                  */
33554432;
var SelectiveHydrationLane =
/*          */
67108864;
var NonIdleLanes =
/*                                 */
134217727;
var IdleHydrationLane =
/*               */
134217728;
var IdleLanes =
/*                             */
805306368;
var OffscreenLane =
/*                   */
1073741824;
var NoTimestamp = -1;
function setCurrentUpdateLanePriority(newLanePriority) {
} // "Registers" used to "return" multiple values
// Used by getHighestPriorityLanes and getNextLanes:

var return_highestLanePriority = DefaultLanePriority;

function getHighestPriorityLanes(lanes) {
  if ((SyncLane & lanes) !== NoLanes) {
    return_highestLanePriority = SyncLanePriority;
    return SyncLane;
  }

  if ((SyncBatchedLane & lanes) !== NoLanes) {
    return_highestLanePriority = SyncBatchedLanePriority;
    return SyncBatchedLane;
  }

  if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
    return_highestLanePriority = InputDiscreteHydrationLanePriority;
    return InputDiscreteHydrationLane;
  }

  var inputDiscreteLanes = InputDiscreteLanes & lanes;

  if (inputDiscreteLanes !== NoLanes) {
    return_highestLanePriority = InputDiscreteLanePriority;
    return inputDiscreteLanes;
  }

  if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
    return_highestLanePriority = InputContinuousHydrationLanePriority;
    return InputContinuousHydrationLane;
  }

  var inputContinuousLanes = InputContinuousLanes & lanes;

  if (inputContinuousLanes !== NoLanes) {
    return_highestLanePriority = InputContinuousLanePriority;
    return inputContinuousLanes;
  }

  if ((lanes & DefaultHydrationLane) !== NoLanes) {
    return_highestLanePriority = DefaultHydrationLanePriority;
    return DefaultHydrationLane;
  }

  var defaultLanes = DefaultLanes & lanes;

  if (defaultLanes !== NoLanes) {
    return_highestLanePriority = DefaultLanePriority;
    return defaultLanes;
  }

  if ((lanes & TransitionHydrationLane) !== NoLanes) {
    return_highestLanePriority = TransitionHydrationPriority;
    return TransitionHydrationLane;
  }

  var transitionLanes = TransitionLanes & lanes;

  if (transitionLanes !== NoLanes) {
    return_highestLanePriority = TransitionPriority;
    return transitionLanes;
  }

  var retryLanes = RetryLanes & lanes;

  if (retryLanes !== NoLanes) {
    return_highestLanePriority = RetryLanePriority;
    return retryLanes;
  }

  if (lanes & SelectiveHydrationLane) {
    return_highestLanePriority = SelectiveHydrationLanePriority;
    return SelectiveHydrationLane;
  }

  if ((lanes & IdleHydrationLane) !== NoLanes) {
    return_highestLanePriority = IdleHydrationLanePriority;
    return IdleHydrationLane;
  }

  var idleLanes = IdleLanes & lanes;

  if (idleLanes !== NoLanes) {
    return_highestLanePriority = IdleLanePriority;
    return idleLanes;
  }

  if ((OffscreenLane & lanes) !== NoLanes) {
    return_highestLanePriority = OffscreenLanePriority;
    return OffscreenLane;
  }

  {
    error('Should have found matching lanes. This is a bug in React.');
  } // This shouldn't be reachable, but as a fallback, return the entire bitmask.


  return_highestLanePriority = DefaultLanePriority;
  return lanes;
}

function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
  switch (schedulerPriorityLevel) {
    case ImmediatePriority:
      return SyncLanePriority;

    case UserBlockingPriority:
      return InputContinuousLanePriority;

    case NormalPriority:
    case LowPriority:
      // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
      return DefaultLanePriority;

    case IdlePriority:
      return IdleLanePriority;

    default:
      return NoLanePriority;
  }
}
function lanePriorityToSchedulerPriority(lanePriority) {
  switch (lanePriority) {
    case SyncLanePriority:
    case SyncBatchedLanePriority:
      return ImmediatePriority;

    case InputDiscreteHydrationLanePriority:
    case InputDiscreteLanePriority:
    case InputContinuousHydrationLanePriority:
    case InputContinuousLanePriority:
      return UserBlockingPriority;

    case DefaultHydrationLanePriority:
    case DefaultLanePriority:
    case TransitionHydrationPriority:
    case TransitionPriority:
    case SelectiveHydrationLanePriority:
    case RetryLanePriority:
      return NormalPriority;

    case IdleHydrationLanePriority:
    case IdleLanePriority:
    case OffscreenLanePriority:
      return IdlePriority;

    case NoLanePriority:
      return NoPriority;

    default:
      {
        {
          throw Error( "Invalid update priority: " + lanePriority + ". This is a bug in React." );
        }
      }

  }
}
function getNextLanes(root, wipLanes) {
  // Early bailout if there's no pending work left.
  var pendingLanes = root.pendingLanes;

  if (pendingLanes === NoLanes) {
    return_highestLanePriority = NoLanePriority;
    return NoLanes;
  }

  var nextLanes = NoLanes;
  var nextLanePriority = NoLanePriority;
  var expiredLanes = root.expiredLanes;
  var suspendedLanes = root.suspendedLanes;
  var pingedLanes = root.pingedLanes; // Check if any work has expired.

  if (expiredLanes !== NoLanes) {
    nextLanes = expiredLanes;
    nextLanePriority = return_highestLanePriority = SyncLanePriority;
  } else {
    // Do not work on any idle work until all the non-idle work has finished,
    // even if the work is suspended.
    var nonIdlePendingLanes = pendingLanes & NonIdleLanes;

    if (nonIdlePendingLanes !== NoLanes) {
      var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;

      if (nonIdleUnblockedLanes !== NoLanes) {
        nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
        nextLanePriority = return_highestLanePriority;
      } else {
        var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;

        if (nonIdlePingedLanes !== NoLanes) {
          nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
          nextLanePriority = return_highestLanePriority;
        }
      }
    } else {
      // The only remaining work is Idle.
      var unblockedLanes = pendingLanes & ~suspendedLanes;

      if (unblockedLanes !== NoLanes) {
        nextLanes = getHighestPriorityLanes(unblockedLanes);
        nextLanePriority = return_highestLanePriority;
      } else {
        if (pingedLanes !== NoLanes) {
          nextLanes = getHighestPriorityLanes(pingedLanes);
          nextLanePriority = return_highestLanePriority;
        }
      }
    }
  }

  if (nextLanes === NoLanes) {
    // This should only be reachable if we're suspended
    // TODO: Consider warning in this path if a fallback timer is not scheduled.
    return NoLanes;
  } // If there are higher priority lanes, we'll include them even if they
  // are suspended.


  nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes); // If we're already in the middle of a render, switching lanes will interrupt
  // it and we'll lose our progress. We should only do this if the new lanes are
  // higher priority.

  if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
  // bother waiting until the root is complete.
  (wipLanes & suspendedLanes) === NoLanes) {
    getHighestPriorityLanes(wipLanes);
    var wipLanePriority = return_highestLanePriority;

    if (nextLanePriority <= wipLanePriority) {
      return wipLanes;
    } else {
      return_highestLanePriority = nextLanePriority;
    }
  } // Check for entangled lanes and add them to the batch.
  //
  // A lane is said to be entangled with another when it's not allowed to render
  // in a batch that does not also include the other lane. Typically we do this
  // when multiple updates have the same source, and we only want to respond to
  // the most recent event from that source.
  //
  // Note that we apply entanglements *after* checking for partial work above.
  // This means that if a lane is entangled during an interleaved event while
  // it's already rendering, we won't interrupt it. This is intentional, since
  // entanglement is usually "best effort": we'll try our best to render the
  // lanes in the same batch, but it's not worth throwing out partially
  // completed work in order to do it.
  //
  // For those exceptions where entanglement is semantically important, like
  // useMutableSource, we should ensure that there is no partial work at the
  // time we apply the entanglement.


  var entangledLanes = root.entangledLanes;

  if (entangledLanes !== NoLanes) {
    var entanglements = root.entanglements;
    var lanes = nextLanes & entangledLanes;

    while (lanes > 0) {
      var index = pickArbitraryLaneIndex(lanes);
      var lane = 1 << index;
      nextLanes |= entanglements[index];
      lanes &= ~lane;
    }
  }

  return nextLanes;
}
function getMostRecentEventTime(root, lanes) {
  var eventTimes = root.eventTimes;
  var mostRecentEventTime = NoTimestamp;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    var eventTime = eventTimes[index];

    if (eventTime > mostRecentEventTime) {
      mostRecentEventTime = eventTime;
    }

    lanes &= ~lane;
  }

  return mostRecentEventTime;
}

function computeExpirationTime(lane, currentTime) {
  // TODO: Expiration heuristic is constant per lane, so could use a map.
  getHighestPriorityLanes(lane);
  var priority = return_highestLanePriority;

  if (priority >= InputContinuousLanePriority) {
    // User interactions should expire slightly more quickly.
    //
    // NOTE: This is set to the corresponding constant as in Scheduler.js. When
    // we made it larger, a product metric in www regressed, suggesting there's
    // a user interaction that's being starved by a series of synchronous
    // updates. If that theory is correct, the proper solution is to fix the
    // starvation. However, this scenario supports the idea that expiration
    // times are an important safeguard when starvation does happen.
    //
    // Also note that, in the case of user input specifically, this will soon no
    // longer be an issue because we plan to make user input synchronous by
    // default (until you enter `startTransition`, of course.)
    //
    // If weren't planning to make these updates synchronous soon anyway, I
    // would probably make this number a configurable parameter.
    return currentTime + 250;
  } else if (priority >= TransitionPriority) {
    return currentTime + 5000;
  } else {
    // Anything idle priority or lower should never expire.
    return NoTimestamp;
  }
}

function markStarvedLanesAsExpired(root, currentTime) {
  // TODO: This gets called every time we yield. We can optimize by storing
  // the earliest expiration time on the root. Then use that to quickly bail out
  // of this function.
  var pendingLanes = root.pendingLanes;
  var suspendedLanes = root.suspendedLanes;
  var pingedLanes = root.pingedLanes;
  var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
  // expiration time. If so, we'll assume the update is being starved and mark
  // it as expired to force it to finish.

  var lanes = pendingLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    var expirationTime = expirationTimes[index];

    if (expirationTime === NoTimestamp) {
      // Found a pending lane with no expiration time. If it's not suspended, or
      // if it's pinged, assume it's CPU-bound. Compute a new expiration time
      // using the current time.
      if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
        // Assumes timestamps are monotonically increasing.
        expirationTimes[index] = computeExpirationTime(lane, currentTime);
      }
    } else if (expirationTime <= currentTime) {
      // This lane expired
      root.expiredLanes |= lane;
    }

    lanes &= ~lane;
  }
} // This returns the highest priority pending lanes regardless of whether they
function getLanesToRetrySynchronouslyOnError(root) {
  var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;

  if (everythingButOffscreen !== NoLanes) {
    return everythingButOffscreen;
  }

  if (everythingButOffscreen & OffscreenLane) {
    return OffscreenLane;
  }

  return NoLanes;
}
function returnNextLanesPriority() {
  return return_highestLanePriority;
}
function includesNonIdleWork(lanes) {
  return (lanes & NonIdleLanes) !== NoLanes;
}
function includesOnlyRetries(lanes) {
  return (lanes & RetryLanes) === lanes;
}
function includesOnlyTransitions(lanes) {
  return (lanes & TransitionLanes) === lanes;
} // To ensure consistency across multiple updates in the same event, this should
// be a pure function, so that it always returns the same lane for given inputs.

function findUpdateLane(lanePriority, wipLanes) {
  switch (lanePriority) {
    case NoLanePriority:
      break;

    case SyncLanePriority:
      return SyncLane;

    case SyncBatchedLanePriority:
      return SyncBatchedLane;

    case InputDiscreteLanePriority:
      {
        var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);

        if (_lane === NoLane) {
          // Shift to the next priority level
          return findUpdateLane(InputContinuousLanePriority, wipLanes);
        }

        return _lane;
      }

    case InputContinuousLanePriority:
      {
        var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);

        if (_lane2 === NoLane) {
          // Shift to the next priority level
          return findUpdateLane(DefaultLanePriority, wipLanes);
        }

        return _lane2;
      }

    case DefaultLanePriority:
      {
        var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);

        if (_lane3 === NoLane) {
          // If all the default lanes are already being worked on, look for a
          // lane in the transition range.
          _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);

          if (_lane3 === NoLane) {
            // All the transition lanes are taken, too. This should be very
            // rare, but as a last resort, pick a default lane. This will have
            // the effect of interrupting the current work-in-progress render.
            _lane3 = pickArbitraryLane(DefaultLanes);
          }
        }

        return _lane3;
      }

    case TransitionPriority: // Should be handled by findTransitionLane instead

    case RetryLanePriority:
      // Should be handled by findRetryLane instead
      break;

    case IdleLanePriority:
      var lane = pickArbitraryLane(IdleLanes & ~wipLanes);

      if (lane === NoLane) {
        lane = pickArbitraryLane(IdleLanes);
      }

      return lane;
  }

  {
    {
      throw Error( "Invalid update priority: " + lanePriority + ". This is a bug in React." );
    }
  }
} // To ensure consistency across multiple updates in the same event, this should
// be pure function, so that it always returns the same lane for given inputs.

function findTransitionLane(wipLanes, pendingLanes) {
  // First look for lanes that are completely unclaimed, i.e. have no
  // pending work.
  var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);

  if (lane === NoLane) {
    // If all lanes have pending work, look for a lane that isn't currently
    // being worked on.
    lane = pickArbitraryLane(TransitionLanes & ~wipLanes);

    if (lane === NoLane) {
      // If everything is being worked on, pick any lane. This has the
      // effect of interrupting the current work-in-progress.
      lane = pickArbitraryLane(TransitionLanes);
    }
  }

  return lane;
} // To ensure consistency across multiple updates in the same event, this should
// be pure function, so that it always returns the same lane for given inputs.

function findRetryLane(wipLanes) {
  // This is a fork of `findUpdateLane` designed specifically for Suspense
  // "retries" — a special update that attempts to flip a Suspense boundary
  // from its placeholder state to its primary/resolved state.
  var lane = pickArbitraryLane(RetryLanes & ~wipLanes);

  if (lane === NoLane) {
    lane = pickArbitraryLane(RetryLanes);
  }

  return lane;
}

function getHighestPriorityLane(lanes) {
  return lanes & -lanes;
}

function getLowestPriorityLane(lanes) {
  // This finds the most significant non-zero bit.
  var index = 31 - clz32(lanes);
  return index < 0 ? NoLanes : 1 << index;
}

function getEqualOrHigherPriorityLanes(lanes) {
  return (getLowestPriorityLane(lanes) << 1) - 1;
}

function pickArbitraryLane(lanes) {
  // This wrapper function gets inlined. Only exists so to communicate that it
  // doesn't matter which bit is selected; you can pick any bit without
  // affecting the algorithms where its used. Here I'm using
  // getHighestPriorityLane because it requires the fewest operations.
  return getHighestPriorityLane(lanes);
}

function pickArbitraryLaneIndex(lanes) {
  return 31 - clz32(lanes);
}

function laneToIndex(lane) {
  return pickArbitraryLaneIndex(lane);
}

function includesSomeLane(a, b) {
  return (a & b) !== NoLanes;
}
function isSubsetOfLanes(set, subset) {
  return (set & subset) === subset;
}
function mergeLanes(a, b) {
  return a | b;
}
function removeLanes(set, subset) {
  return set & ~subset;
} // Seems redundant, but it changes the type from a single lane (used for
// updates) to a group of lanes (used for flushing work).

function laneToLanes(lane) {
  return lane;
}
function higherPriorityLane(a, b) {
  // This works because the bit ranges decrease in priority as you go left.
  return a !== NoLane && a < b ? a : b;
}
function createLaneMap(initial) {
  // Intentionally pushing one by one.
  // https://v8.dev/blog/elements-kinds#avoid-creating-holes
  var laneMap = [];

  for (var i = 0; i < TotalLanes; i++) {
    laneMap.push(initial);
  }

  return laneMap;
}
function markRootUpdated(root, updateLane, eventTime) {
  root.pendingLanes |= updateLane; // TODO: Theoretically, any update to any lane can unblock any other lane. But
  // it's not practical to try every single possible combination. We need a
  // heuristic to decide which lanes to attempt to render, and in which batches.
  // For now, we use the same heuristic as in the old ExpirationTimes model:
  // retry any lane at equal or lower priority, but don't try updates at higher
  // priority without also including the lower priority updates. This works well
  // when considering updates across different priority levels, but isn't
  // sufficient for updates within the same priority, since we want to treat
  // those updates as parallel.
  // Unsuspend any update at equal or lower priority.

  var higherPriorityLanes = updateLane - 1; // Turns 0b1000 into 0b0111

  root.suspendedLanes &= higherPriorityLanes;
  root.pingedLanes &= higherPriorityLanes;
  var eventTimes = root.eventTimes;
  var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
  // recent event, and we assume time is monotonically increasing.

  eventTimes[index] = eventTime;
}
function markRootSuspended(root, suspendedLanes) {
  root.suspendedLanes |= suspendedLanes;
  root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.

  var expirationTimes = root.expirationTimes;
  var lanes = suspendedLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    expirationTimes[index] = NoTimestamp;
    lanes &= ~lane;
  }
}
function markRootPinged(root, pingedLanes, eventTime) {
  root.pingedLanes |= root.suspendedLanes & pingedLanes;
}
function markDiscreteUpdatesExpired(root) {
  root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
}
function hasDiscreteLanes(lanes) {
  return (lanes & InputDiscreteLanes) !== NoLanes;
}
function markRootMutableRead(root, updateLane) {
  root.mutableReadLanes |= updateLane & root.pendingLanes;
}
function markRootFinished(root, remainingLanes) {
  var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
  root.pendingLanes = remainingLanes; // Let's try everything again

  root.suspendedLanes = 0;
  root.pingedLanes = 0;
  root.expiredLanes &= remainingLanes;
  root.mutableReadLanes &= remainingLanes;
  root.entangledLanes &= remainingLanes;
  var entanglements = root.entanglements;
  var eventTimes = root.eventTimes;
  var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work

  var lanes = noLongerPendingLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    entanglements[index] = NoLanes;
    eventTimes[index] = NoTimestamp;
    expirationTimes[index] = NoTimestamp;
    lanes &= ~lane;
  }
}
function markRootEntangled(root, entangledLanes) {
  root.entangledLanes |= entangledLanes;
  var entanglements = root.entanglements;
  var lanes = entangledLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    entanglements[index] |= entangledLanes;
    lanes &= ~lane;
  }
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros. Only used on lanes, so assume input is an integer.
// Based on:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32

var log = Math.log;
var LN2 = Math.LN2;

function clz32Fallback(lanes) {
  if (lanes === 0) {
    return 32;
  }

  return 31 - (log(lanes) / LN2 | 0) | 0;
}

// Intentionally not named imports because Rollup would use dynamic dispatch for
var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority,
    runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?

var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
// We'd like to remove this but it's not clear if this is safe.

function setEnabled(enabled) {
  _enabled = !!enabled;
}
function isEnabled() {
  return _enabled;
}
function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
  var eventPriority = getEventPriorityForPluginSystem(domEventName);
  var listenerWrapper;

  switch (eventPriority) {
    case DiscreteEvent:
      listenerWrapper = dispatchDiscreteEvent;
      break;

    case UserBlockingEvent:
      listenerWrapper = dispatchUserBlockingUpdate;
      break;

    case ContinuousEvent:
    default:
      listenerWrapper = dispatchEvent;
      break;
  }

  return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
}

function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
  {
    flushDiscreteUpdatesIfNeeded();
  }

  discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
}

function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
  {
    runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
  }
}

function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  if (!_enabled) {
    return;
  }

  var allowReplay = true;

  {
    // TODO: replaying capture phase events is currently broken
    // because we used to do it during top-level native bubble handlers
    // but now we use different bubble and capture handlers.
    // In eager mode, we attach capture listeners early, so we need
    // to filter them out until we fix the logic to handle them correctly.
    // This could've been outside the flag but I put it inside to reduce risk.
    allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
  }

  if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
    // If we already have a queue of discrete events, and this is another discrete
    // event, then we can't dispatch it regardless of its target, since they
    // need to dispatch in order.
    queueDiscreteEvent(null, // Flags that we're not actually blocked on anything as far as we know.
    domEventName, eventSystemFlags, targetContainer, nativeEvent);
    return;
  }

  var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);

  if (blockedOn === null) {
    // We successfully dispatched this event.
    if (allowReplay) {
      clearIfContinuousEvent(domEventName, nativeEvent);
    }

    return;
  }

  if (allowReplay) {
    if (isReplayableDiscreteEvent(domEventName)) {
      // This this to be replayed later once the target is available.
      queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
      return;
    }

    if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
      return;
    } // We need to clear only if we didn't queue because
    // queueing is accummulative.


    clearIfContinuousEvent(domEventName, nativeEvent);
  } // This is not replayable so we'll invoke it but without a target,
  // in case the event system needs to trace it.


  dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
} // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.

function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  // TODO: Warn if _enabled is false.
  var nativeEventTarget = getEventTarget(nativeEvent);
  var targetInst = getClosestInstanceFromNode(nativeEventTarget);

  if (targetInst !== null) {
    var nearestMounted = getNearestMountedFiber(targetInst);

    if (nearestMounted === null) {
      // This tree has been unmounted already. Dispatch without a target.
      targetInst = null;
    } else {
      var tag = nearestMounted.tag;

      if (tag === SuspenseComponent) {
        var instance = getSuspenseInstanceFromFiber(nearestMounted);

        if (instance !== null) {
          // Queue the event to be replayed later. Abort dispatching since we
          // don't want this event dispatched twice through the event system.
          // TODO: If this is the first discrete event in the queue. Schedule an increased
          // priority for this boundary.
          return instance;
        } // This shouldn't happen, something went wrong but to avoid blocking
        // the whole system, dispatch the event without a target.
        // TODO: Warn.


        targetInst = null;
      } else if (tag === HostRoot) {
        var root = nearestMounted.stateNode;

        if (root.hydrate) {
          // If this happens during a replay something went wrong and it might block
          // the whole system.
          return getContainerFromFiber(nearestMounted);
        }

        targetInst = null;
      } else if (nearestMounted !== targetInst) {
        // If we get an event (ex: img onload) before committing that
        // component's mount, ignore it for now (that is, treat it as if it was an
        // event on a non-React tree). We might also consider queueing events and
        // dispatching them after the mount.
        targetInst = null;
      }
    }
  }

  dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer); // We're not blocked on anything.

  return null;
}

function addEventBubbleListener(target, eventType, listener) {
  target.addEventListener(eventType, listener, false);
  return listener;
}
function addEventCaptureListener(target, eventType, listener) {
  target.addEventListener(eventType, listener, true);
  return listener;
}
function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
  target.addEventListener(eventType, listener, {
    capture: true,
    passive: passive
  });
  return listener;
}
function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
  target.addEventListener(eventType, listener, {
    passive: passive
  });
  return listener;
}

/**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */
var root = null;
var startText = null;
var fallbackText = null;
function initialize(nativeEventTarget) {
  root = nativeEventTarget;
  startText = getText();
  return true;
}
function reset() {
  root = null;
  startText = null;
  fallbackText = null;
}
function getData() {
  if (fallbackText) {
    return fallbackText;
  }

  var start;
  var startValue = startText;
  var startLength = startValue.length;
  var end;
  var endValue = getText();
  var endLength = endValue.length;

  for (start = 0; start < startLength; start++) {
    if (startValue[start] !== endValue[start]) {
      break;
    }
  }

  var minEnd = startLength - start;

  for (end = 1; end <= minEnd; end++) {
    if (startValue[startLength - end] !== endValue[endLength - end]) {
      break;
    }
  }

  var sliceTail = end > 1 ? 1 - end : undefined;
  fallbackText = endValue.slice(start, sliceTail);
  return fallbackText;
}
function getText() {
  if ('value' in root) {
    return root.value;
  }

  return root.textContent;
}

/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */
function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.

    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  } // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
  // report Enter as charCode 10 when ctrl is pressed.


  if (charCode === 10) {
    charCode = 13;
  } // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.


  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

function functionThatReturnsTrue() {
  return true;
}

function functionThatReturnsFalse() {
  return false;
} // This is intentionally a factory so that we have different returned constructors.
// If we had a single constructor, it would be megamorphic and engines would deopt.


function createSyntheticEvent(Interface) {
  /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */
  function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
    this._reactName = reactName;
    this._targetInst = targetInst;
    this.type = reactEventType;
    this.nativeEvent = nativeEvent;
    this.target = nativeEventTarget;
    this.currentTarget = null;

    for (var _propName in Interface) {
      if (!Interface.hasOwnProperty(_propName)) {
        continue;
      }

      var normalize = Interface[_propName];

      if (normalize) {
        this[_propName] = normalize(nativeEvent);
      } else {
        this[_propName] = nativeEvent[_propName];
      }
    }

    var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;

    if (defaultPrevented) {
      this.isDefaultPrevented = functionThatReturnsTrue;
    } else {
      this.isDefaultPrevented = functionThatReturnsFalse;
    }

    this.isPropagationStopped = functionThatReturnsFalse;
    return this;
  }

  _assign(SyntheticBaseEvent.prototype, {
    preventDefault: function () {
      this.defaultPrevented = true;
      var event = this.nativeEvent;

      if (!event) {
        return;
      }

      if (event.preventDefault) {
        event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
      } else if (typeof event.returnValue !== 'unknown') {
        event.returnValue = false;
      }

      this.isDefaultPrevented = functionThatReturnsTrue;
    },
    stopPropagation: function () {
      var event = this.nativeEvent;

      if (!event) {
        return;
      }

      if (event.stopPropagation) {
        event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
      } else if (typeof event.cancelBubble !== 'unknown') {
        // The ChangeEventPlugin registers a "propertychange" event for
        // IE. This event does not support bubbling or cancelling, and
        // any references to cancelBubble throw "Member not found".  A
        // typeof check of "unknown" circumvents this issue (and is also
        // IE specific).
        event.cancelBubble = true;
      }

      this.isPropagationStopped = functionThatReturnsTrue;
    },

    /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */
    persist: function () {// Modern event system doesn't use pooling.
    },

    /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */
    isPersistent: functionThatReturnsTrue
  });

  return SyntheticBaseEvent;
}
/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var EventInterface = {
  eventPhase: 0,
  bubbles: 0,
  cancelable: 0,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: 0,
  isTrusted: 0
};
var SyntheticEvent = createSyntheticEvent(EventInterface);

var UIEventInterface = _assign({}, EventInterface, {
  view: 0,
  detail: 0
});

var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
var lastMovementX;
var lastMovementY;
var lastMouseEvent;

function updateMouseMovementPolyfillState(event) {
  if (event !== lastMouseEvent) {
    if (lastMouseEvent && event.type === 'mousemove') {
      lastMovementX = event.screenX - lastMouseEvent.screenX;
      lastMovementY = event.screenY - lastMouseEvent.screenY;
    } else {
      lastMovementX = 0;
      lastMovementY = 0;
    }

    lastMouseEvent = event;
  }
}
/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var MouseEventInterface = _assign({}, UIEventInterface, {
  screenX: 0,
  screenY: 0,
  clientX: 0,
  clientY: 0,
  pageX: 0,
  pageY: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  getModifierState: getEventModifierState,
  button: 0,
  buttons: 0,
  relatedTarget: function (event) {
    if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
    return event.relatedTarget;
  },
  movementX: function (event) {
    if ('movementX' in event) {
      return event.movementX;
    }

    updateMouseMovementPolyfillState(event);
    return lastMovementX;
  },
  movementY: function (event) {
    if ('movementY' in event) {
      return event.movementY;
    } // Don't need to call updateMouseMovementPolyfillState() here
    // because it's guaranteed to have already run when movementX
    // was copied.


    return lastMovementY;
  }
});

var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var DragEventInterface = _assign({}, MouseEventInterface, {
  dataTransfer: 0
});

var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var FocusEventInterface = _assign({}, UIEventInterface, {
  relatedTarget: 0
});

var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */

var AnimationEventInterface = _assign({}, EventInterface, {
  animationName: 0,
  elapsedTime: 0,
  pseudoElement: 0
});

var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */

var ClipboardEventInterface = _assign({}, EventInterface, {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
});

var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */

var CompositionEventInterface = _assign({}, EventInterface, {
  data: 0
});

var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
// Happens to share the same list for now.

var SyntheticInputEvent = SyntheticCompositionEvent;
/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */

var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};
/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */

var translateToKey = {
  '8': 'Backspace',
  '9': 'Tab',
  '12': 'Clear',
  '13': 'Enter',
  '16': 'Shift',
  '17': 'Control',
  '18': 'Alt',
  '19': 'Pause',
  '20': 'CapsLock',
  '27': 'Escape',
  '32': ' ',
  '33': 'PageUp',
  '34': 'PageDown',
  '35': 'End',
  '36': 'Home',
  '37': 'ArrowLeft',
  '38': 'ArrowUp',
  '39': 'ArrowRight',
  '40': 'ArrowDown',
  '45': 'Insert',
  '46': 'Delete',
  '112': 'F1',
  '113': 'F2',
  '114': 'F3',
  '115': 'F4',
  '116': 'F5',
  '117': 'F6',
  '118': 'F7',
  '119': 'F8',
  '120': 'F9',
  '121': 'F10',
  '122': 'F11',
  '123': 'F12',
  '144': 'NumLock',
  '145': 'ScrollLock',
  '224': 'Meta'
};
/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */

function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.
    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;

    if (key !== 'Unidentified') {
      return key;
    }
  } // Browser does not implement `key`, polyfill as much of it as we can.


  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.

    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }

  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }

  return '';
}
/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */


var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
}; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
// getModifierState. If getModifierState is not supported, we map it to a set of
// modifier keys exposed by the event. In this case, Lock-keys are not supported.

function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;

  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }

  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}
/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var KeyboardEventInterface = _assign({}, UIEventInterface, {
  key: getEventKey,
  code: 0,
  location: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  repeat: 0,
  locale: 0,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.
    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }

    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.
    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }

    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }

    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }

    return 0;
  }
});

var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
/**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */

var PointerEventInterface = _assign({}, MouseEventInterface, {
  pointerId: 0,
  width: 0,
  height: 0,
  pressure: 0,
  tangentialPressure: 0,
  tiltX: 0,
  tiltY: 0,
  twist: 0,
  pointerType: 0,
  isPrimary: 0
});

var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */

var TouchEventInterface = _assign({}, UIEventInterface, {
  touches: 0,
  targetTouches: 0,
  changedTouches: 0,
  altKey: 0,
  metaKey: 0,
  ctrlKey: 0,
  shiftKey: 0,
  getModifierState: getEventModifierState
});

var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */

var TransitionEventInterface = _assign({}, EventInterface, {
  propertyName: 0,
  elapsedTime: 0,
  pseudoElement: 0
});

var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var WheelEventInterface = _assign({}, MouseEventInterface, {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: 0,
  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: 0
});

var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space

var START_KEYCODE = 229;
var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
var documentMode = null;

if (canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
} // Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.


var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.

var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

function registerEvents() {
  registerTwoPhaseEvent('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
  registerTwoPhaseEvent('onCompositionEnd', ['compositionend', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
  registerTwoPhaseEvent('onCompositionStart', ['compositionstart', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
  registerTwoPhaseEvent('onCompositionUpdate', ['compositionupdate', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
} // Track whether we've ever handled a keypress on the space key.


var hasSpaceKeypress = false;
/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */

function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}
/**
 * Translate native top level events into event types.
 */


function getCompositionEventType(domEventName) {
  switch (domEventName) {
    case 'compositionstart':
      return 'onCompositionStart';

    case 'compositionend':
      return 'onCompositionEnd';

    case 'compositionupdate':
      return 'onCompositionUpdate';
  }
}
/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */


function isFallbackCompositionStart(domEventName, nativeEvent) {
  return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
}
/**
 * Does our fallback mode think that this event is the end of composition?
 */


function isFallbackCompositionEnd(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'keyup':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;

    case 'keydown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;

    case 'keypress':
    case 'mousedown':
    case 'focusout':
      // Events are not possible without cancelling IME.
      return true;

    default:
      return false;
  }
}
/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */


function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;

  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }

  return null;
}
/**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */


function isUsingKoreanIME(nativeEvent) {
  return nativeEvent.locale === 'ko';
} // Track the current IME composition status, if any.


var isComposing = false;
/**
 * @return {?object} A SyntheticCompositionEvent.
 */

function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(domEventName);
  } else if (!isComposing) {
    if (isFallbackCompositionStart(domEventName, nativeEvent)) {
      eventType = 'onCompositionStart';
    }
  } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) {
    eventType = 'onCompositionEnd';
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!isComposing && eventType === 'onCompositionStart') {
      isComposing = initialize(nativeEventTarget);
    } else if (eventType === 'onCompositionEnd') {
      if (isComposing) {
        fallbackData = getData();
      }
    }
  }

  var listeners = accumulateTwoPhaseListeners(targetInst, eventType);

  if (listeners.length > 0) {
    var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });

    if (fallbackData) {
      // Inject data generated from fallback path into the synthetic event.
      // This matches the property of native CompositionEventInterface.
      event.data = fallbackData;
    } else {
      var customData = getDataFromCustomEvent(nativeEvent);

      if (customData !== null) {
        event.data = customData;
      }
    }
  }
}

function getNativeBeforeInputChars(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'compositionend':
      return getDataFromCustomEvent(nativeEvent);

    case 'keypress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;

      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'textInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to ignore it.

      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}
/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */


function getFallbackBeforeInputChars(domEventName, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (isComposing) {
    if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
      var chars = getData();
      reset();
      isComposing = false;
      return chars;
    }

    return null;
  }

  switch (domEventName) {
    case 'paste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;

    case 'keypress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (!isKeypressCommand(nativeEvent)) {
        // IE fires the `keypress` event when a user types an emoji via
        // Touch keyboard of Windows.  In such a case, the `char` property
        // holds an emoji character like `\uD83D\uDE0A`.  Because its length
        // is 2, the property `which` does not represent an emoji correctly.
        // In such a case, we directly return the `char` property instead of
        // using `which`.
        if (nativeEvent.char && nativeEvent.char.length > 1) {
          return nativeEvent.char;
        } else if (nativeEvent.which) {
          return String.fromCharCode(nativeEvent.which);
        }
      }

      return null;

    case 'compositionend':
      return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;

    default:
      return null;
  }
}
/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */


function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(domEventName, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
  } // If no characters are being inserted, no BeforeInput event should
  // be fired.


  if (!chars) {
    return null;
  }

  var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');

  if (listeners.length > 0) {
    var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
    event.data = chars;
  }
}
/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */


function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
  extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
}

/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */
var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */

function isEventSupported(eventNameSuffix) {
  if (!canUseDOM) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = (eventName in document);

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  return isSupported;
}

function registerEvents$1() {
  registerTwoPhaseEvent('onChange', ['change', 'click', 'focusin', 'focusout', 'input', 'keydown', 'keyup', 'selectionchange']);
}

function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
  // Flag this event loop as needing state restore.
  enqueueStateRestore(target);
  var listeners = accumulateTwoPhaseListeners(inst, 'onChange');

  if (listeners.length > 0) {
    var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
  }
}
/**
 * For IE shims
 */


var activeElement = null;
var activeElementInst = null;
/**
 * SECTION: handle `change` event
 */

function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

function manualDispatchChangeEvent(nativeEvent) {
  var dispatchQueue = [];
  createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.

  batchedUpdates(runEventInBatch, dispatchQueue);
}

function runEventInBatch(dispatchQueue) {
  processDispatchQueue(dispatchQueue, 0);
}

function getInstIfValueChanged(targetInst) {
  var targetNode = getNodeFromInstance(targetInst);

  if (updateValueIfChanged(targetNode)) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(domEventName, targetInst) {
  if (domEventName === 'change') {
    return targetInst;
  }
}
/**
 * SECTION: handle `input` event
 */


var isInputEventSupported = false;

if (canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}
/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */


function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}
/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */


function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  activeElement.detachEvent('onpropertychange', handlePropertyChange);
  activeElement = null;
  activeElementInst = null;
}
/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */


function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }

  if (getInstIfValueChanged(activeElementInst)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
  if (domEventName === 'focusin') {
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (domEventName === 'focusout') {
    stopWatchingForValueChange();
  }
} // For IE8 and IE9.


function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
  if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst);
  }
}
/**
 * SECTION: handle `click` event
 */


function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(domEventName, targetInst) {
  if (domEventName === 'click') {
    return getInstIfValueChanged(targetInst);
  }
}

function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
  if (domEventName === 'input' || domEventName === 'change') {
    return getInstIfValueChanged(targetInst);
  }
}

function handleControlledInputBlur(node) {
  var state = node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  {
    // If controlled, assign the value attribute to the current value on blur
    setDefaultValue(node, 'number', node.value);
  }
}
/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */


function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
  var getTargetInstFunc, handleEventFunc;

  if (shouldUseChangeEvent(targetNode)) {
    getTargetInstFunc = getTargetInstForChangeEvent;
  } else if (isTextInputElement(targetNode)) {
    if (isInputEventSupported) {
      getTargetInstFunc = getTargetInstForInputOrChangeEvent;
    } else {
      getTargetInstFunc = getTargetInstForInputEventPolyfill;
      handleEventFunc = handleEventsForInputEventPolyfill;
    }
  } else if (shouldUseClickEvent(targetNode)) {
    getTargetInstFunc = getTargetInstForClickEvent;
  }

  if (getTargetInstFunc) {
    var inst = getTargetInstFunc(domEventName, targetInst);

    if (inst) {
      createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
      return;
    }
  }

  if (handleEventFunc) {
    handleEventFunc(domEventName, targetNode, targetInst);
  } // When blurring, set the value attribute for number inputs


  if (domEventName === 'focusout') {
    handleControlledInputBlur(targetNode);
  }
}

function registerEvents$2() {
  registerDirectEvent('onMouseEnter', ['mouseout', 'mouseover']);
  registerDirectEvent('onMouseLeave', ['mouseout', 'mouseover']);
  registerDirectEvent('onPointerEnter', ['pointerout', 'pointerover']);
  registerDirectEvent('onPointerLeave', ['pointerout', 'pointerover']);
}
/**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */


function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
  var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';

  if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
    // If this is an over event with a target, we might have already dispatched
    // the event in the out event of the other target. If this is replayed,
    // then it's because we couldn't dispatch against this target previously
    // so we have to do it now instead.
    var related = nativeEvent.relatedTarget || nativeEvent.fromElement;

    if (related) {
      // If the related node is managed by React, we can assume that we have
      // already dispatched the corresponding events during its mouseout.
      if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) {
        return;
      }
    }
  }

  if (!isOutEvent && !isOverEvent) {
    // Must not be a mouse or pointer in or out - ignoring.
    return;
  }

  var win; // TODO: why is this nullable in the types but we read from it?

  if (nativeEventTarget.window === nativeEventTarget) {
    // `nativeEventTarget` is probably a window object.
    win = nativeEventTarget;
  } else {
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    var doc = nativeEventTarget.ownerDocument;

    if (doc) {
      win = doc.defaultView || doc.parentWindow;
    } else {
      win = window;
    }
  }

  var from;
  var to;

  if (isOutEvent) {
    var _related = nativeEvent.relatedTarget || nativeEvent.toElement;

    from = targetInst;
    to = _related ? getClosestInstanceFromNode(_related) : null;

    if (to !== null) {
      var nearestMounted = getNearestMountedFiber(to);

      if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
        to = null;
      }
    }
  } else {
    // Moving to a node from outside the window.
    from = null;
    to = targetInst;
  }

  if (from === to) {
    // Nothing pertains to our managed components.
    return;
  }

  var SyntheticEventCtor = SyntheticMouseEvent;
  var leaveEventType = 'onMouseLeave';
  var enterEventType = 'onMouseEnter';
  var eventTypePrefix = 'mouse';

  if (domEventName === 'pointerout' || domEventName === 'pointerover') {
    SyntheticEventCtor = SyntheticPointerEvent;
    leaveEventType = 'onPointerLeave';
    enterEventType = 'onPointerEnter';
    eventTypePrefix = 'pointer';
  }

  var fromNode = from == null ? win : getNodeFromInstance(from);
  var toNode = to == null ? win : getNodeFromInstance(to);
  var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
  leave.target = fromNode;
  leave.relatedTarget = toNode;
  var enter = null; // We should only process this nativeEvent if we are processing
  // the first ancestor. Next time, we will ignore the event.

  var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);

  if (nativeTargetInst === targetInst) {
    var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
    enterEvent.target = toNode;
    enterEvent.relatedTarget = fromNode;
    enter = enterEvent;
  }

  accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
}

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

var objectIs = typeof Object.is === 'function' ? Object.is : is;

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */

function shallowEqual(objA, objB) {
  if (objectIs(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }

  return node;
}
/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */


function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }

    node = node.parentNode;
  }
}
/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */


function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === TEXT_NODE) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

/**
 * @param {DOMElement} outerNode
 * @return {?object}
 */

function getOffsets(outerNode) {
  var ownerDocument = outerNode.ownerDocument;
  var win = ownerDocument && ownerDocument.defaultView || window;
  var selection = win.getSelection && win.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset,
      focusNode = selection.focusNode,
      focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
  // up/down buttons on an <input type="number">. Anonymous divs do not seem to
  // expose properties, triggering a "Permission denied error" if any of its
  // properties are accessed. The only seemingly possible way to avoid erroring
  // is to access a property that typically works for non-anonymous divs and
  // catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427

  try {
    /* eslint-disable no-unused-expressions */
    anchorNode.nodeType;
    focusNode.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
}
/**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */

function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
  var length = 0;
  var start = -1;
  var end = -1;
  var indexWithinAnchor = 0;
  var indexWithinFocus = 0;
  var node = outerNode;
  var parentNode = null;

  outer: while (true) {
    var next = null;

    while (true) {
      if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
        start = length + anchorOffset;
      }

      if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
        end = length + focusOffset;
      }

      if (node.nodeType === TEXT_NODE) {
        length += node.nodeValue.length;
      }

      if ((next = node.firstChild) === null) {
        break;
      } // Moving from `node` to its first child `next`.


      parentNode = node;
      node = next;
    }

    while (true) {
      if (node === outerNode) {
        // If `outerNode` has children, this is always the second time visiting
        // it. If it has no children, this is still the first loop, and the only
        // valid selection is anchorNode and focusNode both equal to this node
        // and both offsets 0, in which case we will have handled above.
        break outer;
      }

      if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
        start = length;
      }

      if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
        end = length;
      }

      if ((next = node.nextSibling) !== null) {
        break;
      }

      node = parentNode;
      parentNode = node.parentNode;
    } // Moving from `node` to its next sibling `next`.


    node = next;
  }

  if (start === -1 || end === -1) {
    // This should never happen. (Would happen if the anchor/focus nodes aren't
    // actually inside the passed-in node.)
    return null;
  }

  return {
    start: start,
    end: end
  };
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */

function setOffsets(node, offsets) {
  var doc = node.ownerDocument || document;
  var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
  // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
  // fails when pasting 100+ items)

  if (!win.getSelection) {
    return;
  }

  var selection = win.getSelection();
  var length = node.textContent.length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.

  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
      return;
    }

    var range = doc.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

function isTextNode(node) {
  return node && node.nodeType === TEXT_NODE;
}

function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

function isInDocument(node) {
  return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
}

function isSameOriginFrame(iframe) {
  try {
    // Accessing the contentDocument of a HTMLIframeElement can cause the browser
    // to throw, e.g. if it has a cross-origin src attribute.
    // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
    // iframe.contentDocument.defaultView;
    // A safety way is to access one of the cross origin properties: Window or Location
    // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
    // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
    return typeof iframe.contentWindow.location.href === 'string';
  } catch (err) {
    return false;
  }
}

function getActiveElementDeep() {
  var win = window;
  var element = getActiveElement();

  while (element instanceof win.HTMLIFrameElement) {
    if (isSameOriginFrame(element)) {
      win = element.contentWindow;
    } else {
      return element;
    }

    element = getActiveElement(win.document);
  }

  return element;
}
/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */

/**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */


function hasSelectionCapabilities(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
}
function getSelectionInformation() {
  var focusedElem = getActiveElementDeep();
  return {
    focusedElem: focusedElem,
    selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
  };
}
/**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */

function restoreSelection(priorSelectionInformation) {
  var curFocusedElem = getActiveElementDeep();
  var priorFocusedElem = priorSelectionInformation.focusedElem;
  var priorSelectionRange = priorSelectionInformation.selectionRange;

  if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
    if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
      setSelection(priorFocusedElem, priorSelectionRange);
    } // Focusing a node can change the scroll position, which is undesirable


    var ancestors = [];
    var ancestor = priorFocusedElem;

    while (ancestor = ancestor.parentNode) {
      if (ancestor.nodeType === ELEMENT_NODE) {
        ancestors.push({
          element: ancestor,
          left: ancestor.scrollLeft,
          top: ancestor.scrollTop
        });
      }
    }

    if (typeof priorFocusedElem.focus === 'function') {
      priorFocusedElem.focus();
    }

    for (var i = 0; i < ancestors.length; i++) {
      var info = ancestors[i];
      info.element.scrollLeft = info.left;
      info.element.scrollTop = info.top;
    }
  }
}
/**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */

function getSelection(input) {
  var selection;

  if ('selectionStart' in input) {
    // Modern browser with input or textarea.
    selection = {
      start: input.selectionStart,
      end: input.selectionEnd
    };
  } else {
    // Content editable or old IE textarea.
    selection = getOffsets(input);
  }

  return selection || {
    start: 0,
    end: 0
  };
}
/**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */

function setSelection(input, offsets) {
  var start = offsets.start;
  var end = offsets.end;

  if (end === undefined) {
    end = start;
  }

  if ('selectionStart' in input) {
    input.selectionStart = start;
    input.selectionEnd = Math.min(end, input.value.length);
  } else {
    setOffsets(input, offsets);
  }
}

var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;

function registerEvents$3() {
  registerTwoPhaseEvent('onSelect', ['focusout', 'contextmenu', 'dragend', 'focusin', 'keydown', 'keyup', 'mousedown', 'mouseup', 'selectionchange']);
}

var activeElement$1 = null;
var activeElementInst$1 = null;
var lastSelection = null;
var mouseDown = false;
/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */

function getSelection$1(node) {
  if ('selectionStart' in node && hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else {
    var win = node.ownerDocument && node.ownerDocument.defaultView || window;
    var selection = win.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  }
}
/**
 * Get document associated with the event target.
 */


function getEventTargetDocument(eventTarget) {
  return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
}
/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */


function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  var doc = getEventTargetDocument(nativeEventTarget);

  if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
    return;
  } // Only fire when selection has actually changed.


  var currentSelection = getSelection$1(activeElement$1);

  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;
    var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');

    if (listeners.length > 0) {
      var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
      dispatchQueue.push({
        event: event,
        listeners: listeners
      });
      event.target = activeElement$1;
    }
  }
}
/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */


function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {

  var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;

  switch (domEventName) {
    // Track the input node that has focus.
    case 'focusin':
      if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
        activeElement$1 = targetNode;
        activeElementInst$1 = targetInst;
        lastSelection = null;
      }

      break;

    case 'focusout':
      activeElement$1 = null;
      activeElementInst$1 = null;
      lastSelection = null;
      break;
    // Don't fire the event while the user is dragging. This matches the
    // semantics of the native select event.

    case 'mousedown':
      mouseDown = true;
      break;

    case 'contextmenu':
    case 'mouseup':
    case 'dragend':
      mouseDown = false;
      constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
      break;
    // Chrome and IE fire non-standard event when selection is changed (and
    // sometimes when it hasn't). IE's event fires out of order with respect
    // to key and input events on deletion, so we discard it.
    //
    // Firefox doesn't support selectionchange, so check selection status
    // after each key entry. The selection changes after keydown and before
    // keyup, but we check on keydown as well in the case of holding down a
    // key, when multiple keydown events are fired but only one keyup is.
    // This is also our approach for IE handling, for the reason above.

    case 'selectionchange':
      if (skipSelectionChangeEvent) {
        break;
      }

    // falls through

    case 'keydown':
    case 'keyup':
      constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
  }
}

function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var reactName = topLevelEventsToReactNames.get(domEventName);

  if (reactName === undefined) {
    return;
  }

  var SyntheticEventCtor = SyntheticEvent;
  var reactEventType = domEventName;

  switch (domEventName) {
    case 'keypress':
      // Firefox creates a keypress event for function keys too. This removes
      // the unwanted keypress events. Enter is however both printable and
      // non-printable. One would expect Tab to be as well (but it isn't).
      if (getEventCharCode(nativeEvent) === 0) {
        return;
      }

    /* falls through */

    case 'keydown':
    case 'keyup':
      SyntheticEventCtor = SyntheticKeyboardEvent;
      break;

    case 'focusin':
      reactEventType = 'focus';
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'focusout':
      reactEventType = 'blur';
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'beforeblur':
    case 'afterblur':
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'click':
      // Firefox creates a click event on right mouse clicks. This removes the
      // unwanted click events.
      if (nativeEvent.button === 2) {
        return;
      }

    /* falls through */

    case 'auxclick':
    case 'dblclick':
    case 'mousedown':
    case 'mousemove':
    case 'mouseup': // TODO: Disabled elements should not respond to mouse events

    /* falls through */

    case 'mouseout':
    case 'mouseover':
    case 'contextmenu':
      SyntheticEventCtor = SyntheticMouseEvent;
      break;

    case 'drag':
    case 'dragend':
    case 'dragenter':
    case 'dragexit':
    case 'dragleave':
    case 'dragover':
    case 'dragstart':
    case 'drop':
      SyntheticEventCtor = SyntheticDragEvent;
      break;

    case 'touchcancel':
    case 'touchend':
    case 'touchmove':
    case 'touchstart':
      SyntheticEventCtor = SyntheticTouchEvent;
      break;

    case ANIMATION_END:
    case ANIMATION_ITERATION:
    case ANIMATION_START:
      SyntheticEventCtor = SyntheticAnimationEvent;
      break;

    case TRANSITION_END:
      SyntheticEventCtor = SyntheticTransitionEvent;
      break;

    case 'scroll':
      SyntheticEventCtor = SyntheticUIEvent;
      break;

    case 'wheel':
      SyntheticEventCtor = SyntheticWheelEvent;
      break;

    case 'copy':
    case 'cut':
    case 'paste':
      SyntheticEventCtor = SyntheticClipboardEvent;
      break;

    case 'gotpointercapture':
    case 'lostpointercapture':
    case 'pointercancel':
    case 'pointerdown':
    case 'pointermove':
    case 'pointerout':
    case 'pointerover':
    case 'pointerup':
      SyntheticEventCtor = SyntheticPointerEvent;
      break;
  }

  var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

  {
    // Some events don't bubble in the browser.
    // In the past, React has always bubbled them, but this can be surprising.
    // We're going to try aligning closer to the browser behavior by not bubbling
    // them in React either. We'll start by not bubbling onScroll, and then expand.
    var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
    // nonDelegatedEvents list in DOMPluginEventSystem.
    // Then we can remove this special list.
    // This is a breaking change that can wait until React 18.
    domEventName === 'scroll';

    var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);

    if (_listeners.length > 0) {
      // Intentionally create event lazily.
      var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);

      dispatchQueue.push({
        event: _event,
        listeners: _listeners
      });
    }
  }
}

// TODO: remove top-level side effect.
registerSimpleEvents();
registerEvents$2();
registerEvents$1();
registerEvents$3();
registerEvents();

function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  // TODO: we should remove the concept of a "SimpleEventPlugin".
  // This is the basic functionality of the event system. All
  // the other plugins are essentially polyfills. So the plugin
  // should probably be inlined somewhere and have its logic
  // be core the to event system. This would potentially allow
  // us to ship builds of React without the polyfilled plugins below.
  extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
  var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
  // event's native "bubble" phase, which means that we're
  // not in the capture phase. That's because we emulate
  // the capture phase here still. This is a trade-off,
  // because in an ideal world we would not emulate and use
  // the phases properly, like we do with the SimpleEvent
  // plugin. However, the plugins below either expect
  // emulation (EnterLeave) or use state localized to that
  // plugin (BeforeInput, Change, Select). The state in
  // these modules complicates things, as you'll essentially
  // get the case where the capture phase event might change
  // state, only for the following bubble event to come in
  // later and not trigger anything as the state now
  // invalidates the heuristics of the event plugin. We
  // could alter all these plugins to work in such ways, but
  // that might cause other unknown side-effects that we
  // can't forsee right now.

  if (shouldProcessPolyfillPlugins) {
    extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
    extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
  }
} // List of events that need to be individually attached to media elements.


var mediaEventTypes = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'encrypted', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting']; // We should not delegate these events to the container, but rather
// set them on the actual target element itself. This is primarily
// because these events do not consistently bubble in the DOM.

var nonDelegatedEvents = new Set(['cancel', 'close', 'invalid', 'load', 'scroll', 'toggle'].concat(mediaEventTypes));

function executeDispatch(event, listener, currentTarget) {
  var type = event.type || 'unknown-event';
  event.currentTarget = currentTarget;
  invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
  event.currentTarget = null;
}

function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
  var previousInstance;

  if (inCapturePhase) {
    for (var i = dispatchListeners.length - 1; i >= 0; i--) {
      var _dispatchListeners$i = dispatchListeners[i],
          instance = _dispatchListeners$i.instance,
          currentTarget = _dispatchListeners$i.currentTarget,
          listener = _dispatchListeners$i.listener;

      if (instance !== previousInstance && event.isPropagationStopped()) {
        return;
      }

      executeDispatch(event, listener, currentTarget);
      previousInstance = instance;
    }
  } else {
    for (var _i = 0; _i < dispatchListeners.length; _i++) {
      var _dispatchListeners$_i = dispatchListeners[_i],
          _instance = _dispatchListeners$_i.instance,
          _currentTarget = _dispatchListeners$_i.currentTarget,
          _listener = _dispatchListeners$_i.listener;

      if (_instance !== previousInstance && event.isPropagationStopped()) {
        return;
      }

      executeDispatch(event, _listener, _currentTarget);
      previousInstance = _instance;
    }
  }
}

function processDispatchQueue(dispatchQueue, eventSystemFlags) {
  var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

  for (var i = 0; i < dispatchQueue.length; i++) {
    var _dispatchQueue$i = dispatchQueue[i],
        event = _dispatchQueue$i.event,
        listeners = _dispatchQueue$i.listeners;
    processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
  } // This would be a good time to rethrow if any of the event handlers threw.


  rethrowCaughtError();
}

function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
  var nativeEventTarget = getEventTarget(nativeEvent);
  var dispatchQueue = [];
  extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
  processDispatchQueue(dispatchQueue, eventSystemFlags);
}

function listenToNonDelegatedEvent(domEventName, targetElement) {
  var isCapturePhaseListener = false;
  var listenerSet = getEventListenerSet(targetElement);
  var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);

  if (!listenerSet.has(listenerSetKey)) {
    addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
    listenerSet.add(listenerSetKey);
  }
}
var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
  {
    if (rootContainerElement[listeningMarker]) {
      // Performance optimization: don't iterate through events
      // for the same portal container or root node more than once.
      // TODO: once we remove the flag, we may be able to also
      // remove some of the bookkeeping maps used for laziness.
      return;
    }

    rootContainerElement[listeningMarker] = true;
    allNativeEvents.forEach(function (domEventName) {
      if (!nonDelegatedEvents.has(domEventName)) {
        listenToNativeEvent(domEventName, false, rootContainerElement, null);
      }

      listenToNativeEvent(domEventName, true, rootContainerElement, null);
    });
  }
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
  var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var target = rootContainerElement; // selectionchange needs to be attached to the document
  // otherwise it won't capture incoming events that are only
  // triggered on the document directly.

  if (domEventName === 'selectionchange' && rootContainerElement.nodeType !== DOCUMENT_NODE) {
    target = rootContainerElement.ownerDocument;
  } // If the event can be delegated (or is capture phase), we can
  // register it to the root container. Otherwise, we should
  // register the event to the target element and mark it as
  // a non-delegated event.


  if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
    // For all non-delegated events, apart from scroll, we attach
    // their event listeners to the respective elements that their
    // events fire on. That means we can skip this step, as event
    // listener has already been added previously. However, we
    // special case the scroll event because the reality is that any
    // element can scroll.
    // TODO: ideally, we'd eventually apply the same logic to all
    // events from the nonDelegatedEvents list. Then we can remove
    // this special case and use the same logic for all events.
    if (domEventName !== 'scroll') {
      return;
    }

    eventSystemFlags |= IS_NON_DELEGATED;
    target = targetElement;
  }

  var listenerSet = getEventListenerSet(target);
  var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener); // If the listener entry is empty or we should upgrade, then
  // we need to trap an event listener onto the target.

  if (!listenerSet.has(listenerSetKey)) {
    if (isCapturePhaseListener) {
      eventSystemFlags |= IS_CAPTURE_PHASE;
    }

    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    listenerSet.add(listenerSetKey);
  }
}

function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
  var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
  // active and not passive.

  var isPassiveListener = undefined;

  if (passiveBrowserEventsSupported) {
    // Browsers introduced an intervention, making these events
    // passive by default on document. React doesn't bind them
    // to document anymore, but changing this now would undo
    // the performance wins from the change. So we emulate
    // the existing behavior manually on the roots now.
    // https://github.com/facebook/react/issues/19651
    if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') {
      isPassiveListener = true;
    }
  }

  targetContainer =  targetContainer;
  var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we


  if (isCapturePhaseListener) {
    if (isPassiveListener !== undefined) {
      unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
    } else {
      unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
    }
  } else {
    if (isPassiveListener !== undefined) {
      unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
    } else {
      unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
  }
}

function isMatchingRootContainer(grandContainer, targetContainer) {
  return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
}

function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
  var ancestorInst = targetInst;

  if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
    var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we

    if (targetInst !== null) {
      // The below logic attempts to work out if we need to change
      // the target fiber to a different ancestor. We had similar logic
      // in the legacy event system, except the big difference between
      // systems is that the modern event system now has an event listener
      // attached to each React Root and React Portal Root. Together,
      // the DOM nodes representing these roots are the "rootContainer".
      // To figure out which ancestor instance we should use, we traverse
      // up the fiber tree from the target instance and attempt to find
      // root boundaries that match that of our current "rootContainer".
      // If we find that "rootContainer", we find the parent fiber
      // sub-tree for that root and make that our ancestor instance.
      var node = targetInst;

      mainLoop: while (true) {
        if (node === null) {
          return;
        }

        var nodeTag = node.tag;

        if (nodeTag === HostRoot || nodeTag === HostPortal) {
          var container = node.stateNode.containerInfo;

          if (isMatchingRootContainer(container, targetContainerNode)) {
            break;
          }

          if (nodeTag === HostPortal) {
            // The target is a portal, but it's not the rootContainer we're looking for.
            // Normally portals handle their own events all the way down to the root.
            // So we should be able to stop now. However, we don't know if this portal
            // was part of *our* root.
            var grandNode = node.return;

            while (grandNode !== null) {
              var grandTag = grandNode.tag;

              if (grandTag === HostRoot || grandTag === HostPortal) {
                var grandContainer = grandNode.stateNode.containerInfo;

                if (isMatchingRootContainer(grandContainer, targetContainerNode)) {
                  // This is the rootContainer we're looking for and we found it as
                  // a parent of the Portal. That means we can ignore it because the
                  // Portal will bubble through to us.
                  return;
                }
              }

              grandNode = grandNode.return;
            }
          } // Now we need to find it's corresponding host fiber in the other
          // tree. To do this we can use getClosestInstanceFromNode, but we
          // need to validate that the fiber is a host instance, otherwise
          // we need to traverse up through the DOM till we find the correct
          // node that is from the other tree.


          while (container !== null) {
            var parentNode = getClosestInstanceFromNode(container);

            if (parentNode === null) {
              return;
            }

            var parentTag = parentNode.tag;

            if (parentTag === HostComponent || parentTag === HostText) {
              node = ancestorInst = parentNode;
              continue mainLoop;
            }

            container = container.parentNode;
          }
        }

        node = node.return;
      }
    }
  }

  batchedEventUpdates(function () {
    return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
  });
}

function createDispatchListener(instance, listener, currentTarget) {
  return {
    instance: instance,
    listener: listener,
    currentTarget: currentTarget
  };
}

function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
  var captureName = reactName !== null ? reactName + 'Capture' : null;
  var reactEventName = inCapturePhase ? captureName : reactName;
  var listeners = [];
  var instance = targetFiber;
  var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.

  while (instance !== null) {
    var _instance2 = instance,
        stateNode = _instance2.stateNode,
        tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)

    if (tag === HostComponent && stateNode !== null) {
      lastHostComponent = stateNode; // createEventHandle listeners


      if (reactEventName !== null) {
        var listener = getListener(instance, reactEventName);

        if (listener != null) {
          listeners.push(createDispatchListener(instance, listener, lastHostComponent));
        }
      }
    } // If we are only accumulating events for the target, then we don't
    // continue to propagate through the React fiber tree to find other
    // listeners.


    if (accumulateTargetOnly) {
      break;
    }

    instance = instance.return;
  }

  return listeners;
} // We should only use this function for:
// - BeforeInputEventPlugin
// - ChangeEventPlugin
// - SelectEventPlugin
// This is because we only process these plugins
// in the bubble phase, so we need to accumulate two
// phase event listeners (via emulation).

function accumulateTwoPhaseListeners(targetFiber, reactName) {
  var captureName = reactName + 'Capture';
  var listeners = [];
  var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.

  while (instance !== null) {
    var _instance3 = instance,
        stateNode = _instance3.stateNode,
        tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)

    if (tag === HostComponent && stateNode !== null) {
      var currentTarget = stateNode;
      var captureListener = getListener(instance, captureName);

      if (captureListener != null) {
        listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
      }

      var bubbleListener = getListener(instance, reactName);

      if (bubbleListener != null) {
        listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
      }
    }

    instance = instance.return;
  }

  return listeners;
}

function getParent(inst) {
  if (inst === null) {
    return null;
  }

  do {
    inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
    // That is depending on if we want nested subtrees (layers) to bubble
    // events to their parent. We could also go through parentNode on the
    // host node but that wouldn't work for React Native and doesn't let us
    // do the portal feature.
  } while (inst && inst.tag !== HostComponent);

  if (inst) {
    return inst;
  }

  return null;
}
/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */


function getLowestCommonAncestor(instA, instB) {
  var nodeA = instA;
  var nodeB = instB;
  var depthA = 0;

  for (var tempA = nodeA; tempA; tempA = getParent(tempA)) {
    depthA++;
  }

  var depthB = 0;

  for (var tempB = nodeB; tempB; tempB = getParent(tempB)) {
    depthB++;
  } // If A is deeper, crawl up.


  while (depthA - depthB > 0) {
    nodeA = getParent(nodeA);
    depthA--;
  } // If B is deeper, crawl up.


  while (depthB - depthA > 0) {
    nodeB = getParent(nodeB);
    depthB--;
  } // Walk in lockstep until we find a match.


  var depth = depthA;

  while (depth--) {
    if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) {
      return nodeA;
    }

    nodeA = getParent(nodeA);
    nodeB = getParent(nodeB);
  }

  return null;
}

function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
  var registrationName = event._reactName;
  var listeners = [];
  var instance = target;

  while (instance !== null) {
    if (instance === common) {
      break;
    }

    var _instance4 = instance,
        alternate = _instance4.alternate,
        stateNode = _instance4.stateNode,
        tag = _instance4.tag;

    if (alternate !== null && alternate === common) {
      break;
    }

    if (tag === HostComponent && stateNode !== null) {
      var currentTarget = stateNode;

      if (inCapturePhase) {
        var captureListener = getListener(instance, registrationName);

        if (captureListener != null) {
          listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
        }
      } else if (!inCapturePhase) {
        var bubbleListener = getListener(instance, registrationName);

        if (bubbleListener != null) {
          listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
        }
      }
    }

    instance = instance.return;
  }

  if (listeners.length !== 0) {
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
  }
} // We should only use this function for:
// - EnterLeaveEventPlugin
// This is because we only process this plugin
// in the bubble phase, so we need to accumulate two
// phase event listeners.


function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;

  if (from !== null) {
    accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
  }

  if (to !== null && enterEvent !== null) {
    accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
  }
}
function getListenerSetKey(domEventName, capture) {
  return domEventName + "__" + (capture ? 'capture' : 'bubble');
}

var didWarnInvalidHydration = false;
var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
var AUTOFOCUS = 'autoFocus';
var CHILDREN = 'children';
var STYLE = 'style';
var HTML$1 = '__html';
var HTML_NAMESPACE$1 = Namespaces.html;
var warnedUnknownTags;
var suppressHydrationWarning;
var validatePropertiesInDevelopment;
var warnForTextDifference;
var warnForPropDifference;
var warnForExtraAttributes;
var warnForInvalidEventListener;
var canDiffStyleForHydrationWarning;
var normalizeMarkupForTextOrAttribute;
var normalizeHTML;

{
  warnedUnknownTags = {
    // There are working polyfills for <dialog>. Let people use it.
    dialog: true,
    // Electron ships a custom <webview> tag to display external web content in
    // an isolated frame and process.
    // This tag is not present in non Electron environments such as JSDom which
    // is often used for testing purposes.
    // @see https://electronjs.org/docs/api/webview-tag
    webview: true
  };

  validatePropertiesInDevelopment = function (type, props) {
    validateProperties(type, props);
    validateProperties$1(type, props);
    validateProperties$2(type, props, {
      registrationNameDependencies: registrationNameDependencies,
      possibleRegistrationNames: possibleRegistrationNames
    });
  }; // IE 11 parses & normalizes the style attribute as opposed to other
  // browsers. It adds spaces and sorts the properties in some
  // non-alphabetical order. Handling that would require sorting CSS
  // properties in the client & server versions or applying
  // `expectedStyle` to a temporary DOM node to read its `style` attribute
  // normalized. Since it only affects IE, we're skipping style warnings
  // in that browser completely in favor of doing all that work.
  // See https://github.com/facebook/react/issues/11807


  canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
  // It also can turn \u0000 into \uFFFD inside attributes.
  // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
  // If we have a mismatch, it might be caused by that.
  // We will still patch up in this case but not fire the warning.

  var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
  var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;

  normalizeMarkupForTextOrAttribute = function (markup) {
    var markupString = typeof markup === 'string' ? markup : '' + markup;
    return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
  };

  warnForTextDifference = function (serverText, clientText) {
    if (didWarnInvalidHydration) {
      return;
    }

    var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
    var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);

    if (normalizedServerText === normalizedClientText) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
  };

  warnForPropDifference = function (propName, serverValue, clientValue) {
    if (didWarnInvalidHydration) {
      return;
    }

    var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
    var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);

    if (normalizedServerValue === normalizedClientValue) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
  };

  warnForExtraAttributes = function (attributeNames) {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;
    var names = [];
    attributeNames.forEach(function (name) {
      names.push(name);
    });

    error('Extra attributes from the server: %s', names);
  };

  warnForInvalidEventListener = function (registrationName, listener) {
    if (listener === false) {
      error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
    } else {
      error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }
  }; // Parse the HTML and read it back to normalize the HTML string so that it
  // can be used for comparison.


  normalizeHTML = function (parent, html) {
    // We could have created a separate document here to avoid
    // re-initializing custom elements if they exist. But this breaks
    // how <noscript> is being handled. So we use the same document.
    // See the discussion in https://github.com/facebook/react/pull/11157.
    var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
    testElement.innerHTML = html;
    return testElement.innerHTML;
  };
}

function getOwnerDocumentFromRootContainer(rootContainerElement) {
  return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
}

function noop() {}

function trapClickOnNonInteractiveElement(node) {
  // Mobile Safari does not fire properly bubble click events on
  // non-interactive elements, which means delegated click listeners do not
  // fire. The workaround for this bug involves attaching an empty click
  // listener on the target node.
  // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
  // Just set it using the onclick property so that we don't have to manage any
  // bookkeeping for it. Not sure if we need to clear it when the listener is
  // removed.
  // TODO: Only do this for the relevant Safaris maybe?
  node.onclick = noop;
}

function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
  for (var propKey in nextProps) {
    if (!nextProps.hasOwnProperty(propKey)) {
      continue;
    }

    var nextProp = nextProps[propKey];

    if (propKey === STYLE) {
      {
        if (nextProp) {
          // Freeze the next style object so that we can assume it won't be
          // mutated. We have already warned for this in the past.
          Object.freeze(nextProp);
        }
      } // Relies on `updateStylesByID` not mutating `styleUpdates`.


      setValueForStyles(domElement, nextProp);
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

      if (nextHtml != null) {
        setInnerHTML(domElement, nextHtml);
      }
    } else if (propKey === CHILDREN) {
      if (typeof nextProp === 'string') {
        // Avoid setting initial textContent when the text is empty. In IE11 setting
        // textContent on a <textarea> will cause the placeholder to not
        // show within the <textarea> until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        var canSetTextContent = tag !== 'textarea' || nextProp !== '';

        if (canSetTextContent) {
          setTextContent(domElement, nextProp);
        }
      } else if (typeof nextProp === 'number') {
        setTextContent(domElement, '' + nextProp);
      }
    } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (propKey === AUTOFOCUS) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }
    } else if (nextProp != null) {
      setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
    }
  }
}

function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
  // TODO: Handle wasCustomComponentTag
  for (var i = 0; i < updatePayload.length; i += 2) {
    var propKey = updatePayload[i];
    var propValue = updatePayload[i + 1];

    if (propKey === STYLE) {
      setValueForStyles(domElement, propValue);
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      setInnerHTML(domElement, propValue);
    } else if (propKey === CHILDREN) {
      setTextContent(domElement, propValue);
    } else {
      setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
    }
  }
}

function createElement(type, props, rootContainerElement, parentNamespace) {
  var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
  // tags get no namespace.

  var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
  var domElement;
  var namespaceURI = parentNamespace;

  if (namespaceURI === HTML_NAMESPACE$1) {
    namespaceURI = getIntrinsicNamespace(type);
  }

  if (namespaceURI === HTML_NAMESPACE$1) {
    {
      isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
      // allow <SVG> or <mATH>.

      if (!isCustomComponentTag && type !== type.toLowerCase()) {
        error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
      }
    }

    if (type === 'script') {
      // Create the script via .innerHTML so its "parser-inserted" flag is
      // set to true and it does not execute
      var div = ownerDocument.createElement('div');

      div.innerHTML = '<script><' + '/script>'; // eslint-disable-line
      // This is guaranteed to yield a script element.

      var firstChild = div.firstChild;
      domElement = div.removeChild(firstChild);
    } else if (typeof props.is === 'string') {
      // $FlowIssue `createElement` should be updated for Web Components
      domElement = ownerDocument.createElement(type, {
        is: props.is
      });
    } else {
      // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
      // See discussion in https://github.com/facebook/react/pull/6896
      // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
      domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
      // attributes on `select`s needs to be added before `option`s are inserted.
      // This prevents:
      // - a bug where the `select` does not scroll to the correct option because singular
      //  `select` elements automatically pick the first item #13222
      // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
      // See https://github.com/facebook/react/issues/13222
      // and https://github.com/facebook/react/issues/14239

      if (type === 'select') {
        var node = domElement;

        if (props.multiple) {
          node.multiple = true;
        } else if (props.size) {
          // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
          // it is possible that no option is selected.
          //
          // This is only necessary when a select in "single selection mode".
          node.size = props.size;
        }
      }
    }
  } else {
    domElement = ownerDocument.createElementNS(namespaceURI, type);
  }

  {
    if (namespaceURI === HTML_NAMESPACE$1) {
      if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
        warnedUnknownTags[type] = true;

        error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
      }
    }
  }

  return domElement;
}
function createTextNode(text, rootContainerElement) {
  return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
}
function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
  var isCustomComponentTag = isCustomComponent(tag, rawProps);

  {
    validatePropertiesInDevelopment(tag, rawProps);
  } // TODO: Make sure that we check isMounted before firing any of these events.


  var props;

  switch (tag) {
    case 'dialog':
      listenToNonDelegatedEvent('cancel', domElement);
      listenToNonDelegatedEvent('close', domElement);
      props = rawProps;
      break;

    case 'iframe':
    case 'object':
    case 'embed':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the load event.
      listenToNonDelegatedEvent('load', domElement);
      props = rawProps;
      break;

    case 'video':
    case 'audio':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for all the media events.
      for (var i = 0; i < mediaEventTypes.length; i++) {
        listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
      }

      props = rawProps;
      break;

    case 'source':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the error event.
      listenToNonDelegatedEvent('error', domElement);
      props = rawProps;
      break;

    case 'img':
    case 'image':
    case 'link':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for error and load events.
      listenToNonDelegatedEvent('error', domElement);
      listenToNonDelegatedEvent('load', domElement);
      props = rawProps;
      break;

    case 'details':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the toggle event.
      listenToNonDelegatedEvent('toggle', domElement);
      props = rawProps;
      break;

    case 'input':
      initWrapperState(domElement, rawProps);
      props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'option':
      validateProps(domElement, rawProps);
      props = getHostProps$1(domElement, rawProps);
      break;

    case 'select':
      initWrapperState$1(domElement, rawProps);
      props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'textarea':
      initWrapperState$2(domElement, rawProps);
      props = getHostProps$3(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    default:
      props = rawProps;
  }

  assertValidProps(tag, props);
  setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);

  switch (tag) {
    case 'input':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper(domElement, rawProps, false);
      break;

    case 'textarea':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper$3(domElement);
      break;

    case 'option':
      postMountWrapper$1(domElement, rawProps);
      break;

    case 'select':
      postMountWrapper$2(domElement, rawProps);
      break;

    default:
      if (typeof props.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }
} // Calculate the diff between the two objects.

function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
  {
    validatePropertiesInDevelopment(tag, nextRawProps);
  }

  var updatePayload = null;
  var lastProps;
  var nextProps;

  switch (tag) {
    case 'input':
      lastProps = getHostProps(domElement, lastRawProps);
      nextProps = getHostProps(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'option':
      lastProps = getHostProps$1(domElement, lastRawProps);
      nextProps = getHostProps$1(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'select':
      lastProps = getHostProps$2(domElement, lastRawProps);
      nextProps = getHostProps$2(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'textarea':
      lastProps = getHostProps$3(domElement, lastRawProps);
      nextProps = getHostProps$3(domElement, nextRawProps);
      updatePayload = [];
      break;

    default:
      lastProps = lastRawProps;
      nextProps = nextRawProps;

      if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }

  assertValidProps(tag, nextProps);
  var propKey;
  var styleName;
  var styleUpdates = null;

  for (propKey in lastProps) {
    if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
      continue;
    }

    if (propKey === STYLE) {
      var lastStyle = lastProps[propKey];

      for (styleName in lastStyle) {
        if (lastStyle.hasOwnProperty(styleName)) {
          if (!styleUpdates) {
            styleUpdates = {};
          }

          styleUpdates[styleName] = '';
        }
      }
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ; else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (propKey === AUTOFOCUS) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      // This is a special case. If any listener updates we need to ensure
      // that the "current" fiber pointer gets updated so we need a commit
      // to update this element.
      if (!updatePayload) {
        updatePayload = [];
      }
    } else {
      // For all other deleted properties we add it to the queue. We use
      // the allowed property list in the commit phase instead.
      (updatePayload = updatePayload || []).push(propKey, null);
    }
  }

  for (propKey in nextProps) {
    var nextProp = nextProps[propKey];
    var lastProp = lastProps != null ? lastProps[propKey] : undefined;

    if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
      continue;
    }

    if (propKey === STYLE) {
      {
        if (nextProp) {
          // Freeze the next style object so that we can assume it won't be
          // mutated. We have already warned for this in the past.
          Object.freeze(nextProp);
        }
      }

      if (lastProp) {
        // Unset styles on `lastProp` but not on `nextProp`.
        for (styleName in lastProp) {
          if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
            if (!styleUpdates) {
              styleUpdates = {};
            }

            styleUpdates[styleName] = '';
          }
        } // Update styles that changed since `lastProp`.


        for (styleName in nextProp) {
          if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
            if (!styleUpdates) {
              styleUpdates = {};
            }

            styleUpdates[styleName] = nextProp[styleName];
          }
        }
      } else {
        // Relies on `updateStylesByID` not mutating `styleUpdates`.
        if (!styleUpdates) {
          if (!updatePayload) {
            updatePayload = [];
          }

          updatePayload.push(propKey, styleUpdates);
        }

        styleUpdates = nextProp;
      }
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
      var lastHtml = lastProp ? lastProp[HTML$1] : undefined;

      if (nextHtml != null) {
        if (lastHtml !== nextHtml) {
          (updatePayload = updatePayload || []).push(propKey, nextHtml);
        }
      }
    } else if (propKey === CHILDREN) {
      if (typeof nextProp === 'string' || typeof nextProp === 'number') {
        (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
      }
    } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        // We eagerly listen to this even though we haven't committed yet.
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }

      if (!updatePayload && lastProp !== nextProp) {
        // This is a special case. If any listener updates we need to ensure
        // that the "current" props pointer gets updated so we need a commit
        // to update this element.
        updatePayload = [];
      }
    } else if (typeof nextProp === 'object' && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) {
      // If we encounter useOpaqueReference's opaque object, this means we are hydrating.
      // In this case, call the opaque object's toString function which generates a new client
      // ID so client and server IDs match and throws to rerender.
      nextProp.toString();
    } else {
      // For any other property we always add it to the queue and then we
      // filter it out using the allowed property list during the commit.
      (updatePayload = updatePayload || []).push(propKey, nextProp);
    }
  }

  if (styleUpdates) {
    {
      validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
    }

    (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
  }

  return updatePayload;
} // Apply the diff.

function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
  // Update checked *before* name.
  // In the middle of an update, it is possible to have multiple checked.
  // When a checked radio tries to change name, browser makes another radio's checked false.
  if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
    updateChecked(domElement, nextRawProps);
  }

  var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
  var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.

  updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
  // changed.

  switch (tag) {
    case 'input':
      // Update the wrapper around inputs *after* updating props. This has to
      // happen after `updateDOMProperties`. Otherwise HTML5 input validations
      // raise warnings and prevent the new value from being assigned.
      updateWrapper(domElement, nextRawProps);
      break;

    case 'textarea':
      updateWrapper$1(domElement, nextRawProps);
      break;

    case 'select':
      // <select> value update needs to occur after <option> children
      // reconciliation
      postUpdateWrapper(domElement, nextRawProps);
      break;
  }
}

function getPossibleStandardName(propName) {
  {
    var lowerCasedName = propName.toLowerCase();

    if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
      return null;
    }

    return possibleStandardNames[lowerCasedName] || null;
  }
}

function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
  var isCustomComponentTag;
  var extraAttributeNames;

  {
    suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
    isCustomComponentTag = isCustomComponent(tag, rawProps);
    validatePropertiesInDevelopment(tag, rawProps);
  } // TODO: Make sure that we check isMounted before firing any of these events.


  switch (tag) {
    case 'dialog':
      listenToNonDelegatedEvent('cancel', domElement);
      listenToNonDelegatedEvent('close', domElement);
      break;

    case 'iframe':
    case 'object':
    case 'embed':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the load event.
      listenToNonDelegatedEvent('load', domElement);
      break;

    case 'video':
    case 'audio':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for all the media events.
      for (var i = 0; i < mediaEventTypes.length; i++) {
        listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
      }

      break;

    case 'source':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the error event.
      listenToNonDelegatedEvent('error', domElement);
      break;

    case 'img':
    case 'image':
    case 'link':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for error and load events.
      listenToNonDelegatedEvent('error', domElement);
      listenToNonDelegatedEvent('load', domElement);
      break;

    case 'details':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the toggle event.
      listenToNonDelegatedEvent('toggle', domElement);
      break;

    case 'input':
      initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'option':
      validateProps(domElement, rawProps);
      break;

    case 'select':
      initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'textarea':
      initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;
  }

  assertValidProps(tag, rawProps);

  {
    extraAttributeNames = new Set();
    var attributes = domElement.attributes;

    for (var _i = 0; _i < attributes.length; _i++) {
      var name = attributes[_i].name.toLowerCase();

      switch (name) {
        // Built-in SSR attribute is allowed
        case 'data-reactroot':
          break;
        // Controlled attributes are not validated
        // TODO: Only ignore them on controlled tags.

        case 'value':
          break;

        case 'checked':
          break;

        case 'selected':
          break;

        default:
          // Intentionally use the original name.
          // See discussion in https://github.com/facebook/react/pull/10676.
          extraAttributeNames.add(attributes[_i].name);
      }
    }
  }

  var updatePayload = null;

  for (var propKey in rawProps) {
    if (!rawProps.hasOwnProperty(propKey)) {
      continue;
    }

    var nextProp = rawProps[propKey];

    if (propKey === CHILDREN) {
      // For text content children we compare against textContent. This
      // might match additional HTML that is hidden when we read it using
      // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
      // satisfies our requirement. Our requirement is not to produce perfect
      // HTML and attributes. Ideally we should preserve structure but it's
      // ok not to if the visible content is still enough to indicate what
      // even listeners these nodes might be wired up to.
      // TODO: Warn if there is more than a single textNode as a child.
      // TODO: Should we use domElement.firstChild.nodeValue to compare?
      if (typeof nextProp === 'string') {
        if (domElement.textContent !== nextProp) {
          if ( !suppressHydrationWarning) {
            warnForTextDifference(domElement.textContent, nextProp);
          }

          updatePayload = [CHILDREN, nextProp];
        }
      } else if (typeof nextProp === 'number') {
        if (domElement.textContent !== '' + nextProp) {
          if ( !suppressHydrationWarning) {
            warnForTextDifference(domElement.textContent, nextProp);
          }

          updatePayload = [CHILDREN, '' + nextProp];
        }
      }
    } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }
    } else if ( // Convince Flow we've calculated it (it's DEV-only in this method.)
    typeof isCustomComponentTag === 'boolean') {
      // Validate that the properties correspond to their expected values.
      var serverValue = void 0;
      var propertyInfo = getPropertyInfo(propKey);

      if (suppressHydrationWarning) ; else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
      // TODO: Only ignore them on controlled tags.
      propKey === 'value' || propKey === 'checked' || propKey === 'selected') ; else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
        var serverHTML = domElement.innerHTML;
        var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

        if (nextHtml != null) {
          var expectedHTML = normalizeHTML(domElement, nextHtml);

          if (expectedHTML !== serverHTML) {
            warnForPropDifference(propKey, serverHTML, expectedHTML);
          }
        }
      } else if (propKey === STYLE) {
        // $FlowFixMe - Should be inferred as not undefined.
        extraAttributeNames.delete(propKey);

        if (canDiffStyleForHydrationWarning) {
          var expectedStyle = createDangerousStringForStyles(nextProp);
          serverValue = domElement.getAttribute('style');

          if (expectedStyle !== serverValue) {
            warnForPropDifference(propKey, serverValue, expectedStyle);
          }
        }
      } else if (isCustomComponentTag) {
        // $FlowFixMe - Should be inferred as not undefined.
        extraAttributeNames.delete(propKey.toLowerCase());
        serverValue = getValueForAttribute(domElement, propKey, nextProp);

        if (nextProp !== serverValue) {
          warnForPropDifference(propKey, serverValue, nextProp);
        }
      } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
        var isMismatchDueToBadCasing = false;

        if (propertyInfo !== null) {
          // $FlowFixMe - Should be inferred as not undefined.
          extraAttributeNames.delete(propertyInfo.attributeName);
          serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
        } else {
          var ownNamespace = parentNamespace;

          if (ownNamespace === HTML_NAMESPACE$1) {
            ownNamespace = getIntrinsicNamespace(tag);
          }

          if (ownNamespace === HTML_NAMESPACE$1) {
            // $FlowFixMe - Should be inferred as not undefined.
            extraAttributeNames.delete(propKey.toLowerCase());
          } else {
            var standardName = getPossibleStandardName(propKey);

            if (standardName !== null && standardName !== propKey) {
              // If an SVG prop is supplied with bad casing, it will
              // be successfully parsed from HTML, but will produce a mismatch
              // (and would be incorrectly rendered on the client).
              // However, we already warn about bad casing elsewhere.
              // So we'll skip the misleading extra mismatch warning in this case.
              isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.

              extraAttributeNames.delete(standardName);
            } // $FlowFixMe - Should be inferred as not undefined.


            extraAttributeNames.delete(propKey);
          }

          serverValue = getValueForAttribute(domElement, propKey, nextProp);
        }

        if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
          warnForPropDifference(propKey, serverValue, nextProp);
        }
      }
    }
  }

  {
    // $FlowFixMe - Should be inferred as not undefined.
    if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
      // $FlowFixMe - Should be inferred as not undefined.
      warnForExtraAttributes(extraAttributeNames);
    }
  }

  switch (tag) {
    case 'input':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper(domElement, rawProps, true);
      break;

    case 'textarea':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper$3(domElement);
      break;

    case 'select':
    case 'option':
      // For input and textarea we current always set the value property at
      // post mount to force it to diverge from attributes. However, for
      // option and select we don't quite do the same thing and select
      // is not resilient to the DOM state changing so we don't do that here.
      // TODO: Consider not doing this for input and textarea.
      break;

    default:
      if (typeof rawProps.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }

  return updatePayload;
}
function diffHydratedText(textNode, text) {
  var isDifferent = textNode.nodeValue !== text;
  return isDifferent;
}
function warnForUnmatchedText(textNode, text) {
  {
    warnForTextDifference(textNode.nodeValue, text);
  }
}
function warnForDeletedHydratableElement(parentNode, child) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
  }
}
function warnForDeletedHydratableText(parentNode, child) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
  }
}
function warnForInsertedHydratedElement(parentNode, tag, props) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
  }
}
function warnForInsertedHydratedText(parentNode, text) {
  {
    if (text === '') {
      // We expect to insert empty text nodes since they're not represented in
      // the HTML.
      // TODO: Remove this special case if we can just avoid inserting empty
      // text nodes.
      return;
    }

    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
  }
}
function restoreControlledState$3(domElement, tag, props) {
  switch (tag) {
    case 'input':
      restoreControlledState(domElement, props);
      return;

    case 'textarea':
      restoreControlledState$2(domElement, props);
      return;

    case 'select':
      restoreControlledState$1(domElement, props);
      return;
  }
}

var validateDOMNesting = function () {};

var updatedAncestorInfo = function () {};

{
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.
  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope

  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template', // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope

  var buttonScopeTags = inScopeTags.concat(['button']); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags

  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
  var emptyAncestorInfo = {
    current: null,
    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,
    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  updatedAncestorInfo = function (oldInfo, tag) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);

    var info = {
      tag: tag
    };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }

    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    } // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }

    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }

    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }

    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }

    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }

    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }

    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };
  /**
   * Returns whether
   */


  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';

      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but

      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr

      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody

      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup

      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable

      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead

      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element

      case 'html':
        return tag === 'head' || tag === 'body' || tag === 'frameset';

      case 'frameset':
        return tag === 'frame';

      case '#document':
        return tag === 'html';
    } // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frameset':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };
  /**
   * Returns whether
   */


  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  var didWarn$1 = {};

  validateDOMNesting = function (childTag, childText, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      if (childTag != null) {
        error('validateDOMNesting: when childText is passed, childTag should be null');
      }

      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var invalidParentOrAncestor = invalidParent || invalidAncestor;

    if (!invalidParentOrAncestor) {
      return;
    }

    var ancestorTag = invalidParentOrAncestor.tag;
    var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;

    if (didWarn$1[warnKey]) {
      return;
    }

    didWarn$1[warnKey] = true;
    var tagDisplayName = childTag;
    var whitespaceInfo = '';

    if (childTag === '#text') {
      if (/\S/.test(childText)) {
        tagDisplayName = 'Text nodes';
      } else {
        tagDisplayName = 'Whitespace text nodes';
        whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
      }
    } else {
      tagDisplayName = '<' + childTag + '>';
    }

    if (invalidParent) {
      var info = '';

      if (ancestorTag === 'table' && childTag === 'tr') {
        info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
      }

      error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
    } else {
      error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
    }
  };
}

var SUPPRESS_HYDRATION_WARNING$1;

{
  SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
}

var SUSPENSE_START_DATA = '$';
var SUSPENSE_END_DATA = '/$';
var SUSPENSE_PENDING_START_DATA = '$?';
var SUSPENSE_FALLBACK_START_DATA = '$!';
var STYLE$1 = 'style';
var eventsEnabled = null;
var selectionInformation = null;

function shouldAutoFocusHostComponent(type, props) {
  switch (type) {
    case 'button':
    case 'input':
    case 'select':
    case 'textarea':
      return !!props.autoFocus;
  }

  return false;
}
function getRootHostContext(rootContainerInstance) {
  var type;
  var namespace;
  var nodeType = rootContainerInstance.nodeType;

  switch (nodeType) {
    case DOCUMENT_NODE:
    case DOCUMENT_FRAGMENT_NODE:
      {
        type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
        var root = rootContainerInstance.documentElement;
        namespace = root ? root.namespaceURI : getChildNamespace(null, '');
        break;
      }

    default:
      {
        var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
        var ownNamespace = container.namespaceURI || null;
        type = container.tagName;
        namespace = getChildNamespace(ownNamespace, type);
        break;
      }
  }

  {
    var validatedTag = type.toLowerCase();
    var ancestorInfo = updatedAncestorInfo(null, validatedTag);
    return {
      namespace: namespace,
      ancestorInfo: ancestorInfo
    };
  }
}
function getChildHostContext(parentHostContext, type, rootContainerInstance) {
  {
    var parentHostContextDev = parentHostContext;
    var namespace = getChildNamespace(parentHostContextDev.namespace, type);
    var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
    return {
      namespace: namespace,
      ancestorInfo: ancestorInfo
    };
  }
}
function getPublicInstance(instance) {
  return instance;
}
function prepareForCommit(containerInfo) {
  eventsEnabled = isEnabled();
  selectionInformation = getSelectionInformation();
  var activeInstance = null;

  setEnabled(false);
  return activeInstance;
}
function resetAfterCommit(containerInfo) {
  restoreSelection(selectionInformation);
  setEnabled(eventsEnabled);
  eventsEnabled = null;
  selectionInformation = null;
}
function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
  var parentNamespace;

  {
    // TODO: take namespace into account when validating.
    var hostContextDev = hostContext;
    validateDOMNesting(type, null, hostContextDev.ancestorInfo);

    if (typeof props.children === 'string' || typeof props.children === 'number') {
      var string = '' + props.children;
      var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
      validateDOMNesting(null, string, ownAncestorInfo);
    }

    parentNamespace = hostContextDev.namespace;
  }

  var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
  precacheFiberNode(internalInstanceHandle, domElement);
  updateFiberProps(domElement, props);
  return domElement;
}
function appendInitialChild(parentInstance, child) {
  parentInstance.appendChild(child);
}
function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
  setInitialProperties(domElement, type, props, rootContainerInstance);
  return shouldAutoFocusHostComponent(type, props);
}
function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
  {
    var hostContextDev = hostContext;

    if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
      var string = '' + newProps.children;
      var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
      validateDOMNesting(null, string, ownAncestorInfo);
    }
  }

  return diffProperties(domElement, type, oldProps, newProps);
}
function shouldSetTextContent(type, props) {
  return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
}
function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
  {
    var hostContextDev = hostContext;
    validateDOMNesting(null, text, hostContextDev.ancestorInfo);
  }

  var textNode = createTextNode(text, rootContainerInstance);
  precacheFiberNode(internalInstanceHandle, textNode);
  return textNode;
}
// if a component just imports ReactDOM (e.g. for findDOMNode).
// Some environments might not have setTimeout or clearTimeout.

var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
var noTimeout = -1; // -------------------
function commitMount(domElement, type, newProps, internalInstanceHandle) {
  // Despite the naming that might imply otherwise, this method only
  // fires if there is an `Update` effect scheduled during mounting.
  // This happens if `finalizeInitialChildren` returns `true` (which it
  // does to implement the `autoFocus` attribute on the client). But
  // there are also other cases when this might happen (such as patching
  // up text content during hydration mismatch). So we'll check this again.
  if (shouldAutoFocusHostComponent(type, newProps)) {
    domElement.focus();
  }
}
function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
  // Update the props handle so that we know which props are the ones with
  // with current event handlers.
  updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.

  updateProperties(domElement, updatePayload, type, oldProps, newProps);
}
function resetTextContent(domElement) {
  setTextContent(domElement, '');
}
function commitTextUpdate(textInstance, oldText, newText) {
  textInstance.nodeValue = newText;
}
function appendChild(parentInstance, child) {
  parentInstance.appendChild(child);
}
function appendChildToContainer(container, child) {
  var parentNode;

  if (container.nodeType === COMMENT_NODE) {
    parentNode = container.parentNode;
    parentNode.insertBefore(child, container);
  } else {
    parentNode = container;
    parentNode.appendChild(child);
  } // This container might be used for a portal.
  // If something inside a portal is clicked, that click should bubble
  // through the React tree. However, on Mobile Safari the click would
  // never bubble through the *DOM* tree unless an ancestor with onclick
  // event exists. So we wouldn't see it and dispatch it.
  // This is why we ensure that non React root containers have inline onclick
  // defined.
  // https://github.com/facebook/react/issues/11918


  var reactRootContainer = container._reactRootContainer;

  if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
    // TODO: This cast may not be sound for SVG, MathML or custom elements.
    trapClickOnNonInteractiveElement(parentNode);
  }
}
function insertBefore(parentInstance, child, beforeChild) {
  parentInstance.insertBefore(child, beforeChild);
}
function insertInContainerBefore(container, child, beforeChild) {
  if (container.nodeType === COMMENT_NODE) {
    container.parentNode.insertBefore(child, beforeChild);
  } else {
    container.insertBefore(child, beforeChild);
  }
}

function removeChild(parentInstance, child) {
  parentInstance.removeChild(child);
}
function removeChildFromContainer(container, child) {
  if (container.nodeType === COMMENT_NODE) {
    container.parentNode.removeChild(child);
  } else {
    container.removeChild(child);
  }
}
function hideInstance(instance) {
  // TODO: Does this work for all element types? What about MathML? Should we
  // pass host context to this method?
  instance = instance;
  var style = instance.style;

  if (typeof style.setProperty === 'function') {
    style.setProperty('display', 'none', 'important');
  } else {
    style.display = 'none';
  }
}
function hideTextInstance(textInstance) {
  textInstance.nodeValue = '';
}
function unhideInstance(instance, props) {
  instance = instance;
  var styleProp = props[STYLE$1];
  var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
  instance.style.display = dangerousStyleValue('display', display);
}
function unhideTextInstance(textInstance, text) {
  textInstance.nodeValue = text;
}
function clearContainer(container) {
  if (container.nodeType === ELEMENT_NODE) {
    container.textContent = '';
  } else if (container.nodeType === DOCUMENT_NODE) {
    var body = container.body;

    if (body != null) {
      body.textContent = '';
    }
  }
} // -------------------
function canHydrateInstance(instance, type, props) {
  if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
    return null;
  } // This has now been refined to an element node.


  return instance;
}
function canHydrateTextInstance(instance, text) {
  if (text === '' || instance.nodeType !== TEXT_NODE) {
    // Empty strings are not parsed by HTML so there won't be a correct match here.
    return null;
  } // This has now been refined to a text node.


  return instance;
}
function isSuspenseInstancePending(instance) {
  return instance.data === SUSPENSE_PENDING_START_DATA;
}
function isSuspenseInstanceFallback(instance) {
  return instance.data === SUSPENSE_FALLBACK_START_DATA;
}

function getNextHydratable(node) {
  // Skip non-hydratable nodes.
  for (; node != null; node = node.nextSibling) {
    var nodeType = node.nodeType;

    if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
      break;
    }
  }

  return node;
}

function getNextHydratableSibling(instance) {
  return getNextHydratable(instance.nextSibling);
}
function getFirstHydratableChild(parentInstance) {
  return getNextHydratable(parentInstance.firstChild);
}
function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
  precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
  // get attached.

  updateFiberProps(instance, props);
  var parentNamespace;

  {
    var hostContextDev = hostContext;
    parentNamespace = hostContextDev.namespace;
  }

  return diffHydratedProperties(instance, type, props, parentNamespace);
}
function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
  precacheFiberNode(internalInstanceHandle, textInstance);
  return diffHydratedText(textInstance, text);
}
function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
  var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
  // There might be nested nodes so we need to keep track of how
  // deep we are and only break out when we're back on top.

  var depth = 0;

  while (node) {
    if (node.nodeType === COMMENT_NODE) {
      var data = node.data;

      if (data === SUSPENSE_END_DATA) {
        if (depth === 0) {
          return getNextHydratableSibling(node);
        } else {
          depth--;
        }
      } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
        depth++;
      }
    }

    node = node.nextSibling;
  } // TODO: Warn, we didn't find the end comment boundary.


  return null;
} // Returns the SuspenseInstance if this node is a direct child of a
// SuspenseInstance. I.e. if its previous sibling is a Comment with
// SUSPENSE_x_START_DATA. Otherwise, null.

function getParentSuspenseInstance(targetInstance) {
  var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
  // There might be nested nodes so we need to keep track of how
  // deep we are and only break out when we're back on top.

  var depth = 0;

  while (node) {
    if (node.nodeType === COMMENT_NODE) {
      var data = node.data;

      if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
        if (depth === 0) {
          return node;
        } else {
          depth--;
        }
      } else if (data === SUSPENSE_END_DATA) {
        depth++;
      }
    }

    node = node.previousSibling;
  }

  return null;
}
function commitHydratedContainer(container) {
  // Retry if any event replaying was blocked on this.
  retryIfBlockedOn(container);
}
function commitHydratedSuspenseInstance(suspenseInstance) {
  // Retry if any event replaying was blocked on this.
  retryIfBlockedOn(suspenseInstance);
}
function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
  {
    warnForUnmatchedText(textInstance, text);
  }
}
function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForUnmatchedText(textInstance, text);
  }
}
function didNotHydrateContainerInstance(parentContainer, instance) {
  {
    if (instance.nodeType === ELEMENT_NODE) {
      warnForDeletedHydratableElement(parentContainer, instance);
    } else if (instance.nodeType === COMMENT_NODE) ; else {
      warnForDeletedHydratableText(parentContainer, instance);
    }
  }
}
function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    if (instance.nodeType === ELEMENT_NODE) {
      warnForDeletedHydratableElement(parentInstance, instance);
    } else if (instance.nodeType === COMMENT_NODE) ; else {
      warnForDeletedHydratableText(parentInstance, instance);
    }
  }
}
function didNotFindHydratableContainerInstance(parentContainer, type, props) {
  {
    warnForInsertedHydratedElement(parentContainer, type);
  }
}
function didNotFindHydratableContainerTextInstance(parentContainer, text) {
  {
    warnForInsertedHydratedText(parentContainer, text);
  }
}
function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForInsertedHydratedElement(parentInstance, type);
  }
}
function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForInsertedHydratedText(parentInstance, text);
  }
}
var clientId = 0;
function makeClientIdInDEV(warnOnAccessInDEV) {
  var id = 'r:' + (clientId++).toString(36);
  return {
    toString: function () {
      warnOnAccessInDEV();
      return id;
    },
    valueOf: function () {
      warnOnAccessInDEV();
      return id;
    }
  };
}
function isOpaqueHydratingObject(value) {
  return value !== null && typeof value === 'object' && value.$$typeof === REACT_OPAQUE_ID_TYPE;
}
function makeOpaqueHydratingObject(attemptToReadValue) {
  return {
    $$typeof: REACT_OPAQUE_ID_TYPE,
    toString: attemptToReadValue,
    valueOf: attemptToReadValue
  };
}
function preparePortalMount(portalInstance) {
  {
    listenToAllSupportedEvents(portalInstance);
  }
}

var randomKey = Math.random().toString(36).slice(2);
var internalInstanceKey = '__reactFiber$' + randomKey;
var internalPropsKey = '__reactProps$' + randomKey;
var internalContainerInstanceKey = '__reactContainer$' + randomKey;
var internalEventHandlersKey = '__reactEvents$' + randomKey;
function precacheFiberNode(hostInst, node) {
  node[internalInstanceKey] = hostInst;
}
function markContainerAsRoot(hostRoot, node) {
  node[internalContainerInstanceKey] = hostRoot;
}
function unmarkContainerAsRoot(node) {
  node[internalContainerInstanceKey] = null;
}
function isContainerMarkedAsRoot(node) {
  return !!node[internalContainerInstanceKey];
} // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
// If the target node is part of a hydrated or not yet rendered subtree, then
// this may also return a SuspenseComponent or HostRoot to indicate that.
// Conceptually the HostRoot fiber is a child of the Container node. So if you
// pass the Container node as the targetNode, you will not actually get the
// HostRoot back. To get to the HostRoot, you need to pass a child of it.
// The same thing applies to Suspense boundaries.

function getClosestInstanceFromNode(targetNode) {
  var targetInst = targetNode[internalInstanceKey];

  if (targetInst) {
    // Don't return HostRoot or SuspenseComponent here.
    return targetInst;
  } // If the direct event target isn't a React owned DOM node, we need to look
  // to see if one of its parents is a React owned DOM node.


  var parentNode = targetNode.parentNode;

  while (parentNode) {
    // We'll check if this is a container root that could include
    // React nodes in the future. We need to check this first because
    // if we're a child of a dehydrated container, we need to first
    // find that inner container before moving on to finding the parent
    // instance. Note that we don't check this field on  the targetNode
    // itself because the fibers are conceptually between the container
    // node and the first child. It isn't surrounding the container node.
    // If it's not a container, we check if it's an instance.
    targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];

    if (targetInst) {
      // Since this wasn't the direct target of the event, we might have
      // stepped past dehydrated DOM nodes to get here. However they could
      // also have been non-React nodes. We need to answer which one.
      // If we the instance doesn't have any children, then there can't be
      // a nested suspense boundary within it. So we can use this as a fast
      // bailout. Most of the time, when people add non-React children to
      // the tree, it is using a ref to a child-less DOM node.
      // Normally we'd only need to check one of the fibers because if it
      // has ever gone from having children to deleting them or vice versa
      // it would have deleted the dehydrated boundary nested inside already.
      // However, since the HostRoot starts out with an alternate it might
      // have one on the alternate so we need to check in case this was a
      // root.
      var alternate = targetInst.alternate;

      if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
        // Next we need to figure out if the node that skipped past is
        // nested within a dehydrated boundary and if so, which one.
        var suspenseInstance = getParentSuspenseInstance(targetNode);

        while (suspenseInstance !== null) {
          // We found a suspense instance. That means that we haven't
          // hydrated it yet. Even though we leave the comments in the
          // DOM after hydrating, and there are boundaries in the DOM
          // that could already be hydrated, we wouldn't have found them
          // through this pass since if the target is hydrated it would
          // have had an internalInstanceKey on it.
          // Let's get the fiber associated with the SuspenseComponent
          // as the deepest instance.
          var targetSuspenseInst = suspenseInstance[internalInstanceKey];

          if (targetSuspenseInst) {
            return targetSuspenseInst;
          } // If we don't find a Fiber on the comment, it might be because
          // we haven't gotten to hydrate it yet. There might still be a
          // parent boundary that hasn't above this one so we need to find
          // the outer most that is known.


          suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
          // host component also hasn't hydrated yet. We can return it
          // below since it will bail out on the isMounted check later.
        }
      }

      return targetInst;
    }

    targetNode = parentNode;
    parentNode = targetNode.parentNode;
  }

  return null;
}
/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */

function getInstanceFromNode(node) {
  var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];

  if (inst) {
    if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
      return inst;
    } else {
      return null;
    }
  }

  return null;
}
/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */

function getNodeFromInstance(inst) {
  if (inst.tag === HostComponent || inst.tag === HostText) {
    // In Fiber this, is just the state node right now. We assume it will be
    // a host component or host text.
    return inst.stateNode;
  } // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.


  {
    {
      throw Error( "getNodeFromInstance: Invalid argument." );
    }
  }
}
function getFiberCurrentPropsFromNode(node) {
  return node[internalPropsKey] || null;
}
function updateFiberProps(node, props) {
  node[internalPropsKey] = props;
}
function getEventListenerSet(node) {
  var elementListenerSet = node[internalEventHandlersKey];

  if (elementListenerSet === undefined) {
    elementListenerSet = node[internalEventHandlersKey] = new Set();
  }

  return elementListenerSet;
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var valueStack = [];
var fiberStack;

{
  fiberStack = [];
}

var index = -1;

function createCursor(defaultValue) {
  return {
    current: defaultValue
  };
}

function pop(cursor, fiber) {
  if (index < 0) {
    {
      error('Unexpected pop.');
    }

    return;
  }

  {
    if (fiber !== fiberStack[index]) {
      error('Unexpected Fiber popped.');
    }
  }

  cursor.current = valueStack[index];
  valueStack[index] = null;

  {
    fiberStack[index] = null;
  }

  index--;
}

function push(cursor, value, fiber) {
  index++;
  valueStack[index] = cursor.current;

  {
    fiberStack[index] = fiber;
  }

  cursor.current = value;
}

var warnedAboutMissingGetChildContext;

{
  warnedAboutMissingGetChildContext = {};
}

var emptyContextObject = {};

{
  Object.freeze(emptyContextObject);
} // A cursor to the current merged context object on the stack.


var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.

var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
// We use this to get access to the parent context after we have already
// pushed the next context provider, and now need to merge their contexts.

var previousContext = emptyContextObject;

function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
  {
    if (didPushOwnContextIfProvider && isContextProvider(Component)) {
      // If the fiber is a context provider itself, when we read its context
      // we may have already pushed its own child context on the stack. A context
      // provider should not "see" its own child context. Therefore we read the
      // previous (parent) context instead for a context provider.
      return previousContext;
    }

    return contextStackCursor.current;
  }
}

function cacheContext(workInProgress, unmaskedContext, maskedContext) {
  {
    var instance = workInProgress.stateNode;
    instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
    instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
  }
}

function getMaskedContext(workInProgress, unmaskedContext) {
  {
    var type = workInProgress.type;
    var contextTypes = type.contextTypes;

    if (!contextTypes) {
      return emptyContextObject;
    } // Avoid recreating masked context unless unmasked context has changed.
    // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
    // This may trigger infinite loops if componentWillReceiveProps calls setState.


    var instance = workInProgress.stateNode;

    if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
      return instance.__reactInternalMemoizedMaskedChildContext;
    }

    var context = {};

    for (var key in contextTypes) {
      context[key] = unmaskedContext[key];
    }

    {
      var name = getComponentName(type) || 'Unknown';
      checkPropTypes(contextTypes, context, 'context', name);
    } // Cache unmasked context so we can avoid recreating masked context unless necessary.
    // Context is created before the class component is instantiated so check for instance.


    if (instance) {
      cacheContext(workInProgress, unmaskedContext, context);
    }

    return context;
  }
}

function hasContextChanged() {
  {
    return didPerformWorkStackCursor.current;
  }
}

function isContextProvider(type) {
  {
    var childContextTypes = type.childContextTypes;
    return childContextTypes !== null && childContextTypes !== undefined;
  }
}

function popContext(fiber) {
  {
    pop(didPerformWorkStackCursor, fiber);
    pop(contextStackCursor, fiber);
  }
}

function popTopLevelContextObject(fiber) {
  {
    pop(didPerformWorkStackCursor, fiber);
    pop(contextStackCursor, fiber);
  }
}

function pushTopLevelContextObject(fiber, context, didChange) {
  {
    if (!(contextStackCursor.current === emptyContextObject)) {
      {
        throw Error( "Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    push(contextStackCursor, context, fiber);
    push(didPerformWorkStackCursor, didChange, fiber);
  }
}

function processChildContext(fiber, type, parentContext) {
  {
    var instance = fiber.stateNode;
    var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
    // It has only been added in Fiber to match the (unintentional) behavior in Stack.

    if (typeof instance.getChildContext !== 'function') {
      {
        var componentName = getComponentName(type) || 'Unknown';

        if (!warnedAboutMissingGetChildContext[componentName]) {
          warnedAboutMissingGetChildContext[componentName] = true;

          error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
        }
      }

      return parentContext;
    }

    var childContext = instance.getChildContext();

    for (var contextKey in childContext) {
      if (!(contextKey in childContextTypes)) {
        {
          throw Error( (getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes." );
        }
      }
    }

    {
      var name = getComponentName(type) || 'Unknown';
      checkPropTypes(childContextTypes, childContext, 'child context', name);
    }

    return _assign({}, parentContext, childContext);
  }
}

function pushContextProvider(workInProgress) {
  {
    var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
    // If the instance does not exist yet, we will push null at first,
    // and replace it on the stack later when invalidating the context.

    var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
    // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

    previousContext = contextStackCursor.current;
    push(contextStackCursor, memoizedMergedChildContext, workInProgress);
    push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
    return true;
  }
}

function invalidateContextProvider(workInProgress, type, didChange) {
  {
    var instance = workInProgress.stateNode;

    if (!instance) {
      {
        throw Error( "Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    if (didChange) {
      // Merge parent and own context.
      // Skip this if we're not updating due to sCU.
      // This avoids unnecessarily recomputing memoized values.
      var mergedContext = processChildContext(workInProgress, type, previousContext);
      instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
      // It is important to unwind the context in the reverse order.

      pop(didPerformWorkStackCursor, workInProgress);
      pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

      push(contextStackCursor, mergedContext, workInProgress);
      push(didPerformWorkStackCursor, didChange, workInProgress);
    } else {
      pop(didPerformWorkStackCursor, workInProgress);
      push(didPerformWorkStackCursor, didChange, workInProgress);
    }
  }
}

function findCurrentUnmaskedContext(fiber) {
  {
    // Currently this is only used with renderSubtreeIntoContainer; not sure if it
    // makes sense elsewhere
    if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
      {
        throw Error( "Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    var node = fiber;

    do {
      switch (node.tag) {
        case HostRoot:
          return node.stateNode.context;

        case ClassComponent:
          {
            var Component = node.type;

            if (isContextProvider(Component)) {
              return node.stateNode.__reactInternalMemoizedMergedChildContext;
            }

            break;
          }
      }

      node = node.return;
    } while (node !== null);

    {
      {
        throw Error( "Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }
}

var LegacyRoot = 0;
var BlockingRoot = 1;
var ConcurrentRoot = 2;

var rendererID = null;
var injectedHook = null;
var hasLoggedError = false;
var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
function injectInternals(internals) {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
    // No DevTools
    return false;
  }

  var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;

  if (hook.isDisabled) {
    // This isn't a real property on the hook, but it can be set to opt out
    // of DevTools integration and associated warnings and logs.
    // https://github.com/facebook/react/issues/3877
    return true;
  }

  if (!hook.supportsFiber) {
    {
      error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://reactjs.org/link/react-devtools');
    } // DevTools exists, even though it doesn't support Fiber.


    return true;
  }

  try {
    rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

    injectedHook = hook;
  } catch (err) {
    // Catch all errors because it is unsafe to throw during initialization.
    {
      error('React instrumentation encountered an error: %s.', err);
    }
  } // DevTools exists


  return true;
}
function onScheduleRoot(root, children) {
  {
    if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') {
      try {
        injectedHook.onScheduleFiberRoot(rendererID, root, children);
      } catch (err) {
        if ( !hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}
function onCommitRoot(root, priorityLevel) {
  if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') {
    try {
      var didError = (root.current.flags & DidCapture) === DidCapture;

      if (enableProfilerTimer) {
        injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
      } else {
        injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
      }
    } catch (err) {
      {
        if (!hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}
function onCommitUnmount(fiber) {
  if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') {
    try {
      injectedHook.onCommitFiberUnmount(rendererID, fiber);
    } catch (err) {
      {
        if (!hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}

var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority,
    Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback,
    Scheduler_cancelCallback = Scheduler.unstable_cancelCallback,
    Scheduler_shouldYield = Scheduler.unstable_shouldYield,
    Scheduler_requestPaint = Scheduler.unstable_requestPaint,
    Scheduler_now$1 = Scheduler.unstable_now,
    Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel,
    Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority,
    Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
    Scheduler_NormalPriority = Scheduler.unstable_NormalPriority,
    Scheduler_LowPriority = Scheduler.unstable_LowPriority,
    Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;

{
  // Provide explicit error message when production+profiling bundle of e.g.
  // react-dom is used with production (non-profiling) bundle of
  // scheduler/tracing
  if (!(tracing$1.__interactionsRef != null && tracing$1.__interactionsRef.current != null)) {
    {
      throw Error( "It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling" );
    }
  }
}

var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
// ascending numbers so we can compare them like numbers. They start at 90 to
// avoid clashing with Scheduler's priorities.

var ImmediatePriority$1 = 99;
var UserBlockingPriority$2 = 98;
var NormalPriority$1 = 97;
var LowPriority$1 = 96;
var IdlePriority$1 = 95; // NoPriority is the absence of priority. Also React-only.

var NoPriority$1 = 90;
var shouldYield = Scheduler_shouldYield;
var requestPaint = // Fall back gracefully if we're running an older version of Scheduler.
Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function () {};
var syncQueue = null;
var immediateQueueCallbackNode = null;
var isFlushingSyncQueue = false;
var initialTimeMs$1 = Scheduler_now$1(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
// This will be the case for modern browsers that support `performance.now`. In
// older browsers, Scheduler falls back to `Date.now`, which returns a Unix
// timestamp. In that case, subtract the module initialization time to simulate
// the behavior of performance.now and keep our times small enough to fit
// within 32 bits.
// TODO: Consider lifting this into Scheduler.

var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function () {
  return Scheduler_now$1() - initialTimeMs$1;
};
function getCurrentPriorityLevel() {
  switch (Scheduler_getCurrentPriorityLevel()) {
    case Scheduler_ImmediatePriority:
      return ImmediatePriority$1;

    case Scheduler_UserBlockingPriority:
      return UserBlockingPriority$2;

    case Scheduler_NormalPriority:
      return NormalPriority$1;

    case Scheduler_LowPriority:
      return LowPriority$1;

    case Scheduler_IdlePriority:
      return IdlePriority$1;

    default:
      {
        {
          throw Error( "Unknown priority level." );
        }
      }

  }
}

function reactPriorityToSchedulerPriority(reactPriorityLevel) {
  switch (reactPriorityLevel) {
    case ImmediatePriority$1:
      return Scheduler_ImmediatePriority;

    case UserBlockingPriority$2:
      return Scheduler_UserBlockingPriority;

    case NormalPriority$1:
      return Scheduler_NormalPriority;

    case LowPriority$1:
      return Scheduler_LowPriority;

    case IdlePriority$1:
      return Scheduler_IdlePriority;

    default:
      {
        {
          throw Error( "Unknown priority level." );
        }
      }

  }
}

function runWithPriority$1(reactPriorityLevel, fn) {
  var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
  return Scheduler_runWithPriority(priorityLevel, fn);
}
function scheduleCallback(reactPriorityLevel, callback, options) {
  var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
  return Scheduler_scheduleCallback(priorityLevel, callback, options);
}
function scheduleSyncCallback(callback) {
  // Push this callback into an internal queue. We'll flush these either in
  // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
  if (syncQueue === null) {
    syncQueue = [callback]; // Flush the queue in the next tick, at the earliest.

    immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
  } else {
    // Push onto existing queue. Don't need to schedule a callback because
    // we already scheduled one when we created the queue.
    syncQueue.push(callback);
  }

  return fakeCallbackNode;
}
function cancelCallback(callbackNode) {
  if (callbackNode !== fakeCallbackNode) {
    Scheduler_cancelCallback(callbackNode);
  }
}
function flushSyncCallbackQueue() {
  if (immediateQueueCallbackNode !== null) {
    var node = immediateQueueCallbackNode;
    immediateQueueCallbackNode = null;
    Scheduler_cancelCallback(node);
  }

  flushSyncCallbackQueueImpl();
}

function flushSyncCallbackQueueImpl() {
  if (!isFlushingSyncQueue && syncQueue !== null) {
    // Prevent re-entrancy.
    isFlushingSyncQueue = true;
    var i = 0;

    {
      try {
        var _isSync2 = true;
        var _queue = syncQueue;
        runWithPriority$1(ImmediatePriority$1, function () {
          for (; i < _queue.length; i++) {
            var callback = _queue[i];

            do {
              callback = callback(_isSync2);
            } while (callback !== null);
          }
        });
        syncQueue = null;
      } catch (error) {
        // If something throws, leave the remaining callbacks on the queue.
        if (syncQueue !== null) {
          syncQueue = syncQueue.slice(i + 1);
        } // Resume flushing in the next tick


        Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
        throw error;
      } finally {
        isFlushingSyncQueue = false;
      }
    }
  }
}

// TODO: this is special because it gets imported during build.
var ReactVersion = '17.0.2';

var NoMode = 0;
var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
// tag instead

var BlockingMode = 2;
var ConcurrentMode = 4;
var ProfileMode = 8;
var DebugTracingMode = 16;

var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
var NoTransition = 0;
function requestCurrentTransition() {
  return ReactCurrentBatchConfig.transition;
}

var ReactStrictModeWarnings = {
  recordUnsafeLifecycleWarnings: function (fiber, instance) {},
  flushPendingUnsafeLifecycleWarnings: function () {},
  recordLegacyContextWarning: function (fiber, instance) {},
  flushLegacyContextWarning: function () {},
  discardPendingWarnings: function () {}
};

{
  var findStrictRoot = function (fiber) {
    var maybeStrictRoot = null;
    var node = fiber;

    while (node !== null) {
      if (node.mode & StrictMode) {
        maybeStrictRoot = node;
      }

      node = node.return;
    }

    return maybeStrictRoot;
  };

  var setToSortedString = function (set) {
    var array = [];
    set.forEach(function (value) {
      array.push(value);
    });
    return array.sort().join(', ');
  };

  var pendingComponentWillMountWarnings = [];
  var pendingUNSAFE_ComponentWillMountWarnings = [];
  var pendingComponentWillReceivePropsWarnings = [];
  var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
  var pendingComponentWillUpdateWarnings = [];
  var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.

  var didWarnAboutUnsafeLifecycles = new Set();

  ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
    // Dedup strategy: Warn once per component.
    if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
      return;
    }

    if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
    instance.componentWillMount.__suppressDeprecationWarning !== true) {
      pendingComponentWillMountWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') {
      pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
    }

    if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
      pendingComponentWillReceivePropsWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
      pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
    }

    if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
      pendingComponentWillUpdateWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
      pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    }
  };

  ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
    // We do an initial pass to gather component names
    var componentWillMountUniqueNames = new Set();

    if (pendingComponentWillMountWarnings.length > 0) {
      pendingComponentWillMountWarnings.forEach(function (fiber) {
        componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillMountWarnings = [];
    }

    var UNSAFE_componentWillMountUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
      pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
        UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillMountWarnings = [];
    }

    var componentWillReceivePropsUniqueNames = new Set();

    if (pendingComponentWillReceivePropsWarnings.length > 0) {
      pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
        componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillReceivePropsWarnings = [];
    }

    var UNSAFE_componentWillReceivePropsUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
      pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
        UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    }

    var componentWillUpdateUniqueNames = new Set();

    if (pendingComponentWillUpdateWarnings.length > 0) {
      pendingComponentWillUpdateWarnings.forEach(function (fiber) {
        componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillUpdateWarnings = [];
    }

    var UNSAFE_componentWillUpdateUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
      pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
        UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillUpdateWarnings = [];
    } // Finally, we flush all the warnings
    // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'


    if (UNSAFE_componentWillMountUniqueNames.size > 0) {
      var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);

      error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
    }

    if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
      var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);

      error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
    }

    if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
      var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);

      error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
    }

    if (componentWillMountUniqueNames.size > 0) {
      var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);

      warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
    }

    if (componentWillReceivePropsUniqueNames.size > 0) {
      var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);

      warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
    }

    if (componentWillUpdateUniqueNames.size > 0) {
      var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);

      warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
    }
  };

  var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

  var didWarnAboutLegacyContext = new Set();

  ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
    var strictRoot = findStrictRoot(fiber);

    if (strictRoot === null) {
      error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');

      return;
    } // Dedup strategy: Warn once per component.


    if (didWarnAboutLegacyContext.has(fiber.type)) {
      return;
    }

    var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);

    if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
      if (warningsForRoot === undefined) {
        warningsForRoot = [];
        pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
      }

      warningsForRoot.push(fiber);
    }
  };

  ReactStrictModeWarnings.flushLegacyContextWarning = function () {
    pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
      if (fiberArray.length === 0) {
        return;
      }

      var firstFiber = fiberArray[0];
      var uniqueNames = new Set();
      fiberArray.forEach(function (fiber) {
        uniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutLegacyContext.add(fiber.type);
      });
      var sortedNames = setToSortedString(uniqueNames);

      try {
        setCurrentFiber(firstFiber);

        error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context', sortedNames);
      } finally {
        resetCurrentFiber();
      }
    });
  };

  ReactStrictModeWarnings.discardPendingWarnings = function () {
    pendingComponentWillMountWarnings = [];
    pendingUNSAFE_ComponentWillMountWarnings = [];
    pendingComponentWillReceivePropsWarnings = [];
    pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    pendingComponentWillUpdateWarnings = [];
    pendingUNSAFE_ComponentWillUpdateWarnings = [];
    pendingLegacyContextWarning = new Map();
  };
}

function resolveDefaultProps(Component, baseProps) {
  if (Component && Component.defaultProps) {
    // Resolve default props. Taken from ReactElement
    var props = _assign({}, baseProps);

    var defaultProps = Component.defaultProps;

    for (var propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }

    return props;
  }

  return baseProps;
}

// Max 31 bit integer. The max integer size in V8 for 32-bit systems.
// Math.pow(2, 30) - 1
// 0b111111111111111111111111111111
var MAX_SIGNED_31_BIT_INT = 1073741823;

var valueCursor = createCursor(null);
var rendererSigil;

{
  // Use this to detect multiple renderers using the same context
  rendererSigil = {};
}

var currentlyRenderingFiber = null;
var lastContextDependency = null;
var lastContextWithAllBitsObserved = null;
var isDisallowedContextReadInDEV = false;
function resetContextDependencies() {
  // This is called right before React yields execution, to ensure `readContext`
  // cannot be called outside the render phase.
  currentlyRenderingFiber = null;
  lastContextDependency = null;
  lastContextWithAllBitsObserved = null;

  {
    isDisallowedContextReadInDEV = false;
  }
}
function enterDisallowedContextReadInDEV() {
  {
    isDisallowedContextReadInDEV = true;
  }
}
function exitDisallowedContextReadInDEV() {
  {
    isDisallowedContextReadInDEV = false;
  }
}
function pushProvider(providerFiber, nextValue) {
  var context = providerFiber.type._context;

  {
    push(valueCursor, context._currentValue, providerFiber);
    context._currentValue = nextValue;

    {
      if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
        error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
      }

      context._currentRenderer = rendererSigil;
    }
  }
}
function popProvider(providerFiber) {
  var currentValue = valueCursor.current;
  pop(valueCursor, providerFiber);
  var context = providerFiber.type._context;

  {
    context._currentValue = currentValue;
  }
}
function calculateChangedBits(context, newValue, oldValue) {
  if (objectIs(oldValue, newValue)) {
    // No change
    return 0;
  } else {
    var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

    {
      if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
        error('calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
      }
    }

    return changedBits | 0;
  }
}
function scheduleWorkOnParentPath(parent, renderLanes) {
  // Update the child lanes of all the ancestors, including the alternates.
  var node = parent;

  while (node !== null) {
    var alternate = node.alternate;

    if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
      node.childLanes = mergeLanes(node.childLanes, renderLanes);

      if (alternate !== null) {
        alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
      }
    } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) {
      alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
    } else {
      // Neither alternate was updated, which means the rest of the
      // ancestor path already has sufficient priority.
      break;
    }

    node = node.return;
  }
}
function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
  var fiber = workInProgress.child;

  if (fiber !== null) {
    // Set the return pointer of the child to the work-in-progress fiber.
    fiber.return = workInProgress;
  }

  while (fiber !== null) {
    var nextFiber = void 0; // Visit this fiber.

    var list = fiber.dependencies;

    if (list !== null) {
      nextFiber = fiber.child;
      var dependency = list.firstContext;

      while (dependency !== null) {
        // Check if the context matches.
        if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
          // Match! Schedule an update on this fiber.
          if (fiber.tag === ClassComponent) {
            // Schedule a force update on the work-in-progress.
            var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
            // update to the current fiber, too, which means it will persist even if
            // this render is thrown away. Since it's a race condition, not sure it's
            // worth fixing.

            enqueueUpdate(fiber, update);
          }

          fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
          var alternate = fiber.alternate;

          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
          }

          scheduleWorkOnParentPath(fiber.return, renderLanes); // Mark the updated lanes on the list, too.

          list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
          // dependency list.

          break;
        }

        dependency = dependency.next;
      }
    } else if (fiber.tag === ContextProvider) {
      // Don't scan deeper if this is a matching provider
      nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
    } else {
      // Traverse down.
      nextFiber = fiber.child;
    }

    if (nextFiber !== null) {
      // Set the return pointer of the child to the work-in-progress fiber.
      nextFiber.return = fiber;
    } else {
      // No child. Traverse to next sibling.
      nextFiber = fiber;

      while (nextFiber !== null) {
        if (nextFiber === workInProgress) {
          // We're back to the root of this subtree. Exit.
          nextFiber = null;
          break;
        }

        var sibling = nextFiber.sibling;

        if (sibling !== null) {
          // Set the return pointer of the sibling to the work-in-progress fiber.
          sibling.return = nextFiber.return;
          nextFiber = sibling;
          break;
        } // No more siblings. Traverse up.


        nextFiber = nextFiber.return;
      }
    }

    fiber = nextFiber;
  }
}
function prepareToReadContext(workInProgress, renderLanes) {
  currentlyRenderingFiber = workInProgress;
  lastContextDependency = null;
  lastContextWithAllBitsObserved = null;
  var dependencies = workInProgress.dependencies;

  if (dependencies !== null) {
    var firstContext = dependencies.firstContext;

    if (firstContext !== null) {
      if (includesSomeLane(dependencies.lanes, renderLanes)) {
        // Context list has a pending update. Mark that this fiber performed work.
        markWorkInProgressReceivedUpdate();
      } // Reset the work-in-progress list


      dependencies.firstContext = null;
    }
  }
}
function readContext(context, observedBits) {
  {
    // This warning would fire if you read context inside a Hook like useMemo.
    // Unlike the class check below, it's not enforced in production for perf.
    if (isDisallowedContextReadInDEV) {
      error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
    }
  }

  if (lastContextWithAllBitsObserved === context) ; else if (observedBits === false || observedBits === 0) ; else {
    var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.

    if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
      // Observe all updates.
      lastContextWithAllBitsObserved = context;
      resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
    } else {
      resolvedObservedBits = observedBits;
    }

    var contextItem = {
      context: context,
      observedBits: resolvedObservedBits,
      next: null
    };

    if (lastContextDependency === null) {
      if (!(currentlyRenderingFiber !== null)) {
        {
          throw Error( "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()." );
        }
      } // This is the first dependency for this component. Create a new list.


      lastContextDependency = contextItem;
      currentlyRenderingFiber.dependencies = {
        lanes: NoLanes,
        firstContext: contextItem,
        responders: null
      };
    } else {
      // Append a new context item.
      lastContextDependency = lastContextDependency.next = contextItem;
    }
  }

  return  context._currentValue ;
}

var UpdateState = 0;
var ReplaceState = 1;
var ForceUpdate = 2;
var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
// It should only be read right after calling `processUpdateQueue`, via
// `checkHasForceUpdateAfterProcessing`.

var hasForceUpdate = false;
var didWarnUpdateInsideUpdate;
var currentlyProcessingQueue;

{
  didWarnUpdateInsideUpdate = false;
  currentlyProcessingQueue = null;
}

function initializeUpdateQueue(fiber) {
  var queue = {
    baseState: fiber.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null
    },
    effects: null
  };
  fiber.updateQueue = queue;
}
function cloneUpdateQueue(current, workInProgress) {
  // Clone the update queue from current. Unless it's already a clone.
  var queue = workInProgress.updateQueue;
  var currentQueue = current.updateQueue;

  if (queue === currentQueue) {
    var clone = {
      baseState: currentQueue.baseState,
      firstBaseUpdate: currentQueue.firstBaseUpdate,
      lastBaseUpdate: currentQueue.lastBaseUpdate,
      shared: currentQueue.shared,
      effects: currentQueue.effects
    };
    workInProgress.updateQueue = clone;
  }
}
function createUpdate(eventTime, lane) {
  var update = {
    eventTime: eventTime,
    lane: lane,
    tag: UpdateState,
    payload: null,
    callback: null,
    next: null
  };
  return update;
}
function enqueueUpdate(fiber, update) {
  var updateQueue = fiber.updateQueue;

  if (updateQueue === null) {
    // Only occurs if the fiber has been unmounted.
    return;
  }

  var sharedQueue = updateQueue.shared;
  var pending = sharedQueue.pending;

  if (pending === null) {
    // This is the first update. Create a circular list.
    update.next = update;
  } else {
    update.next = pending.next;
    pending.next = update;
  }

  sharedQueue.pending = update;

  {
    if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
      error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');

      didWarnUpdateInsideUpdate = true;
    }
  }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
  // Captured updates are updates that are thrown by a child during the render
  // phase. They should be discarded if the render is aborted. Therefore,
  // we should only put them on the work-in-progress queue, not the current one.
  var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.

  var current = workInProgress.alternate;

  if (current !== null) {
    var currentQueue = current.updateQueue;

    if (queue === currentQueue) {
      // The work-in-progress queue is the same as current. This happens when
      // we bail out on a parent fiber that then captures an error thrown by
      // a child. Since we want to append the update only to the work-in
      // -progress queue, we need to clone the updates. We usually clone during
      // processUpdateQueue, but that didn't happen in this case because we
      // skipped over the parent when we bailed out.
      var newFirst = null;
      var newLast = null;
      var firstBaseUpdate = queue.firstBaseUpdate;

      if (firstBaseUpdate !== null) {
        // Loop through the updates and clone them.
        var update = firstBaseUpdate;

        do {
          var clone = {
            eventTime: update.eventTime,
            lane: update.lane,
            tag: update.tag,
            payload: update.payload,
            callback: update.callback,
            next: null
          };

          if (newLast === null) {
            newFirst = newLast = clone;
          } else {
            newLast.next = clone;
            newLast = clone;
          }

          update = update.next;
        } while (update !== null); // Append the captured update the end of the cloned list.


        if (newLast === null) {
          newFirst = newLast = capturedUpdate;
        } else {
          newLast.next = capturedUpdate;
          newLast = capturedUpdate;
        }
      } else {
        // There are no base updates.
        newFirst = newLast = capturedUpdate;
      }

      queue = {
        baseState: currentQueue.baseState,
        firstBaseUpdate: newFirst,
        lastBaseUpdate: newLast,
        shared: currentQueue.shared,
        effects: currentQueue.effects
      };
      workInProgress.updateQueue = queue;
      return;
    }
  } // Append the update to the end of the list.


  var lastBaseUpdate = queue.lastBaseUpdate;

  if (lastBaseUpdate === null) {
    queue.firstBaseUpdate = capturedUpdate;
  } else {
    lastBaseUpdate.next = capturedUpdate;
  }

  queue.lastBaseUpdate = capturedUpdate;
}

function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
  switch (update.tag) {
    case ReplaceState:
      {
        var payload = update.payload;

        if (typeof payload === 'function') {
          // Updater function
          {
            enterDisallowedContextReadInDEV();
          }

          var nextState = payload.call(instance, prevState, nextProps);

          {
            if ( workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                payload.call(instance, prevState, nextProps);
              } finally {
                reenableLogs();
              }
            }

            exitDisallowedContextReadInDEV();
          }

          return nextState;
        } // State object


        return payload;
      }

    case CaptureUpdate:
      {
        workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
      }
    // Intentional fallthrough

    case UpdateState:
      {
        var _payload = update.payload;
        var partialState;

        if (typeof _payload === 'function') {
          // Updater function
          {
            enterDisallowedContextReadInDEV();
          }

          partialState = _payload.call(instance, prevState, nextProps);

          {
            if ( workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                _payload.call(instance, prevState, nextProps);
              } finally {
                reenableLogs();
              }
            }

            exitDisallowedContextReadInDEV();
          }
        } else {
          // Partial state object
          partialState = _payload;
        }

        if (partialState === null || partialState === undefined) {
          // Null and undefined are treated as no-ops.
          return prevState;
        } // Merge the partial state and the previous state.


        return _assign({}, prevState, partialState);
      }

    case ForceUpdate:
      {
        hasForceUpdate = true;
        return prevState;
      }
  }

  return prevState;
}

function processUpdateQueue(workInProgress, props, instance, renderLanes) {
  // This is always non-null on a ClassComponent or HostRoot
  var queue = workInProgress.updateQueue;
  hasForceUpdate = false;

  {
    currentlyProcessingQueue = queue.shared;
  }

  var firstBaseUpdate = queue.firstBaseUpdate;
  var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.

  var pendingQueue = queue.shared.pending;

  if (pendingQueue !== null) {
    queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
    // and last so that it's non-circular.

    var lastPendingUpdate = pendingQueue;
    var firstPendingUpdate = lastPendingUpdate.next;
    lastPendingUpdate.next = null; // Append pending updates to base queue

    if (lastBaseUpdate === null) {
      firstBaseUpdate = firstPendingUpdate;
    } else {
      lastBaseUpdate.next = firstPendingUpdate;
    }

    lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
    // we need to transfer the updates to that queue, too. Because the base
    // queue is a singly-linked list with no cycles, we can append to both
    // lists and take advantage of structural sharing.
    // TODO: Pass `current` as argument

    var current = workInProgress.alternate;

    if (current !== null) {
      // This is always non-null on a ClassComponent or HostRoot
      var currentQueue = current.updateQueue;
      var currentLastBaseUpdate = currentQueue.lastBaseUpdate;

      if (currentLastBaseUpdate !== lastBaseUpdate) {
        if (currentLastBaseUpdate === null) {
          currentQueue.firstBaseUpdate = firstPendingUpdate;
        } else {
          currentLastBaseUpdate.next = firstPendingUpdate;
        }

        currentQueue.lastBaseUpdate = lastPendingUpdate;
      }
    }
  } // These values may change as we process the queue.


  if (firstBaseUpdate !== null) {
    // Iterate through the list of updates to compute the result.
    var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
    // from the original lanes.

    var newLanes = NoLanes;
    var newBaseState = null;
    var newFirstBaseUpdate = null;
    var newLastBaseUpdate = null;
    var update = firstBaseUpdate;

    do {
      var updateLane = update.lane;
      var updateEventTime = update.eventTime;

      if (!isSubsetOfLanes(renderLanes, updateLane)) {
        // Priority is insufficient. Skip this update. If this is the first
        // skipped update, the previous update/state is the new base
        // update/state.
        var clone = {
          eventTime: updateEventTime,
          lane: updateLane,
          tag: update.tag,
          payload: update.payload,
          callback: update.callback,
          next: null
        };

        if (newLastBaseUpdate === null) {
          newFirstBaseUpdate = newLastBaseUpdate = clone;
          newBaseState = newState;
        } else {
          newLastBaseUpdate = newLastBaseUpdate.next = clone;
        } // Update the remaining priority in the queue.


        newLanes = mergeLanes(newLanes, updateLane);
      } else {
        // This update does have sufficient priority.
        if (newLastBaseUpdate !== null) {
          var _clone = {
            eventTime: updateEventTime,
            // This update is going to be committed so we never want uncommit
            // it. Using NoLane works because 0 is a subset of all bitmasks, so
            // this will never be skipped by the check above.
            lane: NoLane,
            tag: update.tag,
            payload: update.payload,
            callback: update.callback,
            next: null
          };
          newLastBaseUpdate = newLastBaseUpdate.next = _clone;
        } // Process this update.


        newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
        var callback = update.callback;

        if (callback !== null) {
          workInProgress.flags |= Callback;
          var effects = queue.effects;

          if (effects === null) {
            queue.effects = [update];
          } else {
            effects.push(update);
          }
        }
      }

      update = update.next;

      if (update === null) {
        pendingQueue = queue.shared.pending;

        if (pendingQueue === null) {
          break;
        } else {
          // An update was scheduled from inside a reducer. Add the new
          // pending updates to the end of the list and keep processing.
          var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
          // unravel them when transferring them to the base queue.

          var _firstPendingUpdate = _lastPendingUpdate.next;
          _lastPendingUpdate.next = null;
          update = _firstPendingUpdate;
          queue.lastBaseUpdate = _lastPendingUpdate;
          queue.shared.pending = null;
        }
      }
    } while (true);

    if (newLastBaseUpdate === null) {
      newBaseState = newState;
    }

    queue.baseState = newBaseState;
    queue.firstBaseUpdate = newFirstBaseUpdate;
    queue.lastBaseUpdate = newLastBaseUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
    // This should be fine because the only two other things that contribute to
    // expiration time are props and context. We're already in the middle of the
    // begin phase by the time we start processing the queue, so we've already
    // dealt with the props. Context in components that specify
    // shouldComponentUpdate is tricky; but we'll have to account for
    // that regardless.

    markSkippedUpdateLanes(newLanes);
    workInProgress.lanes = newLanes;
    workInProgress.memoizedState = newState;
  }

  {
    currentlyProcessingQueue = null;
  }
}

function callCallback(callback, context) {
  if (!(typeof callback === 'function')) {
    {
      throw Error( "Invalid argument passed as callback. Expected a function. Instead received: " + callback );
    }
  }

  callback.call(context);
}

function resetHasForceUpdateBeforeProcessing() {
  hasForceUpdate = false;
}
function checkHasForceUpdateAfterProcessing() {
  return hasForceUpdate;
}
function commitUpdateQueue(finishedWork, finishedQueue, instance) {
  // Commit the effects
  var effects = finishedQueue.effects;
  finishedQueue.effects = null;

  if (effects !== null) {
    for (var i = 0; i < effects.length; i++) {
      var effect = effects[i];
      var callback = effect.callback;

      if (callback !== null) {
        effect.callback = null;
        callCallback(callback, instance);
      }
    }
  }
}

var fakeInternalInstance = {};
var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
// We'll use it to determine whether we need to initialize legacy refs.

var emptyRefsObject = new React$1.Component().refs;
var didWarnAboutStateAssignmentForComponent;
var didWarnAboutUninitializedState;
var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
var didWarnAboutLegacyLifecyclesAndDerivedState;
var didWarnAboutUndefinedDerivedState;
var warnOnUndefinedDerivedState;
var warnOnInvalidCallback;
var didWarnAboutDirectlyAssigningPropsToState;
var didWarnAboutContextTypeAndContextTypes;
var didWarnAboutInvalidateContextType;

{
  didWarnAboutStateAssignmentForComponent = new Set();
  didWarnAboutUninitializedState = new Set();
  didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
  didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
  didWarnAboutDirectlyAssigningPropsToState = new Set();
  didWarnAboutUndefinedDerivedState = new Set();
  didWarnAboutContextTypeAndContextTypes = new Set();
  didWarnAboutInvalidateContextType = new Set();
  var didWarnOnInvalidCallback = new Set();

  warnOnInvalidCallback = function (callback, callerName) {
    if (callback === null || typeof callback === 'function') {
      return;
    }

    var key = callerName + '_' + callback;

    if (!didWarnOnInvalidCallback.has(key)) {
      didWarnOnInvalidCallback.add(key);

      error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
    }
  };

  warnOnUndefinedDerivedState = function (type, partialState) {
    if (partialState === undefined) {
      var componentName = getComponentName(type) || 'Component';

      if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
        didWarnAboutUndefinedDerivedState.add(componentName);

        error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
      }
    }
  }; // This is so gross but it's at least non-critical and can be removed if
  // it causes problems. This is meant to give a nicer error message for
  // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
  // ...)) which otherwise throws a "_processChildContext is not a function"
  // exception.


  Object.defineProperty(fakeInternalInstance, '_processChildContext', {
    enumerable: false,
    value: function () {
      {
        {
          throw Error( "_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal)." );
        }
      }
    }
  });
  Object.freeze(fakeInternalInstance);
}

function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
  var prevState = workInProgress.memoizedState;

  {
    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        // Invoke the function an extra time to help detect side-effects.
        getDerivedStateFromProps(nextProps, prevState);
      } finally {
        reenableLogs();
      }
    }
  }

  var partialState = getDerivedStateFromProps(nextProps, prevState);

  {
    warnOnUndefinedDerivedState(ctor, partialState);
  } // Merge the partial state and the previous state.


  var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
  workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
  // base state.

  if (workInProgress.lanes === NoLanes) {
    // Queue is always non-null for classes
    var updateQueue = workInProgress.updateQueue;
    updateQueue.baseState = memoizedState;
  }
}
var classComponentUpdater = {
  isMounted: isMounted,
  enqueueSetState: function (inst, payload, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.payload = payload;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'setState');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  },
  enqueueReplaceState: function (inst, payload, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.tag = ReplaceState;
    update.payload = payload;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'replaceState');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  },
  enqueueForceUpdate: function (inst, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.tag = ForceUpdate;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'forceUpdate');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  }
};

function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
  var instance = workInProgress.stateNode;

  if (typeof instance.shouldComponentUpdate === 'function') {
    {
      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          // Invoke the function an extra time to help detect side-effects.
          instance.shouldComponentUpdate(newProps, newState, nextContext);
        } finally {
          reenableLogs();
        }
      }
    }

    var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);

    {
      if (shouldUpdate === undefined) {
        error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component');
      }
    }

    return shouldUpdate;
  }

  if (ctor.prototype && ctor.prototype.isPureReactComponent) {
    return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
  }

  return true;
}

function checkClassInstance(workInProgress, ctor, newProps) {
  var instance = workInProgress.stateNode;

  {
    var name = getComponentName(ctor) || 'Component';
    var renderPresent = instance.render;

    if (!renderPresent) {
      if (ctor.prototype && typeof ctor.prototype.render === 'function') {
        error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
      } else {
        error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
      }
    }

    if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
      error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
    }

    if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
    }

    if (instance.propTypes) {
      error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
    }

    if (instance.contextType) {
      error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
    }

    {
      if (instance.contextTypes) {
        error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
      }

      if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
        didWarnAboutContextTypeAndContextTypes.add(ctor);

        error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
      }
    }

    if (typeof instance.componentShouldUpdate === 'function') {
      error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
    }

    if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
      error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
    }

    if (typeof instance.componentDidUnmount === 'function') {
      error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
    }

    if (typeof instance.componentDidReceiveProps === 'function') {
      error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
    }

    if (typeof instance.componentWillRecieveProps === 'function') {
      error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
    }

    if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
      error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
    }

    var hasMutatedProps = instance.props !== newProps;

    if (instance.props !== undefined && hasMutatedProps) {
      error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
    }

    if (instance.defaultProps) {
      error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
      didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);

      error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
    }

    if (typeof instance.getDerivedStateFromProps === 'function') {
      error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
    }

    if (typeof instance.getDerivedStateFromError === 'function') {
      error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
    }

    if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
      error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
    }

    var _state = instance.state;

    if (_state && (typeof _state !== 'object' || isArray(_state))) {
      error('%s.state: must be set to an object or null', name);
    }

    if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
      error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
    }
  }
}

function adoptClassInstance(workInProgress, instance) {
  instance.updater = classComponentUpdater;
  workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

  set(instance, workInProgress);

  {
    instance._reactInternalInstance = fakeInternalInstance;
  }
}

function constructClassInstance(workInProgress, ctor, props) {
  var isLegacyContextConsumer = false;
  var unmaskedContext = emptyContextObject;
  var context = emptyContextObject;
  var contextType = ctor.contextType;

  {
    if ('contextType' in ctor) {
      var isValid = // Allow null for conditional declaration
      contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

      if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
        didWarnAboutInvalidateContextType.add(ctor);
        var addendum = '';

        if (contextType === undefined) {
          addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
        } else if (typeof contextType !== 'object') {
          addendum = ' However, it is set to a ' + typeof contextType + '.';
        } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
          addendum = ' Did you accidentally pass the Context.Provider instead?';
        } else if (contextType._context !== undefined) {
          // <Context.Consumer>
          addendum = ' Did you accidentally pass the Context.Consumer instead?';
        } else {
          addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
        }

        error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(ctor) || 'Component', addendum);
      }
    }
  }

  if (typeof contextType === 'object' && contextType !== null) {
    context = readContext(contextType);
  } else {
    unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    var contextTypes = ctor.contextTypes;
    isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
    context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
  } // Instantiate twice to help detect side-effects.


  {
    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        new ctor(props, context); // eslint-disable-line no-new
      } finally {
        reenableLogs();
      }
    }
  }

  var instance = new ctor(props, context);
  var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
  adoptClassInstance(workInProgress, instance);

  {
    if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
      var componentName = getComponentName(ctor) || 'Component';

      if (!didWarnAboutUninitializedState.has(componentName)) {
        didWarnAboutUninitializedState.add(componentName);

        error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
      }
    } // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Warn about these lifecycles if they are present.
    // Don't warn about react-lifecycles-compat polyfilled methods though.


    if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
      var foundWillMountName = null;
      var foundWillReceivePropsName = null;
      var foundWillUpdateName = null;

      if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
        foundWillMountName = 'componentWillMount';
      } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
        foundWillMountName = 'UNSAFE_componentWillMount';
      }

      if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
        foundWillReceivePropsName = 'componentWillReceiveProps';
      } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
        foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
      }

      if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
        foundWillUpdateName = 'componentWillUpdate';
      } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
        foundWillUpdateName = 'UNSAFE_componentWillUpdate';
      }

      if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var _componentName = getComponentName(ctor) || 'Component';

        var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

        if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
          didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);

          error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
        }
      }
    }
  } // Cache unmasked context so we can avoid recreating masked context unless necessary.
  // ReactFiberContext usually updates this cache but can't for newly-created instances.


  if (isLegacyContextConsumer) {
    cacheContext(workInProgress, unmaskedContext, context);
  }

  return instance;
}

function callComponentWillMount(workInProgress, instance) {
  var oldState = instance.state;

  if (typeof instance.componentWillMount === 'function') {
    instance.componentWillMount();
  }

  if (typeof instance.UNSAFE_componentWillMount === 'function') {
    instance.UNSAFE_componentWillMount();
  }

  if (oldState !== instance.state) {
    {
      error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
    }

    classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
}

function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
  var oldState = instance.state;

  if (typeof instance.componentWillReceiveProps === 'function') {
    instance.componentWillReceiveProps(newProps, nextContext);
  }

  if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
    instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
  }

  if (instance.state !== oldState) {
    {
      var componentName = getComponentName(workInProgress.type) || 'Component';

      if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
        didWarnAboutStateAssignmentForComponent.add(componentName);

        error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
      }
    }

    classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
} // Invokes the mount life-cycles on a previously never rendered instance.


function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
  {
    checkClassInstance(workInProgress, ctor, newProps);
  }

  var instance = workInProgress.stateNode;
  instance.props = newProps;
  instance.state = workInProgress.memoizedState;
  instance.refs = emptyRefsObject;
  initializeUpdateQueue(workInProgress);
  var contextType = ctor.contextType;

  if (typeof contextType === 'object' && contextType !== null) {
    instance.context = readContext(contextType);
  } else {
    var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    instance.context = getMaskedContext(workInProgress, unmaskedContext);
  }

  {
    if (instance.state === newProps) {
      var componentName = getComponentName(ctor) || 'Component';

      if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
        didWarnAboutDirectlyAssigningPropsToState.add(componentName);

        error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
      }
    }

    if (workInProgress.mode & StrictMode) {
      ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
    }

    {
      ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
    }
  }

  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  instance.state = workInProgress.memoizedState;
  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    instance.state = workInProgress.memoizedState;
  } // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.


  if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
    callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
    // process them now.

    processUpdateQueue(workInProgress, newProps, instance, renderLanes);
    instance.state = workInProgress.memoizedState;
  }

  if (typeof instance.componentDidMount === 'function') {
    workInProgress.flags |= Update;
  }
}

function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
  var instance = workInProgress.stateNode;
  var oldProps = workInProgress.memoizedProps;
  instance.props = oldProps;
  var oldContext = instance.context;
  var contextType = ctor.contextType;
  var nextContext = emptyContextObject;

  if (typeof contextType === 'object' && contextType !== null) {
    nextContext = readContext(contextType);
  } else {
    var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
  }

  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
  var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
  // ever the previously attempted to render - not the "current". However,
  // during componentDidUpdate we pass the "current" props.
  // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.

  if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
    if (oldProps !== newProps || oldContext !== nextContext) {
      callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
    }
  }

  resetHasForceUpdateBeforeProcessing();
  var oldState = workInProgress.memoizedState;
  var newState = instance.state = oldState;
  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  newState = workInProgress.memoizedState;

  if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    }

    return false;
  }

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    newState = workInProgress.memoizedState;
  }

  var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

  if (shouldUpdate) {
    // In order to support react-lifecycles-compat polyfilled components,
    // Unsafe lifecycles should not be invoked for components using the new APIs.
    if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
      if (typeof instance.componentWillMount === 'function') {
        instance.componentWillMount();
      }

      if (typeof instance.UNSAFE_componentWillMount === 'function') {
        instance.UNSAFE_componentWillMount();
      }
    }

    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    }
  } else {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    } // If shouldComponentUpdate returned false, we should still update the
    // memoized state to indicate that this work can be reused.


    workInProgress.memoizedProps = newProps;
    workInProgress.memoizedState = newState;
  } // Update the existing instance's state, props, and context pointers even
  // if shouldComponentUpdate returns false.


  instance.props = newProps;
  instance.state = newState;
  instance.context = nextContext;
  return shouldUpdate;
} // Invokes the update life-cycles and returns false if it shouldn't rerender.


function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
  var instance = workInProgress.stateNode;
  cloneUpdateQueue(current, workInProgress);
  var unresolvedOldProps = workInProgress.memoizedProps;
  var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
  instance.props = oldProps;
  var unresolvedNewProps = workInProgress.pendingProps;
  var oldContext = instance.context;
  var contextType = ctor.contextType;
  var nextContext = emptyContextObject;

  if (typeof contextType === 'object' && contextType !== null) {
    nextContext = readContext(contextType);
  } else {
    var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
  }

  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
  var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
  // ever the previously attempted to render - not the "current". However,
  // during componentDidUpdate we pass the "current" props.
  // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.

  if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
    if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
      callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
    }
  }

  resetHasForceUpdateBeforeProcessing();
  var oldState = workInProgress.memoizedState;
  var newState = instance.state = oldState;
  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  newState = workInProgress.memoizedState;

  if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Update;
      }
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Snapshot;
      }
    }

    return false;
  }

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    newState = workInProgress.memoizedState;
  }

  var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

  if (shouldUpdate) {
    // In order to support react-lifecycles-compat polyfilled components,
    // Unsafe lifecycles should not be invoked for components using the new APIs.
    if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
      if (typeof instance.componentWillUpdate === 'function') {
        instance.componentWillUpdate(newProps, newState, nextContext);
      }

      if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
        instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
      }
    }

    if (typeof instance.componentDidUpdate === 'function') {
      workInProgress.flags |= Update;
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      workInProgress.flags |= Snapshot;
    }
  } else {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Update;
      }
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Snapshot;
      }
    } // If shouldComponentUpdate returned false, we should still update the
    // memoized props/state to indicate that this work can be reused.


    workInProgress.memoizedProps = newProps;
    workInProgress.memoizedState = newState;
  } // Update the existing instance's state, props, and context pointers even
  // if shouldComponentUpdate returns false.


  instance.props = newProps;
  instance.state = newState;
  instance.context = nextContext;
  return shouldUpdate;
}

var didWarnAboutMaps;
var didWarnAboutGenerators;
var didWarnAboutStringRefs;
var ownerHasKeyUseWarning;
var ownerHasFunctionTypeWarning;

var warnForMissingKey = function (child, returnFiber) {};

{
  didWarnAboutMaps = false;
  didWarnAboutGenerators = false;
  didWarnAboutStringRefs = {};
  /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */

  ownerHasKeyUseWarning = {};
  ownerHasFunctionTypeWarning = {};

  warnForMissingKey = function (child, returnFiber) {
    if (child === null || typeof child !== 'object') {
      return;
    }

    if (!child._store || child._store.validated || child.key != null) {
      return;
    }

    if (!(typeof child._store === 'object')) {
      {
        throw Error( "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    child._store.validated = true;
    var componentName = getComponentName(returnFiber.type) || 'Component';

    if (ownerHasKeyUseWarning[componentName]) {
      return;
    }

    ownerHasKeyUseWarning[componentName] = true;

    error('Each child in a list should have a unique ' + '"key" prop. See https://reactjs.org/link/warning-keys for ' + 'more information.');
  };
}

var isArray$1 = Array.isArray;

function coerceRef(returnFiber, current, element) {
  var mixedRef = element.ref;

  if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
    {
      // TODO: Clean this up once we turn on the string ref warning for
      // everyone, because the strict mode case will no longer be relevant
      if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
      // because these cannot be automatically converted to an arrow function
      // using a codemod. Therefore, we don't have to warn about string refs again.
      !(element._owner && element._self && element._owner.stateNode !== element._self)) {
        var componentName = getComponentName(returnFiber.type) || 'Component';

        if (!didWarnAboutStringRefs[componentName]) {
          {
            error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', mixedRef);
          }

          didWarnAboutStringRefs[componentName] = true;
        }
      }
    }

    if (element._owner) {
      var owner = element._owner;
      var inst;

      if (owner) {
        var ownerFiber = owner;

        if (!(ownerFiber.tag === ClassComponent)) {
          {
            throw Error( "Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref" );
          }
        }

        inst = ownerFiber.stateNode;
      }

      if (!inst) {
        {
          throw Error( "Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue." );
        }
      }

      var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

      if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
        return current.ref;
      }

      var ref = function (value) {
        var refs = inst.refs;

        if (refs === emptyRefsObject) {
          // This is a lazy pooled frozen object, so we need to initialize.
          refs = inst.refs = {};
        }

        if (value === null) {
          delete refs[stringRef];
        } else {
          refs[stringRef] = value;
        }
      };

      ref._stringRef = stringRef;
      return ref;
    } else {
      if (!(typeof mixedRef === 'string')) {
        {
          throw Error( "Expected ref to be a function, a string, an object returned by React.createRef(), or null." );
        }
      }

      if (!element._owner) {
        {
          throw Error( "Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information." );
        }
      }
    }
  }

  return mixedRef;
}

function throwOnInvalidObjectType(returnFiber, newChild) {
  if (returnFiber.type !== 'textarea') {
    {
      {
        throw Error( "Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + "). If you meant to render a collection of children, use an array instead." );
      }
    }
  }
}

function warnOnFunctionType(returnFiber) {
  {
    var componentName = getComponentName(returnFiber.type) || 'Component';

    if (ownerHasFunctionTypeWarning[componentName]) {
      return;
    }

    ownerHasFunctionTypeWarning[componentName] = true;

    error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
  }
} // We avoid inlining this to avoid potential deopts from using try/catch.
// to be able to optimize each path individually by branching early. This needs
// a compiler or we can do it manually. Helpers that don't need this branching
// live outside of this function.


function ChildReconciler(shouldTrackSideEffects) {
  function deleteChild(returnFiber, childToDelete) {
    if (!shouldTrackSideEffects) {
      // Noop.
      return;
    } // Deletions are added in reversed order so we add it to the front.
    // At this point, the return fiber's effect list is empty except for
    // deletions, so we can just append the deletion to the list. The remaining
    // effects aren't added until the complete phase. Once we implement
    // resuming, this may not be true.


    var last = returnFiber.lastEffect;

    if (last !== null) {
      last.nextEffect = childToDelete;
      returnFiber.lastEffect = childToDelete;
    } else {
      returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }

    childToDelete.nextEffect = null;
    childToDelete.flags = Deletion;
  }

  function deleteRemainingChildren(returnFiber, currentFirstChild) {
    if (!shouldTrackSideEffects) {
      // Noop.
      return null;
    } // TODO: For the shouldClone case, this could be micro-optimized a bit by
    // assuming that after the first child we've already added everything.


    var childToDelete = currentFirstChild;

    while (childToDelete !== null) {
      deleteChild(returnFiber, childToDelete);
      childToDelete = childToDelete.sibling;
    }

    return null;
  }

  function mapRemainingChildren(returnFiber, currentFirstChild) {
    // Add the remaining children to a temporary map so that we can find them by
    // keys quickly. Implicit (null) keys get added to this set with their index
    // instead.
    var existingChildren = new Map();
    var existingChild = currentFirstChild;

    while (existingChild !== null) {
      if (existingChild.key !== null) {
        existingChildren.set(existingChild.key, existingChild);
      } else {
        existingChildren.set(existingChild.index, existingChild);
      }

      existingChild = existingChild.sibling;
    }

    return existingChildren;
  }

  function useFiber(fiber, pendingProps) {
    // We currently set sibling to null and index to 0 here because it is easy
    // to forget to do before returning it. E.g. for the single child case.
    var clone = createWorkInProgress(fiber, pendingProps);
    clone.index = 0;
    clone.sibling = null;
    return clone;
  }

  function placeChild(newFiber, lastPlacedIndex, newIndex) {
    newFiber.index = newIndex;

    if (!shouldTrackSideEffects) {
      // Noop.
      return lastPlacedIndex;
    }

    var current = newFiber.alternate;

    if (current !== null) {
      var oldIndex = current.index;

      if (oldIndex < lastPlacedIndex) {
        // This is a move.
        newFiber.flags = Placement;
        return lastPlacedIndex;
      } else {
        // This item can stay in place.
        return oldIndex;
      }
    } else {
      // This is an insertion.
      newFiber.flags = Placement;
      return lastPlacedIndex;
    }
  }

  function placeSingleChild(newFiber) {
    // This is simpler for the single child case. We only need to do a
    // placement for inserting new children.
    if (shouldTrackSideEffects && newFiber.alternate === null) {
      newFiber.flags = Placement;
    }

    return newFiber;
  }

  function updateTextNode(returnFiber, current, textContent, lanes) {
    if (current === null || current.tag !== HostText) {
      // Insert
      var created = createFiberFromText(textContent, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, textContent);
      existing.return = returnFiber;
      return existing;
    }
  }

  function updateElement(returnFiber, current, element, lanes) {
    if (current !== null) {
      if (current.elementType === element.type || ( // Keep this check inline so it only runs on the false path:
       isCompatibleFamilyForHotReloading(current, element) )) {
        // Move based on index
        var existing = useFiber(current, element.props);
        existing.ref = coerceRef(returnFiber, current, element);
        existing.return = returnFiber;

        {
          existing._debugSource = element._source;
          existing._debugOwner = element._owner;
        }

        return existing;
      }
    } // Insert


    var created = createFiberFromElement(element, returnFiber.mode, lanes);
    created.ref = coerceRef(returnFiber, current, element);
    created.return = returnFiber;
    return created;
  }

  function updatePortal(returnFiber, current, portal, lanes) {
    if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
      // Insert
      var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, portal.children || []);
      existing.return = returnFiber;
      return existing;
    }
  }

  function updateFragment(returnFiber, current, fragment, lanes, key) {
    if (current === null || current.tag !== Fragment) {
      // Insert
      var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, fragment);
      existing.return = returnFiber;
      return existing;
    }
  }

  function createChild(returnFiber, newChild, lanes) {
    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys. If the previous node is implicitly keyed
      // we can continue to replace it without aborting even if it is not a text
      // node.
      var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);

            _created.ref = coerceRef(returnFiber, null, newChild);
            _created.return = returnFiber;
            return _created;
          }

        case REACT_PORTAL_TYPE:
          {
            var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);

            _created2.return = returnFiber;
            return _created2;
          }
      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);

        _created3.return = returnFiber;
        return _created3;
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }

  function updateSlot(returnFiber, oldFiber, newChild, lanes) {
    // Update the fiber if the keys match, otherwise return null.
    var key = oldFiber !== null ? oldFiber.key : null;

    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys. If the previous node is implicitly keyed
      // we can continue to replace it without aborting even if it is not a text
      // node.
      if (key !== null) {
        return null;
      }

      return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            if (newChild.key === key) {
              if (newChild.type === REACT_FRAGMENT_TYPE) {
                return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
              }

              return updateElement(returnFiber, oldFiber, newChild, lanes);
            } else {
              return null;
            }
          }

        case REACT_PORTAL_TYPE:
          {
            if (newChild.key === key) {
              return updatePortal(returnFiber, oldFiber, newChild, lanes);
            } else {
              return null;
            }
          }
      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        if (key !== null) {
          return null;
        }

        return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }

  function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys, so we neither have to check the old nor
      // new node for the key. If both are text nodes, they match.
      var matchedFiber = existingChildren.get(newIdx) || null;
      return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

            if (newChild.type === REACT_FRAGMENT_TYPE) {
              return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
            }

            return updateElement(returnFiber, _matchedFiber, newChild, lanes);
          }

        case REACT_PORTAL_TYPE:
          {
            var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

            return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
          }

      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        var _matchedFiber3 = existingChildren.get(newIdx) || null;

        return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }
  /**
   * Warns if there is a duplicate or missing key
   */


  function warnOnInvalidKey(child, knownKeys, returnFiber) {
    {
      if (typeof child !== 'object' || child === null) {
        return knownKeys;
      }

      switch (child.$$typeof) {
        case REACT_ELEMENT_TYPE:
        case REACT_PORTAL_TYPE:
          warnForMissingKey(child, returnFiber);
          var key = child.key;

          if (typeof key !== 'string') {
            break;
          }

          if (knownKeys === null) {
            knownKeys = new Set();
            knownKeys.add(key);
            break;
          }

          if (!knownKeys.has(key)) {
            knownKeys.add(key);
            break;
          }

          error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);

          break;
      }
    }

    return knownKeys;
  }

  function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
    // This algorithm can't optimize by searching from both ends since we
    // don't have backpointers on fibers. I'm trying to see how far we can get
    // with that model. If it ends up not being worth the tradeoffs, we can
    // add it later.
    // Even with a two ended optimization, we'd want to optimize for the case
    // where there are few changes and brute force the comparison instead of
    // going for the Map. It'd like to explore hitting that path first in
    // forward-only mode and only go for the Map once we notice that we need
    // lots of look ahead. This doesn't handle reversal as well as two ended
    // search but that's unusual. Besides, for the two ended optimization to
    // work on Iterables, we'd need to copy the whole set.
    // In this first iteration, we'll just live with hitting the bad case
    // (adding everything to a Map) in for every insert/move.
    // If you change this code, also update reconcileChildrenIterator() which
    // uses the same algorithm.
    {
      // First, validate keys.
      var knownKeys = null;

      for (var i = 0; i < newChildren.length; i++) {
        var child = newChildren[i];
        knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
      }
    }

    var resultingFirstChild = null;
    var previousNewFiber = null;
    var oldFiber = currentFirstChild;
    var lastPlacedIndex = 0;
    var newIdx = 0;
    var nextOldFiber = null;

    for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
      if (oldFiber.index > newIdx) {
        nextOldFiber = oldFiber;
        oldFiber = null;
      } else {
        nextOldFiber = oldFiber.sibling;
      }

      var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);

      if (newFiber === null) {
        // TODO: This breaks on empty slots like null children. That's
        // unfortunate because it triggers the slow path all the time. We need
        // a better way to communicate whether this was a miss or null,
        // boolean, undefined, etc.
        if (oldFiber === null) {
          oldFiber = nextOldFiber;
        }

        break;
      }

      if (shouldTrackSideEffects) {
        if (oldFiber && newFiber.alternate === null) {
          // We matched the slot, but we didn't reuse the existing fiber, so we
          // need to delete the existing child.
          deleteChild(returnFiber, oldFiber);
        }
      }

      lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

      if (previousNewFiber === null) {
        // TODO: Move out of the loop. This only happens for the first run.
        resultingFirstChild = newFiber;
      } else {
        // TODO: Defer siblings if we're not at the right index for this slot.
        // I.e. if we had null values before, then we want to defer this
        // for each null value. However, we also don't want to call updateSlot
        // with the previous one.
        previousNewFiber.sibling = newFiber;
      }

      previousNewFiber = newFiber;
      oldFiber = nextOldFiber;
    }

    if (newIdx === newChildren.length) {
      // We've reached the end of the new children. We can delete the rest.
      deleteRemainingChildren(returnFiber, oldFiber);
      return resultingFirstChild;
    }

    if (oldFiber === null) {
      // If we don't have any more existing children we can choose a fast path
      // since the rest will all be insertions.
      for (; newIdx < newChildren.length; newIdx++) {
        var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);

        if (_newFiber === null) {
          continue;
        }

        lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          // TODO: Move out of the loop. This only happens for the first run.
          resultingFirstChild = _newFiber;
        } else {
          previousNewFiber.sibling = _newFiber;
        }

        previousNewFiber = _newFiber;
      }

      return resultingFirstChild;
    } // Add all children to a key map for quick lookups.


    var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

    for (; newIdx < newChildren.length; newIdx++) {
      var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);

      if (_newFiber2 !== null) {
        if (shouldTrackSideEffects) {
          if (_newFiber2.alternate !== null) {
            // The new fiber is a work in progress, but if there exists a
            // current, that means that we reused the fiber. We need to delete
            // it from the child list so that we don't add it to the deletion
            // list.
            existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
          }
        }

        lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          resultingFirstChild = _newFiber2;
        } else {
          previousNewFiber.sibling = _newFiber2;
        }

        previousNewFiber = _newFiber2;
      }
    }

    if (shouldTrackSideEffects) {
      // Any existing children that weren't consumed above were deleted. We need
      // to add them to the deletion list.
      existingChildren.forEach(function (child) {
        return deleteChild(returnFiber, child);
      });
    }

    return resultingFirstChild;
  }

  function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
    // This is the same implementation as reconcileChildrenArray(),
    // but using the iterator instead.
    var iteratorFn = getIteratorFn(newChildrenIterable);

    if (!(typeof iteratorFn === 'function')) {
      {
        throw Error( "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    {
      // We don't support rendering Generators because it's a mutation.
      // See https://github.com/facebook/react/issues/12995
      if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
      newChildrenIterable[Symbol.toStringTag] === 'Generator') {
        if (!didWarnAboutGenerators) {
          error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
        }

        didWarnAboutGenerators = true;
      } // Warn about using Maps as children


      if (newChildrenIterable.entries === iteratorFn) {
        if (!didWarnAboutMaps) {
          error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
        }

        didWarnAboutMaps = true;
      } // First, validate keys.
      // We'll get a different iterator later for the main pass.


      var _newChildren = iteratorFn.call(newChildrenIterable);

      if (_newChildren) {
        var knownKeys = null;

        var _step = _newChildren.next();

        for (; !_step.done; _step = _newChildren.next()) {
          var child = _step.value;
          knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
        }
      }
    }

    var newChildren = iteratorFn.call(newChildrenIterable);

    if (!(newChildren != null)) {
      {
        throw Error( "An iterable object provided no iterator." );
      }
    }

    var resultingFirstChild = null;
    var previousNewFiber = null;
    var oldFiber = currentFirstChild;
    var lastPlacedIndex = 0;
    var newIdx = 0;
    var nextOldFiber = null;
    var step = newChildren.next();

    for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
      if (oldFiber.index > newIdx) {
        nextOldFiber = oldFiber;
        oldFiber = null;
      } else {
        nextOldFiber = oldFiber.sibling;
      }

      var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);

      if (newFiber === null) {
        // TODO: This breaks on empty slots like null children. That's
        // unfortunate because it triggers the slow path all the time. We need
        // a better way to communicate whether this was a miss or null,
        // boolean, undefined, etc.
        if (oldFiber === null) {
          oldFiber = nextOldFiber;
        }

        break;
      }

      if (shouldTrackSideEffects) {
        if (oldFiber && newFiber.alternate === null) {
          // We matched the slot, but we didn't reuse the existing fiber, so we
          // need to delete the existing child.
          deleteChild(returnFiber, oldFiber);
        }
      }

      lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

      if (previousNewFiber === null) {
        // TODO: Move out of the loop. This only happens for the first run.
        resultingFirstChild = newFiber;
      } else {
        // TODO: Defer siblings if we're not at the right index for this slot.
        // I.e. if we had null values before, then we want to defer this
        // for each null value. However, we also don't want to call updateSlot
        // with the previous one.
        previousNewFiber.sibling = newFiber;
      }

      previousNewFiber = newFiber;
      oldFiber = nextOldFiber;
    }

    if (step.done) {
      // We've reached the end of the new children. We can delete the rest.
      deleteRemainingChildren(returnFiber, oldFiber);
      return resultingFirstChild;
    }

    if (oldFiber === null) {
      // If we don't have any more existing children we can choose a fast path
      // since the rest will all be insertions.
      for (; !step.done; newIdx++, step = newChildren.next()) {
        var _newFiber3 = createChild(returnFiber, step.value, lanes);

        if (_newFiber3 === null) {
          continue;
        }

        lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          // TODO: Move out of the loop. This only happens for the first run.
          resultingFirstChild = _newFiber3;
        } else {
          previousNewFiber.sibling = _newFiber3;
        }

        previousNewFiber = _newFiber3;
      }

      return resultingFirstChild;
    } // Add all children to a key map for quick lookups.


    var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

    for (; !step.done; newIdx++, step = newChildren.next()) {
      var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);

      if (_newFiber4 !== null) {
        if (shouldTrackSideEffects) {
          if (_newFiber4.alternate !== null) {
            // The new fiber is a work in progress, but if there exists a
            // current, that means that we reused the fiber. We need to delete
            // it from the child list so that we don't add it to the deletion
            // list.
            existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
          }
        }

        lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          resultingFirstChild = _newFiber4;
        } else {
          previousNewFiber.sibling = _newFiber4;
        }

        previousNewFiber = _newFiber4;
      }
    }

    if (shouldTrackSideEffects) {
      // Any existing children that weren't consumed above were deleted. We need
      // to add them to the deletion list.
      existingChildren.forEach(function (child) {
        return deleteChild(returnFiber, child);
      });
    }

    return resultingFirstChild;
  }

  function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
    // There's no need to check for keys on text nodes since we don't have a
    // way to define them.
    if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
      // We already have an existing node so let's just update it and delete
      // the rest.
      deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
      var existing = useFiber(currentFirstChild, textContent);
      existing.return = returnFiber;
      return existing;
    } // The existing first child is not a text node so we need to create one
    // and delete the existing ones.


    deleteRemainingChildren(returnFiber, currentFirstChild);
    var created = createFiberFromText(textContent, returnFiber.mode, lanes);
    created.return = returnFiber;
    return created;
  }

  function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
    var key = element.key;
    var child = currentFirstChild;

    while (child !== null) {
      // TODO: If key === null and child.key === null, then this only applies to
      // the first item in the list.
      if (child.key === key) {
        switch (child.tag) {
          case Fragment:
            {
              if (element.type === REACT_FRAGMENT_TYPE) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, element.props.children);
                existing.return = returnFiber;

                {
                  existing._debugSource = element._source;
                  existing._debugOwner = element._owner;
                }

                return existing;
              }

              break;
            }

          case Block:

          // We intentionally fallthrough here if enableBlocksAPI is not on.
          // eslint-disable-next-lined no-fallthrough

          default:
            {
              if (child.elementType === element.type || ( // Keep this check inline so it only runs on the false path:
               isCompatibleFamilyForHotReloading(child, element) )) {
                deleteRemainingChildren(returnFiber, child.sibling);

                var _existing3 = useFiber(child, element.props);

                _existing3.ref = coerceRef(returnFiber, child, element);
                _existing3.return = returnFiber;

                {
                  _existing3._debugSource = element._source;
                  _existing3._debugOwner = element._owner;
                }

                return _existing3;
              }

              break;
            }
        } // Didn't match.


        deleteRemainingChildren(returnFiber, child);
        break;
      } else {
        deleteChild(returnFiber, child);
      }

      child = child.sibling;
    }

    if (element.type === REACT_FRAGMENT_TYPE) {
      var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
      created.return = returnFiber;
      return created;
    } else {
      var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);

      _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
      _created4.return = returnFiber;
      return _created4;
    }
  }

  function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
    var key = portal.key;
    var child = currentFirstChild;

    while (child !== null) {
      // TODO: If key === null and child.key === null, then this only applies to
      // the first item in the list.
      if (child.key === key) {
        if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
          deleteRemainingChildren(returnFiber, child.sibling);
          var existing = useFiber(child, portal.children || []);
          existing.return = returnFiber;
          return existing;
        } else {
          deleteRemainingChildren(returnFiber, child);
          break;
        }
      } else {
        deleteChild(returnFiber, child);
      }

      child = child.sibling;
    }

    var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
    created.return = returnFiber;
    return created;
  } // This API will tag the children with the side-effect of the reconciliation
  // itself. They will be added to the side-effect list as we pass through the
  // children and the parent.


  function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
    // This function is not recursive.
    // If the top level item is an array, we treat it as a set of children,
    // not as a fragment. Nested arrays on the other hand will be treated as
    // fragment nodes. Recursion happens at the normal flow.
    // Handle top level unkeyed fragments as if they were arrays.
    // This leads to an ambiguity between <>{[...]}</> and <>...</>.
    // We treat the ambiguous cases above the same.
    var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;

    if (isUnkeyedTopLevelFragment) {
      newChild = newChild.props.children;
    } // Handle object types


    var isObject = typeof newChild === 'object' && newChild !== null;

    if (isObject) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));

        case REACT_PORTAL_TYPE:
          return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));

      }
    }

    if (typeof newChild === 'string' || typeof newChild === 'number') {
      return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
    }

    if (isArray$1(newChild)) {
      return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
    }

    if (getIteratorFn(newChild)) {
      return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
    }

    if (isObject) {
      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
      // If the new child is undefined, and the return fiber is a composite
      // component, throw an error. If Fiber return types are disabled,
      // we already threw above.
      switch (returnFiber.tag) {
        case ClassComponent:
          {
            {
              var instance = returnFiber.stateNode;

              if (instance.render._isMockFunction) {
                // We allow auto-mocks to proceed as if they're returning null.
                break;
              }
            }
          }
        // Intentionally fall through to the next case, which handles both
        // functions and classes
        // eslint-disable-next-lined no-fallthrough

        case Block:
        case FunctionComponent:
        case ForwardRef:
        case SimpleMemoComponent:
          {
            {
              {
                throw Error( (getComponentName(returnFiber.type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null." );
              }
            }
          }
      }
    } // Remaining cases are all treated as empty.


    return deleteRemainingChildren(returnFiber, currentFirstChild);
  }

  return reconcileChildFibers;
}

var reconcileChildFibers = ChildReconciler(true);
var mountChildFibers = ChildReconciler(false);
function cloneChildFibers(current, workInProgress) {
  if (!(current === null || workInProgress.child === current.child)) {
    {
      throw Error( "Resuming work not yet implemented." );
    }
  }

  if (workInProgress.child === null) {
    return;
  }

  var currentChild = workInProgress.child;
  var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
  workInProgress.child = newChild;
  newChild.return = workInProgress;

  while (currentChild.sibling !== null) {
    currentChild = currentChild.sibling;
    newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
    newChild.return = workInProgress;
  }

  newChild.sibling = null;
} // Reset a workInProgress child set to prepare it for a second pass.

function resetChildFibers(workInProgress, lanes) {
  var child = workInProgress.child;

  while (child !== null) {
    resetWorkInProgress(child, lanes);
    child = child.sibling;
  }
}

var NO_CONTEXT = {};
var contextStackCursor$1 = createCursor(NO_CONTEXT);
var contextFiberStackCursor = createCursor(NO_CONTEXT);
var rootInstanceStackCursor = createCursor(NO_CONTEXT);

function requiredContext(c) {
  if (!(c !== NO_CONTEXT)) {
    {
      throw Error( "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  return c;
}

function getRootHostContainer() {
  var rootInstance = requiredContext(rootInstanceStackCursor.current);
  return rootInstance;
}

function pushHostContainer(fiber, nextRootInstance) {
  // Push current root instance onto the stack;
  // This allows us to reset root when portals are popped.
  push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
  // This enables us to pop only Fibers that provide unique contexts.

  push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
  // However, we can't just call getRootHostContext() and push it because
  // we'd have a different number of entries on the stack depending on
  // whether getRootHostContext() throws somewhere in renderer code or not.
  // So we push an empty value first. This lets us safely unwind on errors.

  push(contextStackCursor$1, NO_CONTEXT, fiber);
  var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.

  pop(contextStackCursor$1, fiber);
  push(contextStackCursor$1, nextRootContext, fiber);
}

function popHostContainer(fiber) {
  pop(contextStackCursor$1, fiber);
  pop(contextFiberStackCursor, fiber);
  pop(rootInstanceStackCursor, fiber);
}

function getHostContext() {
  var context = requiredContext(contextStackCursor$1.current);
  return context;
}

function pushHostContext(fiber) {
  var rootInstance = requiredContext(rootInstanceStackCursor.current);
  var context = requiredContext(contextStackCursor$1.current);
  var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.

  if (context === nextContext) {
    return;
  } // Track the context and the Fiber that provided it.
  // This enables us to pop only Fibers that provide unique contexts.


  push(contextFiberStackCursor, fiber, fiber);
  push(contextStackCursor$1, nextContext, fiber);
}

function popHostContext(fiber) {
  // Do not pop unless this Fiber provided the current context.
  // pushHostContext() only pushes Fibers that provide unique contexts.
  if (contextFiberStackCursor.current !== fiber) {
    return;
  }

  pop(contextStackCursor$1, fiber);
  pop(contextFiberStackCursor, fiber);
}

var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
// inherited deeply down the subtree. The upper bits only affect
// this immediate suspense boundary and gets reset each new
// boundary or suspense list.

var SubtreeSuspenseContextMask = 1; // Subtree Flags:
// InvisibleParentSuspenseContext indicates that one of our parent Suspense
// boundaries is not currently showing visible main content.
// Either because it is already showing a fallback or is not mounted at all.
// We can use this to determine if it is desirable to trigger a fallback at
// the parent. If not, then we might need to trigger undesirable boundaries
// and/or suspend the commit to avoid hiding the parent content.

var InvisibleParentSuspenseContext = 1; // Shallow Flags:
// ForceSuspenseFallback can be used by SuspenseList to force newly added
// items into their fallback state during one of the render passes.

var ForceSuspenseFallback = 2;
var suspenseStackCursor = createCursor(DefaultSuspenseContext);
function hasSuspenseContext(parentContext, flag) {
  return (parentContext & flag) !== 0;
}
function setDefaultShallowSuspenseContext(parentContext) {
  return parentContext & SubtreeSuspenseContextMask;
}
function setShallowSuspenseContext(parentContext, shallowContext) {
  return parentContext & SubtreeSuspenseContextMask | shallowContext;
}
function addSubtreeSuspenseContext(parentContext, subtreeContext) {
  return parentContext | subtreeContext;
}
function pushSuspenseContext(fiber, newContext) {
  push(suspenseStackCursor, newContext, fiber);
}
function popSuspenseContext(fiber) {
  pop(suspenseStackCursor, fiber);
}

function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
  // If it was the primary children that just suspended, capture and render the
  // fallback. Otherwise, don't capture and bubble to the next boundary.
  var nextState = workInProgress.memoizedState;

  if (nextState !== null) {
    if (nextState.dehydrated !== null) {
      // A dehydrated boundary always captures.
      return true;
    }

    return false;
  }

  var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.

  if (props.fallback === undefined) {
    return false;
  } // Regular boundaries always capture.


  if (props.unstable_avoidThisFallback !== true) {
    return true;
  } // If it's a boundary we should avoid, then we prefer to bubble up to the
  // parent boundary if it is currently invisible.


  if (hasInvisibleParent) {
    return false;
  } // If the parent is not able to handle it, we must handle it.


  return true;
}
function findFirstSuspended(row) {
  var node = row;

  while (node !== null) {
    if (node.tag === SuspenseComponent) {
      var state = node.memoizedState;

      if (state !== null) {
        var dehydrated = state.dehydrated;

        if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
          return node;
        }
      }
    } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
    // keep track of whether it suspended or not.
    node.memoizedProps.revealOrder !== undefined) {
      var didSuspend = (node.flags & DidCapture) !== NoFlags;

      if (didSuspend) {
        return node;
      }
    } else if (node.child !== null) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === row) {
      return null;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === row) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }

  return null;
}

var NoFlags$1 =
/*  */
0; // Represents whether effect should fire.

var HasEffect =
/* */
1; // Represents the phase in which the effect (not the clean-up) fires.

var Layout =
/*    */
2;
var Passive$1 =
/*   */
4;

// This may have been an insertion or a hydration.

var hydrationParentFiber = null;
var nextHydratableInstance = null;
var isHydrating = false;

function enterHydrationState(fiber) {

  var parentInstance = fiber.stateNode.containerInfo;
  nextHydratableInstance = getFirstHydratableChild(parentInstance);
  hydrationParentFiber = fiber;
  isHydrating = true;
  return true;
}

function deleteHydratableInstance(returnFiber, instance) {
  {
    switch (returnFiber.tag) {
      case HostRoot:
        didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
        break;

      case HostComponent:
        didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
        break;
    }
  }

  var childToDelete = createFiberFromHostInstanceForDeletion();
  childToDelete.stateNode = instance;
  childToDelete.return = returnFiber;
  childToDelete.flags = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
  // these children are not part of the reconciliation list of children.
  // Even if we abort and rereconcile the children, that will try to hydrate
  // again and the nodes are still in the host tree so these will be
  // recreated.

  if (returnFiber.lastEffect !== null) {
    returnFiber.lastEffect.nextEffect = childToDelete;
    returnFiber.lastEffect = childToDelete;
  } else {
    returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
  }
}

function insertNonHydratedInstance(returnFiber, fiber) {
  fiber.flags = fiber.flags & ~Hydrating | Placement;

  {
    switch (returnFiber.tag) {
      case HostRoot:
        {
          var parentContainer = returnFiber.stateNode.containerInfo;

          switch (fiber.tag) {
            case HostComponent:
              var type = fiber.type;
              didNotFindHydratableContainerInstance(parentContainer, type);
              break;

            case HostText:
              var text = fiber.pendingProps;
              didNotFindHydratableContainerTextInstance(parentContainer, text);
              break;
          }

          break;
        }

      case HostComponent:
        {
          var parentType = returnFiber.type;
          var parentProps = returnFiber.memoizedProps;
          var parentInstance = returnFiber.stateNode;

          switch (fiber.tag) {
            case HostComponent:
              var _type = fiber.type;
              didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
              break;

            case HostText:
              var _text = fiber.pendingProps;
              didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
              break;
          }

          break;
        }

      default:
        return;
    }
  }
}

function tryHydrate(fiber, nextInstance) {
  switch (fiber.tag) {
    case HostComponent:
      {
        var type = fiber.type;
        var instance = canHydrateInstance(nextInstance, type);

        if (instance !== null) {
          fiber.stateNode = instance;
          return true;
        }

        return false;
      }

    case HostText:
      {
        var text = fiber.pendingProps;
        var textInstance = canHydrateTextInstance(nextInstance, text);

        if (textInstance !== null) {
          fiber.stateNode = textInstance;
          return true;
        }

        return false;
      }

    case SuspenseComponent:
      {

        return false;
      }

    default:
      return false;
  }
}

function tryToClaimNextHydratableInstance(fiber) {
  if (!isHydrating) {
    return;
  }

  var nextInstance = nextHydratableInstance;

  if (!nextInstance) {
    // Nothing to hydrate. Make it an insertion.
    insertNonHydratedInstance(hydrationParentFiber, fiber);
    isHydrating = false;
    hydrationParentFiber = fiber;
    return;
  }

  var firstAttemptedInstance = nextInstance;

  if (!tryHydrate(fiber, nextInstance)) {
    // If we can't hydrate this instance let's try the next one.
    // We use this as a heuristic. It's based on intuition and not data so it
    // might be flawed or unnecessary.
    nextInstance = getNextHydratableSibling(firstAttemptedInstance);

    if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
      // Nothing to hydrate. Make it an insertion.
      insertNonHydratedInstance(hydrationParentFiber, fiber);
      isHydrating = false;
      hydrationParentFiber = fiber;
      return;
    } // We matched the next one, we'll now assume that the first one was
    // superfluous and we'll delete it. Since we can't eagerly delete it
    // we'll have to schedule a deletion. To do that, this node needs a dummy
    // fiber associated with it.


    deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
  }

  hydrationParentFiber = fiber;
  nextHydratableInstance = getFirstHydratableChild(nextInstance);
}

function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {

  var instance = fiber.stateNode;
  var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.

  fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
  // is a new ref we mark this as an update.

  if (updatePayload !== null) {
    return true;
  }

  return false;
}

function prepareToHydrateHostTextInstance(fiber) {

  var textInstance = fiber.stateNode;
  var textContent = fiber.memoizedProps;
  var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);

  {
    if (shouldUpdate) {
      // We assume that prepareToHydrateHostTextInstance is called in a context where the
      // hydration parent is the parent host component of this host text.
      var returnFiber = hydrationParentFiber;

      if (returnFiber !== null) {
        switch (returnFiber.tag) {
          case HostRoot:
            {
              var parentContainer = returnFiber.stateNode.containerInfo;
              didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
              break;
            }

          case HostComponent:
            {
              var parentType = returnFiber.type;
              var parentProps = returnFiber.memoizedProps;
              var parentInstance = returnFiber.stateNode;
              didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
              break;
            }
        }
      }
    }
  }

  return shouldUpdate;
}

function skipPastDehydratedSuspenseInstance(fiber) {

  var suspenseState = fiber.memoizedState;
  var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;

  if (!suspenseInstance) {
    {
      throw Error( "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
}

function popToNextHostParent(fiber) {
  var parent = fiber.return;

  while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
    parent = parent.return;
  }

  hydrationParentFiber = parent;
}

function popHydrationState(fiber) {

  if (fiber !== hydrationParentFiber) {
    // We're deeper than the current hydration context, inside an inserted
    // tree.
    return false;
  }

  if (!isHydrating) {
    // If we're not currently hydrating but we're in a hydration context, then
    // we were an insertion and now need to pop up reenter hydration of our
    // siblings.
    popToNextHostParent(fiber);
    isHydrating = true;
    return false;
  }

  var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
  // We only do this deeper than head and body since they tend to have random
  // other nodes in them. We also ignore components with pure text content in
  // side of them.
  // TODO: Better heuristic.

  if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
    var nextInstance = nextHydratableInstance;

    while (nextInstance) {
      deleteHydratableInstance(fiber, nextInstance);
      nextInstance = getNextHydratableSibling(nextInstance);
    }
  }

  popToNextHostParent(fiber);

  if (fiber.tag === SuspenseComponent) {
    nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
  } else {
    nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
  }

  return true;
}

function resetHydrationState() {

  hydrationParentFiber = null;
  nextHydratableInstance = null;
  isHydrating = false;
}

function getIsHydrating() {
  return isHydrating;
}

// and should be reset before starting a new render.
// This tracks which mutable sources need to be reset after a render.

var workInProgressSources = [];
var rendererSigil$1;

{
  // Used to detect multiple renderers using the same mutable source.
  rendererSigil$1 = {};
}

function markSourceAsDirty(mutableSource) {
  workInProgressSources.push(mutableSource);
}
function resetWorkInProgressVersions() {
  for (var i = 0; i < workInProgressSources.length; i++) {
    var mutableSource = workInProgressSources[i];

    {
      mutableSource._workInProgressVersionPrimary = null;
    }
  }

  workInProgressSources.length = 0;
}
function getWorkInProgressVersion(mutableSource) {
  {
    return mutableSource._workInProgressVersionPrimary;
  }
}
function setWorkInProgressVersion(mutableSource, version) {
  {
    mutableSource._workInProgressVersionPrimary = version;
  }

  workInProgressSources.push(mutableSource);
}
function warnAboutMultipleRenderersDEV(mutableSource) {
  {
    {
      if (mutableSource._currentPrimaryRenderer == null) {
        mutableSource._currentPrimaryRenderer = rendererSigil$1;
      } else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) {
        error('Detected multiple renderers concurrently rendering the ' + 'same mutable source. This is currently unsupported.');
      }
    }
  }
} // Eager reads the version of a mutable source and stores it on the root.

var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
    ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
var didWarnAboutMismatchedHooksForComponent;
var didWarnAboutUseOpaqueIdentifier;

{
  didWarnAboutUseOpaqueIdentifier = {};
  didWarnAboutMismatchedHooksForComponent = new Set();
}

// These are set right before calling the component.
var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
// the work-in-progress hook.

var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
// current hook list is the list that belongs to the current fiber. The
// work-in-progress hook list is a new list that will be added to the
// work-in-progress fiber.

var currentHook = null;
var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
// does not get reset if we do another render pass; only when we're completely
// finished evaluating this component. This is an optimization so we know
// whether we need to clear render phase updates after a throw.

var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
// gets reset after each attempt.
// TODO: Maybe there's some way to consolidate this with
// `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.

var didScheduleRenderPhaseUpdateDuringThisPass = false;
var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook

var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
// The list stores the order of hooks used during the initial render (mount).
// Subsequent renders (updates) reference this list.

var hookTypesDev = null;
var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
// the dependencies for Hooks that need them (e.g. useEffect or useMemo).
// When true, such Hooks will always be "remounted". Only used during hot reload.

var ignorePreviousDependencies = false;

function mountHookTypesDev() {
  {
    var hookName = currentHookNameInDev;

    if (hookTypesDev === null) {
      hookTypesDev = [hookName];
    } else {
      hookTypesDev.push(hookName);
    }
  }
}

function updateHookTypesDev() {
  {
    var hookName = currentHookNameInDev;

    if (hookTypesDev !== null) {
      hookTypesUpdateIndexDev++;

      if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
        warnOnHookMismatchInDev(hookName);
      }
    }
  }
}

function checkDepsAreArrayDev(deps) {
  {
    if (deps !== undefined && deps !== null && !Array.isArray(deps)) {
      // Verify deps, but only on mount to avoid extra checks.
      // It's unlikely their type would change as usually you define them inline.
      error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
    }
  }
}

function warnOnHookMismatchInDev(currentHookName) {
  {
    var componentName = getComponentName(currentlyRenderingFiber$1.type);

    if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
      didWarnAboutMismatchedHooksForComponent.add(componentName);

      if (hookTypesDev !== null) {
        var table = '';
        var secondColumnStart = 30;

        for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
          var oldHookName = hookTypesDev[i];
          var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
          var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
          // lol @ IE not supporting String#repeat

          while (row.length < secondColumnStart) {
            row += ' ';
          }

          row += newHookName + '\n';
          table += row;
        }

        error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
      }
    }
  }
}

function throwInvalidHookError() {
  {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }
}

function areHookInputsEqual(nextDeps, prevDeps) {
  {
    if (ignorePreviousDependencies) {
      // Only true when this component is being hot reloaded.
      return false;
    }
  }

  if (prevDeps === null) {
    {
      error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
    }

    return false;
  }

  {
    // Don't bother comparing lengths in prod because these arrays should be
    // passed inline.
    if (nextDeps.length !== prevDeps.length) {
      error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
    }
  }

  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
    if (objectIs(nextDeps[i], prevDeps[i])) {
      continue;
    }

    return false;
  }

  return true;
}

function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
  renderLanes = nextRenderLanes;
  currentlyRenderingFiber$1 = workInProgress;

  {
    hookTypesDev = current !== null ? current._debugHookTypes : null;
    hookTypesUpdateIndexDev = -1; // Used for hot reloading:

    ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
  }

  workInProgress.memoizedState = null;
  workInProgress.updateQueue = null;
  workInProgress.lanes = NoLanes; // The following should have already been reset
  // currentHook = null;
  // workInProgressHook = null;
  // didScheduleRenderPhaseUpdate = false;
  // TODO Warn if no hooks are used at all during mount, then some are used during update.
  // Currently we will identify the update render as a mount because memoizedState === null.
  // This is tricky because it's valid for certain types of components (e.g. React.lazy)
  // Using memoizedState to differentiate between mount/update only works if at least one stateful hook is used.
  // Non-stateful hooks (e.g. context) don't get added to memoizedState,
  // so memoizedState would be null during updates and mounts.

  {
    if (current !== null && current.memoizedState !== null) {
      ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
    } else if (hookTypesDev !== null) {
      // This dispatcher handles an edge case where a component is updating,
      // but no stateful hooks have been used.
      // We want to match the production code behavior (which will use HooksDispatcherOnMount),
      // but with the extra DEV validation to ensure hooks ordering hasn't changed.
      // This dispatcher does that.
      ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
    } else {
      ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
    }
  }

  var children = Component(props, secondArg); // Check if there was a render phase update

  if (didScheduleRenderPhaseUpdateDuringThisPass) {
    // Keep rendering in a loop for as long as render phase updates continue to
    // be scheduled. Use a counter to prevent infinite loops.
    var numberOfReRenders = 0;

    do {
      didScheduleRenderPhaseUpdateDuringThisPass = false;

      if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
        {
          throw Error( "Too many re-renders. React limits the number of renders to prevent an infinite loop." );
        }
      }

      numberOfReRenders += 1;

      {
        // Even when hot reloading, allow dependencies to stabilize
        // after first render to prevent infinite render phase updates.
        ignorePreviousDependencies = false;
      } // Start over from the beginning of the list


      currentHook = null;
      workInProgressHook = null;
      workInProgress.updateQueue = null;

      {
        // Also validate hook order for cascading updates.
        hookTypesUpdateIndexDev = -1;
      }

      ReactCurrentDispatcher$1.current =  HooksDispatcherOnRerenderInDEV ;
      children = Component(props, secondArg);
    } while (didScheduleRenderPhaseUpdateDuringThisPass);
  } // We can assume the previous dispatcher is always this one, since we set it
  // at the beginning of the render phase and there's no re-entrancy.


  ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

  {
    workInProgress._debugHookTypes = hookTypesDev;
  } // This check uses currentHook so that it works the same in DEV and prod bundles.
  // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.


  var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
  renderLanes = NoLanes;
  currentlyRenderingFiber$1 = null;
  currentHook = null;
  workInProgressHook = null;

  {
    currentHookNameInDev = null;
    hookTypesDev = null;
    hookTypesUpdateIndexDev = -1;
  }

  didScheduleRenderPhaseUpdate = false;

  if (!!didRenderTooFewHooks) {
    {
      throw Error( "Rendered fewer hooks than expected. This may be caused by an accidental early return statement." );
    }
  }

  return children;
}
function bailoutHooks(current, workInProgress, lanes) {
  workInProgress.updateQueue = current.updateQueue;
  workInProgress.flags &= ~(Passive | Update);
  current.lanes = removeLanes(current.lanes, lanes);
}
function resetHooksAfterThrow() {
  // We can assume the previous dispatcher is always this one, since we set it
  // at the beginning of the render phase and there's no re-entrancy.
  ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

  if (didScheduleRenderPhaseUpdate) {
    // There were render phase updates. These are only valid for this render
    // phase, which we are now aborting. Remove the updates from the queues so
    // they do not persist to the next render. Do not remove updates from hooks
    // that weren't processed.
    //
    // Only reset the updates from the queue if it has a clone. If it does
    // not have a clone, that means it wasn't processed, and the updates were
    // scheduled before we entered the render phase.
    var hook = currentlyRenderingFiber$1.memoizedState;

    while (hook !== null) {
      var queue = hook.queue;

      if (queue !== null) {
        queue.pending = null;
      }

      hook = hook.next;
    }

    didScheduleRenderPhaseUpdate = false;
  }

  renderLanes = NoLanes;
  currentlyRenderingFiber$1 = null;
  currentHook = null;
  workInProgressHook = null;

  {
    hookTypesDev = null;
    hookTypesUpdateIndexDev = -1;
    currentHookNameInDev = null;
    isUpdatingOpaqueValueInRenderPhase = false;
  }

  didScheduleRenderPhaseUpdateDuringThisPass = false;
}

function mountWorkInProgressHook() {
  var hook = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };

  if (workInProgressHook === null) {
    // This is the first hook in the list
    currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
  } else {
    // Append to the end of the list
    workInProgressHook = workInProgressHook.next = hook;
  }

  return workInProgressHook;
}

function updateWorkInProgressHook() {
  // This function is used both for updates and for re-renders triggered by a
  // render phase update. It assumes there is either a current hook we can
  // clone, or a work-in-progress hook from a previous render pass that we can
  // use as a base. When we reach the end of the base list, we must switch to
  // the dispatcher used for mounts.
  var nextCurrentHook;

  if (currentHook === null) {
    var current = currentlyRenderingFiber$1.alternate;

    if (current !== null) {
      nextCurrentHook = current.memoizedState;
    } else {
      nextCurrentHook = null;
    }
  } else {
    nextCurrentHook = currentHook.next;
  }

  var nextWorkInProgressHook;

  if (workInProgressHook === null) {
    nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
  } else {
    nextWorkInProgressHook = workInProgressHook.next;
  }

  if (nextWorkInProgressHook !== null) {
    // There's already a work-in-progress. Reuse it.
    workInProgressHook = nextWorkInProgressHook;
    nextWorkInProgressHook = workInProgressHook.next;
    currentHook = nextCurrentHook;
  } else {
    // Clone from the current hook.
    if (!(nextCurrentHook !== null)) {
      {
        throw Error( "Rendered more hooks than during the previous render." );
      }
    }

    currentHook = nextCurrentHook;
    var newHook = {
      memoizedState: currentHook.memoizedState,
      baseState: currentHook.baseState,
      baseQueue: currentHook.baseQueue,
      queue: currentHook.queue,
      next: null
    };

    if (workInProgressHook === null) {
      // This is the first hook in the list.
      currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
    } else {
      // Append to the end of the list.
      workInProgressHook = workInProgressHook.next = newHook;
    }
  }

  return workInProgressHook;
}

function createFunctionComponentUpdateQueue() {
  return {
    lastEffect: null
  };
}

function basicStateReducer(state, action) {
  // $FlowFixMe: Flow doesn't like mixed types
  return typeof action === 'function' ? action(state) : action;
}

function mountReducer(reducer, initialArg, init) {
  var hook = mountWorkInProgressHook();
  var initialState;

  if (init !== undefined) {
    initialState = init(initialArg);
  } else {
    initialState = initialArg;
  }

  hook.memoizedState = hook.baseState = initialState;
  var queue = hook.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: reducer,
    lastRenderedState: initialState
  };
  var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
  return [hook.memoizedState, dispatch];
}

function updateReducer(reducer, initialArg, init) {
  var hook = updateWorkInProgressHook();
  var queue = hook.queue;

  if (!(queue !== null)) {
    {
      throw Error( "Should have a queue. This is likely a bug in React. Please file an issue." );
    }
  }

  queue.lastRenderedReducer = reducer;
  var current = currentHook; // The last rebase update that is NOT part of the base state.

  var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.

  var pendingQueue = queue.pending;

  if (pendingQueue !== null) {
    // We have new updates that haven't been processed yet.
    // We'll add them to the base queue.
    if (baseQueue !== null) {
      // Merge the pending queue and the base queue.
      var baseFirst = baseQueue.next;
      var pendingFirst = pendingQueue.next;
      baseQueue.next = pendingFirst;
      pendingQueue.next = baseFirst;
    }

    {
      if (current.baseQueue !== baseQueue) {
        // Internal invariant that should never happen, but feasibly could in
        // the future if we implement resuming, or some form of that.
        error('Internal error: Expected work-in-progress queue to be a clone. ' + 'This is a bug in React.');
      }
    }

    current.baseQueue = baseQueue = pendingQueue;
    queue.pending = null;
  }

  if (baseQueue !== null) {
    // We have a queue to process.
    var first = baseQueue.next;
    var newState = current.baseState;
    var newBaseState = null;
    var newBaseQueueFirst = null;
    var newBaseQueueLast = null;
    var update = first;

    do {
      var updateLane = update.lane;

      if (!isSubsetOfLanes(renderLanes, updateLane)) {
        // Priority is insufficient. Skip this update. If this is the first
        // skipped update, the previous update/state is the new base
        // update/state.
        var clone = {
          lane: updateLane,
          action: update.action,
          eagerReducer: update.eagerReducer,
          eagerState: update.eagerState,
          next: null
        };

        if (newBaseQueueLast === null) {
          newBaseQueueFirst = newBaseQueueLast = clone;
          newBaseState = newState;
        } else {
          newBaseQueueLast = newBaseQueueLast.next = clone;
        } // Update the remaining priority in the queue.
        // TODO: Don't need to accumulate this. Instead, we can remove
        // renderLanes from the original lanes.


        currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
        markSkippedUpdateLanes(updateLane);
      } else {
        // This update does have sufficient priority.
        if (newBaseQueueLast !== null) {
          var _clone = {
            // This update is going to be committed so we never want uncommit
            // it. Using NoLane works because 0 is a subset of all bitmasks, so
            // this will never be skipped by the check above.
            lane: NoLane,
            action: update.action,
            eagerReducer: update.eagerReducer,
            eagerState: update.eagerState,
            next: null
          };
          newBaseQueueLast = newBaseQueueLast.next = _clone;
        } // Process this update.


        if (update.eagerReducer === reducer) {
          // If this update was processed eagerly, and its reducer matches the
          // current reducer, we can use the eagerly computed state.
          newState = update.eagerState;
        } else {
          var action = update.action;
          newState = reducer(newState, action);
        }
      }

      update = update.next;
    } while (update !== null && update !== first);

    if (newBaseQueueLast === null) {
      newBaseState = newState;
    } else {
      newBaseQueueLast.next = newBaseQueueFirst;
    } // Mark that the fiber performed work, but only if the new state is
    // different from the current state.


    if (!objectIs(newState, hook.memoizedState)) {
      markWorkInProgressReceivedUpdate();
    }

    hook.memoizedState = newState;
    hook.baseState = newBaseState;
    hook.baseQueue = newBaseQueueLast;
    queue.lastRenderedState = newState;
  }

  var dispatch = queue.dispatch;
  return [hook.memoizedState, dispatch];
}

function rerenderReducer(reducer, initialArg, init) {
  var hook = updateWorkInProgressHook();
  var queue = hook.queue;

  if (!(queue !== null)) {
    {
      throw Error( "Should have a queue. This is likely a bug in React. Please file an issue." );
    }
  }

  queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
  // work-in-progress hook.

  var dispatch = queue.dispatch;
  var lastRenderPhaseUpdate = queue.pending;
  var newState = hook.memoizedState;

  if (lastRenderPhaseUpdate !== null) {
    // The queue doesn't persist past this render pass.
    queue.pending = null;
    var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
    var update = firstRenderPhaseUpdate;

    do {
      // Process this render phase update. We don't have to check the
      // priority because it will always be the same as the current
      // render's.
      var action = update.action;
      newState = reducer(newState, action);
      update = update.next;
    } while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
    // different from the current state.


    if (!objectIs(newState, hook.memoizedState)) {
      markWorkInProgressReceivedUpdate();
    }

    hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
    // the base state unless the queue is empty.
    // TODO: Not sure if this is the desired semantics, but it's what we
    // do for gDSFP. I can't remember why.

    if (hook.baseQueue === null) {
      hook.baseState = newState;
    }

    queue.lastRenderedState = newState;
  }

  return [newState, dispatch];
}

function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
  {
    warnAboutMultipleRenderersDEV(source);
  }

  var getVersion = source._getVersion;
  var version = getVersion(source._source); // Is it safe for this component to read from this source during the current render?

  var isSafeToReadFromSource = false; // Check the version first.
  // If this render has already been started with a specific version,
  // we can use it alone to determine if we can safely read from the source.

  var currentRenderVersion = getWorkInProgressVersion(source);

  if (currentRenderVersion !== null) {
    // It's safe to read if the store hasn't been mutated since the last time
    // we read something.
    isSafeToReadFromSource = currentRenderVersion === version;
  } else {
    // If there's no version, then this is the first time we've read from the
    // source during the current render pass, so we need to do a bit more work.
    // What we need to determine is if there are any hooks that already
    // subscribed to the source, and if so, whether there are any pending
    // mutations that haven't been synchronized yet.
    //
    // If there are no pending mutations, then `root.mutableReadLanes` will be
    // empty, and we know we can safely read.
    //
    // If there *are* pending mutations, we may still be able to safely read
    // if the currently rendering lanes are inclusive of the pending mutation
    // lanes, since that guarantees that the value we're about to read from
    // the source is consistent with the values that we read during the most
    // recent mutation.
    isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);

    if (isSafeToReadFromSource) {
      // If it's safe to read from this source during the current render,
      // store the version in case other components read from it.
      // A changed version number will let those components know to throw and restart the render.
      setWorkInProgressVersion(source, version);
    }
  }

  if (isSafeToReadFromSource) {
    var snapshot = getSnapshot(source._source);

    {
      if (typeof snapshot === 'function') {
        error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
      }
    }

    return snapshot;
  } else {
    // This handles the special case of a mutable source being shared between renderers.
    // In that case, if the source is mutated between the first and second renderer,
    // The second renderer don't know that it needs to reset the WIP version during unwind,
    // (because the hook only marks sources as dirty if it's written to their WIP version).
    // That would cause this tear check to throw again and eventually be visible to the user.
    // We can avoid this infinite loop by explicitly marking the source as dirty.
    //
    // This can lead to tearing in the first renderer when it resumes,
    // but there's nothing we can do about that (short of throwing here and refusing to continue the render).
    markSourceAsDirty(source);

    {
      {
        throw Error( "Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue." );
      }
    }
  }
}

function useMutableSource(hook, source, getSnapshot, subscribe) {
  var root = getWorkInProgressRoot();

  if (!(root !== null)) {
    {
      throw Error( "Expected a work-in-progress root. This is a bug in React. Please file an issue." );
    }
  }

  var getVersion = source._getVersion;
  var version = getVersion(source._source);
  var dispatcher = ReactCurrentDispatcher$1.current; // eslint-disable-next-line prefer-const

  var _dispatcher$useState = dispatcher.useState(function () {
    return readFromUnsubcribedMutableSource(root, source, getSnapshot);
  }),
      currentSnapshot = _dispatcher$useState[0],
      setSnapshot = _dispatcher$useState[1];

  var snapshot = currentSnapshot; // Grab a handle to the state hook as well.
  // We use it to clear the pending update queue if we have a new source.

  var stateHook = workInProgressHook;
  var memoizedState = hook.memoizedState;
  var refs = memoizedState.refs;
  var prevGetSnapshot = refs.getSnapshot;
  var prevSource = memoizedState.source;
  var prevSubscribe = memoizedState.subscribe;
  var fiber = currentlyRenderingFiber$1;
  hook.memoizedState = {
    refs: refs,
    source: source,
    subscribe: subscribe
  }; // Sync the values needed by our subscription handler after each commit.

  dispatcher.useEffect(function () {
    refs.getSnapshot = getSnapshot; // Normally the dispatch function for a state hook never changes,
    // but this hook recreates the queue in certain cases  to avoid updates from stale sources.
    // handleChange() below needs to reference the dispatch function without re-subscribing,
    // so we use a ref to ensure that it always has the latest version.

    refs.setSnapshot = setSnapshot; // Check for a possible change between when we last rendered now.

    var maybeNewVersion = getVersion(source._source);

    if (!objectIs(version, maybeNewVersion)) {
      var maybeNewSnapshot = getSnapshot(source._source);

      {
        if (typeof maybeNewSnapshot === 'function') {
          error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
        }
      }

      if (!objectIs(snapshot, maybeNewSnapshot)) {
        setSnapshot(maybeNewSnapshot);
        var lane = requestUpdateLane(fiber);
        markRootMutableRead(root, lane);
      } // If the source mutated between render and now,
      // there may be state updates already scheduled from the old source.
      // Entangle the updates so that they render in the same batch.


      markRootEntangled(root, root.mutableReadLanes);
    }
  }, [getSnapshot, source, subscribe]); // If we got a new source or subscribe function, re-subscribe in a passive effect.

  dispatcher.useEffect(function () {
    var handleChange = function () {
      var latestGetSnapshot = refs.getSnapshot;
      var latestSetSnapshot = refs.setSnapshot;

      try {
        latestSetSnapshot(latestGetSnapshot(source._source)); // Record a pending mutable source update with the same expiration time.

        var lane = requestUpdateLane(fiber);
        markRootMutableRead(root, lane);
      } catch (error) {
        // A selector might throw after a source mutation.
        // e.g. it might try to read from a part of the store that no longer exists.
        // In this case we should still schedule an update with React.
        // Worst case the selector will throw again and then an error boundary will handle it.
        latestSetSnapshot(function () {
          throw error;
        });
      }
    };

    var unsubscribe = subscribe(source._source, handleChange);

    {
      if (typeof unsubscribe !== 'function') {
        error('Mutable source subscribe function must return an unsubscribe function.');
      }
    }

    return unsubscribe;
  }, [source, subscribe]); // If any of the inputs to useMutableSource change, reading is potentially unsafe.
  //
  // If either the source or the subscription have changed we can't can't trust the update queue.
  // Maybe the source changed in a way that the old subscription ignored but the new one depends on.
  //
  // If the getSnapshot function changed, we also shouldn't rely on the update queue.
  // It's possible that the underlying source was mutated between the when the last "change" event fired,
  // and when the current render (with the new getSnapshot function) is processed.
  //
  // In both cases, we need to throw away pending updates (since they are no longer relevant)
  // and treat reading from the source as we do in the mount case.

  if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
    // Create a new queue and setState method,
    // So if there are interleaved updates, they get pushed to the older queue.
    // When this becomes current, the previous queue and dispatch method will be discarded,
    // including any interleaving updates that occur.
    var newQueue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: snapshot
    };
    newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
    stateHook.queue = newQueue;
    stateHook.baseQueue = null;
    snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
    stateHook.memoizedState = stateHook.baseState = snapshot;
  }

  return snapshot;
}

function mountMutableSource(source, getSnapshot, subscribe) {
  var hook = mountWorkInProgressHook();
  hook.memoizedState = {
    refs: {
      getSnapshot: getSnapshot,
      setSnapshot: null
    },
    source: source,
    subscribe: subscribe
  };
  return useMutableSource(hook, source, getSnapshot, subscribe);
}

function updateMutableSource(source, getSnapshot, subscribe) {
  var hook = updateWorkInProgressHook();
  return useMutableSource(hook, source, getSnapshot, subscribe);
}

function mountState(initialState) {
  var hook = mountWorkInProgressHook();

  if (typeof initialState === 'function') {
    // $FlowFixMe: Flow doesn't like mixed types
    initialState = initialState();
  }

  hook.memoizedState = hook.baseState = initialState;
  var queue = hook.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: basicStateReducer,
    lastRenderedState: initialState
  };
  var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
  return [hook.memoizedState, dispatch];
}

function updateState(initialState) {
  return updateReducer(basicStateReducer);
}

function rerenderState(initialState) {
  return rerenderReducer(basicStateReducer);
}

function pushEffect(tag, create, destroy, deps) {
  var effect = {
    tag: tag,
    create: create,
    destroy: destroy,
    deps: deps,
    // Circular
    next: null
  };
  var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;

  if (componentUpdateQueue === null) {
    componentUpdateQueue = createFunctionComponentUpdateQueue();
    currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
    componentUpdateQueue.lastEffect = effect.next = effect;
  } else {
    var lastEffect = componentUpdateQueue.lastEffect;

    if (lastEffect === null) {
      componentUpdateQueue.lastEffect = effect.next = effect;
    } else {
      var firstEffect = lastEffect.next;
      lastEffect.next = effect;
      effect.next = firstEffect;
      componentUpdateQueue.lastEffect = effect;
    }
  }

  return effect;
}

function mountRef(initialValue) {
  var hook = mountWorkInProgressHook();
  var ref = {
    current: initialValue
  };

  {
    Object.seal(ref);
  }

  hook.memoizedState = ref;
  return ref;
}

function updateRef(initialValue) {
  var hook = updateWorkInProgressHook();
  return hook.memoizedState;
}

function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  currentlyRenderingFiber$1.flags |= fiberFlags;
  hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
}

function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var destroy = undefined;

  if (currentHook !== null) {
    var prevEffect = currentHook.memoizedState;
    destroy = prevEffect.destroy;

    if (nextDeps !== null) {
      var prevDeps = prevEffect.deps;

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        pushEffect(hookFlags, create, destroy, nextDeps);
        return;
      }
    }
  }

  currentlyRenderingFiber$1.flags |= fiberFlags;
  hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
}

function mountEffect(create, deps) {
  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
    }
  }

  return mountEffectImpl(Update | Passive, Passive$1, create, deps);
}

function updateEffect(create, deps) {
  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
    }
  }

  return updateEffectImpl(Update | Passive, Passive$1, create, deps);
}

function mountLayoutEffect(create, deps) {
  return mountEffectImpl(Update, Layout, create, deps);
}

function updateLayoutEffect(create, deps) {
  return updateEffectImpl(Update, Layout, create, deps);
}

function imperativeHandleEffect(create, ref) {
  if (typeof ref === 'function') {
    var refCallback = ref;

    var _inst = create();

    refCallback(_inst);
    return function () {
      refCallback(null);
    };
  } else if (ref !== null && ref !== undefined) {
    var refObject = ref;

    {
      if (!refObject.hasOwnProperty('current')) {
        error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
      }
    }

    var _inst2 = create();

    refObject.current = _inst2;
    return function () {
      refObject.current = null;
    };
  }
}

function mountImperativeHandle(ref, create, deps) {
  {
    if (typeof create !== 'function') {
      error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
    }
  } // TODO: If deps are provided, should we skip comparing the ref itself?


  var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
  return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
}

function updateImperativeHandle(ref, create, deps) {
  {
    if (typeof create !== 'function') {
      error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
    }
  } // TODO: If deps are provided, should we skip comparing the ref itself?


  var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
  return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
}

function mountDebugValue(value, formatterFn) {// This hook is normally a no-op.
  // The react-debug-hooks package injects its own implementation
  // so that e.g. DevTools can display custom hook values.
}

var updateDebugValue = mountDebugValue;

function mountCallback(callback, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  hook.memoizedState = [callback, nextDeps];
  return callback;
}

function updateCallback(callback, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var prevState = hook.memoizedState;

  if (prevState !== null) {
    if (nextDeps !== null) {
      var prevDeps = prevState[1];

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        return prevState[0];
      }
    }
  }

  hook.memoizedState = [callback, nextDeps];
  return callback;
}

function mountMemo(nextCreate, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var nextValue = nextCreate();
  hook.memoizedState = [nextValue, nextDeps];
  return nextValue;
}

function updateMemo(nextCreate, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var prevState = hook.memoizedState;

  if (prevState !== null) {
    // Assume these are defined. If they're not, areHookInputsEqual will warn.
    if (nextDeps !== null) {
      var prevDeps = prevState[1];

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        return prevState[0];
      }
    }
  }

  var nextValue = nextCreate();
  hook.memoizedState = [nextValue, nextDeps];
  return nextValue;
}

function mountDeferredValue(value) {
  var _mountState = mountState(value),
      prevValue = _mountState[0],
      setValue = _mountState[1];

  mountEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function updateDeferredValue(value) {
  var _updateState = updateState(),
      prevValue = _updateState[0],
      setValue = _updateState[1];

  updateEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function rerenderDeferredValue(value) {
  var _rerenderState = rerenderState(),
      prevValue = _rerenderState[0],
      setValue = _rerenderState[1];

  updateEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function startTransition(setPending, callback) {
  var priorityLevel = getCurrentPriorityLevel();

  {
    runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function () {
      setPending(true);
    });
    runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function () {
      var prevTransition = ReactCurrentBatchConfig$1.transition;
      ReactCurrentBatchConfig$1.transition = 1;

      try {
        setPending(false);
        callback();
      } finally {
        ReactCurrentBatchConfig$1.transition = prevTransition;
      }
    });
  }
}

function mountTransition() {
  var _mountState2 = mountState(false),
      isPending = _mountState2[0],
      setPending = _mountState2[1]; // The `start` method can be stored on a ref, since `setPending`
  // never changes.


  var start = startTransition.bind(null, setPending);
  mountRef(start);
  return [start, isPending];
}

function updateTransition() {
  var _updateState2 = updateState(),
      isPending = _updateState2[0];

  var startRef = updateRef();
  var start = startRef.current;
  return [start, isPending];
}

function rerenderTransition() {
  var _rerenderState2 = rerenderState(),
      isPending = _rerenderState2[0];

  var startRef = updateRef();
  var start = startRef.current;
  return [start, isPending];
}

var isUpdatingOpaqueValueInRenderPhase = false;
function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
  {
    return isUpdatingOpaqueValueInRenderPhase;
  }
}

function warnOnOpaqueIdentifierAccessInDEV(fiber) {
  {
    // TODO: Should warn in effects and callbacks, too
    var name = getComponentName(fiber.type) || 'Unknown';

    if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
      error('The object passed back from useOpaqueIdentifier is meant to be ' + 'passed through to attributes only. Do not read the ' + 'value directly.');

      didWarnAboutUseOpaqueIdentifier[name] = true;
    }
  }
}

function mountOpaqueIdentifier() {
  var makeId =  makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1)) ;

  if (getIsHydrating()) {
    var didUpgrade = false;
    var fiber = currentlyRenderingFiber$1;

    var readValue = function () {
      if (!didUpgrade) {
        // Only upgrade once. This works even inside the render phase because
        // the update is added to a shared queue, which outlasts the
        // in-progress render.
        didUpgrade = true;

        {
          isUpdatingOpaqueValueInRenderPhase = true;
          setId(makeId());
          isUpdatingOpaqueValueInRenderPhase = false;
          warnOnOpaqueIdentifierAccessInDEV(fiber);
        }
      }

      {
        {
          throw Error( "The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly." );
        }
      }
    };

    var id = makeOpaqueHydratingObject(readValue);
    var setId = mountState(id)[1];

    if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
      currentlyRenderingFiber$1.flags |= Update | Passive;
      pushEffect(HasEffect | Passive$1, function () {
        setId(makeId());
      }, undefined, null);
    }

    return id;
  } else {
    var _id = makeId();

    mountState(_id);
    return _id;
  }
}

function updateOpaqueIdentifier() {
  var id = updateState()[0];
  return id;
}

function rerenderOpaqueIdentifier() {
  var id = rerenderState()[0];
  return id;
}

function dispatchAction(fiber, queue, action) {
  {
    if (typeof arguments[3] === 'function') {
      error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
    }
  }

  var eventTime = requestEventTime();
  var lane = requestUpdateLane(fiber);
  var update = {
    lane: lane,
    action: action,
    eagerReducer: null,
    eagerState: null,
    next: null
  }; // Append the update to the end of the list.

  var pending = queue.pending;

  if (pending === null) {
    // This is the first update. Create a circular list.
    update.next = update;
  } else {
    update.next = pending.next;
    pending.next = update;
  }

  queue.pending = update;
  var alternate = fiber.alternate;

  if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
    // This is a render phase update. Stash it in a lazily-created map of
    // queue -> linked list of updates. After this render pass, we'll restart
    // and apply the stashed updates on top of the work-in-progress hook.
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
  } else {
    if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
      // The queue is currently empty, which means we can eagerly compute the
      // next state before entering the render phase. If the new state is the
      // same as the current state, we may be able to bail out entirely.
      var lastRenderedReducer = queue.lastRenderedReducer;

      if (lastRenderedReducer !== null) {
        var prevDispatcher;

        {
          prevDispatcher = ReactCurrentDispatcher$1.current;
          ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
        }

        try {
          var currentState = queue.lastRenderedState;
          var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
          // it, on the update object. If the reducer hasn't changed by the
          // time we enter the render phase, then the eager state can be used
          // without calling the reducer again.

          update.eagerReducer = lastRenderedReducer;
          update.eagerState = eagerState;

          if (objectIs(eagerState, currentState)) {
            // Fast path. We can bail out without scheduling React to re-render.
            // It's still possible that we'll need to rebase this update later,
            // if the component re-renders for a different reason and by that
            // time the reducer has changed.
            return;
          }
        } catch (error) {// Suppress the error. It will throw again in the render phase.
        } finally {
          {
            ReactCurrentDispatcher$1.current = prevDispatcher;
          }
        }
      }
    }

    {
      // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
      if ('undefined' !== typeof jest) {
        warnIfNotScopedWithMatchingAct(fiber);
        warnIfNotCurrentlyActingUpdatesInDev(fiber);
      }
    }

    scheduleUpdateOnFiber(fiber, lane, eventTime);
  }
}

var ContextOnlyDispatcher = {
  readContext: readContext,
  useCallback: throwInvalidHookError,
  useContext: throwInvalidHookError,
  useEffect: throwInvalidHookError,
  useImperativeHandle: throwInvalidHookError,
  useLayoutEffect: throwInvalidHookError,
  useMemo: throwInvalidHookError,
  useReducer: throwInvalidHookError,
  useRef: throwInvalidHookError,
  useState: throwInvalidHookError,
  useDebugValue: throwInvalidHookError,
  useDeferredValue: throwInvalidHookError,
  useTransition: throwInvalidHookError,
  useMutableSource: throwInvalidHookError,
  useOpaqueIdentifier: throwInvalidHookError,
  unstable_isNewReconciler: enableNewReconciler
};
var HooksDispatcherOnMountInDEV = null;
var HooksDispatcherOnMountWithHookTypesInDEV = null;
var HooksDispatcherOnUpdateInDEV = null;
var HooksDispatcherOnRerenderInDEV = null;
var InvalidNestedHooksDispatcherOnMountInDEV = null;
var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
var InvalidNestedHooksDispatcherOnRerenderInDEV = null;

{
  var warnInvalidContextAccess = function () {
    error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
  };

  var warnInvalidHookAccess = function () {
    error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
  };

  HooksDispatcherOnMountInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      mountHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      mountHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      mountHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      mountHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      mountHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      mountHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      mountHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnMountWithHookTypesInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnUpdateInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return updateDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return updateTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return updateOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnRerenderInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return rerenderReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return rerenderState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return rerenderDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return rerenderTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return rerenderOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnMountInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnUpdateInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnRerenderInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return rerenderReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return rerenderState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
}

var now$1 = Scheduler.unstable_now;
var commitTime = 0;
var profilerStartTime = -1;

function getCommitTime() {
  return commitTime;
}

function recordCommitTime() {

  commitTime = now$1();
}

function startProfilerTimer(fiber) {

  profilerStartTime = now$1();

  if (fiber.actualStartTime < 0) {
    fiber.actualStartTime = now$1();
  }
}

function stopProfilerTimerIfRunning(fiber) {

  profilerStartTime = -1;
}

function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {

  if (profilerStartTime >= 0) {
    var elapsedTime = now$1() - profilerStartTime;
    fiber.actualDuration += elapsedTime;

    if (overrideBaseTime) {
      fiber.selfBaseDuration = elapsedTime;
    }

    profilerStartTime = -1;
  }
}

function transferActualDuration(fiber) {
  // Transfer time spent rendering these children so we don't lose it
  // after we rerender. This is used as a helper in special cases
  // where we should count the work of multiple passes.
  var child = fiber.child;

  while (child) {
    fiber.actualDuration += child.actualDuration;
    child = child.sibling;
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var didReceiveUpdate = false;
var didWarnAboutBadClass;
var didWarnAboutModulePatternComponent;
var didWarnAboutContextTypeOnFunctionComponent;
var didWarnAboutGetDerivedStateOnFunctionComponent;
var didWarnAboutFunctionRefs;
var didWarnAboutReassigningProps;
var didWarnAboutRevealOrder;
var didWarnAboutTailOptions;

{
  didWarnAboutBadClass = {};
  didWarnAboutModulePatternComponent = {};
  didWarnAboutContextTypeOnFunctionComponent = {};
  didWarnAboutGetDerivedStateOnFunctionComponent = {};
  didWarnAboutFunctionRefs = {};
  didWarnAboutReassigningProps = false;
  didWarnAboutRevealOrder = {};
  didWarnAboutTailOptions = {};
}

function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
  if (current === null) {
    // If this is a fresh new component that hasn't been rendered yet, we
    // won't update its child set by applying minimal side-effects. Instead,
    // we will add them all to the child before it gets rendered. That means
    // we can optimize this reconciliation pass by not tracking side-effects.
    workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
  } else {
    // If the current child is the same as the work in progress, it means that
    // we haven't yet started any work on these children. Therefore, we use
    // the clone algorithm to create a copy of all the current children.
    // If we had any progressed work already, that is invalid at this point so
    // let's throw it out.
    workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
  }
}

function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
  // This function is fork of reconcileChildren. It's used in cases where we
  // want to reconcile without matching against the existing set. This has the
  // effect of all current children being unmounted; even if the type and key
  // are the same, the old child is unmounted and a new child is created.
  //
  // To do this, we're going to go through the reconcile algorithm twice. In
  // the first pass, we schedule a deletion for all the current children by
  // passing null.
  workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
  // pass null in place of where we usually pass the current child set. This has
  // the effect of remounting all children regardless of whether their
  // identities match.

  workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
}

function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
  // TODO: current can be non-null here even if the component
  // hasn't yet mounted. This happens after the first render suspends.
  // We'll need to figure out if this is fine or can cause issues.
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  }

  var render = Component.render;
  var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent

  var nextChildren;
  prepareToReadContext(workInProgress, renderLanes);

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);

    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
      } finally {
        reenableLogs();
      }
    }

    setIsRendering(false);
  }

  if (current !== null && !didReceiveUpdate) {
    bailoutHooks(current, workInProgress, renderLanes);
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
  if (current === null) {
    var type = Component.type;

    if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
    Component.defaultProps === undefined) {
      var resolvedType = type;

      {
        resolvedType = resolveFunctionForHotReloading(type);
      } // If this is a plain function component without default props,
      // and with only the default shallow comparison, we upgrade it
      // to a SimpleMemoComponent to allow fast path updates.


      workInProgress.tag = SimpleMemoComponent;
      workInProgress.type = resolvedType;

      {
        validateFunctionComponentInDev(workInProgress, type);
      }

      return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
    }

    {
      var innerPropTypes = type.propTypes;

      if (innerPropTypes) {
        // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(type));
      }
    }

    var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
    child.ref = workInProgress.ref;
    child.return = workInProgress;
    workInProgress.child = child;
    return child;
  }

  {
    var _type = Component.type;
    var _innerPropTypes = _type.propTypes;

    if (_innerPropTypes) {
      // Inner memo component props aren't currently validated in createElement.
      // We could move it there, but we'd still need this for lazy code path.
      checkPropTypes(_innerPropTypes, nextProps, // Resolved props
      'prop', getComponentName(_type));
    }
  }

  var currentChild = current.child; // This is always exactly one child

  if (!includesSomeLane(updateLanes, renderLanes)) {
    // This will be the props with resolved defaultProps,
    // unlike current.memoizedProps which will be the unresolved ones.
    var prevProps = currentChild.memoizedProps; // Default to shallow comparison

    var compare = Component.compare;
    compare = compare !== null ? compare : shallowEqual;

    if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
      return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  var newChild = createWorkInProgress(currentChild, nextProps);
  newChild.ref = workInProgress.ref;
  newChild.return = workInProgress;
  workInProgress.child = newChild;
  return newChild;
}

function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
  // TODO: current can be non-null here even if the component
  // hasn't yet mounted. This happens when the inner render suspends.
  // We'll need to figure out if this is fine or can cause issues.
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var outerMemoType = workInProgress.elementType;

      if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
        // We warn when you define propTypes on lazy()
        // so let's just skip over it to find memo() outer wrapper.
        // Inner props for memo are validated later.
        var lazyComponent = outerMemoType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;

        try {
          outerMemoType = init(payload);
        } catch (x) {
          outerMemoType = null;
        } // Inner propTypes will be validated in the function component path.


        var outerPropTypes = outerMemoType && outerMemoType.propTypes;

        if (outerPropTypes) {
          checkPropTypes(outerPropTypes, nextProps, // Resolved (SimpleMemoComponent has no defaultProps)
          'prop', getComponentName(outerMemoType));
        }
      }
    }
  }

  if (current !== null) {
    var prevProps = current.memoizedProps;

    if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && ( // Prevent bailout if the implementation changed due to hot reload.
     workInProgress.type === current.type )) {
      didReceiveUpdate = false;

      if (!includesSomeLane(renderLanes, updateLanes)) {
        // The pending lanes were cleared at the beginning of beginWork. We're
        // about to bail out, but there might be other lanes that weren't
        // included in the current render. Usually, the priority level of the
        // remaining updates is accumlated during the evaluation of the
        // component (i.e. when processing the update queue). But since since
        // we're bailing out early *without* evaluating the component, we need
        // to account for it here, too. Reset to the value of the current fiber.
        // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
        // because a MemoComponent fiber does not have hooks or an update queue;
        // rather, it wraps around an inner component, which may or may not
        // contains hooks.
        // TODO: Move the reset at in beginWork out of the common path so that
        // this is no longer necessary.
        workInProgress.lanes = current.lanes;
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
      } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
        // This is a special case that only exists for legacy mode.
        // See https://github.com/facebook/react/pull/19216.
        didReceiveUpdate = true;
      }
    }
  }

  return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}

function updateOffscreenComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps;
  var nextChildren = nextProps.children;
  var prevState = current !== null ? current.memoizedState : null;

  if (nextProps.mode === 'hidden' || nextProps.mode === 'unstable-defer-without-hiding') {
    if ((workInProgress.mode & ConcurrentMode) === NoMode) {
      // In legacy sync mode, don't defer the subtree. Render it now.
      // TODO: Figure out what we should do in Blocking mode.
      var nextState = {
        baseLanes: NoLanes
      };
      workInProgress.memoizedState = nextState;
      pushRenderLanes(workInProgress, renderLanes);
    } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
      var nextBaseLanes;

      if (prevState !== null) {
        var prevBaseLanes = prevState.baseLanes;
        nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
      } else {
        nextBaseLanes = renderLanes;
      } // Schedule this fiber to re-render at offscreen priority. Then bailout.


      {
        markSpawnedWork(OffscreenLane);
      }

      workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
      var _nextState = {
        baseLanes: nextBaseLanes
      };
      workInProgress.memoizedState = _nextState; // We're about to bail out, but we need to push this to the stack anyway
      // to avoid a push/pop misalignment.

      pushRenderLanes(workInProgress, nextBaseLanes);
      return null;
    } else {
      // Rendering at offscreen, so we can clear the base lanes.
      var _nextState2 = {
        baseLanes: NoLanes
      };
      workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.

      var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
      pushRenderLanes(workInProgress, subtreeRenderLanes);
    }
  } else {
    var _subtreeRenderLanes;

    if (prevState !== null) {
      _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes); // Since we're not hidden anymore, reset the state

      workInProgress.memoizedState = null;
    } else {
      // We weren't previously hidden, and we still aren't, so there's nothing
      // special to do. Need to push to the stack regardless, though, to avoid
      // a push/pop misalignment.
      _subtreeRenderLanes = renderLanes;
    }

    pushRenderLanes(workInProgress, _subtreeRenderLanes);
  }

  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
} // Note: These happen to have identical begin phases, for now. We shouldn't hold
// ourselves to this constraint, though. If the behavior diverges, we should
// fork the function.


var updateLegacyHiddenComponent = updateOffscreenComponent;

function updateFragment(current, workInProgress, renderLanes) {
  var nextChildren = workInProgress.pendingProps;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateMode(current, workInProgress, renderLanes) {
  var nextChildren = workInProgress.pendingProps.children;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateProfiler(current, workInProgress, renderLanes) {
  {
    workInProgress.flags |= Update; // Reset effect durations for the next eventual effect phase.
    // These are reset during render to allow the DevTools commit hook a chance to read them,

    var stateNode = workInProgress.stateNode;
    stateNode.effectDuration = 0;
    stateNode.passiveEffectDuration = 0;
  }

  var nextProps = workInProgress.pendingProps;
  var nextChildren = nextProps.children;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function markRef(current, workInProgress) {
  var ref = workInProgress.ref;

  if (current === null && ref !== null || current !== null && current.ref !== ref) {
    // Schedule a Ref effect
    workInProgress.flags |= Ref;
  }
}

function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  }

  var context;

  {
    var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
    context = getMaskedContext(workInProgress, unmaskedContext);
  }

  var nextChildren;
  prepareToReadContext(workInProgress, renderLanes);

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);

    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
      } finally {
        reenableLogs();
      }
    }

    setIsRendering(false);
  }

  if (current !== null && !didReceiveUpdate) {
    bailoutHooks(current, workInProgress, renderLanes);
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  } // Push context providers early to prevent context stack mismatches.
  // During mounting we don't know the child context yet as the instance doesn't exist.
  // We will invalidate the child context in finishClassComponent() right after rendering.


  var hasContext;

  if (isContextProvider(Component)) {
    hasContext = true;
    pushContextProvider(workInProgress);
  } else {
    hasContext = false;
  }

  prepareToReadContext(workInProgress, renderLanes);
  var instance = workInProgress.stateNode;
  var shouldUpdate;

  if (instance === null) {
    if (current !== null) {
      // A class component without an instance only mounts if it suspended
      // inside a non-concurrent tree, in an inconsistent state. We want to
      // treat it like a new mount, even though an empty version of it already
      // committed. Disconnect the alternate pointers.
      current.alternate = null;
      workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

      workInProgress.flags |= Placement;
    } // In the initial pass we might need to construct the instance.


    constructClassInstance(workInProgress, Component, nextProps);
    mountClassInstance(workInProgress, Component, nextProps, renderLanes);
    shouldUpdate = true;
  } else if (current === null) {
    // In a resume, we'll already have an instance we can reuse.
    shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
  } else {
    shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
  }

  var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);

  {
    var inst = workInProgress.stateNode;

    if (shouldUpdate && inst.props !== nextProps) {
      if (!didWarnAboutReassigningProps) {
        error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentName(workInProgress.type) || 'a component');
      }

      didWarnAboutReassigningProps = true;
    }
  }

  return nextUnitOfWork;
}

function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
  // Refs should update even if shouldComponentUpdate returns false
  markRef(current, workInProgress);
  var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;

  if (!shouldUpdate && !didCaptureError) {
    // Context providers should defer to sCU for rendering
    if (hasContext) {
      invalidateContextProvider(workInProgress, Component, false);
    }

    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  }

  var instance = workInProgress.stateNode; // Rerender

  ReactCurrentOwner$1.current = workInProgress;
  var nextChildren;

  if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
    // If we captured an error, but getDerivedStateFromError is not defined,
    // unmount all the children. componentDidCatch will schedule an update to
    // re-render a fallback. This is temporary until we migrate everyone to
    // the new API.
    // TODO: Warn in a future release.
    nextChildren = null;

    {
      stopProfilerTimerIfRunning();
    }
  } else {
    {
      setIsRendering(true);
      nextChildren = instance.render();

      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          instance.render();
        } finally {
          reenableLogs();
        }
      }

      setIsRendering(false);
    }
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;

  if (current !== null && didCaptureError) {
    // If we're recovering from an error, reconcile without reusing any of
    // the existing children. Conceptually, the normal children and the children
    // that are shown on error are two different sets, so we shouldn't reuse
    // normal children even if their identities match.
    forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
  } else {
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  } // Memoize state using the values we just used to render.
  // TODO: Restructure so we never read values from the instance.


  workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.

  if (hasContext) {
    invalidateContextProvider(workInProgress, Component, true);
  }

  return workInProgress.child;
}

function pushHostRootContext(workInProgress) {
  var root = workInProgress.stateNode;

  if (root.pendingContext) {
    pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
  } else if (root.context) {
    // Should always be set
    pushTopLevelContextObject(workInProgress, root.context, false);
  }

  pushHostContainer(workInProgress, root.containerInfo);
}

function updateHostRoot(current, workInProgress, renderLanes) {
  pushHostRootContext(workInProgress);
  var updateQueue = workInProgress.updateQueue;

  if (!(current !== null && updateQueue !== null)) {
    {
      throw Error( "If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  var nextProps = workInProgress.pendingProps;
  var prevState = workInProgress.memoizedState;
  var prevChildren = prevState !== null ? prevState.element : null;
  cloneUpdateQueue(current, workInProgress);
  processUpdateQueue(workInProgress, nextProps, null, renderLanes);
  var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
  // being called "element".

  var nextChildren = nextState.element;

  if (nextChildren === prevChildren) {
    resetHydrationState();
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  }

  var root = workInProgress.stateNode;

  if (root.hydrate && enterHydrationState(workInProgress)) {
    // If we don't have any current children this might be the first pass.
    // We always try to hydrate. If this isn't a hydration pass there won't
    // be any children to hydrate which is effectively the same thing as
    // not hydrating.
    {
      var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;

      if (mutableSourceEagerHydrationData != null) {
        for (var i = 0; i < mutableSourceEagerHydrationData.length; i += 2) {
          var mutableSource = mutableSourceEagerHydrationData[i];
          var version = mutableSourceEagerHydrationData[i + 1];
          setWorkInProgressVersion(mutableSource, version);
        }
      }
    }

    var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
    workInProgress.child = child;
    var node = child;

    while (node) {
      // Mark each child as hydrating. This is a fast path to know whether this
      // tree is part of a hydrating tree. This is used to determine if a child
      // node has fully mounted yet, and for scheduling event replaying.
      // Conceptually this is similar to Placement in that a new subtree is
      // inserted into the React tree here. It just happens to not need DOM
      // mutations because it already exists.
      node.flags = node.flags & ~Placement | Hydrating;
      node = node.sibling;
    }
  } else {
    // Otherwise reset hydration state in case we aborted and resumed another
    // root.
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    resetHydrationState();
  }

  return workInProgress.child;
}

function updateHostComponent(current, workInProgress, renderLanes) {
  pushHostContext(workInProgress);

  if (current === null) {
    tryToClaimNextHydratableInstance(workInProgress);
  }

  var type = workInProgress.type;
  var nextProps = workInProgress.pendingProps;
  var prevProps = current !== null ? current.memoizedProps : null;
  var nextChildren = nextProps.children;
  var isDirectTextChild = shouldSetTextContent(type, nextProps);

  if (isDirectTextChild) {
    // We special case a direct text child of a host node. This is a common
    // case. We won't handle it as a reified child. We will instead handle
    // this in the host environment that also has access to this prop. That
    // avoids allocating another HostText fiber and traversing it.
    nextChildren = null;
  } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
    // If we're switching from a direct text child to a normal child, or to
    // empty, we need to schedule the text content to be reset.
    workInProgress.flags |= ContentReset;
  }

  markRef(current, workInProgress);
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateHostText(current, workInProgress) {
  if (current === null) {
    tryToClaimNextHydratableInstance(workInProgress);
  } // Nothing to do here. This is terminal. We'll do the completion step
  // immediately after.


  return null;
}

function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
  if (_current !== null) {
    // A lazy component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  }

  var props = workInProgress.pendingProps;
  var lazyComponent = elementType;
  var payload = lazyComponent._payload;
  var init = lazyComponent._init;
  var Component = init(payload); // Store the unwrapped component in the type.

  workInProgress.type = Component;
  var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
  var resolvedProps = resolveDefaultProps(Component, props);
  var child;

  switch (resolvedTag) {
    case FunctionComponent:
      {
        {
          validateFunctionComponentInDev(workInProgress, Component);
          workInProgress.type = Component = resolveFunctionForHotReloading(Component);
        }

        child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case ClassComponent:
      {
        {
          workInProgress.type = Component = resolveClassForHotReloading(Component);
        }

        child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case ForwardRef:
      {
        {
          workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
        }

        child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case MemoComponent:
      {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var outerPropTypes = Component.propTypes;

            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, resolvedProps, // Resolved for outer only
              'prop', getComponentName(Component));
            }
          }
        }

        child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), // The inner type can have defaults too
        updateLanes, renderLanes);
        return child;
      }
  }

  var hint = '';

  {
    if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
      hint = ' Did you wrap a component in React.lazy() more than once?';
    }
  } // This message intentionally doesn't mention ForwardRef or MemoComponent
  // because the fact that it's a separate type of work is an
  // implementation detail.


  {
    {
      throw Error( "Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint );
    }
  }
}

function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
  if (_current !== null) {
    // An incomplete component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  } // Promote the fiber to a class and try rendering again.


  workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
  // Push context providers early to prevent context stack mismatches.
  // During mounting we don't know the child context yet as the instance doesn't exist.
  // We will invalidate the child context in finishClassComponent() right after rendering.

  var hasContext;

  if (isContextProvider(Component)) {
    hasContext = true;
    pushContextProvider(workInProgress);
  } else {
    hasContext = false;
  }

  prepareToReadContext(workInProgress, renderLanes);
  constructClassInstance(workInProgress, Component, nextProps);
  mountClassInstance(workInProgress, Component, nextProps, renderLanes);
  return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
}

function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
  if (_current !== null) {
    // An indeterminate component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  }

  var props = workInProgress.pendingProps;
  var context;

  {
    var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
    context = getMaskedContext(workInProgress, unmaskedContext);
  }

  prepareToReadContext(workInProgress, renderLanes);
  var value;

  {
    if (Component.prototype && typeof Component.prototype.render === 'function') {
      var componentName = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutBadClass[componentName]) {
        error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);

        didWarnAboutBadClass[componentName] = true;
      }
    }

    if (workInProgress.mode & StrictMode) {
      ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
    }

    setIsRendering(true);
    ReactCurrentOwner$1.current = workInProgress;
    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
    setIsRendering(false);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;

  {
    // Support for module components is deprecated and is removed behind a flag.
    // Whether or not it would crash later, we want to show a good message in DEV first.
    if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
      var _componentName = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutModulePatternComponent[_componentName]) {
        error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);

        didWarnAboutModulePatternComponent[_componentName] = true;
      }
    }
  }

  if ( // Run these checks in production only if the flag is off.
  // Eventually we'll delete this branch altogether.
   typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
    {
      var _componentName2 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutModulePatternComponent[_componentName2]) {
        error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);

        didWarnAboutModulePatternComponent[_componentName2] = true;
      }
    } // Proceed under the assumption that this is a class instance


    workInProgress.tag = ClassComponent; // Throw out any hooks that were used.

    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
    // During mounting we don't know the child context yet as the instance doesn't exist.
    // We will invalidate the child context in finishClassComponent() right after rendering.

    var hasContext = false;

    if (isContextProvider(Component)) {
      hasContext = true;
      pushContextProvider(workInProgress);
    } else {
      hasContext = false;
    }

    workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
    initializeUpdateQueue(workInProgress);
    var getDerivedStateFromProps = Component.getDerivedStateFromProps;

    if (typeof getDerivedStateFromProps === 'function') {
      applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
    }

    adoptClassInstance(workInProgress, value);
    mountClassInstance(workInProgress, Component, props, renderLanes);
    return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
  } else {
    // Proceed under the assumption that this is a function component
    workInProgress.tag = FunctionComponent;

    {

      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        } finally {
          reenableLogs();
        }
      }
    }

    reconcileChildren(null, workInProgress, value, renderLanes);

    {
      validateFunctionComponentInDev(workInProgress, Component);
    }

    return workInProgress.child;
  }
}

function validateFunctionComponentInDev(workInProgress, Component) {
  {
    if (Component) {
      if (Component.childContextTypes) {
        error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
      }
    }

    if (workInProgress.ref !== null) {
      var info = '';
      var ownerName = getCurrentFiberOwnerNameInDevOrNull();

      if (ownerName) {
        info += '\n\nCheck the render method of `' + ownerName + '`.';
      }

      var warningKey = ownerName || workInProgress._debugID || '';
      var debugSource = workInProgress._debugSource;

      if (debugSource) {
        warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
      }

      if (!didWarnAboutFunctionRefs[warningKey]) {
        didWarnAboutFunctionRefs[warningKey] = true;

        error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
      }
    }

    if (typeof Component.getDerivedStateFromProps === 'function') {
      var _componentName3 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
        error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);

        didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
      }
    }

    if (typeof Component.contextType === 'object' && Component.contextType !== null) {
      var _componentName4 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
        error('%s: Function components do not support contextType.', _componentName4);

        didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
      }
    }
  }
}

var SUSPENDED_MARKER = {
  dehydrated: null,
  retryLane: NoLane
};

function mountSuspenseOffscreenState(renderLanes) {
  return {
    baseLanes: renderLanes
  };
}

function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
  return {
    baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes)
  };
} // TODO: Probably should inline this back


function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
  // If we're already showing a fallback, there are cases where we need to
  // remain on that fallback regardless of whether the content has resolved.
  // For example, SuspenseList coordinates when nested content appears.
  if (current !== null) {
    var suspenseState = current.memoizedState;

    if (suspenseState === null) {
      // Currently showing content. Don't hide it, even if ForceSuspenseFallack
      // is true. More precise name might be "ForceRemainSuspenseFallback".
      // Note: This is a factoring smell. Can't remain on a fallback if there's
      // no fallback to remain on.
      return false;
    }
  } // Not currently showing content. Consult the Suspense context.


  return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
}

function getRemainingWorkInPrimaryTree(current, renderLanes) {
  // TODO: Should not remove render lanes that were pinged during this render
  return removeLanes(current.childLanes, renderLanes);
}

function updateSuspenseComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.

  {
    if (shouldSuspend(workInProgress)) {
      workInProgress.flags |= DidCapture;
    }
  }

  var suspenseContext = suspenseStackCursor.current;
  var showFallback = false;
  var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;

  if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
    // Something in this boundary's subtree already suspended. Switch to
    // rendering the fallback children.
    showFallback = true;
    workInProgress.flags &= ~DidCapture;
  } else {
    // Attempting the main content
    if (current === null || current.memoizedState !== null) {
      // This is a new mount or this boundary is already showing a fallback state.
      // Mark this subtree context as having at least one invisible parent that could
      // handle the fallback state.
      // Boundaries without fallbacks or should be avoided are not considered since
      // they cannot handle preferred fallback states.
      if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) {
        suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
      }
    }
  }

  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
  pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
  // boundary's children. This involves some custom reconcilation logic. Two
  // main reasons this is so complicated.
  //
  // First, Legacy Mode has different semantics for backwards compatibility. The
  // primary tree will commit in an inconsistent state, so when we do the
  // second pass to render the fallback, we do some exceedingly, uh, clever
  // hacks to make that not totally break. Like transferring effects and
  // deletions from hidden tree. In Concurrent Mode, it's much simpler,
  // because we bailout on the primary tree completely and leave it in its old
  // state, no effects. Same as what we do for Offscreen (except that
  // Offscreen doesn't have the first render pass).
  //
  // Second is hydration. During hydration, the Suspense fiber has a slightly
  // different layout, where the child points to a dehydrated fragment, which
  // contains the DOM rendered by the server.
  //
  // Third, even if you set all that aside, Suspense is like error boundaries in
  // that we first we try to render one tree, and if that fails, we render again
  // and switch to a different tree. Like a try/catch block. So we have to track
  // which branch we're currently rendering. Ideally we would model this using
  // a stack.

  if (current === null) {
    // Initial mount
    // If we're currently hydrating, try to hydrate this boundary.
    // But only if this has a fallback.
    if (nextProps.fallback !== undefined) {
      tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
    }

    var nextPrimaryChildren = nextProps.children;
    var nextFallbackChildren = nextProps.fallback;

    if (showFallback) {
      var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
      var primaryChildFragment = workInProgress.child;
      primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
      workInProgress.memoizedState = SUSPENDED_MARKER;
      return fallbackFragment;
    } else if (typeof nextProps.unstable_expectedLoadTime === 'number') {
      // This is a CPU-bound tree. Skip this tree and show a placeholder to
      // unblock the surrounding content. Then immediately retry after the
      // initial commit.
      var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);

      var _primaryChildFragment = workInProgress.child;
      _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
      workInProgress.memoizedState = SUSPENDED_MARKER; // Since nothing actually suspended, there will nothing to ping this to
      // get it started back up to attempt the next item. While in terms of
      // priority this work has the same priority as this current render, it's
      // not part of the same transition once the transition has committed. If
      // it's sync, we still want to yield so that it can be painted.
      // Conceptually, this is really the same as pinging. We can use any
      // RetryLane even if it's the one currently rendering since we're leaving
      // it behind on this node.

      workInProgress.lanes = SomeRetryLane;

      {
        markSpawnedWork(SomeRetryLane);
      }

      return _fallbackFragment;
    } else {
      return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
    }
  } else {
    // This is an update.
    // If the current fiber has a SuspenseState, that means it's already showing
    // a fallback.
    var prevState = current.memoizedState;

    if (prevState !== null) {

      if (showFallback) {
        var _nextFallbackChildren2 = nextProps.fallback;
        var _nextPrimaryChildren2 = nextProps.children;

        var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);

        var _primaryChildFragment3 = workInProgress.child;
        var prevOffscreenState = current.child.memoizedState;
        _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
        _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
        workInProgress.memoizedState = SUSPENDED_MARKER;
        return _fallbackChildFragment;
      } else {
        var _nextPrimaryChildren3 = nextProps.children;

        var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);

        workInProgress.memoizedState = null;
        return _primaryChildFragment4;
      }
    } else {
      // The current tree is not already showing a fallback.
      if (showFallback) {
        // Timed out.
        var _nextFallbackChildren3 = nextProps.fallback;
        var _nextPrimaryChildren4 = nextProps.children;

        var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);

        var _primaryChildFragment5 = workInProgress.child;
        var _prevOffscreenState = current.child.memoizedState;
        _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
        _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes); // Skip the primary children, and continue working on the
        // fallback children.

        workInProgress.memoizedState = SUSPENDED_MARKER;
        return _fallbackChildFragment2;
      } else {
        // Still haven't timed out. Continue rendering the children, like we
        // normally do.
        var _nextPrimaryChildren5 = nextProps.children;

        var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);

        workInProgress.memoizedState = null;
        return _primaryChildFragment6;
      }
    }
  }
}

function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
  var mode = workInProgress.mode;
  var primaryChildProps = {
    mode: 'visible',
    children: primaryChildren
  };
  var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
  primaryChildFragment.return = workInProgress;
  workInProgress.child = primaryChildFragment;
  return primaryChildFragment;
}

function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
  var mode = workInProgress.mode;
  var progressedPrimaryFragment = workInProgress.child;
  var primaryChildProps = {
    mode: 'hidden',
    children: primaryChildren
  };
  var primaryChildFragment;
  var fallbackChildFragment;

  if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
    // In legacy mode, we commit the primary tree as if it successfully
    // completed, even though it's in an inconsistent state.
    primaryChildFragment = progressedPrimaryFragment;
    primaryChildFragment.childLanes = NoLanes;
    primaryChildFragment.pendingProps = primaryChildProps;

    if ( workInProgress.mode & ProfileMode) {
      // Reset the durations from the first pass so they aren't included in the
      // final amounts. This seems counterintuitive, since we're intentionally
      // not measuring part of the render phase, but this makes it match what we
      // do in Concurrent Mode.
      primaryChildFragment.actualDuration = 0;
      primaryChildFragment.actualStartTime = -1;
      primaryChildFragment.selfBaseDuration = 0;
      primaryChildFragment.treeBaseDuration = 0;
    }

    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
  } else {
    primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
  }

  primaryChildFragment.return = workInProgress;
  fallbackChildFragment.return = workInProgress;
  primaryChildFragment.sibling = fallbackChildFragment;
  workInProgress.child = primaryChildFragment;
  return fallbackChildFragment;
}

function createWorkInProgressOffscreenFiber(current, offscreenProps) {
  // The props argument to `createWorkInProgress` is `any` typed, so we use this
  // wrapper function to constrain it.
  return createWorkInProgress(current, offscreenProps);
}

function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
  var currentPrimaryChildFragment = current.child;
  var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
  var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
    mode: 'visible',
    children: primaryChildren
  });

  if ((workInProgress.mode & BlockingMode) === NoMode) {
    primaryChildFragment.lanes = renderLanes;
  }

  primaryChildFragment.return = workInProgress;
  primaryChildFragment.sibling = null;

  if (currentFallbackChildFragment !== null) {
    // Delete the fallback child fragment
    currentFallbackChildFragment.nextEffect = null;
    currentFallbackChildFragment.flags = Deletion;
    workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
  }

  workInProgress.child = primaryChildFragment;
  return primaryChildFragment;
}

function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
  var mode = workInProgress.mode;
  var currentPrimaryChildFragment = current.child;
  var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
  var primaryChildProps = {
    mode: 'hidden',
    children: primaryChildren
  };
  var primaryChildFragment;

  if ( // In legacy mode, we commit the primary tree as if it successfully
  // completed, even though it's in an inconsistent state.
  (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
  // already cloned. In legacy mode, the only case where this isn't true is
  // when DevTools forces us to display a fallback; we skip the first render
  // pass entirely and go straight to rendering the fallback. (In Concurrent
  // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
  // only codepath.)
  workInProgress.child !== currentPrimaryChildFragment) {
    var progressedPrimaryFragment = workInProgress.child;
    primaryChildFragment = progressedPrimaryFragment;
    primaryChildFragment.childLanes = NoLanes;
    primaryChildFragment.pendingProps = primaryChildProps;

    if ( workInProgress.mode & ProfileMode) {
      // Reset the durations from the first pass so they aren't included in the
      // final amounts. This seems counterintuitive, since we're intentionally
      // not measuring part of the render phase, but this makes it match what we
      // do in Concurrent Mode.
      primaryChildFragment.actualDuration = 0;
      primaryChildFragment.actualStartTime = -1;
      primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
      primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
    } // The fallback fiber was added as a deletion effect during the first pass.
    // However, since we're going to remain on the fallback, we no longer want
    // to delete it. So we need to remove it from the list. Deletions are stored
    // on the same list as effects. We want to keep the effects from the primary
    // tree. So we copy the primary child fragment's effect list, which does not
    // include the fallback deletion effect.


    var progressedLastEffect = primaryChildFragment.lastEffect;

    if (progressedLastEffect !== null) {
      workInProgress.firstEffect = primaryChildFragment.firstEffect;
      workInProgress.lastEffect = progressedLastEffect;
      progressedLastEffect.nextEffect = null;
    } else {
      // TODO: Reset this somewhere else? Lol legacy mode is so weird.
      workInProgress.firstEffect = workInProgress.lastEffect = null;
    }
  } else {
    primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
  }

  var fallbackChildFragment;

  if (currentFallbackChildFragment !== null) {
    fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
  } else {
    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
    // mounted but this is a new fiber.

    fallbackChildFragment.flags |= Placement;
  }

  fallbackChildFragment.return = workInProgress;
  primaryChildFragment.return = workInProgress;
  primaryChildFragment.sibling = fallbackChildFragment;
  workInProgress.child = primaryChildFragment;
  return fallbackChildFragment;
}

function scheduleWorkOnFiber(fiber, renderLanes) {
  fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
  var alternate = fiber.alternate;

  if (alternate !== null) {
    alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
  }

  scheduleWorkOnParentPath(fiber.return, renderLanes);
}

function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
  // Mark any Suspense boundaries with fallbacks as having work to do.
  // If they were previously forced into fallbacks, they may now be able
  // to unblock.
  var node = firstChild;

  while (node !== null) {
    if (node.tag === SuspenseComponent) {
      var state = node.memoizedState;

      if (state !== null) {
        scheduleWorkOnFiber(node, renderLanes);
      }
    } else if (node.tag === SuspenseListComponent) {
      // If the tail is hidden there might not be an Suspense boundaries
      // to schedule work on. In this case we have to schedule it on the
      // list itself.
      // We don't have to traverse to the children of the list since
      // the list will propagate the change when it rerenders.
      scheduleWorkOnFiber(node, renderLanes);
    } else if (node.child !== null) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === workInProgress) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === workInProgress) {
        return;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function findLastContentRow(firstChild) {
  // This is going to find the last row among these children that is already
  // showing content on the screen, as opposed to being in fallback state or
  // new. If a row has multiple Suspense boundaries, any of them being in the
  // fallback state, counts as the whole row being in a fallback state.
  // Note that the "rows" will be workInProgress, but any nested children
  // will still be current since we haven't rendered them yet. The mounted
  // order may not be the same as the new order. We use the new order.
  var row = firstChild;
  var lastContentRow = null;

  while (row !== null) {
    var currentRow = row.alternate; // New rows can't be content rows.

    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
      lastContentRow = row;
    }

    row = row.sibling;
  }

  return lastContentRow;
}

function validateRevealOrder(revealOrder) {
  {
    if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
      didWarnAboutRevealOrder[revealOrder] = true;

      if (typeof revealOrder === 'string') {
        switch (revealOrder.toLowerCase()) {
          case 'together':
          case 'forwards':
          case 'backwards':
            {
              error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());

              break;
            }

          case 'forward':
          case 'backward':
            {
              error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());

              break;
            }

          default:
            error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);

            break;
        }
      } else {
        error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
      }
    }
  }
}

function validateTailOptions(tailMode, revealOrder) {
  {
    if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
      if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
        didWarnAboutTailOptions[tailMode] = true;

        error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
      } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
        didWarnAboutTailOptions[tailMode] = true;

        error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
      }
    }
  }
}

function validateSuspenseListNestedChild(childSlot, index) {
  {
    var isArray = Array.isArray(childSlot);
    var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';

    if (isArray || isIterable) {
      var type = isArray ? 'array' : 'iterable';

      error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);

      return false;
    }
  }

  return true;
}

function validateSuspenseListChildren(children, revealOrder) {
  {
    if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
      if (Array.isArray(children)) {
        for (var i = 0; i < children.length; i++) {
          if (!validateSuspenseListNestedChild(children[i], i)) {
            return;
          }
        }
      } else {
        var iteratorFn = getIteratorFn(children);

        if (typeof iteratorFn === 'function') {
          var childrenIterator = iteratorFn.call(children);

          if (childrenIterator) {
            var step = childrenIterator.next();
            var _i = 0;

            for (; !step.done; step = childrenIterator.next()) {
              if (!validateSuspenseListNestedChild(step.value, _i)) {
                return;
              }

              _i++;
            }
          }
        } else {
          error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
        }
      }
    }
  }
}

function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
  var renderState = workInProgress.memoizedState;

  if (renderState === null) {
    workInProgress.memoizedState = {
      isBackwards: isBackwards,
      rendering: null,
      renderingStartTime: 0,
      last: lastContentRow,
      tail: tail,
      tailMode: tailMode,
      lastEffect: lastEffectBeforeRendering
    };
  } else {
    // We can reuse the existing object from previous renders.
    renderState.isBackwards = isBackwards;
    renderState.rendering = null;
    renderState.renderingStartTime = 0;
    renderState.last = lastContentRow;
    renderState.tail = tail;
    renderState.tailMode = tailMode;
    renderState.lastEffect = lastEffectBeforeRendering;
  }
} // This can end up rendering this component multiple passes.
// The first pass splits the children fibers into two sets. A head and tail.
// We first render the head. If anything is in fallback state, we do another
// pass through beginWork to rerender all children (including the tail) with
// the force suspend context. If the first render didn't have anything in
// in fallback state. Then we render each row in the tail one-by-one.
// That happens in the completeWork phase without going back to beginWork.


function updateSuspenseListComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps;
  var revealOrder = nextProps.revealOrder;
  var tailMode = nextProps.tail;
  var newChildren = nextProps.children;
  validateRevealOrder(revealOrder);
  validateTailOptions(tailMode, revealOrder);
  validateSuspenseListChildren(newChildren, revealOrder);
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  var suspenseContext = suspenseStackCursor.current;
  var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);

  if (shouldForceFallback) {
    suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
    workInProgress.flags |= DidCapture;
  } else {
    var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;

    if (didSuspendBefore) {
      // If we previously forced a fallback, we need to schedule work
      // on any nested boundaries to let them know to try to render
      // again. This is the same as context updating.
      propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
    }

    suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
  }

  pushSuspenseContext(workInProgress, suspenseContext);

  if ((workInProgress.mode & BlockingMode) === NoMode) {
    // In legacy mode, SuspenseList doesn't work so we just
    // use make it a noop by treating it as the default revealOrder.
    workInProgress.memoizedState = null;
  } else {
    switch (revealOrder) {
      case 'forwards':
        {
          var lastContentRow = findLastContentRow(workInProgress.child);
          var tail;

          if (lastContentRow === null) {
            // The whole list is part of the tail.
            // TODO: We could fast path by just rendering the tail now.
            tail = workInProgress.child;
            workInProgress.child = null;
          } else {
            // Disconnect the tail rows after the content row.
            // We're going to render them separately later.
            tail = lastContentRow.sibling;
            lastContentRow.sibling = null;
          }

          initSuspenseListRenderState(workInProgress, false, // isBackwards
          tail, lastContentRow, tailMode, workInProgress.lastEffect);
          break;
        }

      case 'backwards':
        {
          // We're going to find the first row that has existing content.
          // At the same time we're going to reverse the list of everything
          // we pass in the meantime. That's going to be our tail in reverse
          // order.
          var _tail = null;
          var row = workInProgress.child;
          workInProgress.child = null;

          while (row !== null) {
            var currentRow = row.alternate; // New rows can't be content rows.

            if (currentRow !== null && findFirstSuspended(currentRow) === null) {
              // This is the beginning of the main content.
              workInProgress.child = row;
              break;
            }

            var nextRow = row.sibling;
            row.sibling = _tail;
            _tail = row;
            row = nextRow;
          } // TODO: If workInProgress.child is null, we can continue on the tail immediately.


          initSuspenseListRenderState(workInProgress, true, // isBackwards
          _tail, null, // last
          tailMode, workInProgress.lastEffect);
          break;
        }

      case 'together':
        {
          initSuspenseListRenderState(workInProgress, false, // isBackwards
          null, // tail
          null, // last
          undefined, workInProgress.lastEffect);
          break;
        }

      default:
        {
          // The default reveal order is the same as not having
          // a boundary.
          workInProgress.memoizedState = null;
        }
    }
  }

  return workInProgress.child;
}

function updatePortalComponent(current, workInProgress, renderLanes) {
  pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
  var nextChildren = workInProgress.pendingProps;

  if (current === null) {
    // Portals are special because we don't append the children during mount
    // but at commit. Therefore we need to track insertions which the normal
    // flow doesn't do during mount. This doesn't happen at the root because
    // the root always starts with a "current" with a null child.
    // TODO: Consider unifying this with how the root works.
    workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
  } else {
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  }

  return workInProgress.child;
}

var hasWarnedAboutUsingNoValuePropOnContextProvider = false;

function updateContextProvider(current, workInProgress, renderLanes) {
  var providerType = workInProgress.type;
  var context = providerType._context;
  var newProps = workInProgress.pendingProps;
  var oldProps = workInProgress.memoizedProps;
  var newValue = newProps.value;

  {
    if (!('value' in newProps)) {
      if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
        hasWarnedAboutUsingNoValuePropOnContextProvider = true;

        error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
      }
    }

    var providerPropTypes = workInProgress.type.propTypes;

    if (providerPropTypes) {
      checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
    }
  }

  pushProvider(workInProgress, newValue);

  if (oldProps !== null) {
    var oldValue = oldProps.value;
    var changedBits = calculateChangedBits(context, newValue, oldValue);

    if (changedBits === 0) {
      // No change. Bailout early if children are the same.
      if (oldProps.children === newProps.children && !hasContextChanged()) {
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
      }
    } else {
      // The context value changed. Search for matching consumers and schedule
      // them to update.
      propagateContextChange(workInProgress, context, changedBits, renderLanes);
    }
  }

  var newChildren = newProps.children;
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  return workInProgress.child;
}

var hasWarnedAboutUsingContextAsConsumer = false;

function updateContextConsumer(current, workInProgress, renderLanes) {
  var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
  // DEV mode, we create a separate object for Context.Consumer that acts
  // like a proxy to Context. This proxy object adds unnecessary code in PROD
  // so we use the old behaviour (Context.Consumer references Context) to
  // reduce size and overhead. The separate object references context via
  // a property called "_context", which also gives us the ability to check
  // in DEV mode if this property exists or not and warn if it does not.

  {
    if (context._context === undefined) {
      // This may be because it's a Context (rather than a Consumer).
      // Or it may be because it's older React where they're the same thing.
      // We only want to warn if we're sure it's a new React.
      if (context !== context.Consumer) {
        if (!hasWarnedAboutUsingContextAsConsumer) {
          hasWarnedAboutUsingContextAsConsumer = true;

          error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
        }
      }
    } else {
      context = context._context;
    }
  }

  var newProps = workInProgress.pendingProps;
  var render = newProps.children;

  {
    if (typeof render !== 'function') {
      error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
    }
  }

  prepareToReadContext(workInProgress, renderLanes);
  var newValue = readContext(context, newProps.unstable_observedBits);
  var newChildren;

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    newChildren = render(newValue);
    setIsRendering(false);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  return workInProgress.child;
}

function markWorkInProgressReceivedUpdate() {
  didReceiveUpdate = true;
}

function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
  if (current !== null) {
    // Reuse previous dependencies
    workInProgress.dependencies = current.dependencies;
  }

  {
    // Don't update "base" render times for bailouts.
    stopProfilerTimerIfRunning();
  }

  markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.

  if (!includesSomeLane(renderLanes, workInProgress.childLanes)) {
    // The children don't have any work either. We can skip them.
    // TODO: Once we add back resuming, we should check if the children are
    // a work-in-progress set. If so, we need to transfer their effects.
    return null;
  } else {
    // This fiber doesn't have work, but its subtree does. Clone the child
    // fibers and continue.
    cloneChildFibers(current, workInProgress);
    return workInProgress.child;
  }
}

function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
  {
    var returnFiber = oldWorkInProgress.return;

    if (returnFiber === null) {
      throw new Error('Cannot swap the root fiber.');
    } // Disconnect from the old current.
    // It will get deleted.


    current.alternate = null;
    oldWorkInProgress.alternate = null; // Connect to the new tree.

    newWorkInProgress.index = oldWorkInProgress.index;
    newWorkInProgress.sibling = oldWorkInProgress.sibling;
    newWorkInProgress.return = oldWorkInProgress.return;
    newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.

    if (oldWorkInProgress === returnFiber.child) {
      returnFiber.child = newWorkInProgress;
    } else {
      var prevSibling = returnFiber.child;

      if (prevSibling === null) {
        throw new Error('Expected parent to have a child.');
      }

      while (prevSibling.sibling !== oldWorkInProgress) {
        prevSibling = prevSibling.sibling;

        if (prevSibling === null) {
          throw new Error('Expected to find the previous sibling.');
        }
      }

      prevSibling.sibling = newWorkInProgress;
    } // Delete the old fiber and place the new one.
    // Since the old fiber is disconnected, we have to schedule it manually.


    var last = returnFiber.lastEffect;

    if (last !== null) {
      last.nextEffect = current;
      returnFiber.lastEffect = current;
    } else {
      returnFiber.firstEffect = returnFiber.lastEffect = current;
    }

    current.nextEffect = null;
    current.flags = Deletion;
    newWorkInProgress.flags |= Placement; // Restart work from the new fiber.

    return newWorkInProgress;
  }
}

function beginWork(current, workInProgress, renderLanes) {
  var updateLanes = workInProgress.lanes;

  {
    if (workInProgress._debugNeedsRemount && current !== null) {
      // This will restart the begin phase with a new fiber.
      return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
    }
  }

  if (current !== null) {
    var oldProps = current.memoizedProps;
    var newProps = workInProgress.pendingProps;

    if (oldProps !== newProps || hasContextChanged() || ( // Force a re-render if the implementation changed due to hot reload:
     workInProgress.type !== current.type )) {
      // If props or context changed, mark the fiber as having performed work.
      // This may be unset if the props are determined to be equal later (memo).
      didReceiveUpdate = true;
    } else if (!includesSomeLane(renderLanes, updateLanes)) {
      didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
      // the begin phase. There's still some bookkeeping we that needs to be done
      // in this optimized path, mostly pushing stuff onto the stack.

      switch (workInProgress.tag) {
        case HostRoot:
          pushHostRootContext(workInProgress);
          resetHydrationState();
          break;

        case HostComponent:
          pushHostContext(workInProgress);
          break;

        case ClassComponent:
          {
            var Component = workInProgress.type;

            if (isContextProvider(Component)) {
              pushContextProvider(workInProgress);
            }

            break;
          }

        case HostPortal:
          pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
          break;

        case ContextProvider:
          {
            var newValue = workInProgress.memoizedProps.value;
            pushProvider(workInProgress, newValue);
            break;
          }

        case Profiler:
          {
            // Profiler should only call onRender when one of its descendants actually rendered.
            var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

            if (hasChildWork) {
              workInProgress.flags |= Update;
            } // Reset effect durations for the next eventual effect phase.
            // These are reset during render to allow the DevTools commit hook a chance to read them,


            var stateNode = workInProgress.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }

          break;

        case SuspenseComponent:
          {
            var state = workInProgress.memoizedState;

            if (state !== null) {
              // whether to retry the primary children, or to skip over it and
              // go straight to the fallback. Check the priority of the primary
              // child fragment.


              var primaryChildFragment = workInProgress.child;
              var primaryChildLanes = primaryChildFragment.childLanes;

              if (includesSomeLane(renderLanes, primaryChildLanes)) {
                // The primary children have pending work. Use the normal path
                // to attempt to render the primary children again.
                return updateSuspenseComponent(current, workInProgress, renderLanes);
              } else {
                // The primary child fragment does not have pending work marked
                // on it
                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                // priority. Bailout.

                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);

                if (child !== null) {
                  // The fallback children have pending work. Skip over the
                  // primary children and work on the fallback.
                  return child.sibling;
                } else {
                  return null;
                }
              }
            } else {
              pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
            }

            break;
          }

        case SuspenseListComponent:
          {
            var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;

            var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

            if (didSuspendBefore) {
              if (_hasChildWork) {
                // If something was in fallback state last time, and we have all the
                // same children then we're still in progressive loading state.
                // Something might get unblocked by state updates or retries in the
                // tree which will affect the tail. So we need to use the normal
                // path to compute the correct tail.
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
              } // If none of the children had any work, that means that none of
              // them got retried so they'll still be blocked in the same way
              // as before. We can fast bail out.


              workInProgress.flags |= DidCapture;
            } // If nothing suspended before and we're rendering the same children,
            // then the tail doesn't matter. Anything new that suspends will work
            // in the "together" mode, so we can continue from the state we had.


            var renderState = workInProgress.memoizedState;

            if (renderState !== null) {
              // Reset to the "together" mode in case we've started a different
              // update in the past but didn't complete it.
              renderState.rendering = null;
              renderState.tail = null;
              renderState.lastEffect = null;
            }

            pushSuspenseContext(workInProgress, suspenseStackCursor.current);

            if (_hasChildWork) {
              break;
            } else {
              // If none of the children had any work, that means that none of
              // them got retried so they'll still be blocked in the same way
              // as before. We can fast bail out.
              return null;
            }
          }

        case OffscreenComponent:
        case LegacyHiddenComponent:
          {
            // Need to check if the tree still needs to be deferred. This is
            // almost identical to the logic used in the normal update path,
            // so we'll just enter that. The only difference is we'll bail out
            // at the next level instead of this one, because the child props
            // have not changed. Which is fine.
            // TODO: Probably should refactor `beginWork` to split the bailout
            // path from the normal path. I'm tempted to do a labeled break here
            // but I won't :)
            workInProgress.lanes = NoLanes;
            return updateOffscreenComponent(current, workInProgress, renderLanes);
          }
      }

      return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    } else {
      if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
        // This is a special case that only exists for legacy mode.
        // See https://github.com/facebook/react/pull/19216.
        didReceiveUpdate = true;
      } else {
        // An update was scheduled on this fiber, but there are no new props
        // nor legacy context. Set this to false. If an update queue or context
        // consumer produces a changed value, it will set this to true. Otherwise,
        // the component will assume the children have not changed and bail out.
        didReceiveUpdate = false;
      }
    }
  } else {
    didReceiveUpdate = false;
  } // Before entering the begin phase, clear pending update priority.
  // TODO: This assumes that we're about to evaluate the component and process
  // the update queue. However, there's an exception: SimpleMemoComponent
  // sometimes bails out later in the begin phase. This indicates that we should
  // move this assignment out of the common path and into each branch.


  workInProgress.lanes = NoLanes;

  switch (workInProgress.tag) {
    case IndeterminateComponent:
      {
        return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
      }

    case LazyComponent:
      {
        var elementType = workInProgress.elementType;
        return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
      }

    case FunctionComponent:
      {
        var _Component = workInProgress.type;
        var unresolvedProps = workInProgress.pendingProps;
        var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
        return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
      }

    case ClassComponent:
      {
        var _Component2 = workInProgress.type;
        var _unresolvedProps = workInProgress.pendingProps;

        var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);

        return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
      }

    case HostRoot:
      return updateHostRoot(current, workInProgress, renderLanes);

    case HostComponent:
      return updateHostComponent(current, workInProgress, renderLanes);

    case HostText:
      return updateHostText(current, workInProgress);

    case SuspenseComponent:
      return updateSuspenseComponent(current, workInProgress, renderLanes);

    case HostPortal:
      return updatePortalComponent(current, workInProgress, renderLanes);

    case ForwardRef:
      {
        var type = workInProgress.type;
        var _unresolvedProps2 = workInProgress.pendingProps;

        var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);

        return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
      }

    case Fragment:
      return updateFragment(current, workInProgress, renderLanes);

    case Mode:
      return updateMode(current, workInProgress, renderLanes);

    case Profiler:
      return updateProfiler(current, workInProgress, renderLanes);

    case ContextProvider:
      return updateContextProvider(current, workInProgress, renderLanes);

    case ContextConsumer:
      return updateContextConsumer(current, workInProgress, renderLanes);

    case MemoComponent:
      {
        var _type2 = workInProgress.type;
        var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.

        var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);

        {
          if (workInProgress.type !== workInProgress.elementType) {
            var outerPropTypes = _type2.propTypes;

            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, _resolvedProps3, // Resolved for outer only
              'prop', getComponentName(_type2));
            }
          }
        }

        _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
        return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
      }

    case SimpleMemoComponent:
      {
        return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
      }

    case IncompleteClassComponent:
      {
        var _Component3 = workInProgress.type;
        var _unresolvedProps4 = workInProgress.pendingProps;

        var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);

        return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
      }

    case SuspenseListComponent:
      {
        return updateSuspenseListComponent(current, workInProgress, renderLanes);
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case Block:
      {

        break;
      }

    case OffscreenComponent:
      {
        return updateOffscreenComponent(current, workInProgress, renderLanes);
      }

    case LegacyHiddenComponent:
      {
        return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
      }
  }

  {
    {
      throw Error( "Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function markUpdate(workInProgress) {
  // Tag the fiber with an update effect. This turns a Placement into
  // a PlacementAndUpdate.
  workInProgress.flags |= Update;
}

function markRef$1(workInProgress) {
  workInProgress.flags |= Ref;
}

var appendAllChildren;
var updateHostContainer;
var updateHostComponent$1;
var updateHostText$1;

{
  // Mutation mode
  appendAllChildren = function (parent, workInProgress, needsVisibilityToggle, isHidden) {
    // We only have the top Fiber that was created but we need recurse down its
    // children to find all the terminal nodes.
    var node = workInProgress.child;

    while (node !== null) {
      if (node.tag === HostComponent || node.tag === HostText) {
        appendInitialChild(parent, node.stateNode);
      } else if (node.tag === HostPortal) ; else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === workInProgress) {
        return;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === workInProgress) {
          return;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  };

  updateHostContainer = function (workInProgress) {// Noop
  };

  updateHostComponent$1 = function (current, workInProgress, type, newProps, rootContainerInstance) {
    // If we have an alternate, that means this is an update and we need to
    // schedule a side-effect to do the updates.
    var oldProps = current.memoizedProps;

    if (oldProps === newProps) {
      // In mutation mode, this is sufficient for a bailout because
      // we won't touch this node even if children changed.
      return;
    } // If we get updated because one of our children updated, we don't
    // have newProps so we'll have to reuse them.
    // TODO: Split the update API as separate for the props vs. children.
    // Even better would be if children weren't special cased at all tho.


    var instance = workInProgress.stateNode;
    var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
    // component is hitting the resume path. Figure out why. Possibly
    // related to `hidden`.

    var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.

    workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
    // is a new ref we mark this as an update. All the work is done in commitWork.

    if (updatePayload) {
      markUpdate(workInProgress);
    }
  };

  updateHostText$1 = function (current, workInProgress, oldText, newText) {
    // If the text differs, mark it as an update. All the work in done in commitWork.
    if (oldText !== newText) {
      markUpdate(workInProgress);
    }
  };
}

function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
  if (getIsHydrating()) {
    // If we're hydrating, we should consume as many items as we can
    // so we don't leave any behind.
    return;
  }

  switch (renderState.tailMode) {
    case 'hidden':
      {
        // Any insertions at the end of the tail list after this point
        // should be invisible. If there are already mounted boundaries
        // anything before them are not considered for collapsing.
        // Therefore we need to go through the whole tail to find if
        // there are any.
        var tailNode = renderState.tail;
        var lastTailNode = null;

        while (tailNode !== null) {
          if (tailNode.alternate !== null) {
            lastTailNode = tailNode;
          }

          tailNode = tailNode.sibling;
        } // Next we're simply going to delete all insertions after the
        // last rendered item.


        if (lastTailNode === null) {
          // All remaining items in the tail are insertions.
          renderState.tail = null;
        } else {
          // Detach the insertion after the last node that was already
          // inserted.
          lastTailNode.sibling = null;
        }

        break;
      }

    case 'collapsed':
      {
        // Any insertions at the end of the tail list after this point
        // should be invisible. If there are already mounted boundaries
        // anything before them are not considered for collapsing.
        // Therefore we need to go through the whole tail to find if
        // there are any.
        var _tailNode = renderState.tail;
        var _lastTailNode = null;

        while (_tailNode !== null) {
          if (_tailNode.alternate !== null) {
            _lastTailNode = _tailNode;
          }

          _tailNode = _tailNode.sibling;
        } // Next we're simply going to delete all insertions after the
        // last rendered item.


        if (_lastTailNode === null) {
          // All remaining items in the tail are insertions.
          if (!hasRenderedATailFallback && renderState.tail !== null) {
            // We suspended during the head. We want to show at least one
            // row at the tail. So we'll keep on and cut off the rest.
            renderState.tail.sibling = null;
          } else {
            renderState.tail = null;
          }
        } else {
          // Detach the insertion after the last node that was already
          // inserted.
          _lastTailNode.sibling = null;
        }

        break;
      }
  }
}

function completeWork(current, workInProgress, renderLanes) {
  var newProps = workInProgress.pendingProps;

  switch (workInProgress.tag) {
    case IndeterminateComponent:
    case LazyComponent:
    case SimpleMemoComponent:
    case FunctionComponent:
    case ForwardRef:
    case Fragment:
    case Mode:
    case Profiler:
    case ContextConsumer:
    case MemoComponent:
      return null;

    case ClassComponent:
      {
        var Component = workInProgress.type;

        if (isContextProvider(Component)) {
          popContext(workInProgress);
        }

        return null;
      }

    case HostRoot:
      {
        popHostContainer(workInProgress);
        popTopLevelContextObject(workInProgress);
        resetWorkInProgressVersions();
        var fiberRoot = workInProgress.stateNode;

        if (fiberRoot.pendingContext) {
          fiberRoot.context = fiberRoot.pendingContext;
          fiberRoot.pendingContext = null;
        }

        if (current === null || current.child === null) {
          // If we hydrated, pop so that we can delete any remaining children
          // that weren't hydrated.
          var wasHydrated = popHydrationState(workInProgress);

          if (wasHydrated) {
            // If we hydrated, then we'll need to schedule an update for
            // the commit side-effects on the root.
            markUpdate(workInProgress);
          } else if (!fiberRoot.hydrate) {
            // Schedule an effect to clear this container at the start of the next commit.
            // This handles the case of React rendering into a container with previous children.
            // It's also safe to do for updates too, because current.child would only be null
            // if the previous render was null (so the the container would already be empty).
            workInProgress.flags |= Snapshot;
          }
        }

        updateHostContainer(workInProgress);
        return null;
      }

    case HostComponent:
      {
        popHostContext(workInProgress);
        var rootContainerInstance = getRootHostContainer();
        var type = workInProgress.type;

        if (current !== null && workInProgress.stateNode != null) {
          updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);

          if (current.ref !== workInProgress.ref) {
            markRef$1(workInProgress);
          }
        } else {
          if (!newProps) {
            if (!(workInProgress.stateNode !== null)) {
              {
                throw Error( "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue." );
              }
            } // This can happen when we abort work.


            return null;
          }

          var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
          // "stack" as the parent. Then append children as we go in beginWork
          // or completeWork depending on whether we want to add them top->down or
          // bottom->up. Top->down is faster in IE11.

          var _wasHydrated = popHydrationState(workInProgress);

          if (_wasHydrated) {
            // TODO: Move this and createInstance step into the beginPhase
            // to consolidate.
            if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
              // If changes to the hydrated node need to be applied at the
              // commit-phase we mark this as such.
              markUpdate(workInProgress);
            }
          } else {
            var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
            appendAllChildren(instance, workInProgress, false, false);
            workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
            // (eg DOM renderer supports auto-focus for certain elements).
            // Make sure such renderers get scheduled for later work.

            if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
              markUpdate(workInProgress);
            }
          }

          if (workInProgress.ref !== null) {
            // If there is a ref on a host node we need to schedule a callback
            markRef$1(workInProgress);
          }
        }

        return null;
      }

    case HostText:
      {
        var newText = newProps;

        if (current && workInProgress.stateNode != null) {
          var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
          // to schedule a side-effect to do the updates.

          updateHostText$1(current, workInProgress, oldText, newText);
        } else {
          if (typeof newText !== 'string') {
            if (!(workInProgress.stateNode !== null)) {
              {
                throw Error( "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue." );
              }
            } // This can happen when we abort work.

          }

          var _rootContainerInstance = getRootHostContainer();

          var _currentHostContext = getHostContext();

          var _wasHydrated2 = popHydrationState(workInProgress);

          if (_wasHydrated2) {
            if (prepareToHydrateHostTextInstance(workInProgress)) {
              markUpdate(workInProgress);
            }
          } else {
            workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
          }
        }

        return null;
      }

    case SuspenseComponent:
      {
        popSuspenseContext(workInProgress);
        var nextState = workInProgress.memoizedState;

        if ((workInProgress.flags & DidCapture) !== NoFlags) {
          // Something suspended. Re-render with the fallback children.
          workInProgress.lanes = renderLanes; // Do not reset the effect list.

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        var nextDidTimeout = nextState !== null;
        var prevDidTimeout = false;

        if (current === null) {
          if (workInProgress.memoizedProps.fallback !== undefined) {
            popHydrationState(workInProgress);
          }
        } else {
          var prevState = current.memoizedState;
          prevDidTimeout = prevState !== null;
        }

        if (nextDidTimeout && !prevDidTimeout) {
          // If this subtreee is running in blocking mode we can suspend,
          // otherwise we won't suspend.
          // TODO: This will still suspend a synchronous tree if anything
          // in the concurrent tree already suspended during this render.
          // This is a known bug.
          if ((workInProgress.mode & BlockingMode) !== NoMode) {
            // TODO: Move this back to throwException because this is too late
            // if this is a large tree which is common for initial loads. We
            // don't know if we should restart a render or not until we get
            // this marker, and this is too late.
            // If this render already had a ping or lower pri updates,
            // and this is the first time we know we're going to suspend we
            // should be able to immediately restart from within throwException.
            var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;

            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
              // If this was in an invisible tree or a new render, then showing
              // this boundary is ok.
              renderDidSuspend();
            } else {
              // Otherwise, we're going to have to hide content so we should
              // suspend for longer if possible.
              renderDidSuspendDelayIfPossible();
            }
          }
        }

        {
          // TODO: Only schedule updates if these values are non equal, i.e. it changed.
          if (nextDidTimeout || prevDidTimeout) {
            // If this boundary just timed out, schedule an effect to attach a
            // retry listener to the promise. This flag is also used to hide the
            // primary children. In mutation mode, we also need the flag to
            // *unhide* children that were previously hidden, so check if this
            // is currently timed out, too.
            workInProgress.flags |= Update;
          }
        }

        return null;
      }

    case HostPortal:
      popHostContainer(workInProgress);
      updateHostContainer(workInProgress);

      if (current === null) {
        preparePortalMount(workInProgress.stateNode.containerInfo);
      }

      return null;

    case ContextProvider:
      // Pop provider fiber
      popProvider(workInProgress);
      return null;

    case IncompleteClassComponent:
      {
        // Same as class component case. I put it down here so that the tags are
        // sequential to ensure this switch is compiled to a jump table.
        var _Component = workInProgress.type;

        if (isContextProvider(_Component)) {
          popContext(workInProgress);
        }

        return null;
      }

    case SuspenseListComponent:
      {
        popSuspenseContext(workInProgress);
        var renderState = workInProgress.memoizedState;

        if (renderState === null) {
          // We're running in the default, "independent" mode.
          // We don't do anything in this mode.
          return null;
        }

        var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
        var renderedTail = renderState.rendering;

        if (renderedTail === null) {
          // We just rendered the head.
          if (!didSuspendAlready) {
            // This is the first pass. We need to figure out if anything is still
            // suspended in the rendered set.
            // If new content unsuspended, but there's still some content that
            // didn't. Then we need to do a second pass that forces everything
            // to keep showing their fallbacks.
            // We might be suspended if something in this render pass suspended, or
            // something in the previous committed pass suspended. Otherwise,
            // there's no chance so we can skip the expensive call to
            // findFirstSuspended.
            var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);

            if (!cannotBeSuspended) {
              var row = workInProgress.child;

              while (row !== null) {
                var suspended = findFirstSuspended(row);

                if (suspended !== null) {
                  didSuspendAlready = true;
                  workInProgress.flags |= DidCapture;
                  cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                  // part of the second pass. In that case nothing will subscribe to
                  // its thennables. Instead, we'll transfer its thennables to the
                  // SuspenseList so that it can retry if they resolve.
                  // There might be multiple of these in the list but since we're
                  // going to wait for all of them anyway, it doesn't really matter
                  // which ones gets to ping. In theory we could get clever and keep
                  // track of how many dependencies remain but it gets tricky because
                  // in the meantime, we can add/remove/change items and dependencies.
                  // We might bail out of the loop before finding any but that
                  // doesn't matter since that means that the other boundaries that
                  // we did find already has their listeners attached.

                  var newThennables = suspended.updateQueue;

                  if (newThennables !== null) {
                    workInProgress.updateQueue = newThennables;
                    workInProgress.flags |= Update;
                  } // Rerender the whole list, but this time, we'll force fallbacks
                  // to stay in place.
                  // Reset the effect list before doing the second pass since that's now invalid.


                  if (renderState.lastEffect === null) {
                    workInProgress.firstEffect = null;
                  }

                  workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.

                  resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                  // rerender the children.

                  pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                  return workInProgress.child;
                }

                row = row.sibling;
              }
            }

            if (renderState.tail !== null && now() > getRenderTargetTime()) {
              // We have already passed our CPU deadline but we still have rows
              // left in the tail. We'll just give up further attempts to render
              // the main content and only render fallbacks.
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true;
              cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
              // to get it started back up to attempt the next item. While in terms
              // of priority this work has the same priority as this current render,
              // it's not part of the same transition once the transition has
              // committed. If it's sync, we still want to yield so that it can be
              // painted. Conceptually, this is really the same as pinging.
              // We can use any RetryLane even if it's the one currently rendering
              // since we're leaving it behind on this node.

              workInProgress.lanes = SomeRetryLane;

              {
                markSpawnedWork(SomeRetryLane);
              }
            }
          } else {
            cutOffTailIfNeeded(renderState, false);
          } // Next we're going to render the tail.

        } else {
          // Append the rendered row to the child list.
          if (!didSuspendAlready) {
            var _suspended = findFirstSuspended(renderedTail);

            if (_suspended !== null) {
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
              // get lost if this row ends up dropped during a second pass.

              var _newThennables = _suspended.updateQueue;

              if (_newThennables !== null) {
                workInProgress.updateQueue = _newThennables;
                workInProgress.flags |= Update;
              }

              cutOffTailIfNeeded(renderState, true); // This might have been modified.

              if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
              ) {
                  // We need to delete the row we just rendered.
                  // Reset the effect list to what it was before we rendered this
                  // child. The nested children have already appended themselves.
                  var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.

                  if (lastEffect !== null) {
                    lastEffect.nextEffect = null;
                  } // We're done.


                  return null;
                }
            } else if ( // The time it took to render last row is greater than the remaining
            // time we have to render. So rendering one more row would likely
            // exceed it.
            now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
              // We have now passed our CPU deadline and we'll just give up further
              // attempts to render the main content and only render fallbacks.
              // The assumption is that this is usually faster.
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true;
              cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
              // to get it started back up to attempt the next item. While in terms
              // of priority this work has the same priority as this current render,
              // it's not part of the same transition once the transition has
              // committed. If it's sync, we still want to yield so that it can be
              // painted. Conceptually, this is really the same as pinging.
              // We can use any RetryLane even if it's the one currently rendering
              // since we're leaving it behind on this node.

              workInProgress.lanes = SomeRetryLane;

              {
                markSpawnedWork(SomeRetryLane);
              }
            }
          }

          if (renderState.isBackwards) {
            // The effect list of the backwards tail will have been added
            // to the end. This breaks the guarantee that life-cycles fire in
            // sibling order but that isn't a strong guarantee promised by React.
            // Especially since these might also just pop in during future commits.
            // Append to the beginning of the list.
            renderedTail.sibling = workInProgress.child;
            workInProgress.child = renderedTail;
          } else {
            var previousSibling = renderState.last;

            if (previousSibling !== null) {
              previousSibling.sibling = renderedTail;
            } else {
              workInProgress.child = renderedTail;
            }

            renderState.last = renderedTail;
          }
        }

        if (renderState.tail !== null) {
          // We still have tail rows to render.
          // Pop a row.
          var next = renderState.tail;
          renderState.rendering = next;
          renderState.tail = next.sibling;
          renderState.lastEffect = workInProgress.lastEffect;
          renderState.renderingStartTime = now();
          next.sibling = null; // Restore the context.
          // TODO: We can probably just avoid popping it instead and only
          // setting it the first time we go from not suspended to suspended.

          var suspenseContext = suspenseStackCursor.current;

          if (didSuspendAlready) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          } else {
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          }

          pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.

          return next;
        }

        return null;
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case Block:

      break;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      {
        popRenderLanes(workInProgress);

        if (current !== null) {
          var _nextState = workInProgress.memoizedState;
          var _prevState = current.memoizedState;
          var prevIsHidden = _prevState !== null;
          var nextIsHidden = _nextState !== null;

          if (prevIsHidden !== nextIsHidden && newProps.mode !== 'unstable-defer-without-hiding') {
            workInProgress.flags |= Update;
          }
        }

        return null;
      }
  }

  {
    {
      throw Error( "Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function unwindWork(workInProgress, renderLanes) {
  switch (workInProgress.tag) {
    case ClassComponent:
      {
        var Component = workInProgress.type;

        if (isContextProvider(Component)) {
          popContext(workInProgress);
        }

        var flags = workInProgress.flags;

        if (flags & ShouldCapture) {
          workInProgress.flags = flags & ~ShouldCapture | DidCapture;

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        return null;
      }

    case HostRoot:
      {
        popHostContainer(workInProgress);
        popTopLevelContextObject(workInProgress);
        resetWorkInProgressVersions();
        var _flags = workInProgress.flags;

        if (!((_flags & DidCapture) === NoFlags)) {
          {
            throw Error( "The root failed to unmount after an error. This is likely a bug in React. Please file an issue." );
          }
        }

        workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
        return workInProgress;
      }

    case HostComponent:
      {
        // TODO: popHydrationState
        popHostContext(workInProgress);
        return null;
      }

    case SuspenseComponent:
      {
        popSuspenseContext(workInProgress);

        var _flags2 = workInProgress.flags;

        if (_flags2 & ShouldCapture) {
          workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        return null;
      }

    case SuspenseListComponent:
      {
        popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
        // caught by a nested boundary. If not, it should bubble through.

        return null;
      }

    case HostPortal:
      popHostContainer(workInProgress);
      return null;

    case ContextProvider:
      popProvider(workInProgress);
      return null;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      popRenderLanes(workInProgress);
      return null;

    default:
      return null;
  }
}

function unwindInterruptedWork(interruptedWork) {
  switch (interruptedWork.tag) {
    case ClassComponent:
      {
        var childContextTypes = interruptedWork.type.childContextTypes;

        if (childContextTypes !== null && childContextTypes !== undefined) {
          popContext(interruptedWork);
        }

        break;
      }

    case HostRoot:
      {
        popHostContainer(interruptedWork);
        popTopLevelContextObject(interruptedWork);
        resetWorkInProgressVersions();
        break;
      }

    case HostComponent:
      {
        popHostContext(interruptedWork);
        break;
      }

    case HostPortal:
      popHostContainer(interruptedWork);
      break;

    case SuspenseComponent:
      popSuspenseContext(interruptedWork);
      break;

    case SuspenseListComponent:
      popSuspenseContext(interruptedWork);
      break;

    case ContextProvider:
      popProvider(interruptedWork);
      break;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      popRenderLanes(interruptedWork);
      break;
  }
}

function createCapturedValue(value, source) {
  // If the value is an error, call this function immediately after it is thrown
  // so the stack is accurate.
  return {
    value: value,
    source: source,
    stack: getStackByFiberInDevAndProd(source)
  };
}

// This module is forked in different environments.
// By default, return `true` to log errors to the console.
// Forks can return `false` if this isn't desirable.
function showErrorDialog(boundary, errorInfo) {
  return true;
}

function logCapturedError(boundary, errorInfo) {
  try {
    var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
    // This enables renderers like ReactNative to better manage redbox behavior.

    if (logError === false) {
      return;
    }

    var error = errorInfo.value;

    if (true) {
      var source = errorInfo.source;
      var stack = errorInfo.stack;
      var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
      // `preventDefault()` in window `error` handler.
      // We record this information as an expando on the error.

      if (error != null && error._suppressLogging) {
        if (boundary.tag === ClassComponent) {
          // The error is recoverable and was silenced.
          // Ignore it and don't print the stack addendum.
          // This is handy for testing error boundaries without noise.
          return;
        } // The error is fatal. Since the silencing might have
        // been accidental, we'll surface it anyway.
        // However, the browser would have silenced the original error
        // so we'll print it first, and then print the stack addendum.


        console['error'](error); // Don't transform to our wrapper
        // For a more detailed description of this block, see:
        // https://github.com/facebook/react/pull/13384
      }

      var componentName = source ? getComponentName(source.type) : null;
      var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
      var errorBoundaryMessage;
      var errorBoundaryName = getComponentName(boundary.type);

      if (errorBoundaryName) {
        errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
      } else {
        errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.';
      }

      var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
      // We don't include the original error message and JS stack because the browser
      // has already printed it. Even if the application swallows the error, it is still
      // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

      console['error'](combinedMessage); // Don't transform to our wrapper
    } else {
      // In production, we print the error directly.
      // This will include the message, the JS stack, and anything the browser wants to show.
      // We pass the error object instead of custom message so that the browser displays the error natively.
      console['error'](error); // Don't transform to our wrapper
    }
  } catch (e) {
    // This method must not throw, or React internal state will get messed up.
    // If console.error is overridden, or logCapturedError() shows a dialog that throws,
    // we want to report this error outside of the normal stack as a last resort.
    // https://github.com/facebook/react/issues/13188
    setTimeout(function () {
      throw e;
    });
  }
}

var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;

function createRootErrorUpdate(fiber, errorInfo, lane) {
  var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.

  update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
  // being called "element".

  update.payload = {
    element: null
  };
  var error = errorInfo.value;

  update.callback = function () {
    onUncaughtError(error);
    logCapturedError(fiber, errorInfo);
  };

  return update;
}

function createClassErrorUpdate(fiber, errorInfo, lane) {
  var update = createUpdate(NoTimestamp, lane);
  update.tag = CaptureUpdate;
  var getDerivedStateFromError = fiber.type.getDerivedStateFromError;

  if (typeof getDerivedStateFromError === 'function') {
    var error$1 = errorInfo.value;

    update.payload = function () {
      logCapturedError(fiber, errorInfo);
      return getDerivedStateFromError(error$1);
    };
  }

  var inst = fiber.stateNode;

  if (inst !== null && typeof inst.componentDidCatch === 'function') {
    update.callback = function callback() {
      {
        markFailedErrorBoundaryForHotReloading(fiber);
      }

      if (typeof getDerivedStateFromError !== 'function') {
        // To preserve the preexisting retry behavior of error boundaries,
        // we keep track of which ones already failed during this batch.
        // This gets reset before we yield back to the browser.
        // TODO: Warn in strict mode if getDerivedStateFromError is
        // not defined.
        markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined

        logCapturedError(fiber, errorInfo);
      }

      var error$1 = errorInfo.value;
      var stack = errorInfo.stack;
      this.componentDidCatch(error$1, {
        componentStack: stack !== null ? stack : ''
      });

      {
        if (typeof getDerivedStateFromError !== 'function') {
          // If componentDidCatch is the only error boundary method defined,
          // then it needs to call setState to recover from errors.
          // If no state update is scheduled then the boundary will swallow the error.
          if (!includesSomeLane(fiber.lanes, SyncLane)) {
            error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown');
          }
        }
      }
    };
  } else {
    update.callback = function () {
      markFailedErrorBoundaryForHotReloading(fiber);
    };
  }

  return update;
}

function attachPingListener(root, wakeable, lanes) {
  // Attach a listener to the promise to "ping" the root and retry. But only if
  // one does not already exist for the lanes we're currently rendering (which
  // acts like a "thread ID" here).
  var pingCache = root.pingCache;
  var threadIDs;

  if (pingCache === null) {
    pingCache = root.pingCache = new PossiblyWeakMap$1();
    threadIDs = new Set();
    pingCache.set(wakeable, threadIDs);
  } else {
    threadIDs = pingCache.get(wakeable);

    if (threadIDs === undefined) {
      threadIDs = new Set();
      pingCache.set(wakeable, threadIDs);
    }
  }

  if (!threadIDs.has(lanes)) {
    // Memoize using the thread ID to prevent redundant listeners.
    threadIDs.add(lanes);
    var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
    wakeable.then(ping, ping);
  }
}

function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
  // The source fiber did not complete.
  sourceFiber.flags |= Incomplete; // Its effect list is no longer valid.

  sourceFiber.firstEffect = sourceFiber.lastEffect = null;

  if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
    // This is a wakeable.
    var wakeable = value;

    if ((sourceFiber.mode & BlockingMode) === NoMode) {
      // Reset the memoizedState to what it was before we attempted
      // to render it.
      var currentSource = sourceFiber.alternate;

      if (currentSource) {
        sourceFiber.updateQueue = currentSource.updateQueue;
        sourceFiber.memoizedState = currentSource.memoizedState;
        sourceFiber.lanes = currentSource.lanes;
      } else {
        sourceFiber.updateQueue = null;
        sourceFiber.memoizedState = null;
      }
    }

    var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.

    var _workInProgress = returnFiber;

    do {
      if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
        // Found the nearest boundary.
        // Stash the promise on the boundary fiber. If the boundary times out, we'll
        // attach another listener to flip the boundary back to its normal state.
        var wakeables = _workInProgress.updateQueue;

        if (wakeables === null) {
          var updateQueue = new Set();
          updateQueue.add(wakeable);
          _workInProgress.updateQueue = updateQueue;
        } else {
          wakeables.add(wakeable);
        } // If the boundary is outside of blocking mode, we should *not*
        // suspend the commit. Pretend as if the suspended component rendered
        // null and keep rendering. In the commit phase, we'll schedule a
        // subsequent synchronous update to re-render the Suspense.
        //
        // Note: It doesn't matter whether the component that suspended was
        // inside a blocking mode tree. If the Suspense is outside of it, we
        // should *not* suspend the commit.


        if ((_workInProgress.mode & BlockingMode) === NoMode) {
          _workInProgress.flags |= DidCapture;
          sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
          // But we shouldn't call any lifecycle methods or callbacks. Remove
          // all lifecycle effect tags.

          sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);

          if (sourceFiber.tag === ClassComponent) {
            var currentSourceFiber = sourceFiber.alternate;

            if (currentSourceFiber === null) {
              // This is a new mount. Change the tag so it's not mistaken for a
              // completed class component. For example, we should not call
              // componentWillUnmount if it is deleted.
              sourceFiber.tag = IncompleteClassComponent;
            } else {
              // When we try rendering again, we should not reuse the current fiber,
              // since it's known to be in an inconsistent state. Use a force update to
              // prevent a bail out.
              var update = createUpdate(NoTimestamp, SyncLane);
              update.tag = ForceUpdate;
              enqueueUpdate(sourceFiber, update);
            }
          } // The source fiber did not complete. Mark it with Sync priority to
          // indicate that it still has pending work.


          sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane); // Exit without suspending.

          return;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.


        attachPingListener(root, wakeable, rootRenderLanes);
        _workInProgress.flags |= ShouldCapture;
        _workInProgress.lanes = rootRenderLanes;
        return;
      } // This boundary already captured during this render. Continue to the next
      // boundary.


      _workInProgress = _workInProgress.return;
    } while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
    // TODO: Use invariant so the message is stripped in prod?


    value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.');
  } // We didn't find a boundary that could handle this type of exception. Start
  // over and traverse parent path again, this time treating the exception
  // as an error.


  renderDidError();
  value = createCapturedValue(value, sourceFiber);
  var workInProgress = returnFiber;

  do {
    switch (workInProgress.tag) {
      case HostRoot:
        {
          var _errorInfo = value;
          workInProgress.flags |= ShouldCapture;
          var lane = pickArbitraryLane(rootRenderLanes);
          workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);

          var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);

          enqueueCapturedUpdate(workInProgress, _update);
          return;
        }

      case ClassComponent:
        // Capture and retry
        var errorInfo = value;
        var ctor = workInProgress.type;
        var instance = workInProgress.stateNode;

        if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
          workInProgress.flags |= ShouldCapture;

          var _lane = pickArbitraryLane(rootRenderLanes);

          workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state

          var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);

          enqueueCapturedUpdate(workInProgress, _update2);
          return;
        }

        break;
    }

    workInProgress = workInProgress.return;
  } while (workInProgress !== null);
}

var didWarnAboutUndefinedSnapshotBeforeUpdate = null;

{
  didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
}

var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;

var callComponentWillUnmountWithTimer = function (current, instance) {
  instance.props = current.memoizedProps;
  instance.state = current.memoizedState;

  {
    instance.componentWillUnmount();
  }
}; // Capture errors so they don't interrupt unmounting.


function safelyCallComponentWillUnmount(current, instance) {
  {
    invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);

    if (hasCaughtError()) {
      var unmountError = clearCaughtError();
      captureCommitPhaseError(current, unmountError);
    }
  }
}

function safelyDetachRef(current) {
  var ref = current.ref;

  if (ref !== null) {
    if (typeof ref === 'function') {
      {
        invokeGuardedCallback(null, ref, null, null);

        if (hasCaughtError()) {
          var refError = clearCaughtError();
          captureCommitPhaseError(current, refError);
        }
      }
    } else {
      ref.current = null;
    }
  }
}

function safelyCallDestroy(current, destroy) {
  {
    invokeGuardedCallback(null, destroy, null);

    if (hasCaughtError()) {
      var error = clearCaughtError();
      captureCommitPhaseError(current, error);
    }
  }
}

function commitBeforeMutationLifeCycles(current, finishedWork) {
  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case SimpleMemoComponent:
    case Block:
      {
        return;
      }

    case ClassComponent:
      {
        if (finishedWork.flags & Snapshot) {
          if (current !== null) {
            var prevProps = current.memoizedProps;
            var prevState = current.memoizedState;
            var instance = finishedWork.stateNode; // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.

            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);

            {
              var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;

              if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                didWarnSet.add(finishedWork.type);

                error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
              }
            }

            instance.__reactInternalSnapshotBeforeUpdate = snapshot;
          }
        }

        return;
      }

    case HostRoot:
      {
        {
          if (finishedWork.flags & Snapshot) {
            var root = finishedWork.stateNode;
            clearContainer(root.containerInfo);
          }
        }

        return;
      }

    case HostComponent:
    case HostText:
    case HostPortal:
    case IncompleteClassComponent:
      // Nothing to do for these component types
      return;
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function commitHookEffectListUnmount(tag, finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      if ((effect.tag & tag) === tag) {
        // Unmount
        var destroy = effect.destroy;
        effect.destroy = undefined;

        if (destroy !== undefined) {
          destroy();
        }
      }

      effect = effect.next;
    } while (effect !== firstEffect);
  }
}

function commitHookEffectListMount(tag, finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      if ((effect.tag & tag) === tag) {
        // Mount
        var create = effect.create;
        effect.destroy = create();

        {
          var destroy = effect.destroy;

          if (destroy !== undefined && typeof destroy !== 'function') {
            var addendum = void 0;

            if (destroy === null) {
              addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
            } else if (typeof destroy.then === 'function') {
              addendum = '\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + 'useEffect(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
            } else {
              addendum = ' You returned: ' + destroy;
            }

            error('An effect function must not return anything besides a function, ' + 'which is used for clean-up.%s', addendum);
          }
        }
      }

      effect = effect.next;
    } while (effect !== firstEffect);
  }
}

function schedulePassiveEffects(finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      var _effect = effect,
          next = _effect.next,
          tag = _effect.tag;

      if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
        enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
        enqueuePendingPassiveHookEffectMount(finishedWork, effect);
      }

      effect = next;
    } while (effect !== firstEffect);
  }
}

function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case SimpleMemoComponent:
    case Block:
      {
        // At this point layout effects have already been destroyed (during mutation phase).
        // This is done to prevent sibling component effects from interfering with each other,
        // e.g. a destroy function in one component should never override a ref set
        // by a create function in another component during the same commit.
        {
          commitHookEffectListMount(Layout | HasEffect, finishedWork);
        }

        schedulePassiveEffects(finishedWork);
        return;
      }

    case ClassComponent:
      {
        var instance = finishedWork.stateNode;

        if (finishedWork.flags & Update) {
          if (current === null) {
            // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.
            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            {
              instance.componentDidMount();
            }
          } else {
            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
            var prevState = current.memoizedState; // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.

            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            {
              instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
            }
          }
        } // TODO: I think this is now always non-null by the time it reaches the
        // commit phase. Consider removing the type check.


        var updateQueue = finishedWork.updateQueue;

        if (updateQueue !== null) {
          {
            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
              if (instance.props !== finishedWork.memoizedProps) {
                error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
              }

              if (instance.state !== finishedWork.memoizedState) {
                error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
              }
            }
          } // We could update instance props and state here,
          // but instead we rely on them being set during last render.
          // TODO: revisit this when we implement resuming.


          commitUpdateQueue(finishedWork, updateQueue, instance);
        }

        return;
      }

    case HostRoot:
      {
        // TODO: I think this is now always non-null by the time it reaches the
        // commit phase. Consider removing the type check.
        var _updateQueue = finishedWork.updateQueue;

        if (_updateQueue !== null) {
          var _instance = null;

          if (finishedWork.child !== null) {
            switch (finishedWork.child.tag) {
              case HostComponent:
                _instance = getPublicInstance(finishedWork.child.stateNode);
                break;

              case ClassComponent:
                _instance = finishedWork.child.stateNode;
                break;
            }
          }

          commitUpdateQueue(finishedWork, _updateQueue, _instance);
        }

        return;
      }

    case HostComponent:
      {
        var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
        // (eg DOM renderer may schedule auto-focus for inputs and form controls).
        // These effects should only be committed when components are first mounted,
        // aka when there is no current/alternate.

        if (current === null && finishedWork.flags & Update) {
          var type = finishedWork.type;
          var props = finishedWork.memoizedProps;
          commitMount(_instance2, type, props);
        }

        return;
      }

    case HostText:
      {
        // We have no life-cycles associated with text.
        return;
      }

    case HostPortal:
      {
        // We have no life-cycles associated with portals.
        return;
      }

    case Profiler:
      {
        {
          var _finishedWork$memoize2 = finishedWork.memoizedProps,
              onRender = _finishedWork$memoize2.onRender;
          var commitTime = getCommitTime();

          if (typeof onRender === 'function') {
            {
              onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
            }
          }
        }

        return;
      }

    case SuspenseComponent:
      {
        commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
        return;
      }

    case SuspenseListComponent:
    case IncompleteClassComponent:
    case FundamentalComponent:
    case ScopeComponent:
    case OffscreenComponent:
    case LegacyHiddenComponent:
      return;
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function hideOrUnhideAllChildren(finishedWork, isHidden) {
  {
    // We only have the top Fiber that was inserted but we need to recurse down its
    // children to find all the terminal nodes.
    var node = finishedWork;

    while (true) {
      if (node.tag === HostComponent) {
        var instance = node.stateNode;

        if (isHidden) {
          hideInstance(instance);
        } else {
          unhideInstance(node.stateNode, node.memoizedProps);
        }
      } else if (node.tag === HostText) {
        var _instance3 = node.stateNode;

        if (isHidden) {
          hideTextInstance(_instance3);
        } else {
          unhideTextInstance(_instance3, node.memoizedProps);
        }
      } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ; else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === finishedWork) {
        return;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === finishedWork) {
          return;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  }
}

function commitAttachRef(finishedWork) {
  var ref = finishedWork.ref;

  if (ref !== null) {
    var instance = finishedWork.stateNode;
    var instanceToUse;

    switch (finishedWork.tag) {
      case HostComponent:
        instanceToUse = getPublicInstance(instance);
        break;

      default:
        instanceToUse = instance;
    } // Moved outside to ensure DCE works with this flag

    if (typeof ref === 'function') {
      ref(instanceToUse);
    } else {
      {
        if (!ref.hasOwnProperty('current')) {
          error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().', getComponentName(finishedWork.type));
        }
      }

      ref.current = instanceToUse;
    }
  }
}

function commitDetachRef(current) {
  var currentRef = current.ref;

  if (currentRef !== null) {
    if (typeof currentRef === 'function') {
      currentRef(null);
    } else {
      currentRef.current = null;
    }
  }
} // User-originating errors (lifecycles and refs) should not interrupt
// deletion, so don't let them throw. Host-originating errors should
// interrupt deletion, so it's okay


function commitUnmount(finishedRoot, current, renderPriorityLevel) {
  onCommitUnmount(current);

  switch (current.tag) {
    case FunctionComponent:
    case ForwardRef:
    case MemoComponent:
    case SimpleMemoComponent:
    case Block:
      {
        var updateQueue = current.updateQueue;

        if (updateQueue !== null) {
          var lastEffect = updateQueue.lastEffect;

          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;

            do {
              var _effect2 = effect,
                  destroy = _effect2.destroy,
                  tag = _effect2.tag;

              if (destroy !== undefined) {
                if ((tag & Passive$1) !== NoFlags$1) {
                  enqueuePendingPassiveHookEffectUnmount(current, effect);
                } else {
                  {
                    safelyCallDestroy(current, destroy);
                  }
                }
              }

              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }

        return;
      }

    case ClassComponent:
      {
        safelyDetachRef(current);
        var instance = current.stateNode;

        if (typeof instance.componentWillUnmount === 'function') {
          safelyCallComponentWillUnmount(current, instance);
        }

        return;
      }

    case HostComponent:
      {
        safelyDetachRef(current);
        return;
      }

    case HostPortal:
      {
        // TODO: this is recursive.
        // We are also not using this parent because
        // the portal will get pushed immediately.
        {
          unmountHostComponents(finishedRoot, current);
        }

        return;
      }

    case FundamentalComponent:
      {

        return;
      }

    case DehydratedFragment:
      {

        return;
      }

    case ScopeComponent:
      {

        return;
      }
  }
}

function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
  // While we're inside a removed host node we don't want to call
  // removeChild on the inner nodes because they're removed by the top
  // call anyway. We also want to call componentWillUnmount on all
  // composites before this host node is removed from the tree. Therefore
  // we do an inner loop while we're still inside the host node.
  var node = root;

  while (true) {
    commitUnmount(finishedRoot, node); // Visit children because they may contain more composite or host nodes.
    // Skip portals because commitUnmount() currently visits them recursively.

    if (node.child !== null && ( // If we use mutation we drill down into portals using commitUnmount above.
    // If we don't use mutation we drill down into portals here instead.
     node.tag !== HostPortal)) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === root) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === root) {
        return;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function detachFiberMutation(fiber) {
  // Cut off the return pointers to disconnect it from the tree. Ideally, we
  // should clear the child pointer of the parent alternate to let this
  // get GC:ed but we don't know which for sure which parent is the current
  // one so we'll settle for GC:ing the subtree of this child. This child
  // itself will be GC:ed when the parent updates the next time.
  // Note: we cannot null out sibling here, otherwise it can cause issues
  // with findDOMNode and how it requires the sibling field to carry out
  // traversal in a later effect. See PR #16820. We now clear the sibling
  // field after effects, see: detachFiberAfterEffects.
  //
  // Don't disconnect stateNode now; it will be detached in detachFiberAfterEffects.
  // It may be required if the current component is an error boundary,
  // and one of its descendants throws while unmounting a passive effect.
  fiber.alternate = null;
  fiber.child = null;
  fiber.dependencies = null;
  fiber.firstEffect = null;
  fiber.lastEffect = null;
  fiber.memoizedProps = null;
  fiber.memoizedState = null;
  fiber.pendingProps = null;
  fiber.return = null;
  fiber.updateQueue = null;

  {
    fiber._debugOwner = null;
  }
}

function getHostParentFiber(fiber) {
  var parent = fiber.return;

  while (parent !== null) {
    if (isHostParent(parent)) {
      return parent;
    }

    parent = parent.return;
  }

  {
    {
      throw Error( "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function isHostParent(fiber) {
  return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
}

function getHostSibling(fiber) {
  // We're going to search forward into the tree until we find a sibling host
  // node. Unfortunately, if multiple insertions are done in a row we have to
  // search past them. This leads to exponential search for the next sibling.
  // TODO: Find a more efficient way to do this.
  var node = fiber;

  siblings: while (true) {
    // If we didn't find anything, let's try the next sibling.
    while (node.sibling === null) {
      if (node.return === null || isHostParent(node.return)) {
        // If we pop out of the root or hit the parent the fiber we are the
        // last sibling.
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;

    while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
      // If it is not host node and, we might have a host node inside it.
      // Try to search down until we find one.
      if (node.flags & Placement) {
        // If we don't have a child, try the siblings instead.
        continue siblings;
      } // If we don't have a child, try the siblings instead.
      // We also skip portals because they are not part of this host tree.


      if (node.child === null || node.tag === HostPortal) {
        continue siblings;
      } else {
        node.child.return = node;
        node = node.child;
      }
    } // Check if this host node is stable or about to be placed.


    if (!(node.flags & Placement)) {
      // Found it!
      return node.stateNode;
    }
  }
}

function commitPlacement(finishedWork) {


  var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.

  var parent;
  var isContainer;
  var parentStateNode = parentFiber.stateNode;

  switch (parentFiber.tag) {
    case HostComponent:
      parent = parentStateNode;
      isContainer = false;
      break;

    case HostRoot:
      parent = parentStateNode.containerInfo;
      isContainer = true;
      break;

    case HostPortal:
      parent = parentStateNode.containerInfo;
      isContainer = true;
      break;

    case FundamentalComponent:

    // eslint-disable-next-line-no-fallthrough

    default:
      {
        {
          throw Error( "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue." );
        }
      }

  }

  if (parentFiber.flags & ContentReset) {
    // Reset the text content of the parent before doing any insertions
    resetTextContent(parent); // Clear ContentReset from the effect tag

    parentFiber.flags &= ~ContentReset;
  }

  var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
  // children to find all the terminal nodes.

  if (isContainer) {
    insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
  } else {
    insertOrAppendPlacementNode(finishedWork, before, parent);
  }
}

function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
  var tag = node.tag;
  var isHost = tag === HostComponent || tag === HostText;

  if (isHost || enableFundamentalAPI ) {
    var stateNode = isHost ? node.stateNode : node.stateNode.instance;

    if (before) {
      insertInContainerBefore(parent, stateNode, before);
    } else {
      appendChildToContainer(parent, stateNode);
    }
  } else if (tag === HostPortal) ; else {
    var child = node.child;

    if (child !== null) {
      insertOrAppendPlacementNodeIntoContainer(child, before, parent);
      var sibling = child.sibling;

      while (sibling !== null) {
        insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
        sibling = sibling.sibling;
      }
    }
  }
}

function insertOrAppendPlacementNode(node, before, parent) {
  var tag = node.tag;
  var isHost = tag === HostComponent || tag === HostText;

  if (isHost || enableFundamentalAPI ) {
    var stateNode = isHost ? node.stateNode : node.stateNode.instance;

    if (before) {
      insertBefore(parent, stateNode, before);
    } else {
      appendChild(parent, stateNode);
    }
  } else if (tag === HostPortal) ; else {
    var child = node.child;

    if (child !== null) {
      insertOrAppendPlacementNode(child, before, parent);
      var sibling = child.sibling;

      while (sibling !== null) {
        insertOrAppendPlacementNode(sibling, before, parent);
        sibling = sibling.sibling;
      }
    }
  }
}

function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
  // We only have the top Fiber that was deleted but we need to recurse down its
  // children to find all the terminal nodes.
  var node = current; // Each iteration, currentParent is populated with node's host parent if not
  // currentParentIsValid.

  var currentParentIsValid = false; // Note: these two variables *must* always be updated together.

  var currentParent;
  var currentParentIsContainer;

  while (true) {
    if (!currentParentIsValid) {
      var parent = node.return;

      findParent: while (true) {
        if (!(parent !== null)) {
          {
            throw Error( "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue." );
          }
        }

        var parentStateNode = parent.stateNode;

        switch (parent.tag) {
          case HostComponent:
            currentParent = parentStateNode;
            currentParentIsContainer = false;
            break findParent;

          case HostRoot:
            currentParent = parentStateNode.containerInfo;
            currentParentIsContainer = true;
            break findParent;

          case HostPortal:
            currentParent = parentStateNode.containerInfo;
            currentParentIsContainer = true;
            break findParent;

        }

        parent = parent.return;
      }

      currentParentIsValid = true;
    }

    if (node.tag === HostComponent || node.tag === HostText) {
      commitNestedUnmounts(finishedRoot, node); // After all the children have unmounted, it is now safe to remove the
      // node from the tree.

      if (currentParentIsContainer) {
        removeChildFromContainer(currentParent, node.stateNode);
      } else {
        removeChild(currentParent, node.stateNode);
      } // Don't visit children because we already visited them.

    } else if (node.tag === HostPortal) {
      if (node.child !== null) {
        // When we go into a portal, it becomes the parent to remove from.
        // We will reassign it back when we pop the portal on the way up.
        currentParent = node.stateNode.containerInfo;
        currentParentIsContainer = true; // Visit children because portals might contain host components.

        node.child.return = node;
        node = node.child;
        continue;
      }
    } else {
      commitUnmount(finishedRoot, node); // Visit children because we may find more host components below.

      if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }
    }

    if (node === current) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === current) {
        return;
      }

      node = node.return;

      if (node.tag === HostPortal) {
        // When we go out of the portal, we need to restore the parent.
        // Since we don't keep a stack of them, we will search for it.
        currentParentIsValid = false;
      }
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function commitDeletion(finishedRoot, current, renderPriorityLevel) {
  {
    // Recursively delete all host nodes from the parent.
    // Detach refs and call componentWillUnmount() on the whole subtree.
    unmountHostComponents(finishedRoot, current);
  }

  var alternate = current.alternate;
  detachFiberMutation(current);

  if (alternate !== null) {
    detachFiberMutation(alternate);
  }
}

function commitWork(current, finishedWork) {

  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case MemoComponent:
    case SimpleMemoComponent:
    case Block:
      {
        // Layout effects are destroyed during the mutation phase so that all
        // destroy functions for all fibers are called before any create functions.
        // This prevents sibling component effects from interfering with each other,
        // e.g. a destroy function in one component should never override a ref set
        // by a create function in another component during the same commit.
        {
          commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
        }

        return;
      }

    case ClassComponent:
      {
        return;
      }

    case HostComponent:
      {
        var instance = finishedWork.stateNode;

        if (instance != null) {
          // Commit the work prepared earlier.
          var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
          // as the newProps. The updatePayload will contain the real change in
          // this case.

          var oldProps = current !== null ? current.memoizedProps : newProps;
          var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

          var updatePayload = finishedWork.updateQueue;
          finishedWork.updateQueue = null;

          if (updatePayload !== null) {
            commitUpdate(instance, updatePayload, type, oldProps, newProps);
          }
        }

        return;
      }

    case HostText:
      {
        if (!(finishedWork.stateNode !== null)) {
          {
            throw Error( "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue." );
          }
        }

        var textInstance = finishedWork.stateNode;
        var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
        // as the newProps. The updatePayload will contain the real change in
        // this case.

        var oldText = current !== null ? current.memoizedProps : newText;
        commitTextUpdate(textInstance, oldText, newText);
        return;
      }

    case HostRoot:
      {
        {
          var _root = finishedWork.stateNode;

          if (_root.hydrate) {
            // We've just hydrated. No need to hydrate again.
            _root.hydrate = false;
            commitHydratedContainer(_root.containerInfo);
          }
        }

        return;
      }

    case Profiler:
      {
        return;
      }

    case SuspenseComponent:
      {
        commitSuspenseComponent(finishedWork);
        attachSuspenseRetryListeners(finishedWork);
        return;
      }

    case SuspenseListComponent:
      {
        attachSuspenseRetryListeners(finishedWork);
        return;
      }

    case IncompleteClassComponent:
      {
        return;
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case OffscreenComponent:
    case LegacyHiddenComponent:
      {
        var newState = finishedWork.memoizedState;
        var isHidden = newState !== null;
        hideOrUnhideAllChildren(finishedWork, isHidden);
        return;
      }
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function commitSuspenseComponent(finishedWork) {
  var newState = finishedWork.memoizedState;

  if (newState !== null) {
    markCommitTimeOfFallback();

    {
      // Hide the Offscreen component that contains the primary children. TODO:
      // Ideally, this effect would have been scheduled on the Offscreen fiber
      // itself. That's how unhiding works: the Offscreen component schedules an
      // effect on itself. However, in this case, the component didn't complete,
      // so the fiber was never added to the effect list in the normal path. We
      // could have appended it to the effect list in the Suspense component's
      // second pass, but doing it this way is less complicated. This would be
      // simpler if we got rid of the effect list and traversed the tree, like
      // we're planning to do.
      var primaryChildParent = finishedWork.child;
      hideOrUnhideAllChildren(primaryChildParent, true);
    }
  }
}

function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {

  var newState = finishedWork.memoizedState;

  if (newState === null) {
    var current = finishedWork.alternate;

    if (current !== null) {
      var prevState = current.memoizedState;

      if (prevState !== null) {
        var suspenseInstance = prevState.dehydrated;

        if (suspenseInstance !== null) {
          commitHydratedSuspenseInstance(suspenseInstance);
        }
      }
    }
  }
}

function attachSuspenseRetryListeners(finishedWork) {
  // If this boundary just timed out, then it will have a set of wakeables.
  // For each wakeable, attach a listener so that when it resolves, React
  // attempts to re-render the boundary in the primary (pre-timeout) state.
  var wakeables = finishedWork.updateQueue;

  if (wakeables !== null) {
    finishedWork.updateQueue = null;
    var retryCache = finishedWork.stateNode;

    if (retryCache === null) {
      retryCache = finishedWork.stateNode = new PossiblyWeakSet();
    }

    wakeables.forEach(function (wakeable) {
      // Memoize using the boundary fiber to prevent redundant listeners.
      var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);

      if (!retryCache.has(wakeable)) {
        {
          if (wakeable.__reactDoNotTraceInteractions !== true) {
            retry = tracing$1.unstable_wrap(retry);
          }
        }

        retryCache.add(wakeable);
        wakeable.then(retry, retry);
      }
    });
  }
} // This function detects when a Suspense boundary goes from visible to hidden.

function commitResetTextContent(current) {

  resetTextContent(current.stateNode);
}

var COMPONENT_TYPE = 0;
var HAS_PSEUDO_CLASS_TYPE = 1;
var ROLE_TYPE = 2;
var TEST_NAME_TYPE = 3;
var TEXT_TYPE = 4;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor$1 = Symbol.for;
  COMPONENT_TYPE = symbolFor$1('selector.component');
  HAS_PSEUDO_CLASS_TYPE = symbolFor$1('selector.has_pseudo_class');
  ROLE_TYPE = symbolFor$1('selector.role');
  TEST_NAME_TYPE = symbolFor$1('selector.test_id');
  TEXT_TYPE = symbolFor$1('selector.text');
}
var commitHooks = [];
function onCommitRoot$1() {
  {
    commitHooks.forEach(function (commitHook) {
      return commitHook();
    });
  }
}

var ceil = Math.ceil;
var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher,
    ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
    IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
var NoContext =
/*             */
0;
var BatchedContext =
/*               */
1;
var EventContext =
/*                 */
2;
var DiscreteEventContext =
/*         */
4;
var LegacyUnbatchedContext =
/*       */
8;
var RenderContext =
/*                */
16;
var CommitContext =
/*                */
32;
var RetryAfterError =
/*       */
64;
var RootIncomplete = 0;
var RootFatalErrored = 1;
var RootErrored = 2;
var RootSuspended = 3;
var RootSuspendedWithDelay = 4;
var RootCompleted = 5; // Describes where we are in the React execution stack

var executionContext = NoContext; // The root we're working on

var workInProgressRoot = null; // The fiber we're working on

var workInProgress = null; // The lanes we're rendering

var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
// This is a superset of the lanes we started working on at the root. The only
// case where it's different from `workInProgressRootRenderLanes` is when we
// enter a subtree that is hidden and needs to be unhidden: Suspense and
// Offscreen component.
//
// Most things in the work loop should deal with workInProgressRootRenderLanes.
// Most things in begin/complete phases should deal with subtreeRenderLanes.

var subtreeRenderLanes = NoLanes;
var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.

var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown

var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
// slightly different than `renderLanes` because `renderLanes` can change as you
// enter and exit an Offscreen tree. This value is the combination of all render
// lanes for the entire render phase.

var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
// includes unprocessed updates, not work in bailed out children.

var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.

var workInProgressRootUpdatedLanes = NoLanes; // Lanes that were pinged (in an interleaved event) during this render.

var workInProgressRootPingedLanes = NoLanes;
var mostRecentlyUpdatedRoot = null; // The most recent time we committed a fallback. This lets us ensure a train
// model where we don't commit new loading states in too quick succession.

var globalMostRecentFallbackTime = 0;
var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
// more and prefer CPU suspense heuristics instead.

var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
// suspense heuristics and opt out of rendering more content.

var RENDER_TIMEOUT_MS = 500;

function resetRenderTimer() {
  workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
}

function getRenderTargetTime() {
  return workInProgressRootRenderTargetTime;
}
var nextEffect = null;
var hasUncaughtError = false;
var firstUncaughtError = null;
var legacyErrorBoundariesThatAlreadyFailed = null;
var rootDoesHavePassiveEffects = false;
var rootWithPendingPassiveEffects = null;
var pendingPassiveEffectsRenderPriority = NoPriority$1;
var pendingPassiveEffectsLanes = NoLanes;
var pendingPassiveHookEffectsMount = [];
var pendingPassiveHookEffectsUnmount = [];
var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates

var NESTED_UPDATE_LIMIT = 50;
var nestedUpdateCount = 0;
var rootWithNestedUpdates = null;
var NESTED_PASSIVE_UPDATE_LIMIT = 50;
var nestedPassiveUpdateCount = 0; // Marks the need to reschedule pending interactions at these lanes
// during the commit phase. This enables them to be traced across components
// that spawn new work during render. E.g. hidden boundaries, suspended SSR
// hydration or SuspenseList.
// TODO: Can use a bitmask instead of an array

var spawnedWorkDuringRender = null; // If two updates are scheduled within the same event, we should treat their
// event times as simultaneous, even if the actual clock time has advanced
// between the first and second call.

var currentEventTime = NoTimestamp;
var currentEventWipLanes = NoLanes;
var currentEventPendingLanes = NoLanes; // Dev only flag that tracks if passive effects are currently being flushed.
// We warn about state updates for unmounted components differently in this case.

var isFlushingPassiveEffects = false;
var focusedInstanceHandle = null;
function getWorkInProgressRoot() {
  return workInProgressRoot;
}
function requestEventTime() {
  if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
    // We're inside React, so it's fine to read the actual time.
    return now();
  } // We're not inside React, so we may be in the middle of a browser event.


  if (currentEventTime !== NoTimestamp) {
    // Use the same start time for all updates until we enter React again.
    return currentEventTime;
  } // This is the first update since React yielded. Compute a new start time.


  currentEventTime = now();
  return currentEventTime;
}
function requestUpdateLane(fiber) {
  // Special cases
  var mode = fiber.mode;

  if ((mode & BlockingMode) === NoMode) {
    return SyncLane;
  } else if ((mode & ConcurrentMode) === NoMode) {
    return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
  } // The algorithm for assigning an update to a lane should be stable for all
  // updates at the same priority within the same event. To do this, the inputs
  // to the algorithm must be the same. For example, we use the `renderLanes`
  // to avoid choosing a lane that is already in the middle of rendering.
  //
  // However, the "included" lanes could be mutated in between updates in the
  // same event, like if you perform an update inside `flushSync`. Or any other
  // code path that might call `prepareFreshStack`.
  //
  // The trick we use is to cache the first of each of these inputs within an
  // event. Then reset the cached values once we can be sure the event is over.
  // Our heuristic for that is whenever we enter a concurrent work loop.
  //
  // We'll do the same for `currentEventPendingLanes` below.


  if (currentEventWipLanes === NoLanes) {
    currentEventWipLanes = workInProgressRootIncludedLanes;
  }

  var isTransition = requestCurrentTransition() !== NoTransition;

  if (isTransition) {
    if (currentEventPendingLanes !== NoLanes) {
      currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
    }

    return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
  } // TODO: Remove this dependency on the Scheduler priority.
  // To do that, we're replacing it with an update lane priority.


  var schedulerPriority = getCurrentPriorityLevel(); // The old behavior was using the priority level of the Scheduler.
  // This couples React to the Scheduler internals, so we're replacing it
  // with the currentUpdateLanePriority above. As an example of how this
  // could be problematic, if we're not inside `Scheduler.runWithPriority`,
  // then we'll get the priority of the current running Scheduler task,
  // which is probably not what we want.

  var lane;

  if ( // TODO: Temporary. We're removing the concept of discrete updates.
  (executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) {
    lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
  } else {
    var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);

    lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
  }

  return lane;
}

function requestRetryLane(fiber) {
  // This is a fork of `requestUpdateLane` designed specifically for Suspense
  // "retries" — a special update that attempts to flip a Suspense boundary
  // from its placeholder state to its primary/resolved state.
  // Special cases
  var mode = fiber.mode;

  if ((mode & BlockingMode) === NoMode) {
    return SyncLane;
  } else if ((mode & ConcurrentMode) === NoMode) {
    return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
  } // See `requestUpdateLane` for explanation of `currentEventWipLanes`


  if (currentEventWipLanes === NoLanes) {
    currentEventWipLanes = workInProgressRootIncludedLanes;
  }

  return findRetryLane(currentEventWipLanes);
}

function scheduleUpdateOnFiber(fiber, lane, eventTime) {
  checkForNestedUpdates();
  warnAboutRenderPhaseUpdatesInDEV(fiber);
  var root = markUpdateLaneFromFiberToRoot(fiber, lane);

  if (root === null) {
    warnAboutUpdateOnUnmountedFiberInDEV(fiber);
    return null;
  } // Mark that the root has a pending update.


  markRootUpdated(root, lane, eventTime);

  if (root === workInProgressRoot) {
    // Received an update to a tree that's in the middle of rendering. Mark
    // that there was an interleaved update work on this root. Unless the
    // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
    // phase update. In that case, we don't treat render phase updates as if
    // they were interleaved, for backwards compat reasons.
    {
      workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
    }

    if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
      // The root already suspended with a delay, which means this render
      // definitely won't finish. Since we have a new update, let's mark it as
      // suspended now, right before marking the incoming update. This has the
      // effect of interrupting the current render and switching to the update.
      // TODO: Make sure this doesn't override pings that happen while we've
      // already started rendering.
      markRootSuspended$1(root, workInProgressRootRenderLanes);
    }
  } // TODO: requestUpdateLanePriority also reads the priority. Pass the
  // priority as an argument to that function and this one.


  var priorityLevel = getCurrentPriorityLevel();

  if (lane === SyncLane) {
    if ( // Check if we're inside unbatchedUpdates
    (executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
    (executionContext & (RenderContext | CommitContext)) === NoContext) {
      // Register pending interactions on the root to avoid losing traced interaction data.
      schedulePendingInteractions(root, lane); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
      // root inside of batchedUpdates should be synchronous, but layout updates
      // should be deferred until the end of the batch.

      performSyncWorkOnRoot(root);
    } else {
      ensureRootIsScheduled(root, eventTime);
      schedulePendingInteractions(root, lane);

      if (executionContext === NoContext) {
        // Flush the synchronous work now, unless we're already working or inside
        // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
        // scheduleCallbackForFiber to preserve the ability to schedule a callback
        // without immediately flushing it. We only do this for user-initiated
        // updates, to preserve historical behavior of legacy mode.
        resetRenderTimer();
        flushSyncCallbackQueue();
      }
    }
  } else {
    // Schedule a discrete update but only if it's not Sync.
    if ((executionContext & DiscreteEventContext) !== NoContext && ( // Only updates at user-blocking priority or greater are considered
    // discrete, even inside a discrete event.
    priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
      // This is the result of a discrete event. Track the lowest priority
      // discrete update per root so we can flush them early, if needed.
      if (rootsWithPendingDiscreteUpdates === null) {
        rootsWithPendingDiscreteUpdates = new Set([root]);
      } else {
        rootsWithPendingDiscreteUpdates.add(root);
      }
    } // Schedule other updates after in case the callback is sync.


    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, lane);
  } // We use this when assigning a lane for a transition inside
  // `requestUpdateLane`. We assume it's the same as the root being updated,
  // since in the common case of a single root app it probably is. If it's not
  // the same root, then it's not a huge deal, we just might batch more stuff
  // together more than necessary.


  mostRecentlyUpdatedRoot = root;
} // This is split into a separate function so we can mark a fiber with pending
// work without treating it as a typical update that originates from an event;
// e.g. retrying a Suspense boundary isn't an update, but it does schedule work
// on a fiber.

function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
  // Update the source fiber's lanes
  sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
  var alternate = sourceFiber.alternate;

  if (alternate !== null) {
    alternate.lanes = mergeLanes(alternate.lanes, lane);
  }

  {
    if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
      warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
    }
  } // Walk the parent path to the root and update the child expiration time.


  var node = sourceFiber;
  var parent = sourceFiber.return;

  while (parent !== null) {
    parent.childLanes = mergeLanes(parent.childLanes, lane);
    alternate = parent.alternate;

    if (alternate !== null) {
      alternate.childLanes = mergeLanes(alternate.childLanes, lane);
    } else {
      {
        if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
          warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        }
      }
    }

    node = parent;
    parent = parent.return;
  }

  if (node.tag === HostRoot) {
    var root = node.stateNode;
    return root;
  } else {
    return null;
  }
} // Use this function to schedule a task for a root. There's only one task per
// root; if a task was already scheduled, we'll check to make sure the priority
// of the existing task is the same as the priority of the next level that the
// root has work on. This function is called on every update, and right before
// exiting a task.


function ensureRootIsScheduled(root, currentTime) {
  var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
  // expired so we know to work on those next.

  markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.

  var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes); // This returns the priority level computed during the `getNextLanes` call.

  var newCallbackPriority = returnNextLanesPriority();

  if (nextLanes === NoLanes) {
    // Special case: There's nothing to work on.
    if (existingCallbackNode !== null) {
      cancelCallback(existingCallbackNode);
      root.callbackNode = null;
      root.callbackPriority = NoLanePriority;
    }

    return;
  } // Check if there's an existing task. We may be able to reuse it.


  if (existingCallbackNode !== null) {
    var existingCallbackPriority = root.callbackPriority;

    if (existingCallbackPriority === newCallbackPriority) {
      // The priority hasn't changed. We can reuse the existing task. Exit.
      return;
    } // The priority changed. Cancel the existing callback. We'll schedule a new
    // one below.


    cancelCallback(existingCallbackNode);
  } // Schedule a new callback.


  var newCallbackNode;

  if (newCallbackPriority === SyncLanePriority) {
    // Special case: Sync React callbacks are scheduled on a special
    // internal queue
    newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
  } else if (newCallbackPriority === SyncBatchedLanePriority) {
    newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
  } else {
    var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
    newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
  }

  root.callbackPriority = newCallbackPriority;
  root.callbackNode = newCallbackNode;
} // This is the entry point for every concurrent task, i.e. anything that
// goes through Scheduler.


function performConcurrentWorkOnRoot(root) {
  // Since we know we're in a React event, we can clear the current
  // event time. The next update will compute a new event time.
  currentEventTime = NoTimestamp;
  currentEventWipLanes = NoLanes;
  currentEventPendingLanes = NoLanes;

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  } // Flush any pending passive effects before deciding which lanes to work on,
  // in case they schedule additional work.


  var originalCallbackNode = root.callbackNode;
  var didFlushPassiveEffects = flushPassiveEffects();

  if (didFlushPassiveEffects) {
    // Something in the passive effect phase may have canceled the current task.
    // Check if the task node for this root was changed.
    if (root.callbackNode !== originalCallbackNode) {
      // The current task was canceled. Exit. We don't need to call
      // `ensureRootIsScheduled` because the check above implies either that
      // there's a new task, or that there's no remaining work on this root.
      return null;
    }
  } // Determine the next expiration time to work on, using the fields stored
  // on the root.


  var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);

  if (lanes === NoLanes) {
    // Defensive coding. This is never expected to happen.
    return null;
  }

  var exitStatus = renderRootConcurrent(root, lanes);

  if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
    // The render included lanes that were updated during the render phase.
    // For example, when unhiding a hidden tree, we include all the lanes
    // that were previously skipped when the tree was hidden. That set of
    // lanes is a superset of the lanes we started rendering with.
    //
    // So we'll throw out the current work and restart.
    prepareFreshStack(root, NoLanes);
  } else if (exitStatus !== RootIncomplete) {
    if (exitStatus === RootErrored) {
      executionContext |= RetryAfterError; // If an error occurred during hydration,
      // discard server response and fall back to client side render.

      if (root.hydrate) {
        root.hydrate = false;
        clearContainer(root.containerInfo);
      } // If something threw an error, try rendering one more time. We'll render
      // synchronously to block concurrent data mutations, and we'll includes
      // all pending updates are included. If it still fails after the second
      // attempt, we'll give up and commit the resulting tree.


      lanes = getLanesToRetrySynchronouslyOnError(root);

      if (lanes !== NoLanes) {
        exitStatus = renderRootSync(root, lanes);
      }
    }

    if (exitStatus === RootFatalErrored) {
      var fatalError = workInProgressRootFatalError;
      prepareFreshStack(root, NoLanes);
      markRootSuspended$1(root, lanes);
      ensureRootIsScheduled(root, now());
      throw fatalError;
    } // We now have a consistent tree. The next step is either to commit it,
    // or, if something suspended, wait to commit it after a timeout.


    var finishedWork = root.current.alternate;
    root.finishedWork = finishedWork;
    root.finishedLanes = lanes;
    finishConcurrentRender(root, exitStatus, lanes);
  }

  ensureRootIsScheduled(root, now());

  if (root.callbackNode === originalCallbackNode) {
    // The task node scheduled for this root is the same one that's
    // currently executed. Need to return a continuation.
    return performConcurrentWorkOnRoot.bind(null, root);
  }

  return null;
}

function finishConcurrentRender(root, exitStatus, lanes) {
  switch (exitStatus) {
    case RootIncomplete:
    case RootFatalErrored:
      {
        {
          {
            throw Error( "Root did not complete. This is a bug in React." );
          }
        }
      }
    // Flow knows about invariant, so it complains if I add a break
    // statement, but eslint doesn't know about invariant, so it complains
    // if I do. eslint-disable-next-line no-fallthrough

    case RootErrored:
      {
        // We should have already attempted to retry this tree. If we reached
        // this point, it errored again. Commit it.
        commitRoot(root);
        break;
      }

    case RootSuspended:
      {
        markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
        // should immediately commit it or wait a bit.

        if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
        !shouldForceFlushFallbacksInDEV()) {
          // This render only included retries, no updates. Throttle committing
          // retries so that we don't show too many loading states too quickly.
          var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.

          if (msUntilTimeout > 10) {
            var nextLanes = getNextLanes(root, NoLanes);

            if (nextLanes !== NoLanes) {
              // There's additional work on this root.
              break;
            }

            var suspendedLanes = root.suspendedLanes;

            if (!isSubsetOfLanes(suspendedLanes, lanes)) {
              // We should prefer to render the fallback of at the last
              // suspended level. Ping the last suspended level to try
              // rendering it again.
              // FIXME: What if the suspended lanes are Idle? Should not restart.
              var eventTime = requestEventTime();
              markRootPinged(root, suspendedLanes);
              break;
            } // The render is suspended, it hasn't timed out, and there's no
            // lower priority work to do. Instead of committing the fallback
            // immediately, wait for more data to arrive.


            root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
            break;
          }
        } // The work expired. Commit immediately.


        commitRoot(root);
        break;
      }

    case RootSuspendedWithDelay:
      {
        markRootSuspended$1(root, lanes);

        if (includesOnlyTransitions(lanes)) {
          // This is a transition, so we should exit without committing a
          // placeholder and without scheduling a timeout. Delay indefinitely
          // until we receive more data.
          break;
        }

        {
          // This is not a transition, but we did trigger an avoided state.
          // Schedule a placeholder to display after a short delay, using the Just
          // Noticeable Difference.
          // TODO: Is the JND optimization worth the added complexity? If this is
          // the only reason we track the event time, then probably not.
          // Consider removing.
          var mostRecentEventTime = getMostRecentEventTime(root, lanes);
          var eventTimeMs = mostRecentEventTime;
          var timeElapsedMs = now() - eventTimeMs;

          var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.


          if (_msUntilTimeout > 10) {
            // Instead of committing the fallback immediately, wait for more data
            // to arrive.
            root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
            break;
          }
        } // Commit the placeholder.


        commitRoot(root);
        break;
      }

    case RootCompleted:
      {
        // The work completed. Ready to commit.
        commitRoot(root);
        break;
      }

    default:
      {
        {
          {
            throw Error( "Unknown root exit status." );
          }
        }
      }
  }
}

function markRootSuspended$1(root, suspendedLanes) {
  // When suspending, we should always exclude lanes that were pinged or (more
  // rarely, since we try to avoid it) updated during the render phase.
  // TODO: Lol maybe there's a better way to factor this besides this
  // obnoxiously named function :)
  suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
  suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
  markRootSuspended(root, suspendedLanes);
} // This is the entry point for synchronous tasks that don't go
// through Scheduler


function performSyncWorkOnRoot(root) {
  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  }

  flushPassiveEffects();
  var lanes;
  var exitStatus;

  if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
    // There's a partial tree, and at least one of its lanes has expired. Finish
    // rendering it before rendering the rest of the expired work.
    lanes = workInProgressRootRenderLanes;
    exitStatus = renderRootSync(root, lanes);

    if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
      // The render included lanes that were updated during the render phase.
      // For example, when unhiding a hidden tree, we include all the lanes
      // that were previously skipped when the tree was hidden. That set of
      // lanes is a superset of the lanes we started rendering with.
      //
      // Note that this only happens when part of the tree is rendered
      // concurrently. If the whole tree is rendered synchronously, then there
      // are no interleaved events.
      lanes = getNextLanes(root, lanes);
      exitStatus = renderRootSync(root, lanes);
    }
  } else {
    lanes = getNextLanes(root, NoLanes);
    exitStatus = renderRootSync(root, lanes);
  }

  if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
    executionContext |= RetryAfterError; // If an error occurred during hydration,
    // discard server response and fall back to client side render.

    if (root.hydrate) {
      root.hydrate = false;
      clearContainer(root.containerInfo);
    } // If something threw an error, try rendering one more time. We'll render
    // synchronously to block concurrent data mutations, and we'll includes
    // all pending updates are included. If it still fails after the second
    // attempt, we'll give up and commit the resulting tree.


    lanes = getLanesToRetrySynchronouslyOnError(root);

    if (lanes !== NoLanes) {
      exitStatus = renderRootSync(root, lanes);
    }
  }

  if (exitStatus === RootFatalErrored) {
    var fatalError = workInProgressRootFatalError;
    prepareFreshStack(root, NoLanes);
    markRootSuspended$1(root, lanes);
    ensureRootIsScheduled(root, now());
    throw fatalError;
  } // We now have a consistent tree. Because this is a sync render, we
  // will commit it even if something suspended.


  var finishedWork = root.current.alternate;
  root.finishedWork = finishedWork;
  root.finishedLanes = lanes;
  commitRoot(root); // Before exiting, make sure there's a callback scheduled for the next
  // pending level.

  ensureRootIsScheduled(root, now());
  return null;
}
function flushDiscreteUpdates() {
  // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
  // However, `act` uses `batchedUpdates`, so there's no way to distinguish
  // those two cases. Need to fix this before exposing flushDiscreteUpdates
  // as a public API.
  if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
    {
      if ((executionContext & RenderContext) !== NoContext) {
        error('unstable_flushDiscreteUpdates: Cannot flush updates when React is ' + 'already rendering.');
      }
    } // We're already rendering, so we can't synchronously flush pending work.
    // This is probably a nested event dispatch triggered by a lifecycle/effect,
    // like `el.focus()`. Exit.


    return;
  }

  flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
  // they fire before the next serial event.

  flushPassiveEffects();
}

function flushPendingDiscreteUpdates() {
  if (rootsWithPendingDiscreteUpdates !== null) {
    // For each root with pending discrete updates, schedule a callback to
    // immediately flush them.
    var roots = rootsWithPendingDiscreteUpdates;
    rootsWithPendingDiscreteUpdates = null;
    roots.forEach(function (root) {
      markDiscreteUpdatesExpired(root);
      ensureRootIsScheduled(root, now());
    });
  } // Now flush the immediate queue.


  flushSyncCallbackQueue();
}

function batchedUpdates$1(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext |= BatchedContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function batchedEventUpdates$1(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext |= EventContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function discreteUpdates$1(fn, a, b, c, d) {
  var prevExecutionContext = executionContext;
  executionContext |= DiscreteEventContext;

  {
    try {
      return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
    } finally {
      executionContext = prevExecutionContext;

      if (executionContext === NoContext) {
        // Flush the immediate callbacks that were scheduled during this batch
        resetRenderTimer();
        flushSyncCallbackQueue();
      }
    }
  }
}
function unbatchedUpdates(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext &= ~BatchedContext;
  executionContext |= LegacyUnbatchedContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function flushSync(fn, a) {
  var prevExecutionContext = executionContext;

  if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
    {
      error('flushSync was called from inside a lifecycle method. React cannot ' + 'flush when React is already rendering. Consider moving this call to ' + 'a scheduler task or micro task.');
    }

    return fn(a);
  }

  executionContext |= BatchedContext;

  {
    try {
      if (fn) {
        return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
      } else {
        return undefined;
      }
    } finally {
      executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
      // Note that this will happen even if batchedUpdates is higher up
      // the stack.

      flushSyncCallbackQueue();
    }
  }
}
function pushRenderLanes(fiber, lanes) {
  push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
  subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
  workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
}
function popRenderLanes(fiber) {
  subtreeRenderLanes = subtreeRenderLanesCursor.current;
  pop(subtreeRenderLanesCursor, fiber);
}

function prepareFreshStack(root, lanes) {
  root.finishedWork = null;
  root.finishedLanes = NoLanes;
  var timeoutHandle = root.timeoutHandle;

  if (timeoutHandle !== noTimeout) {
    // The root previous suspended and scheduled a timeout to commit a fallback
    // state. Now that we have additional work, cancel the timeout.
    root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

    cancelTimeout(timeoutHandle);
  }

  if (workInProgress !== null) {
    var interruptedWork = workInProgress.return;

    while (interruptedWork !== null) {
      unwindInterruptedWork(interruptedWork);
      interruptedWork = interruptedWork.return;
    }
  }

  workInProgressRoot = root;
  workInProgress = createWorkInProgress(root.current, null);
  workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
  workInProgressRootExitStatus = RootIncomplete;
  workInProgressRootFatalError = null;
  workInProgressRootSkippedLanes = NoLanes;
  workInProgressRootUpdatedLanes = NoLanes;
  workInProgressRootPingedLanes = NoLanes;

  {
    spawnedWorkDuringRender = null;
  }

  {
    ReactStrictModeWarnings.discardPendingWarnings();
  }
}

function handleError(root, thrownValue) {
  do {
    var erroredWork = workInProgress;

    try {
      // Reset module-level state that was set during the render phase.
      resetContextDependencies();
      resetHooksAfterThrow();
      resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
      // separate issue. Write a regression test using string refs.

      ReactCurrentOwner$2.current = null;

      if (erroredWork === null || erroredWork.return === null) {
        // Expected to be working on a non-root fiber. This is a fatal error
        // because there's no ancestor that can handle it; the root is
        // supposed to capture all errors that weren't caught by an error
        // boundary.
        workInProgressRootExitStatus = RootFatalErrored;
        workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
        // sibling, or the parent if there are no siblings. But since the root
        // has no siblings nor a parent, we set it to null. Usually this is
        // handled by `completeUnitOfWork` or `unwindWork`, but since we're
        // intentionally not calling those, we need set it here.
        // TODO: Consider calling `unwindWork` to pop the contexts.

        workInProgress = null;
        return;
      }

      if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
        // Record the time spent rendering before an error was thrown. This
        // avoids inaccurate Profiler durations in the case of a
        // suspended render.
        stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
      }

      throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
      completeUnitOfWork(erroredWork);
    } catch (yetAnotherThrownValue) {
      // Something in the return path also threw.
      thrownValue = yetAnotherThrownValue;

      if (workInProgress === erroredWork && erroredWork !== null) {
        // If this boundary has already errored, then we had trouble processing
        // the error. Bubble it to the next boundary.
        erroredWork = erroredWork.return;
        workInProgress = erroredWork;
      } else {
        erroredWork = workInProgress;
      }

      continue;
    } // Return to the normal work loop.


    return;
  } while (true);
}

function pushDispatcher() {
  var prevDispatcher = ReactCurrentDispatcher$2.current;
  ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;

  if (prevDispatcher === null) {
    // The React isomorphic package does not include a default dispatcher.
    // Instead the first renderer will lazily attach one, in order to give
    // nicer error messages.
    return ContextOnlyDispatcher;
  } else {
    return prevDispatcher;
  }
}

function popDispatcher(prevDispatcher) {
  ReactCurrentDispatcher$2.current = prevDispatcher;
}

function pushInteractions(root) {
  {
    var prevInteractions = tracing$1.__interactionsRef.current;
    tracing$1.__interactionsRef.current = root.memoizedInteractions;
    return prevInteractions;
  }
}

function popInteractions(prevInteractions) {
  {
    tracing$1.__interactionsRef.current = prevInteractions;
  }
}

function markCommitTimeOfFallback() {
  globalMostRecentFallbackTime = now();
}
function markSkippedUpdateLanes(lane) {
  workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
}
function renderDidSuspend() {
  if (workInProgressRootExitStatus === RootIncomplete) {
    workInProgressRootExitStatus = RootSuspended;
  }
}
function renderDidSuspendDelayIfPossible() {
  if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
    workInProgressRootExitStatus = RootSuspendedWithDelay;
  } // Check if there are updates that we skipped tree that might have unblocked
  // this render.


  if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) {
    // Mark the current render as suspended so that we switch to working on
    // the updates that were skipped. Usually we only suspend at the end of
    // the render phase.
    // TODO: We should probably always mark the root as suspended immediately
    // (inside this function), since by suspending at the end of the render
    // phase introduces a potential mistake where we suspend lanes that were
    // pinged or updated while we were rendering.
    markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
  }
}
function renderDidError() {
  if (workInProgressRootExitStatus !== RootCompleted) {
    workInProgressRootExitStatus = RootErrored;
  }
} // Called during render to determine if anything has suspended.
// Returns false if we're not sure.

function renderHasNotSuspendedYet() {
  // If something errored or completed, we can't really be sure,
  // so those are false.
  return workInProgressRootExitStatus === RootIncomplete;
}

function renderRootSync(root, lanes) {
  var prevExecutionContext = executionContext;
  executionContext |= RenderContext;
  var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
  // and prepare a fresh one. Otherwise we'll continue where we left off.

  if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
    prepareFreshStack(root, lanes);
    startWorkOnPendingInteractions(root, lanes);
  }

  var prevInteractions = pushInteractions(root);

  do {
    try {
      workLoopSync();
      break;
    } catch (thrownValue) {
      handleError(root, thrownValue);
    }
  } while (true);

  resetContextDependencies();

  {
    popInteractions(prevInteractions);
  }

  executionContext = prevExecutionContext;
  popDispatcher(prevDispatcher);

  if (workInProgress !== null) {
    // This is a sync render, so we should have finished the whole tree.
    {
      {
        throw Error( "Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }


  workInProgressRoot = null;
  workInProgressRootRenderLanes = NoLanes;
  return workInProgressRootExitStatus;
} // The work loop is an extremely hot path. Tell Closure not to inline it.

/** @noinline */


function workLoopSync() {
  // Already timed out, so perform work without checking if we need to yield.
  while (workInProgress !== null) {
    performUnitOfWork(workInProgress);
  }
}

function renderRootConcurrent(root, lanes) {
  var prevExecutionContext = executionContext;
  executionContext |= RenderContext;
  var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
  // and prepare a fresh one. Otherwise we'll continue where we left off.

  if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
    resetRenderTimer();
    prepareFreshStack(root, lanes);
    startWorkOnPendingInteractions(root, lanes);
  }

  var prevInteractions = pushInteractions(root);

  do {
    try {
      workLoopConcurrent();
      break;
    } catch (thrownValue) {
      handleError(root, thrownValue);
    }
  } while (true);

  resetContextDependencies();

  {
    popInteractions(prevInteractions);
  }

  popDispatcher(prevDispatcher);
  executionContext = prevExecutionContext;


  if (workInProgress !== null) {

    return RootIncomplete;
  } else {


    workInProgressRoot = null;
    workInProgressRootRenderLanes = NoLanes; // Return the final exit status.

    return workInProgressRootExitStatus;
  }
}
/** @noinline */


function workLoopConcurrent() {
  // Perform work until Scheduler asks us to yield
  while (workInProgress !== null && !shouldYield()) {
    performUnitOfWork(workInProgress);
  }
}

function performUnitOfWork(unitOfWork) {
  // The current, flushed, state of this fiber is the alternate. Ideally
  // nothing should rely on this, but relying on it here means that we don't
  // need an additional field on the work in progress.
  var current = unitOfWork.alternate;
  setCurrentFiber(unitOfWork);
  var next;

  if ( (unitOfWork.mode & ProfileMode) !== NoMode) {
    startProfilerTimer(unitOfWork);
    next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
    stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
  } else {
    next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
  }

  resetCurrentFiber();
  unitOfWork.memoizedProps = unitOfWork.pendingProps;

  if (next === null) {
    // If this doesn't spawn new work, complete the current work.
    completeUnitOfWork(unitOfWork);
  } else {
    workInProgress = next;
  }

  ReactCurrentOwner$2.current = null;
}

function completeUnitOfWork(unitOfWork) {
  // Attempt to complete the current unit of work, then move to the next
  // sibling. If there are no more siblings, return to the parent fiber.
  var completedWork = unitOfWork;

  do {
    // The current, flushed, state of this fiber is the alternate. Ideally
    // nothing should rely on this, but relying on it here means that we don't
    // need an additional field on the work in progress.
    var current = completedWork.alternate;
    var returnFiber = completedWork.return; // Check if the work completed or if something threw.

    if ((completedWork.flags & Incomplete) === NoFlags) {
      setCurrentFiber(completedWork);
      var next = void 0;

      if ( (completedWork.mode & ProfileMode) === NoMode) {
        next = completeWork(current, completedWork, subtreeRenderLanes);
      } else {
        startProfilerTimer(completedWork);
        next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.

        stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
      }

      resetCurrentFiber();

      if (next !== null) {
        // Completing this fiber spawned new work. Work on that next.
        workInProgress = next;
        return;
      }

      resetChildLanes(completedWork);

      if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
      (returnFiber.flags & Incomplete) === NoFlags) {
        // Append all the effects of the subtree and this fiber onto the effect
        // list of the parent. The completion order of the children affects the
        // side-effect order.
        if (returnFiber.firstEffect === null) {
          returnFiber.firstEffect = completedWork.firstEffect;
        }

        if (completedWork.lastEffect !== null) {
          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
          }

          returnFiber.lastEffect = completedWork.lastEffect;
        } // If this fiber had side-effects, we append it AFTER the children's
        // side-effects. We can perform certain side-effects earlier if needed,
        // by doing multiple passes over the effect list. We don't want to
        // schedule our own side-effect on our own list because if end up
        // reusing children we'll schedule this effect onto itself since we're
        // at the end.


        var flags = completedWork.flags; // Skip both NoWork and PerformedWork tags when creating the effect
        // list. PerformedWork effect is read by React DevTools but shouldn't be
        // committed.

        if (flags > PerformedWork) {
          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = completedWork;
          } else {
            returnFiber.firstEffect = completedWork;
          }

          returnFiber.lastEffect = completedWork;
        }
      }
    } else {
      // This fiber did not complete because something threw. Pop values off
      // the stack without entering the complete phase. If this is a boundary,
      // capture values if possible.
      var _next = unwindWork(completedWork); // Because this fiber did not complete, don't reset its expiration time.


      if (_next !== null) {
        // If completing this work spawned new work, do that next. We'll come
        // back here again.
        // Since we're restarting, remove anything that is not a host effect
        // from the effect tag.
        _next.flags &= HostEffectMask;
        workInProgress = _next;
        return;
      }

      if ( (completedWork.mode & ProfileMode) !== NoMode) {
        // Record the render duration for the fiber that errored.
        stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.

        var actualDuration = completedWork.actualDuration;
        var child = completedWork.child;

        while (child !== null) {
          actualDuration += child.actualDuration;
          child = child.sibling;
        }

        completedWork.actualDuration = actualDuration;
      }

      if (returnFiber !== null) {
        // Mark the parent fiber as incomplete and clear its effect list.
        returnFiber.firstEffect = returnFiber.lastEffect = null;
        returnFiber.flags |= Incomplete;
      }
    }

    var siblingFiber = completedWork.sibling;

    if (siblingFiber !== null) {
      // If there is more work to do in this returnFiber, do that next.
      workInProgress = siblingFiber;
      return;
    } // Otherwise, return to the parent


    completedWork = returnFiber; // Update the next thing we're working on in case something throws.

    workInProgress = completedWork;
  } while (completedWork !== null); // We've reached the root.


  if (workInProgressRootExitStatus === RootIncomplete) {
    workInProgressRootExitStatus = RootCompleted;
  }
}

function resetChildLanes(completedWork) {
  if ( // TODO: Move this check out of the hot path by moving `resetChildLanes`
  // to switch statement in `completeWork`.
  (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) {
    // The children of this component are hidden. Don't bubble their
    // expiration times.
    return;
  }

  var newChildLanes = NoLanes; // Bubble up the earliest expiration time.

  if ( (completedWork.mode & ProfileMode) !== NoMode) {
    // In profiling mode, resetChildExpirationTime is also used to reset
    // profiler durations.
    var actualDuration = completedWork.actualDuration;
    var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
    // When work is done, it should bubble to the parent's actualDuration. If
    // the fiber has not been cloned though, (meaning no work was done), then
    // this value will reflect the amount of time spent working on a previous
    // render. In that case it should not bubble. We determine whether it was
    // cloned by comparing the child pointer.

    var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
    var child = completedWork.child;

    while (child !== null) {
      newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));

      if (shouldBubbleActualDurations) {
        actualDuration += child.actualDuration;
      }

      treeBaseDuration += child.treeBaseDuration;
      child = child.sibling;
    }

    var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;

    if (isTimedOutSuspense) {
      // Don't count time spent in a timed out Suspense subtree as part of the base duration.
      var primaryChildFragment = completedWork.child;

      if (primaryChildFragment !== null) {
        treeBaseDuration -= primaryChildFragment.treeBaseDuration;
      }
    }

    completedWork.actualDuration = actualDuration;
    completedWork.treeBaseDuration = treeBaseDuration;
  } else {
    var _child = completedWork.child;

    while (_child !== null) {
      newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
      _child = _child.sibling;
    }
  }

  completedWork.childLanes = newChildLanes;
}

function commitRoot(root) {
  var renderPriorityLevel = getCurrentPriorityLevel();
  runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
  return null;
}

function commitRootImpl(root, renderPriorityLevel) {
  do {
    // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
    // means `flushPassiveEffects` will sometimes result in additional
    // passive effects. So we need to keep flushing in a loop until there are
    // no more pending effects.
    // TODO: Might be better if `flushPassiveEffects` did not automatically
    // flush synchronous work at the end, to avoid factoring hazards like this.
    flushPassiveEffects();
  } while (rootWithPendingPassiveEffects !== null);

  flushRenderPhaseStrictModeWarningsInDEV();

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  }

  var finishedWork = root.finishedWork;
  var lanes = root.finishedLanes;

  if (finishedWork === null) {

    return null;
  }

  root.finishedWork = null;
  root.finishedLanes = NoLanes;

  if (!(finishedWork !== root.current)) {
    {
      throw Error( "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue." );
    }
  } // commitRoot never returns a continuation; it always finishes synchronously.
  // So we can clear these now to allow a new callback to be scheduled.


  root.callbackNode = null; // Update the first and last pending times on this root. The new first
  // pending time is whatever is left on the root fiber.

  var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
  markRootFinished(root, remainingLanes); // Clear already finished discrete updates in case that a later call of
  // `flushDiscreteUpdates` starts a useless render pass which may cancels
  // a scheduled timeout.

  if (rootsWithPendingDiscreteUpdates !== null) {
    if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) {
      rootsWithPendingDiscreteUpdates.delete(root);
    }
  }

  if (root === workInProgressRoot) {
    // We can reset these now that they are finished.
    workInProgressRoot = null;
    workInProgress = null;
    workInProgressRootRenderLanes = NoLanes;
  } // Get the list of effects.


  var firstEffect;

  if (finishedWork.flags > PerformedWork) {
    // A fiber's effect list consists only of its children, not itself. So if
    // the root has an effect, we need to add it to the end of the list. The
    // resulting list is the set that would belong to the root's parent, if it
    // had one; that is, all the effects in the tree including the root.
    if (finishedWork.lastEffect !== null) {
      finishedWork.lastEffect.nextEffect = finishedWork;
      firstEffect = finishedWork.firstEffect;
    } else {
      firstEffect = finishedWork;
    }
  } else {
    // There is no effect on the root.
    firstEffect = finishedWork.firstEffect;
  }

  if (firstEffect !== null) {

    var prevExecutionContext = executionContext;
    executionContext |= CommitContext;
    var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles

    ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
    // of the effect list for each phase: all mutation effects come before all
    // layout effects, and so on.
    // The first phase a "before mutation" phase. We use this phase to read the
    // state of the host tree right before we mutate it. This is where
    // getSnapshotBeforeUpdate is called.

    focusedInstanceHandle = prepareForCommit();
    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitBeforeMutationEffects, null);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var error = clearCaughtError();
          captureCommitPhaseError(nextEffect, error);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null); // We no longer need to track the active instance fiber


    focusedInstanceHandle = null;

    {
      // Mark the current commit time to be shared by all Profilers in this
      // batch. This enables them to be grouped later.
      recordCommitTime();
    } // The next phase is the mutation phase, where we mutate the host tree.


    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var _error = clearCaughtError();

          captureCommitPhaseError(nextEffect, _error);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null);

    resetAfterCommit(); // The work-in-progress tree is now the current tree. This must come after
    // the mutation phase, so that the previous tree is still current during
    // componentWillUnmount, but before the layout phase, so that the finished
    // work is current during componentDidMount/Update.

    root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
    // the host tree after it's been mutated. The idiomatic use case for this is
    // layout, but class component lifecycles also fire here for legacy reasons.

    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var _error2 = clearCaughtError();

          captureCommitPhaseError(nextEffect, _error2);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null);

    nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
    // opportunity to paint.

    requestPaint();

    {
      popInteractions(prevInteractions);
    }

    executionContext = prevExecutionContext;
  } else {
    // No effects.
    root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
    // no effects.
    // TODO: Maybe there's a better way to report this.

    {
      recordCommitTime();
    }
  }

  var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;

  if (rootDoesHavePassiveEffects) {
    // This commit has passive effects. Stash a reference to them. But don't
    // schedule a callback until after flushing layout work.
    rootDoesHavePassiveEffects = false;
    rootWithPendingPassiveEffects = root;
    pendingPassiveEffectsLanes = lanes;
    pendingPassiveEffectsRenderPriority = renderPriorityLevel;
  } else {
    // We are done with the effect chain at this point so let's clear the
    // nextEffect pointers to assist with GC. If we have passive effects, we'll
    // clear this in flushPassiveEffects.
    nextEffect = firstEffect;

    while (nextEffect !== null) {
      var nextNextEffect = nextEffect.nextEffect;
      nextEffect.nextEffect = null;

      if (nextEffect.flags & Deletion) {
        detachFiberAfterEffects(nextEffect);
      }

      nextEffect = nextNextEffect;
    }
  } // Read this again, since an effect might have updated it


  remainingLanes = root.pendingLanes; // Check if there's remaining work on this root

  if (remainingLanes !== NoLanes) {
    {
      if (spawnedWorkDuringRender !== null) {
        var expirationTimes = spawnedWorkDuringRender;
        spawnedWorkDuringRender = null;

        for (var i = 0; i < expirationTimes.length; i++) {
          scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
        }
      }

      schedulePendingInteractions(root, remainingLanes);
    }
  } else {
    // If there's no remaining work, we can clear the set of already failed
    // error boundaries.
    legacyErrorBoundariesThatAlreadyFailed = null;
  }

  {
    if (!rootDidHavePassiveEffects) {
      // If there are no passive effects, then we can complete the pending interactions.
      // Otherwise, we'll wait until after the passive effects are flushed.
      // Wait to do this until after remaining work has been scheduled,
      // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
      finishPendingInteractions(root, lanes);
    }
  }

  if (remainingLanes === SyncLane) {
    // Count the number of times the root synchronously re-renders without
    // finishing. If there are too many, it indicates an infinite update loop.
    if (root === rootWithNestedUpdates) {
      nestedUpdateCount++;
    } else {
      nestedUpdateCount = 0;
      rootWithNestedUpdates = root;
    }
  } else {
    nestedUpdateCount = 0;
  }

  onCommitRoot(finishedWork.stateNode, renderPriorityLevel);

  {
    onCommitRoot$1();
  } // Always call this before exiting `commitRoot`, to ensure that any
  // additional work on this root is scheduled.


  ensureRootIsScheduled(root, now());

  if (hasUncaughtError) {
    hasUncaughtError = false;
    var _error3 = firstUncaughtError;
    firstUncaughtError = null;
    throw _error3;
  }

  if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
    // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
    // synchronously, but layout updates should be deferred until the end
    // of the batch.


    return null;
  } // If layout work was scheduled, flush it now.


  flushSyncCallbackQueue();

  return null;
}

function commitBeforeMutationEffects() {
  while (nextEffect !== null) {
    var current = nextEffect.alternate;

    var flags = nextEffect.flags;

    if ((flags & Snapshot) !== NoFlags) {
      setCurrentFiber(nextEffect);
      commitBeforeMutationLifeCycles(current, nextEffect);
      resetCurrentFiber();
    }

    if ((flags & Passive) !== NoFlags) {
      // If there are passive effects, schedule a callback to flush at
      // the earliest opportunity.
      if (!rootDoesHavePassiveEffects) {
        rootDoesHavePassiveEffects = true;
        scheduleCallback(NormalPriority$1, function () {
          flushPassiveEffects();
          return null;
        });
      }
    }

    nextEffect = nextEffect.nextEffect;
  }
}

function commitMutationEffects(root, renderPriorityLevel) {
  // TODO: Should probably move the bulk of this function to commitWork.
  while (nextEffect !== null) {
    setCurrentFiber(nextEffect);
    var flags = nextEffect.flags;

    if (flags & ContentReset) {
      commitResetTextContent(nextEffect);
    }

    if (flags & Ref) {
      var current = nextEffect.alternate;

      if (current !== null) {
        commitDetachRef(current);
      }
    } // The following switch statement is only concerned about placement,
    // updates, and deletions. To avoid needing to add a case for every possible
    // bitmap value, we remove the secondary effects from the effect tag and
    // switch on that value.


    var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);

    switch (primaryFlags) {
      case Placement:
        {
          commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
          // inserted, before any life-cycles like componentDidMount gets called.
          // TODO: findDOMNode doesn't rely on this any more but isMounted does
          // and isMounted is deprecated anyway so we should be able to kill this.

          nextEffect.flags &= ~Placement;
          break;
        }

      case PlacementAndUpdate:
        {
          // Placement
          commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
          // inserted, before any life-cycles like componentDidMount gets called.

          nextEffect.flags &= ~Placement; // Update

          var _current = nextEffect.alternate;
          commitWork(_current, nextEffect);
          break;
        }

      case Hydrating:
        {
          nextEffect.flags &= ~Hydrating;
          break;
        }

      case HydratingAndUpdate:
        {
          nextEffect.flags &= ~Hydrating; // Update

          var _current2 = nextEffect.alternate;
          commitWork(_current2, nextEffect);
          break;
        }

      case Update:
        {
          var _current3 = nextEffect.alternate;
          commitWork(_current3, nextEffect);
          break;
        }

      case Deletion:
        {
          commitDeletion(root, nextEffect);
          break;
        }
    }

    resetCurrentFiber();
    nextEffect = nextEffect.nextEffect;
  }
}

function commitLayoutEffects(root, committedLanes) {


  while (nextEffect !== null) {
    setCurrentFiber(nextEffect);
    var flags = nextEffect.flags;

    if (flags & (Update | Callback)) {
      var current = nextEffect.alternate;
      commitLifeCycles(root, current, nextEffect);
    }

    {
      if (flags & Ref) {
        commitAttachRef(nextEffect);
      }
    }

    resetCurrentFiber();
    nextEffect = nextEffect.nextEffect;
  }
}

function flushPassiveEffects() {
  // Returns whether passive effects were flushed.
  if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
    var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
    pendingPassiveEffectsRenderPriority = NoPriority$1;

    {
      return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
    }
  }

  return false;
}
function enqueuePendingPassiveHookEffectMount(fiber, effect) {
  pendingPassiveHookEffectsMount.push(effect, fiber);

  if (!rootDoesHavePassiveEffects) {
    rootDoesHavePassiveEffects = true;
    scheduleCallback(NormalPriority$1, function () {
      flushPassiveEffects();
      return null;
    });
  }
}
function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
  pendingPassiveHookEffectsUnmount.push(effect, fiber);

  {
    fiber.flags |= PassiveUnmountPendingDev;
    var alternate = fiber.alternate;

    if (alternate !== null) {
      alternate.flags |= PassiveUnmountPendingDev;
    }
  }

  if (!rootDoesHavePassiveEffects) {
    rootDoesHavePassiveEffects = true;
    scheduleCallback(NormalPriority$1, function () {
      flushPassiveEffects();
      return null;
    });
  }
}

function invokePassiveEffectCreate(effect) {
  var create = effect.create;
  effect.destroy = create();
}

function flushPassiveEffectsImpl() {
  if (rootWithPendingPassiveEffects === null) {
    return false;
  }

  var root = rootWithPendingPassiveEffects;
  var lanes = pendingPassiveEffectsLanes;
  rootWithPendingPassiveEffects = null;
  pendingPassiveEffectsLanes = NoLanes;

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Cannot flush passive effects while already rendering." );
    }
  }

  {
    isFlushingPassiveEffects = true;
  }

  var prevExecutionContext = executionContext;
  executionContext |= CommitContext;
  var prevInteractions = pushInteractions(root); // It's important that ALL pending passive effect destroy functions are called
  // before ANY passive effect create functions are called.
  // Otherwise effects in sibling components might interfere with each other.
  // e.g. a destroy function in one component may unintentionally override a ref
  // value set by a create function in another component.
  // Layout effects have the same constraint.
  // First pass: Destroy stale passive effects.

  var unmountEffects = pendingPassiveHookEffectsUnmount;
  pendingPassiveHookEffectsUnmount = [];

  for (var i = 0; i < unmountEffects.length; i += 2) {
    var _effect = unmountEffects[i];
    var fiber = unmountEffects[i + 1];
    var destroy = _effect.destroy;
    _effect.destroy = undefined;

    {
      fiber.flags &= ~PassiveUnmountPendingDev;
      var alternate = fiber.alternate;

      if (alternate !== null) {
        alternate.flags &= ~PassiveUnmountPendingDev;
      }
    }

    if (typeof destroy === 'function') {
      {
        setCurrentFiber(fiber);

        {
          invokeGuardedCallback(null, destroy, null);
        }

        if (hasCaughtError()) {
          if (!(fiber !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var error = clearCaughtError();
          captureCommitPhaseError(fiber, error);
        }

        resetCurrentFiber();
      }
    }
  } // Second pass: Create new passive effects.


  var mountEffects = pendingPassiveHookEffectsMount;
  pendingPassiveHookEffectsMount = [];

  for (var _i = 0; _i < mountEffects.length; _i += 2) {
    var _effect2 = mountEffects[_i];
    var _fiber = mountEffects[_i + 1];

    {
      setCurrentFiber(_fiber);

      {
        invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
      }

      if (hasCaughtError()) {
        if (!(_fiber !== null)) {
          {
            throw Error( "Should be working on an effect." );
          }
        }

        var _error4 = clearCaughtError();

        captureCommitPhaseError(_fiber, _error4);
      }

      resetCurrentFiber();
    }
  } // Note: This currently assumes there are no passive effects on the root fiber
  // because the root is not part of its own effect list.
  // This could change in the future.


  var effect = root.current.firstEffect;

  while (effect !== null) {
    var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC

    effect.nextEffect = null;

    if (effect.flags & Deletion) {
      detachFiberAfterEffects(effect);
    }

    effect = nextNextEffect;
  }

  {
    popInteractions(prevInteractions);
    finishPendingInteractions(root, lanes);
  }

  {
    isFlushingPassiveEffects = false;
  }

  executionContext = prevExecutionContext;
  flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
  // exceeds the limit, we'll fire a warning.

  nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
  return true;
}

function isAlreadyFailedLegacyErrorBoundary(instance) {
  return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
}
function markLegacyErrorBoundaryAsFailed(instance) {
  if (legacyErrorBoundariesThatAlreadyFailed === null) {
    legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
  } else {
    legacyErrorBoundariesThatAlreadyFailed.add(instance);
  }
}

function prepareToThrowUncaughtError(error) {
  if (!hasUncaughtError) {
    hasUncaughtError = true;
    firstUncaughtError = error;
  }
}

var onUncaughtError = prepareToThrowUncaughtError;

function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
  var errorInfo = createCapturedValue(error, sourceFiber);
  var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
  enqueueUpdate(rootFiber, update);
  var eventTime = requestEventTime();
  var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);

  if (root !== null) {
    markRootUpdated(root, SyncLane, eventTime);
    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, SyncLane);
  }
}

function captureCommitPhaseError(sourceFiber, error) {
  if (sourceFiber.tag === HostRoot) {
    // Error was thrown at the root. There is no parent, so the root
    // itself should capture it.
    captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    return;
  }

  var fiber = sourceFiber.return;

  while (fiber !== null) {
    if (fiber.tag === HostRoot) {
      captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
      return;
    } else if (fiber.tag === ClassComponent) {
      var ctor = fiber.type;
      var instance = fiber.stateNode;

      if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
        enqueueUpdate(fiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);

        if (root !== null) {
          markRootUpdated(root, SyncLane, eventTime);
          ensureRootIsScheduled(root, eventTime);
          schedulePendingInteractions(root, SyncLane);
        } else {
          // This component has already been unmounted.
          // We can't schedule any follow up work for the root because the fiber is already unmounted,
          // but we can still call the log-only boundary so the error isn't swallowed.
          //
          // TODO This is only a temporary bandaid for the old reconciler fork.
          // We can delete this special case once the new fork is merged.
          if (typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
            try {
              instance.componentDidCatch(error, errorInfo);
            } catch (errorToIgnore) {// TODO Ignore this error? Rethrow it?
              // This is kind of an edge case.
            }
          }
        }

        return;
      }
    }

    fiber = fiber.return;
  }
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
  var pingCache = root.pingCache;

  if (pingCache !== null) {
    // The wakeable resolved, so we no longer need to memoize, because it will
    // never be thrown again.
    pingCache.delete(wakeable);
  }

  var eventTime = requestEventTime();
  markRootPinged(root, pingedLanes);

  if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
    // Received a ping at the same priority level at which we're currently
    // rendering. We might want to restart this render. This should mirror
    // the logic of whether or not a root suspends once it completes.
    // TODO: If we're rendering sync either due to Sync, Batched or expired,
    // we should probably never restart.
    // If we're suspended with delay, or if it's a retry, we'll always suspend
    // so we can always restart.
    if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
      // Restart from the root.
      prepareFreshStack(root, NoLanes);
    } else {
      // Even though we can't restart right now, we might get an
      // opportunity later. So we mark this render as having a ping.
      workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
    }
  }

  ensureRootIsScheduled(root, eventTime);
  schedulePendingInteractions(root, pingedLanes);
}

function retryTimedOutBoundary(boundaryFiber, retryLane) {
  // The boundary fiber (a Suspense component or SuspenseList component)
  // previously was rendered in its fallback state. One of the promises that
  // suspended it has resolved, which means at least part of the tree was
  // likely unblocked. Try rendering again, at a new expiration time.
  if (retryLane === NoLane) {
    retryLane = requestRetryLane(boundaryFiber);
  } // TODO: Special case idle priority?


  var eventTime = requestEventTime();
  var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);

  if (root !== null) {
    markRootUpdated(root, retryLane, eventTime);
    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, retryLane);
  }
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
  var retryLane = NoLane; // Default

  var retryCache;

  {
    retryCache = boundaryFiber.stateNode;
  }

  if (retryCache !== null) {
    // The wakeable resolved, so we no longer need to memoize, because it will
    // never be thrown again.
    retryCache.delete(wakeable);
  }

  retryTimedOutBoundary(boundaryFiber, retryLane);
} // Computes the next Just Noticeable Difference (JND) boundary.
// The theory is that a person can't tell the difference between small differences in time.
// Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
// difference in the experience. However, waiting for longer might mean that we can avoid
// showing an intermediate loading state. The longer we have already waited, the harder it
// is to tell small differences in time. Therefore, the longer we've already waited,
// the longer we can wait additionally. At some point we have to give up though.
// We pick a train model where the next boundary commits at a consistent schedule.
// These particular numbers are vague estimates. We expect to adjust them based on research.

function jnd(timeElapsed) {
  return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
}

function checkForNestedUpdates() {
  if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
    nestedUpdateCount = 0;
    rootWithNestedUpdates = null;

    {
      {
        throw Error( "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops." );
      }
    }
  }

  {
    if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
      nestedPassiveUpdateCount = 0;

      error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
    }
  }
}

function flushRenderPhaseStrictModeWarningsInDEV() {
  {
    ReactStrictModeWarnings.flushLegacyContextWarning();

    {
      ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
  }
}

var didWarnStateUpdateForNotYetMountedComponent = null;

function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
  {
    if ((executionContext & RenderContext) !== NoContext) {
      // We let the other warning about render phase updates deal with this one.
      return;
    }

    if (!(fiber.mode & (BlockingMode | ConcurrentMode))) {
      return;
    }

    var tag = fiber.tag;

    if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
      // Only warn for user-defined components, not internal ones like Suspense.
      return;
    } // We show the whole stack but dedupe on the top component's name because
    // the problematic code almost always lies inside that component.


    var componentName = getComponentName(fiber.type) || 'ReactComponent';

    if (didWarnStateUpdateForNotYetMountedComponent !== null) {
      if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
        return;
      }

      didWarnStateUpdateForNotYetMountedComponent.add(componentName);
    } else {
      didWarnStateUpdateForNotYetMountedComponent = new Set([componentName]);
    }

    var previousFiber = current;

    try {
      setCurrentFiber(fiber);

      error("Can't perform a React state update on a component that hasn't mounted yet. " + 'This indicates that you have a side-effect in your render function that ' + 'asynchronously later calls tries to update the component. Move this work to ' + 'useEffect instead.');
    } finally {
      if (previousFiber) {
        setCurrentFiber(fiber);
      } else {
        resetCurrentFiber();
      }
    }
  }
}

var didWarnStateUpdateForUnmountedComponent = null;

function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
  {
    var tag = fiber.tag;

    if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
      // Only warn for user-defined components, not internal ones like Suspense.
      return;
    } // If there are pending passive effects unmounts for this Fiber,
    // we can assume that they would have prevented this update.


    if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) {
      return;
    } // We show the whole stack but dedupe on the top component's name because
    // the problematic code almost always lies inside that component.


    var componentName = getComponentName(fiber.type) || 'ReactComponent';

    if (didWarnStateUpdateForUnmountedComponent !== null) {
      if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
        return;
      }

      didWarnStateUpdateForUnmountedComponent.add(componentName);
    } else {
      didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
    }

    if (isFlushingPassiveEffects) ; else {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error("Can't perform a React state update on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.', tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function');
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}

var beginWork$1;

{
  var dummyFiber = null;

  beginWork$1 = function (current, unitOfWork, lanes) {
    // If a component throws an error, we replay it again in a synchronously
    // dispatched event, so that the debugger will treat it as an uncaught
    // error See ReactErrorUtils for more information.
    // Before entering the begin phase, copy the work-in-progress onto a dummy
    // fiber. If beginWork throws, we'll use this to reset the state.
    var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);

    try {
      return beginWork(current, unitOfWork, lanes);
    } catch (originalError) {
      if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
        // Don't replay promises. Treat everything else like an error.
        throw originalError;
      } // Keep this code in sync with handleError; any changes here must have
      // corresponding changes there.


      resetContextDependencies();
      resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
      // same fiber again.
      // Unwind the failed stack frame

      unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.

      assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);

      if ( unitOfWork.mode & ProfileMode) {
        // Reset the profiler timer.
        startProfilerTimer(unitOfWork);
      } // Run beginWork again.


      invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);

      if (hasCaughtError()) {
        var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
        // Rethrow this error instead of the original one.

        throw replayError;
      } else {
        // This branch is reachable if the render phase is impure.
        throw originalError;
      }
    }
  };
}

var didWarnAboutUpdateInRender = false;
var didWarnAboutUpdateInRenderForAnotherComponent;

{
  didWarnAboutUpdateInRenderForAnotherComponent = new Set();
}

function warnAboutRenderPhaseUpdatesInDEV(fiber) {
  {
    if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
      switch (fiber.tag) {
        case FunctionComponent:
        case ForwardRef:
        case SimpleMemoComponent:
          {
            var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.

            var dedupeKey = renderingComponentName;

            if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
              didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
              var setStateComponentName = getComponentName(fiber.type) || 'Unknown';

              error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://reactjs.org/link/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
            }

            break;
          }

        case ClassComponent:
          {
            if (!didWarnAboutUpdateInRender) {
              error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');

              didWarnAboutUpdateInRender = true;
            }

            break;
          }
      }
    }
  }
} // a 'shared' variable that changes when act() opens/closes in tests.


var IsThisRendererActing = {
  current: false
};
function warnIfNotScopedWithMatchingAct(fiber) {
  {
    if ( IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error("It looks like you're using the wrong act() around your test interactions.\n" + 'Be sure to use the matching version of act() corresponding to your renderer:\n\n' + '// for react-dom:\n' + // Break up imports to avoid accidentally parsing them as dependencies.
        'import {act} fr' + "om 'react-dom/test-utils';\n" + '// ...\n' + 'act(() => ...);\n\n' + '// for react-test-renderer:\n' + // Break up imports to avoid accidentally parsing them as dependencies.
        'import TestRenderer fr' + "om react-test-renderer';\n" + 'const {act} = TestRenderer;\n' + '// ...\n' + 'act(() => ...);');
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}
function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
  {
    if ( (fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
      error('An update to %s ran an effect, but was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
    }
  }
}

function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
  {
    if ( executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}

var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.

var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
// scheduler is the actual recommendation. The alternative could be a testing build,
// a new lib, or whatever; we dunno just yet. This message is for early adopters
// to get their tests right.

function warnIfUnmockedScheduler(fiber) {
  {
    if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
      if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
        didWarnAboutUnmockedScheduler = true;

        error('In Concurrent or Sync modes, the "scheduler" module needs to be mocked ' + 'to guarantee consistent behaviour across tests and browsers. ' + 'For example, with jest: \n' + // Break up requires to avoid accidentally parsing them as dependencies.
        "jest.mock('scheduler', () => require" + "('scheduler/unstable_mock'));\n\n" + 'For more info, visit https://reactjs.org/link/mock-scheduler');
      }
    }
  }
}

function computeThreadID(root, lane) {
  // Interaction threads are unique per root and expiration time.
  // NOTE: Intentionally unsound cast. All that matters is that it's a number
  // and it represents a batch of work. Could make a helper function instead,
  // but meh this is fine for now.
  return lane * 1000 + root.interactionThreadID;
}

function markSpawnedWork(lane) {

  if (spawnedWorkDuringRender === null) {
    spawnedWorkDuringRender = [lane];
  } else {
    spawnedWorkDuringRender.push(lane);
  }
}

function scheduleInteractions(root, lane, interactions) {

  if (interactions.size > 0) {
    var pendingInteractionMap = root.pendingInteractionMap;
    var pendingInteractions = pendingInteractionMap.get(lane);

    if (pendingInteractions != null) {
      interactions.forEach(function (interaction) {
        if (!pendingInteractions.has(interaction)) {
          // Update the pending async work count for previously unscheduled interaction.
          interaction.__count++;
        }

        pendingInteractions.add(interaction);
      });
    } else {
      pendingInteractionMap.set(lane, new Set(interactions)); // Update the pending async work count for the current interactions.

      interactions.forEach(function (interaction) {
        interaction.__count++;
      });
    }

    var subscriber = tracing$1.__subscriberRef.current;

    if (subscriber !== null) {
      var threadID = computeThreadID(root, lane);
      subscriber.onWorkScheduled(interactions, threadID);
    }
  }
}

function schedulePendingInteractions(root, lane) {

  scheduleInteractions(root, lane, tracing$1.__interactionsRef.current);
}

function startWorkOnPendingInteractions(root, lanes) {
  // we can accurately attribute time spent working on it, And so that cascading
  // work triggered during the render phase will be associated with it.


  var interactions = new Set();
  root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledLane) {
    if (includesSomeLane(lanes, scheduledLane)) {
      scheduledInteractions.forEach(function (interaction) {
        return interactions.add(interaction);
      });
    }
  }); // Store the current set of interactions on the FiberRoot for a few reasons:
  // We can re-use it in hot functions like performConcurrentWorkOnRoot()
  // without having to recalculate it. We will also use it in commitWork() to
  // pass to any Profiler onRender() hooks. This also provides DevTools with a
  // way to access it when the onCommitRoot() hook is called.

  root.memoizedInteractions = interactions;

  if (interactions.size > 0) {
    var subscriber = tracing$1.__subscriberRef.current;

    if (subscriber !== null) {
      var threadID = computeThreadID(root, lanes);

      try {
        subscriber.onWorkStarted(interactions, threadID);
      } catch (error) {
        // If the subscriber throws, rethrow it in a separate task
        scheduleCallback(ImmediatePriority$1, function () {
          throw error;
        });
      }
    }
  }
}

function finishPendingInteractions(root, committedLanes) {

  var remainingLanesAfterCommit = root.pendingLanes;
  var subscriber;

  try {
    subscriber = tracing$1.__subscriberRef.current;

    if (subscriber !== null && root.memoizedInteractions.size > 0) {
      // FIXME: More than one lane can finish in a single commit.
      var threadID = computeThreadID(root, committedLanes);
      subscriber.onWorkStopped(root.memoizedInteractions, threadID);
    }
  } catch (error) {
    // If the subscriber throws, rethrow it in a separate task
    scheduleCallback(ImmediatePriority$1, function () {
      throw error;
    });
  } finally {
    // Clear completed interactions from the pending Map.
    // Unless the render was suspended or cascading work was scheduled,
    // In which case– leave pending interactions until the subsequent render.
    var pendingInteractionMap = root.pendingInteractionMap;
    pendingInteractionMap.forEach(function (scheduledInteractions, lane) {
      // Only decrement the pending interaction count if we're done.
      // If there's still work at the current priority,
      // That indicates that we are waiting for suspense data.
      if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
        pendingInteractionMap.delete(lane);
        scheduledInteractions.forEach(function (interaction) {
          interaction.__count--;

          if (subscriber !== null && interaction.__count === 0) {
            try {
              subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
              // If the subscriber throws, rethrow it in a separate task
              scheduleCallback(ImmediatePriority$1, function () {
                throw error;
              });
            }
          }
        });
      }
    });
  }
} // `act` testing API

function shouldForceFlushFallbacksInDEV() {
  // Never force flush in production. This function should get stripped out.
  return  actingUpdatesScopeDepth > 0;
}
// so we can tell if any async act() calls try to run in parallel.


var actingUpdatesScopeDepth = 0;

function detachFiberAfterEffects(fiber) {
  fiber.sibling = null;
  fiber.stateNode = null;
}

var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.

var failedBoundaries = null;
var setRefreshHandler = function (handler) {
  {
    resolveFamily = handler;
  }
};
function resolveFunctionForHotReloading(type) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return type;
    }

    var family = resolveFamily(type);

    if (family === undefined) {
      return type;
    } // Use the latest known implementation.


    return family.current;
  }
}
function resolveClassForHotReloading(type) {
  // No implementation differences.
  return resolveFunctionForHotReloading(type);
}
function resolveForwardRefForHotReloading(type) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return type;
    }

    var family = resolveFamily(type);

    if (family === undefined) {
      // Check if we're dealing with a real forwardRef. Don't want to crash early.
      if (type !== null && type !== undefined && typeof type.render === 'function') {
        // ForwardRef is special because its resolved .type is an object,
        // but it's possible that we only have its inner render function in the map.
        // If that inner render function is different, we'll build a new forwardRef type.
        var currentRender = resolveFunctionForHotReloading(type.render);

        if (type.render !== currentRender) {
          var syntheticType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: currentRender
          };

          if (type.displayName !== undefined) {
            syntheticType.displayName = type.displayName;
          }

          return syntheticType;
        }
      }

      return type;
    } // Use the latest known implementation.


    return family.current;
  }
}
function isCompatibleFamilyForHotReloading(fiber, element) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return false;
    }

    var prevType = fiber.elementType;
    var nextType = element.type; // If we got here, we know types aren't === equal.

    var needsCompareFamilies = false;
    var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;

    switch (fiber.tag) {
      case ClassComponent:
        {
          if (typeof nextType === 'function') {
            needsCompareFamilies = true;
          }

          break;
        }

      case FunctionComponent:
        {
          if (typeof nextType === 'function') {
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            // We don't know the inner type yet.
            // We're going to assume that the lazy inner type is stable,
            // and so it is sufficient to avoid reconciling it away.
            // We're not going to unwrap or actually use the new lazy type.
            needsCompareFamilies = true;
          }

          break;
        }

      case ForwardRef:
        {
          if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            needsCompareFamilies = true;
          }

          break;
        }

      case MemoComponent:
      case SimpleMemoComponent:
        {
          if ($$typeofNextType === REACT_MEMO_TYPE) {
            // TODO: if it was but can no longer be simple,
            // we shouldn't set this.
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            needsCompareFamilies = true;
          }

          break;
        }

      default:
        return false;
    } // Check if both types have a family and it's the same one.


    if (needsCompareFamilies) {
      // Note: memo() and forwardRef() we'll compare outer rather than inner type.
      // This means both of them need to be registered to preserve state.
      // If we unwrapped and compared the inner types for wrappers instead,
      // then we would risk falsely saying two separate memo(Foo)
      // calls are equivalent because they wrap the same Foo function.
      var prevFamily = resolveFamily(prevType);

      if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
        return true;
      }
    }

    return false;
  }
}
function markFailedErrorBoundaryForHotReloading(fiber) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return;
    }

    if (typeof WeakSet !== 'function') {
      return;
    }

    if (failedBoundaries === null) {
      failedBoundaries = new WeakSet();
    }

    failedBoundaries.add(fiber);
  }
}
var scheduleRefresh = function (root, update) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return;
    }

    var staleFamilies = update.staleFamilies,
        updatedFamilies = update.updatedFamilies;
    flushPassiveEffects();
    flushSync(function () {
      scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
    });
  }
};
var scheduleRoot = function (root, element) {
  {
    if (root.context !== emptyContextObject) {
      // Super edge case: root has a legacy _renderSubtree context
      // but we don't know the parentComponent so we can't pass it.
      // Just ignore. We'll delete this with _renderSubtree code path later.
      return;
    }

    flushPassiveEffects();
    flushSync(function () {
      updateContainer(element, root, null, null);
    });
  }
};

function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
  {
    var alternate = fiber.alternate,
        child = fiber.child,
        sibling = fiber.sibling,
        tag = fiber.tag,
        type = fiber.type;
    var candidateType = null;

    switch (tag) {
      case FunctionComponent:
      case SimpleMemoComponent:
      case ClassComponent:
        candidateType = type;
        break;

      case ForwardRef:
        candidateType = type.render;
        break;
    }

    if (resolveFamily === null) {
      throw new Error('Expected resolveFamily to be set during hot reload.');
    }

    var needsRender = false;
    var needsRemount = false;

    if (candidateType !== null) {
      var family = resolveFamily(candidateType);

      if (family !== undefined) {
        if (staleFamilies.has(family)) {
          needsRemount = true;
        } else if (updatedFamilies.has(family)) {
          if (tag === ClassComponent) {
            needsRemount = true;
          } else {
            needsRender = true;
          }
        }
      }
    }

    if (failedBoundaries !== null) {
      if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
        needsRemount = true;
      }
    }

    if (needsRemount) {
      fiber._debugNeedsRemount = true;
    }

    if (needsRemount || needsRender) {
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }

    if (child !== null && !needsRemount) {
      scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
    }

    if (sibling !== null) {
      scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
  }
}

var findHostInstancesForRefresh = function (root, families) {
  {
    var hostInstances = new Set();
    var types = new Set(families.map(function (family) {
      return family.current;
    }));
    findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
    return hostInstances;
  }
};

function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
  {
    var child = fiber.child,
        sibling = fiber.sibling,
        tag = fiber.tag,
        type = fiber.type;
    var candidateType = null;

    switch (tag) {
      case FunctionComponent:
      case SimpleMemoComponent:
      case ClassComponent:
        candidateType = type;
        break;

      case ForwardRef:
        candidateType = type.render;
        break;
    }

    var didMatch = false;

    if (candidateType !== null) {
      if (types.has(candidateType)) {
        didMatch = true;
      }
    }

    if (didMatch) {
      // We have a match. This only drills down to the closest host components.
      // There's no need to search deeper because for the purpose of giving
      // visual feedback, "flashing" outermost parent rectangles is sufficient.
      findHostInstancesForFiberShallowly(fiber, hostInstances);
    } else {
      // If there's no match, maybe there will be one further down in the child tree.
      if (child !== null) {
        findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
      }
    }

    if (sibling !== null) {
      findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
  }
}

function findHostInstancesForFiberShallowly(fiber, hostInstances) {
  {
    var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);

    if (foundHostInstances) {
      return;
    } // If we didn't find any host children, fallback to closest host parent.


    var node = fiber;

    while (true) {
      switch (node.tag) {
        case HostComponent:
          hostInstances.add(node.stateNode);
          return;

        case HostPortal:
          hostInstances.add(node.stateNode.containerInfo);
          return;

        case HostRoot:
          hostInstances.add(node.stateNode.containerInfo);
          return;
      }

      if (node.return === null) {
        throw new Error('Expected to reach root first.');
      }

      node = node.return;
    }
  }
}

function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
  {
    var node = fiber;
    var foundHostInstances = false;

    while (true) {
      if (node.tag === HostComponent) {
        // We got a match.
        foundHostInstances = true;
        hostInstances.add(node.stateNode); // There may still be more, so keep searching.
      } else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === fiber) {
        return foundHostInstances;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === fiber) {
          return foundHostInstances;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  }

  return false;
}

var hasBadMapPolyfill;

{
  hasBadMapPolyfill = false;

  try {
    var nonExtensibleObject = Object.preventExtensions({});
    /* eslint-disable no-new */

    new Map([[nonExtensibleObject, null]]);
    new Set([nonExtensibleObject]);
    /* eslint-enable no-new */
  } catch (e) {
    // TODO: Consider warning about bad polyfills
    hasBadMapPolyfill = true;
  }
}

var debugCounter = 1;

function FiberNode(tag, pendingProps, key, mode) {
  // Instance
  this.tag = tag;
  this.key = key;
  this.elementType = null;
  this.type = null;
  this.stateNode = null; // Fiber

  this.return = null;
  this.child = null;
  this.sibling = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = pendingProps;
  this.memoizedProps = null;
  this.updateQueue = null;
  this.memoizedState = null;
  this.dependencies = null;
  this.mode = mode; // Effects

  this.flags = NoFlags;
  this.nextEffect = null;
  this.firstEffect = null;
  this.lastEffect = null;
  this.lanes = NoLanes;
  this.childLanes = NoLanes;
  this.alternate = null;

  {
    // Note: The following is done to avoid a v8 performance cliff.
    //
    // Initializing the fields below to smis and later updating them with
    // double values will cause Fibers to end up having separate shapes.
    // This behavior/bug has something to do with Object.preventExtension().
    // Fortunately this only impacts DEV builds.
    // Unfortunately it makes React unusably slow for some applications.
    // To work around this, initialize the fields below with doubles.
    //
    // Learn more about this here:
    // https://github.com/facebook/react/issues/14365
    // https://bugs.chromium.org/p/v8/issues/detail?id=8538
    this.actualDuration = Number.NaN;
    this.actualStartTime = Number.NaN;
    this.selfBaseDuration = Number.NaN;
    this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
    // This won't trigger the performance cliff mentioned above,
    // and it simplifies other profiler code (including DevTools).

    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.selfBaseDuration = 0;
    this.treeBaseDuration = 0;
  }

  {
    // This isn't directly used but is handy for debugging internals:
    this._debugID = debugCounter++;
    this._debugSource = null;
    this._debugOwner = null;
    this._debugNeedsRemount = false;
    this._debugHookTypes = null;

    if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
      Object.preventExtensions(this);
    }
  }
} // This is a constructor function, rather than a POJO constructor, still
// please ensure we do the following:
// 1) Nobody should add any instance methods on this. Instance methods can be
//    more difficult to predict when they get optimized and they are almost
//    never inlined properly in static compilers.
// 2) Nobody should rely on `instanceof Fiber` for type testing. We should
//    always know when it is a fiber.
// 3) We might want to experiment with using numeric keys since they are easier
//    to optimize in a non-JIT environment.
// 4) We can easily go from a constructor to a createFiber object literal if that
//    is faster.
// 5) It should be easy to port this to a C struct and keep a C implementation
//    compatible.


var createFiber = function (tag, pendingProps, key, mode) {
  // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
  return new FiberNode(tag, pendingProps, key, mode);
};

function shouldConstruct$1(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function isSimpleFunctionComponent(type) {
  return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
}
function resolveLazyComponentTag(Component) {
  if (typeof Component === 'function') {
    return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
  } else if (Component !== undefined && Component !== null) {
    var $$typeof = Component.$$typeof;

    if ($$typeof === REACT_FORWARD_REF_TYPE) {
      return ForwardRef;
    }

    if ($$typeof === REACT_MEMO_TYPE) {
      return MemoComponent;
    }
  }

  return IndeterminateComponent;
} // This is used to create an alternate fiber to do work on.

function createWorkInProgress(current, pendingProps) {
  var workInProgress = current.alternate;

  if (workInProgress === null) {
    // We use a double buffering pooling technique because we know that we'll
    // only ever need at most two versions of a tree. We pool the "other" unused
    // node that we're free to reuse. This is lazily created to avoid allocating
    // extra objects for things that are never updated. It also allow us to
    // reclaim the extra memory if needed.
    workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
    workInProgress.elementType = current.elementType;
    workInProgress.type = current.type;
    workInProgress.stateNode = current.stateNode;

    {
      // DEV-only fields
      workInProgress._debugID = current._debugID;
      workInProgress._debugSource = current._debugSource;
      workInProgress._debugOwner = current._debugOwner;
      workInProgress._debugHookTypes = current._debugHookTypes;
    }

    workInProgress.alternate = current;
    current.alternate = workInProgress;
  } else {
    workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.

    workInProgress.type = current.type; // We already have an alternate.
    // Reset the effect tag.

    workInProgress.flags = NoFlags; // The effect list is no longer valid.

    workInProgress.nextEffect = null;
    workInProgress.firstEffect = null;
    workInProgress.lastEffect = null;

    {
      // We intentionally reset, rather than copy, actualDuration & actualStartTime.
      // This prevents time from endlessly accumulating in new commits.
      // This has the downside of resetting values for different priority renders,
      // But works for yielding (the common case) and should support resuming.
      workInProgress.actualDuration = 0;
      workInProgress.actualStartTime = -1;
    }
  }

  workInProgress.childLanes = current.childLanes;
  workInProgress.lanes = current.lanes;
  workInProgress.child = current.child;
  workInProgress.memoizedProps = current.memoizedProps;
  workInProgress.memoizedState = current.memoizedState;
  workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
  // it cannot be shared with the current fiber.

  var currentDependencies = current.dependencies;
  workInProgress.dependencies = currentDependencies === null ? null : {
    lanes: currentDependencies.lanes,
    firstContext: currentDependencies.firstContext
  }; // These will be overridden during the parent's reconciliation

  workInProgress.sibling = current.sibling;
  workInProgress.index = current.index;
  workInProgress.ref = current.ref;

  {
    workInProgress.selfBaseDuration = current.selfBaseDuration;
    workInProgress.treeBaseDuration = current.treeBaseDuration;
  }

  {
    workInProgress._debugNeedsRemount = current._debugNeedsRemount;

    switch (workInProgress.tag) {
      case IndeterminateComponent:
      case FunctionComponent:
      case SimpleMemoComponent:
        workInProgress.type = resolveFunctionForHotReloading(current.type);
        break;

      case ClassComponent:
        workInProgress.type = resolveClassForHotReloading(current.type);
        break;

      case ForwardRef:
        workInProgress.type = resolveForwardRefForHotReloading(current.type);
        break;
    }
  }

  return workInProgress;
} // Used to reuse a Fiber for a second pass.

function resetWorkInProgress(workInProgress, renderLanes) {
  // This resets the Fiber to what createFiber or createWorkInProgress would
  // have set the values to before during the first pass. Ideally this wouldn't
  // be necessary but unfortunately many code paths reads from the workInProgress
  // when they should be reading from current and writing to workInProgress.
  // We assume pendingProps, index, key, ref, return are still untouched to
  // avoid doing another reconciliation.
  // Reset the effect tag but keep any Placement tags, since that's something
  // that child fiber is setting, not the reconciliation.
  workInProgress.flags &= Placement; // The effect list is no longer valid.

  workInProgress.nextEffect = null;
  workInProgress.firstEffect = null;
  workInProgress.lastEffect = null;
  var current = workInProgress.alternate;

  if (current === null) {
    // Reset to createFiber's initial values.
    workInProgress.childLanes = NoLanes;
    workInProgress.lanes = renderLanes;
    workInProgress.child = null;
    workInProgress.memoizedProps = null;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.dependencies = null;
    workInProgress.stateNode = null;

    {
      // Note: We don't reset the actualTime counts. It's useful to accumulate
      // actual time across multiple render passes.
      workInProgress.selfBaseDuration = 0;
      workInProgress.treeBaseDuration = 0;
    }
  } else {
    // Reset to the cloned values that createWorkInProgress would've.
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.

    workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
    // it cannot be shared with the current fiber.

    var currentDependencies = current.dependencies;
    workInProgress.dependencies = currentDependencies === null ? null : {
      lanes: currentDependencies.lanes,
      firstContext: currentDependencies.firstContext
    };

    {
      // Note: We don't reset the actualTime counts. It's useful to accumulate
      // actual time across multiple render passes.
      workInProgress.selfBaseDuration = current.selfBaseDuration;
      workInProgress.treeBaseDuration = current.treeBaseDuration;
    }
  }

  return workInProgress;
}
function createHostRootFiber(tag) {
  var mode;

  if (tag === ConcurrentRoot) {
    mode = ConcurrentMode | BlockingMode | StrictMode;
  } else if (tag === BlockingRoot) {
    mode = BlockingMode | StrictMode;
  } else {
    mode = NoMode;
  }

  if ( isDevToolsPresent) {
    // Always collect profile timings when DevTools are present.
    // This enables DevTools to start capturing timing at any point–
    // Without some nodes in the tree having empty base times.
    mode |= ProfileMode;
  }

  return createFiber(HostRoot, null, null, mode);
}
function createFiberFromTypeAndProps(type, // React$ElementType
key, pendingProps, owner, mode, lanes) {
  var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.

  var resolvedType = type;

  if (typeof type === 'function') {
    if (shouldConstruct$1(type)) {
      fiberTag = ClassComponent;

      {
        resolvedType = resolveClassForHotReloading(resolvedType);
      }
    } else {
      {
        resolvedType = resolveFunctionForHotReloading(resolvedType);
      }
    }
  } else if (typeof type === 'string') {
    fiberTag = HostComponent;
  } else {
    getTag: switch (type) {
      case REACT_FRAGMENT_TYPE:
        return createFiberFromFragment(pendingProps.children, mode, lanes, key);

      case REACT_DEBUG_TRACING_MODE_TYPE:
        fiberTag = Mode;
        mode |= DebugTracingMode;
        break;

      case REACT_STRICT_MODE_TYPE:
        fiberTag = Mode;
        mode |= StrictMode;
        break;

      case REACT_PROFILER_TYPE:
        return createFiberFromProfiler(pendingProps, mode, lanes, key);

      case REACT_SUSPENSE_TYPE:
        return createFiberFromSuspense(pendingProps, mode, lanes, key);

      case REACT_SUSPENSE_LIST_TYPE:
        return createFiberFromSuspenseList(pendingProps, mode, lanes, key);

      case REACT_OFFSCREEN_TYPE:
        return createFiberFromOffscreen(pendingProps, mode, lanes, key);

      case REACT_LEGACY_HIDDEN_TYPE:
        return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);

      case REACT_SCOPE_TYPE:

      // eslint-disable-next-line no-fallthrough

      default:
        {
          if (typeof type === 'object' && type !== null) {
            switch (type.$$typeof) {
              case REACT_PROVIDER_TYPE:
                fiberTag = ContextProvider;
                break getTag;

              case REACT_CONTEXT_TYPE:
                // This is a consumer
                fiberTag = ContextConsumer;
                break getTag;

              case REACT_FORWARD_REF_TYPE:
                fiberTag = ForwardRef;

                {
                  resolvedType = resolveForwardRefForHotReloading(resolvedType);
                }

                break getTag;

              case REACT_MEMO_TYPE:
                fiberTag = MemoComponent;
                break getTag;

              case REACT_LAZY_TYPE:
                fiberTag = LazyComponent;
                resolvedType = null;
                break getTag;

              case REACT_BLOCK_TYPE:
                fiberTag = Block;
                break getTag;
            }
          }

          var info = '';

          {
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
            }

            var ownerName = owner ? getComponentName(owner.type) : null;

            if (ownerName) {
              info += '\n\nCheck the render method of `' + ownerName + '`.';
            }
          }

          {
            {
              throw Error( "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info );
            }
          }
        }
    }
  }

  var fiber = createFiber(fiberTag, pendingProps, key, mode);
  fiber.elementType = type;
  fiber.type = resolvedType;
  fiber.lanes = lanes;

  {
    fiber._debugOwner = owner;
  }

  return fiber;
}
function createFiberFromElement(element, mode, lanes) {
  var owner = null;

  {
    owner = element._owner;
  }

  var type = element.type;
  var key = element.key;
  var pendingProps = element.props;
  var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);

  {
    fiber._debugSource = element._source;
    fiber._debugOwner = element._owner;
  }

  return fiber;
}
function createFiberFromFragment(elements, mode, lanes, key) {
  var fiber = createFiber(Fragment, elements, key, mode);
  fiber.lanes = lanes;
  return fiber;
}

function createFiberFromProfiler(pendingProps, mode, lanes, key) {
  {
    if (typeof pendingProps.id !== 'string') {
      error('Profiler must specify an "id" as a prop');
    }
  }

  var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.

  fiber.elementType = REACT_PROFILER_TYPE;
  fiber.type = REACT_PROFILER_TYPE;
  fiber.lanes = lanes;

  {
    fiber.stateNode = {
      effectDuration: 0,
      passiveEffectDuration: 0
    };
  }

  return fiber;
}

function createFiberFromSuspense(pendingProps, mode, lanes, key) {
  var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  fiber.type = REACT_SUSPENSE_TYPE;
  fiber.elementType = REACT_SUSPENSE_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
  var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);

  {
    // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
    // This needs to be fixed in getComponentName so that it relies on the tag
    // instead.
    fiber.type = REACT_SUSPENSE_LIST_TYPE;
  }

  fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
  var fiber = createFiber(OffscreenComponent, pendingProps, key, mode); // TODO: The OffscreenComponent fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  {
    fiber.type = REACT_OFFSCREEN_TYPE;
  }

  fiber.elementType = REACT_OFFSCREEN_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
  var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode); // TODO: The LegacyHidden fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  {
    fiber.type = REACT_LEGACY_HIDDEN_TYPE;
  }

  fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromText(content, mode, lanes) {
  var fiber = createFiber(HostText, content, null, mode);
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromHostInstanceForDeletion() {
  var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.

  fiber.elementType = 'DELETED';
  fiber.type = 'DELETED';
  return fiber;
}
function createFiberFromPortal(portal, mode, lanes) {
  var pendingProps = portal.children !== null ? portal.children : [];
  var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
  fiber.lanes = lanes;
  fiber.stateNode = {
    containerInfo: portal.containerInfo,
    pendingChildren: null,
    // Used by persistent updates
    implementation: portal.implementation
  };
  return fiber;
} // Used for stashing WIP properties to replay failed work in DEV.

function assignFiberPropertiesInDEV(target, source) {
  if (target === null) {
    // This Fiber's initial properties will always be overwritten.
    // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
    target = createFiber(IndeterminateComponent, null, null, NoMode);
  } // This is intentionally written as a list of all properties.
  // We tried to use Object.assign() instead but this is called in
  // the hottest path, and Object.assign() was too slow:
  // https://github.com/facebook/react/issues/12502
  // This code is DEV-only so size is not a concern.


  target.tag = source.tag;
  target.key = source.key;
  target.elementType = source.elementType;
  target.type = source.type;
  target.stateNode = source.stateNode;
  target.return = source.return;
  target.child = source.child;
  target.sibling = source.sibling;
  target.index = source.index;
  target.ref = source.ref;
  target.pendingProps = source.pendingProps;
  target.memoizedProps = source.memoizedProps;
  target.updateQueue = source.updateQueue;
  target.memoizedState = source.memoizedState;
  target.dependencies = source.dependencies;
  target.mode = source.mode;
  target.flags = source.flags;
  target.nextEffect = source.nextEffect;
  target.firstEffect = source.firstEffect;
  target.lastEffect = source.lastEffect;
  target.lanes = source.lanes;
  target.childLanes = source.childLanes;
  target.alternate = source.alternate;

  {
    target.actualDuration = source.actualDuration;
    target.actualStartTime = source.actualStartTime;
    target.selfBaseDuration = source.selfBaseDuration;
    target.treeBaseDuration = source.treeBaseDuration;
  }

  target._debugID = source._debugID;
  target._debugSource = source._debugSource;
  target._debugOwner = source._debugOwner;
  target._debugNeedsRemount = source._debugNeedsRemount;
  target._debugHookTypes = source._debugHookTypes;
  return target;
}

function FiberRootNode(containerInfo, tag, hydrate) {
  this.tag = tag;
  this.containerInfo = containerInfo;
  this.pendingChildren = null;
  this.current = null;
  this.pingCache = null;
  this.finishedWork = null;
  this.timeoutHandle = noTimeout;
  this.context = null;
  this.pendingContext = null;
  this.hydrate = hydrate;
  this.callbackNode = null;
  this.callbackPriority = NoLanePriority;
  this.eventTimes = createLaneMap(NoLanes);
  this.expirationTimes = createLaneMap(NoTimestamp);
  this.pendingLanes = NoLanes;
  this.suspendedLanes = NoLanes;
  this.pingedLanes = NoLanes;
  this.expiredLanes = NoLanes;
  this.mutableReadLanes = NoLanes;
  this.finishedLanes = NoLanes;
  this.entangledLanes = NoLanes;
  this.entanglements = createLaneMap(NoLanes);

  {
    this.mutableSourceEagerHydrationData = null;
  }

  {
    this.interactionThreadID = tracing$1.unstable_getThreadID();
    this.memoizedInteractions = new Set();
    this.pendingInteractionMap = new Map();
  }

  {
    switch (tag) {
      case BlockingRoot:
        this._debugRootType = 'createBlockingRoot()';
        break;

      case ConcurrentRoot:
        this._debugRootType = 'createRoot()';
        break;

      case LegacyRoot:
        this._debugRootType = 'createLegacyRoot()';
        break;
    }
  }
}

function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
  var root = new FiberRootNode(containerInfo, tag, hydrate);
  // stateNode is any.


  var uninitializedFiber = createHostRootFiber(tag);
  root.current = uninitializedFiber;
  uninitializedFiber.stateNode = root;
  initializeUpdateQueue(uninitializedFiber);
  return root;
}

// This ensures that the version used for server rendering matches the one
// that is eventually read during hydration.
// If they don't match there's a potential tear and a full deopt render is required.

function registerMutableSourceForHydration(root, mutableSource) {
  var getVersion = mutableSource._getVersion;
  var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
  // Retaining it forever may interfere with GC.

  if (root.mutableSourceEagerHydrationData == null) {
    root.mutableSourceEagerHydrationData = [mutableSource, version];
  } else {
    root.mutableSourceEagerHydrationData.push(mutableSource, version);
  }
}

function createPortal(children, containerInfo, // TODO: figure out the API for cross-renderer implementation.
implementation) {
  var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return {
    // This tag allow us to uniquely identify this as a React Portal
    $$typeof: REACT_PORTAL_TYPE,
    key: key == null ? null : '' + key,
    children: children,
    containerInfo: containerInfo,
    implementation: implementation
  };
}

var didWarnAboutNestedUpdates;
var didWarnAboutFindNodeInStrictMode;

{
  didWarnAboutNestedUpdates = false;
  didWarnAboutFindNodeInStrictMode = {};
}

function getContextForSubtree(parentComponent) {
  if (!parentComponent) {
    return emptyContextObject;
  }

  var fiber = get(parentComponent);
  var parentContext = findCurrentUnmaskedContext(fiber);

  if (fiber.tag === ClassComponent) {
    var Component = fiber.type;

    if (isContextProvider(Component)) {
      return processChildContext(fiber, Component, parentContext);
    }
  }

  return parentContext;
}

function findHostInstanceWithWarning(component, methodName) {
  {
    var fiber = get(component);

    if (fiber === undefined) {
      if (typeof component.render === 'function') {
        {
          {
            throw Error( "Unable to find node on an unmounted component." );
          }
        }
      } else {
        {
          {
            throw Error( "Argument appears to not be a ReactComponent. Keys: " + Object.keys(component) );
          }
        }
      }
    }

    var hostFiber = findCurrentHostFiber(fiber);

    if (hostFiber === null) {
      return null;
    }

    if (hostFiber.mode & StrictMode) {
      var componentName = getComponentName(fiber.type) || 'Component';

      if (!didWarnAboutFindNodeInStrictMode[componentName]) {
        didWarnAboutFindNodeInStrictMode[componentName] = true;
        var previousFiber = current;

        try {
          setCurrentFiber(hostFiber);

          if (fiber.mode & StrictMode) {
            error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
          } else {
            error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
          }
        } finally {
          // Ideally this should reset to previous but this shouldn't be called in
          // render and there's another warning for that anyway.
          if (previousFiber) {
            setCurrentFiber(previousFiber);
          } else {
            resetCurrentFiber();
          }
        }
      }
    }

    return hostFiber.stateNode;
  }
}

function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
  return createFiberRoot(containerInfo, tag, hydrate);
}
function updateContainer(element, container, parentComponent, callback) {
  {
    onScheduleRoot(container, element);
  }

  var current$1 = container.current;
  var eventTime = requestEventTime();

  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfUnmockedScheduler(current$1);
      warnIfNotScopedWithMatchingAct(current$1);
    }
  }

  var lane = requestUpdateLane(current$1);

  var context = getContextForSubtree(parentComponent);

  if (container.context === null) {
    container.context = context;
  } else {
    container.pendingContext = context;
  }

  {
    if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
      didWarnAboutNestedUpdates = true;

      error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
    }
  }

  var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
  // being called "element".

  update.payload = {
    element: element
  };
  callback = callback === undefined ? null : callback;

  if (callback !== null) {
    {
      if (typeof callback !== 'function') {
        error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
      }
    }

    update.callback = callback;
  }

  enqueueUpdate(current$1, update);
  scheduleUpdateOnFiber(current$1, lane, eventTime);
  return lane;
}
function getPublicRootInstance(container) {
  var containerFiber = container.current;

  if (!containerFiber.child) {
    return null;
  }

  switch (containerFiber.child.tag) {
    case HostComponent:
      return getPublicInstance(containerFiber.child.stateNode);

    default:
      return containerFiber.child.stateNode;
  }
}

function markRetryLaneImpl(fiber, retryLane) {
  var suspenseState = fiber.memoizedState;

  if (suspenseState !== null && suspenseState.dehydrated !== null) {
    suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
  }
} // Increases the priority of thennables when they resolve within this boundary.


function markRetryLaneIfNotHydrated(fiber, retryLane) {
  markRetryLaneImpl(fiber, retryLane);
  var alternate = fiber.alternate;

  if (alternate) {
    markRetryLaneImpl(alternate, retryLane);
  }
}

function attemptUserBlockingHydration$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority and they should not suspend on I/O,
    // since you have to wrap anything that might suspend in
    // Suspense.
    return;
  }

  var eventTime = requestEventTime();
  var lane = InputDiscreteHydrationLane;
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function attemptContinuousHydration$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority and they should not suspend on I/O,
    // since you have to wrap anything that might suspend in
    // Suspense.
    return;
  }

  var eventTime = requestEventTime();
  var lane = SelectiveHydrationLane;
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function attemptHydrationAtCurrentPriority$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority other than synchronously flush it.
    return;
  }

  var eventTime = requestEventTime();
  var lane = requestUpdateLane(fiber);
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function runWithPriority$2(priority, fn) {

  try {
    setCurrentUpdateLanePriority(priority);
    return fn();
  } finally {
  }
}
function findHostInstanceWithNoPortals(fiber) {
  var hostFiber = findCurrentHostFiberWithNoPortals(fiber);

  if (hostFiber === null) {
    return null;
  }

  if (hostFiber.tag === FundamentalComponent) {
    return hostFiber.stateNode.instance;
  }

  return hostFiber.stateNode;
}

var shouldSuspendImpl = function (fiber) {
  return false;
};

function shouldSuspend(fiber) {
  return shouldSuspendImpl(fiber);
}
var overrideHookState = null;
var overrideHookStateDeletePath = null;
var overrideHookStateRenamePath = null;
var overrideProps = null;
var overridePropsDeletePath = null;
var overridePropsRenamePath = null;
var scheduleUpdate = null;
var setSuspenseHandler = null;

{
  var copyWithDeleteImpl = function (obj, path, index) {
    var key = path[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);

    if (index + 1 === path.length) {
      if (Array.isArray(updated)) {
        updated.splice(key, 1);
      } else {
        delete updated[key];
      }

      return updated;
    } // $FlowFixMe number or string is fine here


    updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
    return updated;
  };

  var copyWithDelete = function (obj, path) {
    return copyWithDeleteImpl(obj, path, 0);
  };

  var copyWithRenameImpl = function (obj, oldPath, newPath, index) {
    var oldKey = oldPath[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);

    if (index + 1 === oldPath.length) {
      var newKey = newPath[index]; // $FlowFixMe number or string is fine here

      updated[newKey] = updated[oldKey];

      if (Array.isArray(updated)) {
        updated.splice(oldKey, 1);
      } else {
        delete updated[oldKey];
      }
    } else {
      // $FlowFixMe number or string is fine here
      updated[oldKey] = copyWithRenameImpl( // $FlowFixMe number or string is fine here
      obj[oldKey], oldPath, newPath, index + 1);
    }

    return updated;
  };

  var copyWithRename = function (obj, oldPath, newPath) {
    if (oldPath.length !== newPath.length) {
      warn('copyWithRename() expects paths of the same length');

      return;
    } else {
      for (var i = 0; i < newPath.length - 1; i++) {
        if (oldPath[i] !== newPath[i]) {
          warn('copyWithRename() expects paths to be the same except for the deepest key');

          return;
        }
      }
    }

    return copyWithRenameImpl(obj, oldPath, newPath, 0);
  };

  var copyWithSetImpl = function (obj, path, index, value) {
    if (index >= path.length) {
      return value;
    }

    var key = path[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here

    updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
    return updated;
  };

  var copyWithSet = function (obj, path, value) {
    return copyWithSetImpl(obj, path, 0, value);
  };

  var findHook = function (fiber, id) {
    // For now, the "id" of stateful hooks is just the stateful hook index.
    // This may change in the future with e.g. nested hooks.
    var currentHook = fiber.memoizedState;

    while (currentHook !== null && id > 0) {
      currentHook = currentHook.next;
      id--;
    }

    return currentHook;
  }; // Support DevTools editable values for useState and useReducer.


  overrideHookState = function (fiber, id, path, value) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithSet(hook.memoizedState, path, value);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  };

  overrideHookStateDeletePath = function (fiber, id, path) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithDelete(hook.memoizedState, path);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  };

  overrideHookStateRenamePath = function (fiber, id, oldPath, newPath) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  }; // Support DevTools props for function components, forwardRef, memo, host components, etc.


  overrideProps = function (fiber, path, value) {
    fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  overridePropsDeletePath = function (fiber, path) {
    fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  overridePropsRenamePath = function (fiber, oldPath, newPath) {
    fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  scheduleUpdate = function (fiber) {
    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  setSuspenseHandler = function (newShouldSuspendImpl) {
    shouldSuspendImpl = newShouldSuspendImpl;
  };
}

function findHostInstanceByFiber(fiber) {
  var hostFiber = findCurrentHostFiber(fiber);

  if (hostFiber === null) {
    return null;
  }

  return hostFiber.stateNode;
}

function emptyFindFiberByHostInstance(instance) {
  return null;
}

function getCurrentFiberForDevTools() {
  return current;
}

function injectIntoDevTools(devToolsConfig) {
  var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
  var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
  return injectInternals({
    bundleType: devToolsConfig.bundleType,
    version: devToolsConfig.version,
    rendererPackageName: devToolsConfig.rendererPackageName,
    rendererConfig: devToolsConfig.rendererConfig,
    overrideHookState: overrideHookState,
    overrideHookStateDeletePath: overrideHookStateDeletePath,
    overrideHookStateRenamePath: overrideHookStateRenamePath,
    overrideProps: overrideProps,
    overridePropsDeletePath: overridePropsDeletePath,
    overridePropsRenamePath: overridePropsRenamePath,
    setSuspenseHandler: setSuspenseHandler,
    scheduleUpdate: scheduleUpdate,
    currentDispatcherRef: ReactCurrentDispatcher,
    findHostInstanceByFiber: findHostInstanceByFiber,
    findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
    // React Refresh
    findHostInstancesForRefresh:  findHostInstancesForRefresh ,
    scheduleRefresh:  scheduleRefresh ,
    scheduleRoot:  scheduleRoot ,
    setRefreshHandler:  setRefreshHandler ,
    // Enables DevTools to append owner stacks to error messages in DEV mode.
    getCurrentFiber:  getCurrentFiberForDevTools 
  });
}

function ReactDOMRoot(container, options) {
  this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
}

function ReactDOMBlockingRoot(container, tag, options) {
  this._internalRoot = createRootImpl(container, tag, options);
}

ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function (children) {
  var root = this._internalRoot;

  {
    if (typeof arguments[1] === 'function') {
      error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
    }

    var container = root.containerInfo;

    if (container.nodeType !== COMMENT_NODE) {
      var hostInstance = findHostInstanceWithNoPortals(root.current);

      if (hostInstance) {
        if (hostInstance.parentNode !== container) {
          error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + "root.unmount() to empty a root's container.");
        }
      }
    }
  }

  updateContainer(children, root, null, null);
};

ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function () {
  {
    if (typeof arguments[0] === 'function') {
      error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
    }
  }

  var root = this._internalRoot;
  var container = root.containerInfo;
  updateContainer(null, root, null, function () {
    unmarkContainerAsRoot(container);
  });
};

function createRootImpl(container, tag, options) {
  // Tag is either LegacyRoot or Concurrent Root
  var hydrate = options != null && options.hydrate === true;
  var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
  var root = createContainer(container, tag, hydrate);
  markContainerAsRoot(root.current, container);

  {
    var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
    listenToAllSupportedEvents(rootContainerElement);
  }

  if (mutableSources) {
    for (var i = 0; i < mutableSources.length; i++) {
      var mutableSource = mutableSources[i];
      registerMutableSourceForHydration(root, mutableSource);
    }
  }

  return root;
}
function createLegacyRoot(container, options) {
  return new ReactDOMBlockingRoot(container, LegacyRoot, options);
}
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
}

var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
var topLevelUpdateWarnings;
var warnedAboutHydrateAPI = false;

{
  topLevelUpdateWarnings = function (container) {
    if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
      var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);

      if (hostInstance) {
        if (hostInstance.parentNode !== container) {
          error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
        }
      }
    }

    var isRootRenderedBySomeReact = !!container._reactRootContainer;
    var rootEl = getReactRootElementInContainer(container);
    var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));

    if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
      error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
    }

    if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
      error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
    }
  };
}

function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOCUMENT_NODE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function shouldHydrateDueToLegacyHeuristic(container) {
  var rootElement = getReactRootElementInContainer(container);
  return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
}

function legacyCreateRootFromDOMContainer(container, forceHydrate) {
  var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.

  if (!shouldHydrate) {
    var warned = false;
    var rootSibling;

    while (rootSibling = container.lastChild) {
      {
        if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
          warned = true;

          error('render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.');
        }
      }

      container.removeChild(rootSibling);
    }
  }

  {
    if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
      warnedAboutHydrateAPI = true;

      warn('render(): Calling ReactDOM.render() to hydrate server-rendered markup ' + 'will stop working in React v18. Replace the ReactDOM.render() call ' + 'with ReactDOM.hydrate() if you want React to attach to the server HTML.');
    }
  }

  return createLegacyRoot(container, shouldHydrate ? {
    hydrate: true
  } : undefined);
}

function warnOnInvalidCallback$1(callback, callerName) {
  {
    if (callback !== null && typeof callback !== 'function') {
      error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
    }
  }
}

function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
  {
    topLevelUpdateWarnings(container);
    warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
  } // TODO: Without `any` type, Flow says "Property cannot be accessed on any
  // member of intersection type." Whyyyyyy.


  var root = container._reactRootContainer;
  var fiberRoot;

  if (!root) {
    // Initial mount
    root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
    fiberRoot = root._internalRoot;

    if (typeof callback === 'function') {
      var originalCallback = callback;

      callback = function () {
        var instance = getPublicRootInstance(fiberRoot);
        originalCallback.call(instance);
      };
    } // Initial mount should not be batched.


    unbatchedUpdates(function () {
      updateContainer(children, fiberRoot, parentComponent, callback);
    });
  } else {
    fiberRoot = root._internalRoot;

    if (typeof callback === 'function') {
      var _originalCallback = callback;

      callback = function () {
        var instance = getPublicRootInstance(fiberRoot);

        _originalCallback.call(instance);
      };
    } // Update


    updateContainer(children, fiberRoot, parentComponent, callback);
  }

  return getPublicRootInstance(fiberRoot);
}

function findDOMNode(componentOrElement) {
  {
    var owner = ReactCurrentOwner$3.current;

    if (owner !== null && owner.stateNode !== null) {
      var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;

      if (!warnedAboutRefsInRender) {
        error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(owner.type) || 'A component');
      }

      owner.stateNode._warnedAboutRefsInRender = true;
    }
  }

  if (componentOrElement == null) {
    return null;
  }

  if (componentOrElement.nodeType === ELEMENT_NODE) {
    return componentOrElement;
  }

  {
    return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
  }
}
function hydrate(element, container, callback) {
  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call createRoot(container, {hydrate: true}).render(element)?');
    }
  } // TODO: throw or warn if we couldn't hydrate?


  return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
}
function render(element, container, callback) {
  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
    }
  }

  return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
}
function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
  if (!isValidContainer(containerNode)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  if (!(parentComponent != null && has(parentComponent))) {
    {
      throw Error( "parentComponent must be a valid React Component" );
    }
  }

  return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
}
function unmountComponentAtNode(container) {
  if (!isValidContainer(container)) {
    {
      throw Error( "unmountComponentAtNode(...): Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?');
    }
  }

  if (container._reactRootContainer) {
    {
      var rootEl = getReactRootElementInContainer(container);
      var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);

      if (renderedByDifferentReact) {
        error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.');
      }
    } // Unmount should not be batched.


    unbatchedUpdates(function () {
      legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
        // $FlowFixMe This should probably use `delete container._reactRootContainer`
        container._reactRootContainer = null;
        unmarkContainerAsRoot(container);
      });
    }); // If you call unmountComponentAtNode twice in quick succession, you'll
    // get `true` twice. That's probably fine?

    return true;
  } else {
    {
      var _rootEl = getReactRootElementInContainer(container);

      var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.

      var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;

      if (hasNonRootReactChild) {
        error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
      }
    }

    return false;
  }
}

setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
setAttemptContinuousHydration(attemptContinuousHydration$1);
setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
setAttemptHydrationAtPriority(runWithPriority$2);
var didWarnAboutUnstableCreatePortal = false;

{
  if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
  Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
  Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
    error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
  }
}

setRestoreImplementation(restoreControlledState$3);
setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);

function createPortal$1(children, container) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  } // TODO: pass ReactDOM portal implementation as third argument
  // $FlowFixMe The Flow type is opaque but there's no way to actually create it.


  return createPortal(children, container, null, key);
}

function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {

  return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
}

function unstable_createPortal(children, container) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  {
    if (!didWarnAboutUnstableCreatePortal) {
      didWarnAboutUnstableCreatePortal = true;

      warn('The ReactDOM.unstable_createPortal() alias has been deprecated, ' + 'and will be removed in React 18+. Update your code to use ' + 'ReactDOM.createPortal() instead. It has the exact same API, ' + 'but without the "unstable_" prefix.');
    }
  }

  return createPortal$1(children, container, key);
}

var Internals = {
  // Keep in sync with ReactTestUtils.js, and ReactTestUtilsAct.js.
  // This is an array for better minification.
  Events: [getInstanceFromNode, getNodeFromInstance, getFiberCurrentPropsFromNode, enqueueStateRestore, restoreStateIfNeeded, flushPassiveEffects, // TODO: This is related to `act`, not events. Move to separate key?
  IsThisRendererActing]
};
var foundDevTools = injectIntoDevTools({
  findFiberByHostInstance: getClosestInstanceFromNode,
  bundleType:  1 ,
  version: ReactVersion,
  rendererPackageName: 'react-dom'
});

{
  if (!foundDevTools && canUseDOM && window.top === window.self) {
    // If we're in Chrome or Firefox, provide a download link if not installed.
    if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
      var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.

      if (/^(https?|file):$/.test(protocol)) {
        // eslint-disable-next-line react-internal/no-production-logging
        console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://reactjs.org/link/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://reactjs.org/link/react-devtools-faq' : ''), 'font-weight:bold');
      }
    }
  }
}

exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
exports.createPortal = createPortal$1;
exports.findDOMNode = findDOMNode;
exports.flushSync = flushSync;
exports.hydrate = hydrate;
exports.render = render;
exports.unmountComponentAtNode = unmountComponentAtNode;
exports.unstable_batchedUpdates = batchedUpdates$1;
exports.unstable_createPortal = unstable_createPortal;
exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
exports.version = ReactVersion;
  })();
}
});

var reactDom = createCommonjsModule(function (module) {

function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (process.env.NODE_ENV !== 'production') {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (process.env.NODE_ENV === 'production') {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = reactDom_production_min;
} else {
  module.exports = reactDom_development;
}
});

function Portal(props) {
  var elm = useRef(document.createElement('div'));
  useEffect(function () {
    props.targetRef.appendChild(elm.current);
    return function () {
      props.targetRef.removeChild(elm.current);
    };
  }, [props.targetRef]);
  return /*#__PURE__*/reactDom.createPortal(props.children, elm.current);
}

Portal.propTypes = {
  targetRef: PropTypes__default.instanceOf(Object).isRequired
};

var _templateObject$p;

var _excluded$5 = ["underline", "type", "fontWeight", "children", "disabled", "preventHrefOnClick"];
var colorMap = {
  primary: '#6e0ad6',
  secondary: '#4a4a4a',
  white: '#fff',
  darkyellow: '#583F18'
};

var onClickWrapper = function onClickWrapper(props) {
  return function (event) {
    if (props.disabled || props.onClick && props.preventHrefOnClick) {
      event.preventDefault();
    }

    if (props.onClick) {
      props.onClick(event);
    }
  };
};

var LINK = function LINK(props) {
  var children = props.children,
      disabled = props.disabled,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded$5);

  if (disabled) {
    otherProps.tabIndex = '-1';
  }

  return /*#__PURE__*/React.createElement("a", _extends({}, otherProps, {
    onClick: onClickWrapper(props)
  }), children);
};

var link = styled(LINK)(_templateObject$p || (_templateObject$p = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 14px !important;\n  font-weight: ", ";\n  text-align: center !important;\n  text-decoration: ", ";\n  ", "\n  font-family: \"Nunito Sans\", sans-serif !important;\n  ", "\n  cursor: pointer;\n  ", "\n"])), function (props) {
  return colorMap[props.type];
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.underline ? 'underline !important' : 'none !important';
}, function (props) {
  return props.underline && 'line-height: 20px !important';
}, function (props) {
  return props.disabled && "\n    opacity: 0.6;\n    pointer-events: none;\n    cursor: default;\n    outline: 0;\n  ";
}, function (props) {
  return props.fontAdjust;
});
link.propTypes = {
  type: PropTypes__default.oneOf(['primary', 'secondary', 'white', 'darkyellow']),
  fontWeight: PropTypes__default.number,
  underline: PropTypes__default.bool,
  href: PropTypes__default.string,
  track: PropTypes__default.string,
  fontAdjust: PropTypes__default.string,
  target: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  onClick: PropTypes__default.func,
  preventHrefOnClick: PropTypes__default.bool
};
link.defaultProps = {
  href: '#',
  type: 'secondary',
  fontWeight: 600,
  underline: false,
  disabled: false,
  preventHrefOnClick: true
};

var AddressIcon = (function () {
  return /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "#E2CEF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 22.1667H20.6667C21.1269 22.1667 21.5 21.7936 21.5 21.3333V14.2445L16 9.96676L10.5 14.2445V21.3333C10.5 21.7936 10.8731 22.1667 11.3333 22.1667H13.5V16C13.5 15.7239 13.7239 15.5 14 15.5H18C18.2761 15.5 18.5 15.7239 18.5 16V22.1667ZM17.5 22.1667V16.5H14.5V22.1667H17.5ZM9.69303 13.6053L15.693 8.93864C15.8736 8.79821 16.1264 8.79821 16.307 8.93864L22.307 13.6053C22.4288 13.7 22.5 13.8457 22.5 14V21.3333C22.5 22.3458 21.6792 23.1666 20.6667 23.1666H11.3333C10.3208 23.1666 9.5 22.3458 9.5 21.3333V14C9.5 13.8457 9.57124 13.7 9.69303 13.6053Z",
    fill: "#6E0AD6"
  }));
});

var _templateObject$q;
var Circle = styled(View$1)(_templateObject$q || (_templateObject$q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-radius: 100px;\n  width: 32px;\n  height: 32px;\n  background-color: #fff4f4;\n  align-items: center;\n  justify-content: center;\n"])));
var AlertCircleIcon = (function () {
  return /*#__PURE__*/React.createElement(Circle, null, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71362 3.58265C10.196 2.75648 11.0619 2.25 12 2.25C12.9381 2.25 13.8041 2.75648 14.2864 3.58265L22.399 17.6527C22.8644 18.4899 22.8672 19.5172 22.4064 20.357C21.9405 21.2061 21.0687 21.7391 20.1068 21.75L3.88466 21.75C2.93136 21.7391 2.05957 21.2061 1.59368 20.357C1.13288 19.5172 1.13564 18.4899 1.60682 17.6424L9.71362 3.58265ZM2.91209 18.3814C2.69721 18.768 2.69592 19.2476 2.90874 19.6355C3.11649 20.0141 3.49484 20.2454 3.89322 20.25L20.0983 20.25C20.5052 20.2454 20.8836 20.0141 21.0913 19.6355C21.3041 19.2476 21.3028 18.768 21.0938 18.3917L12.989 4.33545C12.7753 3.96942 12.4001 3.75 12 3.75C11.6005 3.75 11.2258 3.9688 11.0119 4.33389L2.91209 18.3814ZM11.25 10V14C11.25 14.4142 11.5858 14.75 12 14.75C12.4142 14.75 12.75 14.4142 12.75 14V10C12.75 9.58579 12.4142 9.25 12 9.25C11.5858 9.25 11.25 9.58579 11.25 10ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z",
    fill: "#FF4444"
  })));
});

var _templateObject$r, _templateObject2$d;
var Content$4 = styled(View$1)(_templateObject$r || (_templateObject$r = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  height: 72px;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid #e5e5e5;\n  box-sizing: border-box;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 16px rgba(0, 0, 0, 0.08);\n  border-radius: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n"])));
var AddressContent = styled(View$1)(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding-left: 16px;\n  padding-right: 16px;\n"])));

var isIncompleteAddress = function isIncompleteAddress(zipcode, street, number) {
  return !(zipcode && street && number);
};

var getAddressText = function getAddressText(id, zipcode, street, number) {
  if (id) {
    if (isIncompleteAddress(zipcode, street, number)) {
      return 'Atenção!';
    }

    return [street, number].filter(function (i) {
      return !!i;
    }).join(', ');
  }

  return 'Você não possui endereços';
};

var getNeighbourhoodText = function getNeighbourhoodText(id, zipcode, street, number, neighbourhood, city, state) {
  if (id) {
    if (isIncompleteAddress(zipcode, street, number)) {
      return 'Complete seu endereço';
    }

    return [neighbourhood, city, state].filter(function (i) {
      return !!i;
    }).join(', ');
  }
};

var AddressShortInfo = function AddressShortInfo(_ref) {
  var city = _ref.city,
      id = _ref.id,
      neighbourhood = _ref.neighbourhood,
      number = _ref.number,
      onClick = _ref.onClick,
      state = _ref.state,
      street = _ref.street,
      zipcode = _ref.zipcode;
  var addressText = getAddressText(id, zipcode, street, number);
  var neighbourhoodText = getNeighbourhoodText(id, zipcode, street, number, neighbourhood, city, state);
  var linkText = id ? 'Alterar' : 'Adicionar';
  var incompleteAddress = id && isIncompleteAddress(zipcode, street, number);
  var isWithoutAddress = !id;
  return /*#__PURE__*/React.createElement(Content$4, null, incompleteAddress || isWithoutAddress ? /*#__PURE__*/React.createElement(AlertCircleIcon, null) : /*#__PURE__*/React.createElement(AddressIcon, null), /*#__PURE__*/React.createElement(AddressContent, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "body2",
    fontWeight: 600,
    color: "dark"
  }, addressText), /*#__PURE__*/React.createElement(Text$1, {
    size: "caption",
    color: incompleteAddress ? 'dark' : 'grayscale.darker'
  }, neighbourhoodText)), onClick &&
  /*#__PURE__*/
  React.createElement(link, {
    type: "primary",
    onClick: onClick
  }, linkText));
};

AddressShortInfo.propTypes = {
  city: PropTypes__default.string,
  id: PropTypes__default.string,
  neighbourhood: PropTypes__default.string,
  number: PropTypes__default.number,
  onClick: PropTypes__default.func,
  state: PropTypes__default.string,
  street: PropTypes__default.string,
  zipcode: PropTypes__default.string
};

var API_ENDPOINT$2 = function API_ENDPOINT(id) {
  return id ? "/v1.1/addresses/" + id : '/v1.1/addresses';
};
var getAddresses$1 = function getAddresses() {
  return axios.get(API_ENDPOINT$2());
};
var deleteAddress$1 = function deleteAddress(id) {
  return axios["delete"](API_ENDPOINT$2(id));
};

var _templateObject$s, _templateObject2$e, _templateObject3$7;

var basicRadio = function basicRadio(props) {
  return /*#__PURE__*/React.createElement("input", {
    id: props.id,
    className: props.className,
    value: props.value,
    name: props.name,
    checked: props.checked,
    onChange: props.onChange,
    disabled: props.disabled,
    type: "radio"
  });
};

var Input = styled(basicRadio)(_templateObject$s || (_templateObject$s = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n"])));
var InputWrapper = styled.label(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteralLoose(["\n  position: relative;\n  cursor: ", ";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 20px;\n  height: 20px;\n"])), function (props) {
  return props.disabled ? 'initial' : 'pointer';
});
var Checkmark = styled.span(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  box-sizing: content-box;\n  border-radius: 50%;\n  border-color: ", ";\n  border-width: 2px;\n  border-style: solid;\n  opacity: ", ";\n  background-color: ", ";\n\n  &:after {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #6e0ad6;\n    content: '';\n    display: ", ";\n  }\n"])), function (props) {
  return props.checked ? '#6E0AD6' : '#999999';
}, function (props) {
  return props.disabled ? 0.3 : 1;
}, function (props) {
  return props.disabled && !props.checked ? '#d2d2d2' : '#ffffff';
}, function (props) {
  return props.checked ? 'block' : 'none';
});

var RadioButton = function RadioButton(props) {
  return /*#__PURE__*/React.createElement(InputWrapper, {
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement(Input, {
    id: props.id,
    value: props.value,
    name: props.name,
    checked: props.checked,
    onChange: props.onChange,
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement(Checkmark, {
    checked: props.checked,
    disabled: props.disabled
  }));
};

var _templateObject$t, _templateObject2$f;
var Content$5 = styled(View$1)(_templateObject$t || (_templateObject$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  position: relative;\n  border-style: solid;\n  border-width: 0;\n  border-top-width: 1px;\n  border-color: var(--color-neutral-90);\n"])));
var Title$1 = styled(Text$1)(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 14px;\n  color: #898989;\n  background-color: #ffffff;\n  padding: 8px;\n"])));

var ruleWithText = function ruleWithText(props) {
  return /*#__PURE__*/React.createElement(Content$5, props, props.text && /*#__PURE__*/React.createElement(Title$1, null, props.text));
};

ruleWithText.propTypes = {
  text: PropTypes__default.string,
  color: PropTypes__default.string,
  opacity: PropTypes__default.string
};
ruleWithText.defaultProps = {
  color: '#f2f2f2'
};

var _templateObject$u;
var Content$6 = styled(View$1)(_templateObject$u || (_templateObject$u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  cursor: pointer;\n"])));

var Touchable = function Touchable(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Content$6, {
    onClick: onClick
  }, children);
};

Touchable.propTypes = {
  onClick: PropTypes__default.func.isRequired
};

var _templateObject$v, _templateObject2$g, _templateObject3$8, _templateObject4$5, _templateObject5$2;
var AddressContent$1 = styled(View$1)(_templateObject$v || (_templateObject$v = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-shrink: 1;\n  flex-direction: column;\n  padding-left: 16px;\n"])));
var HRuleWrapper = styled(View$1)(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var AddressWrapper = styled(View$1)(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n"])));
var TouchableAddress = styled(Touchable)(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-grow: 1;\n"])));
var EditLink = styled(link)(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding-left: 16px;\n"])));

var AddressOption = function AddressOption(_ref) {
  var id = _ref.id,
      street = _ref.street,
      number = _ref.number,
      neighbourhood = _ref.neighbourhood,
      city = _ref.city,
      state = _ref.state,
      _onClick = _ref.onClick,
      onSelect = _ref.onSelect,
      onPressUpdate = _ref.onPressUpdate,
      isLast = _ref.isLast,
      checked = _ref.checked;
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RadioButton, {
    checked: checked,
    onChange: function onChange() {
      return onSelect(id);
    },
    value: id
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(AddressWrapper, null, /*#__PURE__*/React.createElement(TouchableAddress, {
    onClick: function onClick() {
      return onSelect(id);
    }
  }, /*#__PURE__*/React.createElement(AddressContent$1, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "body2",
    fontWeight: 600
  }, [street, number].filter(function (i) {
    return !!i;
  }).join(', ')), /*#__PURE__*/React.createElement(Text$1, {
    size: "caption",
    color: "grayscale.darker"
  }, neighbourhood), /*#__PURE__*/React.createElement(Text$1, {
    size: "caption",
    color: "grayscale.darker"
  }, [city, state].filter(function (i) {
    return !!i;
  }).join(', '))))), /*#__PURE__*/React.createElement(EditLink, {
    type: "primary",
    onClick: function onClick() {
      if (onPressUpdate) onPressUpdate();

      _onClick(id);
    }
  }, "Editar")), !isLast && /*#__PURE__*/React.createElement(HRuleWrapper, null, /*#__PURE__*/React.createElement(ruleWithText, null))));
};

AddressOption.propTypes = {
  checked: PropTypes__default.bool,
  city: PropTypes__default.string,
  id: PropTypes__default.string,
  isLast: PropTypes__default.bool,
  neighbourhood: PropTypes__default.string,
  number: PropTypes__default.number,
  onClick: PropTypes__default.func,
  onSelect: PropTypes__default.func,
  onPressUpdate: PropTypes__default.func,
  state: PropTypes__default.string,
  street: PropTypes__default.string
};

var AddressOptions = function AddressOptions(_ref2) {
  var addresses = _ref2.addresses,
      onClick = _ref2.onClick,
      onSelect = _ref2.onSelect,
      onPressUpdate = _ref2.onPressUpdate,
      selectedAddressId = _ref2.selectedAddressId;
  return /*#__PURE__*/React.createElement(Col, null, addresses.map(function (address, i) {
    return /*#__PURE__*/React.createElement(AddressOption, _extends({
      key: address.id
    }, address, {
      isLast: i === addresses.length - 1,
      onClick: onClick,
      onSelect: onSelect,
      onPressUpdate: onPressUpdate,
      checked: selectedAddressId === address.id
    }));
  }));
};

AddressOptions.propTypes = {
  addresses: PropTypes__default.array,
  onClick: PropTypes__default.func,
  onSelect: PropTypes__default.func,
  onPressUpdate: PropTypes__default.func,
  selectedAddressId: PropTypes__default.string
};

var _templateObject$w;
var IconWrapper = styled(View$1)(_templateObject$w || (_templateObject$w = _taggedTemplateLiteralLoose(["\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n  display: flex;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});

var Icon = function Icon(_ref) {
  var color = _ref.color,
      width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox,
      svgPath = _ref.svgPath;
  return /*#__PURE__*/React.createElement(IconWrapper, {
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement(SVG, {
    width: width,
    height: height,
    viewBox: viewBox,
    svgPath: svgPath,
    color: color
  }));
};

Icon.propTypes = {
  svgPath: PropTypes__default.string.isRequired,
  color: PropTypes__default.string,
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
Icon.defaultProps = {
  color: '#4a4a4a',
  viewBox: '0 0 24 24',
  width: 48,
  height: 48
};

var plusPath = 'M12.75,11.25 L19,11.25 C19.4142136,11.25 19.75,11.5857864 19.75,12 C19.75,12.4142136 19.4142136,12.75 19,12.75 L12.75,12.75 L12.75,19 C12.75,19.4142136 12.4142136,19.75 12,19.75 C11.5857864,19.75 11.25,19.4142136 11.25,19 L11.25,12.75 L5,12.75 C4.58578644,12.75 4.25,12.4142136 4.25,12 C4.25,11.5857864 4.58578644,11.25 5,11.25 L11.25,11.25 L11.25,5 C11.25,4.58578644 11.5857864,4.25 12,4.25 C12.4142136,4.25 12.75,4.58578644 12.75,5 L12.75,11.25 Z';

var _templateObject$x, _templateObject2$h, _templateObject3$9;
var Row$1 = styled(Row)(_templateObject$x || (_templateObject$x = _taggedTemplateLiteralLoose(["\n  justify-content: flex-start;\n  margin-bottom: 8px;\n"])));
var IconWrapper$1 = styled(View$1)(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteralLoose(["\n  margin-right: 16px;\n"])));
var HRuleWrapper$1 = styled(View$1)(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));

var AddAddress = function AddAddress(props) {
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(HRuleWrapper$1, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(link, {
    type: "primary",
    onClick: function onClick() {
      return props.onClick();
    }
  }, /*#__PURE__*/React.createElement(Row$1, null, /*#__PURE__*/React.createElement(IconWrapper$1, null, /*#__PURE__*/React.createElement(Icon, {
    svgPath: plusPath,
    color: "#4A4A4A",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement(Text$1, null, "Adicionar endere\xE7o"))));
};

AddAddress.propTypes = {
  onClick: PropTypes__default.func.isRequired
};

var _templateObject$y, _templateObject2$i, _templateObject3$a, _templateObject4$6, _templateObject5$3;
var Wrapper$1 = styled(View$1)(_templateObject$y || (_templateObject$y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  z-index: 1;\n  position: fixed;\n  bottom: 0;\n  ", "\n"])), function (_ref) {
  var alignment = _ref.alignment;
  return alignment + ": 0px";
});
var fadeUpAnimation = keyframes(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 0;\n    transform: translate(0, 100%);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n"])));
var FadeUp = styled(View$1)(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteralLoose(["\n  animation: 0.5s ", ";\n"])), fadeUpAnimation);
var fadeDownAnimation = keyframes(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 1;\n    transform: none;\n  }\n  100% {\n    opacity: 0;\n    transform: translate(0, 100%);\n  }\n"])));
var FadeDown = styled(View$1)(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n  animation: 0.5s ", ";\n  animation-fill-mode: forwards;\n"])), fadeDownAnimation);

var Fade = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Fade, _React$Component);

  function Fade(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      unmount: !props.show
    };
    return _this;
  }

  var _proto = Fade.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var previousShow = prevProps.show;
    var show = this.props.show;

    if (previousShow && !show) {
      setTimeout(function () {
        return _this2.setState({
          unmount: true
        });
      }, 1000);
    }
  };

  Fade.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.show && state.unmount) {
      return {
        unmount: false
      };
    }

    return null;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        show = _this$props.show,
        children = _this$props.children,
        alignment = _this$props.alignment;
    var unmount = this.state.unmount;

    if (unmount) {
      return null;
    }

    if (show) {
      return /*#__PURE__*/React.createElement(Wrapper$1, {
        alignment: alignment
      }, /*#__PURE__*/React.createElement(FadeUp, null, children));
    }

    return /*#__PURE__*/React.createElement(Wrapper$1, {
      alignment: alignment
    }, /*#__PURE__*/React.createElement(FadeDown, null, children));
  };

  return Fade;
}(React.Component);

Fade.defaultProps = {
  alignment: 'left'
};
Fade.propTypes = {
  alignment: PropTypes__default.oneOf(['left', 'right']),
  show: PropTypes__default.bool
};

var _templateObject$z, _templateObject2$j, _templateObject3$b;
var Content$7 = styled(View$1)(_templateObject$z || (_templateObject$z = _taggedTemplateLiteralLoose(["\n  background-color: #f6f6f6;\n  padding: 24px;\n  flex-direction: column;\n  width: 100%;\n"])));
var Row$2 = styled(View$1)(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 24px;\n"])));
var ButtonWrapper = styled(View$1)(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-left: 24px;\n"])));

var AddressDeletionConfirmation = function AddressDeletionConfirmation(_ref) {
  var onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm;
  return /*#__PURE__*/React.createElement(Content$7, null, /*#__PURE__*/React.createElement(Text$1, {
    fontWeight: 600
  }, "Excluir este endere\xE7o?"), /*#__PURE__*/React.createElement(Row$2, null, /*#__PURE__*/React.createElement(link, {
    type: "primary",
    underline: false,
    onClick: onCancel
  }, "Cancelar"), /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(Button$1, {
    size: "small",
    fluid: true,
    onClick: onConfirm
  }, "Sim, excluir"))));
};

AddressDeletionConfirmation.propTypes = {
  onCancel: PropTypes__default.func,
  onConfirm: PropTypes__default.func
};

var _templateObject$A, _templateObject2$k, _templateObject3$c, _templateObject4$7, _templateObject5$4, _templateObject6$1, _templateObject7$1;
var AddressOptionsTitle = styled(Title)(_templateObject$A || (_templateObject$A = _taggedTemplateLiteralLoose(["\n  margin-bottom: 0.78em;\n  display: flex;\n"])));
var AddressTitle = styled(Title)(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteralLoose(["\n  margin-bottom: 0.78em;\n  margin-top: 0.78em;\n  font-size: 20px;\n  display: flex;\n"])));
var HRuleWrapper$2 = styled(ruleWithText)(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"])));
var LeftArea = styled.button(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  max-width: 50px;\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  top: -40px;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var Relative = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var FormWrapper$1 = styled(View$1)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 94px;\n  ", "\n"])), function (_ref) {
  var isCommonAddress = _ref.isCommonAddress;
  return isCommonAddress && "\n      margin-bottom: 32px;\n  ";
});
var DeletionConfirmationWrapper = styled(View$1)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  z-index: 99999;\n"])));
var defaultState = {
  isEditing: false,
  editingAddress: {},
  deletionConfirmationOpen: false,
  disableForm: false
};

var isIncompleteAddress$1 = function isIncompleteAddress(_ref2) {
  var street = _ref2.street,
      number = _ref2.number,
      zipcode = _ref2.zipcode;
  return !(street && number && zipcode);
};

var leftArrowSvgPath = 'M5.81 12.75l4.72 4.72a.75.75 0 0 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 1.06l-4.72 4.72H20a.75.75 0 1 1 0 1.5H5.81z';

var AddressSelectionStack = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AddressSelectionStack, _React$Component);

  function AddressSelectionStack(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.componentDidUpdate = function (prevProps) {
      var _this$props$screenPro = _this.props.screenProps,
          currentSelectedAddress = _this$props$screenPro.selectedAddress,
          currentAddresses = _this$props$screenPro.addresses;
      var _prevProps$screenProp = prevProps.screenProps,
          prevSelectedAddress = _prevProps$screenProp.selectedAddress,
          prevAddresses = _prevProps$screenProp.addresses;
      var hasAddressesChanged = prevAddresses !== currentAddresses;
      var hasSelectedAddressChanged = currentSelectedAddress !== prevSelectedAddress;

      if (hasAddressesChanged || hasSelectedAddressChanged) {
        _this.setState(_extends({}, defaultState, _this.getUpdatedState(currentSelectedAddress, currentAddresses)), _this.closeDeleteConfirmation);
      }
    };

    _this.onFormOpen = function (addressId) {
      var selectedAddress = _this.state.selectedAddress;
      if (!addressId && !selectedAddress) _this.setState({
        selectedAddress: {
          main: false
        }
      });
      var addresses = _this.state.addresses;
      var address = addresses.find(function (a) {
        return a.id === addressId;
      });

      _this.setState({
        editingAddress: address
      }, _this.openEditionMode);
    };

    _this.onSuccess = function (response) {
      var _this$props$screenPro2 = _this.props.screenProps,
          onCreate = _this$props$screenPro2.onCreate,
          onUpdate = _this$props$screenPro2.onUpdate;
      var selectedAddress = _this.state.selectedAddress;
      var isUpdate = Boolean(_this.state.editingAddress);

      _this.setState({
        isEditing: false
      }, function () {
        if (selectedAddress && isUpdate) {
          onUpdate(response);
        } else {
          onCreate(response);
        }
      });
    };

    _this.onDelete = function () {
      var onDelete = _this.props.screenProps.onDelete;
      var editingAddress = _this.state.editingAddress;
      onDelete(editingAddress.id);
    };

    _this.onAddAddress = function () {
      var onPressCreate = _this.props.screenProps.onPressCreate;

      _this.onFormOpen(null);

      if (onPressCreate) onPressCreate();
    };

    _this.onUpdateAddress = function (addressId) {
      var onPressUpdate = _this.props.screenProps.onPressUpdate;

      _this.onFormOpen(addressId);

      if (onPressUpdate) onPressUpdate();
    };

    _this.getUpdatedState = function (selectedAddress, addresses) {
      if (selectedAddress && isIncompleteAddress$1(selectedAddress)) {
        return {
          screenToRender: 'IncompleteAddress',
          selectedAddress: selectedAddress
        };
      }

      if (selectedAddress && addresses && addresses.length) {
        return {
          screenToRender: 'AddressOptions',
          addresses: addresses,
          selectedAddress: selectedAddress
        };
      }

      return {
        screenToRender: 'IncompleteAddress',
        addresses: addresses,
        selectedAddress: {
          main: true
        }
      };
    };

    _this.selectAddressById = function (addressId) {
      var addresses = _this.state.addresses;
      var onSelect = _this.props.screenProps.onSelect;
      var address = addresses.find(function (a) {
        return a.id === addressId;
      });
      if (!address) return;

      _this.setState({
        selectedAddress: address
      });

      onSelect(address);
    };

    _this.openDeleteConfirmation = function (event) {
      event.preventDefault();
      var onPressDelete = _this.props.screenProps.onPressDelete;

      _this.setState({
        deletionConfirmationOpen: true,
        disableForm: true
      }, function () {
        if (onPressDelete) onPressDelete();
      });
    };

    _this.closeDeleteConfirmation = function () {
      _this.setState({
        deletionConfirmationOpen: false,
        disableForm: false
      });
    };

    _this.openEditionMode = function () {
      _this.setState({
        isEditing: true
      });
    };

    _this.closeEditionMode = function () {
      _this.setState({
        isEditing: false,
        deletionConfirmationOpen: false,
        disableForm: false
      });
    };

    _this.isCommonAddress = function (id, main) {
      return id && !main ? '32px' : '94px';
    };

    _this.renderEligibleScreen = function () {
      var _this$state = _this.state,
          screenToRender = _this$state.screenToRender,
          selectedAddress = _this$state.selectedAddress,
          addresses = _this$state.addresses,
          isEditing = _this$state.isEditing,
          editingAddress = _this$state.editingAddress,
          disableForm = _this$state.disableForm,
          deletionConfirmationOpen = _this$state.deletionConfirmationOpen;
      var deletionConfirmationWidth = _this.props.screenProps.deletionConfirmationWidth;
      var id = selectedAddress.id,
          main = selectedAddress.main;

      var _ref3 = editingAddress || {},
          editingId = _ref3.id,
          editingMain = _ref3.main;

      var title = editingId && editingMain ? 'Endereço Principal' : 'Endereço';
      title = editingAddress && editingId ? title : 'Novo Endereço';

      switch (screenToRender) {
        case 'IncompleteAddress':
          return selectedAddress && /*#__PURE__*/React.createElement(FormWrapper$1, {
            style: {
              marginBottom: _this.isCommonAddress(id, main)
            }
          }, /*#__PURE__*/React.createElement(AddressTitle, null, title), /*#__PURE__*/React.createElement(HRuleWrapper$2, null), /*#__PURE__*/React.createElement(AddressForm, _extends({}, selectedAddress, {
            onSuccess: _this.onSuccess,
            isOnAdInsertion: true,
            isFirstAddress: !addresses || addresses.length === 0
          })));

        case 'AddressOptions':
          return /*#__PURE__*/React.createElement(View$1, null, selectedAddress && !isEditing && addresses && /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(AddressOptionsTitle, null, "Endere\xE7os"), /*#__PURE__*/React.createElement(HRuleWrapper$2, null), /*#__PURE__*/React.createElement(AddressOptions, {
            addresses: addresses,
            selectedAddressId: id,
            onClick: _this.onUpdateAddress,
            onSelect: _this.selectAddressById
          }), addresses.length < 5 && /*#__PURE__*/React.createElement(AddAddress, {
            onClick: _this.onAddAddress
          })), isEditing && /*#__PURE__*/React.createElement(FormWrapper$1, {
            style: {
              marginBottom: _this.isCommonAddress(id, main)
            }
          }, /*#__PURE__*/React.createElement(Relative, null, /*#__PURE__*/React.createElement(LeftArea, {
            onClick: _this.closeEditionMode
          }, /*#__PURE__*/React.createElement(SVG, {
            svgPath: leftArrowSvgPath,
            height: 24,
            width: 24,
            color: "#4A4A4A"
          }))), /*#__PURE__*/React.createElement(AddressTitle, null, title), /*#__PURE__*/React.createElement(HRuleWrapper$2, null), /*#__PURE__*/React.createElement(AddressForm, _extends({}, editingAddress, {
            onSuccess: _this.onSuccess,
            onDeleteClick: _this.openDeleteConfirmation,
            disabled: disableForm,
            isOnAdInsertion: true
          })), /*#__PURE__*/React.createElement(Fade, {
            show: deletionConfirmationOpen
          }, /*#__PURE__*/React.createElement(DeletionConfirmationWrapper, {
            style: {
              width: deletionConfirmationWidth || '424px'
            }
          }, /*#__PURE__*/React.createElement(AddressDeletionConfirmation, {
            onCancel: _this.closeDeleteConfirmation,
            onConfirm: _this.onDelete
          })))));

        default:
          return null;
      }
    };

    var screenProps = props.screenProps;
    var _addresses = screenProps.addresses,
        _selectedAddress = screenProps.selectedAddress;
    _this.state = _extends({}, defaultState, {
      addresses: _addresses,
      selectedAddress: _selectedAddress
    });
    _this.state = _this.getUpdatedState(_selectedAddress, _addresses);
    return _this;
  }

  var _proto = AddressSelectionStack.prototype;

  _proto.render = function render() {
    return this.renderEligibleScreen();
  };

  return AddressSelectionStack;
}(React.Component);

AddressSelectionStack.propTypes = {
  screenProps: PropTypes__default.object
};

var _templateObject$B, _templateObject2$l, _templateObject3$d;
var SideContainer = styled(View$1)(_templateObject$B || (_templateObject$B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  overflow-y: scroll;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  padding-left: 3em;\n  padding-right: 3em;\n  background-color: #fff;\n  z-index: -1;\n\n  &.sidebar-enter {\n    z-index: 99999;\n    transform: translate3d(100vw, 0, 0);\n  }\n\n  &.sidebar-enter-active {\n    z-index: 99999;\n    transform: translate(0);\n    transition: transform 0.3s linear;\n  }\n\n  &.sidebar-enter-done {\n    z-index: 99999;\n  }\n\n  &.sidebar-exit {\n    z-index: 99999;\n    transform: translate(0);\n  }\n\n  &.sidebar-exit-active {\n    z-index: 99999;\n    transform: translate3d(100vw, 0, 0);\n    transition: transform 0.3s linear;\n  }\n\n  &.hide-scroll-on-scrolling::-webkit-scrollbar {\n    display: none;\n  }\n\n  &.hide-scroll-on-scrolling {\n    -ms-overflow-style: none;\n  }\n"])));
var CrossRuler = styled(View$1)(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row-reverse;\n  border-radius: 31px;\n  width: 100%;\n  height: 24px;\n  right: 0;\n  margin-top: 4em;\n"])));
var CrossHolder = styled(View$1)(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteralLoose(["\n  width: 24px;\n  height: 24px;\n"])));

var compareAddress = function compareAddress(a, b) {
  if (a.main) return -1;
  if (b.main) return 1;
  if (a.id < b.id) return -1;
  if (a.id > b.id) return 1;
  return 0;
};

var AddressSideSheet = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AddressSideSheet, _Component);

  function AddressSideSheet(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onCreate = function (_ref) {
      var address = _ref.data;
      var _this$state$addresses = _this.state.addresses,
          addresses = _this$state$addresses === void 0 ? [] : _this$state$addresses;
      var addressCount = addresses.length;

      _this.setState({
        addresses: [address].concat(addresses)
      }, function () {
        _this.hideSideBar();

        if (addressCount === 0) {
          _this.selectAddress(address);
        }

        _this.showSuccessMessage('Endereço adicionado!');
      });
    };

    _this.onDelete = function (id) {
      var _this$state = _this.state,
          addresses = _this$state.addresses,
          selectedAddressId = _this$state.selectedAddressId;
      deleteAddress$1(id).then(function () {
        _this.setState({
          addresses: addresses.filter(function (a) {
            return a.id !== id;
          })
        }, function () {
          _this.hideSideBar();

          if (selectedAddressId === id) {
            _this.selectAddress(_this.getMainAddress());
          }

          _this.showSuccessMessage('Endereço excluído!');
        });
      })["catch"](function () {
        return null;
      });
    };

    _this.onUpdate = function (_ref2) {
      var address = _ref2.data;
      var addresses = _this.state.addresses;

      _this.setState({
        addresses: addresses.map(function (a) {
          if (a.id === address.id) {
            return address;
          }

          if (a.main && address.main) {
            return _extends({}, a, {
              main: false
            });
          }

          return a;
        })
      }, function () {
        _this.selectAddress(address);

        _this.hideSideBar();

        _this.showSuccessMessage(address.main ? 'Endereço principal atualizado!' : 'Endereço atualizado!');
      });
    };

    _this.getMainAddress = function () {
      var addresses = _this.state.addresses;
      return addresses.find(function (a) {
        return a.main;
      });
    };

    _this.isWindowDesktop = function (width) {
      return width >= 800;
    };

    _this.handleResize = function () {
      _this.setState({
        isDesktop: _this.isWindowDesktop(window.innerWidth)
      });
    };

    _this.fetchAddresses = function () {
      var _this$props = _this.props,
          onError = _this$props.onError,
          addresses = _this$props.addresses;

      _this.setState({
        loading: true
      });

      if (addresses && _this.Mounted) {
        if (addresses.length > 0) {
          _this.setState({
            addresses: addresses,
            loading: false
          }, function () {
            return _this.selectAddress(_this.getMainAddress());
          });
        } else _this.setState({
          addresses: [],
          loading: false
        });
      } else {
        getAddresses$1().then(function (_ref3) {
          var _ref3$data = _ref3.data,
              data = _ref3$data === void 0 ? [] : _ref3$data;

          if (_this.Mounted) {
            _this.setState({
              loading: false,
              addresses: data.sort(compareAddress)
            }, function () {
              return _this.selectAddress(_this.getMainAddress());
            });
          }
        })["catch"](function (err) {
          _this.setState({
            addresses: addresses || []
          });

          if (typeof onError === 'function') {
            onError('Could not load address', err);
          }
        });
      }
    };

    _this.selectAddress = function (address) {
      if (!address) return;
      var onSelect = _this.props.onSelect;
      var id = address.id,
          zipcode = address.zipcode,
          street = address.street,
          neighbourhood = address.neighbourhood,
          city = address.city,
          number = address.number,
          state = address.state,
          main = address.main;

      _this.setState({
        selectedAddressId: id,
        zipcode: zipcode,
        neighbourhood: neighbourhood,
        city: city,
        number: number,
        state: state,
        street: street,
        main: main
      }, function () {
        if (typeof onSelect === 'function') {
          onSelect(address);
        }
      });
    };

    _this.selectAddressById = function (addressId) {
      var addresses = _this.state.addresses;
      var address = addresses.find(function (a) {
        return a.id === addressId;
      });
      if (!address) return;

      _this.selectAddress(address);
    };

    _this.showSideBar = function () {
      return _this.setState({
        isSideBarVisible: true
      });
    };

    _this.hideSideBar = function () {
      return _this.setState({
        isSideBarVisible: false
      });
    };

    _this.showSuccessMessage = function (successMessage) {
      setTimeout(function () {
        return _this.setState({
          successMessage: successMessage,
          successMessageOpen: true
        });
      }, 100);
    };

    _this.shouldHaveFixedWidth = function (should) {
      return should ? {
        width: '424px'
      } : {
        maxWidth: '424px'
      };
    };

    _this.Mounted = false;
    var _selectedAddressId = props.selectedAddressId,
        _addresses = props.addresses,
        accessToken = props.accessToken;

    if (accessToken) {
      setAuthHeader(accessToken);
    }

    _this.state = {
      addresses: _addresses,
      selectedAddressId: _selectedAddressId,
      loading: false,
      isSideBarVisible: false,
      isDesktop: _this.isWindowDesktop(window.innerWidth)
    };
    _this.isWindowDesktop = _this.isWindowDesktop.bind(_assertThisInitialized(_this));
    _this.fetchAddresses = _this.fetchAddresses.bind(_assertThisInitialized(_this));
    _this.selectAddress = _this.selectAddress.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = AddressSideSheet.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.Mounted = true;
    this.fetchAddresses();
    window.addEventListener('resize', this.handleResize);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.Mounted = false;
    window.addEventListener('resize', this.handleResize);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$state2 = this.state,
        loading = _this$state2.loading,
        isSideBarVisible = _this$state2.isSideBarVisible,
        street = _this$state2.street,
        number = _this$state2.number,
        zipcode = _this$state2.zipcode,
        neighbourhood = _this$state2.neighbourhood,
        city = _this$state2.city,
        state = _this$state2.state,
        main = _this$state2.main,
        selectedAddressId = _this$state2.selectedAddressId,
        addresses = _this$state2.addresses,
        successMessage = _this$state2.successMessage,
        successMessageOpen = _this$state2.successMessageOpen,
        isDesktop = _this$state2.isDesktop;
    return !loading && /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(AddressShortInfo, {
      id: selectedAddressId,
      street: street,
      zipcode: zipcode,
      number: number,
      neighbourhood: neighbourhood,
      city: city,
      state: state,
      onClick: this.showSideBar
    }), /*#__PURE__*/React.createElement(Portal, {
      targetRef: document.body
    }, /*#__PURE__*/React.createElement(CSSTransition, {
      timeout: 300,
      "in": isSideBarVisible,
      classNames: "sidebar"
    }, /*#__PURE__*/React.createElement(SideContainer, {
      style: this.shouldHaveFixedWidth(isDesktop),
      className: "hide-scroll-on-scrolling"
    }, isSideBarVisible && /*#__PURE__*/React.createElement(CrossRuler, null, /*#__PURE__*/React.createElement(CrossHolder, {
      onClick: function onClick() {
        return _this2.hideSideBar();
      }
    }, /*#__PURE__*/React.createElement(Cross, null))), isSideBarVisible && !loading && /*#__PURE__*/React.createElement(AddressSelectionStack, {
      screenProps: {
        addresses: addresses,
        onCreate: this.onCreate,
        onDelete: this.onDelete,
        onSelect: this.selectAddress,
        onUpdate: this.onUpdate,
        selectedAddress: {
          id: selectedAddressId,
          street: street,
          zipcode: zipcode,
          number: number,
          neighbourhood: neighbourhood,
          city: city,
          state: state,
          main: main
        }
      }
    }))), /*#__PURE__*/React.createElement(CSSTransition, {
      timeout: 500,
      "in": isSideBarVisible,
      classNames: "fade"
    }, /*#__PURE__*/React.createElement(Backdrop, {
      open: isSideBarVisible,
      onClick: function onClick() {
        return _this2.hideSideBar();
      }
    }))), /*#__PURE__*/React.createElement(SuccessMessage, {
      text: successMessage,
      show: successMessageOpen,
      onClose: function onClose() {
        return _this2.setState({
          successMessageOpen: false
        });
      }
    }));
  };

  return AddressSideSheet;
}(Component$2);
AddressSideSheet.propTypes = {
  addresses: PropTypes__default.array,
  selectedAddressId: PropTypes__default.string,
  onSelect: PropTypes__default.func,
  onError: PropTypes__default.func,
  accessToken: PropTypes__default.string
};

var _templateObject$C, _templateObject2$m, _templateObject3$e, _templateObject4$8, _templateObject5$5, _templateObject6$2, _templateObject7$2, _templateObject8$1;
var leftArrowSvgPath$1 = 'M5.81 12.75l4.72 4.72a.75.75 0 0 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 1.06l-4.72 4.72H20a.75.75 0 1 1 0 1.5H5.81z';
var closeSvgPath = 'M13.06 12l5.47 5.47a.75.75 0 0 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 1.06-1.06L12 10.94l5.47-5.47a.7    5.75 0 0 1 1.06 1.06L13.06 12z';
var TitleBar = styled(View$1)(_templateObject$C || (_templateObject$C = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  height: 32px;\n"])));
var LeftArea$1 = styled.button(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n"])));
var RightArea = styled.div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  justify-content: flex-end;\n  background: transparent;\n"])));
var Close = styled.a(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteralLoose(["\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var HeaderWrapper = styled.div(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  height: 32px;\n"])));
var Body = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n  padding: 16px;\n"])));
var BottomSheetContainer = styled(BottomSheet$1)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n  & [data-rsbs-header] {\n    box-shadow: none !important;\n    padding-bottom: 0;\n  }\n\n  & [data-rsbs-overlay] {\n    height: auto !important;\n    max-height: calc(100% - 24px);\n  }\n\n  & [data-rsbs-header]:before {\n    background-color: transparent !important;\n  }\n"])));

var BottomSheet = function BottomSheet(props) {
  var open = props.open,
      onClose = props.onClose,
      onLeftClick = props.onLeftClick,
      children = props.children,
      footer = props.footer,
      bodyStyle = props.bodyStyle,
      showCloseButton = props.showCloseButton,
      showBackButton = props.showBackButton;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, null), /*#__PURE__*/React.createElement(BottomSheetContainer, {
    open: open,
    footer: footer,
    onDismiss: onClose,
    snapPoints: function snapPoints(_ref) {
      var maxHeight = _ref.maxHeight;
      return maxHeight - 32;
    },
    "data-testid": "bottom-sheet"
  }, /*#__PURE__*/React.createElement(Body, {
    style: bodyStyle
  }, /*#__PURE__*/React.createElement(TitleBar, null, showBackButton && /*#__PURE__*/React.createElement(LeftArea$1, {
    href: null,
    onClick: onLeftClick
  }, /*#__PURE__*/React.createElement(SVG, {
    svgPath: leftArrowSvgPath$1,
    height: 24,
    width: 24,
    color: "#4A4A4A",
    viewBox: "0 0 24 24"
  })), showCloseButton && /*#__PURE__*/React.createElement(RightArea, null, /*#__PURE__*/React.createElement(Close, {
    href: null,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(SVG, {
    svgPath: closeSvgPath,
    height: 24,
    width: 24,
    color: "#4A4A4A",
    viewBox: "0 0 24 24"
  })))), children)));
};

BottomSheet.defaultProps = {
  showBackButton: false,
  showCloseButton: true
};
BottomSheet.propTypes = {
  bodyStyle: PropTypes__default.objectOf({}),
  open: PropTypes__default.bool,
  onClose: PropTypes__default.func,
  onLeftClick: PropTypes__default.func,
  showBackButton: PropTypes__default.bool,
  showCloseButton: PropTypes__default.bool,
  footer: PropTypes__default.elementType
};
var GlobalStyles = createGlobalStyle(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n  [data-rsbs-overlay] {\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    display: flex;\n    background: #fff;\n    background: var(--rsbs-bg, #fff);\n    flex-direction: column;\n    height: 0px;\n    height: var(--rsbs-overlay-h, 0px);\n    transform: translate3d(0, 0px, 0);\n    transform: translate3d(0, var(--rsbs-overlay-translate-y, 0px), 0);\n    will-change: height;\n  }\n\n  [data-rsbs-overlay]:focus {\n    outline: none;\n  }\n\n  [data-rsbs-is-blocking='false'] [data-rsbs-overlay] {\n    box-shadow: 0 -5px 60px 0 rgba(38, 89, 115, 0.11), 0 -1px 0 rgba(38, 89, 115, 0.05);\n  }\n\n  [data-rsbs-overlay],\n  [data-rsbs-root]:after {\n    max-width: auto;\n    max-width: var(--rsbs-max-w, auto);\n    margin-left: env(safe-area-inset-left);\n    margin-left: var(--rsbs-ml, env(safe-area-inset-left));\n    margin-right: env(safe-area-inset-right);\n    margin-right: var(--rsbs-mr, env(safe-area-inset-right));\n  }\n\n  [data-rsbs-overlay],\n  [data-rsbs-backdrop],\n  [data-rsbs-root]:after {\n    z-index: 3;\n    -ms-scroll-chaining: none;\n    overscroll-behavior: none;\n    touch-action: none;\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-touch-callout: none;\n  }\n\n  [data-rsbs-backdrop] {\n    top: -60px;\n    bottom: -60px;\n    background-color: rgba(0, 0, 0, 0.6);\n    background-color: var(--rsbs-backdrop-bg, rgba(0, 0, 0, 0.6));\n    will-change: opacity;\n    cursor: pointer;\n    opacity: 1;\n  }\n\n  [data-rsbs-is-dismissable='false'] [data-rsbs-backdrop] {\n    cursor: ns-resize;\n  }\n\n  [data-rsbs-root]:after {\n    content: '';\n    pointer-events: none;\n    background: #fff;\n    background: var(--rsbs-bg, #fff);\n    height: 1px;\n    transform-origin: bottom;\n    transform: scale3d(1, 0, 1);\n    transform: scale3d(1, var(--rsbs-antigap-scale-y, 0), 1);\n    will-change: transform;\n  }\n\n  [data-rsbs-footer],\n  [data-rsbs-header] {\n    flex-shrink: 0;\n    cursor: ns-resize;\n    padding: 16px;\n  }\n\n  [data-rsbs-header] {\n    text-align: center;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    box-shadow: 0 1px 0 rgba(46, 59, 66, calc(1 * 0.125));\n    box-shadow: 0 1px 0 rgba(46, 59, 66, calc(var(--rsbs-content-opacity, 1) * 0.125));\n    z-index: 1;\n    padding-top: calc(20px + env(safe-area-inset-top));\n    padding-bottom: 8px;\n  }\n\n  [data-rsbs-header]:before {\n    position: absolute;\n    content: '';\n    display: block;\n    width: 36px;\n    height: 4px;\n    top: calc(8px + env(safe-area-inset-top));\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: 2px;\n    background-color: hsla(0, 0%, 0%, 0.14);\n    background-color: var(--rsbs-handle-bg, hsla(0, 0%, 0%, 0.14));\n  }\n\n  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {\n    [data-rsbs-header]:before {\n      transform: translateX(-50%) scaleY(0.75);\n    }\n  }\n\n  [data-rsbs-has-header='false'] [data-rsbs-header] {\n    box-shadow: none;\n    padding-top: calc(12px + env(safe-area-inset-top));\n  }\n\n  [data-rsbs-scroll] {\n    flex-shrink: 1;\n    flex-grow: 1;\n    -webkit-tap-highlight-color: revert;\n    -webkit-touch-callout: revert;\n    -webkit-user-select: auto;\n    -ms-user-select: auto;\n    -moz-user-select: auto;\n    user-select: auto;\n    overflow: auto;\n    -ms-scroll-chaining: none;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  [data-rsbs-scroll]:focus {\n    outline: none;\n  }\n\n  [data-rsbs-has-footer='false'] [data-rsbs-content] {\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n\n  [data-rsbs-content] {\n    overflow: hidden;\n  }\n\n  [data-rsbs-footer] {\n    box-shadow: 0 -1px 0 rgba(46, 59, 66, calc(1 * 0.125)), 0 2px 0 #fff;\n    box-shadow: 0 -1px 0 rgba(46, 59, 66, calc(var(--rsbs-content-opacity, 1) * 0.125)), 0 2px 0 var(--rsbs-bg, #fff);\n    overflow: hidden;\n    z-index: 1;\n    padding-bottom: calc(16px + env(safe-area-inset-bottom));\n  }\n\n  [data-rsbs-is-dismissable='true'] [data-rsbs-header] > *,\n  [data-rsbs-is-dismissable='true'] [data-rsbs-scroll] > *,\n  [data-rsbs-is-dismissable='true'] [data-rsbs-footer] > *,\n  [data-rsbs-is-dismissable='false'][data-rsbs-state='opening'] [data-rsbs-header] > *,\n  [data-rsbs-is-dismissable='false'][data-rsbs-state='closing'] [data-rsbs-header] > *,\n  [data-rsbs-is-dismissable='false'][data-rsbs-state='opening'] [data-rsbs-scroll] > *,\n  [data-rsbs-is-dismissable='false'][data-rsbs-state='closing'] [data-rsbs-scroll] > *,\n  [data-rsbs-is-dismissable='false'][data-rsbs-state='opening'] [data-rsbs-footer] > *,\n  [data-rsbs-is-dismissable='false'][data-rsbs-state='closing'] [data-rsbs-footer] > * {\n    opacity: 1;\n    opacity: var(--rsbs-content-opacity, 1);\n  }\n\n  [data-rsbs-is-dismissable='true'] [data-rsbs-backdrop],\n  [data-rsbs-is-dismissable='false'][data-rsbs-state='opening'] [data-rsbs-backdrop],\n  [data-rsbs-is-dismissable='false'][data-rsbs-state='closing'] [data-rsbs-backdrop] {\n    opacity: 1;\n    opacity: var(--rsbs-backdrop-opacity, 1);\n  }\n\n  [data-rsbs-state='closed'],\n  [data-rsbs-state='closing'] {\n    pointer-events: none;\n  }\n"])));

var _templateObject$D, _templateObject2$n, _templateObject3$f, _templateObject4$9, _templateObject5$6;
var Content$8 = styled(View$1)(_templateObject$D || (_templateObject$D = _taggedTemplateLiteralLoose(["\n  background-color: #fff;\n  padding: 32px 24px;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  left: 50%;\n  border-radius: 10px;\n  width: ", ";\n  @media (max-width: 440px) {\n    width: 90%;\n  }\n"])), function (_ref) {
  var widthSize = _ref.widthSize;
  return widthSize ? widthSize + "px" : '400px';
});
var TitleBar$1 = styled(View$1)(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  height: 32px;\n"])));
var LeftArea$2 = styled.button(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteralLoose(["\n  margin-right: auto;\n  font-size: 18px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n"])));
var RightArea$1 = styled.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n"])));
var Close$1 = styled(Link$2)(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteralLoose([""])));

var internalClose = function internalClose(onClose) {
  return function (event) {
    event.preventDefault();
    onClose();
  };
};

var rootId = 'modalRoot';
var leftArrowSvgPath$2 = 'M5.81 12.75l4.72 4.72a.75.75 0 0 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 1.06l-4.72 4.72H20a.75.75 0 1 1 0 1.5H5.81z';
var closeSvgPath$1 = 'M13.06 12l5.47 5.47a.75.75 0 0 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 1.06-1.06L12 10.94l5.47-5.47a.7    5.75 0 0 1 1.06 1.06L13.06 12z';

var Modal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Modal, _React$Component);

  function Modal() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.el = document.createElement('div');
    this.root = document.getElementById(rootId);

    if (!this.root) {
      this.root = document.createElement('div');
      this.root.id = rootId;
      document.body.appendChild(this.root);
    }

    this.root.appendChild(this.el);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.root.removeChild(this.el);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        onClose = _this$props.onClose,
        open = _this$props.open,
        onLeftClick = _this$props.onLeftClick,
        showBackButton = _this$props.showBackButton,
        showCloseButton = _this$props.showCloseButton,
        widthSize = _this$props.widthSize;
    return /*#__PURE__*/React.createElement(Backdrop, {
      open: open
    }, /*#__PURE__*/React.createElement(Content$8, {
      widthSize: widthSize
    }, /*#__PURE__*/React.createElement(TitleBar$1, null, showBackButton && /*#__PURE__*/React.createElement(LeftArea$2, {
      href: "#",
      onClick: onLeftClick
    }, /*#__PURE__*/React.createElement(SVG, {
      svgPath: leftArrowSvgPath$2,
      height: 24,
      width: 24,
      color: "#4A4A4A",
      viewBox: "0 0 24 24"
    })), showCloseButton && /*#__PURE__*/React.createElement(RightArea$1, null, /*#__PURE__*/React.createElement(Close$1, {
      href: "#",
      onClick: internalClose(onClose)
    }, /*#__PURE__*/React.createElement(SVG, {
      svgPath: closeSvgPath$1,
      height: 24,
      width: 24,
      color: "#4A4A4A",
      viewBox: "0 0 24 24"
    })))), children));
  };

  return Modal;
}(React.Component);

Modal.defaultProps = {
  open: true,
  widthSize: null,
  showCloseButton: true
};
Modal.propTypes = {
  onClose: PropTypes__default.func,
  onLeftClick: PropTypes__default.func,
  open: PropTypes__default.bool,
  showBackButton: PropTypes__default.bool,
  showCloseButton: PropTypes__default.bool,
  widthSize: PropTypes__default.string
};

var isMobile = (function () {
  if (typeof window === 'undefined') {
    return false;
  }

  var userAgent = typeof window.navigator === 'undefined' ? '' : window.navigator.userAgent;
  return Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
});

var _templateObject$E;
var Content$9 = styled(View$1)(_templateObject$E || (_templateObject$E = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  justify-content: center;\n"])));

var Container$1 = function Container(props) {
  return isMobile() ? /*#__PURE__*/React.createElement(BottomSheet, props) : /*#__PURE__*/React.createElement(Modal, props);
};

var compareAddress$1 = function compareAddress(a, b) {
  if (a.main) return -1;
  if (b.main) return 1;
  if (a.id < b.id) return -1;
  if (a.id > b.id) return 1;
  return 0;
};

var AddressManager = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AddressManager, _React$Component);

  function AddressManager(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onCreate = function (_ref) {
      var address = _ref.data;
      var _this$state$addresses = _this.state.addresses,
          addresses = _this$state$addresses === void 0 ? [] : _this$state$addresses;
      var updatedAddresses = address.main ? addresses.map(function (a) {
        return _extends({}, a, {
          main: false
        });
      }) : addresses;

      _this.setState({
        addresses: [address].concat(updatedAddresses).sort(compareAddress$1)
      }, function () {
        _this.selectAddress(address);

        _this.closeModal();

        _this.showSuccessMessage('Endereço adicionado!');
      });

      if (_this.props.onCreate) _this.props.onCreate(address);
    };

    _this.onDelete = function (id) {
      var _this$state = _this.state,
          addresses = _this$state.addresses,
          selectedAddress = _this$state.selectedAddress;
      var onDelete = _this.props.onDelete;
      deleteAddress$1(id).then(function () {
        _this.setState({
          addresses: addresses.filter(function (a) {
            return a.id !== id;
          })
        }, function () {
          if (selectedAddress.id === id) {
            _this.selectAddress(_this.getMainAddress());
          }

          if (onDelete) onDelete();
        });
      })["catch"](function () {
        return null;
      });
    };

    _this.onUpdate = function (_ref2) {
      var address = _ref2.data;
      var addresses = _this.state.addresses;

      _this.setState({
        addresses: addresses.map(function (a) {
          if (a.id === address.id) return address;
          if (a.main && address.main) return _extends({}, a, {
            main: false
          });
          return a;
        }).sort(compareAddress$1)
      }, function () {
        _this.selectAddress(address);

        _this.closeModal();

        _this.showSuccessMessage('Endereço atualizado com sucesso!');
      });

      if (_this.props.onUpdate) _this.props.onUpdate(address);
    };

    _this.onSelect = function (selectedAddress) {
      var addresses = _this.state.addresses;
      var address = addresses.find(function (a) {
        return a.id === selectedAddress.id;
      });

      _this.selectAddress(address);

      _this.closeModal();

      _this.showSuccessMessage('Endereço alterado com sucesso!');
    };

    _this.getMainAddress = function () {
      var addresses = _this.state.addresses;
      return addresses.find(function (a) {
        return a.main;
      });
    };

    _this.selectAddress = function (address) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          selectedAddressProp = _this$props.selectedAddress;

      var callOnSelect = function callOnSelect() {
        return onSelect(address);
      };

      if (selectedAddressProp && selectedAddressProp.id === address.id) {
        callOnSelect();
      } else {
        _this.setState({
          selectedAddress: address
        }, callOnSelect);
      }
    };

    _this.closeModal = function () {
      _this.setState({
        modalOpen: false
      });
    };

    _this.openModal = function () {
      var onModalOptionsOpen = _this.props.onModalOptionsOpen;

      _this.setState({
        modalOpen: true
      });

      if (onModalOptionsOpen) onModalOptionsOpen();
    };

    _this.showSuccessMessage = function (successMessage) {
      setTimeout(function () {
        return _this.setState({
          successMessage: successMessage,
          successMessageOpen: true
        });
      }, 100);
    };

    _this.closeSuccessMessage = function () {
      _this.setState({
        successMessageOpen: false
      });
    };

    _this.fetchAddresses = function () {
      var _this$props2 = _this.props,
          onError = _this$props2.onError,
          selectedAddressProp = _this$props2.selectedAddress;

      _this.setState({
        loading: true
      });

      getAddresses$1().then(function (_ref3) {
        var _ref3$data = _ref3.data,
            data = _ref3$data === void 0 ? [] : _ref3$data;

        _this.setState({
          loading: false,
          addresses: data.sort(compareAddress$1)
        }, function () {
          if (!selectedAddressProp) _this.selectAddress(_this.getMainAddress());
        });
      })["catch"](function (err) {
        if (typeof onError === 'function') {
          onError('Could not load address', err);
        }
      });
    };

    _this.state = {
      loading: true,
      modalOpen: false,
      addresses: [],
      successMessage: '',
      successMessageOpen: false,
      selectedAddress: {}
    };
    return _this;
  }

  var _proto = AddressManager.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.fetchAddresses();
  };

  AddressManager.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var selectedAddressProp = props.selectedAddress;
    var selectedAddress = state.selectedAddress;

    if (selectedAddress && selectedAddressProp && selectedAddressProp !== selectedAddress) {
      return {
        selectedAddress: selectedAddressProp
      };
    }

    return null;
  };

  _proto.render = function render() {
    var _this$state2 = this.state,
        addresses = _this$state2.addresses,
        loading = _this$state2.loading,
        modalOpen = _this$state2.modalOpen,
        successMessage = _this$state2.successMessage,
        successMessageOpen = _this$state2.successMessageOpen,
        selectedAddress = _this$state2.selectedAddress;
    var _this$props3 = this.props,
        onPressCreate = _this$props3.onPressCreate,
        onPressDelete = _this$props3.onPressDelete,
        onPressUpdate = _this$props3.onPressUpdate,
        ShortInfoComponent = _this$props3.ShortInfoComponent;
    if (loading && !ShortInfoComponent) return null;
    return /*#__PURE__*/React.createElement(Content$9, null, ShortInfoComponent ? /*#__PURE__*/React.createElement(ShortInfoComponent, {
      address: selectedAddress,
      onClick: this.openModal,
      loading: loading
    }) : /*#__PURE__*/React.createElement(AddressShortInfo, _extends({}, selectedAddress, {
      onClick: this.openModal
    })), /*#__PURE__*/React.createElement(Container$1, {
      open: modalOpen,
      onClose: this.closeModal
    }, /*#__PURE__*/React.createElement(AddressSelectionStack, {
      screenProps: {
        addresses: addresses,
        selectedAddress: selectedAddress,
        open: modalOpen,
        isFirstAddress: false,
        deletionConfirmationWidth: '100%',
        onClose: this.closeModal,
        onCreate: this.onCreate,
        onDelete: this.onDelete,
        onSelect: this.onSelect,
        onUpdate: this.onUpdate,
        onPressCreate: onPressCreate,
        onPressUpdate: onPressUpdate,
        onPressDelete: onPressDelete
      }
    })), /*#__PURE__*/React.createElement(SuccessMessage, {
      text: successMessage,
      show: successMessageOpen,
      onClose: this.closeSuccessMessage
    }));
  };

  return AddressManager;
}(React.Component);
AddressManager.propTypes = {
  onSelect: PropTypes__default.func.isRequired,
  onError: PropTypes__default.func,
  onPressCreate: PropTypes__default.func,
  onPressDelete: PropTypes__default.func,
  onPressUpdate: PropTypes__default.func,
  onCreate: PropTypes__default.func,
  onUpdate: PropTypes__default.func,
  onDelete: PropTypes__default.func,
  onModalOptionsOpen: PropTypes__default.func,
  selectedAddress: PropTypes__default.shape({
    id: PropTypes__default.string,
    zipcode: PropTypes__default.string,
    street: PropTypes__default.string,
    number: PropTypes__default.number,
    complement: PropTypes__default.string,
    neighbourhood: PropTypes__default.string,
    city: PropTypes__default.string,
    state: PropTypes__default.string,
    reference: PropTypes__default.string,
    main: PropTypes__default.bool
  }),
  ShortInfoComponent: PropTypes__default.elementType
};

var _templateObject$F, _templateObject2$o, _templateObject3$g, _templateObject4$a, _templateObject5$7;
var Nav = styled.nav(_templateObject$F || (_templateObject$F = _taggedTemplateLiteralLoose([""])));
var Ul = styled.ul(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  margin: var(--spacing-0-5) 0;\n"])));
var Li$1 = styled.li(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteralLoose(["\n  margin: 0;\n"])));
var LinkBoxOfSideMenuItem = styled(Link$2)(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteralLoose(["\n  font-weight: var(--font-weight-regular);\n  width: 100%;\n  height: 48px;\n  padding-left: var(--spacing-4);\n  justify-content: flex-start;\n\n  color: var(--color-neutral-130);\n\n  & > svg {\n    margin-right: var(--spacing-3);\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &[aria-current='page'] {\n    color: var(--color-secondary-100);\n    background-color: #f3eef5;\n    border-radius: 25px;\n  }\n"])));
var SideMenuWrapper = styled.div(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 287px;\n"])));
var SideMenu = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(SideMenu, _React$PureComponent);

  function SideMenu(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      selectedMenu: props.selectedMenu
    };
    return _this;
  }

  var _proto = SideMenu.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var selectedMenu = this.state.selectedMenu;

    var clickMenu = function clickMenu(ev, menuSelection) {
      ev.preventDefault();

      _this2.setState({
        selectedMenu: menuSelection
      });

      window.location.href = window.location.origin + "/" + menuSelection;
    };

    var myAccount = 'meu-cadastro';
    var security = 'seguranca';
    var payments = 'pagamentos';
    var comunications = 'comunicacoes';
    var myLevel = 'meu-nivel';
    return /*#__PURE__*/React.createElement(SideMenuWrapper, null, /*#__PURE__*/React.createElement(Nav, this.props, /*#__PURE__*/React.createElement(Ul, null, /*#__PURE__*/React.createElement(Li$1, null, /*#__PURE__*/React.createElement(LinkBoxOfSideMenuItem, {
      onClick: function onClick(ev) {
        return clickMenu(ev, myAccount);
      },
      href: "/" + myAccount,
      "aria-current": selectedMenu === myAccount ? 'page' : 'false',
      size: "medium"
    }, /*#__PURE__*/React.createElement(Clipboard, {
      width: 24,
      height: 24
    }), "Meu cadastro")), /*#__PURE__*/React.createElement(Li$1, null, /*#__PURE__*/React.createElement(LinkBoxOfSideMenuItem, {
      onClick: function onClick(ev) {
        return clickMenu(ev, security);
      },
      href: "/" + security,
      "aria-current": selectedMenu === security ? 'page' : 'false',
      size: "medium"
    }, /*#__PURE__*/React.createElement(Shield, {
      width: 24,
      height: 24
    }), "Seguran\xE7a e privacidade")), /*#__PURE__*/React.createElement(Li$1, null, /*#__PURE__*/React.createElement(LinkBoxOfSideMenuItem, {
      onClick: function onClick(ev) {
        return clickMenu(ev, payments);
      },
      href: "/" + payments,
      "aria-current": selectedMenu === payments ? 'page' : 'false',
      size: "medium"
    }, /*#__PURE__*/React.createElement(CreditCard, {
      width: 24,
      height: 24
    }), "Pagamentos")), /*#__PURE__*/React.createElement(Li$1, null, /*#__PURE__*/React.createElement(LinkBoxOfSideMenuItem, {
      onClick: function onClick(ev) {
        return clickMenu(ev, comunications);
      },
      href: "/" + comunications,
      "aria-current": selectedMenu === comunications ? 'page' : 'false',
      size: "medium"
    }, /*#__PURE__*/React.createElement(Bell, {
      width: 24,
      height: 24
    }), "Comunica\xE7\xF5es")), /*#__PURE__*/React.createElement(Li$1, null, /*#__PURE__*/React.createElement(LinkBoxOfSideMenuItem, {
      onClick: function onClick(ev) {
        return clickMenu(ev, myLevel);
      },
      href: "/" + myLevel,
      "aria-current": selectedMenu === myLevel ? 'page' : 'false',
      size: "medium"
    }, /*#__PURE__*/React.createElement(Award, {
      width: 24,
      height: 24
    }), "Meu n\xEDvel")))));
  };

  return SideMenu;
}(React.PureComponent);
SideMenu.defaultProps = {
  selectedMenu: 'meu-cadastro'
};
SideMenu.propTypes = {
  selectedMenu: PropTypes__default.string
};

var CheckedSvgPath = 'M4.53 12.47a.75.75 0 0 0-1.06 1.06l5 5a.75.75 0 0 0 1.06 0l11-11a.75.75 0 0 0-1.06-1.06L9 16.94l-4.47-4.47z';

var _templateObject$G;
var Content$a = styled(View$1)(_templateObject$G || (_templateObject$G = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));

var TextWithCheck = function TextWithCheck(_ref) {
  var render = _ref.render;
  return /*#__PURE__*/React.createElement(Content$a, null, /*#__PURE__*/React.createElement(SVG, {
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    svgPath: CheckedSvgPath,
    color: "#4A4A4A"
  }), render());
};

TextWithCheck.propTypes = {
  render: PropTypes__default.func.isRequired
};

var _templateObject$H;
var SvgElement = styled.svg(_templateObject$H || (_templateObject$H = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  padding: 0;\n  cursor: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.onClick ? 'pointer' : 'initial';
});

var Svg = function Svg(props) {
  var onClick = props.onClick,
      className = props.className,
      config = props.config;
  var viewBox = config.viewBox,
      width = config.width,
      height = config.height,
      paths = config.paths,
      polylines = config.polylines,
      rects = config.rects,
      fill = config.fill,
      stroke = config.stroke,
      strokeWidth = config.strokeWidth,
      strokeLinecap = config.strokeLinecap,
      strokeLinejoin = config.strokeLinejoin;
  var pathElements = paths ? paths.map(function (_ref, i) {
    var path = _ref.path,
        color = _ref.color,
        transform = _ref.transform;
    return /*#__PURE__*/React.createElement("path", {
      key: i,
      fill: color,
      d: path,
      transform: transform
    });
  }) : null;
  var polylineElements = polylines ? polylines.map(function (points, i) {
    return /*#__PURE__*/React.createElement("polyline", {
      key: i,
      points: points
    });
  }) : null;
  var rectElements = rects ? rects.map(function (_ref2, i) {
    var _x = _ref2.x,
        _y = _ref2.y,
        _width = _ref2.width,
        _height = _ref2.height,
        _stroke = _ref2.stroke,
        _strokeWidth = _ref2.strokeWidth,
        _strokeLinecap = _ref2.strokeLinecap,
        _strokeLinejoin = _ref2.strokeLinejoin;
    return /*#__PURE__*/React.createElement("rect", {
      key: i,
      x: _x,
      y: _y,
      width: _width,
      height: _height,
      stroke: _stroke,
      strokeWidth: _strokeWidth,
      strokeLinecap: _strokeLinecap,
      strokeLinejoin: _strokeLinejoin
    });
  }) : null;
  return /*#__PURE__*/React.createElement(SvgElement, {
    onClick: onClick,
    className: className,
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin
  }, pathElements, polylineElements, rectElements);
};

Svg.propTypes = {
  className: PropTypes__default.string,
  onClick: PropTypes__default.func,
  config: PropTypes__default.object
};

var sellConfig = {
  viewBox: '0 0 146 80',
  width: '146',
  height: '80',
  paths: [{
    color: 'none',
    path: 'M0 0h146v80H0z'
  }, {
    color: '#A822B5',
    path: 'M17.163 79.353c-2.444-.444-2.508-1.12-3.002-6.38-.13-1.378-2.122-13.232-2.362-15.436a.902.902 0 0 1 1.793-.196c.24 2.215 2.233 14.078 2.363 15.463.23 2.443.357 3.788.59 4.369.093.229.103.252.94.405 2.042.37 6.274-.778 6.412-1.54.235-1.294-1.423-9.342-1.777-10.987-.232-1.072.892-6.119.833-7.037a.9.9 0 1 1 1.798-.118c.051.786-1.087 5.77-.87 6.774.392 1.817 2.089 10.044 1.79 11.691-.467 2.571-6.644 3.33-8.508 2.992'
  }, {
    color: '#A822B5',
    path: 'M23.544 59.608a.902.902 0 0 1-.693-1.179c2.363-6.939 6.16-9.984 11.284-9.052.935.17 4.42 1.876 10.502 4.877 6.403 3.158 14.37 7.09 16.273 7.435.56.102.641.095 2.173-.194 1.067-.201 2.791-.526 5.778-.993C66.575 44.5 64.115 25.664 62.9 6.225c-11.418 2.351-14.246 5.264-19.725 10.91-2.707 2.787-6.074 6.257-11.375 10.612a.896.896 0 0 1-.45.197C3.697 31.74 2.732 37.058 1.957 41.33c-.975 5.372 2.687 8.993 5.705 9.542 1.842.334 3.893-.091 5.877-.504a50.53 50.53 0 0 1 1.958-.38c3.223-.541 6.465-1.233 9.6-1.902 2.719-.58 5.53-1.181 8.307-1.677a.901.901 0 1 1 .316 1.776c-2.747.49-5.543 1.088-8.248 1.666-3.154.673-6.415 1.37-9.677 1.916-.616.103-1.248.235-1.89.368-2.152.448-4.378.91-6.565.513-4.333-.789-8.243-5.654-7.156-11.64.876-4.832 1.967-10.841 30.67-14.817 5.11-4.215 8.388-7.593 11.03-10.314 5.712-5.887 8.86-9.13 21.682-11.625a.9.9 0 0 1 1.072.832c1.206 20.098 3.778 39.61 6.133 56.046a.901.901 0 0 1-.755 1.02c-3.507.535-5.443.9-6.6 1.118-1.55.293-1.918.362-2.828.196-1.997-.362-8.2-3.375-16.748-7.592-4.349-2.146-9.277-4.577-10.027-4.72-4.17-.758-7.197 1.813-9.256 7.86a.9.9 0 0 1-1.013.596'
  }, {
    color: '#A822B5',
    path: 'M12.494 58.147a.903.903 0 0 1-.695-.605c-.493-1.493-.855-2.95-1.206-4.358l-.201-.806a.9.9 0 1 1 1.748-.44l.202.81c.359 1.439.696 2.798 1.17 4.228a.902.902 0 0 1-1.018 1.17M1.86 39.498a.901.901 0 0 1-.013-1.773c1.779-.348 3.612-.659 5.384-.958 1.76-.298 3.578-.605 5.332-.95a.902.902 0 0 1 .347 1.772c-1.777.348-3.608.658-5.379.957a209.98 209.98 0 0 0-5.337.95.895.895 0 0 1-.335.002M1.547 44.484a.901.901 0 0 1-.078-1.758c2.183-.6 4.422-.964 6.588-1.317 1.744-.284 3.548-.577 5.266-.99a.902.902 0 1 1 .42 1.755c-1.783.428-3.62.727-5.396 1.016-2.12.346-4.31.702-6.4 1.277a.911.911 0 0 1-.4.017M3.204 49.235a.901.901 0 0 1-.026-1.77c3.364-.713 6.679-1.613 9.884-2.483a.902.902 0 0 1 .471 1.741c-3.229.877-6.568 1.783-9.98 2.507a.917.917 0 0 1-.349.005M65.34 62.76a.902.902 0 0 1-.73-.758c-1.41-9.699-2.353-19.54-3.264-29.058-.837-8.74-1.703-17.776-2.927-26.653a.903.903 0 0 1 1.787-.247c1.228 8.915 2.095 17.97 2.934 26.728.91 9.496 1.85 19.315 3.253 28.97a.902.902 0 0 1-1.053 1.018M33.919 50.758a.903.903 0 0 1-.735-.8c-.149-1.503-.427-2.997-.696-4.44-.29-1.565-.592-3.183-.74-4.857-.12-1.328-.186-2.63-.251-3.89-.076-1.458-.154-2.966-.311-4.485-.067-.652-.207-1.294-.344-1.916-.235-1.079-.48-2.195-.361-3.415a.902.902 0 0 1 .984-.81.908.908 0 0 1 .81.984c-.091.938.113 1.87.329 2.856.146.67.298 1.362.375 2.115.161 1.565.24 3.097.318 4.578.064 1.243.13 2.528.245 3.823.142 1.588.435 3.163.718 4.686.276 1.481.561 3.013.718 4.594a.903.903 0 0 1-1.059.977M67.731 40.406a.903.903 0 0 1-.487-1.514c.632-.655 2.13-2.726 2.473-4.609.582-3.213-1.138-6.378-4.091-7.528a.904.904 0 0 1-.514-1.168.9.9 0 0 1 1.167-.513c3.756 1.462 5.948 5.47 5.211 9.532-.404 2.225-2.023 4.578-2.948 5.538a.899.899 0 0 1-.81.262M72.595 25.221a.903.903 0 0 1-.505-1.495l2.733-3.016a.9.9 0 0 1 1.273-.06.903.903 0 0 1 .06 1.275l-2.733 3.016a.898.898 0 0 1-.828.28M73.484 31.76a.902.902 0 0 1 .322-1.775c.877.16 1.794-.022 2.766-.214.393-.078.783-.154 1.169-.21a.901.901 0 1 1 .255 1.786c-.355.051-.713.123-1.075.194-1.043.207-2.223.44-3.437.22M77.292 41.797c-1.013-.185-1.847-.687-2.652-1.171-.503-.302-.976-.587-1.47-.783a.902.902 0 0 1 .665-1.677c.63.25 1.191.587 1.732.913.7.42 1.359.817 2.047.942a.902.902 0 0 1-.322 1.776M109.44 1.4c-2.376.013-3.184.204-4.12.426-.358.084-.728.172-1.202.253-9.98 1.722-11.784 5.802-11.744 13.218.052 9.424 4.057 10.467 7.93 11.477 3.144.818 6.393 1.665 6.424 7.188.003.626-.047 1.28-.148 1.937 1.799-1.34 3.396-3.648 3.517-6.482.013-.3.25-.542.55-.56 9.54-.596 15.922-6.456 15.878-14.58-.053-9.574-9.236-12.92-17.084-12.877m-3.706 36.304a.588.588 0 0 1-.57-.735c.26-1.003.396-2.04.39-3-.026-4.621-2.461-5.256-5.546-6.06-3.899-1.015-8.75-2.28-8.807-12.606-.026-4.591.711-7.473 2.464-9.634C95.58 3.307 98.839 1.8 103.918.922c.439-.075.791-.159 1.133-.24.963-.227 1.874-.443 4.383-.456 8.39-.046 18.206 3.604 18.263 14.044.047 8.503-6.698 14.91-16.466 15.721-.323 3.218-2.335 6.181-5.235 7.65a.584.584 0 0 1-.261.063'
  }, {
    color: '#A822B5',
    path: 'M109.442 1.626c-2.352.013-3.148.2-4.07.42-.364.085-.737.173-1.217.255C94.335 3.996 92.56 8.007 92.6 15.296c.051 9.25 3.971 10.272 7.762 11.259 3.075.8 6.561 1.71 6.592 7.406.003.459-.023.933-.076 1.413 1.79-1.518 2.898-3.71 2.995-5.966a.81.81 0 0 1 .76-.776c9.415-.589 15.711-6.357 15.667-14.355-.023-4.293-1.878-7.609-5.512-9.853-2.96-1.828-6.972-2.816-11.345-2.798zm-3.168 34.781l.084-.542c.1-.65.148-1.29.144-1.902-.029-5.35-3.053-6.137-6.254-6.971-3.956-1.031-8.047-2.096-8.1-11.694-.022-4.262.624-6.919 2.163-8.884 1.774-2.265 4.878-3.713 9.768-4.556.468-.081.832-.168 1.185-.25.953-.226 1.772-.42 4.176-.433 4.428-.013 8.553.992 11.584 2.865 3.722 2.299 5.702 5.838 5.726 10.235.045 8.253-6.421 14.203-16.09 14.807a.36.36 0 0 0-.338.345c-.11 2.565-1.458 5.052-3.607 6.652l-.44.328zM109.598.451h-.163c-2.48.014-3.379.226-4.33.45-.348.083-.705.167-1.148.243-5.023.867-8.237 2.35-10.117 4.667-1.716 2.118-2.438 4.956-2.413 9.49.055 10.153 4.814 11.394 8.639 12.39 3.052.795 5.688 1.481 5.715 6.277.005.978-.133 2.036-.399 3.058a.361.361 0 0 0 .35.452h.001a.36.36 0 0 0 .162-.039c2.834-1.435 4.793-4.298 5.112-7.47l.019-.187.187-.016c9.618-.8 16.304-7.171 16.259-15.495-.026-4.69-2.011-8.313-5.902-10.764C118.44 1.534 114.193.45 109.598.45zm-3.866 37.478a.814.814 0 0 1-.786-1.017c.256-.984.39-2.001.384-2.943-.025-4.447-2.27-5.032-5.377-5.84-3.974-1.037-8.92-2.326-8.977-12.825-.026-4.647.727-7.572 2.515-9.777 1.951-2.408 5.253-3.94 10.39-4.827.432-.074.78-.157 1.117-.237.98-.23 1.903-.45 4.435-.462h.165c4.68 0 9.01 1.106 12.212 3.124 3.973 2.503 6.086 6.357 6.112 11.144.047 8.515-6.724 15.045-16.487 15.93-.39 3.25-2.422 6.167-5.337 7.643a.801.801 0 0 1-.362.087h-.004z'
  }, {
    color: '#A822B5',
    path: 'M102.329 11.443c.052.65.113 1.303.172 1.94.081.865.165 1.756.225 2.647a36.846 36.846 0 0 0 1.772-.155 35.587 35.587 0 0 1 2.034-.17 312.85 312.85 0 0 1-.05-1.308c-.037-.978-.074-1.983-.13-2.975-.58.024-1.185.037-1.832.04a81.779 81.779 0 0 1-2.191-.02zm-.15 5.783a.586.586 0 0 1-.588-.554c-.06-1.06-.16-2.138-.257-3.18-.08-.853-.163-1.735-.223-2.612a.587.587 0 0 1 .162-.446.566.566 0 0 1 .438-.181c1.123.03 1.988.04 2.803.036a48.847 48.847 0 0 0 2.357-.067.585.585 0 0 1 .617.548c.077 1.193.122 2.409.165 3.583.024.633.048 1.265.076 1.896a.589.589 0 0 1-.58.613c-.847.007-1.703.095-2.53.181-.79.081-1.606.166-2.43.183h-.01z'
  }, {
    color: '#A822B5',
    path: 'M102.574 11.673c.045.553.097 1.105.148 1.645.078.838.154 1.656.213 2.473.514-.034 1.034-.088 1.54-.14.56-.058 1.189-.124 1.823-.16l-.041-1.085c-.035-.916-.069-1.838-.118-2.75-.515.018-1.05.03-1.618.032-.597.002-1.22-.001-1.947-.015zm-.057 4.595l-.016-.222c-.06-.889-.143-1.776-.224-2.638-.062-.671-.122-1.31-.173-1.948l-.02-.248.25.005c.831.018 1.523.024 2.185.02a50.623 50.623 0 0 0 1.824-.04l.222-.01.012.222c.056.988.093 1.987.13 2.96l.06 1.551-.225.01c-.697.032-1.4.105-2.02.17a37.2 37.2 0 0 1-1.784.155l-.221.013zm-.832-5.79a.343.343 0 0 0-.249.112.36.36 0 0 0-.1.274c.06.87.141 1.742.22 2.585.1 1.065.2 2.143.26 3.21.01.192.169.341.36.341h.012c.81-.016 1.62-.1 2.403-.18.834-.087 1.692-.176 2.555-.183a.362.362 0 0 0 .358-.378c-.028-.631-.052-1.265-.075-1.897-.045-1.177-.09-2.389-.166-3.578a.364.364 0 0 0-.38-.337 48.33 48.33 0 0 1-2.368.067c-.832.005-1.7-.006-2.81-.035h-.02zm.49 6.974a.812.812 0 0 1-.81-.768 84.61 84.61 0 0 0-.256-3.171 108.7 108.7 0 0 1-.223-2.617.813.813 0 0 1 .84-.868 90.31 90.31 0 0 0 2.787.035 49.07 49.07 0 0 0 2.346-.066.801.801 0 0 1 .853.759c.078 1.194.123 2.41.167 3.585.023.636.047 1.268.075 1.898a.815.815 0 0 1-.805.849c-.841.007-1.688.094-2.507.18-.797.082-1.617.167-2.449.184h-.017z'
  }, {
    color: '#A822B5',
    path: 'M104.296 21.462a.587.587 0 0 1-.51-.882c.884-1.523 1.87-2.974 2.822-4.377l.176-.259a.587.587 0 0 1 .97.66l-.176.259c-.94 1.386-1.915 2.82-2.778 4.307a.586.586 0 0 1-.504.292'
  }, {
    color: '#A822B5',
    path: 'M107.27 15.913a.358.358 0 0 0-.3.159l-.175.258c-.951 1.4-1.934 2.847-2.814 4.363a.363.363 0 0 0 .312.544h.002c.128 0 .247-.07.31-.18.865-1.491 1.839-2.925 2.78-4.31l.183-.27a.363.363 0 0 0-.298-.564zm-2.977 5.775a.815.815 0 0 1-.702-1.222c.888-1.53 1.876-2.984 2.831-4.39l.176-.258a.808.808 0 0 1 1.127-.216c.37.252.467.758.215 1.129l-.176.26c-.944 1.39-1.912 2.816-2.769 4.292a.815.815 0 0 1-.697.405h-.005zM110.273 11.024c.052.652.112 1.304.172 1.94.081.866.165 1.757.225 2.649a36.994 36.994 0 0 0 1.772-.156 35.587 35.587 0 0 1 2.034-.17c-.018-.436-.035-.871-.05-1.308-.037-.977-.074-1.983-.13-2.975-.581.024-1.185.037-1.832.04a81.976 81.976 0 0 1-2.191-.02zm-.15 5.784a.587.587 0 0 1-.589-.554c-.058-1.06-.16-2.138-.256-3.18-.08-.853-.163-1.735-.223-2.612a.587.587 0 0 1 .6-.627c1.123.03 1.988.04 2.803.036a48.904 48.904 0 0 0 2.356-.066.58.58 0 0 1 .617.547c.078 1.193.123 2.408.166 3.584.024.632.047 1.264.076 1.894a.59.59 0 0 1-.581.615c-.846.006-1.702.095-2.53.18-.788.081-1.605.166-2.43.183h-.009z'
  }, {
    color: '#A822B5',
    path: 'M110.517 11.255c.047.567.1 1.134.153 1.689.074.798.15 1.612.21 2.43.498-.033.997-.085 1.522-.14.576-.06 1.206-.125 1.84-.161l-.041-1.086c-.035-.919-.069-1.84-.118-2.75-.515.02-1.05.03-1.618.033-.597.003-1.22-.002-1.948-.015zm-.057 4.595l-.015-.222c-.06-.888-.143-1.775-.224-2.638-.06-.642-.121-1.296-.173-1.948l-.02-.249.25.006c.832.018 1.523.025 2.185.02a49.19 49.19 0 0 0 1.823-.04l.223-.01.012.222c.055.985.092 1.983.128 2.954l.061 1.557-.224.01c-.696.032-1.4.105-2.021.17-.624.064-1.199.123-1.783.156l-.222.012zm-.815-5.79a.375.375 0 0 0-.266.112.365.365 0 0 0-.1.275c.06.874.143 1.754.223 2.606l.006.062c.096 1.023.194 2.083.252 3.127.01.191.169.34.36.34h.012c.802-.016 1.606-.1 2.383-.178.857-.09 1.719-.178 2.575-.185a.364.364 0 0 0 .358-.38 244.99 244.99 0 0 1-.075-1.895c-.045-1.196-.09-2.399-.167-3.577-.012-.201-.181-.338-.379-.338a48.64 48.64 0 0 1-2.368.067c-.834.003-1.7-.006-2.81-.035h-.004zm.475 6.974a.811.811 0 0 1-.81-.767c-.057-1.036-.156-2.09-.25-3.111l-.007-.06c-.08-.855-.163-1.74-.223-2.618a.818.818 0 0 1 .223-.618c.155-.161.376-.228.604-.25 1.11.028 1.973.04 2.8.035a49.3 49.3 0 0 0 2.346-.066.802.802 0 0 1 .853.76c.077 1.183.122 2.39.166 3.556.024.664.048 1.296.076 1.926a.82.82 0 0 1-.222.595.817.817 0 0 1-.581.254c-.837.007-1.687.094-2.51.18-.81.083-1.622.166-2.448.184h-.017z'
  }, {
    color: '#A822B5',
    path: 'M112.24 21.044a.588.588 0 0 1-.51-.882c.884-1.523 1.869-2.974 2.822-4.377l.175-.259a.586.586 0 1 1 .97.66l-.175.259c-.941 1.386-1.915 2.82-2.778 4.307a.587.587 0 0 1-.504.292'
  }, {
    color: '#A822B5',
    path: 'M115.213 15.495a.36.36 0 0 0-.3.159l-.174.257c-.95 1.398-1.93 2.842-2.814 4.364a.363.363 0 0 0 .13.495c.057.032.114.064.184.048.128 0 .246-.07.31-.18.869-1.497 1.844-2.932 2.787-4.32l.175-.259a.362.362 0 0 0-.298-.564zm-2.977 5.775a.813.813 0 0 1-.701-1.222c.892-1.536 1.878-2.987 2.831-4.39l.175-.258a.808.808 0 0 1 1.128-.215c.37.251.466.757.215 1.128l-.176.259c-.938 1.382-1.909 2.81-2.769 4.293a.816.816 0 0 1-.698.405h-.005zM130.496 43.215c-5.709.184-9.214 6.236-9.214 10.494 0 5.4 4.296 11.23 11.237 11.23 6.797 0 11.362-5.992 11.362-11.587 0-4.887-4.02-10.146-12.847-10.146-.18 0-.36.003-.538.009m2.023 23.529c-7.19 0-13.04-5.847-13.04-13.035 0-2.692 1.098-5.686 2.937-8.008 2.112-2.667 4.96-4.19 8.02-4.29h.002c.198-.006.396-.01.596-.01 7.28 0 14.65 4.106 14.65 11.95 0 6.468-5.29 13.393-13.165 13.393'
  }, {
    color: '#A822B5',
    path: 'M132.13 60.117c-1.16 0-2.32-.322-3.265-.908a.902.902 0 0 1 .948-1.535 4.444 4.444 0 0 0 2.317.638c1.764 0 2.843-1.004 2.98-1.359-.021-.659-.539-.863-2.639-1.071-1.967-.196-4.94-.491-5.02-3.675v-.097c0-2.77 2.822-4.033 5.443-4.033.507 0 .991.048 1.44.143a.901.901 0 0 1-.368 1.766 5.35 5.35 0 0 0-1.072-.104c-1.463 0-3.64.594-3.64 2.228.036 1.493 1.062 1.744 3.396 1.976 1.8.178 4.263.423 4.263 2.91 0 1.414-2.133 3.12-4.783 3.12z'
  }, {
    color: '#A822B5',
    path: 'M132.935 62.245a.902.902 0 0 1-.888-.754c-.105-.635-.105-1.349-.105-1.923a.902.902 0 1 1 1.803 0c0 .534 0 1.14.08 1.627a.901.901 0 0 1-.89 1.05M131.536 49.818a.902.902 0 0 1-.874-.684c-.196-.788-.4-1.603-.4-2.461a.902.902 0 1 1 1.803 0c0 .637.168 1.31.346 2.024a.903.903 0 0 1-.875 1.12'
  }]
};

var SellIcon = function SellIcon() {
  return /*#__PURE__*/React.createElement(Svg, {
    config: sellConfig
  });
};

var _templateObject$I;
var max = 'max-width';
var min = 'min-width';
var mediaQueryConfig = [{
  label: 'doubleExtraLarge',
  size: 1200,
  query: min
}, {
  label: 'extraLarge',
  size: 1200,
  query: max
}, {
  label: 'large',
  size: 992,
  query: max
}, {
  label: 'medium',
  size: 768,
  query: max
}, {
  label: 'small',
  size: 576,
  query: max
}, {
  label: 'fontMax',
  size: 1024,
  query: max
}, {
  label: 'fontMin',
  size: 360,
  query: min
}, {
  label: 'desktop',
  size: 576,
  query: min
}];
var mediaQuery = mediaQueryConfig.reduce(function (acc, item) {
  var label = item.label,
      size = item.size,
      query = item.query;
  var emSize = size / 16;

  acc[label] = function () {
    return css(_templateObject$I || (_templateObject$I = _taggedTemplateLiteralLoose(["\n    @media (", ": ", "em) {\n      ", "\n    }\n  "])), query, emSize, css.apply(void 0, arguments));
  };

  return acc;
}, {});
var breakpoints = {
  mobile: 599,
  tablet: 839
};

var _templateObject$J, _templateObject2$p, _templateObject3$h, _templateObject4$b, _templateObject5$8, _templateObject6$3, _templateObject7$3, _templateObject8$2, _templateObject9$1, _templateObject10$1, _templateObject11, _templateObject12;
var fontH1 = css(_templateObject$J || (_templateObject$J = _taggedTemplateLiteralLoose(["\n  line-height: ", "px;\n  font-size: 36px;\n  font-size: calc(24px + (36 - 24) * ((100vw - 360px) / (1024 - 360)));\n  ", ";\n  ", ";\n"])), 36 * 1.333, mediaQuery.fontMax(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteralLoose(["font-size: 36px;"]))), mediaQuery.fontMin(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteralLoose(["font-size: 24px;"]))));
var fontH2 = css(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteralLoose(["\n  line-height: ", "px;\n  font-size: 24px;\n  font-size: calc(20px + (24 - 20) * ((100vw - 360px) / (1024 - 360)));\n  ", ";\n  ", ";\n"])), 24 * 1.333, mediaQuery.fontMax(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteralLoose(["font-size: 36px;"]))), mediaQuery.fontMin(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["font-size: 24px;"]))));
var fontH3 = css(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n  line-height: ", "px;\n  font-size: 20px;\n  font-size: calc(16px + (20 - 16) * ((100vw - 360px) / (1024 - 360)));\n  ", ";\n  ", ";\n"])), 20 * 1.333, mediaQuery.fontMax(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["font-size: 20px;"]))), mediaQuery.fontMin(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["font-size: 16px;"]))));
var fontBase = css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n  line-height: ", "px;\n  font-size: 16px;\n"])), 16 * 1.5);
var fontSemiSmall = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  line-height: ", "px;\n  font-size: 14px;\n"])), 14 * 1.5);
var fontSmall = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  line-height: ", "px;\n  font-size: 12px;\n"])), 12 * 1.333);

var _templateObject$K, _templateObject2$q;

var _excluded$6 = ["inverted"],
    _excluded2 = ["inverted"],
    _excluded3 = ["href", "width", "height", "inverted", "renderIcon", "text", "onClick"];

var _Text = function _Text(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  return /*#__PURE__*/React.createElement(Text$1, props);
};

var LinkText = styled(_Text)(_templateObject$K || (_templateObject$K = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  flex-direction: row;\n  color: ", ";\n"])), function (props) {
  return props.inverted ? '#f28000' : '#ffffff';
});

var LINK$1 = function LINK(_ref2) {
  var props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement("a", props);
};

var Anchor = styled(LINK$1)(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  background-color: ", ";\n  border-radius: 30px;\n  ", ";\n  font-weight: 700;\n  text-align: center;\n  user-select: none;\n  border: 1px solid ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.inverted ? '#ffffff' : '#f28000';
}, fontSemiSmall, function (props) {
  return props.inverted ? '#f28000' : 'transparent';
});

var LinkButton = function LinkButton(props) {
  var href = props.href,
      width = props.width,
      height = props.height,
      inverted = props.inverted,
      renderIcon = props.renderIcon,
      text = props.text,
      onClick = props.onClick,
      rest = _objectWithoutPropertiesLoose(props, _excluded3);

  return /*#__PURE__*/React.createElement(Anchor, {
    href: href,
    width: width,
    height: height,
    inverted: inverted,
    onClick: onClick
  }, renderIcon && renderIcon(), /*#__PURE__*/React.createElement(LinkText, {
    inverted: inverted
  }, text));
};

LinkButton.propTypes = {
  renderIcon: PropTypes__default.func,
  text: PropTypes__default.string,
  href: PropTypes__default.string,
  width: PropTypes__default.string,
  height: PropTypes__default.string,
  inverted: PropTypes__default.bool
};
LinkButton.defaultProps = {
  href: '#'
};

var _templateObject$L, _templateObject2$r, _templateObject3$i, _templateObject4$c, _templateObject5$9, _templateObject6$4, _templateObject7$4;
var Description$1 = styled(Subtitle)(_templateObject$L || (_templateObject$L = _taggedTemplateLiteralLoose(["\n  margin-left: 8px;\n  line-height: ", "px;\n  font-size: 14px;\n  font-size: calc(12px + (14 - 12) * ((100vw - 360px) / (1024 - 360)));\n  ", ";\n  ", ";\n"])), 14 * 1.5, mediaQuery.fontMax(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteralLoose(["font-size: 14px;"]))), mediaQuery.fontMin(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteralLoose(["font-size: 12px;"]))));
var Content$b = styled(View$1)(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var Title$2 = styled(Text$1)(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  font-size: 16px;\n  font-weight: 700;\n"])));
var Itens = styled(View$1)(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var Row$3 = styled(View$1)(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));

var CallToSell = function CallToSell(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Content$b, null, /*#__PURE__*/React.createElement(SellIcon, null), /*#__PURE__*/React.createElement(Title$2, null, "Venda o que n\xE3o usa mais"), /*#__PURE__*/React.createElement(Itens, null, /*#__PURE__*/React.createElement(Row$3, null, /*#__PURE__*/React.createElement(TextWithCheck, {
    render: function render() {
      return /*#__PURE__*/React.createElement(Description$1, null, "Crie um an\xFAncio em menos de 5 minutos.");
    }
  })), /*#__PURE__*/React.createElement(Row$3, null, /*#__PURE__*/React.createElement(TextWithCheck, {
    render: function render() {
      return /*#__PURE__*/React.createElement(Description$1, null, "Negocie direto com compradores via chat.");
    }
  })), /*#__PURE__*/React.createElement(Row$3, null, /*#__PURE__*/React.createElement(TextWithCheck, {
    render: function render() {
      return /*#__PURE__*/React.createElement(Description$1, null, "100% da grana \xE9 sua, sem intermedi\xE1rias.");
    }
  }))), /*#__PURE__*/React.createElement(Row$3, null, /*#__PURE__*/React.createElement(LinkButton, {
    href: "https://www2.olx.com.br/ai",
    text: "Anunciar agora",
    width: "180px",
    height: "48px",
    onClick: onClick
  })));
};

CallToSell.propTypes = {
  onClick: PropTypes__default.func
};

var BuyIcon = function BuyIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "146",
    height: "80",
    viewBox: "0 0 146 80"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h146v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A822B5",
    d: "M95.657 25.092c-.021-.333.144-.674.487-.919.594-.424 1.496-.398 2.015.058 2.897 2.545 6.48 5.346 11.083 6.818.722.23 1.052.886.737 1.464-.316.578-1.157.858-1.88.627-5.121-1.637-8.986-4.647-12.092-7.375a.981.981 0 0 1-.35-.673"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A822B5",
    d: "M86.582 2.455c-6.022.43-10.923 5.497-10.923 11.297 0 7.047 5.494 13 11.997 13 7.637 0 13.18-5.916 13.18-14.066 0-6.145-6.779-10.272-13.11-10.272-.38 0-.764.014-1.144.04m1.074 25.757c-7.295 0-13.46-6.621-13.46-14.459 0-6.55 5.51-12.27 12.282-12.753.414-.029.834-.044 1.248-.044 7.038 0 14.572 4.714 14.572 11.73 0 8.997-6.157 15.526-14.642 15.526"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.598 .241)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.24.356h28.818v27.972H.24z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A822B5",
    d: "M13.01 2.571c-5.84.416-10.59 5.324-10.59 10.94 0 6.852 5.33 12.642 11.637 12.642 7.43 0 12.821-5.765 12.821-13.709 0-5.93-6.593-9.913-12.75-9.913-.368 0-.744.013-1.119.04zm1.047 24.297c-6.696 0-12.355-6.117-12.355-13.357 0-5.984 5.05-11.212 11.256-11.655.392-.027.785-.041 1.17-.041 6.504 0 13.468 4.271 13.468 10.63 0 8.358-5.694 14.423-13.539 14.423zm.07-25.797c-.402 0-.813.015-1.222.045C6.317 1.585.957 7.146.957 13.51c0 7.643 6 14.1 13.1 14.1 8.277 0 14.284-6.378 14.284-15.167 0-6.802-7.35-11.373-14.214-11.373zm-.07 27.257C6.567 28.328.24 21.542.24 13.511.24 6.778 5.9.896 12.854.4c.426-.03.855-.045 1.273-.045 7.211 0 14.931 4.857 14.931 12.088 0 9.204-6.308 15.884-15 15.884z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .091h78.945v50.43H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A822B5",
    d: "M13.532 48.245c9.52.147 47.95.672 63.151-.171-1.147-4.304-2.15-8.039-3.044-11.365-4.092-15.231-5.836-21.723-8.455-34.592-12.489.658-34.236.692-62.935.527.875 3.692 1.735 7.417 2.569 11.031 2.625 11.373 5.337 23.125 8.714 34.57m35.412 2.276c-15.488 0-31.406-.232-36.173-.308a.991.991 0 0 1-.934-.708C8.345 37.782 5.569 25.752 2.885 14.12 1.958 10.108 1 5.96.027 1.876A.99.99 0 0 1 .992.657h.006C30.959.833 53.468.804 65.93.094c.5-.035.93.31 1.03.792 2.702 13.372 4.427 19.794 8.595 35.31.975 3.626 2.079 7.736 3.357 12.538a.993.993 0 0 1-.893 1.242c-6.28.416-17.559.545-29.075.545",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A822B5",
    d: "M38.014 79.644c-3.97 0-7.943-.055-11.903-.192a278.257 278.257 0 0 1-6.716-.314c-.594-.02-1.247.068-1.945.16-.725.096-1.473.193-2.209.17-1.732-.06-2.687-.886-3.182-1.568-.615-.845-.914-2.001-.867-3.345a8.006 8.006 0 0 1 .826-3.27.997.997 0 0 1 1.333-.438.99.99 0 0 1 .44 1.33 6.065 6.065 0 0 0-.616 2.446c-.031.9.138 1.63.49 2.114.348.48.887.726 1.645.752.573.019 1.206-.065 1.88-.153.748-.1 1.523-.205 2.3-.175.057.004 3.062.186 6.69.312 12.454.43 25.09.049 37.311-.32 4.436-.135 9.007-.274 13.533-.372a6.058 6.058 0 0 1-.49-2.622c.039-1.157.396-2.214 1.032-3.055a.992.992 0 0 1 1.39-.195c.437.328.524.95.195 1.385-.384.509-.61 1.195-.635 1.933-.037 1.085.355 2.153 1.026 2.79.291.277.386.702.24 1.075a.993.993 0 0 1-.905.632c-5.104.098-10.3.255-15.326.407-8.377.253-16.951.513-25.537.513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A822B5",
    d: "M78.965 78.812a.99.99 0 0 1-.066-1.977c2.243-.153 4.514-.17 6.516-.182 4.55-.03 8.848-.06 8.908-1.776.045-1.313-.382-1.777-1.087-2.1-1.047-.482-2.838-.636-5.202-.718-1.289-.045-2.614-.021-3.896.002-1.32.023-2.685.048-4.052 0a32.157 32.157 0 0 1-1.241-.063.991.991 0 0 1-.92-1.057.986.986 0 0 1 1.059-.918c.39.027.78.048 1.17.06 1.316.046 2.653.022 3.948 0 1.306-.026 2.659-.049 4-.002 2.679.092 4.61.275 5.964.897 1.575.724 2.308 2.022 2.24 3.967-.126 3.616-4.87 3.647-10.876 3.687-2.071.015-4.213.028-6.396.178a.873.873 0 0 1-.069.002M27.475 49.097c1.496.96 2.954 1.99 4.372 2.992 1.28.905 2.596 1.836 3.94 2.715 1.73-2.561 3.563-4.948 5.218-7.032-1.213-.879-2.398-1.799-3.552-2.694-1.205-.936-2.445-1.898-3.694-2.795a143.892 143.892 0 0 0-6.284 6.814m8.596 8.056a.99.99 0 0 1-.53-.153c-1.672-1.054-3.282-2.194-4.841-3.295-1.7-1.202-3.459-2.446-5.244-3.537a.984.984 0 0 1-.238-1.485 145.62 145.62 0 0 1 7.724-8.391.994.994 0 0 1 1.27-.114c1.522 1.058 3.015 2.216 4.458 3.337 1.406 1.09 2.86 2.217 4.332 3.247.225.157.374.4.412.67a.98.98 0 0 1-.206.759c-1.958 2.444-4.239 5.367-6.306 8.515a.993.993 0 0 1-.83.447M119.076 43.897c.07 1.924.16 3.926.301 5.89l1.218-.062c3.199-.16 6.505-.324 9.785-.67 1.383-.146 2.886-.215 4.731-.215.949 0 1.897.017 2.845.035.936.016 1.874.033 2.811.033 1.077 0 2.01-.023 2.872-.071-.164-2.188-.349-4.347-.51-6.157-7.266.765-14.96 1.155-24.053 1.217m-.528 7.724a.897.897 0 0 1-.894-.824c-.209-2.587-.318-5.258-.405-7.759a.896.896 0 0 1 .893-.926c9.82-.044 17.986-.46 25.7-1.31a.895.895 0 0 1 .993.81c.2 2.207.454 5.11.66 7.994a.895.895 0 0 1-.823.956 47.839 47.839 0 0 1-3.905.137c-.949 0-1.897-.017-2.844-.034-.937-.017-1.874-.034-2.812-.034-1.78 0-3.224.065-4.542.204-3.33.352-6.662.518-9.885.679l-2.088.106h-.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A822B5",
    d: "M122.34 66.413a.896.896 0 0 1-.892-.805c-.24-2.35-.275-4.158-.31-5.906-.046-2.328-.094-4.736-.633-8.503a.896.896 0 0 1 .762-1.013.899.899 0 0 1 1.015.76c.555 3.875.603 6.339.65 8.72.032 1.566.061 3.056.223 4.926 6.094-.224 12.064-.553 18.586-.928-.041-1.091-.071-2.181-.1-3.27-.095-3.462-.192-7.04-.693-10.539a.896.896 0 0 1 .762-1.013.9.9 0 0 1 1.015.76c.516 3.6.615 7.231.71 10.743.037 1.374.074 2.747.135 4.122a.896.896 0 0 1-.844.934c-7.182.414-13.671.777-20.353 1.011l-.033.001M123.753 33.457c-1.213 0-2.523.805-2.523 2.103 0 1.157 2.246 4.42 7.5 5.837-.386-1.959-2.198-7.94-4.977-7.94m5.843 9.961a.866.866 0 0 1-.182-.019c-6.511-1.344-9.979-5.415-9.979-7.839 0-2.405 2.241-3.894 4.318-3.894 5.018 0 6.85 9.462 6.85 10.257 0 .329-.058.643-.175.932a.897.897 0 0 1-.832.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A822B5",
    d: "M135.385 33.476c-1.534 0-4.6 2.345-4.6 5.424 0 .51.047 1.028.097 1.575l.017.195c1.9-1.058 3.694-2.062 5.11-3.733.482-.568.747-1.22.747-1.84 0-.925-.59-1.621-1.371-1.621m-5.3 9.576a.894.894 0 0 1-.897-.896c0-.483-.046-.987-.095-1.52-.05-.563-.103-1.145-.103-1.736 0-4.117 3.88-7.215 6.395-7.215 1.775 0 3.166 1.499 3.166 3.412 0 1.043-.416 2.106-1.171 2.997-1.638 1.933-3.678 3.067-5.651 4.164-.4.222-.798.445-1.194.673a.899.899 0 0 1-.45.12"
  })));
};

var _templateObject$M, _templateObject2$s, _templateObject3$j, _templateObject4$d, _templateObject5$a, _templateObject6$5, _templateObject7$5;
var Description$2 = styled(Subtitle)(_templateObject$M || (_templateObject$M = _taggedTemplateLiteralLoose(["\n  margin-left: 8px;\n  line-height: ", "px;\n  font-size: 14px;\n  font-size: calc(12px + (14 - 12) * ((100vw - 360px) / (1024 - 360)));\n  ", ";\n  ", ";\n"])), 14 * 1.5, mediaQuery.fontMax(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteralLoose(["font-size: 14px;"]))), mediaQuery.fontMin(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteralLoose(["font-size: 12px;"]))));
var Content$c = styled(View$1)(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var Title$3 = styled(Text$1)(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  font-weight: 700;\n  margin-top: 8px;\n"])));
var Itens$1 = styled(View$1)(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var Row$4 = styled(View$1)(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));

var CallToBuy = function CallToBuy(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Content$c, null, /*#__PURE__*/React.createElement(BuyIcon, null), /*#__PURE__*/React.createElement(Title$3, null, "Veja o que voc\xEA pode comprar"), /*#__PURE__*/React.createElement(Itens$1, null, /*#__PURE__*/React.createElement(Row$4, null, /*#__PURE__*/React.createElement(TextWithCheck, {
    render: function render() {
      return /*#__PURE__*/React.createElement(Description$2, null, "Maior variedade de produtos do mercado.");
    }
  })), /*#__PURE__*/React.createElement(Row$4, null, /*#__PURE__*/React.createElement(TextWithCheck, {
    render: function render() {
      return /*#__PURE__*/React.createElement(Description$2, null, "Milhares de an\xFAncios novos todos os dias.");
    }
  })), /*#__PURE__*/React.createElement(Row$4, null, /*#__PURE__*/React.createElement(TextWithCheck, {
    render: function render() {
      return /*#__PURE__*/React.createElement(Description$2, null, "Compra por perto. \xC9 r\xE1pido e pr\xE1tico.");
    }
  }))), /*#__PURE__*/React.createElement(Row$4, null, /*#__PURE__*/React.createElement(LinkButton, {
    href: "https://www.olx.com.br/brasil",
    text: "Ver ofertas",
    width: "180px",
    height: "48px",
    inverted: true,
    onClick: onClick
  })));
};

CallToBuy.propTypes = {
  onClick: PropTypes__default.func
};

var checkCircleSvgPath = 'M30.3750847,16.6143523 C30.3750847,15.9930319 30.8787643,15.4893523 31.5000847,15.4893523 C32.121405,15.4893523 32.6250847,15.9930319 32.6250847,16.6143523 L32.6250845,18.0099955 C32.6210014,25.1512515 27.9202835,31.4392389 21.0720903,33.4640358 C14.223897,35.4888327 6.8595816,32.7680988 2.97274958,26.777265 C-0.914082437,20.7864312 -0.397523188,12.9526134 4.24230165,7.52402435 C8.88212648,2.09543534 16.5399337,0.365255042 23.0629595,3.27174552 C23.630491,3.5246228 23.8855687,4.18969556 23.6326914,4.7572271 C23.3798142,5.32475864 22.7147414,5.57983632 22.1472099,5.32695904 C16.5343737,2.82602537 9.94509773,4.31478516 5.95269032,8.98589664 C1.9602829,13.6570081 1.51580169,20.3977351 4.86028506,25.5526386 C8.20476842,30.7075421 14.5415049,33.0486387 20.4341363,31.3063716 C26.3267677,29.5641045 30.3715715,24.1535107 30.3750847,18.0093523 L30.3750847,16.6143523 Z M16.5000847,19.418362 L32.2045896,3.71385715 C32.6439294,3.27451732 33.35624,3.27451732 33.7955798,3.71385715 C34.2349196,4.15319698 34.2349196,4.86550758 33.7955798,5.30484741 L17.2955798,21.8048474 C16.85624,22.2441872 16.1439294,22.2441872 15.7045896,21.8048474 L11.2045896,17.3048474 C10.7652497,16.8655076 10.7652497,16.153197 11.2045896,15.7138572 C11.6439294,15.2745173 12.35624,15.2745173 12.7955798,15.7138572 L16.5000847,19.418362 Z';

var checkCircleSymbol = function checkCircleSymbol(props) {
  return /*#__PURE__*/React.createElement(SVG, {
    viewBox: "0 0 35 34",
    width: props.width,
    height: props.height,
    svgPath: checkCircleSvgPath,
    color: props.color
  });
};

checkCircleSymbol.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number,
  color: PropTypes__default.string
};
checkCircleSymbol.defaultProps = {
  width: 35,
  height: 34,
  color: '#85D43E'
};

var _templateObject$N, _templateObject2$t, _templateObject3$k;

var _excluded$7 = ["direction"];

var ViewWrapper = function ViewWrapper(_ref) {
  var others = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  return /*#__PURE__*/React.createElement(View$1, others);
};

var Content$d = styled(ViewWrapper)(_templateObject$N || (_templateObject$N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n"])), function (props) {
  return props.direction;
});
var CalloutLink = styled(Link$2)(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteralLoose(["\n  margin-left: 6px;\n  margin-right: 6px;\n"])));
var CalloutButton = styled(Button)(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteralLoose(["\n  margin-left: 6px;\n  margin-right: 6px;\n"])));

var formLabel = function formLabel(props) {
  return /*#__PURE__*/React.createElement(Content$d, {
    direction: props.direction
  }, /*#__PURE__*/React.createElement(Text.BodyMedium, {
    fontWeight: props.fontWeight
  }, props.text), props.href && /*#__PURE__*/React.createElement(CalloutLink, {
    size: "Medium",
    href: props.href,
    onClick: props.onClick
  }, props.linkText), !props.href && /*#__PURE__*/React.createElement(CalloutButton, {
    variant: "link-button",
    size: "small",
    onClick: props.onClick,
    disabled: props.disabled
  }, props.linkText), !!props.remainingText && /*#__PURE__*/React.createElement(Text.BodyMedium, {
    fontWeight: props.fontWeight
  }, props.remainingText));
};

formLabel.propTypes = {
  text: PropTypes__default.string.isRequired,
  linkText: PropTypes__default.string.isRequired,
  href: PropTypes__default.string,
  onClick: PropTypes__default.func,
  preventHrefOnClick: PropTypes__default.bool,
  direction: PropTypes__default.oneOf(['row', 'column']),
  fontWeight: PropTypes__default.number,
  remainingText: PropTypes__default.string,
  disabled: PropTypes__default.bool
};
formLabel.defaultProps = {
  preventHrefOnClick: true,
  direction: 'row',
  fontWeight: 400
};

var _templateObject$O, _templateObject2$u, _templateObject3$l, _templateObject4$e, _templateObject5$b, _templateObject6$6, _templateObject7$6, _templateObject8$3;
var Content$e = styled(View$1)(_templateObject$O || (_templateObject$O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n"])));
var Wrapper$2 = styled(View$1)(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteralLoose(["\n  margin-left: 36px;\n"])));
var WrapperDescription = styled(View$1)(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  max-width: 464px;\n"])));
var Description$3 = styled(Subtitle)(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  ", ";\n  ", ";\n"])), mediaQuery.fontMax(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteralLoose(["font-size: 16px;"]))), mediaQuery.fontMin(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteralLoose(["font-size: 14px;"]))));
var Title$4 = styled(Text$1)(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: 700;\n"])), fontH3);
var WrapperLink = styled(View$1)(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 8px;\n  align-items: flex-start;\n"])));

var EmailVerified = function EmailVerified(_ref) {
  var onMyAccountClick = _ref.onMyAccountClick;
  return /*#__PURE__*/React.createElement(Content$e, null, /*#__PURE__*/React.createElement(checkCircleSymbol, null), /*#__PURE__*/React.createElement(Wrapper$2, null, /*#__PURE__*/React.createElement(Title$4, null, "E-mail verificado com sucesso!"), /*#__PURE__*/React.createElement(WrapperDescription, null, /*#__PURE__*/React.createElement(Description$3, null, "Seja confi\xE1vel e fortale\xE7a o seu perfil. Compradores confiam mais em vendedores com telefone e e-mail verificados e Facebook conectado.")), /*#__PURE__*/React.createElement(WrapperLink, null, /*#__PURE__*/React.createElement(formLabel, {
    text: "Ir para",
    linkText: "Meu Cadastro",
    onClick: onMyAccountClick
  }))));
};

var WarningSvgPath = 'M9.714 3.583A2.652 2.652 0 0 1 12 2.25c.938 0 1.804.506 2.286 1.333l8.113 14.07c.465.837.468 1.864.007 2.704a2.657 2.657 0 0 1-2.3 1.393H3.886a2.653 2.653 0 0 1-2.291-1.393 2.81 2.81 0 0 1 .013-2.715l8.107-14.06zM2.912 18.38a1.306 1.306 0 0 0-.003 1.254c.207.38.586.61.984.615h16.205c.407-.005.786-.236.993-.615.213-.387.212-.867.003-1.243L12.989 4.335A1.15 1.15 0 0 0 12 3.75c-.4 0-.774.219-.988.584l-8.1 14.047zM11.25 10v4a.75.75 0 1 0 1.5 0v-4a.75.75 0 1 0-1.5 0zm.75 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z';

var AlertSymbol = function AlertSymbol(props) {
  return /*#__PURE__*/React.createElement(SVG, {
    viewBox: "0 0 24 24",
    width: props.width,
    height: props.height,
    svgPath: WarningSvgPath,
    color: props.color
  });
};

AlertSymbol.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number,
  color: PropTypes__default.string
};
AlertSymbol.defaultProps = {
  width: 40,
  height: 40,
  color: '#ff3b3c'
};

var _templateObject$P, _templateObject2$v, _templateObject3$m, _templateObject4$f, _templateObject5$c, _templateObject6$7, _templateObject7$7, _templateObject8$4, _templateObject9$2, _templateObject10$2;
var Content$f = styled(View$1)(_templateObject$P || (_templateObject$P = _taggedTemplateLiteralLoose(["\n  width: 600px;\n  padding: 64px;\n  display: flex;\n  flex-direction: row;\n  background-color: #ffffff;\n  ", "\n  ", "\n"])), mediaQuery.extraLarge(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteralLoose(["width: 100%;"]))), mediaQuery.extraLarge(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteralLoose(["padding: 32px 24px;"]))));
var Wrapper$3 = styled(View$1)(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteralLoose(["\n  margin-left: 36px;\n"])));
var WrapperDescription$1 = styled(View$1)(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  max-width: 464px;\n"])));
var Description$4 = styled(Subtitle)(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var Title$5 = styled(Text$1)(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: 700;\n"])), fontH2);
var WrapperLink$1 = styled(View$1)(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 8px;\n  align-items: flex-start;\n"])));
var Link = styled(link)(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n"])));
var LinkText$1 = styled(Text$1)(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  color: #4a4a4a;\n"])));

var VerifyEmailLinkExpired = function VerifyEmailLinkExpired(_ref) {
  var onMyAccountClick = _ref.onMyAccountClick;
  return /*#__PURE__*/React.createElement(Content$f, null, /*#__PURE__*/React.createElement(AlertSymbol, null), /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(Title$5, null, "Link Expirado"), /*#__PURE__*/React.createElement(WrapperDescription$1, null, /*#__PURE__*/React.createElement(Description$4, null, "O link para verifica\xE7\xE3o da conta n\xE3o \xE9 v\xE1lido.")), /*#__PURE__*/React.createElement(WrapperLink$1, null, /*#__PURE__*/React.createElement(LinkText$1, null, "V\xE1 para", ' ', /*#__PURE__*/React.createElement(Link, {
    type: "primary",
    underline: true,
    onClick: onMyAccountClick
  }, "Meu Cadastro"), ' ', "e reenvie o e-mail de verifica\xE7\xE3o."))));
};

var scrollToTop = function scrollToTop() {
  window.scrollTo(0, 0);
};

var goToErrorPage = function goToErrorPage(errorCode) {
  var errorUrl = 'https://oops.olx.com.br/502.html';
  if (errorCode) errorUrl += "?error=" + errorCode;
  window.location = errorUrl;
};

var behaviors = {
  scrollToTop: scrollToTop,
  goToErrorPage: goToErrorPage
};

var API_ENDPOINT$3 = '/v1/accounts/email/validate';
var validateEmailApiCall = (function (token) {
  return axios.post(API_ENDPOINT$3, {
    token: token
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
});

var _templateObject$Q, _templateObject2$w, _templateObject3$n, _templateObject4$g, _templateObject5$d, _templateObject6$8, _templateObject7$8, _templateObject8$5;
var lurker$2 = new Lurker('email_validation');
var Content$g = styled(View$1)(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var Row$5 = styled(View$1)(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  padding-bottom: 32px;\n  ", "\n"])), mediaQuery.extraLarge(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteralLoose(["flex-direction: column;"]))));
var HRuleWrapper$3 = styled(View$1)(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var CallToSellWrapper = styled(View$1)(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteralLoose(["\n  ", "\n"])), mediaQuery.extraLarge(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteralLoose(["margin-bottom: 64px;"]))));
var EmailVerifiedWrapper = styled(View$1)(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteralLoose(["\n  width: 70%;\n  ", "\n  padding: 32px 24px;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n"])), mediaQuery.extraLarge(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteralLoose(["width: 100%;"]))));
var EmailValidationTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EmailValidationTemplate, _React$Component);

  function EmailValidationTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isExpired: false,
      isVerified: false
    };
    return _this;
  }

  var _proto = EmailValidationTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$2.pageLoadEvt();
    this.validateEmail();
  };

  _proto.validateEmail = function validateEmail() {
    var _this2 = this;

    var _this$props = this.props,
        token = _this$props.token,
        onSuccess = _this$props.onSuccess,
        onExpiredLink = _this$props.onExpiredLink;
    validateEmailApiCall(token).then(function () {
      lurker$2.viewMessageEvt('validation_success');

      _this2.setState({
        isVerified: true
      }, onSuccess);
    })["catch"](function (error) {
      var _ref = error || {},
          _ref$response = _ref.response,
          _ref$response2 = _ref$response === void 0 ? {} : _ref$response,
          _ref$response2$status = _ref$response2.status,
          status = _ref$response2$status === void 0 ? '' : _ref$response2$status;

      if (status === 410) {
        lurker$2.viewMessageEvt('error', {
          accounts_reason: 'expired_link',
          accounts_status_code: status
        });

        _this2.setState({
          isExpired: true
        }, onExpiredLink);
      } else if (status) {
        lurker$2.viewMessageEvt('error', {
          accounts_reason: 'unexpected_status_code',
          accounts_status_code: status
        });
        behaviors.goToErrorPage("ErrorExchangingToken" + status);
      } else {
        lurker$2.viewMessageEvt('error', {
          accounts_reason: 'unexpected_error',
          accounts_error_message: error && error.message || 'unknown'
        });
        behaviors.goToErrorPage('UnexpectedErrorExchangingToken');
      }
    });
  };

  _proto.renderEmailVerified = function renderEmailVerified() {
    var onMyAccountClick = this.props.onMyAccountClick;
    return /*#__PURE__*/React.createElement(EmailVerifiedWrapper, null, /*#__PURE__*/React.createElement(EmailVerified, {
      onMyAccountClick: onMyAccountClick
    }), /*#__PURE__*/React.createElement(HRuleWrapper$3, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(Row$5, null, /*#__PURE__*/React.createElement(CallToSellWrapper, null, /*#__PURE__*/React.createElement(CallToSell, {
      onClick: function onClick() {
        return lurker$2.clickEvt('insert_now');
      }
    })), /*#__PURE__*/React.createElement(CallToBuy, {
      onClick: function onClick() {
        return lurker$2.clickEvt('see_offers');
      }
    })));
  };

  _proto.renderLinkExpired = function renderLinkExpired() {
    var onMyAccountClick = this.props.onMyAccountClick;
    return /*#__PURE__*/React.createElement(VerifyEmailLinkExpired, {
      onMyAccountClick: onMyAccountClick
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        isVerified = _this$state.isVerified,
        isExpired = _this$state.isExpired;
    return /*#__PURE__*/React.createElement(Content$g, null, isVerified && this.renderEmailVerified(), isExpired && this.renderLinkExpired());
  };

  return EmailValidationTemplate;
}(React.Component);
EmailValidationTemplate.propTypes = {
  token: PropTypes__default.string,
  onMyAccountClick: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  onExpiredLink: PropTypes__default.func
};

var _templateObject$R, _templateObject2$x;
var Option = styled(Button)(_templateObject$R || (_templateObject$R = _taggedTemplateLiteralLoose(["\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  border-style: solid;\n  border-color: #e5e5e5;\n  border-width: 1px;\n  border-radius: 8px;\n  padding: 32px;\n  ", "\n"])), function (props) {
  return props.last ? '' : "margin-bottom: 16px;";
});
var IconArea = styled(View$1)(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteralLoose(["\n  display: flex;\n  min-width: 32px;\n  min-height: 32px;\n  border-radius: 16px;\n  align-items: center;\n  justify-content: center;\n  margin-right: 24px;\n  background-color: #f0e6ff;\n"])));

var HelpOption = function HelpOption(_ref) {
  var onClick = _ref.onClick,
      svgPath = _ref.svgPath,
      text = _ref.text,
      last = _ref.last;
  return /*#__PURE__*/React.createElement(Touchable, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Option, {
    last: last,
    size: "extra-large",
    variant: "neutral",
    fullWidth: true,
    icon: /*#__PURE__*/React.createElement(IconArea, null, /*#__PURE__*/React.createElement(SVG, {
      width: 16,
      height: 16,
      svgPath: svgPath,
      color: theme.colors.purple,
      viewBox: "0 0 24 24"
    }))
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    size: "body1",
    color: "dark",
    weight: "semibold"
  }, text)));
};

HelpOption.propTypes = {
  onClick: PropTypes__default.func,
  svgPath: PropTypes__default.string.isRequired,
  text: PropTypes__default.string.isRequired,
  last: PropTypes__default.bool
};

var lockSvgPath = 'M6.25 10.25V7a5.75 5.75 0 0 1 11.5 0v3.25H19A2.75 2.75 0 0 1 21.75 13v7A2.75 2.75 0 0 1 19 22.75H5A2.75 2.75 0 0 1 2.25 20v-7A2.75 2.75 0 0 1 5 10.25h1.25zm1.5 0h8.5V7a4.25 4.25 0 1 0-8.5 0v3.25zM5 11.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25H5z';

var logoutSvgPath = 'M19.1893 13.0551H9C8.58579 13.0551 8.25 12.7193 8.25 12.3051C8.25 11.8908 8.58579 11.5551 9 11.5551H19.1893L16.4697 8.83538C16.1768 8.54249 16.1768 8.06762 16.4697 7.77472C16.7626 7.48183 17.2374 7.48183 17.5303 7.77472L21.5303 11.7747C21.8232 12.0676 21.8232 12.5425 21.5303 12.8354L17.5303 16.8354C17.2374 17.1283 16.7626 17.1283 16.4697 16.8354C16.1768 16.5425 16.1768 16.0676 16.4697 15.7747L19.1893 13.0551ZM10 21.5551C10.4142 21.5551 10.75 21.8908 10.75 22.3051C10.75 22.7193 10.4142 23.0551 10 23.0551H5C3.48122 23.0551 2.25 21.8238 2.25 20.3051V4.30505C2.25 2.78627 3.48122 1.55505 5 1.55505H10C10.4142 1.55505 10.75 1.89084 10.75 2.30505C10.75 2.71927 10.4142 3.05505 10 3.05505H5C4.30964 3.05505 3.75 3.6147 3.75 4.30505V20.3051C3.75 20.9954 4.30964 21.5551 5 21.5551H10Z';

var userSvgPath = 'M20.75 21v-2A4.75 4.75 0 0 0 16 14.25H8A4.75 4.75 0 0 0 3.25 19v2a.75.75 0 1 0 1.5 0v-2A3.25 3.25 0 0 1 8 15.75h8A3.25 3.25 0 0 1 19.25 19v2a.75.75 0 1 0 1.5 0zM12 11.75a4.75 4.75 0 1 1 0-9.5 4.75 4.75 0 0 1 0 9.5zm0-1.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5z';

var _templateObject$S, _templateObject2$y, _templateObject3$o;
var lurker$3 = new Lurker('help_modal');
var Title$6 = styled(Text$1)(_templateObject$S || (_templateObject$S = _taggedTemplateLiteralLoose(["\n  padding-bottom: 8px;\n"])));
var Header = styled(View$1)(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 32px;\n"])));
var Content$h = styled(View$1)(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));

var HelpContent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(HelpContent, _React$Component);

  function HelpContent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onOptionClick = function (onClick, lurkerEvent) {
      return function () {
        if (onClick) {
          lurker$3.clickEvt(lurkerEvent);
          onClick();
        }

        _this.props.onOptionClick();
      };
    };

    return _this;
  }

  var _proto = HelpContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onForgotPasswordLinkClick = _this$props.onForgotPasswordLinkClick,
        onReactivationLinkClick = _this$props.onReactivationLinkClick,
        onMagicLinkClick = _this$props.onMagicLinkClick;
    return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Title$6, {
      size: "title2",
      fontWeight: 600
    }, "Como podemos ajudar?"), /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, "Enviaremos um e-mail para ajudar voc\xEA a acessar sua conta!")), /*#__PURE__*/React.createElement(Content$h, null, onReactivationLinkClick && /*#__PURE__*/React.createElement(HelpOption, {
      text: "Quero reativar minha conta",
      svgPath: userSvgPath,
      onClick: this.onOptionClick(onReactivationLinkClick, 'account_reactivation'),
      last: !onForgotPasswordLinkClick && !onMagicLinkClick
    }), onForgotPasswordLinkClick && /*#__PURE__*/React.createElement(HelpOption, {
      text: "Esqueci a minha senha",
      svgPath: lockSvgPath,
      onClick: this.onOptionClick(onForgotPasswordLinkClick, 'forgot_password'),
      last: !onMagicLinkClick
    }), onMagicLinkClick && /*#__PURE__*/React.createElement(HelpOption, {
      text: "Entrar sem senha",
      svgPath: logoutSvgPath,
      onClick: this.onOptionClick(onMagicLinkClick, 'passwordless_login_button'),
      last: true
    })));
  };

  return HelpContent;
}(React.Component);

HelpContent.propTypes = {
  onForgotPasswordLinkClick: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onMagicLinkClick: PropTypes__default.func,
  onOptionClick: PropTypes__default.func
};

var HelpModalTemplate = function HelpModalTemplate(_ref) {
  var abTests = _ref.abTests,
      open = _ref.open,
      onClose = _ref.onClose,
      onForgotPasswordLinkClick = _ref.onForgotPasswordLinkClick,
      onReactivationLinkClick = _ref.onReactivationLinkClick,
      onMagicLinkClick = _ref.onMagicLinkClick;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose,
    transitionTime: 250
  }, /*#__PURE__*/React.createElement(HelpContent, {
    abTests: abTests,
    onForgotPasswordLinkClick: onForgotPasswordLinkClick,
    onReactivationLinkClick: onReactivationLinkClick,
    onMagicLinkClick: onMagicLinkClick,
    onOptionClick: onClose
  }));
};
HelpModalTemplate.propTypes = {
  abTests: PropTypes__default.string,
  open: PropTypes__default.bool.isRequired,
  onClose: PropTypes__default.func.isRequired,
  onForgotPasswordLinkClick: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onMagicLinkClick: PropTypes__default.func
};

var GET_ACCOUNT_ENDPOINT = '/v4/me';
var getAccount = function getAccount() {
  return axios.get(GET_ACCOUNT_ENDPOINT);
};

var GET_WALLET_ENDPOINT = 'https://wallet-api.olx.com.br/wallet';
var getWallet = function getWallet() {
  return axios.get(GET_WALLET_ENDPOINT);
};

var AccountLevelPage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountLevelPage, _React$Component);

  function AccountLevelPage(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.fetchData = function () {
      return Promise.allSettled([getAccount(), getWallet()]).then(function (_ref) {
        var _accountPromise$value, _accountPromise$value2, _accountPromise$value3, _accountPromise$value4, _walletPromise$value, _walletPromise$value$, _accountPromise$value5, _accountPromise$value6, _accountPromise$value7, _accountPromise$value8;

        var accountPromise = _ref[0],
            walletPromise = _ref[1];
        return _this.setState({
          emailVerified: (_accountPromise$value = accountPromise.value) === null || _accountPromise$value === void 0 ? void 0 : (_accountPromise$value2 = _accountPromise$value.data) === null || _accountPromise$value2 === void 0 ? void 0 : _accountPromise$value2.emailVerified,
          phoneVerified: (_accountPromise$value3 = accountPromise.value) === null || _accountPromise$value3 === void 0 ? void 0 : (_accountPromise$value4 = _accountPromise$value3.data) === null || _accountPromise$value4 === void 0 ? void 0 : _accountPromise$value4.phoneVerified,
          hasWallet: ((_walletPromise$value = walletPromise.value) === null || _walletPromise$value === void 0 ? void 0 : (_walletPromise$value$ = _walletPromise$value.data) === null || _walletPromise$value$ === void 0 ? void 0 : _walletPromise$value$.status) === 'ACTIVE',
          email: (_accountPromise$value5 = accountPromise.value) === null || _accountPromise$value5 === void 0 ? void 0 : (_accountPromise$value6 = _accountPromise$value5.data) === null || _accountPromise$value6 === void 0 ? void 0 : _accountPromise$value6.email,
          publicAccountId: (_accountPromise$value7 = accountPromise.value) === null || _accountPromise$value7 === void 0 ? void 0 : (_accountPromise$value8 = _accountPromise$value7.data) === null || _accountPromise$value8 === void 0 ? void 0 : _accountPromise$value8.publicAccountId
        });
      })["catch"](function () {
        return null;
      })["finally"](function () {
        return _this.setState({
          loading: false
        });
      });
    };

    _this.state = {
      loading: true,
      hasWallet: false,
      emailVerified: false,
      phoneVerified: false,
      email: '',
      publicAccountId: ''
    };
    return _this;
  }

  var _proto = AccountLevelPage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.fetchData();
  };

  _proto.render = function render() {
    var profileCreated = true;
    var _this$state = this.state,
        email = _this$state.email,
        publicAccountId = _this$state.publicAccountId,
        loading = _this$state.loading,
        emailVerified = _this$state.emailVerified,
        phoneVerified = _this$state.phoneVerified,
        hasWallet = _this$state.hasWallet;
    var tasks = [profileCreated, emailVerified, phoneVerified, hasWallet];
    var tasksCompleted = tasks.filter(function (task) {
      return task;
    }).length;
    return /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column"
    }, /*#__PURE__*/React.createElement(Text.TitleLarge, {
      marginBottom: "--spacing-stack-nano"
    }, "N\xEDvel da conta"), /*#__PURE__*/React.createElement(Text.SubtitleMedium, {
      color: "--color-neutral-darker",
      marginBottom: "--spacing-stack-xs"
    }, "Torne sua conta mais segura e seu perfil mais confi\xE1vel."), /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column"
    }, /*#__PURE__*/React.createElement(Container$7, {
      type: "outlined",
      flexDirection: "column",
      alignItems: "stretch",
      marginBottom: "--spacing-stack-xxs"
    }, loading ? /*#__PURE__*/React.createElement(LevelProgressSkeleton, null) : /*#__PURE__*/React.createElement(LevelProgress, {
      steps: tasks.length,
      stepsCompleted: tasksCompleted,
      publicAccountId: publicAccountId
    })), /*#__PURE__*/React.createElement(Container$7, {
      type: "outlined",
      flexDirection: "column",
      alignItems: "stretch"
    }, loading ? /*#__PURE__*/React.createElement(LevelStepsSkeleton, null) : /*#__PURE__*/React.createElement(LevelSteps, {
      email: email,
      emailVerified: emailVerified,
      phoneVerified: phoneVerified,
      hasWallet: hasWallet,
      profileCreated: profileCreated
    }))));
  };

  return AccountLevelPage;
}(React.Component);

var ErrorToastMsg = function ErrorToastMsg(_ref) {
  var text = _ref.text,
      show = _ref.show,
      onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(ToastMessage, {
    showInfoIcon: true,
    iconPath: "M9.71362 3.58265C10.196 2.75648 11.0619 2.25 12 2.25C12.9381 2.25 13.8041 2.75648 14.2864 3.58265L22.399 17.6527C22.8644 18.4899 22.8672 19.5172 22.4064 20.357C21.9405 21.2061 21.0687 21.7391 20.1068 21.75L3.88466 21.75C2.93136 21.7391 2.05957 21.2061 1.59368 20.357C1.13288 19.5172 1.13564 18.4899 1.60682 17.6424L9.71362 3.58265ZM2.91209 18.3814C2.69721 18.768 2.69592 19.2476 2.90874 19.6355C3.11649 20.0141 3.49484 20.2454 3.89322 20.25L20.0983 20.25C20.5052 20.2454 20.8836 20.0141 21.0913 19.6355C21.3041 19.2476 21.3028 18.768 21.0938 18.3917L12.989 4.33545C12.7753 3.96942 12.4001 3.75 12 3.75C11.6005 3.75 11.2258 3.9688 11.0119 4.33389L2.91209 18.3814ZM11.25 10V14C11.25 14.4142 11.5858 14.75 12 14.75C12.4142 14.75 12.75 14.4142 12.75 14V10C12.75 9.58579 12.4142 9.25 12 9.25C11.5858 9.25 11.25 9.58579 11.25 10ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z",
    iconColor: "#FF4444",
    text: text,
    show: show,
    onClose: onClose
  });
};

ErrorToastMsg.propTypes = {
  text: PropTypes__default.string,
  show: PropTypes__default.bool,
  onClose: PropTypes__default.func
};

var _templateObject$T;
var caption = styled(Text$1)(_templateObject$T || (_templateObject$T = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  font-weight: 400;\n  color: #999999;\n"])));

var _templateObject$U, _templateObject2$z;
var Content$i = styled(View$1)(_templateObject$U || (_templateObject$U = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  ", "\n"])), function (props) {
  return props.callout ? 'justify-content: space-between;' : '';
});
var TipWrapper = styled(View$1)(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteralLoose(["\n  margin-left: 6px;\n"])));

var TipComp = function TipComp(props) {
  return /*#__PURE__*/React.createElement(TipWrapper, null, /*#__PURE__*/React.createElement(caption, null, props.tip));
};

var CalloutFactory = function CalloutFactory(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      linkText = _ref.linkText;
  return function () {
    return /*#__PURE__*/React.createElement(Link$2, {
      size: "small",
      href: href,
      onClick: onClick,
      tabIndex: -1
    }, linkText);
  };
};

var formLabelWithCallout = function formLabelWithCallout(props) {
  var label = props.label,
      tip = props.tip,
      linkText = props.linkText,
      required = props.required;
  var CalloutComp = CalloutFactory(props);
  var withCallout = linkText;
  return /*#__PURE__*/React.createElement(Content$i, {
    callout: withCallout
  }, /*#__PURE__*/React.createElement(Label$1, props, ' ', label, " ", required ? /*#__PURE__*/React.createElement(caption, null, "*") : null, ' '), withCallout ? /*#__PURE__*/React.createElement(CalloutComp, null) : /*#__PURE__*/React.createElement(TipComp, {
    tip: tip
  }));
};

formLabelWithCallout.defaultProps = {
  underline: true
};
formLabelWithCallout.propTypes = {
  label: PropTypes__default.string.isRequired,
  tip: PropTypes__default.string,
  linkText: PropTypes__default.string,
  linkTarget: PropTypes__default.string,
  linkUnderline: PropTypes__default.bool,
  href: PropTypes__default.string,
  onClick: PropTypes__default.func,
  underline: PropTypes__default.bool,
  required: PropTypes__default.bool
};

var _templateObject$V;
var errorMsg = styled(Text$1)(_templateObject$V || (_templateObject$V = _taggedTemplateLiteralLoose(["\n  font-size: 12px !important;\n  color: #ff4444;\n"])));

var isFunction = (function (param) {
  if (param && typeof param === 'function') {
    return true;
  }

  return false;
});

var _templateObject$W, _templateObject2$A, _templateObject3$p;
var Content$j = styled(View$1)(_templateObject$W || (_templateObject$W = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 8px;\n"])));
var FieldWrapper = styled(View$1)(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteralLoose(["\n  padding-top: 8px;\n"])));
var ErrorPlaceHolder = styled(View$1)(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteralLoose(["\n  margin-top: 4px;\n  height: 20px;\n"])));

var formItem = function formItem(props) {
  var hasError = props.hasError,
      error = props.error,
      className = props.className,
      children = props.children,
      style = props.style;
  return /*#__PURE__*/React.createElement(Content$j, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(formLabelWithCallout, props), /*#__PURE__*/React.createElement(FieldWrapper, null, /*#__PURE__*/React.cloneElement(children, {
    hasError: hasError,
    error: error
  })), hasError && /*#__PURE__*/React.createElement(ErrorPlaceHolder, null, isFunction(error) ? error() : /*#__PURE__*/React.createElement(errorMsg, null, " ", error, " ")));
};

formItem.defaultProps = {
  hasError: false
};
formItem.propTypes = {
  label: PropTypes__default.string.isRequired,
  tip: PropTypes__default.string,
  error: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.func]),
  hasError: PropTypes__default.bool,
  linkText: PropTypes__default.string,
  linkTarget: PropTypes__default.string,
  linkUnderline: PropTypes__default.bool,
  href: PropTypes__default.string,
  onClick: PropTypes__default.func,
  required: PropTypes__default.bool,
  className: PropTypes__default.string,
  style: PropTypes__default.string
};

var REQUIRED_PASSWORD_MESSAGE = 'Campo obrigatório. Informe sua senha.';
var SHORT_PASSWORD_MESSAGE = 'Senha muito curta. Use 8 ou mais caracteres.';
var NUMBER_SEQUENCE_PASSWORD_MESSAGE = 'Não use números em sequência.';
var LETTERS_SEQUENCE_PASSWORD_MESSAGE = 'Não use letras em sequência.';
var KEYBOARD_SEQUENCE_PASSWORD_MESSAGE = 'Não use sequências do teclado.';
var VERY_WEAK_PASSWORD_MESSAGE = 'Senha muito fraca. Experimente usar letras e números.';
var WEAK_PASSWORD_MESSAGE = 'Senha fraca. Tente usar maiúsculo, minúsculo e símbolos.';
var GOOD_PASSWORD_MESSAGE = 'Senha ok. Experimente colocar mais caracteres.';
var STRONG_PASSWORD_MESSAGE = 'Senha forte. Excelente!';

var isSequenceOfNumbers = function isSequenceOfNumbers(pattern) {
  return pattern.test('0123456789') || pattern.test('9876543210');
};

var isSequenceOfLetters = function isSequenceOfLetters(pattern) {
  return pattern.test('abcdefghijklmnopqrstuvwxyz') || pattern.test('zyxwvutsrqponmlkjihgfedcba');
};

var isSequenceOfKeys = function isSequenceOfKeys(pattern) {
  return pattern.test('qwertyuiop') || pattern.test('asdfghjkl') || pattern.test('zxcvbnm') || pattern.test('poiuytrewq') || pattern.test('lkjhgfdsa') || pattern.test('mnbvcxz');
};

var hasMinimumCharacteres = function hasMinimumCharacteres(value) {
  return value.length >= 8;
};
var hasNumbers = function hasNumbers(value) {
  return /\d/.test(value);
};
var hasLowerCase = function hasLowerCase(value) {
  return /[a-z]/.test(value);
};
var hasUpperCase = function hasUpperCase(value) {
  return /[A-Z]/.test(value);
};
var hasSymbols = function hasSymbols(value) {
  return /[^a-z\d]/i.test(value);
};

var countMatch = function countMatch(password) {
  return [hasNumbers(password), hasLowerCase(password), hasUpperCase(password), hasSymbols(password)].filter(Boolean).length;
};

var isVeryWeakPassword = function isVeryWeakPassword(password) {
  return countMatch(password) <= 1;
};

var isWeakPassword = function isWeakPassword(password) {
  return countMatch(password) <= 3;
};

var isGoodPassword = function isGoodPassword(password) {
  return countMatch(password) >= 3 && password.length < 12;
};

var groupLength = 4;

var safeRegex = function safeRegex(item) {
  return item.replace(/(.)/g, '[$1]');
};

var fakePattern = {
  test: function test() {
    return false;
  }
};

var createPattern = function createPattern(pass) {
  try {
    if (pass.length < groupLength) {
      return fakePattern;
    }

    var len = pass.length - (groupLength - 1);
    var prePattern = Array(len).fill(pass).map(function (item, key) {
      return item.slice(key, key + groupLength);
    }).map(safeRegex).join('|');
    return new RegExp("(" + prePattern + ")", 'i');
  } catch (error) {
    return fakePattern;
  }
};

var rules = [{
  isTruth: function isTruth(test) {
    return test.password.length === 0;
  },
  strength: -3,
  message: REQUIRED_PASSWORD_MESSAGE
}, {
  isTruth: function isTruth(test) {
    return !hasMinimumCharacteres(test.password);
  },
  strength: -2,
  message: SHORT_PASSWORD_MESSAGE
}, {
  isTruth: function isTruth(test) {
    return isSequenceOfNumbers(test.pattern);
  },
  strength: -1,
  message: NUMBER_SEQUENCE_PASSWORD_MESSAGE
}, {
  isTruth: function isTruth(test) {
    return isSequenceOfLetters(test.pattern);
  },
  strength: -1,
  message: LETTERS_SEQUENCE_PASSWORD_MESSAGE
}, {
  isTruth: function isTruth(test) {
    return isSequenceOfKeys(test.pattern);
  },
  strength: -1,
  message: KEYBOARD_SEQUENCE_PASSWORD_MESSAGE
}, {
  isTruth: function isTruth(test) {
    return isVeryWeakPassword(test.password);
  },
  strength: 1,
  message: VERY_WEAK_PASSWORD_MESSAGE
}, {
  isTruth: function isTruth(test) {
    return isWeakPassword(test.password);
  },
  strength: 2,
  message: WEAK_PASSWORD_MESSAGE
}, {
  isTruth: function isTruth(test) {
    return isGoodPassword(test.password);
  },
  strength: 3,
  message: GOOD_PASSWORD_MESSAGE
}];

var findFirstCase = function findFirstCase(password, pattern) {
  return rules.reduce(function (result, item) {
    return result === null && item.isTruth({
      password: password,
      pattern: pattern
    }) ? item : result;
  }, null);
};

var checkStrength = function checkStrength(password) {
  var defaultResult = {
    strength: 4,
    message: STRONG_PASSWORD_MESSAGE
  };
  var result = findFirstCase(password, createPattern(password));
  return result === null ? defaultResult : result;
};
var isValidEmail = function isValidEmail(emailParam) {
  var email = emailParam.toLowerCase().trim();
  return !!email && typeof email.match === 'function' && !!email.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,7})$/);
};
var isValidPasswordByTest = function isValidPasswordByTest(passwordSecurityVersion) {
  return passwordSecurityVersion === 'oldLayoutPasswordStrong' || passwordSecurityVersion === 'newLayoutPasswordWeak' || passwordSecurityVersion === 'newLayoutPasswordStrong';
};
var maxNumbers = function maxNumbers(value, n) {
  var numbers = value.match(/\d+/g);
  return numbers && numbers.length ? numbers.join('').length <= n : true;
};
var isValidNickname = function isValidNickname(value) {
  return value.length >= 3 && maxNumbers(value, 5);
};

var validValue = function validValue(value) {
  return typeof value === 'string' ? value.length >= 3 && maxNumbers(value, 5) : !!value;
};

var onFieldChange = function onFieldChange(onChange) {
  return function (event) {
    if (onChange) {
      var value = event.target.value;
      var isValid = validValue(value);
      onChange(value, isValid);
    }
  };
};

var onFieldBlur = function onFieldBlur(onBlur) {
  return function (event) {
    if (event.type === 'change' && event.isTrusted) return;

    if (onBlur) {
      var value = event.target.value;
      var isValid = validValue(value);
      onBlur(value, isValid);
    }
  };
};

var handleError = function handleError(error) {
  return typeof error == 'function' ? error() : error;
};

var NicknameFormItem = function NicknameFormItem(_ref) {
  var error = _ref.error,
      hasError = _ref.hasError,
      tip = _ref.tip,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      inputRef = _ref.inputRef,
      autoComplete = _ref.autoComplete;
  return /*#__PURE__*/React.createElement(formItem, {
    label: "Apelido",
    tip: tip
  }, /*#__PURE__*/React.createElement(TextInput$1, {
    placeholder: "Exemplo: Jo\xE3o S.",
    "aria-label": "Apelido",
    value: value,
    maxLength: 100,
    onChange: onFieldChange(onChange),
    onBlur: onFieldBlur(onBlur),
    disabled: disabled,
    ref: inputRef,
    autoComplete: autoComplete,
    id: "nickname",
    state: hasError ? 'error' : '',
    stateMessage: handleError(error) || 'Por favor, preencha ao menos 3 caracteres.'
  }));
};

NicknameFormItem.defaultProps = {
  tip: 'Como aparecerá em seus anúncios.',
  inputRef: function inputRef() {
    return null;
  },
  abTests: ''
};
NicknameFormItem.propTypes = {
  onChange: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  hasError: PropTypes__default.bool,
  value: PropTypes__default.string,
  blurOnSubmit: PropTypes__default.bool,
  onSubmitEditing: PropTypes__default.func,
  abTests: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  inputRef: PropTypes__default.func,
  autoComplete: PropTypes__default.bool,
  error: PropTypes__default.string,
  tip: PropTypes__default.string
};

var API_ENDPOINT$4 = '/accounts/update';
var updateAccount = (function (data) {
  return axios.patch(API_ENDPOINT$4, data, {
    withCredentials: true,
    headers: {
      'Content-type': 'application/json'
    }
  }).then(function (response) {
    return response.data;
  });
});

var VALID_DDD = '([14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])';
var VALID_MOBILE_NUMBER = "(" + VALID_DDD + "9[1-9]\\d{7})";
var VALID_SPECIALIZED_MOBILE_SERVICE = '(' + '1[1-9]7[0789]|' + '2[124]7[078]|' + '3[147]7[78]|' + '(' + '27|' + '4[1-478]|' + '5[14]|' + '6[125]|' + '7[135]|' + '8[15]' + ')78' + ')\\d{6}';
var MOBILE_NUMBER = new RegExp("^(" + VALID_MOBILE_NUMBER + "|" + VALID_SPECIALIZED_MOBILE_SERVICE + ")$");
var LANDLINE_NUMBER = new RegExp("^" + VALID_DDD + "[2345]\\d{7}$");
var TOLL_FREE_NUMBER = new RegExp('^0800\\d{7}$');
var NATIONAL_NUMBER = new RegExp('^4004\\d{4}$');
var removeMask = function removeMask(value) {
  return typeof value === 'string' ? value.replace(/[^\d\*]/g, '') : '';
};
var isMobileNumber = function isMobileNumber(phoneNumber) {
  return !!MOBILE_NUMBER.exec(phoneNumber);
};
var isLandlineNumber = function isLandlineNumber(phoneNumber) {
  return !!LANDLINE_NUMBER.exec(phoneNumber);
};
var isTollFreeNumber = function isTollFreeNumber(phoneNumber) {
  return !!TOLL_FREE_NUMBER.exec(phoneNumber);
};
var isNationalNumber = function isNationalNumber(phoneNumber) {
  return !!NATIONAL_NUMBER.exec(phoneNumber);
};
var isLandline = function isLandline(phone) {
  return /^\d+$/.test(removeMask(phone)) && removeMask(phone).length === 10;
};
var isValid = function isValid(phoneNumber) {
  return isLandlineNumber(phoneNumber) || isMobileNumber(phoneNumber) || isTollFreeNumber(phoneNumber) || isNationalNumber(phoneNumber);
};
var getMaskedValue = function getMaskedValue(value, allowTollFree) {
  if (allowTollFree === void 0) {
    allowTollFree = false;
  }

  var inputValue = value.replace(/[^\d\*]/g, '');
  var ret = {
    pretty: inputValue,
    clean: inputValue
  };

  if (inputValue.length >= 3) {
    var isTollFree = allowTollFree && inputValue.substr(0, 4) === '0800';
    var isNational = inputValue.substr(0, 4) === '4004';

    if (isNational) {
      var prefix = inputValue.substr(0, 4);
      var sufix = inputValue.gfsubstr(4, 4);
      ret.pretty = (prefix + " " + sufix).trimEnd();
    } else if (isTollFree) {
      var _prefix = inputValue.substr(0, 4);

      var first = inputValue.substr(4, 3);
      var second = inputValue.substr(7, 4);
      ret.pretty = (_prefix + " " + first + "-" + second).trimEnd();
    } else {
      var ddd = inputValue.substr(0, 2);
      var rest = inputValue.substr(2);
      var isNineDigitNumber = rest.length >= 9 && (rest.startsWith('9') || rest.startsWith('*'));

      if (isNineDigitNumber) {
        rest = rest.substr(0, 9);
      } else {
        rest = rest.substr(0, 8);
      }

      var restOutput = rest;

      if (rest.length >= 8) {
        var dividerIndex = Math.ceil(rest.length / 2);
        restOutput = rest.substr(0, dividerIndex) + "-" + rest.substr(dividerIndex);
      }

      ret.pretty = "(" + ddd + ") " + restOutput;
      ret.clean = ddd + rest;
    }
  }

  return ret;
};

var _templateObject$X, _templateObject2$B;
var GeneroRow = styled(View$1)(_templateObject$X || (_templateObject$X = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 8px;\n\n  ", "\n"])), mediaQuery.small(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteralLoose(["\n    flex-direction: column;\n    &>*+* {\n      margin-top: 28px;\n    }\n  "]))));

var SecurityShield = function SecurityShield() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "0.1",
    d: "M48.1151 87.3105C69.7621 87.3105 87.3105 69.7621 87.3105 48.1151C87.3105 26.468 69.7621 8.91956 48.1151 8.91956C26.468 8.91956 8.91956 26.468 8.91956 48.1151C8.91956 69.7621 26.468 87.3105 48.1151 87.3105Z",
    fill: "#6E0AD6",
    stroke: "#6E0AD6",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0265 31.3447L39.151 39.3458L32.5984 40.2667L31.3576 31.4379C31.3576 31.4379 29.3372 14.5597 45.6841 12.2623C62.0311 9.96486 64.9019 25.3872 64.9019 25.3872L66.3366 35.5954L59.715 36.526L58.2998 26.4557C58.2998 26.4557 56.1526 17.684 47.1169 18.9539C38.0813 20.2238 37.7573 28.4284 38.0265 31.3447Z",
    fill: "#6E0AD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6926 37.6512L34.9931 39.7895",
    stroke: "white",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0525 35.2255L31.3707 40.2402C24.3834 41.2222 21.8443 45.9916 22.6045 51.4005L25.8637 74.591C26.6144 79.9323 31.6871 83.3443 37.3174 82.553L72.9992 77.5383C78.5591 76.7569 82.8388 74.0158 81.1151 66.826L77.8559 43.6354C76.9299 37.0467 74.3894 34.1944 67.0525 35.2255ZM55.3289 59.5565C55.2071 59.7115 55.0854 59.8665 55.1139 60.0693L55.931 65.8838C56.1211 67.2361 55.1566 68.5437 53.6786 68.7514L52.8341 68.8701C51.4265 69.0679 50.078 68.1543 49.8785 66.7345L49.0613 60.9199C49.0328 60.7171 48.9434 60.5918 48.7133 60.4862C46.1114 59.3351 44.6376 56.5086 45.5148 53.5585C46.061 51.827 47.4287 50.3248 49.2111 49.7296C52.9678 48.3743 56.8155 50.7293 57.3191 54.3126C57.5946 56.2733 56.7955 58.2472 55.3289 59.5565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7103 43.6964C25.827 42.1327 27.6322 40.9646 29.7015 40.6738L69.2928 35.1096C73.3623 34.5377 77.1384 37.3832 77.7103 41.4526L81.5588 68.8355C82.1307 72.905 79.2852 76.6811 75.2157 77.253L37.3487 82.5749",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3959 35.5167L65.1066 26.3431C63.798 17.0316 55.1445 10.5107 45.8329 11.8193C36.5213 13.128 29.9315 21.7912 31.2401 31.1027L32.5294 40.2763L39.2889 39.3263L37.9996 30.1527C37.2048 24.4968 41.1173 19.3047 46.7732 18.5098C52.4291 17.715 57.6212 21.6275 58.4161 27.2834L59.7054 36.457",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4358 68.9194C52.0563 69.1133 50.7286 68.1745 50.525 66.726L49.6914 60.7942C49.6623 60.5873 49.5739 60.459 49.3476 60.3502C46.7892 59.1623 45.3281 56.2728 46.1722 53.2704C46.6983 51.5084 48.0315 49.9846 49.7764 49.3877C53.4537 48.0269 57.2405 50.4488 57.7543 54.1044C58.0354 56.1047 57.2625 58.1124 55.7623 59.4487C55.6437 59.606 55.5251 59.7633 55.5542 59.9703L56.3879 65.9021C56.5818 67.2815 55.643 68.6092 54.1945 68.8128L53.4358 68.9194Z",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.408 48.9437C23.408 48.9437 16.773 55.7845 10.4963 56.6666L12.5611 71.3582C12.9876 74.393 14.6169 76.9775 16.9781 78.2634C19.3393 79.5494 26.5025 82.9738 26.7978 83.073L28.3033 83.7758L29.5568 82.6853C29.8036 82.4396 35.7552 77.2422 37.7297 75.2767C39.5857 73.4684 40.5085 70.5252 40.0722 67.4214L38.0172 52.7988C31.6715 53.6906 23.408 48.9437 23.408 48.9437Z",
    fill: "#6E0AD6",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0882 66.3614L25.3493 70.2642L31.7516 61.7681",
    stroke: "white",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2237 18.2344C34.8275 21.5955 33.1416 26.6153 33.888 31.9264L34.363 35.3061",
    stroke: "white",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1589 47.7775L76.3213 63.164",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9111 67.3603L77.3042 70.1578",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconShield = function IconShield() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "#F7F1FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7236 22.1139C15.5829 22.1842 15.4172 22.1842 15.2764 22.1139C15.2287 22.09 15.1444 22.0457 15.0287 21.9817C14.8389 21.8766 14.6282 21.753 14.4017 21.6115C13.7554 21.2075 13.1092 20.739 12.5041 20.2096C10.7396 18.6656 9.66669 16.9222 9.66669 15V9.66665C9.66669 9.43721 9.82284 9.23722 10.0454 9.18158L15.3788 7.84824C15.4584 7.82834 15.5417 7.82834 15.6213 7.84824L20.9546 9.18158C21.1772 9.23722 21.3334 9.43721 21.3334 9.66665V15C21.3334 16.9222 20.2605 18.6656 18.4959 20.2096C17.8909 20.739 17.2447 21.2075 16.5984 21.6115C16.3719 21.753 16.1611 21.8766 15.9713 21.9817C15.8557 22.0457 15.7714 22.09 15.7236 22.1139ZM16.0684 20.7635C16.672 20.3862 17.2758 19.9484 17.8374 19.457C19.4062 18.0843 20.3334 16.5778 20.3334 15V10.057L15.5 8.8487L10.6667 10.057V15C10.6667 16.5778 11.5938 18.0843 13.1626 19.457C13.7242 19.9484 14.328 20.3862 14.9317 20.7635C15.1375 20.8921 15.3286 21.0044 15.5 21.0996C15.6715 21.0044 15.8626 20.8921 16.0684 20.7635Z",
    fill: "#6E0AD6"
  }));
};

var _templateObject$Y, _templateObject2$C, _templateObject3$q, _templateObject4$h, _templateObject5$e, _templateObject6$9, _templateObject7$9;
var Container$2 = styled(View$1)(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteralLoose(["\n  height: 434px;\n  display: flex;\n  flex-direction: column;\n"])));
var LinkInstructionContent = styled(Link$2)(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteralLoose(["\n  border: 1px solid #e5e5e5;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: normal;\n  padding: 16px;\n  margin-top: 10px;\n  margin-bottom: 30px;\n\n  :hover {\n    background: #f9f9f9;\n    text-decoration: none;\n  }\n"])));
var IconLink = styled(View$1)(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteralLoose(["\n  margin-top: 5px;\n  width: 50px;\n  display: flex;\n  align-items: center;\n"])));
var ActionLinkInstruction = styled(Text$1)(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n  font-family: Nunito Sans;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin-left: 10px;\n"])));
var ButtonContent = styled(View$1)(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n"])));
var TitleModal = styled(Text$1)(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n  font-family: Nunito Sans;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  letter-spacing: 0px;\n  margin-top: 30px;\n  text-align: left;\n"])));
var TextModal = styled(Text$1)(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n  font-family: Nunito Sans;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  margin: 20px 0px;\n  text-align: left;\n"])));

var InstructionModal = function InstructionModal(_ref) {
  var open = _ref.open,
      onOpen = _ref.onOpen,
      onSuccessChange = _ref.onSuccessChange,
      onCancelChange = _ref.onCancelChange;
  useEffect(function () {
    if (open) onOpen();
  }, [open]);
  return /*#__PURE__*/React.createElement(Modal$1, {
    maxWidth: "600px",
    maxHeight: "600px",
    open: open,
    closeCallback: onCancelChange
  }, /*#__PURE__*/React.createElement(Container$2, null, /*#__PURE__*/React.createElement(SecurityShield, null), /*#__PURE__*/React.createElement(TitleModal, {
    fontWeight: 700
  }, "Lembre-se, sua conta \xE9 pessoal e intransfer\xEDvel"), /*#__PURE__*/React.createElement(TextModal, null, "Voc\xEA n\xE3o pode compartilhar, transferir, vender ou alugar sua conta para terceiros. A utiliza\xE7\xE3o da conta, as mensagens enviadas pelo chat e os an\xFAncios nela inseridos ser\xE3o sempre de sua responsabilidade."), /*#__PURE__*/React.createElement(LinkInstructionContent, {
    target: "_blank",
    href: "https://seguranca.olx.com.br/hubseguranca/golpe-do-aluguel-de-conta-como-funciona-como-evitar/"
  }, /*#__PURE__*/React.createElement(IconLink, null, /*#__PURE__*/React.createElement(IconShield, null)), /*#__PURE__*/React.createElement(ActionLinkInstruction, null, "Saiba como se proteger do \u201DGolpe do aluguel de conta\u201D")), /*#__PURE__*/React.createElement(ButtonContent, null, /*#__PURE__*/React.createElement(Button, {
    variant: "link-button",
    onClick: onCancelChange
  }, "Cancelar altera\xE7\xF5es"), /*#__PURE__*/React.createElement(Button, {
    marginLeft: "--spacing-1",
    onClick: onSuccessChange
  }, "Manter altera\xE7\xF5es"))));
};

InstructionModal.propTypes = {
  open: PropTypes__default.bool,
  onCancelChange: PropTypes__default.func,
  onSuccessChange: PropTypes__default.func,
  onOpen: PropTypes__default.func
};

var _templateObject$Z, _templateObject2$D, _templateObject3$r, _templateObject4$i, _templateObject5$f, _templateObject6$a, _templateObject7$a, _templateObject8$6;
var lurker$4 = new Lurker('meu_cadastro');
var Content$k = styled(View$1)(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));
var FormWrapper$2 = styled(Form)(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));
var ComponentTitle = styled(Title)(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteralLoose(["\n  margin-bottom: 24px;\n  font-size: 20px;\n  font-weight: 700;\n  text-align: left;\n"])));
var GenderWrapper = styled(View$1)(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var AccountTypeRow = styled(View$1)(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 32px 0;\n"])));
var AccountTypeText = styled(Text$1)(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteralLoose(["\n  margin: 0 8px;\n  font-size: 14px;\n  font-weight: 400;\n"])));
var ButtonWrapper$1 = styled(View$1)(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteralLoose(["\n  width: 220px;\n"])));
var GenericErrorMsgWrapper = styled(View$1)(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 24px;\n"])));

var getDocumentoMask = function getDocumentoMask(documento) {
  var value = documento;
  if (typeof value === 'number') value = String(value);
  if (typeof value !== 'string') value = '';
  var unmaskedValue = value.replace(/\D/g, '');
  return unmaskedValue.length <= 11 ? [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/] : [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
};

var getNickNameErrorMsg = function getNickNameErrorMsg(value) {
  return !value || value.length < 3 ? 'Por favor, preencha ao menos 3 caracteres.' : 'Seu apelido não pode ter mais de 5 caracteres numéricos';
};

var MyAccount = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MyAccount, _React$Component);

  function MyAccount(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onFullnameChange = _this.onFullnameChange.bind(_assertThisInitialized(_this));
    _this.onFullNameBlur = _this.onFullNameBlur.bind(_assertThisInitialized(_this));
    _this.onNicknameChange = _this.onNicknameChange.bind(_assertThisInitialized(_this));
    _this.onNicknameBlur = _this.onNicknameBlur.bind(_assertThisInitialized(_this));
    _this.onPhoneChange = _this.onPhoneChange.bind(_assertThisInitialized(_this));
    _this.onPhoneBlur = _this.onPhoneBlur.bind(_assertThisInitialized(_this));
    _this.onCreciChange = _this.onCreciChange.bind(_assertThisInitialized(_this));
    _this.onCreciBlur = _this.onCreciBlur.bind(_assertThisInitialized(_this));
    _this.onGenderChange = _this.onGenderChange.bind(_assertThisInitialized(_this));
    _this.onBirthDayChange = _this.onBirthDayChange.bind(_assertThisInitialized(_this));
    _this.onBirthDayBlur = _this.onBirthDayBlur.bind(_assertThisInitialized(_this));
    _this.onBirthMonthChange = _this.onBirthMonthChange.bind(_assertThisInitialized(_this));
    _this.onBirthMonthBlur = _this.onBirthMonthBlur.bind(_assertThisInitialized(_this));
    _this.onBirthYearChange = _this.onBirthYearChange.bind(_assertThisInitialized(_this));
    _this.onBirthYearBlur = _this.onBirthYearBlur.bind(_assertThisInitialized(_this));
    _this.onSubmitClick = _this.onSubmitClick.bind(_assertThisInitialized(_this));
    _this.onCancelClick = _this.onCancelClick.bind(_assertThisInitialized(_this));
    _this.onDataChange = _this.onDataChange.bind(_assertThisInitialized(_this));
    _this.doUpdateData = _this.doUpdateData.bind(_assertThisInitialized(_this));
    _this.sendRequest = _this.sendRequest.bind(_assertThisInitialized(_this));
    _this.checkFormIsValid = _this.checkFormIsValid.bind(_assertThisInitialized(_this));
    _this.updateBirthDate = _this.updateBirthDate.bind(_assertThisInitialized(_this));
    _this.state = {
      openModal: false,
      isSaving: false,
      showRateLimitError: false,
      showGenericError: false,
      showNicknameError: false,
      phoneAllowed: false,
      creciAllowed: false,
      fields: {
        fullName: {
          isValid: true,
          pristine: true,
          patch: true
        },
        nickname: {
          isValid: true,
          pristine: true,
          patch: true
        },
        documento: {
          isValid: true,
          pristine: true,
          patch: false
        },
        phone: {
          isValid: true,
          pristine: true,
          patch: false
        },
        creci: {
          isValid: true,
          pristine: true,
          patch: false
        },
        gender: {
          isValid: true,
          pristine: true,
          patch: true
        },
        birthDate: {
          isValid: true,
          pristine: true
        },
        birthDay: {
          isValid: true,
          pristine: true
        },
        birthMonth: {
          isValid: true,
          pristine: true
        },
        birthYear: {
          isValid: true,
          pristine: true
        }
      }
    };
    _this.inputs = {};
    return _this;
  }

  var _proto = MyAccount.prototype;

  _proto.onFullNameBlur = function onFullNameBlur(event) {
    var value = event.target.value;
    var names = value.toString().trim().split(' ');
    var isValid = value ? !/\d+/.test(value) && names.length > 1 && !names.some(function (x) {
      return x.length < 2;
    }) : true;
    this.updateFields('fullName', value, isValid);
  };

  _proto.onFullnameChange = function onFullnameChange(event) {
    var value = event.target.value;
    this.updateFields('fullName', value, true);
  };

  _proto.onNicknameBlur = function onNicknameBlur(value, valid) {
    var errorMsg = '';

    if (!valid) {
      errorMsg = getNickNameErrorMsg(value);
    }

    this.updateFields('nickname', value, valid, errorMsg);
  };

  _proto.onNicknameChange = function onNicknameChange(value) {
    this.updateFields('nickname', value, true);
  };

  _proto.onPhoneBlur = function onPhoneBlur(event) {
    var value = event.target.value;
    var valueWithoutMask = value.replace(/\D/g, '');
    var isValid$1 = !valueWithoutMask || isValid(valueWithoutMask);
    this.updateFields('phone', value, isValid$1);
  };

  _proto.onCreciBlur = function onCreciBlur(event) {
    var value = event.target.value;
    this.updateFields('creci', value, true);
  };

  _proto.onPhoneChange = function onPhoneChange(event) {
    var allowTollFree = this.props.allowTollFree;
    var value = event.target.value;
    value = value.replace(/\D/g, '').substr(0, 11);
    var masked = getMaskedValue(value, allowTollFree);
    this.updateFields('phone', masked.pretty, true);
  };

  _proto.onCreciChange = function onCreciChange(event) {
    var value = event.target.value;
    this.updateFields('creci', value, true);
  };

  _proto.onGenderChange = function onGenderChange(event) {
    var value = event.target.value;
    this.updateFields('gender', value, true);
  };

  _proto.onBirthDayChange = function onBirthDayChange(event) {
    var value = event.target.value;
    value = value.replace(/\D/g, '');
    this.updateFields('birthDay', value, true);
  };

  _proto.onBirthDayBlur = function onBirthDayBlur(event) {
    var value = event.target.value;
    var isValid = /^\d+$/.test(value) && parseInt(value, 10) > 0 && parseInt(value, 10) < 32;
    this.updateFields('birthDay', value, isValid);
  };

  _proto.onBirthMonthChange = function onBirthMonthChange(event) {
    var value = event.target.value;
    value = value.replace(/\D/g, '');
    this.updateFields('birthMonth', value, true);
  };

  _proto.onBirthMonthBlur = function onBirthMonthBlur(event) {
    var value = event.target.value;
    var isValid = /^\d+$/.test(value) && parseInt(value, 10) > 0 && parseInt(value, 10) < 13;
    this.updateFields('birthMonth', value, isValid);
  };

  _proto.onBirthYearChange = function onBirthYearChange(event) {
    var value = event.target.value;
    value = value.replace(/\D/g, '');
    this.updateFields('birthYear', value, true);
  };

  _proto.onBirthYearBlur = function onBirthYearBlur(event) {
    var value = event.target.value;
    var isValid = /^\d+$/.test(value) && parseInt(value, 10) > 1900 && parseInt(value, 10) < 2100;
    this.updateFields('birthYear', value, isValid);
  };

  _proto.onSubmitClick = function onSubmitClick(event) {
    event.preventDefault();
    lurker$4.clickEvt('salvar_dados_da_conta');
    this.setState({
      openModal: false
    });
    this.setState({
      isSaving: true
    }, this.doUpdateData);
  };

  _proto.onDataChange = function onDataChange(event) {
    var _this2 = this;

    event.preventDefault();
    this.checkFormIsValid().then(function () {
      return _this2.setState({
        openModal: true
      });
    })["catch"](function () {});
  };

  _proto.onCancelClick = function onCancelClick(event) {
    if (event) {
      event.preventDefault();
    }

    lurker$4.clickEvt('cancela_salvar_dados_da_conta');
    this.setState({
      openModal: false
    });
  };

  MyAccount.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var fields = state.fields;
    var fieldsToPopulate = Object.keys(fields).reduce(function (obj, field) {
      if (typeof props[field] !== 'undefined' && fields[field].pristine) {
        var _extends2;

        var value = props[field];

        if (field === 'documento') {
          var mask = getDocumentoMask(value);
          value = applyMask(value, null, mask);
        }

        if (field === 'phone' && value) {
          value = getMaskedValue(value, props.allowTollFree).pretty;
        }

        return _extends({}, obj, (_extends2 = {}, _extends2[field] = _extends({}, fields[field], {
          value: value
        }), _extends2));
      }

      return obj;
    }, {});
    return {
      fields: _extends({}, fields, fieldsToPopulate),
      phoneAllowed: props.showPhone,
      creciAllowed: props.showCreci,
      allowTollFree: props.allowTollFree
    };
  };

  _proto.sendRequest = function sendRequest() {
    var _this3 = this;

    var _this$state = this.state,
        fields = _this$state.fields,
        phoneAllowed = _this$state.phoneAllowed,
        creciAllowed = _this$state.creciAllowed;
    var _this$props = this.props,
        onSuccess = _this$props.onSuccess,
        onError = _this$props.onError;
    var patchParams = Object.keys(fields).reduce(function (acc, item) {
      var field = fields[item];

      if (field.patch) {
        acc[item] = field.value;
      }

      return acc;
    }, {});
    patchParams.cpf = undefined;
    patchParams.cnpj = undefined;
    var phoneValue = fields.phone.value;

    if (phoneAllowed && phoneValue && phoneValue.trim().length > 0) {
      patchParams.phone = phoneValue;
    }

    if (creciAllowed) {
      patchParams.creci = null;
      var creciValue = fields.creci.value;

      if (creciValue && creciValue.trim().length > 0) {
        patchParams.creci = creciValue.trim();
      }
    }

    this.setState({
      isSaving: true
    });
    updateAccount(patchParams).then(function (data) {
      _this3.setState({
        showGenericError: false,
        showNicknameError: false,
        showRateLimitError: false
      }, function () {
        if (onSuccess) {
          onSuccess(data, patchParams);
        }
      });
    })["catch"](function (data) {
      if (onError) onError(data);

      if (data && data.response && data.response.status === 428) {
        _this3.setState({
          showRateLimitError: true
        });
      } else if (data && data.response && data.response.status === 403) {
        var error = data.response.data && data.response.data.message ? data.response.data.message : null;

        if (error === 'NICKNAME_IN_BLACKLIST') {
          _this3.updateFields('nickname', fields.nickname.value, false, 'Este apelido não pode ser utilizado.');

          _this3.setState({
            showNicknameError: true
          });
        } else {
          _this3.setState({
            showGenericError: true
          });
        }
      } else {
        _this3.setState({
          showGenericError: true
        });
      }
    })["finally"](function () {
      return _this3.setState({
        isSaving: false
      });
    });
  };

  _proto.doUpdateData = function doUpdateData() {
    this.checkFormIsValid().then(this.sendRequest)["catch"](function () {});
  };

  _proto.checkFormIsValid = function checkFormIsValid() {
    var _this4 = this;

    return new Promise(function (resolve, reject) {
      var allValid = true;
      var fields = _this4.state.fields;
      var updatedFields = Object.keys(fields).reduce(function (obj, field) {
        var _extends3;

        var newField = _extends({}, fields[field], {
          pristine: false
        });

        var isValid = fields[field].isValid;

        if (!isValid) {
          allValid = false;
        }

        return _extends({}, obj, (_extends3 = {}, _extends3[field] = newField, _extends3));
      }, {});

      if (allValid) {
        resolve();
      } else {
        _this4.setState({
          fields: updatedFields,
          isSaving: false
        }, reject);
      }
    });
  };

  _proto.updateBirthDate = function updateBirthDate() {
    var _this$state$fields = this.state.fields,
        birthDay = _this$state$fields.birthDay,
        birthMonth = _this$state$fields.birthMonth,
        birthYear = _this$state$fields.birthYear;

    if (birthYear.value && birthMonth.value && birthDay.value) {
      var year = parseInt(birthYear.value, 10);
      var month = parseInt(birthMonth.value, 10) - 1;
      var day = parseInt(birthDay.value, 10);
      var date = new Date();
      date.setFullYear(year, month, day);
      var valid = date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
      this.updateFields('birthDate', date, valid);
    }
  };

  _proto.updateFields = function updateFields(field, value, isValid, message) {
    this.updateFieldValue(field, value, isValid, false, message);
  };

  _proto.updateFieldValue = function updateFieldValue(field, value, isValid, pristine, message) {
    var _extends4;

    var fields = _extends({}, this.state.fields);

    var newField = _extends({}, fields[field], {
      value: value
    });

    if (isValid !== undefined) {
      newField.isValid = isValid;
    }

    if (pristine !== undefined) {
      newField.pristine = pristine;
    }

    if (message !== undefined) {
      newField.msg = message;
    }

    this.setState({
      fields: _extends({}, fields, (_extends4 = {}, _extends4[field] = newField, _extends4))
    });
  };

  _proto.updateFocus = function updateFocus(input) {
    if (this.inputs && this.inputs[input] && this.inputs[input].focus) {
      this.inputs[input].focus();
    }
  };

  _proto.render = function render() {
    var _this5 = this;

    var _this$state2 = this.state,
        isSaving = _this$state2.isSaving,
        showGenericError = _this$state2.showGenericError,
        showNicknameError = _this$state2.showNicknameError,
        showRateLimitError = _this$state2.showRateLimitError,
        fields = _this$state2.fields,
        openModal = _this$state2.openModal;
    var fullName = fields.fullName,
        nickname = fields.nickname,
        gender = fields.gender,
        documento = fields.documento,
        phone = fields.phone,
        creci = fields.creci;
    var fullNameHasError = !fullName.isValid && !fullName.pristine;
    var nicknameHasError = !nickname.isValid && !nickname.pristine;
    var phoneHasError = !phone.isValid && !phone.pristine;
    var creciHasError = !creci.isValid && !creci.pristine;
    var isFormDisabled = isSaving || this.props.disabled;
    var _this$props2 = this.props,
        isCompany = _this$props2.isCompany,
        loading = _this$props2.loading,
        showPhone = _this$props2.showPhone,
        showCreci = _this$props2.showCreci,
        showDoc = _this$props2.showDoc,
        cpfVerified = _this$props2.cpfVerified,
        abTests = _this$props2.abTests;

    if (loading) {
      return /*#__PURE__*/React.createElement(Content$k, null, /*#__PURE__*/React.createElement(FormSkeleton, {
        type: "form",
        size: "5"
      }));
    }

    return /*#__PURE__*/React.createElement(Content$k, null, /*#__PURE__*/React.createElement(InstructionModal, {
      open: openModal,
      onOpen: function onOpen() {
        return lurker$4.viewMessageEvt('show_modal_salvar_dados_da_conta');
      },
      onSuccessChange: this.onSubmitClick,
      onCancelChange: this.onCancelClick
    }), /*#__PURE__*/React.createElement(ComponentTitle, null, "Dados da conta"), showGenericError && /*#__PURE__*/React.createElement(GenericErrorMsgWrapper, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel salvar seus dados."
    })), showNicknameError && /*#__PURE__*/React.createElement(GenericErrorMsgWrapper, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "Este apelido n\xE3o pode ser utilizado."
    })), showRateLimitError && /*#__PURE__*/React.createElement(GenericErrorMsgWrapper, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
    })), /*#__PURE__*/React.createElement(FormWrapper$2, {
      onSubmit: this.onDataChange
    }, /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-fullName",
      label: "Nome completo",
      onBlur: this.onFullNameBlur,
      onChange: this.onFullnameChange,
      value: fullName.value,
      disabled: isFormDisabled || cpfVerified,
      maxLength: 100,
      state: fullNameHasError && 'error',
      stateMessage: fullNameHasError && 'Por favor, preencha um nome válido'
    }), /*#__PURE__*/React.createElement(NicknameFormItem, {
      hasError: nicknameHasError,
      onChange: this.onNicknameChange,
      onBlur: this.onNicknameBlur,
      value: nickname.value,
      disabled: isFormDisabled,
      error: nickname.msg,
      tip: "(obrigat\xF3rio) Como aparecer\xE1 nos seus an\xFAncios.",
      inputRef: function inputRef(x) {
        _this5.inputs.nickname = x;
      },
      blurOnSubmit: !(showCreci || showPhone),
      onSubmitEditing: function onSubmitEditing() {
        if (showCreci) {
          _this5.updateFocus('creci');
        } else if (showPhone) {
          _this5.updateFocus('phone');
        }
      },
      abTests: abTests
    }), showDoc && /*#__PURE__*/React.createElement(TextInput$1, {
      disabled: true,
      value: documento.value,
      type: "tel",
      ref: function ref(x) {
        _this5.inputs.document = x;
      },
      label: "CPF / CNPJ",
      id: "input-document"
    }), showCreci && /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-creci",
      label: "CRECI (Apenas para corretores de im\xF3veis.)",
      onBlur: this.onCreciBlur,
      onChange: this.onCreciChange,
      disabled: isFormDisabled,
      value: creci.value,
      maxLength: 20,
      ref: function ref(x) {
        _this5.inputs.creci = x;
      },
      state: creciHasError ? 'error' : '',
      stateMessage: creci.msg || 'Digite um CRECI válido',
      marginTop: "--spacing-1"
    }), showPhone && /*#__PURE__*/React.createElement(TextInput$1, {
      id: "input-phone",
      label: "Telefone",
      onBlur: this.onPhoneBlur,
      onChange: this.onPhoneChange,
      disabled: isFormDisabled,
      value: phone.value,
      type: "tel",
      ref: function ref(x) {
        _this5.inputs.phone = x;
      },
      state: phoneHasError ? 'error' : '',
      stateMessage: phone.msg || 'Digite um telefone válido',
      marginTop: "--spacing-1"
    }), /*#__PURE__*/React.createElement(GenderWrapper, null, /*#__PURE__*/React.createElement(Text.BodyMedium, {
      weight: "semibold"
    }, "G\xEAnero"), /*#__PURE__*/React.createElement(GeneroRow, null, /*#__PURE__*/React.createElement(Radio, {
      label: "Feminino",
      name: "gender",
      value: "female",
      checked: gender.value === 'female',
      onChange: this.onGenderChange,
      disabled: isFormDisabled,
      "aria-label": "G\xEAnero feminino"
    }), /*#__PURE__*/React.createElement(Radio, {
      label: "Masculino",
      name: "gender",
      value: "male",
      checked: gender.value === 'male',
      onChange: this.onGenderChange,
      disabled: isFormDisabled,
      "aria-label": "G\xEAnero masculino"
    }), /*#__PURE__*/React.createElement(Radio, {
      label: "N\xE3o informar",
      name: "gender",
      value: "",
      checked: gender.value == null || gender.value === '',
      onChange: this.onGenderChange,
      disabled: isFormDisabled,
      "aria-label": "G\xEAnero n\xE3o informado"
    }))), /*#__PURE__*/React.createElement(AccountTypeRow, null, /*#__PURE__*/React.createElement(Label$1, {
      fontWeight: 700
    }, "Tipo de conta"), /*#__PURE__*/React.createElement(AccountTypeText, null, isCompany ? 'Profissional' : 'Particular')), /*#__PURE__*/React.createElement(ButtonWrapper$1, null, /*#__PURE__*/React.createElement(Button, {
      disabled: isFormDisabled,
      isLoading: isSaving,
      onClick: this.onDataChange,
      size: "large",
      fullWidth: true
    }, "Salvar altera\xE7\xF5es"))));
  };

  return MyAccount;
}(React.Component);

MyAccount.propTypes = {
  fullName: PropTypes__default.string,
  nickname: PropTypes__default.string,
  gender: PropTypes__default.string,
  documento: PropTypes__default.string,
  isCompany: PropTypes__default.bool,
  birthDay: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  birthMonth: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  birthYear: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  disabled: PropTypes__default.bool,
  loading: PropTypes__default.bool,
  showPhone: PropTypes__default.bool,
  showCreci: PropTypes__default.bool,
  showDoc: PropTypes__default.bool,
  allowTollFree: PropTypes__default.bool,
  cpfVerified: PropTypes__default.bool,
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  abTests: PropTypes__default.string
};
MyAccount.defaultProps = {
  isCompany: false,
  loading: false,
  showPhone: false,
  showCreci: false,
  showDoc: false,
  allowTollFree: false
};

var _templateObject$_, _templateObject2$E, _templateObject3$s, _templateObject4$j, _templateObject5$g, _templateObject6$b, _templateObject7$b;
var lurker$5 = new Lurker('meu_cadastro');
var Content$l = styled(View$1)(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n"])));
var IconWrapper$2 = styled(View$1)(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteralLoose(["\n  width: 24px;\n  height: 24px;\n  margin-right: 16px;\n"])));
var Row$6 = styled(View$1)(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  margin-bottom: 8px;\n"])));
var Col$1 = styled(View$1)(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"])));
var StyledText = styled(Text$1)(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n"])));
var TitleText = styled(StyledText)(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  font-weight: 700;\n"])));
var Description$5 = styled(StyledText)(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  line-height: ", ";\n  color: #999999;\n"])), function () {
  return '1.5';
});

var handleDeleteClick = function handleDeleteClick() {
  lurker$5.clickEvt('excluir_conta');
};

var MyAccountDisableTemplate = function MyAccountDisableTemplate() {
  return /*#__PURE__*/React.createElement(Content$l, null, /*#__PURE__*/React.createElement(IconWrapper$2, null, /*#__PURE__*/React.createElement(Icon, {
    width: 24,
    height: 24,
    color: "#ff3b3c",
    svgPath: WarningSvgPath
  })), /*#__PURE__*/React.createElement(Col$1, null, /*#__PURE__*/React.createElement(Row$6, null, /*#__PURE__*/React.createElement(TitleText, {
    id: "text-deactivate-my-account"
  }, "Desativar minha conta"), /*#__PURE__*/React.createElement(Link$2, {
    href: deactivateAccount,
    onClick: handleDeleteClick,
    size: "small",
    "aria-labelledby": "text-deactivate-my-account",
    "aria-describedby": "text-deactivate-my-account-description"
  }, "desativar")), /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Description$5, {
    id: "text-deactivate-my-account-description"
  }, "Seu perfil ser\xE1 desabilitado e an\xFAncios exclu\xEDdos.", '\n', "Voc\xEA pode reativar sua conta quando quiser."))));
};

var facebookSvgPath = 'M8.06658388,24 L8.06658388,13.0674637 L11.756254,13.0674637 L12.3070237,8.78803124 L8.06658388,8.78803124 L8.06658388,6.06342678 C8.06658388,4.8254133 8.41264277,3.98707346 10.1868038,3.98707346 L12.4532458,3.98707346 L12.4532458,0.165803515 C11.3602506,0.052837448 10.2620638,-0.00247862868 9.16324936,8.51757899e-05 C5.90249733,8.51757899e-05 3.67992195,1.98870525 3.67992195,5.63938279 L3.67992195,8.78803124 L0,8.78803124 L0,13.0674637 L3.67992195,13.0674637 L3.67992195,24 L8.06658388,24 Z';

var _templateObject$$, _templateObject2$F;
var FacebookIcon = styled(View$1)(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: flex-end;\n  bottom: 0;\n  right: 0;\n  width: 15px;\n  height: 15px;\n  max-height: 15px;\n  background-color: #4267b2;\n  padding-right: 3px;\n"])));
var Logo = styled(SVG)(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteralLoose(["\n  width: 6px;\n  height: 12px;\n"])));

var FBLogo = function FBLogo() {
  return /*#__PURE__*/React.createElement(Logo, {
    color: "#FFFFFF",
    width: 6.2,
    height: 12,
    viewBox: "0 0 12 24",
    svgPath: facebookSvgPath
  });
};

var facebookSquare = function facebookSquare() {
  return /*#__PURE__*/React.createElement(FacebookIcon, null, /*#__PURE__*/React.createElement(FBLogo, null));
};

var API_ENDPOINT$5 = '/v1/accounts/my/facebook';
var linkFacebook = function linkFacebook(facebookId) {
  return axios.post(API_ENDPOINT$5, {
    facebookId: facebookId
  }, {
    withCredentials: true
  }).then(function (response) {
    lastLoginStorage.saveFacebookLogin({
      facebookId: facebookId
    });
    return response;
  }).then(function (response) {
    return response.status > 199 && response.status < 400;
  });
};
var unlinkFacebook = function unlinkFacebook() {
  return axios["delete"](API_ENDPOINT$5, {}, {
    withCredentials: true
  }).then(function (response) {
    return response.status > 199 && response.status < 400;
  })["catch"](function (e) {
    return e.status > 399 && e.status < 500 ? false : e;
  });
};

var clickWrapper = function clickWrapper(checked, connectToFacebook, onFacebookConnectedChange, onClick) {
  return function () {
    if (onClick) onClick(checked);

    if (!checked) {
      connectToFacebook();
    } else {
      unlinkFacebook().then(function (result) {
        return onFacebookConnectedChange(!result);
      });
    }
  };
};

var Component = function Component(props) {
  var checked = props.checked,
      onFacebookConnectedChange = props.onFacebookConnectedChange,
      connectToFacebook = props.connectToFacebook,
      onClick = props.onClick;
  return /*#__PURE__*/React.createElement(ToggleSwitch, {
    "aria-label": "Conectar com o Facebook",
    checked: checked,
    onChange: clickWrapper(checked, connectToFacebook, onFacebookConnectedChange, onClick)
  });
};

Component.propTypes = {
  connectToFacebook: PropTypes__default.func.isRequired,
  onFacebookConnectedChange: PropTypes__default.func.isRequired,
  onClick: PropTypes__default.func,
  checked: PropTypes__default.bool
};

var callbackWrapper = function callbackWrapper(onFacebookConnectedChange, onError, onConnectStart, onConnectFinish) {
  return function (facebookResponse) {
    if (facebookResponse.status === 'unknown') return;
    if (onConnectStart) onConnectStart();
    linkFacebook(facebookResponse.id).then(function (r) {
      return onFacebookConnectedChange(r, facebookResponse.id, facebookResponse.name);
    })["catch"](function (err) {
      return onError(err);
    })["finally"](function () {
      if (onConnectFinish) onConnectFinish();
    });
  };
};

var Component$1 = function Component$1(props) {
  var facebookAppId = props.facebookAppId,
      checked = props.checked,
      onFacebookConnectedChange = props.onFacebookConnectedChange,
      onError = props.onError,
      onConnectStart = props.onConnectStart,
      onConnectFinish = props.onConnectFinish,
      onClick = props.onClick;
  return /*#__PURE__*/React.createElement(FacebookLogin, {
    appId: facebookAppId,
    autoLoad: false,
    disableMobileRedirect: true,
    callback: callbackWrapper(onFacebookConnectedChange, onError, onConnectStart, onConnectFinish),
    render: function render(renderProps) {
      return /*#__PURE__*/React.createElement(Component, {
        checked: checked,
        connectToFacebook: renderProps.onClick,
        onFacebookConnectedChange: onFacebookConnectedChange,
        onClick: onClick
      });
    }
  });
};

Component$1.propTypes = {
  facebookAppId: PropTypes__default.string.isRequired,
  onFacebookConnectedChange: PropTypes__default.func.isRequired,
  onError: PropTypes__default.func,
  onConnectStart: PropTypes__default.func,
  onConnectFinish: PropTypes__default.func,
  onClick: PropTypes__default.func,
  checked: PropTypes__default.bool
};

var userAvatar = function userAvatar(props) {
  var imageUrl = props.imageUrl;
  return /*#__PURE__*/React.createElement("img", {
    style: {
      width: 64,
      height: 64,
      borderRadius: 32
    },
    src: imageUrl,
    alt: props.alt || ''
  });
};

userAvatar.propTypes = {
  imageUrl: PropTypes__default.string.isRequired,
  alt: PropTypes__default.string
};

var _templateObject$10, _templateObject2$G;
var Content$m = styled(View$1)(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 64px;\n  height: 64px;\n"])));
var SquarePlacement = styled(View$1)(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n"])));

var facebookAvatar = function facebookAvatar(props) {
  var imageUrl = props.imageUrl;
  return /*#__PURE__*/React.createElement(Content$m, null, /*#__PURE__*/React.createElement(userAvatar, {
    imageUrl: imageUrl
  }), /*#__PURE__*/React.createElement(SquarePlacement, null, /*#__PURE__*/React.createElement(facebookSquare, null)));
};

facebookAvatar.propTypes = {
  imageUrl: PropTypes__default.string.isRequired
};

var _templateObject$11, _templateObject2$H, _templateObject3$t;
var Content$n = styled(View$1)(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  max-height: 96px;\n  flex-direction: row;\n  align-items: center;\n  background-color: #f9f9f9;\n  padding-top: 16px;\n  padding-right: 16px;\n  padding-bottom: 16px;\n  padding-left: 16px;\n"])));
var InfoBox = styled(View$1)(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-left: 24px;\n"])));
var FacebookName = styled(Subtitle)(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteralLoose(["\n  text-align: left;\n"])));

var facebookConnectedAs = function facebookConnectedAs(props) {
  var name = props.name,
      imageUrl = props.imageUrl,
      className = props.className,
      style = props.style;
  return /*#__PURE__*/React.createElement(Content$n, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(facebookAvatar, {
    imageUrl: imageUrl
  }), /*#__PURE__*/React.createElement(InfoBox, null, /*#__PURE__*/React.createElement(caption, null, "Conectado como"), /*#__PURE__*/React.createElement(FacebookName, null, name)));
};

facebookConnectedAs.propTypes = {
  name: PropTypes__default.string.isRequired,
  imageUrl: PropTypes__default.string.isRequired,
  className: PropTypes__default.string
};

var API_ENDPOINT$6 = '/v1/accounts/my/email/send';
var verifyEmail = (function () {
  return axios.post(API_ENDPOINT$6, {}, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
});

var EMAIL_CHANGER_BASE_URL = 'https://email-changer.olx.com.br';
var createEmailChangeRequest = function createEmailChangeRequest() {
  return axios.post(EMAIL_CHANGER_BASE_URL + "/create", {}, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};
var createEmailChangeConfirmationToken = function createEmailChangeConfirmationToken() {
  return axios.post(EMAIL_CHANGER_BASE_URL + "/token/confirmation", {}, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};

var _templateObject$12, _templateObject2$I;
var Container$3 = styled(View$1)(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteralLoose(["\n  border-radius: 24px;\n  border: solid 0.5px ", ";\n  padding: 4px 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n"])), function (props) {
  return props.borderColor;
});
var Caption = styled(Text$1)(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteralLoose(["\n  font-size: ", "px;\n  text-align: center;\n  color: ", ";\n  flex: 1;\n  font-weight: ", ";\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.fontWeight;
});

var LabelBox = function LabelBox(_ref) {
  var children = _ref.children,
      fontSize = _ref.fontSize,
      fontColor = _ref.fontColor,
      fontWeight = _ref.fontWeight,
      borderColor = _ref.borderColor;
  return /*#__PURE__*/React.createElement(Container$3, {
    borderColor: borderColor
  }, /*#__PURE__*/React.createElement(Caption, {
    fontSize: fontSize,
    fontWeight: fontWeight,
    fontColor: fontColor
  }, children));
};

LabelBox.defaultProps = {
  fontSize: 14,
  fontWeight: 300,
  fontColor: '#4a4a4a',
  borderColor: '#d2d2d2'
};
LabelBox.propTypes = {
  fontSize: PropTypes__default.number,
  fontWeight: PropTypes__default.number,
  fontColor: PropTypes__default.string,
  borderColor: PropTypes__default.string
};

var LockIcon = function LockIcon(props) {
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "0.1",
    d: "M48.1149 87.3109C69.762 87.3109 87.3104 69.7625 87.3104 48.1154C87.3104 26.4683 69.762 8.91992 48.1149 8.91992C26.4679 8.91992 8.91943 26.4683 8.91943 48.1154C8.91943 69.7625 26.4679 87.3109 48.1149 87.3109Z",
    fill: "#6E0AD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0264 31.344L39.1508 39.345L32.5983 40.2659L31.3575 31.4372C31.3575 31.4372 29.3371 14.559 45.684 12.2615C62.031 9.96412 64.9018 25.3864 64.9018 25.3864L66.3365 35.5947L59.7149 36.5253L58.2996 26.455C58.2996 26.455 56.1525 17.6833 47.1168 18.9532C38.0812 20.2231 37.7572 28.4277 38.0264 31.344Z",
    fill: "#6E0AD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6926 37.6504L34.9931 39.7886",
    stroke: "white",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0526 35.225L31.3708 40.2398C24.3836 41.2217 21.8445 45.9912 22.6046 51.4L25.8638 74.5906C26.6145 79.9318 31.6872 83.3438 37.3175 82.5525L72.9993 77.5378C78.5592 76.7564 82.8389 74.0153 81.1152 66.8255L77.856 43.635C76.93 37.0462 74.3896 34.1939 67.0526 35.225ZM55.329 59.556C55.2072 59.711 55.0855 59.866 55.114 60.0688L55.9312 65.8834C56.1212 67.2356 55.1567 68.5432 53.6787 68.7509L52.8342 68.8696C51.4266 69.0674 50.0782 68.1538 49.8786 66.734L49.0614 60.9195C49.0329 60.7166 48.9436 60.5913 48.7134 60.4857C46.1115 59.3346 44.6377 56.5081 45.515 53.558C46.0611 51.8265 47.4289 50.3243 49.2112 49.7291C52.968 48.3738 56.8156 50.7288 57.3192 54.3121C57.5948 56.2729 56.7956 58.2467 55.329 59.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7103 43.6961C25.8269 42.1324 27.6322 40.9643 29.7014 40.6735L69.2928 35.1093C73.3623 34.5374 77.1384 37.3828 77.7103 41.4523L81.5587 68.8352C82.1306 72.9047 79.2852 76.6808 75.2157 77.2527L37.3487 82.5746",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3959 35.5159L65.1067 26.3423C63.798 17.0307 55.1445 10.5098 45.833 11.8185C36.5214 13.1271 29.9315 21.7903 31.2402 31.1019L32.5295 40.2755L39.289 39.3255L37.9997 30.1519C37.2048 24.496 41.1173 19.3039 46.7733 18.509C52.4292 17.7141 57.6213 21.6266 58.4161 27.2825L59.7054 36.4562",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4358 68.9193C52.0563 69.1132 50.7286 68.1744 50.525 66.7259L49.6914 60.7941C49.6623 60.5872 49.5739 60.4589 49.3476 60.35C46.7892 59.1622 45.3281 56.2727 46.1722 53.2703C46.6983 51.5083 48.0315 49.9845 49.7764 49.3876C53.4537 48.0267 57.2405 50.4487 57.7543 54.1043C58.0354 56.1046 57.2625 58.1123 55.7623 59.4485C55.6437 59.6059 55.5251 59.7632 55.5542 59.9701L56.3879 65.9019C56.5818 67.2814 55.643 68.6091 54.1945 68.8127L53.4358 68.9193Z",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4081 48.943C23.4081 48.943 16.7731 55.7838 10.4964 56.6659L12.5612 71.3575C12.9877 74.3924 14.617 76.9769 16.9781 78.2628C19.3393 79.5487 26.5026 82.9732 26.7979 83.0723L28.3034 83.7751L29.5569 82.6846C29.8037 82.4389 35.7552 77.2416 37.7298 75.276C39.5858 73.4677 40.5085 70.5246 40.0723 67.4207L38.0172 52.7981C31.6716 53.69 23.4081 48.943 23.4081 48.943Z",
    fill: "#6E0AD6",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0883 66.3608L25.3494 70.2636L31.7517 61.7675",
    stroke: "white",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2237 18.2339C34.8275 21.595 33.1416 26.6149 33.888 31.9259L34.363 35.3057",
    stroke: "white",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1589 47.7773L76.3214 63.1638",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9111 67.3604L77.3043 70.1579",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

LockIcon.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
LockIcon.defaultProps = {
  width: 96,
  height: 96
};

var _templateObject$13, _templateObject2$J;
var Box = styled(View$1)(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  min-height: 73px;\n  border-radius: 4px;\n  background-color: #fef7e9;\n  padding: 16px;\n  border: 1px solid #f9af27;\n"])));
var DetailColumn$1 = styled(View$1)(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin-left: 16px;\n  justify-content: center;\n"])));

var GenericWarningBox = function GenericWarningBox(_ref) {
  var className = _ref.className,
      style = _ref.style,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(Icons.System.AlertCircle, {
    color: "#F9AF27",
    size: "18"
  }), /*#__PURE__*/React.createElement(DetailColumn$1, null, children));
};

var formatTimestamp = function formatTimestamp(timestamp) {
  return Intl.DateTimeFormat('pt-br', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }).format(new Date(parseInt(timestamp)));
};

var isGreaterThan = function isGreaterThan(days, phoneVerifiedAt) {
  var date = new Date(phoneVerifiedAt);
  var oneDay = 1000 * 60 * 60 * 24;
  var diffInTime = Date.now() - date.getTime();
  var diffInDays = Math.round(diffInTime / oneDay);
  return diffInDays > days;
};

var formatedTime = function formatedTime(secondsFull) {
  var hours = Math.floor(secondsFull / 3600);
  var minutes = Math.floor(secondsFull % 3600 / 60);
  var seconds = Math.floor(secondsFull % 3600 % 60);
  var showHours = hours > 0 ? hours + "h" : '';
  var showMinutes = minutes > 0 ? minutes + "min" : '';
  var showSeconds = hours === 0 && seconds > 0 ? seconds + "s" : '';
  return "" + showHours + (!!showHours && !!showMinutes ? ' e' : '') + " " + showMinutes + (showMinutes && showSeconds ? ' e ' : '') + showSeconds;
};

var _templateObject$14, _templateObject2$K, _templateObject3$u, _templateObject4$k, _templateObject5$h, _templateObject6$c, _templateObject7$c, _templateObject8$7, _templateObject9$3, _templateObject10$3;
var lurker$6 = new Lurker('email_change_confirmation_modal');
var Content$o = styled(View$1)(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n"])));
var LabelBoxView = styled(View$1)(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteralLoose(["\n  padding: 7px 50px;\n"])));
var HelpCalloutWrapper = styled(View$1)(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteralLoose(["\n  flex-direction: row;\n"])));
var HelpCalloutLink = styled(Button)(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteralLoose(["\n  font-size: 12px !important;\n"])));
var TitleWrapper$1 = styled(View$1)(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteralLoose(["\n  margin-top: 28px;\n"])));
var Description$6 = styled(Text$1)(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 24px;\n  margin-bottom: 8px;\n"])));
var BoxWrapper = styled(View$1)(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-top: 32px;\n"])));
var BoxTitle = styled(Text$1)(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteralLoose(["\n  margin-top: 1px;\n"])));
var BoxContent = styled(Text$1)(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteralLoose(["\n  margin-top: 5px;\n"])));
var LinkWrapper = styled(Link$2)(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteralLoose(["\n  font-size: 12px !important;\n  font-weight: 400;\n  text-decoration: underline;\n"])));

var contactUsClick = function contactUsClick() {
  lurker$6.clickEvt('contact_us_link');
  window.location.href = faleConosco;
};

var passwordChangeClick = function passwordChangeClick() {
  lurker$6.clickEvt('password_change_link');
  window.location.href = trocaSenha;
};

var modalClose = function modalClose(onClose) {
  return function () {
    lurker$6.clickEvt('modal_close');

    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };
};

var isEmailChangePincodeAllowed = function isEmailChangePincodeAllowed(phoneVerified, phoneVerifiedAt) {
  var daysInNumber = 7;
  return phoneVerified && isGreaterThan(daysInNumber, phoneVerifiedAt);
};

var EmailChangeConfirmationSentModal = function EmailChangeConfirmationSentModal(_ref) {
  var email = _ref.email,
      onClose = _ref.onClose,
      open = _ref.open,
      phoneVerified = _ref.phoneVerified,
      phoneVerifiedAt = _ref.phoneVerifiedAt,
      onAnotherWayHandler = _ref.onAnotherWayHandler;
  return /*#__PURE__*/React.createElement(Modal$1, {
    closeCallback: modalClose(onClose),
    maxWidth: "400px",
    maxHeight: "550px",
    open: open
  }, /*#__PURE__*/React.createElement(Content$o, null, /*#__PURE__*/React.createElement(LockIcon, null), /*#__PURE__*/React.createElement(TitleWrapper$1, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "title3",
    weight: "semiBold"
  }, "Confirme o", ' '), /*#__PURE__*/React.createElement(Text$1, {
    size: "title3",
    weight: "bold"
  }, "e-mail atual")), /*#__PURE__*/React.createElement(Description$6, {
    size: "body1",
    weight: "regular"
  }, "O e-mail de confirma\xE7\xE3o de seguran\xE7a foi enviado para"), /*#__PURE__*/React.createElement(LabelBoxView, null, /*#__PURE__*/React.createElement(LabelBox, null, truncate(email))), isEmailChangePincodeAllowed(phoneVerified, phoneVerifiedAt) ? /*#__PURE__*/React.createElement(HelpCalloutWrapper, null, /*#__PURE__*/React.createElement(HelpCalloutLink, {
    size: "small",
    variant: "link-button",
    onClick: onAnotherWayHandler
  }, "Tentar de outro jeito")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HelpCalloutWrapper, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "caption"
  }, "N\xE3o tem acesso ao e-mail?"), /*#__PURE__*/React.createElement(HelpCalloutLink, {
    size: "small",
    variant: "link-button",
    onClick: contactUsClick
  }, "Fale conosco")), /*#__PURE__*/React.createElement(BoxWrapper, null, /*#__PURE__*/React.createElement(GenericWarningBox, null, /*#__PURE__*/React.createElement(BoxTitle, {
    size: "caption",
    weight: "bold"
  }, "Criou conta com Google ou Facebook?"), /*#__PURE__*/React.createElement(BoxContent, {
    size: "caption"
  }, /*#__PURE__*/React.createElement(LinkWrapper, {
    size: "caption",
    onClick: passwordChangeClick
  }, "Altere a senha"), ' ', "antes de continuar para evitar problemas de login. O acesso r\xE1pido via Facebook pode ser vinculado na sua conta posteriormente."))))));
};

EmailChangeConfirmationSentModal.propTypes = {
  email: PropTypes__default.string.isRequired,
  onClose: PropTypes__default.func.isRequired,
  open: PropTypes__default.bool.isRequired,
  phoneVerifiedAt: PropTypes__default.string.isRequired,
  phoneVerified: PropTypes__default.bool.isRequired,
  onAnotherWayHandler: PropTypes__default.func.isRequired
};

var MailIcon = function MailIcon(props) {
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "0.1",
    d: "M48.1149 87.3109C69.762 87.3109 87.3104 69.7625 87.3104 48.1154C87.3104 26.4683 69.762 8.91992 48.1149 8.91992C26.4679 8.91992 8.91943 26.4683 8.91943 48.1154C8.91943 69.7625 26.4679 87.3109 48.1149 87.3109Z",
    fill: "#6E0AD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0589 24.6551L64.6551 17.2632C68.2711 16.755 71.6454 19.2977 72.1536 22.9137L77.6976 62.3609C78.2058 65.9769 75.663 69.3512 72.047 69.8594L19.4508 77.2513C15.8348 77.7595 12.4605 75.2168 11.9523 71.6008L6.40836 32.1536C5.90017 28.5376 8.44291 25.1633 12.0589 24.6551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1656 25.667C9.08684 26.0997 6.88319 28.8793 7.11251 31.9385L42.3902 49.9072L71.348 22.9112C70.7253 19.9071 67.8408 17.8424 64.7619 18.2751L12.1656 25.667ZM12.6974 71.7656L7.35389 33.7449L42.1772 51.4821C42.4581 51.6252 42.7985 51.5774 43.029 51.3624L71.6254 24.7033L74.8224 46.0463C74.8838 46.4559 75.2656 46.7382 75.6753 46.6769C76.0849 46.6155 76.3672 46.2337 76.3059 45.824L72.9011 23.0948C72.8995 23.0813 72.8976 23.0678 72.8953 23.0544C72.3179 19.0411 68.5712 16.225 64.5531 16.7897L11.9569 24.1816C7.9307 24.7474 5.10218 28.501 5.66802 32.5272L11.212 71.9744C11.7778 76.0005 15.5314 78.8291 19.5576 78.2632L19.5576 78.2633L19.5675 78.2618L43.3526 74.5941C43.762 74.531 44.0427 74.148 43.9796 73.7386C43.9164 73.3292 43.5334 73.0485 43.124 73.1117L19.3441 76.7785C16.1401 77.2262 13.1477 74.9698 12.6974 71.7656ZM16.947 71.7638C16.709 72.1028 16.7909 72.5705 17.1299 72.8085C17.4689 73.0465 17.9367 72.9647 18.1747 72.6257L21.1437 68.3968C21.3817 68.0578 21.2999 67.59 20.9609 67.352C20.6219 67.114 20.1541 67.1959 19.9161 67.5349L16.947 71.7638ZM21.969 64.6109C21.731 64.9499 21.8128 65.4177 22.1519 65.6557C22.4909 65.8937 22.9586 65.8119 23.1966 65.4728L32.5279 52.1822C32.7659 51.8432 32.6841 51.3754 32.3451 51.1374C32.0061 50.8994 31.5383 50.9813 31.3003 51.3203L21.969 64.6109Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5706 81.3576C87.0918 74.9637 88.0057 63.6833 81.6117 56.1621C75.2178 48.6409 63.9374 47.7271 56.4162 54.121C48.895 60.5149 47.9812 71.7954 54.3751 79.3166C60.769 86.8378 72.0495 87.7516 79.5706 81.3576Z",
    fill: "#6E0AD6",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1611 65.5161L74.0574 64.6198C74.9882 63.689 74.9882 62.1741 74.0574 61.2429C73.6066 60.7925 73.0075 60.5449 72.3687 60.5449C71.7299 60.5449 71.1304 60.7929 70.6801 61.2432L69.7841 62.1392L73.1611 65.5161ZM69.005 62.9183L62.3675 69.5557C62.2261 69.6972 62.1185 69.8717 62.056 70.0608L60.8255 73.7787C60.7597 73.9763 60.8115 74.1941 60.9588 74.3414C61.0642 74.4465 61.2045 74.5027 61.3485 74.5027C61.4066 74.5027 61.465 74.4935 61.5219 74.4748L65.2387 73.2438C65.4286 73.1814 65.6034 73.0737 65.7449 72.932L72.3819 66.2949L69.005 62.9183Z",
    fill: "white"
  })));
};

MailIcon.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
MailIcon.defaultProps = {
  width: 96,
  height: 96
};

var _templateObject$15, _templateObject2$L, _templateObject3$v, _templateObject4$l;
var lurker$7 = new Lurker('email_change_contact_us_modal');
var Content$p = styled(View$1)(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n"])));
var TitleWrapper$2 = styled(View$1)(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteralLoose(["\n  margin-top: 28px;\n"])));
var ReasonText = styled(Text$1)(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 32px;\n"])));
var ContactUsText = styled(Text$1)(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-bottom: 32px;\n"])));

var contactUsClick$1 = function contactUsClick() {
  lurker$7.clickEvt('contact_us_button');
  window.location.href = faleConosco;
};

var modalClose$1 = function modalClose(onClose, detail) {
  return function () {
    lurker$7.clickEvt(detail);

    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };
};

var reasonText = function reasonText(message) {
  if (message === 'IS_PRO') return 'Sua conta possui plano contratado ativo.';
  if (message === 'HAS_WALLET') return 'Sua conta possui OLX Pay ativada.';
  return '';
};

var EmailChangeContactUsModal = function EmailChangeContactUsModal(_ref) {
  var message = _ref.message,
      onClose = _ref.onClose,
      open = _ref.open;
  return /*#__PURE__*/React.createElement(Modal$1, {
    fullScreen: true,
    onClose: modalClose$1(onClose, 'modal_close'),
    maxWidth: "400px",
    maxHeight: "440px",
    open: open
  }, /*#__PURE__*/React.createElement(Content$p, null, /*#__PURE__*/React.createElement(MailIcon, null), /*#__PURE__*/React.createElement(TitleWrapper$2, null, /*#__PURE__*/React.createElement(Title, null, "Solicite a altera\xE7\xE3o de e-mail")), /*#__PURE__*/React.createElement(ReasonText, {
    size: "body1",
    weight: "regular"
  }, reasonText(message)), /*#__PURE__*/React.createElement(ContactUsText, {
    size: "body1",
    weight: "regular"
  }, "Para alterar o seu e-mail, fale conosco."), /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    size: "large",
    onClick: contactUsClick$1
  }, "Fale conosco"), /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    marginTop: "--spacing-2",
    size: "small",
    variant: "link-button",
    onClick: modalClose$1(onClose, 'cancel_link')
  }, "Cancelar")));
};

EmailChangeContactUsModal.propTypes = {
  onClose: PropTypes__default.func.isRequired,
  open: PropTypes__default.bool.isRequired,
  message: PropTypes__default.string
};

var SquareLockIcon = function SquareLockIcon(props) {
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "0.3",
    d: "M71.617 87.306L13.6217 77.8443C10.9408 77.398 9.1536 74.8987 9.60041 72.2209L18.9833 14.2907C19.4301 11.6129 21.9322 9.82767 24.6131 10.274L82.6084 19.7356C85.2893 20.1819 87.0765 22.6812 86.6297 25.359L77.2468 83.2C76.8893 85.8778 74.2979 87.7523 71.617 87.306Z",
    fill: "#F28000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0265 31.3447L39.151 39.3458L32.5984 40.2667L31.3576 31.4379C31.3576 31.4379 29.3372 14.5597 45.6841 12.2623C62.0311 9.96486 64.9019 25.3872 64.9019 25.3872L66.3366 35.5954L59.715 36.526L58.2998 26.4557C58.2998 26.4557 56.1526 17.684 47.1169 18.9539C38.0813 20.2238 37.7573 28.4284 38.0265 31.3447Z",
    fill: "#6E0AD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6926 37.6512L34.9931 39.7895",
    stroke: "white",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0525 35.2255L31.3707 40.2402C24.3834 41.2222 21.8443 45.9916 22.6045 51.4005L25.8637 74.591C26.6144 79.9323 31.6871 83.3443 37.3174 82.553L72.9992 77.5383C78.5591 76.7569 82.8388 74.0158 81.1151 66.826L77.8559 43.6354C76.9299 37.0467 74.3894 34.1944 67.0525 35.2255ZM55.3289 59.5565C55.2071 59.7115 55.0854 59.8665 55.1139 60.0693L55.931 65.8838C56.1211 67.2361 55.1566 68.5437 53.6786 68.7514L52.8341 68.8701C51.4265 69.0679 50.078 68.1543 49.8785 66.7345L49.0613 60.9199C49.0328 60.7171 48.9434 60.5918 48.7133 60.4862C46.1114 59.3351 44.6376 56.5086 45.5148 53.5585C46.061 51.827 47.4287 50.3248 49.2111 49.7296C52.9678 48.3743 56.8155 50.7293 57.3191 54.3126C57.5946 56.2733 56.7955 58.2472 55.3289 59.5565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7104 43.6964C25.827 42.1327 27.6323 40.9646 29.7015 40.6738L69.2929 35.1096C73.3624 34.5377 77.1385 37.3832 77.7104 41.4526L81.5588 68.8355C82.1307 72.905 79.2853 76.6811 75.2158 77.253L37.3488 82.5749",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3958 35.5167L65.1065 26.3431C63.7979 17.0316 55.1444 10.5107 45.8328 11.8193C36.5213 13.128 29.9314 21.7912 31.2401 31.1027L32.5293 40.2763L39.2888 39.3263L37.9996 30.1527C37.2047 24.4968 41.1172 19.3047 46.7731 18.5098C52.429 17.715 57.6211 21.6275 58.416 27.2834L59.7053 36.457",
    fill: "#F28000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3958 35.5167L65.1066 26.3431C63.7979 17.0316 55.1444 10.5107 45.8328 11.8193C36.5213 13.128 29.9314 21.7912 31.2401 31.1027L32.5293 40.2763L39.2888 39.3263L37.9996 30.1527C37.2047 24.4968 41.1172 19.3047 46.7731 18.5098C52.429 17.715 57.6211 21.6275 58.416 27.2834L59.7053 36.457",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4358 68.9194C52.0563 69.1133 50.7286 68.1745 50.525 66.726L49.6914 60.7942C49.6623 60.5873 49.5739 60.459 49.3476 60.3502C46.7892 59.1623 45.3281 56.2728 46.1722 53.2704C46.6983 51.5084 48.0315 49.9846 49.7764 49.3877C53.4537 48.0269 57.2405 50.4488 57.7543 54.1044C58.0354 56.1047 57.2625 58.1124 55.7623 59.4487C55.6437 59.606 55.5251 59.7633 55.5542 59.9703L56.3879 65.9021C56.5818 67.2815 55.643 68.6092 54.1945 68.8128L53.4358 68.9194Z",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4079 48.9437C23.4079 48.9437 16.773 55.7845 10.4963 56.6666L12.561 71.3582C12.9876 74.393 14.6169 76.9775 16.978 78.2634C19.3392 79.5494 26.5025 82.9738 26.7978 83.073L28.3033 83.7758L29.5567 82.6853C29.8036 82.4396 35.7551 77.2422 37.7297 75.2767C39.5856 73.4684 40.5084 70.5252 40.0722 67.4214L38.0171 52.7988C31.6715 53.6906 23.4079 48.9437 23.4079 48.9437Z",
    fill: "#F28000",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0883 66.3614L25.3494 70.2642L31.7517 61.7681",
    stroke: "white",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2237 18.2344C34.8275 21.5955 33.1416 26.6153 33.888 31.9264L34.363 35.3061",
    stroke: "white",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1588 47.7775L76.3212 63.164",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.911 67.3603L77.3042 70.1578",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

SquareLockIcon.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
SquareLockIcon.defaultProps = {
  width: 96,
  height: 96
};

var _templateObject$16, _templateObject2$M;
var Content$q = styled(View$1)(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-start;\n"])));
var CodeWrapper = styled(View$1)(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteralLoose(["\n  margin-right: var(--spacing-stack-nano);\n"])));
var CODE_LENGTH = 6;

function replaceAt(pincode, index, replace) {
  var copy = [].concat(pincode);
  copy[index] = replace;
  return copy;
}

var isLastNumber = function isLastNumber(i) {
  return i === CODE_LENGTH - 1;
};

var isValid$1 = function isValid(pincode) {
  return pincode.join('').replace(/ /g, '').length === CODE_LENGTH;
};

var isOneDigit = function isOneDigit(i) {
  return /^\d$/.test(i);
};

var PinCode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PinCode, _React$Component);

  function PinCode(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onKeyPress = function (_ref, i) {
      var key = _ref.key;
      var pincode = _this.state.pincode;
      var onChange = _this.props.onChange;

      if (key === 'Enter') {
        if (i + 1 === CODE_LENGTH) {
          var onSubmitEditing = _this.props.onSubmitEditing;

          if (typeof onSubmitEditing === 'function') {
            onSubmitEditing();
          }
        }

        _this.goToNextInput(i);
      } else if (key === 'Backspace') {
        if (pincode[i].trim() === '') {
          _this.goToPreviusInput(i);
        } else {
          var newCode = replaceAt(pincode, i, '');

          _this.setState({
            pincode: newCode
          }, function () {
            if (typeof onChange === 'function') {
              onChange(newCode.join(''), isValid$1(newCode));
            }
          });
        }
      }
    };

    _this.onCodeChange = function (event, i) {
      var pincode = _this.state.pincode;
      var onChange = _this.props.onChange;
      var value = event.target.value;

      if (value && value.length) {
        var chars = value.split('');
        var index = i;
        var newCode = pincode;
        chars.forEach(function (c) {
          if (isOneDigit(c) && index < CODE_LENGTH) {
            newCode = replaceAt(newCode, index, c);

            _this.goToNextInput(index);

            index += 1;
          }
        });

        _this.setState({
          pincode: newCode
        }, function () {
          if (typeof onChange === 'function') {
            onChange(newCode.join(''), isValid$1(newCode));
          }
        });

        if (isLastNumber(i)) {
          _this.onKeyPress({
            key: 'Enter'
          }, i);
        }
      }
    };

    _this.updateFocus = function (input) {
      if (_this.inputs[input] && _this.inputs[input].focus) {
        _this.inputs[input].focus();
      }

      setTimeout(function () {
        return _this.selectText(input);
      }, 0);
    };

    _this.selectText = function (input) {
      if (_this.inputs[input] && _this.inputs[input].select) {
        _this.inputs[input].select();
      }
    };

    _this.inputs = new Array(CODE_LENGTH);
    _this.state = {
      pincode: new Array(CODE_LENGTH).fill('')
    };
    return _this;
  }

  var _proto = PinCode.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      return _this2.updateFocus(0);
    }, 0);
  };

  _proto.goToNextInput = function goToNextInput(currentInput) {
    var nextInput = currentInput + 1;

    if (nextInput < CODE_LENGTH) {
      this.updateFocus(nextInput);
    }
  };

  _proto.goToPreviusInput = function goToPreviusInput(currentInput) {
    var previousInput = currentInput - 1;

    if (previousInput >= 0) {
      this.updateFocus(previousInput);
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        pincodeByProps = _this$props.value,
        _onFocus = _this$props.onFocus;
    var pincode = this.state.pincode;

    if (pincodeByProps && isValid$1(pincodeByProps.split(''))) {
      pincode = pincodeByProps.split('');
    }

    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        hasError = _this$props2.hasError;
    return /*#__PURE__*/React.createElement(Content$q, null, pincode.map(function (value, i) {
      return (
        /*#__PURE__*/
        React.createElement(CodeWrapper, {
          key: i
        }, /*#__PURE__*/React.createElement(TextInput$1, {
          id: "input-pincode-" + i,
          "aria-label": "Codigo de verifica\xE7\xE3o da " + (i + 1) + "\xBA posi\xE7\xE3o de 6 posi\xE7\xF5es",
          "aria-required": true,
          onChange: function onChange(event) {
            return _this3.onCodeChange(event, i);
          },
          onKeyDown: function onKeyDown(event) {
            return _this3.onKeyPress(event, i);
          },
          value: value || '',
          keyboardType: "number-pad",
          ref: function ref(x) {
            _this3.inputs[i] = x;
          },
          onFocus: function onFocus() {
            _this3.selectText(i);

            if (typeof _onFocus === 'function') {
              _onFocus();
            }
          },
          state: hasError && 'error',
          disabled: disabled,
          type: "tel"
        }))
      );
    }));
  };

  return PinCode;
}(React.Component);

PinCode.propTypes = {
  disabled: PropTypes__default.bool,
  onSubmitEditing: PropTypes__default.func,
  pinCode: PropTypes__default.object,
  onChange: PropTypes__default.func,
  hasError: PropTypes__default.bool,
  onFocus: PropTypes__default.func
};

var BaseForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BaseForm, _React$Component);

  function BaseForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onFieldChange = function (event, field, validator, msg, pristine) {
      if (pristine === void 0) {
        pristine = false;
      }

      var value = event.target.value;
      var valid = value && typeof validator === 'function' ? validator(value) : !!value;

      _this.updateField(field, value, valid, pristine, msg, undefined);
    };

    _this.getInvalidFields = function () {
      var fields = _this.state.fields;
      var invalidFields = {};
      Object.keys(fields).forEach(function (key) {
        if (!fields[key].valid) invalidFields["invalid_" + key] = true;
      });
      return invalidFields;
    };

    _this.getErrorMessage = function (value, message) {
      return typeof message === 'function' ? message(value) : message;
    };

    _this.getPasswordErrorMessage = function (value) {
      var _checkStrength = checkStrength(value),
          message = _checkStrength.message;

      return message;
    };

    _this.isValidPassword = function (value, level) {
      var passwordSecurityVersion = _this.props.passwordSecurityVersion;

      var _ref = level ? {
        strength: level
      } : checkStrength(value),
          strength = _ref.strength;

      return isValidPasswordByTest(passwordSecurityVersion) ? passwordSecurityVersion === 'newLayoutPasswordWeak' ? strength > 0 : strength > 2 : strength > 0;
    };

    _this.updateField = function (field, value, valid, pristine, message, callback) {
      var _extends2;

      var fields = _extends({}, _this.state.fields);

      var newField = _extends({}, fields[field], {
        value: value
      });

      newField.valid = false;

      if (typeof valid === 'boolean') {
        newField.valid = valid;
      }

      newField.pristine = true;

      if (typeof pristine === 'boolean') {
        newField.pristine = pristine;
      }

      newField.msg = '';

      if (typeof message === 'string') {
        newField.msg = message;
      }

      _this.setState({
        fields: _extends({}, fields, (_extends2 = {}, _extends2[field] = newField, _extends2))
      }, callback);
    };

    _this.checkSomeFieldsIsValid = function (fieldsToCheck) {
      return new Promise(function (resolve, reject) {
        var allValid = true;
        var updatedFields = _this.state.fields;
        fieldsToCheck.filter(function (key) {
          return !_this.state.fields[key].valid;
        }).forEach(function (key) {
          updatedFields[key].pristine = false;
          allValid = false;
        });

        if (allValid) {
          resolve();
        } else {
          _this.setState({
            fields: updatedFields,
            isSubmitting: false
          }, reject);
        }
      });
    };

    _this.checkFormIsValid = function () {
      return new Promise(function (resolve, reject) {
        var allValid = true;
        var updatedFields = _this.state.fields;
        Object.keys(_this.state.fields).forEach(function (key) {
          if (!_this.state.fields[key].valid) {
            updatedFields[key].pristine = false;
            allValid = false;
          }
        });

        if (allValid) {
          resolve();
        } else {
          _this.setState({
            fields: updatedFields,
            isSubmitting: false
          }, reject);
        }
      });
    };

    _this.updateFocus = function (input) {
      if (_this.inputs && _this.inputs[input] && _this.inputs[input].focus) {
        _this.inputs[input].focus();
      }
    };

    _this.validateSomeFieldsBeforeSend = function (fieldsToValidate) {
      return new Promise(function (resolve) {
        var _this$state = _extends({}, _this.state),
            fields = _this$state.fields,
            validators = _this$state.validators;

        var _validators$fieldsToV = validators[fieldsToValidate],
            action = _validators$fieldsToV.action,
            message = _validators$fieldsToV.message;
        var field = fields[fieldsToValidate];
        var value = field.value;
        fields[fieldsToValidate] = _extends({}, field, {
          msg: _this.getErrorMessage(value, message),
          valid: value && typeof action === 'function' ? action(value) : !!value,
          pristine: false
        });

        _this.setState({
          fields: fields
        }, resolve);
      });
    };

    _this.validateBeforeSend = function () {
      return new Promise(function (resolve) {
        var _this$state2 = _extends({}, _this.state),
            fields = _this$state2.fields,
            validators = _this$state2.validators;

        Object.keys(fields).forEach(function (currentField) {
          var _validators$currentFi = validators[currentField],
              action = _validators$currentFi.action,
              message = _validators$currentFi.message;
          var field = fields[currentField];
          var value = field.value;
          fields[currentField] = _extends({}, field, {
            msg: _this.getErrorMessage(value, message),
            valid: value && typeof action === 'function' ? action(value) : !!value,
            pristine: false
          });
        });

        _this.setState({
          fields: fields
        }, resolve);
      });
    };

    _this.inputs = {};
    _this.state = {
      isSubmitting: false,
      showGenericError: false,
      validators: {},
      fields: {}
    };
    return _this;
  }

  var _proto = BaseForm.prototype;

  _proto.render = function render() {
    throw new Error('not implemented');
  };

  return BaseForm;
}(React.Component);

var platform$1 = 'WEB';
var sendSMS = function sendSMS(phone, token) {
  return axios.post('/v2/pincode/send/sms', {
    phone: phone,
    platform: platform$1
  }, {
    headers: {
      Authorization: token
    },
    withCredentials: true
  });
};
var sendSMSV3 = function sendSMSV3(type, issuer, token) {
  return axios.post('/v3/pincode/send', {
    type: type,
    issuer: issuer
  }, {
    headers: {
      Authorization: token
    },
    withCredentials: true
  });
};
var makeCall = function makeCall(phone) {
  return axios.post('/v2/pincode/make/call', {
    phone: phone,
    platform: platform$1
  }, {
    withCredentials: true
  });
};
var checkCodeV3 = function checkCodeV3(phone, code) {
  return axios.post('/v3/pincode/check', {
    type: 'CUSTOM-PHONE',
    code: code,
    key: phone,
    platform: platform$1
  }, {
    withCredentials: true
  });
};

var _templateObject$17, _templateObject2$N, _templateObject3$w;
var Base = styled(View$1)(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteralLoose(["\n  border-radius: 3px 3px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  width: 100%;\n  height: 0;\n  top: -50px;\n  transition: top 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);\n  position: relative;\n  ", "\n\n  &.in {\n    height: 50px;\n    top: 0;\n  }\n"])), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor && "\n    background-color: " + backgroundColor + ";\n  ";
}, mediaQuery.medium(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteralLoose(["\n    padding: 8px 16px 24px 16px;\n  "]))));
var Enclousure = styled.div(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteralLoose(["\n  height: 50px;\n"])));

var WaitLockBanner = function WaitLockBanner(props) {
  var value = props.value;

  var formatedTime = function formatedTime(secondsFull) {
    var hours = Math.floor(secondsFull / 3600);
    var minutes = Math.floor(secondsFull % 3600 / 60);
    var seconds = Math.floor(secondsFull % 3600 % 60);
    var showHours = hours > 0 ? hours + "h " : '';
    var showMinutes = minutes > 0 ? minutes + "min " : '';
    var showSeconds = hours === 0 && seconds >= 0 ? seconds + "s" : '';
    return showHours + showMinutes + showSeconds;
  };

  return /*#__PURE__*/React.createElement(Base, {
    className: value >= 0 ? 'in' : '',
    backgroundColor: props.backgroundColor
  }, /*#__PURE__*/React.createElement(Text$1, {
    weight: "fine"
  }, ' ', "Voc\xEA pode tentar novamente em ", /*#__PURE__*/React.createElement(Text$1, {
    weight: "bold"
  }, formatedTime(value))));
};

WaitLockBanner.defaultProps = {
  value: '...',
  backgroundColor: '#F8F3FD'
};

var API_ENDPOINT$7 = '/v1/attempts/check';
var API_ENDPOINT_V2 = '/v2/attempts/check';
var getRemainingTime = (function () {
  return axios.get(API_ENDPOINT$7, {
    withCredentials: true
  }).then(function (res) {
    return res.data.remaining_time;
  })["catch"](function (err) {
    return err;
  });
});
var getAttemptCheck = function getAttemptCheck() {
  return axios.get(API_ENDPOINT$7, {
    withCredentials: true
  }).then(function (res) {
    return res.data;
  })["catch"](function (err) {
    return err;
  });
};
var getAttemptCheckv2 = function getAttemptCheckv2(token) {
  if (!token) return new Promise(function (resolve, reject) {
    return reject('No token');
  });
  return axios.get(API_ENDPOINT_V2, {
    withCredentials: true,
    headers: {
      Authorization: token
    }
  }).then(function (res) {
    return res.data;
  })["catch"](function (err) {
    return err;
  });
};

var Router = /*#__PURE__*/function () {
  function Router(initialRoute) {
    this.state = {
      currentRoute: initialRoute,
      history: [initialRoute]
    };
    this.subscribers = [];
    this.subscribe = this.subscribe.bind(this);
    this.unsubscribe = this.unsubscribe.bind(this);
    this.getCurrentRoute = this.getCurrentRoute.bind(this);
    this.push = this.push.bind(this);
    this.pop = this.pop.bind(this);
    this.popToTop = this.popToTop.bind(this);
    this.canPop = this.canPop.bind(this);
  }

  var _proto = Router.prototype;

  _proto.subscribe = function subscribe(subscriber) {
    this.subscribers.push(subscriber);
  };

  _proto.unsubscribe = function unsubscribe(subscriber) {
    var index = this.subscribers.indexOf(subscriber);

    if (index !== -1) {
      this.subscribers.splice(index, 1);
    }
  };

  _proto.getCurrentRoute = function getCurrentRoute() {
    return this.state.currentRoute;
  };

  _proto.setState = function setState(newState) {
    var _this = this;

    this.state = newState;
    this.subscribers.forEach(function (sc) {
      return sc.onRouteChange && sc.onRouteChange(_this.state.currentRoute);
    });
  };

  _proto.push = function push(route) {
    var history = this.state.history;
    history.push(route);
    this.setState({
      currentRoute: route,
      history: history
    });
  };

  _proto.pop = function pop() {
    var history = this.state.history;

    if (!this.canPop()) {
      return;
    }

    history.pop();
    var route = history[history.length - 1];
    this.setState({
      currentRoute: route,
      history: history
    });
  };

  _proto.popToTop = function popToTop() {
    var history = this.state.history;

    if (!this.canPop()) {
      return;
    }

    var route = history[0];
    this.setState({
      currentRoute: route,
      history: []
    });
  };

  _proto.canPop = function canPop() {
    var history = this.state.history;
    return history.length > 1;
  };

  return Router;
}();

var AccessNavigator = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccessNavigator, _React$Component);

  function AccessNavigator(props) {
    var _this2;

    _this2 = _React$Component.call(this, props) || this;
    _this2.state = {
      currentRoute: props.router.getCurrentRoute()
    };
    _this2.onRouteChange = _this2.onRouteChange.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  var _proto2 = AccessNavigator.prototype;

  _proto2.componentDidMount = function componentDidMount() {
    this.props.router.subscribe(this);
  };

  _proto2.componentWillUnmount = function componentWillUnmount() {
    this.props.router.unsubscribe(this);
  };

  _proto2.onRouteChange = function onRouteChange(currentRoute) {
    this.setState({
      currentRoute: currentRoute
    });
  };

  _proto2.render = function render() {
    var currentRoute = this.state.currentRoute;
    var routes = this.props.routes;

    if (!routes || routes.length === 0 || currentRoute === '') {
      return null;
    }

    var route = routes.find(function (r) {
      return r.route === currentRoute;
    });

    if (!route) {
      return null;
    }

    var Route = route.component;
    return /*#__PURE__*/React.createElement(Route, this.props.router);
  };

  return AccessNavigator;
}(React.Component);

AccessNavigator.propTypes = {
  router: PropTypes__default.instanceOf(Router),
  routes: PropTypes__default.arrayOf(PropTypes__default.shape({
    route: PropTypes__default.string,
    component: PropTypes__default.func
  }))
};
var createNewRouter = function createNewRouter(initialRoute) {
  return new Router(initialRoute);
};

var _templateObject$18, _templateObject2$O, _templateObject3$x, _templateObject4$m, _templateObject5$i, _templateObject6$d, _templateObject7$d, _templateObject8$8;
var lurker$8 = new Lurker('email_change_pincode_modal');
var Content$r = styled(View$1)(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n"])));
var ErrorMessageWrapper = styled(View$1)(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var TextWrapper = styled(View$1)(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteralLoose(["\n  margin-left: 4px;\n"])));
var TitleWrapper$3 = styled(View$1)(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteralLoose(["\n  margin-top: 28px;\n"])));
var Description$7 = styled(Text$1)(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 24px;\n  margin-bottom: 8px;\n"])));
var PincodeWrapper = styled(View$1)(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteralLoose(["\n  margin-top: 32px;\n  width: 100%;\n"])));
var WaitLockWrapper = styled(View$1)(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  flex: 1;\n  width: 100%;\n"])));
var PhoneText = styled(function (props) {
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    size: "title3",
    weight: "semiBold"
  }, props));
})(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  color: #4a4a4a;\n"])));

var modalClose$2 = function modalClose(onClose) {
  return function () {
    lurker$8.clickEvt('modal_close');

    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };
};

var errors = {
  showGenericError: false,
  showInvalidPinCodeError: false
};

var EmailChangePincodeModal = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(EmailChangePincodeModal, _BaseForm);

  function EmailChangePincodeModal(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.closeResendCodeSuccessMessage = function () {
      return _this.setState({
        showResendCodeSuccessMessage: false
      });
    };

    _this.lockCountdown = function () {
      var lockTime = _this.state.lockTime;

      if (lockTime >= -1) {
        setTimeout(function () {
          _this.setState({
            lockTime: lockTime - 1
          }, _this.lockCountdown);
        }, 1000);
      }
    };

    _this.checkAttemptLockTime = function () {
      getRemainingTime().then(function (remaining) {
        if (remaining > 0) {
          _this.setState({
            lockTime: remaining
          }, _this.lockCountdown);
        }
      });
    };

    _this.onCheckPincodeSuccess = function () {
      lurker$8.viewMessageEvt('check_pincode_success');

      if (_this.props.onSuccess) {
        _this.props.onSuccess();
      }
    };

    _this.onCheckPincodeError = function (error, eventName) {
      if (error === void 0) {
        error = {};
      }

      if (eventName === void 0) {
        eventName = 'error';
      }

      var _error = error,
          _error$response = _error.response,
          _error$response2 = _error$response === void 0 ? {} : _error$response,
          status = _error$response2.status,
          _error$response2$data = _error$response2.data,
          _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
          message = _error$response2$data2.message;

      var genericError = 'showGenericError';

      if (eventName !== 'error') {
        genericError = 'showResendCodeError';
      }

      if (status === 401) {
        lurker$8.viewMessageEvt(eventName, {
          accounts_reason: 'unauthorized',
          accounts_status_code: status
        });
      } else if (status === 429) {
        lurker$8.viewMessageEvt(eventName, {
          accounts_reason: 'rate_limit_exceeded',
          accounts_status_code: status
        });
      } else if (status === 403) {
        switch (message) {
          case 'INVALID_PIN_CODE':
            lurker$8.viewMessageEvt(eventName, {
              accounts_reason: 'invalid_pin_code',
              accounts_status_code: status
            });

            _this.showError('showInvalidPinCodeError');

            break;

          default:
            lurker$8.viewMessageEvt(eventName, {
              accounts_reason: message && typeof message === 'string' ? message.toLowerCase() : 'unexpected_status_code',
              accounts_status_code: status
            });

            _this.showError(genericError);

        }
      } else if (status) {
        lurker$8.viewMessageEvt(eventName, {
          accounts_reason: 'unexpected_status_code',
          accounts_status_code: status
        });

        _this.showError(genericError);
      } else {
        lurker$8.viewMessageEvt(eventName, {
          accounts_reason: 'unexpected_error',
          accounts_error_message: error && error.message || 'unknown'
        });

        _this.showError(genericError);
      }
    };

    _this.onSendPincodeSuccess = function (actionType) {
      _this.checkAttemptLockTime();

      lurker$8.viewMessageEvt(actionType + "_success");
    };

    _this.onSendPincodeError = function (actionType) {
      lurker$8.viewMessageEvt(actionType + "_error");
    };

    _this.onResendPincodeSuccess = function (actionType) {
      _this.checkAttemptLockTime();

      lurker$8.viewMessageEvt(actionType + "_success");
    };

    _this.onResendPincodeError = function (actionType) {
      lurker$8.viewMessageEvt(actionType + "_error");
    };

    _this.onPincodeChange = function (pincode, isValid) {
      _this.updateField('pincode', pincode, isValid, false, null, null);
    };

    _this.resendPincode = function () {
      var phone = _this.props.phone;
      var landLine = isLandline(phone);
      var actionType = landLine ? 'remake_call' : 'resend_pincode';
      var action = landLine ? makeCall(phone) : sendSMS(phone);
      lurker$8.clickEvt(actionType);

      _this.setState({
        isSubmitting: true
      });

      action.then(function () {
        return _this.onResendPincodeSuccess(actionType);
      })["catch"](function () {
        return _this.onResendPincodeError(actionType);
      })["finally"](function () {
        _this.setState({
          isSubmitting: false,
          showResendCodeSuccessMessage: true
        });
      });
    };

    _this.sendPincode = function () {
      var phone = _this.props.phone;
      var router = _this.state.router;
      var landLine = isLandline(phone);
      var actionType = landLine ? 'make_call' : 'send_pincode';
      var action = landLine ? makeCall(phone) : sendSMS(phone);
      lurker$8.clickEvt(actionType);

      _this.setState({
        isSubmitting: true
      });

      action.then(function () {
        return _this.onSendPincodeSuccess(actionType);
      })["catch"](function () {
        return _this.onSendPincodeError(actionType);
      })["finally"](function () {
        return _this.setState({
          isSubmitting: false
        }, function () {
          return router.push('CheckPincode');
        });
      });
    };

    _this.checkPincode = function (event) {
      if (event) event.preventDefault();
      var pincode = _this.state.fields.pincode;
      var phone = _this.props.phone;
      if (!pincode.valid) return;
      lurker$8.clickEvt('check_pincode');

      _this.setState({
        isSubmitting: true
      });

      checkCodeV3(phone, pincode.value).then(_this.onCheckPincodeSuccess)["catch"](_this.onCheckPincodeError)["finally"](function () {
        return _this.setState({
          isSubmitting: false
        });
      });
    };

    _this.renderCheckPincode = function () {
      var formattedPhone = getMaskedValue(_this.props.phone, false);
      var _this$state = _this.state,
          isSubmitting = _this$state.isSubmitting,
          pincode = _this$state.fields.pincode,
          lockTime = _this$state.lockTime,
          showResendCodeSuccessMessage = _this$state.showResendCodeSuccessMessage,
          showInvalidPinCodeError = _this$state.showInvalidPinCodeError,
          showGenericError = _this$state.showGenericError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Description$7, {
        size: "body1",
        weight: "regular"
      }, "Digite o c\xF3digo enviado para"), /*#__PURE__*/React.createElement(PhoneText, null, formattedPhone.pretty), /*#__PURE__*/React.createElement(PincodeWrapper, null, /*#__PURE__*/React.createElement(PinCode, {
        disabled: isSubmitting,
        hasError: showInvalidPinCodeError,
        onChange: _this.onPincodeChange,
        pinCode: pincode
      }), (showInvalidPinCodeError || showGenericError) && /*#__PURE__*/React.createElement(ErrorMessageWrapper, null, /*#__PURE__*/React.createElement(AlertSymbol, {
        width: 16,
        heigth: 16
      }), /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(Text$1, {
        size: "caption",
        style: {
          color: '#ff4444'
        }
      }, showInvalidPinCodeError && 'O código digitado é inválido', showGenericError && 'Houve um erro inesperado, tente novamente')))), /*#__PURE__*/React.createElement(Button, {
        marginTop: "--spacing-4",
        size: "large",
        fullWidth: true,
        onClick: _this.checkPincode,
        disabled: isSubmitting || !pincode.valid
      }, "Confirmar c\xF3digo"), /*#__PURE__*/React.createElement(WaitLockWrapper, null, lockTime <= 0 ? /*#__PURE__*/React.createElement(formLabel, {
        text: "N\xE3o recebeu o c\xF3digo?",
        linkText: "Reenviar",
        onClick: _this.resendPincode,
        disabled: isSubmitting
      }) : /*#__PURE__*/React.createElement(WaitLockBanner, {
        value: lockTime,
        backgroundColor: "#FFFFFF"
      })), /*#__PURE__*/React.createElement(SuccessMessage, {
        text: "C\xF3digo reenviado com sucesso",
        show: showResendCodeSuccessMessage,
        onClose: _this.closeResendCodeSuccessMessage
      }));
    };

    _this.renderSendPincode = function () {
      var _this$props = _this.props,
          onBack = _this$props.onBack,
          phone = _this$props.phone;
      var isSubmitting = _this.state.isSubmitting;
      var formattedPhone = getMaskedValue(phone, false);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Description$7, {
        size: "body1",
        weight: "regular"
      }, "Um c\xF3digo ser\xE1 enviado por SMS para seu celular. Se fixo, faremos uma liga\xE7\xE3o."), /*#__PURE__*/React.createElement(PhoneText, null, formattedPhone.pretty), /*#__PURE__*/React.createElement(Button, {
        marginTop: "--spacing-4",
        size: "large",
        fullWidth: true,
        onClick: _this.sendPincode,
        disabled: isSubmitting
      }, "Enviar c\xF3digo"), /*#__PURE__*/React.createElement(Button, {
        marginTop: "--spacing-3",
        variant: "link-button",
        size: "small",
        onClick: function onClick() {
          lurker$8.clickEvt('back');
          onBack();
        }
      }, "Voltar"));
    };

    _this.showError = function (error) {
      var _extends2;

      _this.setState(_extends({}, errors, (_extends2 = {}, _extends2[error] = true, _extends2.isSubmitting = false, _extends2)));
    };

    var _router = createNewRouter('SendPincode');

    _this.state = _extends({
      router: _router,
      lockTime: -1,
      isSubmitting: false,
      showResendCodeSuccessMessage: false
    }, errors, {
      validators: {
        pincode: {
          action: null,
          message: ''
        }
      },
      fields: {
        pincode: {
          valid: false,
          pristine: true,
          value: null
        }
      }
    });
    return _this;
  }

  var _proto = EmailChangePincodeModal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkAttemptLockTime();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        onClose = _this$props2.onClose,
        open = _this$props2.open;
    var router = this.state.router;
    return /*#__PURE__*/React.createElement(Modal$1, {
      onClose: modalClose$2(onClose),
      maxWidth: "400px",
      maxHeight: "600px",
      open: open
    }, /*#__PURE__*/React.createElement(Content$r, null, /*#__PURE__*/React.createElement(SquareLockIcon, null), /*#__PURE__*/React.createElement(TitleWrapper$3, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title3",
      weight: "semiBold"
    }, "Confirme seu telefone")), /*#__PURE__*/React.createElement(AccessNavigator, {
      router: router,
      routes: [{
        route: 'SendPincode',
        component: this.renderSendPincode
      }, {
        route: 'CheckPincode',
        component: this.renderCheckPincode
      }]
    })));
  };

  return EmailChangePincodeModal;
}(BaseForm);

EmailChangePincodeModal.propTypes = {
  phone: PropTypes__default.string.isRequired,
  onClose: PropTypes__default.func.isRequired,
  onBack: PropTypes__default.func.isRequired,
  onSuccess: PropTypes__default.func.isRequired,
  open: PropTypes__default.bool.isRequired
};

var _templateObject$19, _templateObject2$P, _templateObject3$y, _templateObject4$n, _templateObject5$j, _templateObject6$e, _templateObject7$e, _templateObject8$9, _templateObject9$4, _templateObject10$4, _templateObject11$1, _templateObject12$1, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
var lurker$9 = new Lurker('meu_cadastro');
var Content$s = styled(View$1)(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var Row$7 = styled(View$1)(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-top: 32px;\n  margin-bottom: 32px;\n"])));
var ContactWrapper = styled(View$1)(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n"])));
var ContactData = styled(Text$1)(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n  font-size: 16;\n  margin-right: 8px;\n"])));
var FacebookRow = styled(Row$7)(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteralLoose(["\n  justify-content: space-between;\n  display: flex;\n  margin: 0;\n"])));
var ContactLabel = styled(Label$1)(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteralLoose(["\n  margin-right: 8px;\n"])));
var ActionLink = styled(link)(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  font-size: 14px;\n"])));
var ConnectWithFacebookLabel = styled(Label$1)(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteralLoose(["\n  margin-left: 8px;\n  font-weight: 700;\n"])));
var FacebookWrapper = styled(Row$7)(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  margin: 0;\n"])));
var VerifiedText = styled(Text$1)(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteralLoose(["\n  color: #84d43e;\n  margin-left: 4px;\n  margin-right: 8px;\n  font-size: 16px;\n  ", "\n  ", "\n"])), mediaQuery.medium(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteralLoose(["font-size:14px;"]))), mediaQuery.small(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteralLoose(["font-size:12px;"]))));
var ChangePhoneWrapper = styled(View$1)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n"])));

var facebookNotLoggedIn = function facebookNotLoggedIn(_ref) {
  var className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/React.createElement(View$1, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(facebookSquare, null), /*#__PURE__*/React.createElement(ConnectWithFacebookLabel, null, "Conectar com Facebook"));
};

var FacebookNotLoggedIn = styled(facebookNotLoggedIn)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n  margin-top: 32px;\n  margin-bottom: 32px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n"])));
var BaseWrapper = styled(View$1)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 24px;\n"])));
var ActivateMailWrapper = styled(View$1)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  display: flex;\n  flex-basis: 100%;\n"])));

var Verified = function Verified() {
  return /*#__PURE__*/React.createElement(BaseWrapper, null, /*#__PURE__*/React.createElement(Icon, {
    color: "#84d43e",
    width: 16,
    height: 16,
    svgPath: CheckedSvgPath
  }), /*#__PURE__*/React.createElement(VerifiedText, null, "verificado"));
};

var GrayText = styled(Text$1)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n  color: #9b9b9b;\n  font-size: 14px;\n"])));

var VerificationEmailSent = function VerificationEmailSent() {
  return /*#__PURE__*/React.createElement(BaseWrapper, null, /*#__PURE__*/React.createElement(GrayText, null, "E-mail para verifica\xE7\xE3o reenviado."));
};

var FacebookLoggedIn = styled(facebookConnectedAs)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n  background-color: transparent;\n  padding-left: 0;\n  padding-top: 11px;\n  padding-bottom: 11px;\n"])));

var onConnectToFacebookSwitchClick = function onConnectToFacebookSwitchClick(checked) {
  lurker$9.clickEvt(checked ? 'desconectar_facebook' : 'conectar_facebook');
};

var MyAccountContactTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MyAccountContactTemplate, _React$Component);

  function MyAccountContactTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onFacebookChange = function (result, facebookId, facebookName) {
      var onFacebookConnectedChange = _this.props.onFacebookConnectedChange;

      _this.setState({
        facebookId: facebookId,
        facebookName: facebookName
      }, function () {
        return onFacebookConnectedChange(result, facebookId, facebookName);
      });
    };

    _this.onFacebookError = function (error) {
      var onFacebookConnectedError = _this.props.onFacebookConnectedError;

      if (onFacebookConnectedError && typeof onFacebookConnectedError === 'function') {
        onFacebookConnectedError(error);
      }
    };

    _this.onSendVerificationEmailClick = function (event) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }

      lurker$9.clickEvt('reenviar_email_verificacao');
      var _this$state = _this.state,
          sendingVerificationEmail = _this$state.sendingVerificationEmail,
          verificationEmailSent = _this$state.verificationEmailSent;

      if (!sendingVerificationEmail && !verificationEmailSent) {
        _this.setState({
          sendingVerificationEmail: true
        }, function () {
          verifyEmail().then(function () {
            return _this.setState({
              verificationEmailSent: true,
              sendingVerificationEmail: false
            });
          })["catch"](function () {
            return _this.setState({
              sendingVerificationEmail: false
            });
          });
        });
      }
    };

    _this.onConfirmarTelefoneClick = function () {
      lurker$9.clickEvt('cadastre_telefone');

      _this.changePhone();
    };

    _this.onEmailChangeMailSentModalClose = function () {
      _this.setState({
        showEmailChangeConfirmationModal: false
      });
    };

    _this.emailChangeMailSent = function () {
      _this.setState({
        showEmailChangeConfirmationModal: true
      });

      lurker$9.viewMessageEvt('email_change_request_success');

      if (_this.props.onChangeEmailMailSent) {
        _this.props.onChangeEmailMailSent();
      }
    };

    _this.sendEmailChangeEmail = function () {
      createEmailChangeRequest().then(_this.emailChangeMailSent)["catch"](function (error) {
        var _error$response = error.response,
            _error$response2 = _error$response === void 0 ? {} : _error$response,
            status = _error$response2.status,
            _error$response2$data = _error$response2.data,
            _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
            message = _error$response2$data2.message;

        lurker$9.viewMessageEvt('email_change_request_error', {
          accounts_reason: message,
          accounts_error_code: status
        });

        if (status === 403) {
          _this.setState({
            showContactUsModal: true,
            changeEmailFailedMessage: message
          });
        }
      });
    };

    _this.closeContactUsModal = function () {
      _this.setState({
        showContactUsModal: false,
        changeEmailFailedMessage: null
      });
    };

    _this.changePhone = function () {
      var _this$props = _this.props,
          onChangePhone = _this$props.onChangePhone,
          phone = _this$props.phone;

      if (onChangePhone) {
        onChangePhone(phone);
      }
    };

    _this.openEmailChangePincodeModal = function () {
      _this.setState({
        showEmailChangePincodeModal: true,
        showEmailChangeConfirmationModal: false
      });
    };

    _this.closeEmailChangePincodeModal = function () {
      _this.setState({
        showEmailChangePincodeModal: false,
        showEmailChangeConfirmationModal: false
      });
    };

    _this.moveBackToEmailChangeSentModal = function () {
      _this.setState({
        showEmailChangePincodeModal: false,
        showEmailChangeConfirmationModal: true
      });
    };

    _this.changeEmail = function () {
      var onChangeEmail = _this.props.onChangeEmail;
      lurker$9.clickEvt('email_change_request');

      _this.sendEmailChangeEmail();

      if (onChangeEmail) {
        onChangeEmail();
      }
    };

    _this.state = {
      sendingVerificationEmail: false,
      verificationEmailSent: false,
      showEmailChangeConfirmationModal: false,
      showContactUsModal: false,
      changeEmailFailedMessage: null,
      showEmailChangePincodeModal: false
    };
    return _this;
  }

  MyAccountContactTemplate.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var facebookId = props.facebookId,
        facebookName = props.facebookName;
    return {
      facebookId: facebookId,
      facebookName: facebookName
    };
  };

  var _proto = MyAccountContactTemplate.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        email = _this$props2.email,
        phone = _this$props2.phone,
        emailVerified = _this$props2.emailVerified,
        phoneVerified = _this$props2.phoneVerified,
        phoneVerifiedAt = _this$props2.phoneVerifiedAt,
        onFacebookConnectStart = _this$props2.onFacebookConnectStart,
        onFacebookConnectFinish = _this$props2.onFacebookConnectFinish,
        loading = _this$props2.loading,
        onChangePhone = _this$props2.onChangePhone,
        onChangeEmailPincodeSuccess = _this$props2.onChangeEmailPincodeSuccess;
    var _this$state2 = this.state,
        facebookId = _this$state2.facebookId,
        facebookName = _this$state2.facebookName,
        sendingVerificationEmail = _this$state2.sendingVerificationEmail,
        verificationEmailSent = _this$state2.verificationEmailSent,
        showEmailChangeConfirmationModal = _this$state2.showEmailChangeConfirmationModal,
        showContactUsModal = _this$state2.showContactUsModal,
        changeEmailFailedMessage = _this$state2.changeEmailFailedMessage,
        showEmailChangePincodeModal = _this$state2.showEmailChangePincodeModal;

    if (loading) {
      return /*#__PURE__*/React.createElement(Content$s, null, /*#__PURE__*/React.createElement(FormSkeleton, {
        size: "3",
        height: 250
      }));
    }

    return /*#__PURE__*/React.createElement(Content$s, null, /*#__PURE__*/React.createElement(Row$7, null, /*#__PURE__*/React.createElement(ContactWrapper, null, /*#__PURE__*/React.createElement(ContactLabel, null, "E-mail"), /*#__PURE__*/React.createElement(ContactData, null, email), emailVerified && /*#__PURE__*/React.createElement(Verified, null)), /*#__PURE__*/React.createElement(Button, {
      variant: "link-button",
      size: "small",
      onClick: this.changeEmail,
      "aria-label": "Alterar e-mail"
    }, "Alterar"), !emailVerified && /*#__PURE__*/React.createElement(ActivateMailWrapper, null, !verificationEmailSent && /*#__PURE__*/React.createElement(ActionLink, {
      type: "primary",
      underline: false,
      onClick: this.onSendVerificationEmailClick,
      disabled: sendingVerificationEmail
    }, "Reenviar e-mail para verifica\xE7\xE3o"), verificationEmailSent && /*#__PURE__*/React.createElement(VerificationEmailSent, null))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ruleWithText, null), /*#__PURE__*/React.createElement(Row$7, null, /*#__PURE__*/React.createElement(ContactWrapper, null, /*#__PURE__*/React.createElement(ContactLabel, null, "Telefone"), phone && /*#__PURE__*/React.createElement(ContactData, null, phone), phoneVerified && /*#__PURE__*/React.createElement(ChangePhoneWrapper, null, /*#__PURE__*/React.createElement(Verified, null), /*#__PURE__*/React.createElement(Button, {
      variant: "link-button",
      tag: "a",
      size: "small",
      href: confirmarTelefone,
      onClick: this.changePhone,
      "aria-label": "Alterar telefone"
    }, "Alterar"))), !phoneVerified && /*#__PURE__*/React.createElement(ActionLink, {
      href: confirmarTelefone,
      type: "primary",
      underline: false,
      onClick: this.onConfirmarTelefoneClick,
      preventHrefOnClick: !!onChangePhone
    }, "Cadastre um telefone verificado"))), /*#__PURE__*/React.createElement(ruleWithText, null), /*#__PURE__*/React.createElement(FacebookRow, null, /*#__PURE__*/React.createElement(FacebookWrapper, null, facebookId ? /*#__PURE__*/React.createElement(FacebookLoggedIn, {
      name: facebookName,
      imageUrl: "https://graph.facebook.com/" + facebookId + "/picture"
    }) : /*#__PURE__*/React.createElement(FacebookNotLoggedIn, null)), /*#__PURE__*/React.createElement(Component$1, {
      facebookAppId: "106401512762894",
      onFacebookConnectedChange: this.onFacebookChange,
      onError: this.onFacebookError,
      onConnectStart: onFacebookConnectStart,
      onConnectFinish: onFacebookConnectFinish,
      onClick: onConnectToFacebookSwitchClick,
      checked: !!facebookId
    })), /*#__PURE__*/React.createElement(EmailChangeConfirmationSentModal, {
      email: email,
      phoneVerified: phoneVerified,
      phoneVerifiedAt: phoneVerifiedAt,
      open: showEmailChangeConfirmationModal,
      onClose: this.onEmailChangeMailSentModalClose,
      onAnotherWayHandler: this.openEmailChangePincodeModal
    }), phone && phoneVerified && /*#__PURE__*/React.createElement(EmailChangePincodeModal, {
      phone: phone,
      open: showEmailChangePincodeModal,
      onClose: this.closeEmailChangePincodeModal,
      onBack: this.moveBackToEmailChangeSentModal,
      onSuccess: onChangeEmailPincodeSuccess
    }), /*#__PURE__*/React.createElement(EmailChangeContactUsModal, {
      open: showContactUsModal,
      onClose: this.closeContactUsModal,
      message: changeEmailFailedMessage
    }));
  };

  return MyAccountContactTemplate;
}(React.Component);

MyAccountContactTemplate.defaultProps = {
  onFacebookConnectedChange: function onFacebookConnectedChange() {},
  pincodeEmailChangeEnabled: false
};
MyAccountContactTemplate.propTypes = {
  email: PropTypes__default.string,
  emailVerified: PropTypes__default.bool,
  phone: PropTypes__default.string,
  phoneVerified: PropTypes__default.bool,
  phoneVerifiedAt: PropTypes__default.string,
  onFacebookConnectedChange: PropTypes__default.func,
  onFacebookConnectedError: PropTypes__default.func,
  onFacebookConnectStart: PropTypes__default.func,
  onFacebookConnectFinish: PropTypes__default.func,
  onChangePhone: PropTypes__default.func,
  onChangeEmail: PropTypes__default.func,
  onChangeEmailMailSent: PropTypes__default.func,
  onChangeEmailPincodeSuccess: PropTypes__default.func,
  loading: PropTypes__default.bool
};
MyAccountContactTemplate.defaultProps = {
  loading: false
};

var morePath = 'M12,8 C10.9,8 10,7.1 10,6 C10,4.9 10.9,4 12,4 C13.1,4 14,4.9 14,6 C14,7.1 13.1,8 12,8 Z M12,10 C13.1,10 14,10.9 14,12 C14,13.1 13.1,14 12,14 C10.9,14 10,13.1 10,12 C10,10.9 10.9,10 12,10 Z M12,16 C13.1,16 14,16.9 14,18 C14,19.1 13.1,20 12,20 C10.9,20 10,19.1 10,18 C10,16.9 10.9,16 12,16 Z';

var _templateObject$1a, _templateObject2$Q, _templateObject3$z, _templateObject4$o, _templateObject5$k, _templateObject6$f, _templateObject7$f;
var WIDTH = 240;
var Content$t = styled(View$1)(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n  padding: 8px 0;\n  width: ", "px;\n  height: auto;\n  position: absolute;\n  top: 0;\n  left: ", "px;\n  z-index: 999;\n  display: ", ";\n  border-radius: 8px;\n"])), WIDTH, -1 * WIDTH, function (_ref) {
  var open = _ref.open;
  return open ? 'block' : 'none';
});
var MenuContent = styled(View$1)(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n"])));
var MainWrapper = styled(View$1)(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  position: relative;\n"])));
var ActionsWrapper = styled(View$1)(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n"])));
var Icon$1 = styled(SVG)(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteralLoose(["\n  margin-right: 16;\n"])));
var DotsMenuIcon = styled(SVG)(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteralLoose(["\n  margin-right: 16;\n  background-color: ", ";\n  border-radius: 50%;\n  padding: 2px;\n  margin: 4px;\n"])), function (_ref2) {
  var open = _ref2.open;
  return open ? '#F7F1FD' : 'unset';
});
var Action = styled(Button)(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  color: #4a4a4a;\n  line-height: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: 'Nunito Sans';\n  text-decoration: none;\n  padding: 12px 24px;\n  -webkit-tap-highlight-color: transparent;\n  justify-content: start;\n  border-radius: 0;\n\n  &:hover .icon > path {\n    fill: #6e0ad6;\n  }\n  &:hover {\n    border-radius: 0;\n    border-color: transparent;\n    background-color: #f6f6f6;\n    color: #6e0ad6;\n  }\n"])));

var ActionElement = function ActionElement(props) {
  var onClick = props.onClick,
      label = props.label,
      iconPath = props.iconPath;
  return /*#__PURE__*/React.createElement(Action, {
    fullWidth: true,
    variant: "link-button",
    icon: /*#__PURE__*/React.createElement(Icon$1, {
      svgPath: iconPath,
      viewBox: "0 0 24 24",
      height: 24,
      width: 24,
      color: "#4A4A4A",
      className: "icon"
    }),
    onClick: onClick
  }, label);
};

var MoreVertical = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MoreVertical, _React$Component);

  function MoreVertical(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleMouseEnter = function () {
      _this.setState({
        open: true
      });

      if (_this.props.onHover) {
        _this.props.onHover();
      }
    };

    _this.handleMouseLeave = function () {
      _this.setState({
        open: false
      });
    };

    _this.toggle = function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  var _proto = MoreVertical.prototype;

  _proto.render = function render() {
    var open = this.state.open;
    var actions = this.props.actions;
    return /*#__PURE__*/React.createElement(MainWrapper, {
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      onClick: this.toggle,
      onFocus: this.handleMouseEnter
    }, /*#__PURE__*/React.createElement(DotsMenuIcon, {
      open: open,
      svgPath: morePath,
      color: open ? '#6E0AD6' : '#4A4A4A',
      width: 24,
      height: 24
    }), /*#__PURE__*/React.createElement(Content$t, {
      open: open
    }, /*#__PURE__*/React.createElement(MenuContent, null, /*#__PURE__*/React.createElement(ActionsWrapper, null, actions.map(function (action) {
      return /*#__PURE__*/React.createElement(ActionElement, {
        label: action.label,
        onClick: action.onPress,
        iconPath: action.icon,
        key: action.id
      });
    })))));
  };

  return MoreVertical;
}(React.Component);

MoreVertical.propTypes = {
  actions: PropTypes__default.arrayOf(PropTypes__default.object),
  onHover: PropTypes__default.func
};
MoreVertical.defaultProps = {
  actions: []
};

var editPath = 'M12.5303 0.46967L16.5303 4.46967C16.8232 4.76256 16.8232 5.23744 16.5303 5.53033L5.53033 16.5303C5.38968 16.671 5.19891 16.75 5 16.75H1C0.585786 16.75 0.25 16.4142 0.25 16V12C0.25 11.8011 0.329018 11.6103 0.46967 11.4697L11.4697 0.46967C11.7626 0.176777 12.2374 0.176777 12.5303 0.46967ZM12 2.06066L1.75 12.3107V15.25H4.68934L14.9393 5L12 2.06066ZM1 21.75C0.585786 21.75 0.25 21.4142 0.25 21C0.25 20.5858 0.585786 20.25 1 20.25H19C19.4142 20.25 19.75 20.5858 19.75 21C19.75 21.4142 19.4142 21.75 19 21.75H1Z';

var starPath = 'M7.41177 6.57485L10.3274 0.668032C10.6026 0.110656 11.3974 0.110656 11.6725 0.668032L14.5882 6.57485L21.1084 7.52789C21.7234 7.61777 21.9685 8.37365 21.5233 8.80727L16.8059 13.402L17.9192 19.8932C18.0243 20.5059 17.3811 20.9732 16.8309 20.6838L11 17.6174L5.16905 20.6838C4.61883 20.9732 3.97567 20.5059 4.08076 19.8932L5.19407 13.402L0.476662 8.80727C0.031467 8.37365 0.276555 7.61777 0.891491 7.52789L7.41177 6.57485ZM11 2.69444L8.58249 7.59197C8.47334 7.8131 8.26245 7.96645 8.01843 8.00211L2.61127 8.79245L6.52326 12.6027C6.70017 12.775 6.78091 13.0234 6.73917 13.2668L5.8161 18.6488L10.6509 16.1062C10.8694 15.9913 11.1305 15.9913 11.349 16.1062L16.1838 18.6488L15.2608 13.2668C15.219 13.0234 15.2998 12.775 15.4767 12.6027L19.3887 8.79245L13.9815 8.00211C13.7375 7.96645 13.5266 7.8131 13.4174 7.59197L11 2.69444Z';

var trashPath = 'M14.75 4.25H19C19.4142 4.25 19.75 4.58579 19.75 5C19.75 5.41421 19.4142 5.75 19 5.75H17.75V19C17.75 20.5188 16.5188 21.75 15 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V5.75H1C0.585786 5.75 0.25 5.41421 0.25 5C0.25 4.58579 0.585786 4.25 1 4.25H5.25V3C5.25 1.48122 6.48122 0.25 8 0.25H12C13.5188 0.25 14.75 1.48122 14.75 3V4.25ZM13.25 4.25V3C13.25 2.30964 12.6904 1.75 12 1.75H8C7.30964 1.75 6.75 2.30964 6.75 3V4.25H13.25ZM16.25 5.75H3.75V19C3.75 19.6904 4.30964 20.25 5 20.25H15C15.6904 20.25 16.25 19.6904 16.25 19V5.75Z';

var _templateObject$1b, _templateObject2$R, _templateObject3$A, _templateObject4$p, _templateObject5$l, _templateObject6$g, _templateObject7$g, _templateObject8$a, _templateObject9$5, _templateObject10$5;
var Main = styled(View$1)(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var Wrapper$4 = styled(View$1)(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  margin-right: 0;\n  margin-left: 0;\n"])));
var LeftContent = styled(View$1)(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 53%;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-right: 16px;\n  margin-left: 16px;\n"])));
var AddressDetailsContainer = styled(View$1)(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n"])));
var RightContent = styled(View$1)(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var LinkWrapper$1 = styled(View$1)(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-right: 16px;\n  align-self: flex-end;\n"])));
var LinkAction = styled(Touchable)(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n  line-height: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: 'Nunito Sans';\n  text-decoration: none;\n"])));
var TagWrapper = styled(View$1)(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-top-left-radius: 30px;\n  border-bottom-left-radius: 30px;\n  background-color: #f6f6f6;\n  width: 73px;\n  padding-left: 10px;\n  height: 18px;\n  align-items: center;\n  align-self: flex-end;\n  justify-content: center;\n"])));
var TagText = styled(View$1)(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteralLoose(["\n  margin-right: 16px;\n  margin-bottom: 1px;\n"])));
var Divider = styled(View$1)(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteralLoose(["\n  height: 1px;\n  overflow: hidden;\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--color-neutral-90);\n  margin-top: 4px;\n  margin-bottom: 4px;\n  margin-right: 16px;\n  margin-left: 16px;\n"])));

var Tag = function Tag() {
  return /*#__PURE__*/React.createElement(TagWrapper, null, /*#__PURE__*/React.createElement(TagText, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "caption",
    color: "grayscale.darker"
  }, "principal")));
};

var AddressElement = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AddressElement, _React$Component);

  function AddressElement() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onClick = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          onClickEdit = _this$props.onClickEdit;

      if (data.main) {
        onClickEdit(data);
      }
    };

    _this.onDelete = function (ev) {
      ev.preventDefault();

      if (_this.props.onDelete) {
        _this.props.onDelete();
      }
    };

    _this.onEdit = function (ev) {
      ev.preventDefault();
      var _this$props2 = _this.props,
          data = _this$props2.data,
          onClickEdit = _this$props2.onClickEdit;

      if (onClickEdit) {
        onClickEdit(data);
      }
    };

    _this.onHover = function () {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          onHoverMore = _this$props3.onHoverMore;

      if (onHoverMore) {
        onHoverMore(data);
      }
    };

    _this.onSetAsDefault = function (ev) {
      ev.preventDefault();

      if (_this.props.onSetAsDefault) {
        _this.props.onSetAsDefault();
      }
    };

    return _this;
  }

  var _proto = AddressElement.prototype;

  _proto.render = function render() {
    var _this$props4 = this.props,
        data = _this$props4.data,
        last = _this$props4.last;
    var id = data.id,
        street = data.street,
        number = data.number,
        complement = data.complement,
        neighbourhood = data.neighbourhood,
        city = data.city,
        state = data.state,
        zipcode = data.zipcode,
        reference = data.reference,
        main = data.main;
    var hasComplement = complement && complement !== '';
    return /*#__PURE__*/React.createElement(Main, {
      id: id
    }, /*#__PURE__*/React.createElement(Wrapper$4, null, /*#__PURE__*/React.createElement(LeftContent, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "body1"
    }, street, ", ", number), /*#__PURE__*/React.createElement(AddressDetailsContainer, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, hasComplement && complement + ", ", neighbourhood), /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, city, ", ", state), /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, applyMask(zipcode, null, [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/])), !!reference && /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, reference))), /*#__PURE__*/React.createElement(RightContent, null, main && /*#__PURE__*/React.createElement(Tag, null), /*#__PURE__*/React.createElement(LinkWrapper$1, null, /*#__PURE__*/React.createElement(Button, {
      variant: "link-button",
      onClick: this.onClick,
      "aria-label": "Editar endere\xE7o"
    }, main ? /*#__PURE__*/React.createElement(Text$1, {
      size: "body1",
      color: "secondary"
    }, "editar") : /*#__PURE__*/React.createElement(MoreVertical, {
      actions: [{
        id: 1,
        label: 'Editar',
        icon: editPath,
        onPress: this.onEdit
      }, {
        id: 2,
        label: 'Usar como principal',
        icon: starPath,
        onPress: this.onSetAsDefault
      }, {
        id: 3,
        label: 'Excluir',
        icon: trashPath,
        onPress: this.onDelete
      }],
      onHover: this.onHover
    }))))), !last && /*#__PURE__*/React.createElement(Divider, null));
  };

  return AddressElement;
}(React.Component);

AddressElement.propTypes = {
  onClickEdit: PropTypes__default.func,
  onHoverMore: PropTypes__default.func,
  last: PropTypes__default.bool,
  data: PropTypes__default.shape({
    id: PropTypes__default.string,
    street: PropTypes__default.string,
    number: PropTypes__default.number,
    complement: PropTypes__default.string,
    neighbourhood: PropTypes__default.string,
    city: PropTypes__default.string,
    state: PropTypes__default.string,
    zipcode: PropTypes__default.string,
    reference: PropTypes__default.string,
    main: PropTypes__default.bool
  })
};

var _templateObject$1c, _templateObject2$S, _templateObject3$B, _templateObject4$q, _templateObject5$m;
var lurker$a = new Lurker('meu_cadastro');
var BorderedContent = styled(View$1)(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  border-style: solid;\n  border-color: var(--color-neutral-90);\n  border-width: 1px;\n  border-radius: 4px;\n"])));
var Main$1 = styled(View$1)(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var ComponentTitle$1 = styled(Title)(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteralLoose(["\n  font-size: 20px;\n  font-weight: 700;\n  text-align: left;\n"])));
var CalloutTouchable = styled(Button)(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  border-radius: 0;\n  height: 100%;\n\n  margin: 0;\n  padding: 24px 16px;\n\n  &:hover {\n    background-color: transparent;\n  }\n\n  & > div {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n"])));
var TouchableText = styled(Text$1)(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Nunito Sans';\n  text-decoration: none;\n  margin-left: 0;\n  line-height: 24px;\n"])));
var MAX_ADDRESSES = 5;

var MyAccountAddressListTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MyAccountAddressListTemplate, _React$Component);

  function MyAccountAddressListTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onHoverMore = function (address) {
      lurker$a.clickEvt('abrir_menu_endereco');

      _this.setState({
        currentMoreFocus: address
      });

      if (_this.props.onHoverMore) {
        _this.props.onHoverMore(address);
      }
    };

    _this.onEdit = function (address) {
      var currentMoreFocus = _this.state.currentMoreFocus;
      lurker$a.clickEvt('abrir_editar_endereco');
      var data = address || currentMoreFocus;

      _this.setState({
        currentMoreFocus: data
      });

      if (_this.props.onEdit) {
        _this.props.onEdit(data);
      }
    };

    _this.onSetAsDefault = function () {
      lurker$a.clickEvt('definir_main');
      var currentMoreFocus = _this.state.currentMoreFocus;
      var operation = 'set_main';
      setAddressAsDefault(currentMoreFocus.id).then(function () {
        _this.onSuccess(operation, 'Endereço principal atualizado');

        if (_this.props.onSetAsDefault) {
          _this.props.onSetAsDefault();
        }
      })["catch"](function () {
        return _this.onError(operation);
      });
    };

    _this.onDelete = function () {
      lurker$a.clickEvt('deletar_endereco');
      var operation = 'delete_address';
      var currentMoreFocus = _this.state.currentMoreFocus;
      deleteAddress(currentMoreFocus.id).then(function () {
        _this.onSuccess(operation, 'Endereço excluído');

        if (_this.props.onDelete) {
          _this.props.onDelete();
        }
      })["catch"](function () {
        return _this.onError(operation);
      });
    };

    _this.onError = function (operation, error) {
      var _error$response = error.response,
          response = _error$response === void 0 ? {} : _error$response;

      var _ref = response.data || {},
          _ref$message = _ref.message,
          message = _ref$message === void 0 ? 'unexpected_error' : _ref$message;

      lurker$a.viewMessageEvt('error', {
        accounts_operation: operation,
        accounts_reason: message.toLowerCase(),
        accounts_status_code: response.status
      });

      if (_this.props.onError) {
        _this.props.onError('Não foi possível executar essa operação');
      }
    };

    _this.onSuccess = function (operation, message) {
      lurker$a.viewMessageEvt('success', {
        accounts_operation: operation
      });

      if (_this.props.onSuccess) {
        _this.props.onSuccess(message);
      }
    };

    _this.orderList = function (addressList) {
      return addressList.sort(function (address1, address2) {
        return address1.main ? -1 : address2.main ? 1 : 0;
      });
    };

    _this.renderList = function (addressList) {
      return _this.orderList(addressList).map(function (element, i) {
        return /*#__PURE__*/React.createElement(View$1, {
          id: i,
          key: element.id
        }, /*#__PURE__*/React.createElement(AddressElement, {
          data: element,
          onHoverMore: _this.onHoverMore,
          onClickEdit: _this.onEdit,
          onSetAsDefault: _this.onSetAsDefault,
          onDelete: _this.onDelete,
          last: addressList.length === i + 1
        }));
      });
    };

    _this.state = {
      currentMoreFocus: {}
    };
    return _this;
  }

  var _proto = MyAccountAddressListTemplate.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        addressList = _this$props.addressList,
        onAddNew = _this$props.onAddNew;
    return /*#__PURE__*/React.createElement(Main$1, null, /*#__PURE__*/React.createElement(ComponentTitle$1, null, "Endere\xE7os"), /*#__PURE__*/React.createElement(View$1, null, addressList.length > 0 && /*#__PURE__*/React.createElement(BorderedContent, null, this.renderList(addressList)), addressList.length < MAX_ADDRESSES && /*#__PURE__*/React.createElement(BorderedContent, null, /*#__PURE__*/React.createElement(CalloutTouchable, {
      onClick: onAddNew,
      variant: "link-button",
      fullWidth: true
    }, /*#__PURE__*/React.createElement(TouchableText, {
      size: "body1"
    }, "Adicionar endere\xE7o"), /*#__PURE__*/React.createElement(Icon, {
      svgPath: plusPath,
      color: "#6E0AD6",
      width: 24,
      height: 24
    })))));
  };

  return MyAccountAddressListTemplate;
}(React.Component);

MyAccountAddressListTemplate.propTypes = {
  onAddNew: PropTypes__default.func,
  onEdit: PropTypes__default.func,
  onSetAsDefault: PropTypes__default.func,
  onDelete: PropTypes__default.func,
  onHoverMore: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  addressList: PropTypes__default.arrayOf(PropTypes__default.object)
};
MyAccountAddressListTemplate.defaultProps = {
  addressList: []
};

var _templateObject$1d, _templateObject2$T;
var Main$2 = styled(View$1)(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var ComponentTitle$2 = styled(Text$1)(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteralLoose(["\n  font-size: 20px;\n  font-weight: 700;\n  text-align: left;\n"])));

var MyAccountAddressFormTemplate = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MyAccountAddressFormTemplate, _Component);

  function MyAccountAddressFormTemplate() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.getTitle = function () {
      var address = _this.props.address;

      if (address) {
        return address.main ? 'Endereço principal' : 'Endereço';
      }

      return 'Novo endereço';
    };

    return _this;
  }

  var _proto = MyAccountAddressFormTemplate.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        address = _this$props.address,
        onSuccess = _this$props.onSuccess,
        goBack = _this$props.goBack,
        isFirstAddress = _this$props.isFirstAddress;
    return /*#__PURE__*/React.createElement(Main$2, null, /*#__PURE__*/React.createElement(ComponentTitle$2, {
      size: "title1"
    }, this.getTitle()), /*#__PURE__*/React.createElement(AddressForm, _extends({}, address, {
      onSuccess: onSuccess,
      goBack: goBack,
      isFirstAddress: isFirstAddress
    })));
  };

  return MyAccountAddressFormTemplate;
}(Component$2);

MyAccountAddressFormTemplate.propTypes = {
  address: PropTypes__default.shape({
    id: PropTypes__default.string,
    street: PropTypes__default.string,
    number: PropTypes__default.number,
    complement: PropTypes__default.string,
    neighbourhood: PropTypes__default.string,
    city: PropTypes__default.string,
    state: PropTypes__default.string,
    reference: PropTypes__default.string,
    zipcode: PropTypes__default.string,
    main: PropTypes__default.bool
  }),
  onSuccess: PropTypes__default.func,
  goBack: PropTypes__default.func,
  isFirstAddress: PropTypes__default.bool
};
MyAccountAddressFormTemplate.defaultProps = {};

var get$1 = function get(key) {
  var re = new RegExp(key + "=([^;]+)");
  var value = re.exec(document.cookie);
  return value != null ? unescape(value[1]) : null;
};

var create = function create(key, value, expires) {
  document.cookie = key + "=" + value + ";domain=.olx.com.br;path=/;expires=" + expires + ";";
};

var Cookie = {
  get: get$1,
  create: create
};

var _templateObject$1e, _templateObject2$U, _templateObject3$C, _templateObject4$r;
var lurker$b = new Lurker('meu_cadastro');
var Content$u = styled.div(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 680px;\n"])));
var TitleRow = styled.div(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var CardWrapper = styled(Card)(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  padding: 32px;\n  ", "\n"])), mediaQuery.small(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteralLoose(["\n    padding: 16px;\n  "]))));
var MyAccountPage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MyAccountPage, _React$Component);

  function MyAccountPage(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onAccountEdited = function () {
      return _this.setState({
        showSuccessMessage: true
      });
    };

    _this.onFacebookConnectedChange = function (result, facebookId, facebookName) {
      _this.setState({
        showFacebookSuccessMessage: result === true,
        facebookSuccessMessageText: 'Facebook conectado com sucesso',
        facebookId: facebookId,
        facebookName: facebookName
      });
    };

    _this.onFacebookConnectedErrorMessage = function (error) {
      if (error && error.response) {
        var errorMessage = 'Não foi possível conectar com o Facebook';

        if (error.response.status === 409) {
          errorMessage = 'Facebook conectado em outra conta OLX, desvincule e tente de novo';
        }

        _this.setState({
          showFacebookFailMessage: true,
          facebookFailMessageText: errorMessage
        });
      }
    };

    _this.onStartLoading = function () {
      return _this.setState({
        showLoading: true
      });
    };

    _this.onFinishLoading = function () {
      return _this.setState({
        showLoading: false
      });
    };

    _this.onAddressNew = function () {
      return _this.setState({
        showAddressForm: true
      });
    };

    _this.onAddressEdit = function (targetAddress) {
      return _this.setState({
        showAddressForm: true,
        targetAddress: targetAddress
      });
    };

    _this.onAddressSuccess = function () {
      var text = _this.state.targetAddress ? 'Endereço atualizado' : 'Endereço cadastrado';

      _this.setState({
        showAddressForm: false,
        targetAddress: null,
        showLoading: true
      });

      _this.onAddressesChanged(text);

      _this.loadAddresses();
    };

    _this.onAddressesChanged = function (text) {
      return _this.setState({
        showLoading: true,
        showAddressSuccessMessage: true,
        addressSuccessMessageText: text
      });
    };

    _this.onAddressSetAsDefault = function () {
      return _this.onAddressesChanged('Endereço principal atualizado');
    };

    _this.onAddressDelete = function () {
      return _this.onAddressesChanged('Endereço excluído');
    };

    _this.onAddressCancelForm = function () {
      return _this.setState({
        showAddressForm: false,
        targetAddress: null
      });
    };

    _this.onChangeEmailPincodeSuccess = function () {
      return createEmailChangeConfirmationToken().then(function (_ref) {
        var token = _ref.token;
        window.location.href = emailChangeConfirmationLink + "?email=" + _this.state.email + "&token=" + token;
      });
    };

    _this.closeSuccessMessage = function () {
      return _this.setState({
        showSuccessMessage: false
      });
    };

    _this.closeAddressSuccessMessage = function () {
      return _this.setState({
        showAddressSuccessMessage: false
      });
    };

    _this.closeFacebookFailMessage = function () {
      return _this.setState({
        showFacebookFailMessage: false
      });
    };

    _this.closeFacebookSuccessMessage = function () {
      return _this.setState({
        showFacebookSuccessMessage: false
      });
    };

    _this.loadAccountData = function () {
      getAccount().then(function (response) {
        return response.data;
      }).then(function (accountData) {
        _this.setState({
          accountDataLoaded: true,
          email: accountData.email,
          emailVerified: accountData.emailVerified,
          phone: accountData.phone,
          phoneVerified: accountData.phoneVerified,
          phoneVerifiedAt: accountData.phoneVerifiedAt,
          facebookId: accountData.facebookId,
          facebookName: accountData.nickname,
          fullName: accountData.fullName,
          nickname: accountData.nickname,
          gender: accountData.gender,
          documento: accountData.documento,
          isCompany: accountData.configs && accountData.configs.proAccount,
          activeProfile: accountData.activeProfile,
          keyAccount: accountData.keyAccount,
          creci: accountData.creci,
          cpfVerified: accountData.cpfVerified
        });
      });
    };

    _this.loadAddresses = function () {
      getAddresses().then(function (res) {
        return _this.setState({
          addresses: res.data,
          showLoading: false
        });
      });
    };

    _this.state = {
      showLoading: false,
      showSuccessMessage: false,
      showAddressSuccessMessage: false,
      showFacebookFailMessage: false,
      showFacebookSuccessMessage: false,
      showAddressForm: false,
      accountDataLoaded: false,
      addressSuccessMessageText: undefined,
      facebookFailMessageText: undefined,
      facebookSuccessMessageText: undefined,
      email: undefined,
      emailVerified: undefined,
      phone: undefined,
      phoneVerified: undefined,
      phoneVerifiedAt: undefined,
      facebookId: undefined,
      facebookName: undefined,
      fullName: undefined,
      nickname: undefined,
      gender: undefined,
      documento: undefined,
      isCompany: undefined,
      birthDay: undefined,
      birthMonth: undefined,
      birthYear: undefined,
      addresses: undefined,
      targetAddress: undefined,
      activeProfile: undefined,
      keyAccount: undefined,
      creci: undefined,
      cpfVerified: undefined
    };
    return _this;
  }

  var _proto = MyAccountPage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$b.pageLoadEvt();
    this.loadAccountData();
    this.loadAddresses();
  };

  _proto.render = function render() {
    var abTests = Cookie.get('TestAB_Groups') || '';
    var _this$state = this.state,
        showLoading = _this$state.showLoading,
        showSuccessMessage = _this$state.showSuccessMessage,
        showAddressSuccessMessage = _this$state.showAddressSuccessMessage,
        showFacebookFailMessage = _this$state.showFacebookFailMessage,
        showFacebookSuccessMessage = _this$state.showFacebookSuccessMessage,
        showAddressForm = _this$state.showAddressForm,
        addressSuccessMessageText = _this$state.addressSuccessMessageText,
        facebookFailMessageText = _this$state.facebookFailMessageText,
        facebookSuccessMessageText = _this$state.facebookSuccessMessageText,
        accountDataLoaded = _this$state.accountDataLoaded,
        email = _this$state.email,
        emailVerified = _this$state.emailVerified,
        phone = _this$state.phone,
        phoneVerified = _this$state.phoneVerified,
        phoneVerifiedAt = _this$state.phoneVerifiedAt,
        facebookId = _this$state.facebookId,
        facebookName = _this$state.facebookName,
        fullName = _this$state.fullName,
        nickname = _this$state.nickname,
        gender = _this$state.gender,
        documento = _this$state.documento,
        birthDay = _this$state.birthDay,
        birthMonth = _this$state.birthMonth,
        birthYear = _this$state.birthYear,
        addresses = _this$state.addresses,
        targetAddress = _this$state.targetAddress,
        isCompany = _this$state.isCompany,
        activeProfile = _this$state.activeProfile,
        keyAccount = _this$state.keyAccount,
        creci = _this$state.creci,
        cpfVerified = _this$state.cpfVerified;
    return /*#__PURE__*/React.createElement(Content$u, null, /*#__PURE__*/React.createElement(SuccessMessage, {
      text: "Cadastro atualizado com sucesso",
      show: showSuccessMessage,
      onClose: this.closeSuccessMessage
    }), /*#__PURE__*/React.createElement(SuccessMessage, {
      text: addressSuccessMessageText,
      show: showAddressSuccessMessage,
      onClose: this.closeAddressSuccessMessage
    }), /*#__PURE__*/React.createElement(SuccessMessage, {
      text: facebookSuccessMessageText,
      show: showFacebookSuccessMessage,
      onClose: this.closeFacebookSuccessMessage
    }), /*#__PURE__*/React.createElement(ErrorToastMsg, {
      text: facebookFailMessageText,
      show: showFacebookFailMessage,
      onClose: this.closeFacebookFailMessage
    }), showLoading && /*#__PURE__*/React.createElement(LoadingBackdrop$1, null), /*#__PURE__*/React.createElement(TitleRow, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title1"
    }, "Meu cadastro"), /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, "Configure o seu cadastro.")), /*#__PURE__*/React.createElement(CardWrapper, null, /*#__PURE__*/React.createElement(MyAccount, {
      loading: !accountDataLoaded,
      disabled: !accountDataLoaded,
      fullName: fullName,
      nickname: nickname,
      gender: gender,
      isCompany: isCompany,
      documento: documento,
      phone: phone,
      creci: creci,
      birthDay: birthDay,
      birthMonth: birthMonth,
      birthYear: birthYear,
      showPhone: !!activeProfile,
      showCreci: !!activeProfile,
      showDoc: !!documento,
      allowTollFree: !!keyAccount,
      cpfVerified: !!cpfVerified,
      onSuccess: this.onAccountEdited,
      similitySessionId: this.similitySessionId,
      abTests: abTests
    })), /*#__PURE__*/React.createElement(CardWrapper, null, /*#__PURE__*/React.createElement(MyAccountContactTemplate, {
      loading: !accountDataLoaded,
      email: email,
      emailVerified: emailVerified,
      phone: phone,
      phoneVerified: phoneVerified,
      phoneVerifiedAt: phoneVerifiedAt,
      facebookId: facebookId,
      facebookName: facebookName,
      onFacebookConnectedChange: this.onFacebookConnectedChange,
      onFacebookConnectedError: this.onFacebookConnectedErrorMessage,
      onFacebookConnectStart: this.onStartLoading,
      onFacebookConnectFinish: this.onFinishLoading,
      onChangeEmailPincodeSuccess: this.onChangeEmailPincodeSuccess,
      similitySessionId: this.similitySessionId
    })), /*#__PURE__*/React.createElement(CardWrapper, null, showAddressForm ? /*#__PURE__*/React.createElement(MyAccountAddressFormTemplate, {
      address: targetAddress,
      onSuccess: this.onAddressSuccess,
      goBack: this.onAddressCancelForm
    }) : /*#__PURE__*/React.createElement(MyAccountAddressListTemplate, {
      addressList: addresses,
      onSuccess: this.onAddressSuccess,
      onAddNew: this.onAddressNew,
      onEdit: this.onAddressEdit,
      onSetAsDefault: this.onAddressSetAsDefault,
      onDelete: this.onAddressDelete
    })), /*#__PURE__*/React.createElement(CardWrapper, null, /*#__PURE__*/React.createElement(MyAccountDisableTemplate, null)));
  };

  return MyAccountPage;
}(React.Component);

var shieldIcon = {
  viewBox: '0 0 26 32',
  width: '26',
  height: '32',
  fill: 'none',
  stroke: 'none',
  strokeWidth: '1',
  paths: [{
    path: 'M24.885894,5.91263277 L13.8461284,0.24511354 C13.2183796,-0.0817045132 12.4608924,-0.0817045132 11.8331436,0.24511354 L1.09300462,5.91263277 C0.418951997,6.26834164 0,6.94777143 0,7.68575665 L0,15.7012481 C-0.0012805253,22.3518546 4.11150303,28.3691741 10.4700533,31.019743 L11.9470861,31.6350736 C12.4755253,31.851073 13.0729238,31.851073 13.6013629,31.6350736 L15.2894005,30.9509231 L15.2894005,30.9509231 C21.7757735,28.3680853 26.0025648,22.2924965 26,15.5555119 L26,7.69790133 C26.0003113,6.95124299 25.5720929,6.26505548 24.885894,5.91263277 Z',
    color: '#10CE64'
  }, {
    path: 'M11.75871,0.24511354 C12.1438731,0.0433209115 12.5781866,-0.0338755861 13.000955,0.0135240468 L13.0009345,31.7752575 C12.6217625,31.8294336 12.2308433,31.7827056 11.8719358,31.6350736 L11.8719358,31.6350736 L10.4041938,31.019743 C4.08564058,28.3691741 -0.00127247045,22.3518546 -1.0658141e-14,15.7012481 L-1.0658141e-14,15.7012481 L-1.0658141e-14,7.68575665 C-1.0658141e-14,6.94777143 0.416316678,6.26834164 1.08612933,5.91263277 L1.08612933,5.91263277 Z',
    transform: 'translate(0 -.0657269022)'
  }, {
    path: 'M18.3709359,10.8181946 C17.9647803,10.8320335 17.5796421,11.0152099 17.297287,11.328835 C15.5349021,13.2242799 13.5244068,15.3768885 11.6728114,17.3648667 L9.25101092,15.2044754 C8.82471294,14.8026943 8.22891527,14.6806091 7.69466742,14.8855643 C7.16041956,15.0905195 6.77175721,15.5902762 6.67940308,16.1910295 C6.58704895,16.7917827 6.80553009,17.3990357 7.25011982,17.7772966 L10.7638798,20.9196993 C11.3850377,21.4742841 12.2978038,21.4288551 12.8684659,20.8149525 C14.9482018,18.5782531 17.4208347,15.9343194 19.505568,13.6921836 C19.9651414,13.2099973 20.102544,12.4749036 19.8518116,11.839806 C19.6010792,11.2047083 19.0134116,10.7992942 18.3709359,10.8181946 Z',
    color: '#FFFFFF'
  }]
};

var ShieldIcon = (function () {
  return /*#__PURE__*/React.createElement(Svg, {
    config: shieldIcon
  });
});

var _templateObject$1f, _templateObject2$V, _templateObject3$D, _templateObject4$s, _templateObject5$n;
var Content$v = styled(View$1)(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"])));
var Info = styled(View$1)(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var Icon$2 = styled(View$1)(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-right: 26px;\n"])));
var BlockText = styled(Text$1)(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  font-weight: 400;\n  padding-bottom: 4px;\n  padding-right: 36px;\n"])));
var GoToTipsPageLink = styled(link)(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteralLoose(["\n  text-align: left;\n"])));

var SecurityTipsBlock = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SecurityTipsBlock, _React$Component);

  function SecurityTipsBlock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onSecurityLinkClick = function () {
      var onSecurityLink = _this.props.onSecurityLink;

      if (onSecurityLink && typeof onSecurityLink === 'function') {
        onSecurityLink();
      }
    };

    return _this;
  }

  var _proto = SecurityTipsBlock.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Content$v, null, /*#__PURE__*/React.createElement(Icon$2, null, /*#__PURE__*/React.createElement(ShieldIcon, null)), /*#__PURE__*/React.createElement(Info, null, /*#__PURE__*/React.createElement(BlockText, null, "Entenda como a OLX cuida da sua seguran\xE7a e veja dicas de como fazer uma negocia\xE7\xE3o segura."), /*#__PURE__*/React.createElement(GoToTipsPageLink, {
      preventHrefOnClick: false,
      href: security,
      onClick: this.onSecurityLinkClick,
      type: "primary",
      underline: false,
      rel: "noopener noreferrer",
      target: "_blank"
    }, "Acessar p\xE1gina de seguran\xE7a")));
  };

  return SecurityTipsBlock;
}(React.Component);

SecurityTipsBlock.propTypes = {
  onSecurityLink: PropTypes__default.func
};

var _templateObject$1g, _templateObject2$W;
var Content$w = styled(View$1)(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var ButtonWrapper$2 = styled(View$1)(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  width: 250px;\n"])));

var ChangePasswordBlock = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ChangePasswordBlock, _React$Component);

  function ChangePasswordBlock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onChangePasswordClick = function (event) {
      event.preventDefault();
      var onChangePassword = _this.props.onChangePassword;
      if (onChangePassword && typeof onChangePassword === 'function') onChangePassword('button');
    };

    return _this;
  }

  var _proto = ChangePasswordBlock.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Content$w, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title3",
      weight: "bold"
    }, "Altera\xE7\xE3o de senha"), /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, "Escolha uma senha forte que voc\xEA n\xE3o esteja usando em nenhum outro lugar."), /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, "Troque sua senha a cada 6 meses para aumentar a seguran\xE7a da sua conta."), /*#__PURE__*/React.createElement(ButtonWrapper$2, null, /*#__PURE__*/React.createElement(Button$1, {
      fluid: true,
      size: "medium",
      onClick: this.onChangePasswordClick
    }, "Alterar senha")));
  };

  return ChangePasswordBlock;
}(React.Component);

ChangePasswordBlock.propTypes = {
  onChangePassword: PropTypes__default.func.isRequired
};

var _templateObject$1h, _templateObject2$X, _templateObject3$E, _templateObject4$t, _templateObject5$o, _templateObject6$h, _templateObject7$h;
var Container$4 = styled(View$1)(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin: 0;\n"])));
var SessionCard = styled(View$1)(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  margin-left: 0;\n  margin-right: 0;\n  position: relative;\n  &:hover {\n    background-color: #f6f6f6;\n    a {\n      color: #6e0ad6;\n    }\n  }\n"])));
var SessionInfo = styled(View$1)(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var DeviceIcon = styled(View$1)(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteralLoose(["\n  margin-right: 10px;\n"])));
var DeviceName = styled(Text$1)(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  font-weight: 700;\n  color: #4b4b4b;\n"])));
var SessionData = styled(Text$1)(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  font-weight: 500;\n  color: #838383;\n"])));
var SessionActive = styled(SessionData)(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteralLoose(["\n  color: #10ce63;\n"])));

var LoginHistory = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LoginHistory, _React$Component);

  function LoginHistory(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.deviceIcon = function (type) {
      var iconType = {
        pc: /*#__PURE__*/React.createElement(Icons.System.Monitor, {
          color: "#4a4a4a",
          size: 32
        }),
        mobile: /*#__PURE__*/React.createElement(Icons.System.Smartphone, {
          color: "#4a4a4a",
          size: 32
        })
      };
      return iconType[type];
    };

    _this.renderHistory = function (sessions) {
      return sessions.map(function (session) {
        return /*#__PURE__*/React.createElement(SessionCard, {
          key: session.id
        }, /*#__PURE__*/React.createElement(DeviceIcon, null, _this.deviceIcon(session.deviceName)), /*#__PURE__*/React.createElement(SessionInfo, null, /*#__PURE__*/React.createElement(DeviceName, null, session.deviceType), /*#__PURE__*/React.createElement(SessionData, null, session.location, " -", ' ', session.lastActivityAge === 'agora' ? /*#__PURE__*/React.createElement(SessionActive, null, session.lastActivityAge) : /*#__PURE__*/React.createElement(SessionData, null, session.lastActivityAge))));
      });
    };

    _this.state = {
      sessions: props.sessions
    };
    return _this;
  }

  var _proto = LoginHistory.prototype;

  _proto.render = function render() {
    var sessions = this.state.sessions;
    return /*#__PURE__*/React.createElement(Container$4, null, sessions ? this.renderHistory(sessions) : []);
  };

  return LoginHistory;
}(React.Component);

LoginHistory.propTypes = {
  sessions: PropTypes__default.arrayOf(PropTypes__default.shape({
    id: PropTypes__default.number.isRequired,
    deviceType: PropTypes__default.string.isRequired,
    deviceName: PropTypes__default.oneOf(['pc', 'mobile']).isRequired,
    location: PropTypes__default.string.isRequired,
    lastActivityAge: PropTypes__default.string.isRequired
  }))
};

var API_ENDPOINT$8 = '/captain-marvel/v1/sessions/my';
var getSessions = function getSessions() {
  return axios.get(API_ENDPOINT$8, {}, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};
var deleteSessions = function deleteSessions() {
  return axios["delete"](API_ENDPOINT$8, {}, {
    withCredentials: true
  }).then(function (response) {
    return response.status > 199 && response.status < 400;
  })["catch"](function (e) {
    return e.status > 399 && e.status < 500 ? false : e;
  });
};

var _templateObject$1i, _templateObject2$Y, _templateObject3$F, _templateObject4$u, _templateObject5$p;
var Content$x = styled(View$1)(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var HistoryDiv = styled(View$1)(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteralLoose(["\n  margin: 0;\n"])));
var HRuleWrapper$4 = styled(View$1)(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteralLoose(["\n  margin-top: 14px;\n  margin-bottom: 14px;\n"])));
var Suggestion = styled(Text$1)(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  font-weight: 400;\n"])));
var ButtonWrapper$3 = styled(View$1)(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  width: 200px;\n"])));

var LoginHistoryControlBlock = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LoginHistoryControlBlock, _React$Component);

  function LoginHistoryControlBlock(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.fetchSessions = function () {
      _this.setState({
        loading: true
      });

      getSessions().then(function (data) {
        if (data === void 0) {
          data = [];
        }

        _this.setState({
          loading: false,
          sessions: _this.transformDataToSessions(data)
        });
      })["catch"](function () {
        return _this.setState({
          loading: false,
          sessions: []
        });
      });
    };

    _this.transformDataToSessions = function (data) {
      var timeAgo = _this.state.timeAgo;
      var sessions = [];
      data.forEach(function (session) {
        sessions.push({
          id: session.ID,
          deviceType: session.device_type,
          deviceName: session.device_name,
          location: session.session_location,
          lastActivityAge: timeAgo.format(new Date(session.created_at))
        });
      });
      return sessions;
    };

    _this.lurkerClickEvt = function (detail) {
      var lurker = _this.state.lurker;

      if (lurker && typeof lurker.clickEvt === 'function') {
        lurker.clickEvt(detail);
      }
    };

    _this.onChangePasswordClick = function () {
      var onChangePassword = _this.props.onChangePassword;

      if (onChangePassword && typeof onChangePassword === 'function') {
        onChangePassword('link');
      }
    };

    _this.onFinishSessionsClick = function () {
      _this.lurkerClickEvt('delete_sessions');

      _this.setState({
        isDeleting: true
      }, _this.onDeleteCall);
    };

    _this.onDeleteCall = function () {
      var _this$props = _this.props,
          onSuccess = _this$props.onSuccess,
          onError = _this$props.onError;
      deleteSessions().then(function (deleted) {
        if (deleted && onSuccess && typeof onSuccess === 'function') {
          onSuccess();
        }
      })["catch"](function () {
        if (onError && typeof onError === 'function') {
          onError();
        }
      })["finally"](function () {
        return _this.setState({
          isDeleting: false
        });
      });
    };

    TimeAgo.addLocale(pt);
    _this.state = {
      isDeleting: false,
      loading: false,
      lurker: props.lurker,
      timeAgo: new TimeAgo('pt-BR')
    };
    return _this;
  }

  var _proto = LoginHistoryControlBlock.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.fetchSessions();
  };

  _proto.render = function render() {
    var _this$state = this.state,
        isDeleting = _this$state.isDeleting,
        sessions = _this$state.sessions,
        loading = _this$state.loading;
    var isButtonDisabled = isDeleting || loading;
    return /*#__PURE__*/React.createElement(Content$x, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title3",
      weight: "bold"
    }, "Hist\xF3rico de conex\xF5es"), /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, "Todos os aparelhos (computadores, celulares e tablets) em que sua conta da OLX esteve conectada nos \xFAltimos 30 dias."), !loading && /*#__PURE__*/React.createElement(HistoryDiv, null, /*#__PURE__*/React.createElement(LoginHistory, {
      sessions: sessions
    })), /*#__PURE__*/React.createElement(HRuleWrapper$4, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(Suggestion, null, "N\xE3o reconhece uma conex\xE3o?", ' ', /*#__PURE__*/React.createElement(link, {
      type: "primary",
      underline: false,
      onClick: this.onChangePasswordClick,
      preventHrefOnClick: !!this.props.onChangePassword
    }, "Altere sua senha")), /*#__PURE__*/React.createElement(HRuleWrapper$4, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(Text$1, {
      size: "body1",
      wight: "bold"
    }, "Encerrar a sess\xE3o em todos os aparelhos"), /*#__PURE__*/React.createElement(Text$1, {
      size: "caption",
      color: "grayscale.darker"
    }, "Todos os aparelhos (computadores, celulares e tablets) em que sua conta da OLX estiver ativa ser\xE3o desconectados."), /*#__PURE__*/React.createElement(ButtonWrapper$3, null, /*#__PURE__*/React.createElement(Button$1, {
      fluid: true,
      size: "medium",
      onClick: this.onFinishSessionsClick,
      isLoading: isDeleting,
      disabled: isButtonDisabled
    }, "Encerrar sess\xF5es")));
  };

  return LoginHistoryControlBlock;
}(React.Component);

LoginHistoryControlBlock.defaultProps = {
  loading: false
};
LoginHistoryControlBlock.propTypes = {
  loading: PropTypes__default.bool,
  lurker: PropTypes__default.object,
  onChangePassword: PropTypes__default.func.isRequired,
  onSuccess: PropTypes__default.func.isRequired,
  onError: PropTypes__default.func
};

var pauseIcon = {
  viewBox: '0 0 24 24',
  width: '24',
  height: '24',
  fill: 'none',
  rects: [{
    x: '4',
    y: '3',
    width: '6',
    height: '17',
    stroke: '#4A4A4A',
    strokeWidth: '1.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }, {
    x: '14',
    y: '3',
    width: '6',
    height: '17',
    stroke: '#4A4A4A',
    strokeWidth: '1.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }]
};

var PauseIcon = (function () {
  return /*#__PURE__*/React.createElement(Svg, {
    config: pauseIcon
  });
});

var DownloadStatusWaitingIcon = function DownloadStatusWaitingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 60 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2246 30.2702V4.2666C24.2246 3.38296 24.941 2.66663 25.8246 2.66663C26.7083 2.66663 27.4246 3.38296 27.4246 4.2666V30.2702L33.2265 24.4683C33.8513 23.8434 34.8643 23.8434 35.4892 24.4683C36.114 25.0931 36.114 26.1062 35.4892 26.731L26.956 35.2642C26.3311 35.889 25.3181 35.889 24.6933 35.2642L16.16 26.731C15.5352 26.1062 15.5352 25.0931 16.16 24.4683C16.7849 23.8434 17.7979 23.8434 18.4227 24.4683L24.2246 30.2702ZM5.0249 36.2661C5.0249 35.3825 5.74124 34.6662 6.62488 34.6662C7.50852 34.6662 8.22486 35.3825 8.22486 36.2661V42.6661C8.22486 44.1388 9.41875 45.3327 10.8915 45.3327H40.7577C42.2305 45.3327 43.4244 44.1388 43.4244 42.6661V36.2661C43.4244 35.3825 44.1407 34.6662 45.0243 34.6662C45.908 34.6662 46.6243 35.3825 46.6243 36.2661V42.6661C46.6243 45.9061 43.9978 48.5326 40.7577 48.5326H10.8915C7.65146 48.5326 5.0249 45.9061 5.0249 42.6661V36.2661Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7749 63.0001C52.6115 63.0001 59.7749 55.8366 59.7749 47.0001C59.7749 38.1635 52.6115 31.0001 43.7749 31.0001C34.9383 31.0001 27.7749 38.1635 27.7749 47.0001C27.7749 55.8366 34.9383 63.0001 43.7749 63.0001Z",
    fill: "#FEF7E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7747 58.6459C37.3429 58.6459 32.1289 53.4319 32.1289 47.0001C32.1289 40.5682 37.3429 35.3542 43.7747 35.3542C50.2066 35.3542 55.4206 40.5682 55.4206 47.0001C55.4206 53.4319 50.2066 58.6459 43.7747 58.6459ZM43.7747 57.0209C49.3091 57.0209 53.7956 52.5344 53.7956 47.0001C53.7956 41.4657 49.3091 36.9792 43.7747 36.9792C38.2404 36.9792 33.7539 41.4657 33.7539 47.0001C33.7539 52.5344 38.2404 57.0209 43.7747 57.0209ZM43.7747 39.6875C44.2235 39.6875 44.5872 40.0513 44.5872 40.5V46.6635L47.5993 49.6755C47.9166 49.9928 47.9166 50.5073 47.5993 50.8246C47.282 51.1419 46.7675 51.1419 46.4502 50.8246L43.2002 47.5746C43.0478 47.4222 42.9622 47.2155 42.9622 47V40.5C42.9622 40.0513 43.326 39.6875 43.7747 39.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "32",
    y: "35",
    width: "24",
    height: "24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7747 58.6459C37.3429 58.6459 32.1289 53.4319 32.1289 47.0001C32.1289 40.5682 37.3429 35.3542 43.7747 35.3542C50.2066 35.3542 55.4206 40.5682 55.4206 47.0001C55.4206 53.4319 50.2066 58.6459 43.7747 58.6459ZM43.7747 57.0209C49.3091 57.0209 53.7956 52.5344 53.7956 47.0001C53.7956 41.4657 49.3091 36.9792 43.7747 36.9792C38.2404 36.9792 33.7539 41.4657 33.7539 47.0001C33.7539 52.5344 38.2404 57.0209 43.7747 57.0209ZM43.7747 39.6875C44.2235 39.6875 44.5872 40.0513 44.5872 40.5V46.6635L47.5993 49.6755C47.9166 49.9928 47.9166 50.5073 47.5993 50.8246C47.282 51.1419 46.7675 51.1419 46.4502 50.8246L43.2002 47.5746C43.0478 47.4222 42.9622 47.2155 42.9622 47V40.5C42.9622 40.0513 43.326 39.6875 43.7747 39.6875Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "30.0859",
    y: "34.0001",
    width: "26",
    height: "26",
    fill: "#F9AF27"
  })));
};

DownloadStatusWaitingIcon.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
DownloadStatusWaitingIcon.defaultProps = {
  width: 60,
  height: 63
};

var DownloadStatusReadyIcon = function DownloadStatusReadyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.375 15.8244V5.66666C13.375 5.32148 13.6548 5.04166 14 5.04166C14.3452 5.04166 14.625 5.32148 14.625 5.66666V15.8244L16.8914 13.558C17.1355 13.314 17.5312 13.314 17.7753 13.558C18.0194 13.8021 18.0194 14.1979 17.7753 14.4419L14.4419 17.7753C14.1979 18.0193 13.8021 18.0193 13.5581 17.7753L10.2247 14.4419C9.98065 14.1979 9.98065 13.8021 10.2247 13.558C10.4688 13.314 10.8645 13.314 11.1086 13.558L13.375 15.8244ZM5.875 18.1667C5.875 17.8215 6.15482 17.5417 6.5 17.5417C6.84518 17.5417 7.125 17.8215 7.125 18.1667V20.6667C7.125 21.242 7.59137 21.7083 8.16667 21.7083H19.8333C20.4086 21.7083 20.875 21.242 20.875 20.6667V18.1667C20.875 17.8215 21.1548 17.5417 21.5 17.5417C21.8452 17.5417 22.125 17.8215 22.125 18.1667V20.6667C22.125 21.9323 21.099 22.9583 19.8333 22.9583H8.16667C6.90101 22.9583 5.875 21.9323 5.875 20.6667V18.1667Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 29C25.0899 29 28 26.0899 28 22.5C28 18.9101 25.0899 16 21.5 16C17.9101 16 15 18.9101 15 22.5C15 26.0899 17.9101 29 21.5 29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 29C25.0899 29 28 26.0899 28 22.5C28 18.9101 25.0899 16 21.5 16C17.9101 16 15 18.9101 15 22.5C15 26.0899 17.9101 29 21.5 29Z",
    fill: "#8CE563"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6132 22.0066C25.6132 21.8168 25.7671 21.6629 25.957 21.6629C26.1468 21.6629 26.3007 21.8168 26.3007 22.0066V22.4331C26.2995 24.6151 24.8631 26.5364 22.7706 27.1551C20.6781 27.7738 18.4279 26.9425 17.2403 25.1119C16.0526 23.2814 16.2105 20.8877 17.6282 19.229C19.0459 17.5703 21.3858 17.0416 23.379 17.9297C23.5524 18.007 23.6303 18.2102 23.5531 18.3836C23.4758 18.557 23.2726 18.635 23.0992 18.5577C21.3841 17.7935 19.3707 18.2484 18.1508 19.6757C16.9309 21.103 16.7951 23.1626 17.817 24.7378C18.839 26.3129 20.7752 27.0282 22.5757 26.4958C24.3762 25.9635 25.6122 24.3102 25.6132 22.4329V22.0066ZM21.3736 22.8631L26.1722 18.0645C26.3065 17.9302 26.5241 17.9302 26.6584 18.0645C26.7926 18.1987 26.7926 18.4164 26.6584 18.5506L21.6167 23.5923C21.4825 23.7265 21.2648 23.7265 21.1306 23.5923L19.7556 22.2173C19.6213 22.083 19.6213 21.8654 19.7556 21.7311C19.8898 21.5969 20.1075 21.5969 20.2417 21.7311L21.3736 22.8631Z",
    fill: "#8CE563"
  }));
};

DownloadStatusReadyIcon.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
DownloadStatusReadyIcon.defaultProps = {
  width: 32,
  height: 32
};

var nullifierUrl = process.env.REACT_APP_NULLIFIER_URL || 'https://nullifier.olx.com.br';
var BASE_API_URL = nullifierUrl + "/takeout";
var startTakeout = function startTakeout(recaptchaToken) {
  return axios.post(BASE_API_URL + "/start", {}, {
    headers: {
      'X-Accounts-Takeout-Recaptcha': recaptchaToken
    },
    withCredentials: true
  }).then(function (response) {
    return response.status > 199 && response.status < 400;
  });
};
var fetchRequests = function fetchRequests() {
  return axios.get(BASE_API_URL + "/status", {}, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};

var _templateObject$1j, _templateObject2$Z, _templateObject3$G, _templateObject4$v, _templateObject5$q, _templateObject6$i, _templateObject7$i, _templateObject8$b, _templateObject9$6, _templateObject10$6, _templateObject11$2, _templateObject12$2, _templateObject13$1;
var CardWrapperSlide = styled(Card)(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 24px;\n  padding-top: 32px;\n  padding-bottom: 32px;\n  padding-left: 32px;\n  padding-right: 32px;\n  transition: all ease 1s;\n  max-height: ", "px;\n  scroll-behavior: smooth;\n"])), function (props) {
  return props.open ? 500 : 112;
});
var ContentOptions = styled(View$1)(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n"])));
var HRule = styled(ruleWithText)(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteralLoose(["\n  border-top-width: 1px;\n"])));
var HRuleWrapper$5 = styled(View$1)(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-bottom: 24px;\n"])));
var TitleContainer = styled(View$1)(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 32px;\n"])));
var TitleContent = styled(View$1)(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n"])));
var OpenOptionsIconWrapper = styled(View$1)(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteralLoose(["\n  width: 40px;\n  height: 24px;\n  color: #6e0ad6;\n  padding-left: 16px;\n  cursor: pointer;\n"])));
var Option$1 = styled(View$1)(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var OptionDescription = styled(View$1)(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 40px;\n"])));
var IconWrapper$3 = styled(View$1)(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteralLoose(["\n  width: 24px;\n  height: 24px;\n  color: #4a4a4a;\n  margin-right: 16px;\n"])));
var OptionNameWrapper = styled(View$1)(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n"])));
var LinkWrapper$2 = styled(Link$3)(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  padding-left: 4px;\n  color: #999999;\n"])));
var ElementReference = styled.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteralLoose([""])));

var OptionName = function OptionName(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(OptionNameWrapper, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "body1",
    weight: "semiBold"
  }, children));
};

var OptionItem = function OptionItem(_ref2) {
  var name = _ref2.name,
      icon = _ref2.icon,
      linkText = _ref2.linkText,
      descriptions = _ref2.descriptions,
      onClick = _ref2.onClick,
      _ref2$linkEnabled = _ref2.linkEnabled,
      linkEnabled = _ref2$linkEnabled === void 0 ? true : _ref2$linkEnabled;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Option$1, null, /*#__PURE__*/React.createElement(IconWrapper$3, null, icon), /*#__PURE__*/React.createElement(OptionName, null, name), /*#__PURE__*/React.createElement(View$1, {
    style: linkEnabled ? {} : {
      cursor: 'not-allowed'
    }
  }, /*#__PURE__*/React.createElement(Link$3, {
    type: linkEnabled ? 'primary' : 'secondary',
    underline: false,
    fontWeight: 600,
    onClick: onClick,
    style: linkEnabled ? {} : {
      pointerEvents: 'none',
      color: '#D2D2D2'
    }
  }, linkText))), /*#__PURE__*/React.createElement(OptionDescription, null, descriptions.map(function (description, idx) {
    return /*#__PURE__*/React.createElement(Text$1, {
      key: idx.toString(),
      size: "caption",
      color: "grayscale.darker"
    }, description);
  })));
};

OptionItem.propTypes = {
  name: PropTypes__default.string,
  icon: PropTypes__default.string,
  linkText: PropTypes__default.string,
  descriptions: PropTypes__default.array,
  onClick: PropTypes__default.func,
  linkEnabled: PropTypes__default.bool
};

var AccountDeleteCard = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountDeleteCard, _React$Component);

  function AccountDeleteCard(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.setFocus = function () {
      if (_this.props.focus) {
        _this.toggleOptions();

        _this.takeoutStatusRef.current.scrollIntoView();
      }
    };

    _this.fetchTakeoutRequests = function () {
      fetchRequests().then(function (data) {
        return _this.setState({
          takeoutRequests: data.requests
        });
      })["finally"](function () {
        return _this.setFocus();
      });
    };

    _this.toggleOptions = function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    };

    _this.renderDataDownloadOption = function () {
      var takeoutRequests = _this.state.takeoutRequests;
      var requestInProgress = takeoutRequests.find(function (request) {
        return ['IN_PROGRESS', 'COMPLETED'].includes(request.status);
      });
      var requestReady = takeoutRequests.find(function (request) {
        return request.status === 'TAKEOUT_READY';
      });
      var _this$props = _this.props,
          onAccountTakeoutLink = _this$props.onAccountTakeoutLink,
          onMyAccountLink = _this$props.onMyAccountLink;
      var icon = /*#__PURE__*/React.createElement(Icons.System.Download, null);
      var linkText = 'solicitar';
      var linkEnabled = true;
      var descriptions = ['Solicite a cópia dos seus dados pessoais', /*#__PURE__*/React.createElement(React.Fragment, null, "Voc\xEA pode ver os principais dados da sua conta em", /*#__PURE__*/React.createElement(LinkWrapper$2, {
        href: "#",
        onClick: onMyAccountLink
      }, "Meu cadastro"))];

      if (requestInProgress) {
        icon = /*#__PURE__*/React.createElement(DownloadStatusWaitingIcon, {
          width: 32,
          height: 32
        });
        linkText = 'solicitado';
        linkEnabled = false;
        descriptions = [/*#__PURE__*/React.createElement(React.Fragment, null, "Solicitado em", ' ', /*#__PURE__*/React.createElement(Text$1, {
          size: "caption",
          color: "grayscale.darker",
          weight: "semiBold"
        }, formatTimestamp(requestInProgress.requestedAt))), /*#__PURE__*/React.createElement(React.Fragment, null, "Estamos preparando seu arquivo de dados")];
      }

      if (requestReady) {
        icon = /*#__PURE__*/React.createElement(DownloadStatusReadyIcon, null);
        linkText = '';
        descriptions = [/*#__PURE__*/React.createElement(React.Fragment, null, "Enviado em", ' ', /*#__PURE__*/React.createElement(Text$1, {
          size: "caption",
          color: "grayscale.darker",
          weight: "semiBold"
        }, formatTimestamp(requestReady.updatedAt))), /*#__PURE__*/React.createElement(React.Fragment, null, "C\xF3pia dispon\xEDvel durante 7 dias")];
      }

      return /*#__PURE__*/React.createElement(OptionItem, {
        name: "Baixar dados pessoais",
        icon: icon,
        onClick: requestInProgress ? null : onAccountTakeoutLink,
        linkText: linkText,
        linkEnabled: linkEnabled,
        descriptions: descriptions
      });
    };

    _this.takeoutStatusRef = /*#__PURE__*/React.createRef();
    _this.state = {
      open: false,
      takeoutRequests: []
    };
    return _this;
  }

  var _proto = AccountDeleteCard.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.fetchTakeoutRequests();
  };

  _proto.render = function render() {
    var open = this.state.open;
    var _this$props2 = this.props,
        onDeactivateAccount = _this$props2.onDeactivateAccount,
        onDeleteAccount = _this$props2.onDeleteAccount;
    return /*#__PURE__*/React.createElement(CardWrapperSlide, {
      open: open
    }, /*#__PURE__*/React.createElement(ElementReference, {
      ref: this.takeoutStatusRef
    }), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(TitleContent, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title3",
      weight: "bold"
    }, "Gerencie seus dados"), /*#__PURE__*/React.createElement(Text$1, {
      size: "body2"
    }, "Voc\xEA pode desativar, excluir sua conta e baixar seus dados pessoais.")), /*#__PURE__*/React.createElement(OpenOptionsIconWrapper, {
      onClick: this.toggleOptions
    }, open ? /*#__PURE__*/React.createElement(Icons.System.ChevronUp, null) : /*#__PURE__*/React.createElement(Icons.System.ChevronDown, null))), /*#__PURE__*/React.createElement(ContentOptions, null, /*#__PURE__*/React.createElement(React.Fragment, null, this.renderDataDownloadOption(), /*#__PURE__*/React.createElement(HRuleWrapper$5, null, /*#__PURE__*/React.createElement(HRule, null))), /*#__PURE__*/React.createElement(OptionItem, {
      name: "Desativar conta temporariamente",
      icon: /*#__PURE__*/React.createElement(PauseIcon, null),
      onClick: onDeactivateAccount,
      linkText: "desativar",
      descriptions: ['Seu perfil será desabilitado e anúncios excluídos', 'Você pode reativar sua conta quando quiser']
    }), /*#__PURE__*/React.createElement(HRuleWrapper$5, null, /*#__PURE__*/React.createElement(HRule, null)), /*#__PURE__*/React.createElement(OptionItem, {
      name: "Excluir conta definitivamente",
      icon: /*#__PURE__*/React.createElement(Icons.System.Trash, null),
      onClick: onDeleteAccount,
      linkText: "excluir",
      descriptions: ['Dados da sua conta, anúncios e perfil serão excluídos definitivamente', 'Não será possível recuperar sua conta']
    })));
  };

  return AccountDeleteCard;
}(React.Component);

AccountDeleteCard.propTypes = {
  onDeleteAccount: PropTypes__default.func,
  onDeactivateAccount: PropTypes__default.func,
  onAccountTakeoutLink: PropTypes__default.func,
  onMyAccountLink: PropTypes__default.func,
  focus: PropTypes__default.bool
};

var _templateObject$1k, _templateObject2$_, _templateObject3$H, _templateObject4$w;
var recaptchaSiteKey = '6Legz2gUAAAAAH0T1aFbgPvFOVjFHOaKto3GNMMN';
var TitleWrapper$4 = styled(View$1)(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteralLoose(["\n  margin-bottom: 12px;\n"])));
var SafetyTipWrapper = styled(View$1)(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n"])));
var SafetyTipText = styled(Text$1)(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  color: #999999;\n  margin-left: 4px;\n"])));
var ButtonWrapper$4 = styled(Button$1)(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-bottom: 8px;\n  flex: none;\n"])));

var AccountTakeoutRequestModal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountTakeoutRequestModal, _React$Component);

  function AccountTakeoutRequestModal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onRecaptchaExpiration = function () {
      return _this.setState({
        recaptchaVerified: false
      }, _this.recaptcha.reset());
    };

    _this.onRecaptchaLoad = function () {
      return _this.setState({
        recaptchaReady: true
      });
    };

    _this.onRecaptchaVerify = function (recaptchaToken) {
      if (recaptchaToken) {
        _this.setState({
          recaptchaToken: recaptchaToken,
          recaptchaVerified: true
        });
      } else {
        _this.props.lurker.viewMessageEvt('recaptcha_failed_token');

        _this.setState({
          recaptchaToken: ''
        });

        _this.recaptcha.reset();
      }
    };

    _this.onRecaptchaError = function () {
      _this.props.lurker.viewMessageEvt('recaptcha_error');

      _this.setState({
        recaptchaReady: false,
        recaptchaVerified: false,
        recaptchaToken: ''
      });
    };

    _this.onSuccess = function () {
      _this.setState({
        submitting: false
      });

      if (_this.props.onSuccess) {
        _this.props.onSuccess();
      }
    };

    _this.onError = function () {
      if (_this.props.onError) {
        _this.props.onError();
      }
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();

      _this.setState({
        submitting: true
      });

      startTakeout(_this.state.recaptchaToken).then(_this.onSuccess)["catch"](_this.onError)["finally"](function () {
        return _this.setState({
          submitting: false
        });
      });
    };

    _this.state = {
      recaptchaReady: false,
      recaptchaVerified: false,
      recaptchaToken: '',
      submitting: false
    };
    return _this;
  }

  var _proto = AccountTakeoutRequestModal.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        recaptchaReady = _this$state.recaptchaReady,
        recaptchaVerified = _this$state.recaptchaVerified,
        submitting = _this$state.submitting;
    var _this$props = this.props,
        onClose = _this$props.onClose,
        open = _this$props.open;
    return /*#__PURE__*/React.createElement(Modal, {
      open: open,
      onClose: onClose
    }, /*#__PURE__*/React.createElement(TitleWrapper$4, null, /*#__PURE__*/React.createElement(Title$9, null, "Para continuar, confirme")), /*#__PURE__*/React.createElement(Reaptcha, {
      ref: function ref(e) {
        _this2.recaptcha = e;
      },
      sitekey: recaptchaSiteKey,
      onLoad: this.onRecaptchaLoad,
      onVerify: this.onRecaptchaVerify,
      onExpire: this.onRecaptchaExpiration,
      onError: this.onRecaptchaError
    }), /*#__PURE__*/React.createElement(SafetyTipWrapper, null, /*#__PURE__*/React.createElement(Icons.System.Shield, {
      color: "#999",
      width: "20",
      height: "13"
    }), /*#__PURE__*/React.createElement(SafetyTipText, null, "Isso nos ajuda a manter seus dados protegidos")), /*#__PURE__*/React.createElement(ButtonWrapper$4, {
      fluid: true,
      size: "large",
      disabled: !(recaptchaReady && recaptchaVerified) || submitting,
      isLoading: submitting,
      onClick: this.handleSubmit
    }, "Solicitar arquivo"));
  };

  return AccountTakeoutRequestModal;
}(React.Component);

AccountTakeoutRequestModal.propTypes = {
  open: PropTypes__default.bool.isRequired,
  onClose: PropTypes__default.func.isRequired,
  onSuccess: PropTypes__default.func.isRequired,
  onError: PropTypes__default.func,
  lurker: PropTypes__default.object
};

var _templateObject$1l, _templateObject2$$;
var lurker$c = new Lurker('security_central');
var Content$y = styled(View$1)(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var CardWrapper$1 = styled(Card)(_templateObject2$$ || (_templateObject2$$ = _taggedTemplateLiteralLoose(["\n  margin-bottom: 24px;\n  padding-top: 32px;\n  padding-bottom: 32px;\n  padding-left: 32px;\n  padding-right: 32px;\n"])));

var SecurityCentralTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SecurityCentralTemplate, _React$Component);

  function SecurityCentralTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onSecurityLinkClick = function () {
      lurker$c.viewMessageEvt('security_tips_link');
    };

    _this.onChangePasswordClick = function (type) {
      lurker$c.clickEvt("change_password_" + type);
      var onChangePassword = _this.props.onChangePassword;

      if (onChangePassword && typeof onChangePassword === 'function') {
        onChangePassword();
      }
    };

    _this.onDeleteSessionsSuccess = function () {
      lurker$c.viewMessageEvt('delete_sessions_success');
      var onDeleteSessionsSuccess = _this.props.onDeleteSessionsSuccess;

      if (onDeleteSessionsSuccess && typeof onDeleteSessionsSuccess === 'function') {
        onDeleteSessionsSuccess();
      }
    };

    _this.onDeleteSessionsError = function () {
      lurker$c.viewMessageEvt('delete_sessions_error');
    };

    _this.onDeleteAccountClick = function (event) {
      if (event) event.preventDefault();
      lurker$c.clickEvt('delete_account');
      var onDeleteAccount = _this.props.onDeleteAccount;

      if (onDeleteAccount && typeof onDeleteAccount === 'function') {
        onDeleteAccount();
      }
    };

    _this.onDeactivateAccountClick = function (event) {
      event.preventDefault();
      lurker$c.clickEvt('inactivate_account');
      var onDeactivateAccount = _this.props.onDeactivateAccount;

      if (onDeactivateAccount && typeof onDeactivateAccount === 'function') {
        onDeactivateAccount();
      }
    };

    _this.onAccountTakeoutClick = function (event) {
      event.preventDefault();
      lurker$c.clickEvt('account_takeout_modal_open');

      _this.setState({
        showAccountTakeoutModal: true
      });
    };

    _this.onAccountTakeoutLinkClose = function () {
      lurker$c.clickEvt('account_takeout_modal_close');

      _this.setState({
        showAccountTakeoutModal: false
      });
    };

    _this.onAccountTakeoutRequestSuccess = function () {
      lurker$c.clickEvt('account_takeout_success');
      var onDownloadAccountData = _this.props.onDownloadAccountData;

      if (onDownloadAccountData && typeof onDownloadAccountData === 'function') {
        onDownloadAccountData(_this.state.email);
      }
    };

    _this.onMyAccountClick = function () {
      lurker$c.clickEvt('my_account_click');
      var onMyAccount = _this.props.onMyAccount;

      if (onMyAccount && typeof onMyAccount === 'function') {
        onMyAccount();
      }
    };

    _this.loadAccountData = function () {
      getAccount().then(function (_ref) {
        var accountData = _ref.data;

        _this.setState({
          email: accountData.email
        });
      });
    };

    _this.state = {
      showAccountTakeoutModal: false,
      email: ''
    };
    return _this;
  }

  var _proto = SecurityCentralTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$c.pageLoadEvt();
    this.loadAccountData();
  };

  _proto.render = function render() {
    var fragment = this.props.fragment;
    return /*#__PURE__*/React.createElement(Content$y, null, /*#__PURE__*/React.createElement(CardWrapper$1, null, /*#__PURE__*/React.createElement(SecurityTipsBlock, {
      onSecurityLink: this.onSecurityLinkClick
    })), /*#__PURE__*/React.createElement(CardWrapper$1, null, /*#__PURE__*/React.createElement(ChangePasswordBlock, {
      onChangePassword: this.onChangePasswordClick
    })), /*#__PURE__*/React.createElement(CardWrapper$1, null, /*#__PURE__*/React.createElement(LoginHistoryControlBlock, {
      onChangePassword: this.onChangePasswordClick,
      onSuccess: this.onDeleteSessionsSuccess,
      onError: this.onDeleteSessionsError,
      lurker: lurker$c
    })), /*#__PURE__*/React.createElement(AccountDeleteCard, {
      onDeleteAccount: this.onDeleteAccountClick,
      onDeactivateAccount: this.onDeactivateAccountClick,
      onAccountTakeoutLink: this.onAccountTakeoutClick,
      onMyAccountLink: this.onMyAccountClick,
      focus: fragment === 'takeout-status'
    }), /*#__PURE__*/React.createElement(AccountTakeoutRequestModal, {
      open: this.state.showAccountTakeoutModal,
      onClose: this.onAccountTakeoutLinkClose,
      onSuccess: this.onAccountTakeoutRequestSuccess,
      lurker: lurker$c
    }));
  };

  return SecurityCentralTemplate;
}(React.Component);

SecurityCentralTemplate.propTypes = {
  onDeleteSessionsSuccess: PropTypes__default.func.isRequired,
  onChangePassword: PropTypes__default.func.isRequired,
  onDeleteAccount: PropTypes__default.func.isRequired,
  onDeactivateAccount: PropTypes__default.func,
  onDownloadAccountData: PropTypes__default.func,
  onMyAccount: PropTypes__default.func,
  fragment: PropTypes__default.string
};
SecurityCentralTemplate.defaultProps = {
  fragment: ''
};

var _templateObject$1m, _templateObject2$10;
var Content$z = styled(View$1)(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  max-width: 680px;\n  @media (max-width: 577px) {\n    margin-left: 0;\n  }\n"])));
var TitleWrapper$5 = styled(View$1)(_templateObject2$10 || (_templateObject2$10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n"])));

var onLoginPage = function onLoginPage() {
  window.location.href = login;
};

var onChangePasswordPage = function onChangePasswordPage() {
  window.location.href = changePassword;
};

var onDeleteAccountPage = function onDeleteAccountPage() {
  window.location.href = deleteAccount;
};

var onDeactivateAccountPage = function onDeactivateAccountPage() {
  window.location.href = deactivateAccount;
};

var onDownloadAccountDataPage = function onDownloadAccountDataPage(email) {
  if (email === void 0) {
    email = '';
  }

  window.location.href = downloadAccountData + "?email=" + email;
};

var onMyAccountPage = function onMyAccountPage() {
  window.location.href = myAccount;
};

var SecurityCentralPage = function SecurityCentralPage(_ref) {
  var fragment = _ref.fragment;
  return /*#__PURE__*/React.createElement(Content$z, null, /*#__PURE__*/React.createElement(TitleWrapper$5, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "title1"
  }, "Seguran\xE7a e privacidade"), /*#__PURE__*/React.createElement(Text$1, {
    size: "caption",
    color: "grayscale.darker"
  }, "Aumente a seguran\xE7a e tenha o controle da sua conta")), /*#__PURE__*/React.createElement(SecurityCentralTemplate, {
    onDeleteSessionsSuccess: onLoginPage,
    onChangePassword: onChangePasswordPage,
    onDeleteAccount: onDeleteAccountPage,
    onDeactivateAccount: onDeactivateAccountPage,
    onDownloadAccountData: onDownloadAccountDataPage,
    onMyAccount: onMyAccountPage,
    fragment: fragment
  }));
};
SecurityCentralPage.propTypes = {
  fragment: PropTypes__default.string
};
SecurityCentralPage.defaultProps = {
  fragment: ''
};

var _excluded$8 = ["children"];

var _templateObject$1n;
var InnerView = styled.div(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n"])));
var View = function View(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  return /*#__PURE__*/React.createElement(InnerView, props, children);
};

var faleConosco$1 = 'https://ajuda.olx.com.br/fale-conosco';
var home$1 = 'https://www.olx.com.br/';
var ajuda = 'https://www.olx.com.br/faq.htm';
var deactivateAccount$1 = 'https://conta.olx.com.br/desativacao-conta';

var _templateObject$1o, _templateObject2$11, _templateObject3$I, _templateObject4$x, _templateObject5$r, _templateObject6$j;
var Box$1 = styled(View$1)(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  min-height: 73px;\n  background-color: #e5e5e5;\n  padding: 16px;\n"])));
var Title$7 = styled(Text$1)(_templateObject2$11 || (_templateObject2$11 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  color: #4a4a4a;\n  line-height: 20px;\n  font-weight: 700;\n"])));
var Content$A = styled(Text$1)(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  color: #4a4a4a;\n  line-height: 20px;\n  font-weight: 400;\n"])));
var DetailColumn$2 = styled(View$1)(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin-left: 16px;\n"])));
var LinkRow = styled(View$1)(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n"])));
var IconWrapper$4 = styled(View$1)(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteralLoose(["\n  padding-top: 8px;\n"])));

var TemporaryWarningBox = function TemporaryWarningBox(props) {
  var title = props.title,
      text = props.text;
  return /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(IconWrapper$4, null, /*#__PURE__*/React.createElement(Icons.System.Clock, {
    color: "#000000",
    size: "18"
  })), /*#__PURE__*/React.createElement(DetailColumn$2, null, /*#__PURE__*/React.createElement(Title$7, null, title), /*#__PURE__*/React.createElement(Content$A, null, text)));
};

TemporaryWarningBox.propTypes = {
  title: PropTypes__default.string.isRequired,
  text: PropTypes__default.string.isRequired
};

var _templateObject$1p, _templateObject2$12;
var DEFAULT_RADIUS = 4;
var Paper = styled.div(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteralLoose(["\n  padding: 32px 56px 24px 56px;\n  border-top-left-radius: ", "px;\n  border-top-right-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n  border-bottom-left-radius: ", "px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(153, 153, 153, 0.2);\n  ", "\n"])), function (props) {
  return props.borderTopLeftRadius;
}, function (props) {
  return props.borderTopRightRadius;
}, function (props) {
  return props.borderBottomRightRadius;
}, function (props) {
  return props.borderBottomLeftRadius;
}, mediaQuery.small(_templateObject2$12 || (_templateObject2$12 = _taggedTemplateLiteralLoose(["padding: 32px 16px 24px 16px;"]))));
Paper.propTypes = {
  borderTopLeftRadius: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  borderTopRightRadius: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  borderBottomRightRadius: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  borderBottomLeftRadius: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number])
};
Paper.defaultProps = {
  borderTopLeftRadius: DEFAULT_RADIUS,
  borderTopRightRadius: DEFAULT_RADIUS,
  borderBottomRightRadius: DEFAULT_RADIUS,
  borderBottomLeftRadius: DEFAULT_RADIUS
};

var _templateObject$1q;
var Logo$1 = styled(Link$2)(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteralLoose(["\n  width: 64px;\n  height: 64px;\n"])));

var OLXLogo = function OLXLogo(props) {
  return /*#__PURE__*/React.createElement(Logo$1, {
    href: props.href
  }, /*#__PURE__*/React.createElement(LogoOLX, null));
};

OLXLogo.defaultProps = {
  href: home$1
};

var _templateObject$1r;
var Content$B = styled(View$1)(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: 300;\n"])));

var logoTitle = function logoTitle(props) {
  var title = props.title;
  return /*#__PURE__*/React.createElement(Content$B, null, /*#__PURE__*/React.createElement(OLXLogo, null), /*#__PURE__*/React.createElement(Text.TitleMedium, null, title));
};

logoTitle.propTypes = {
  title: PropTypes__default.string.isRequired
};

var mailSvgPath = 'M22.75 5.988V18A2.756 2.756 0 0 1 20 20.75H4A2.756 2.756 0 0 1 1.25 18V6.01v-.022A2.756 2.756 0 0 1 4 3.25h16a2.756 2.756 0 0 1 2.75 2.738zm-1.552-.342A1.258 1.258 0 0 0 20 4.75H4c-.563 0-1.044.38-1.198.896L12 12.085l9.198-6.44zm.052 1.794l-8.82 6.174a.75.75 0 0 1-.86 0L2.75 7.44V18c0 .686.564 1.25 1.25 1.25h16c.686 0 1.25-.564 1.25-1.25V7.44z';

var _templateObject$1s, _templateObject2$13, _templateObject3$J;
var Main$3 = styled(View$1)(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 48px;\n"])));
var MailIcon$1 = styled(SVG)(_templateObject2$13 || (_templateObject2$13 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 24px;\n  transform: translateY(-50%);\n"])));
var EnterText = styled(Text$1)(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px !important;\n  color: #f28000;\n"])));

var MagicLinkButton = function MagicLinkButton(_ref) {
  var onClick = _ref.onClick,
      text = _ref.text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      lurker = _ref.lurker;

  var onMagicLinkClick = function onMagicLinkClick() {
    if (onClick) {
      lurker.clickEvt('passwordless_login_button');
      onClick();
    }
  };

  return /*#__PURE__*/React.createElement(Main$3, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onMagicLinkClick,
    size: size,
    fullWidth: true,
    "aria-label": "Login sem senha"
  }, /*#__PURE__*/React.createElement(MailIcon$1, {
    width: 24,
    height: 24,
    svgPath: mailSvgPath,
    viewBox: "0 0 24 24",
    color: "#F28000"
  }), /*#__PURE__*/React.createElement(EnterText, null, text)));
};

MagicLinkButton.propTypes = {
  onClick: PropTypes__default.func,
  lurker: PropTypes__default.object,
  text: PropTypes__default.string
};

var OauthLoginCallout = function OauthLoginCallout(props) {
  var facebookAppId = props.facebookAppId,
      magiclinkButtonText = props.magiclinkButtonText,
      onCancel = props.onCancel,
      onError = props.onError,
      onRequireEmail = props.onRequireEmail,
      onSubmit = props.onSubmit,
      onUserLoggedIn = props.onUserLoggedIn,
      lurker = props.lurker,
      tracker = props.tracker,
      onMagicLinkClick = props.onMagicLinkClick,
      onFacebookLoginCallback = props.onFacebookLoginCallback,
      _props$hideDivider = props.hideDivider,
      hideDivider = _props$hideDivider === void 0 ? false : _props$hideDivider;

  var onFacebookSubmit = function onFacebookSubmit() {
    if (typeof onFacebookLoginCallback === 'function') {
      onFacebookLoginCallback();
    }

    if (typeof onSubmit === 'function') {
      onSubmit();
    }
  };

  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    marginTop: "--spacing-2"
  }, onMagicLinkClick && /*#__PURE__*/React.createElement(Flex, {
    marginBottom: "--spacing-3"
  }, /*#__PURE__*/React.createElement(MagicLinkButton, {
    size: "medium",
    onClick: onMagicLinkClick,
    text: magiclinkButtonText,
    lurker: lurker
  })), !hideDivider && /*#__PURE__*/React.createElement(Flex, {
    marginBottom: "--spacing-4"
  }, /*#__PURE__*/React.createElement(ruleWithText, {
    text: "Ou conecte com"
  })), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(GoogleIconButton, {
    onCancel: onCancel,
    onError: onError,
    onSubmit: onSubmit,
    onUserLoggedIn: onUserLoggedIn,
    lurker: lurker,
    tracker: tracker
  }), /*#__PURE__*/React.createElement(FacebookIconButton, {
    marginLeft: "--spacing-4",
    facebookAppId: facebookAppId,
    onCancel: onCancel,
    onError: onError,
    onRequireEmail: onRequireEmail,
    onSubmit: onFacebookSubmit,
    onUserLoggedIn: onUserLoggedIn,
    lurker: lurker,
    tracker: tracker
  })));
};

OauthLoginCallout.defaultProps = {
  facebookButtonText: 'Entrar com o Facebook',
  googleButtonText: 'Entrar com o Google',
  magiclinkButtonText: 'Entrar sem senha'
};
OauthLoginCallout.propTypes = {
  facebookAppId: PropTypes__default.string,
  magiclinkButtonText: PropTypes__default.string,
  hideDivider: PropTypes__default.bool,
  onCancel: PropTypes__default.func.isRequired,
  onError: PropTypes__default.func.isRequired,
  onRequireEmail: PropTypes__default.func.isRequired,
  onSubmit: PropTypes__default.func.isRequired,
  onUserLoggedIn: PropTypes__default.func.isRequired,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object,
  onMagicLinkClick: PropTypes__default.func,
  onFacebookLoginCallback: PropTypes__default.func
};

var _templateObject$1t;
var style = css(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--color-neutral-80);\n  height: 35px;\n  width: 100%;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 2px 4px 0 rgba(153, 153, 153, 0.2);\n\n  &:hover {\n    background-color: #f7f1fd;\n    span {\n      color: #6e0ad6;\n    }\n  }\n"])));

var chevronRightSvgPath = 'M8.46966991,17.4696699 C8.1767767,17.7625631 8.1767767,18.2374369 8.46966991,18.5303301 C8.76256313,18.8232233 9.23743687,18.8232233 9.53033009,18.5303301 L15.5303301,12.5303301 C15.8232233,12.2374369 15.8232233,11.7625631 15.5303301,11.4696699 L9.53033009,5.46966991 C9.23743687,5.1767767 8.76256313,5.1767767 8.46966991,5.46966991 C8.1767767,5.76256313 8.1767767,6.23743687 8.46966991,6.53033009 L13.9393398,12 L8.46966991,17.4696699 Z';

var _templateObject$1u;
var Content$C = styled(View$1)(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteralLoose(["\n  ", "\n"])), style);

var HelpFooter = function HelpFooter(props) {
  return /*#__PURE__*/React.createElement(Touchable, {
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Content$C, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "body2",
    color: "dark"
  }, "Preciso de ajuda"), /*#__PURE__*/React.createElement(SVG, {
    width: 16,
    height: 16,
    svgPath: chevronRightSvgPath,
    color: theme.colors.dark,
    viewBox: "0 0 24 24"
  })));
};

HelpFooter.propTypes = {
  onClick: PropTypes__default.func
};

var _templateObject$1v, _templateObject2$14;
var Content$D = styled(View$1)(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteralLoose(["\n  ", "\n"])), mediaQuery.small(_templateObject2$14 || (_templateObject2$14 = _taggedTemplateLiteralLoose(["padding: 0 16px 16px 16px;"]))));

var termsAndPrivacyNotice = function termsAndPrivacyNotice() {
  return /*#__PURE__*/React.createElement(Content$D, null, /*#__PURE__*/React.createElement(Text.Caption, {
    color: "--color-neutral-120"
  }, "Ao continuar, voc\xEA concorda com os", ' ', /*#__PURE__*/React.createElement(Link$2, {
    size: "caption",
    href: termosDeUso
  }, "Termos de Uso"), "\xA0e a", ' ', /*#__PURE__*/React.createElement(Link$2, {
    size: "caption",
    href: politicaDePrivacidade
  }, "Pol\xEDtica de Privacidade"), "\xA0da OLX, e tamb\xE9m, em receber comunica\xE7\xF5es via e-mail e push da OLX e seus parceiros."));
};

var _templateObject$1w, _templateObject2$15;
var domains = ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com', 'yahoo.com.br', 'icloud.com', 'bol.com.br', 'live.com', 'outlook.com.br', 'uol.com.br', 'terra.com.br', 'ig.com.br'];
var secondLevelDomains = ['yahoo', 'hotmail', 'live', 'outlook'];
var topLevelDomains = ['com', 'com.br'];
var Wrapper$5 = styled(View$1)(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  margin-top: var(--spacing-1);\n  margin-bottom: var(--spacing-1);\n"])));
var EmailWrapper = styled(View$1)(_templateObject2$15 || (_templateObject2$15 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  margin-left: var(--spacing-0-5);\n"])));

var DidYouMean = function DidYouMean(_ref) {
  var address = _ref.address,
      domain = _ref.domain,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Wrapper$5, null, /*#__PURE__*/React.createElement(Text.BodySmall, null, "Deseja usar"), /*#__PURE__*/React.createElement(Link$2, {
    size: "small",
    onMouseDown: function onMouseDown() {
      return onClick && onClick(address + "@" + domain);
    }
  }, /*#__PURE__*/React.createElement(EmailWrapper, null, address + "@", /*#__PURE__*/React.createElement("b", null, domain))), /*#__PURE__*/React.createElement(Text.BodySmall, null, "?"));
};

var handleError$1 = function handleError(error) {
  return typeof error == 'function' ? error() : error;
};

var DsMailCheckFormItem = function DsMailCheckFormItem(_ref2) {
  var value = _ref2.value,
      label = _ref2.label,
      error = _ref2.error,
      hasError = _ref2.hasError,
      inputRef = _ref2.inputRef,
      disabled = _ref2.disabled,
      onBlur = _ref2.onBlur,
      onChange = _ref2.onChange,
      onSuggestionClick = _ref2.onSuggestionClick,
      labelweight = _ref2.labelweight,
      tip = _ref2.tip;

  var _useState = useState(true),
      showSuggestion = _useState[0],
      setShowSuggestion = _useState[1];

  var handleAction = function handleAction(handler, showSuggestion) {
    return function (event) {
      if (handler) {
        handler(event);
      }

      setShowSuggestion(showSuggestion);
    };
  };

  return /*#__PURE__*/React.createElement(MailCheck$1, {
    email: value,
    domains: domains,
    domainThreshold: 4,
    secondLevelDomains: secondLevelDomains,
    secondLevelThreshold: 3,
    topLevelDomains: topLevelDomains,
    topLevelThreshold: 1
  }, function (suggestion) {
    return /*#__PURE__*/React.createElement(formItem, {
      label: label || 'E-mail',
      labelweight: labelweight,
      tip: tip
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput$1, {
      "aria-label": "email",
      inputRef: inputRef,
      disabled: disabled,
      id: "input-1",
      type: "email",
      value: value,
      onChange: handleAction(onChange, true),
      onBlur: handleAction(onBlur, false),
      stateMessage: handleError$1(error) || 'Campo obrigatório. Informe um e-mail válido.',
      state: hasError ? 'error' : null
    }), suggestion && showSuggestion && /*#__PURE__*/React.createElement(DidYouMean, {
      address: suggestion.address,
      domain: suggestion.domain,
      onClick: onSuggestionClick
    })));
  });
};

var _excluded$9 = ["error"];

var _templateObject$1x, _templateObject2$16, _templateObject3$K, _templateObject4$y, _templateObject5$s;
var FormContent = styled(View)(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var PageForm = styled(Form)(_templateObject2$16 || (_templateObject2$16 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var Content$E = styled(View)(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n"])));
var HRuleWrapper$6 = styled(View)(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var FooterWrapper = styled(View)(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));

var EmailLoginTemplate = function EmailLoginTemplate(_ref) {
  var abTests = _ref.abTests,
      facebookAppId = _ref.facebookAppId,
      onMagicLinkClick = _ref.onMagicLinkClick,
      onRequireEmail = _ref.onRequireEmail,
      onSubmit = _ref.onSubmit,
      onRegisterClick = _ref.onRegisterClick,
      onHelpLinkClick = _ref.onHelpLinkClick,
      onForgotPassword = _ref.onForgotPassword,
      onReactivationLinkClick = _ref.onReactivationLinkClick,
      onHelpLinkClose = _ref.onHelpLinkClose,
      onMailCheckSuggestionClick = _ref.onMailCheckSuggestionClick,
      onOauthCancel = _ref.onOauthCancel,
      onOauthError = _ref.onOauthError,
      onOauthSubmit = _ref.onOauthSubmit,
      onOauthSuccess = _ref.onOauthSuccess,
      isSubmitting = _ref.isSubmitting,
      showHelpingModalLink = _ref.showHelpingModalLink,
      shouldDisableSubmit = _ref.shouldDisableSubmit,
      inputWrapper = _ref.inputWrapper,
      errorMsg = _ref.errorMsg,
      captchaChallenge = _ref.captchaChallenge,
      lurker = _ref.lurker,
      tracker = _ref.tracker;

  var _useState = useState(false),
      showHelpModal = _useState[0],
      setShowHelpModal = _useState[1];

  var bottomBorderRadius = showHelpingModalLink ? 0 : 4;
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$E, null, /*#__PURE__*/React.createElement(Paper, {
    borderBottomLeftRadius: bottomBorderRadius,
    borderBottomRightRadius: bottomBorderRadius
  }, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Acesse a sua conta"
  }), /*#__PURE__*/React.createElement(FormContent, null, errorMsg, /*#__PURE__*/React.createElement(PageForm, {
    method: "POST",
    onSubmit: onSubmit,
    noValidate: true
  }, inputWrapper(function (_ref2) {
    var field = _ref2.field,
        _ref2$fieldState = _ref2.fieldState,
        error = _ref2$fieldState.error,
        restFields = _objectWithoutPropertiesLoose(_ref2$fieldState, _excluded$9);

    return /*#__PURE__*/React.createElement(DsMailCheckFormItem, _extends({
      label: "E-mail",
      disabled: isSubmitting,
      onSuggestionClick: onMailCheckSuggestionClick
    }, field, restFields, {
      hasError: !!(error !== null && error !== void 0 && error.message)
    }));
  }), captchaChallenge || null, /*#__PURE__*/React.createElement(Flex, {
    marginTop: "--spacing-2"
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    size: "medium",
    disabled: shouldDisableSubmit,
    isLoading: isSubmitting,
    onClick: onSubmit
  }, "Continuar"))), /*#__PURE__*/React.createElement(OauthLoginCallout, {
    facebookAppId: facebookAppId,
    onCancel: onOauthCancel,
    onError: onOauthError,
    onRequireEmail: onRequireEmail,
    onSubmit: onOauthSubmit,
    onUserLoggedIn: onOauthSuccess,
    lurker: lurker,
    tracker: tracker,
    onMagicLinkClick: onMagicLinkClick,
    abTests: abTests
  })), /*#__PURE__*/React.createElement(HRuleWrapper$6, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
    text: "N\xE3o tem uma conta?",
    linkText: "Cadastre-se",
    href: "/cadastro",
    onClick: onRegisterClick
  })), showHelpingModalLink && /*#__PURE__*/React.createElement(HelpFooter, {
    onClick: function onClick() {
      setShowHelpModal(true);
      onHelpLinkClick();
    }
  }), /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))), /*#__PURE__*/React.createElement(HelpModalTemplate, {
    abTests: abTests,
    open: showHelpModal,
    onForgotPasswordLinkClick: onForgotPassword,
    onReactivationLinkClick: onReactivationLinkClick,
    onMagicLinkClick: onMagicLinkClick,
    onClose: function onClose() {
      setShowHelpModal(false);
      onHelpLinkClose();
    }
  }));
};

EmailLoginTemplate.propTypes = {
  abTests: PropTypes__default.string,
  facebookAppId: PropTypes__default.string,
  onMagicLinkClick: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onHelpLinkClick: PropTypes__default.func,
  onOauthCancel: PropTypes__default.func,
  onOauthError: PropTypes__default.func,
  onOauthSubmit: PropTypes__default.func,
  onOauthSuccess: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onHelpLinkClose: PropTypes__default.func,
  onMailCheckSuggestionClick: PropTypes__default.func,
  showReactivationLink: PropTypes__default.bool,
  smartLockLogin: PropTypes__default.bool,
  isSubmitting: PropTypes__default.bool,
  showHelpingModalLink: PropTypes__default.bool,
  shouldDisableSubmit: PropTypes__default.bool,
  errorMsg: PropTypes__default.element,
  captchaChallenge: PropTypes__default.element,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object
};

var trackerSend = function trackerSend(eventName, eventPayload, options) {
  SentryWrapper.addBreadcrumb('tracker', eventName, eventPayload, options);

  try {
    if (window.Tracker) {
      window.Tracker.track(eventName, eventPayload, options);
    } else {
      console.log('TRACKER EVENT: ', eventName, eventPayload, options);
    }
  } catch (error) {
    console.error("Error on send Tracker event: " + error);
  }
};

var setDataToString$1 = function setDataToString(extraData) {
  if (extraData === void 0) {
    extraData = {};
  }

  var data = {};
  Object.keys(extraData).forEach(function (k) {
    if (typeof extraData[k] === 'object') {
      data[k] = JSON.stringify(extraData[k]);
    } else if (typeof extraData[k] !== 'undefined') {
      data[k] = "" + extraData[k];
    }
  });
  return data;
};

var round$1 = function round(number) {
  return Math.round(number * 1000) / 1000;
};

var Tracker = function Tracker(_pageName) {
  var _this = this;

  this.getElapsedTime = function () {
    return _this.initialLoadTime && round$1((new Date().getTime() - _this.initialLoadTime) / 1000);
  };

  this.pageLoadEvt = function (pageName) {
    if (pageName) {
      _this.pageName = pageName;
    }

    _this.initialLoadTime = new Date().getTime();
  };

  this.viewMessageEvt = function (eventName, eventPayload) {
    trackerSend(eventName, setDataToString$1(_extends({}, eventPayload, {
      accounts_elapsed_time: _this.getElapsedTime()
    })));
  };

  this.pageName = _pageName;
};

var KEY$1 = 'ACCOUNTS_TRANSIENTS_ERROS';

var getTransientError = function getTransientError() {
  return get(KEY$1).then(function (value) {
    remove(KEY$1);
    return value;
  })["catch"](function () {
    return null;
  });
};

var setTransientError = function setTransientError(value) {
  set(KEY$1, value);
};

var transientErrorsStorage = {
  get: getTransientError,
  set: setTransientError
};

var UnsupportedSmartLockError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(UnsupportedSmartLockError, _Error);

  function UnsupportedSmartLockError() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Error.call.apply(_Error, [this].concat(args)) || this;
    _this.code = 'unsupported_smart_lock';
    _this.message = 'Unsupported Smart Lock error';
    return _this;
  }

  return UnsupportedSmartLockError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SMART_LOCK_KEY = 'SMART_LOCK_STATUS';
var EXPIRE_DAYS = 30;

var changeSmarLockStatus = function changeSmarLockStatus(status) {
  var date = new Date();
  date.setDate(date.getDate() + EXPIRE_DAYS);
  Cookie.create(SMART_LOCK_KEY, status, date.toUTCString());
};

var disableSmartLock = function disableSmartLock() {
  changeSmarLockStatus('off');
};

var enableSmartLock = function enableSmartLock() {
  changeSmarLockStatus('on');
};

var storeCredential = function storeCredential(email, password, name) {
  var _window = window,
      PasswordCredential = _window.PasswordCredential,
      _window$navigator = _window.navigator,
      navigator = _window$navigator === void 0 ? {} : _window$navigator;

  if (PasswordCredential && navigator.credentials) {
    var data = {
      id: email.toLowerCase().trim(),
      password: password
    };

    if (name) {
      data[name] = name;
    }

    var credentials = new PasswordCredential(data);
    return navigator.credentials.store(credentials);
  }

  return Promise.reject(new UnsupportedSmartLockError());
};

var SmartLock = function SmartLock(pageName) {
  var _this2 = this;

  this.isAvailable = function () {
    return Cookie.get(SMART_LOCK_KEY) !== 'off';
  };

  this.saveCredential = function (email, password, name) {
    if (name === void 0) {
      name = '';
    }

    return storeCredential(email, password, name).then(function () {
      enableSmartLock();

      _this2.lurker.viewMessageEvt('save_credentials_success');
    })["catch"](function (error) {
      disableSmartLock();

      _this2.lurker.viewMessageEvt('save_credentials_error', {
        accounts_reason: error.code || 'unknown',
        accounts_error_message: error.message || 'unknown'
      });
    });
  };

  this.removeCredential = function (email) {
    return storeCredential(email, '-').then(function () {
      _this2.lurker.viewMessageEvt('remove_credentials_success');
    })["catch"](function (error) {
      _this2.lurker.viewMessageEvt('remove_credentials_error', {
        accounts_reason: error.code || 'unknown',
        accounts_error_message: error.message || 'unknown'
      });
    });
  };

  this.requestCredential = function () {
    var _window2 = window,
        _window2$navigator = _window2.navigator,
        navigator = _window2$navigator === void 0 ? {} : _window2$navigator;

    if (navigator.credentials) {
      return navigator.credentials.get({
        password: true,
        unmediated: false,
        mediation: 'required'
      }).then(function (credentials) {
        if (credentials) {
          var email = credentials.id,
              password = credentials.password;
          return {
            email: email,
            password: password
          };
        }

        disableSmartLock();
        return null;
      })["catch"](function (error) {
        disableSmartLock();
      });
    }

    disableSmartLock();
    return Promise.resolve();
  };

  this.lurker = new Lurker(pageName);
};

var getQueryParams = function getQueryParams() {
  var params = window.location.search;
  return params ? params.replace(/^\?/, '') : '';
};

var API_ENDPOINT$9 = '/v0/user/passwordless_send_email';
var passwordlessSendEmailApiCall = (function (email) {
  var data = {
    email: email,
    redirectParams: getQueryParams()
  };
  return axios.post(API_ENDPOINT$9, data, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
});

var INCIDENT_STATUS_ENDPOINT = '/incident-status';
var instabilityStatus = (function () {
  return axios.get(INCIDENT_STATUS_ENDPOINT).then(function (response) {
    return response.data;
  });
});

var API_ENDPOINT_WITH_2FA = '/2fa/v1/login/pincode';
var API_LOGIN_TURNSTILE_V2 = '/2fa/v2/login/captcha';
var API_SPLIT_LOGIN_CHECK_EMAIL = '/v0/user/login/check_email';
var smartLock = new SmartLock('login');
var loginWith2FA = function loginWith2FA(code, token, type) {
  return axios.post(API_ENDPOINT_WITH_2FA, {
    code: code,
    token: token,
    type: type
  }, {
    withCredentials: true
  }).then(function (_ref2) {
    var data = _ref2.data;

    try {
      lastLoginStorage.saveEmailLogin(data);
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  });
};
var loginWithTurnstilev2 = function loginWithTurnstilev2(email, password, turnstileToken) {
  return axios.post(API_LOGIN_TURNSTILE_V2, {
    email: email.toLowerCase().trim(),
    password: password,
    platform: platform
  }, {
    headers: {
      'X-Accounts-Login-Turnstile': turnstileToken
    },
    withCredentials: true
  }).then(function (_ref4) {
    var data = _ref4.data;

    try {
      var _data$fullName6 = data.fullName,
          fullName = _data$fullName6 === void 0 ? '' : _data$fullName6;
      lastLoginStorage.saveEmailLogin(data);
      return Promise.resolve(smartLock.saveCredential(email, password, fullName)).then(function () {
        return data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  });
};
var checkMail = function checkMail(email) {
  return axios.post(API_SPLIT_LOGIN_CHECK_EMAIL, {
    email: email.toLowerCase().trim()
  }, {
    withCredentials: true
  });
};

var _templateObject$1y, _templateObject2$17, _templateObject3$L;
var lurker$d = new Lurker('login_email');
var tracker = new Tracker('login_email');
var smartLock$1 = new SmartLock('login');
var ErrorMsgWrapper$1 = styled(View)(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var InstabilityBox = styled(GenericWarningBox)(_templateObject2$17 || (_templateObject2$17 = _taggedTemplateLiteralLoose(["\n  border-style: none;\n  border-radius: 8px;\n  margin: 15px 0px 10px 0px;\n  padding: 16px 24px;\n  background: #fff7e0;\n"])));
var InstabilityBoxFade = styled(View)(_templateObject3$L || (_templateObject3$L = _taggedTemplateLiteralLoose(["\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  div {\n    animation-name: fadeIn;\n    animation-duration: 1s;\n  }\n"])));
var apiErrors = {
  Unauthorized: 'showUnauthorizedError',
  Inactive: 'showInactiveError',
  Generic: 'showGenericError',
  RateLimit: 'showRateLimitError',
  AccountNotFound: 'showAccountNotFoundError',
  GoogleInitialization: 'showGoogleInitializationError',
  ExpiredToken: 'showExpiredTokenError',
  RedScore: 'showRedScoreError',
  AccountLocked: 'showAccountLockedError',
  AccountDisabledByFraud: 'showAccountDisabledByFraudError',
  Instability: 'showInstabilityError',
  NoNetwork: 'showNetworkError'
};
var errorMessages = {
  INVALID_EMAIL: 'Informe um e-mail válido.'
};
var SplitLoginEmailPage = function SplitLoginEmailPage(_ref) {
  var facebookAppId = _ref.facebookAppId,
      onChallengePinCodeCall = _ref.onChallengePinCodeCall,
      onError = _ref.onError,
      onForgotPassword = _ref.onForgotPassword,
      onLoginSuccess = _ref.onLoginSuccess,
      onMagicLinkClick = _ref.onMagicLinkClick,
      onMagicLinkEmailSentClick = _ref.onMagicLinkEmailSentClick,
      onReactivationLinkClick = _ref.onReactivationLinkClick,
      onRegisterClick = _ref.onRegisterClick,
      onRequireEmail = _ref.onRequireEmail,
      onSubmit = _ref.onSubmit,
      showReactivationLink = _ref.showReactivationLink,
      showHelpingModalLink = _ref.showHelpingModalLink,
      smartLockLogin = _ref.smartLockLogin,
      _ref$abTests = _ref.abTests,
      abTests = _ref$abTests === void 0 ? '' : _ref$abTests;

  var _useState = useState(''),
      currentError = _useState[0],
      setCurrentError = _useState[1];

  var _useState2 = useState(false),
      isSubmitting = _useState2[0],
      setIsSubmitting = _useState2[1];

  var _useForm = useForm({
    defaultValues: {
      email: ''
    },
    mode: 'onBlur',
    reValidateMode: 'onChange'
  }),
      control = _useForm.control,
      isValid = _useForm.formState.isValid,
      handleSubmit = _useForm.handleSubmit,
      setValue = _useForm.setValue,
      getValues = _useForm.getValues;

  var onReactivationClick = function onReactivationClick() {
    lurker$d.clickEvt('reactivation_link');

    if (isValid && typeof onReactivationLinkClick === 'function') {
      onReactivationLinkClick(getValues('email'));
    }
  };

  var onSendQuickAccess = function onSendQuickAccess() {
    return function (event) {
      event.preventDefault();
      lurker$d.clickEvt('rate-limit-magiclink');

      if (isValid && typeof sendMagicLink === 'function') {
        sendMagicLink();
      }
    };
  };

  var onLinkSended = function onLinkSended() {
    setCurrentError('');

    if (typeof onMagicLinkEmailSentClick === 'function') {
      onMagicLinkEmailSentClick(getValues('email'));
    }
  };

  var sendMagicLink = function sendMagicLink() {
    getValues('email');
    setIsSubmitting(true);
    passwordlessSendEmailApiCall(getValues('email')).then(onLinkSended)["catch"](onEmailLoginError)["finally"](function () {
      setIsSubmitting(false);
    });
  };

  var onEmailSubmit = function onEmailSubmit(_ref2) {
    var email = _ref2.email;
    lurker$d.clickEvt('email');
    setIsSubmitting(true);
    checkMail(email).then(function () {
      setIsSubmitting(false);
      onSubmit(email);
    })["catch"](function (error) {
      onEmailLoginError(error);
      setIsSubmitting(false);
    });
  };

  var onOauthSuccess = function onOauthSuccess(data) {
    if (onLoginSuccess) {
      onLoginSuccess(data);
    }

    setIsSubmitting(false);
  };

  var onOauthError = function onOauthError(error) {
    if (onError) {
      onError(error);
    }

    var errorBox = apiErrors.Generic;

    if (error === 'google_initialization_error') {
      errorBox = apiErrors.GoogleInitialization;
    }

    setCurrentError(errorBox);
    setIsSubmitting(false);
  };

  var onOauthCancel = function onOauthCancel() {
    setIsSubmitting(false);
  };

  var onOauthSubmit = function onOauthSubmit() {
    setIsSubmitting(true);
  };

  var getErrorAlertbox = function getErrorAlertbox(error) {
    var _errorMessages;

    var errorMessages = (_errorMessages = {}, _errorMessages[apiErrors.Instability] = /*#__PURE__*/React.createElement(InstabilityBoxFade, null, /*#__PURE__*/React.createElement(InstabilityBox, null, /*#__PURE__*/React.createElement(Text.BodyMedium, {
      color: "--color-feedback-attention-110"
    }, "Podemos apresentar instabilidades no login neste momento. J\xE1 estamos trabalhando para resolv\xEA-las!"))), _errorMessages[apiErrors.Generic] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel acessar sua conta. Por favor, tente novamente."
    })), _errorMessages[apiErrors.GoogleInitialization] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showGoogleInitializationError: true,
      text: "N\xE3o foi poss\xEDvel entrar com o Google."
    })), _errorMessages[apiErrors.RateLimit] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      errorAction: onSendQuickAccess,
      showRateLimitMagicLink: true,
      text: "Voc\xEA excedeu o n\xFAmero de tentativas."
    })), _errorMessages[apiErrors.Inactive] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      contactUsLink: "https://ajuda.olx.com.br/s/article/reativar-conta-na-olx",
      showInactiveError: showReactivationLink,
      errorAction: showReactivationLink ? onReactivationClick : null,
      text: "Esta conta foi desativada."
    })), _errorMessages[apiErrors.AccountDisabledByFraud] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "Conta temporariamente bloqueada.",
      showContactUs: true
    })), _errorMessages[apiErrors.AccountNotFound] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showAccountNotFoundError: true,
      errorAction: onRegisterClick,
      text: "N\xE3o existe uma conta com este e-mail."
    })), _errorMessages[apiErrors.ExpiredToken] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "O link para acesso r\xE1pido expirou."
    })), _errorMessages[apiErrors.RedScore] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "Conta temporariamente bloqueada.",
      showContactUs: true
    })), _errorMessages[apiErrors.AccountLocked] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(TemporaryWarningBox, {
      title: "Por favor, aguarde!",
      text: "Estamos atualizando suas informa\xE7\xF5es de contato. Um e-mail ser\xE1 enviado assim que o acesso for liberado."
    })), _errorMessages[apiErrors.NoNetwork] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "N\xE3o foi poss\xEDvel acessar sua conta.",
      info: "Por favor, verifique sua conex\xE3o com a internet e tente novamente."
    })), _errorMessages);
    return errorMessages[error] || errorMessages[apiErrors.Generic];
  };

  var onUnauthorizedError = function onUnauthorizedError(response, isSmartLock) {
    var prefix = isSmartLock ? 'smart_lock_' : '';

    var _ref3 = response.data || {},
        _ref3$message = _ref3.message,
        message = _ref3$message === void 0 ? 'UNAUTHORIZED' : _ref3$message;

    lurker$d.viewMessageEvt('error', {
      accounts_reason: "" + prefix + message.toLowerCase(),
      accounts_status_code: response.status
    });

    if (message === 'PIN_CODE') {
      if (typeof onChallengePinCodeCall === 'function') {
        onChallengePinCodeCall(response.data);
      }
    }

    if (message === 'ACCOUNT_NOT_FOUND') {
      setCurrentError(apiErrors.AccountNotFound);
    } else {
      setCurrentError(apiErrors.Unauthorized);
    }

    if (isSmartLock) {
      smartLock$1.removeCredential(getValues('email'));
    }
  };

  var handleUnexpectedError = function handleUnexpectedError(error, prefix) {
    var _error$response;

    if (error.message.includes('timeout')) {
      setCurrentError(apiErrors.NoNetwork);
    }

    if (error !== null && error !== void 0 && (_error$response = error.response) !== null && _error$response !== void 0 && _error$response.status) {
      lurker$d.viewMessageEvt('error', {
        accounts_reason: prefix + "unexpected_status_code",
        accounts_status_code: error === null || error === void 0 ? void 0 : error.response.status
      });
      setCurrentError(apiErrors.Generic);
    } else {
      lurker$d.viewMessageEvt('error', {
        accounts_reason: prefix + "unexpected_error",
        accounts_error_message: (error === null || error === void 0 ? void 0 : error.message) || 'unknown'
      });
      setCurrentError(apiErrors.Generic);
    }
  };

  var onApiError = function onApiError(error, isSmartLock) {
    var _errorActions, _error2;

    if (error === void 0) {
      error = {};
    }

    var _error = error,
        _error$response2 = _error.response,
        response = _error$response2 === void 0 ? {} : _error$response2;
    var prefix = isSmartLock ? 'smart_lock_' : '';
    var errorActions = (_errorActions = {
      'Network Error': function NetworkError() {
        lurker$d.viewMessageEvt('login_timeout');
        setCurrentError(apiErrors.NoNetwork);
      }
    }, _errorActions[httpStatus.UNAUTHORIZED] = function () {
      onUnauthorizedError(response, isSmartLock);
    }, _errorActions[httpStatus.LOCKED] = function () {
      lurker$d.viewMessageEvt('error', {
        accounts_reason: prefix + "account_locked",
        accounts_status_code: response.status
      });
      setCurrentError(apiErrors.AccountLocked);
    }, _errorActions[httpStatus.TOO_MANY_REQUESTS] = function () {
      lurker$d.viewMessageEvt('error', {
        accounts_reason: prefix + "rate_limit_exceeded",
        accounts_status_code: response.status
      });
      setCurrentError(apiErrors.RateLimit);
    }, _errorActions[httpStatus.GONE] = function () {
      lurker$d.viewMessageEvt('error', {
        accounts_reason: prefix + "account_inactive",
        accounts_status_code: response.status
      });
      setCurrentError(apiErrors.Inactive);
    }, _errorActions[httpStatus.FORBIDDEN] = function () {
      var _ref4 = response.data || {},
          _ref4$message = _ref4.message,
          message = _ref4$message === void 0 ? 'TURNSTILE_INVALID_TOKEN' : _ref4$message;

      switch (message) {
        case 'ACCOUNT_DISABLED':
          lurker$d.viewMessageEvt('error', {
            accounts_reason: "" + prefix + message.toLowerCase(),
            accounts_status_code: response.status
          });
          setCurrentError(apiErrors.AccountDisabledByFraud);
          break;

        default:
          lurker$d.viewMessageEvt('error', {
            accounts_reason: "" + prefix + message.toLowerCase(),
            accounts_status_code: response.status
          });
          setCurrentError(apiErrors.Generic);
      }
    }, _errorActions[httpStatus.BAD_REQUEST] = function () {
      if (response.data && response.data.trim() === 'Missing turnstile token') {
        lurker$d.viewMessageEvt('error', {
          accounts_reason: prefix + "turnstile_missing_token",
          accounts_status_code: response.status
        });
        setCurrentError(apiErrors.Generic);
      }
    }, _errorActions["default"] = function _default() {
      handleUnexpectedError(response);
    }, _errorActions);
    var action = errorActions[response.status] || errorActions[(_error2 = error) === null || _error2 === void 0 ? void 0 : _error2.message] || errorActions["default"];
    return action();
  };

  var onEmailLoginError = function onEmailLoginError(error, isSmartLock) {
    if (error === void 0) {
      error = {};
    }

    if (onError) {
      onError();
    }

    onApiError(error, isSmartLock);
    behaviors.scrollToTop();
  };

  var onHelpLinkClick = function onHelpLinkClick() {
    lurker$d.clickEvt('help_modal_open');
  };

  var onHelpLinkClose = function onHelpLinkClose() {
    lurker$d.clickEvt('help_modal_close');
  };

  var checkStoredEmail = function checkStoredEmail() {
    storage.get('loggedInEmail').then(function (value) {
      if (typeof value === 'string') {
        setValue('email', value, {
          shouldValidate: true
        });
      }
    });
  };

  var checkTransientErrors = function checkTransientErrors() {
    transientErrorsStorage.get().then(function (error) {
      if (typeof error === 'string') {
        setCurrentError(error);
      }
    });
  };

  var trySmartLockLogin = function trySmartLockLogin() {
    if (smartLockLogin) {
      smartLock$1.requestCredential().then(function (credentials) {
        if (credentials) {
          var email = credentials.email;
          setValue('email', email, {
            shouldValidate: true
          });
        }
      });
    }
  };

  var onMailCheckSuggestionClick = function onMailCheckSuggestionClick(suggestion) {
    lurker$d.viewMessageEvt('mailcheck_suggestion_accepted', {
      mailcheck_original: getValues('email'),
      mailcheck_suggestion: suggestion
    });
    setValue('email', suggestion, {
      shouldValidate: true
    });
  };

  var checkInstability = function checkInstability() {
    instabilityStatus().then(function (_ref5) {
      var variants = _ref5.variants;

      if (variants) {
        var unstable = variants.some(function (v) {
          return v.name === 'enabled' && v.group_size > 0;
        });

        if (unstable) {
          setCurrentError(apiErrors.Instability);
          lurker$d.viewMessageEvt('instability_message_displayed');
        }
      }
    });
  };

  useEffect(function () {
    lurker$d.pageLoadEvt();
    tracker.pageLoadEvt();
    checkStoredEmail();
    checkTransientErrors();
    trySmartLockLogin();
    checkInstability();
  }, []);
  return /*#__PURE__*/React.createElement(EmailLoginTemplate, {
    abTests: abTests,
    facebookAppId: facebookAppId,
    onRequireEmail: onRequireEmail,
    onMagicLinkClick: onMagicLinkClick,
    onSubmit: handleSubmit(onEmailSubmit),
    onRegisterClick: onRegisterClick,
    onHelpLinkClick: onHelpLinkClick,
    onForgotPassword: onForgotPassword,
    onReactivationLinkClick: onReactivationLinkClick,
    onHelpLinkClose: onHelpLinkClose,
    onMailCheckSuggestionClick: onMailCheckSuggestionClick,
    onOauthCancel: onOauthCancel,
    onOauthError: onOauthError,
    onOauthSubmit: onOauthSubmit,
    onOauthSuccess: onOauthSuccess,
    isSubmitting: isSubmitting,
    showHelpingModalLink: showHelpingModalLink,
    shouldDisableSubmit: isSubmitting,
    errorMsg: currentError ? getErrorAlertbox(currentError) : null,
    lurker: lurker$d,
    tracker: tracker,
    inputWrapper: function inputWrapper(renderComponent) {
      return /*#__PURE__*/React.createElement(Controller, {
        control: control,
        name: "email",
        rules: {
          required: errorMessages['INVALID_EMAIL'],
          validate: function validate(email) {
            return isValidEmail(email) && currentError !== apiErrors.Inactive || errorMessages['INVALID_EMAIL'];
          }
        },
        render: renderComponent
      });
    }
  });
};
SplitLoginEmailPage.propTypes = {
  abTests: PropTypes__default.string,
  emailStorage: PropTypes__default.bool,
  facebookAppId: PropTypes__default.string.isRequired,
  onChallengePinCodeCall: PropTypes__default.func,
  onError: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onLoginSuccess: PropTypes__default.func,
  onMagicLinkEmailSentClick: PropTypes__default.func,
  onMagicLinkClick: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  showReactivationLink: PropTypes__default.bool,
  showHelpingModalLink: PropTypes__default.bool,
  smartLockLogin: PropTypes__default.bool
};

var showPasswordSvgPath = 'M1.57626969,8.56207062 C1.96456746,9.16330588 2.42323893,9.76484223 2.94810194,10.3246961 C4.42455447,11.8995788 6.11698456,12.8333333 8,12.8333333 C9.88301544,12.8333333 11.5754455,11.8995788 13.0518981,10.3246961 C13.5767611,9.76484223 14.0354325,9.16330588 14.4237303,8.56207062 C14.5551755,8.35854262 14.6690083,8.16958874 14.7648469,8 C14.6690083,7.83041126 14.5551755,7.64145738 14.4237303,7.43792938 C14.0354325,6.83669412 13.5767611,6.23515777 13.0518981,5.6753039 C11.5754455,4.1004212 9.88301544,3.16666667 8,3.16666667 C6.11698456,3.16666667 4.42455447,4.1004212 2.94810194,5.6753039 C2.42323893,6.23515777 1.96456746,6.83669412 1.57626969,7.43792938 C1.44482452,7.64145738 1.33099169,7.83041126 1.23515306,8 C1.33099169,8.16958874 1.44482452,8.35854262 1.57626969,8.56207062 Z M0.219453071,7.7763932 C0.243827414,7.72764452 0.288957872,7.64235861 0.354576815,7.52570271 C0.461967629,7.33478571 0.589262775,7.12296659 0.736230311,6.89540395 C1.15522421,6.24663921 1.64967774,5.59817556 2.21856473,4.99136277 C3.8671122,3.23291213 5.79968211,2.16666667 8,2.16666667 C10.2003179,2.16666667 12.1328878,3.23291213 13.7814353,4.99136277 C14.3503223,5.59817556 14.8447758,6.24663921 15.2637697,6.89540395 C15.4107372,7.12296659 15.5380324,7.33478571 15.6454232,7.52570271 C15.7110421,7.64235861 15.7561726,7.72764452 15.7805469,7.7763932 C15.8509288,7.91715695 15.8509288,8.08284305 15.7805469,8.2236068 C15.7561726,8.27235548 15.7110421,8.35764139 15.6454232,8.47429729 C15.5380324,8.66521429 15.4107372,8.87703341 15.2637697,9.10459605 C14.8447758,9.75336079 14.3503223,10.4018244 13.7814353,11.0086372 C12.1328878,12.7670879 10.2003179,13.8333333 8,13.8333333 C5.79968211,13.8333333 3.8671122,12.7670879 2.21856473,11.0086372 C1.64967774,10.4018244 1.15522421,9.75336079 0.736230311,9.10459605 C0.589262775,8.87703341 0.461967629,8.66521429 0.354576815,8.47429729 C0.288957872,8.35764139 0.243827414,8.27235548 0.219453071,8.2236068 C0.149071198,8.08284305 0.149071198,7.91715695 0.219453071,7.7763932 Z M8,10.5 C6.61928813,10.5 5.5,9.38071187 5.5,8 C5.5,6.61928813 6.61928813,5.5 8,5.5 C9.38071187,5.5 10.5,6.61928813 10.5,8 C10.5,9.38071187 9.38071187,10.5 8,10.5 Z M8,9.5 C8.82842712,9.5 9.5,8.82842712 9.5,8 C9.5,7.17157288 8.82842712,6.5 8,6.5 C7.17157288,6.5 6.5,7.17157288 6.5,8 C6.5,8.82842712 7.17157288,9.5 8,9.5 Z';

var showPassword = function showPassword(props) {
  var onClick = props.onClick,
      onPress = props.onPress,
      enabled = props.enabled;
  return /*#__PURE__*/React.createElement(SVG, {
    onClick: onClick,
    onPress: onPress,
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    svgPath: showPasswordSvgPath,
    color: enabled ? '#4A4A4A' : '#D2D2D2'
  });
};

showPassword.propTypes = {
  enabled: PropTypes__default.bool,
  onClick: PropTypes__default.func
};
showPassword.defaultProps = {
  enabled: false
};

var _templateObject$1z;
var StyledView = styled.div(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"])));
var Clickable = (function (props) {
  return /*#__PURE__*/React.createElement(StyledView, {
    onClick: props.onClick || props.onPress,
    className: props.className
  }, props.children);
});

var _templateObject$1A, _templateObject2$18, _templateObject3$M;
var Content$F = styled(View$1)(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 1 0;\n"])));
var ShowPasswordPlacement = styled(Clickable)(_templateObject2$18 || (_templateObject2$18 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  top: 4px;\n  left: 4px;\n"])));
var InputLink = styled(Link$2)(_templateObject3$M || (_templateObject3$M = _taggedTemplateLiteralLoose(["\n  font-size: var(--font-size-xxs);\n"])));

var DsPasswordInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DsPasswordInput, _React$Component);

  function DsPasswordInput(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.state = {
      showingPassword: props.visiblePassword
    };
    return _this;
  }

  var _proto = DsPasswordInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var visiblePassword = this.props.visiblePassword;
    var previousVisiblePassword = prevProps.visiblePassword;

    if (previousVisiblePassword !== visiblePassword) {
      this.setState({
        showingPassword: visiblePassword
      });
    }
  };

  _proto.handleClick = function handleClick() {
    var showingPassword = this.state.showingPassword;
    this.setState({
      showingPassword: !showingPassword
    });
  };

  _proto.render = function render() {
    var props = this.props;
    var showingPassword = this.state.showingPassword;
    return /*#__PURE__*/React.createElement(Content$F, null, /*#__PURE__*/React.createElement(TextInput$1, _extends({
      id: "password-input",
      type: !showingPassword ? 'password' : 'text',
      state: props.hasError ? 'error' : null,
      stateMessage: props.errorMsg,
      iconRight: /*#__PURE__*/React.createElement(ShowPasswordPlacement, {
        onPress: this.handleClick
      }, /*#__PURE__*/React.createElement(showPassword, {
        enabled: showingPassword
      })),
      link: /*#__PURE__*/React.createElement(InputLink, {
        onMouseDown: props.onClickLink
      }, props.linkText),
      marginBottom: "--spacing-2"
    }, props)));
  };

  return DsPasswordInput;
}(React.Component);

DsPasswordInput.defaultProps = {
  hasError: false,
  visiblePassword: false
};
DsPasswordInput.propTypes = {
  onChange: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  hasError: PropTypes__default.bool,
  value: PropTypes__default.string,
  visiblePassword: PropTypes__default.bool,
  onClickLink: PropTypes__default.func,
  errorMsg: PropTypes__default.string,
  linkText: PropTypes__default.string
};

var CapsLockIcon = function CapsLockIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "11",
    height: "16",
    viewBox: "0 0 11 16"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-834.000000, -566.000000)",
    stroke: "#10CE64"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(817.000000, 558.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7509677,5.63298249 L5.2928427,0.445732493 C5.1489677,0.229732493 4.9307177,0.0798574928 4.6784677,0.0238574928 C4.2707177,-0.0651425072 3.8577177,0.0991074928 3.6265927,0.445732493 L0.168467704,5.63298249 C-0.036782296,5.94048249 -0.055782296,6.33435749 0.118592704,6.66060749 C0.293217704,6.98698249 0.631592704,7.18948249 1.0015927,7.18948249 L2.4548427,7.18948249 L2.4548427,10.4999825 C2.4548427,10.9134825 2.7913427,11.2499825 3.2048427,11.2499825 L5.7144677,11.2499825 C6.1279677,11.2499825 6.4644677,10.9134825 6.4644677,10.4999825 L6.4644677,7.18960749 L7.9178427,7.18960749 C8.2877177,7.18960749 8.6260927,6.98698249 8.8007177,6.66073249 C8.9752177,6.33435749 8.9562177,5.94048249 8.7509677,5.63298249 Z",
    id: "Shape",
    strokeWidth: "1.1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: "1.5",
    x: "2.85",
    y: "14.25",
    width: "3.225",
    height: "1",
    rx: "0.5"
  }))))));
};

var _templateObject$1B, _templateObject2$19, _templateObject3$N, _templateObject4$z, _templateObject5$t;
var Wrapper$6 = styled(View$1)(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: absolute;\n  margin-left: 10px;\n  align-items: center;\n  justify-content: center;\n"])));
var IconWrapper$5 = styled(View$1)(_templateObject2$19 || (_templateObject2$19 = _taggedTemplateLiteralLoose(["\n  margin-left: 6px;\n  margin-right: 8px;\n"])));
var TooltipBody = styled(View$1)(_templateObject3$N || (_templateObject3$N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  padding: 6px;\n  height: 32px;\n  width: 40px;\n  border: 1px solid #f9f9f9;\n  border-radius: 8px;\n  background-color: #ffffff;\n  box-sizing: border-box;\n  box-shadow: 0 4px 5px 1px rgba(0, 0, 0, 0.1);\n  &::after {\n    z-index: -10;\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: 0;\n    bottom: 0;\n    top: calc(50% - 6px);\n    left: 0;\n    border: 4px solid #ffffff;\n    transform-origin: 0 0;\n    transform: rotate(45deg);\n    box-shadow: 0 4px 3px -2px rgba(0, 0, 0, 0.1);\n  }\n  &::before {\n    z-index: 10;\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: 0;\n    bottom: 0;\n    top: calc(50% - 6px);\n    left: 0;\n    border: 4px solid #ffffff;\n    transform-origin: 0 0;\n    transform: rotate(45deg);\n    box-shadow: 0 4px 3px -2px rgba(0, 0, 0, 0.1);\n  }\n  :hover {\n    display: flex;\n    width: auto;\n  }\n"])));
var Message = styled(Text$1)(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  color: #999999;\n  flex-direction: row;\n"])));
var Highlight = styled(Message)(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  color: #4a4a4a;\n"])));

var CapsLockTooltip = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CapsLockTooltip, _React$Component);

  function CapsLockTooltip(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.renderMessage = function (message, highlight) {
      if (message.indexOf(highlight) === -1) {
        return /*#__PURE__*/React.createElement(Message, null, message);
      }

      return /*#__PURE__*/React.createElement(Message, null, message.split(highlight).reduce(function (prev, current, i) {
        if (!i) {
          return [current];
        }

        return prev.concat( /*#__PURE__*/React.createElement(Highlight, {
          key: highlight + current
        }, highlight), current);
      }, []));
    };

    _this.state = {
      hovering: false
    };
    _this.toggleHover = _this.toggleHover.bind(_assertThisInitialized(_this));
    _this.onMouseEnter = _this.onMouseEnter.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = CapsLockTooltip.prototype;

  _proto.onMouseEnter = function onMouseEnter() {
    var lurker = this.props.lurker;

    if (lurker && typeof lurker.viewMessageEvt === 'function') {
      lurker.viewMessageEvt('caps_lock_tooltip_opened');
    }

    this.toggleHover();
  };

  _proto.toggleHover = function toggleHover() {
    this.setState(function (prevState) {
      return {
        hovering: !prevState.hovering
      };
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        message = _this$props.message,
        highlight = _this$props.highlight;
    return /*#__PURE__*/React.createElement(Wrapper$6, null, /*#__PURE__*/React.createElement(TooltipBody, {
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.toggleHover
    }, /*#__PURE__*/React.createElement(IconWrapper$5, null, /*#__PURE__*/React.createElement(CapsLockIcon, null)), this.state.hovering && this.renderMessage(message, highlight)));
  };

  return CapsLockTooltip;
}(React.Component);

CapsLockTooltip.propTypes = {
  message: PropTypes__default.string.isRequired,
  highlight: PropTypes__default.string,
  lurker: PropTypes__default.object
};

var _excluded$a = ["error"];

var _templateObject$1C, _templateObject2$1a, _templateObject3$O, _templateObject4$A, _templateObject5$u, _templateObject6$k;
var FormContent$1 = styled(View)(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var PageForm$1 = styled(Form)(_templateObject2$1a || (_templateObject2$1a = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var Content$G = styled(View)(_templateObject3$O || (_templateObject3$O = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n"])));
var HRuleWrapper$7 = styled(View)(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var FooterWrapper$1 = styled(View)(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var PasswordInputWrapper = styled(View)(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"])));

var PasswordLoginTemplate = function PasswordLoginTemplate(_ref) {
  var abTests = _ref.abTests,
      facebookAppId = _ref.facebookAppId,
      onMagicLinkClick = _ref.onMagicLinkClick,
      onRequireEmail = _ref.onRequireEmail,
      onSubmit = _ref.onSubmit,
      onRegisterClick = _ref.onRegisterClick,
      onHelpLinkClick = _ref.onHelpLinkClick,
      onForgotPassword = _ref.onForgotPassword,
      onReactivationLinkClick = _ref.onReactivationLinkClick,
      onHelpLinkClose = _ref.onHelpLinkClose,
      onBackClick = _ref.onBackClick,
      onOauthCancel = _ref.onOauthCancel,
      onOauthError = _ref.onOauthError,
      onOauthSubmit = _ref.onOauthSubmit,
      onOauthSuccess = _ref.onOauthSuccess,
      isSubmitting = _ref.isSubmitting,
      showHelpingModalLink = _ref.showHelpingModalLink,
      shouldDisableSubmit = _ref.shouldDisableSubmit,
      inputWrapper = _ref.inputWrapper,
      errorMsg = _ref.errorMsg,
      captchaChallenge = _ref.captchaChallenge,
      lurker = _ref.lurker,
      tracker = _ref.tracker;

  var _useState = useState(false),
      showHelpModal = _useState[0],
      setShowHelpModal = _useState[1];

  var _useState2 = useState(false),
      showCapsOnTooltip = _useState2[0],
      setShowCapsOnTooltip = _useState2[1];

  var _useState3 = useState(false),
      isCapsOn = _useState3[0],
      setIsCapsOn = _useState3[1];

  var bottomBorderRadius = showHelpingModalLink ? 0 : 4;

  var addKeyboardListeners = function addKeyboardListeners() {
    document.addEventListener('keydown', onKeyPress);
    document.addEventListener('keyup', onKeyPress);
  };

  var removeKeyboardListeners = function removeKeyboardListeners() {
    document.removeEventListener('keydown', onKeyPress);
    document.removeEventListener('keyup', onKeyPress);
  };

  var onPasswordKeyPress = function onPasswordKeyPress(event) {
    var isCapsOn = event.getModifierState && event.getModifierState('CapsLock');
    setIsCapsOn(isCapsOn);
    setShowCapsOnTooltip(isCapsOn);
  };

  var onKeyPress = function onKeyPress(event) {
    var isCapsOn = event.getModifierState && event.getModifierState('CapsLock');
    setIsCapsOn(isCapsOn);
  };

  useEffect(function () {
    addKeyboardListeners();
    return function () {
      removeKeyboardListeners();
    };
  }, []);
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$G, null, /*#__PURE__*/React.createElement(Paper, {
    borderBottomLeftRadius: bottomBorderRadius,
    borderBottomRightRadius: bottomBorderRadius
  }, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Acesse a sua conta"
  }), /*#__PURE__*/React.createElement(FormContent$1, null, errorMsg, /*#__PURE__*/React.createElement(PageForm$1, {
    method: "POST",
    onSubmit: onSubmit,
    noValidate: true
  }, /*#__PURE__*/React.createElement(PasswordInputWrapper, null, inputWrapper(function (_ref2) {
    var field = _ref2.field,
        _ref2$fieldState = _ref2.fieldState,
        error = _ref2$fieldState.error,
        restFields = _objectWithoutPropertiesLoose(_ref2$fieldState, _excluded$a),
        ref = _ref2.ref;

    return /*#__PURE__*/React.createElement(DsPasswordInput, _extends({
      key: "password",
      label: "Senha",
      "aria-label": "Senha",
      errorMsg: 'Campo obrigatório. Informe sua senha.',
      onKeyUp: onPasswordKeyPress,
      onKeyDown: onPasswordKeyPress,
      disabled: isSubmitting,
      linkText: "Esqueceu sua senha?",
      onClickLink: onForgotPassword,
      maxLength: 40
    }, field, restFields, {
      hasError: !!error,
      ref: ref
    }));
  }), isCapsOn && showCapsOnTooltip && /*#__PURE__*/React.createElement(CapsLockTooltip, {
    message: "caps lock ativado",
    highlight: "ativado",
    lurker: lurker
  })), captchaChallenge || null, /*#__PURE__*/React.createElement(Flex, {
    marginTop: "--spacing-2",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isSubmitting,
    onClick: onBackClick,
    variant: "link-button",
    type: "button"
  }, "Voltar"), /*#__PURE__*/React.createElement(Button, {
    disabled: shouldDisableSubmit,
    isLoading: isSubmitting,
    onClick: onSubmit
  }, "Entrar"))), /*#__PURE__*/React.createElement(OauthLoginCallout, {
    facebookAppId: facebookAppId,
    onCancel: onOauthCancel,
    onError: onOauthError,
    onRequireEmail: onRequireEmail,
    onSubmit: onOauthSubmit,
    onUserLoggedIn: onOauthSuccess,
    lurker: lurker,
    tracker: tracker,
    abTests: abTests
  })), /*#__PURE__*/React.createElement(HRuleWrapper$7, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
    text: "N\xE3o tem uma conta?",
    linkText: "Cadastre-se",
    href: "/cadastro",
    onClick: onRegisterClick
  })), showHelpingModalLink && /*#__PURE__*/React.createElement(HelpFooter, {
    onClick: function onClick() {
      setShowHelpModal(true);
      onHelpLinkClick();
    }
  }), /*#__PURE__*/React.createElement(FooterWrapper$1, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))), /*#__PURE__*/React.createElement(HelpModalTemplate, {
    abTests: abTests,
    open: showHelpModal,
    onForgotPasswordLinkClick: onForgotPassword,
    onReactivationLinkClick: onReactivationLinkClick,
    onMagicLinkClick: onMagicLinkClick,
    onClose: function onClose() {
      setShowHelpModal(false);
      onHelpLinkClose();
    }
  }));
};

PasswordLoginTemplate.propTypes = {
  abTests: PropTypes__default.string,
  facebookAppId: PropTypes__default.string,
  onMagicLinkClick: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onHelpLinkClick: PropTypes__default.func,
  onOauthCancel: PropTypes__default.func,
  onOauthError: PropTypes__default.func,
  onOauthSubmit: PropTypes__default.func,
  onOauthSuccess: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onBackClick: PropTypes__default.func,
  onHelpLinkClose: PropTypes__default.func,
  showReactivationLink: PropTypes__default.bool,
  isSubmitting: PropTypes__default.bool,
  showHelpingModalLink: PropTypes__default.bool,
  shouldDisableSubmit: PropTypes__default.bool,
  errorMsg: PropTypes__default.element,
  captchaChallenge: PropTypes__default.element,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object
};

var _templateObject$1D, _templateObject2$1b, _templateObject3$P;
var lurker$e = new Lurker('login');
var tracker$1 = new Tracker('login');
var ErrorMsgWrapper$2 = styled(View)(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var InstabilityBox$1 = styled(GenericWarningBox)(_templateObject2$1b || (_templateObject2$1b = _taggedTemplateLiteralLoose(["\n  border-style: none;\n  border-radius: 8px;\n  margin: 15px 0px 10px 0px;\n  padding: 16px 24px;\n  background: #fff7e0;\n"])));
var InstabilityBoxFade$1 = styled(View)(_templateObject3$P || (_templateObject3$P = _taggedTemplateLiteralLoose(["\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  div {\n    animation-name: fadeIn;\n    animation-duration: 1s;\n  }\n"])));
var apiErrors$1 = {
  Unauthorized: 'showUnauthorizedError',
  Inactive: 'showInactiveError',
  Generic: 'showGenericError',
  RateLimit: 'showRateLimitError',
  AccountNotFound: 'showAccountNotFoundError',
  GoogleInitialization: 'showGoogleInitializationError',
  ExpiredToken: 'showExpiredTokenError',
  RedScore: 'showRedScoreError',
  AccountLocked: 'showAccountLockedError',
  AccountDisabledByFraud: 'showAccountDisabledByFraudError',
  Instability: 'showInstabilityError',
  NoNetwork: 'showNetworkError',
  MaxPasswordAttempts: 'showPasswordlessError',
  PasswordMismatch: 'showPasswordMismatchError'
};
var MAX_PASSWORD_ATTEMPTS = 3;
var SplitLoginPasswordPage = function SplitLoginPasswordPage(_ref) {
  var facebookAppId = _ref.facebookAppId,
      onChallengePinCodeCall = _ref.onChallengePinCodeCall,
      onError = _ref.onError,
      onForgotPassword = _ref.onForgotPassword,
      onLoginSuccess = _ref.onLoginSuccess,
      onMagicLinkClick = _ref.onMagicLinkClick,
      onMaxPasswordAttemptsReached = _ref.onMaxPasswordAttemptsReached,
      onSubmit = _ref.onSubmit,
      onReactivationLinkClick = _ref.onReactivationLinkClick,
      onRegisterClick = _ref.onRegisterClick,
      onPhoneNotValidatedError = _ref.onPhoneNotValidatedError,
      onRequireEmail = _ref.onRequireEmail,
      onBackClick = _ref.onBackClick,
      showHelpingModalLink = _ref.showHelpingModalLink,
      passwordlessSignIn = _ref.passwordlessSignIn,
      _ref$abTests = _ref.abTests,
      abTests = _ref$abTests === void 0 ? '' : _ref$abTests;

  var _useState = useState(''),
      currentError = _useState[0],
      setCurrentError = _useState[1];

  var _useState2 = useState(0),
      passwordAttempts = _useState2[0],
      setPasswordAttempts = _useState2[1];

  var _useState3 = useState(false),
      isSubmitting = _useState3[0],
      setIsSubmitting = _useState3[1];

  var _useState4 = useState(false),
      turnstileReady = _useState4[0],
      setTurnstileReady = _useState4[1];

  var _useForm = useForm({
    defaultValues: {
      password: '',
      turnstileToken: ''
    },
    mode: 'onSubmit',
    reValidateMode: 'onChange'
  }),
      control = _useForm.control,
      errors = _useForm.formState.errors,
      setValue = _useForm.setValue,
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit;

  var onPasswordSubmit = function onPasswordSubmit(_ref2) {
    var password = _ref2.password,
        turnstileToken = _ref2.turnstileToken;
    lurker$e.clickEvt('password');
    setIsSubmitting(true);
    onSubmit(password, turnstileToken).then(function (data) {
      var method = 'email_and_password';
      lurker$e.viewMessageEvt('email_login_success', {
        accounts_method: method,
        remote_addr: data.remoteAddress
      });
    })["catch"](onPasswordLoginError)["finally"](function () {
      return setIsSubmitting(false);
    });
  };

  var onOauthSuccess = function onOauthSuccess(data) {
    if (onLoginSuccess) {
      onLoginSuccess(data);
    }

    setIsSubmitting(false);
  };

  var onOauthError = function onOauthError(error) {
    if (onError) {
      onError(error);
    }

    var errorBox = apiErrors$1.Generic;

    if (error === 'google_initialization_error') {
      errorBox = apiErrors$1.GoogleInitialization;
    }

    showError(errorBox);
    setIsSubmitting(false);
  };

  var onOauthCancel = function onOauthCancel() {
    setIsSubmitting(false);
  };

  var onOauthSubmit = function onOauthSubmit() {
    setIsSubmitting(true);
  };

  var showError = function showError(error) {
    setCurrentError(error);
  };

  var getErrorAlertbox = function getErrorAlertbox(error) {
    var _errorMessages;

    var errorMessages = (_errorMessages = {}, _errorMessages[apiErrors$1.Instability] = /*#__PURE__*/React.createElement(InstabilityBoxFade$1, null, /*#__PURE__*/React.createElement(InstabilityBox$1, null, /*#__PURE__*/React.createElement(Text.BodyMedium, {
      color: "--color-feedback-attention-110"
    }, "Podemos apresentar instabilidades no login neste momento. J\xE1 estamos trabalhando para resolv\xEA-las!"))), _errorMessages[apiErrors$1.Generic] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$2, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel acessar sua conta. Por favor, tente novamente."
    })), _errorMessages[apiErrors$1.GoogleInitialization] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$2, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showGoogleInitializationError: true,
      text: "N\xE3o foi poss\xEDvel entrar com o Google."
    })), _errorMessages[apiErrors$1.PasswordMismatch] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$2, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showPasswordMismatchError: true,
      errorAction: onForgotPassword,
      text: "Sua senha est\xE1 incorreta."
    })), _errorMessages[apiErrors$1.NoNetwork] = /*#__PURE__*/React.createElement(ErrorMsgWrapper$2, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "N\xE3o foi poss\xEDvel acessar sua conta.",
      info: "Por favor, verifique sua conex\xE3o com a internet e tente novamente."
    })), _errorMessages);
    return errorMessages[error] || errorMessages[apiErrors$1.Generic];
  };

  var onUnauthorizedError = function onUnauthorizedError(response, isSmartLock) {
    var prefix = isSmartLock ? 'smart_lock_' : '';

    var _ref3 = response.data || {},
        _ref3$message = _ref3.message,
        message = _ref3$message === void 0 ? 'UNAUTHORIZED' : _ref3$message;

    lurker$e.viewMessageEvt('error', {
      accounts_reason: "" + prefix + message.toLowerCase(),
      accounts_status_code: response.status
    });
    var unauthorizedActions = {
      PIN_CODE: function PIN_CODE() {
        if (typeof onChallengePinCodeCall === 'function') {
          onChallengePinCodeCall(response.data);
        }
      },
      ACCOUNT_NOT_FOUND: function ACCOUNT_NOT_FOUND() {
        setCurrentError(apiErrors$1.AccountNotFound);
      },
      PASSWORD_MISMATCH: onPasswordMismatchError,
      PHONE_NOT_VALIDATED: function PHONE_NOT_VALIDATED() {
        if (typeof onPhoneNotValidatedError === 'function') {
          onPhoneNotValidatedError(response.data.token);
        }
      },
      "default": function _default() {
        setCurrentError(apiErrors$1.Unauthorized);
      }
    };
    unauthorizedActions[message] ? unauthorizedActions[message]() : unauthorizedActions["default"]();
  };

  var onPasswordMismatchError = function onPasswordMismatchError() {
    if (passwordAttempts >= MAX_PASSWORD_ATTEMPTS) {
      onMaxPasswordAttemptsReached().then(function () {
        setCurrentError(apiErrors$1.MaxPasswordAttempts);
      })["catch"](function () {
        return setCurrentError(apiErrors$1.PasswordMismatch);
      });
    } else {
      setCurrentError(apiErrors$1.PasswordMismatch);

      if (passwordlessSignIn) {
        setPasswordAttempts(function (passwordAttempts) {
          return passwordAttempts + 1;
        });
      }
    }
  };

  var handleUnexpectedError = function handleUnexpectedError(error, prefix) {
    var _error$response;

    if (error.message.includes('timeout')) {
      setCurrentError(apiErrors$1.NoNetwork);
    }

    if (error !== null && error !== void 0 && (_error$response = error.response) !== null && _error$response !== void 0 && _error$response.status) {
      lurker$e.viewMessageEvt('error', {
        accounts_reason: prefix + "unexpected_status_code",
        accounts_status_code: error === null || error === void 0 ? void 0 : error.response.status
      });
      setCurrentError(apiErrors$1.Generic);
    } else {
      lurker$e.viewMessageEvt('error', {
        accounts_reason: prefix + "unexpected_error",
        accounts_error_message: (error === null || error === void 0 ? void 0 : error.message) || 'unknown'
      });
      setCurrentError(apiErrors$1.Generic);
    }
  };

  var onApiError = function onApiError(error, isSmartLock) {
    var _errorActions, _error2;

    if (error === void 0) {
      error = {};
    }

    var _error = error,
        _error$response2 = _error.response,
        response = _error$response2 === void 0 ? {} : _error$response2;
    var prefix = isSmartLock ? 'smart_lock_' : '';
    var errorActions = (_errorActions = {
      'Network Error': function NetworkError() {
        lurker$e.viewMessageEvt('login_timeout');
        setCurrentError(apiErrors$1.NoNetwork);
      }
    }, _errorActions[httpStatus.UNAUTHORIZED] = function () {
      onUnauthorizedError(response, isSmartLock);
    }, _errorActions[httpStatus.LOCKED] = function () {
      lurker$e.viewMessageEvt('error', {
        accounts_reason: prefix + "account_locked",
        accounts_status_code: response.status
      });
      setCurrentError(apiErrors$1.AccountLocked);
    }, _errorActions[httpStatus.TOO_MANY_REQUESTS] = function () {
      lurker$e.viewMessageEvt('error', {
        accounts_reason: prefix + "rate_limit_exceeded",
        accounts_status_code: response.status
      });
      setCurrentError(apiErrors$1.RateLimit);
    }, _errorActions[httpStatus.GONE] = function () {
      lurker$e.viewMessageEvt('error', {
        accounts_reason: prefix + "account_inactive",
        accounts_status_code: response.status
      });
      setCurrentError(apiErrors$1.Inactive);
    }, _errorActions[httpStatus.FORBIDDEN] = function () {
      var _ref4 = response.data || {},
          _ref4$message = _ref4.message,
          message = _ref4$message === void 0 ? 'TURNSTILE_INVALID_TOKEN' : _ref4$message;

      switch (message) {
        case 'ACCOUNT_DISABLED':
          lurker$e.viewMessageEvt('error', {
            accounts_reason: "" + prefix + message.toLowerCase(),
            accounts_status_code: response.status
          });
          setCurrentError(apiErrors$1.AccountDisabledByFraud);
          break;

        default:
          lurker$e.viewMessageEvt('error', {
            accounts_reason: "" + prefix + message.toLowerCase(),
            accounts_status_code: response.status
          });
          setCurrentError(apiErrors$1.Generic);
      }
    }, _errorActions[httpStatus.BAD_REQUEST] = function () {
      if (response.data && response.data.trim() === 'Missing turnstile token') {
        lurker$e.viewMessageEvt('error', {
          accounts_reason: prefix + "turnstile_missing_token",
          accounts_status_code: response.status
        });
        setCurrentError(apiErrors$1.Generic);
      }
    }, _errorActions["default"] = function _default() {
      handleUnexpectedError(response);
    }, _errorActions);
    var action = errorActions[response.status] || errorActions[(_error2 = error) === null || _error2 === void 0 ? void 0 : _error2.message] || errorActions["default"];
    return action();
  };

  var onPasswordLoginError = function onPasswordLoginError(error, isSmartLock) {
    var _window, _window$turnstile;

    if (error === void 0) {
      error = {};
    }

    if (onError) {
      onError();
    }

    (_window = window) === null || _window === void 0 ? void 0 : (_window$turnstile = _window.turnstile) === null || _window$turnstile === void 0 ? void 0 : _window$turnstile.reset();
    onApiError(error, isSmartLock);
    behaviors.scrollToTop();
  };

  var onTurnstileVerify = function onTurnstileVerify(turnstileToken) {
    setTurnstileReady(true);
    setValue('turnstileToken', turnstileToken, {
      shouldValidate: true
    });
  };

  var shouldDisableSubmit = function shouldDisableSubmit() {
    return isSubmitting || !turnstileReady;
  };

  var onHelpLinkClick = function onHelpLinkClick() {
    lurker$e.clickEvt('help_modal_open');
  };

  var onHelpLinkClose = function onHelpLinkClose() {
    lurker$e.clickEvt('help_modal_close');
  };

  useEffect(function () {
    lurker$e.pageLoadEvt();
    tracker$1.pageLoadEvt();
  }, []);
  return /*#__PURE__*/React.createElement(PasswordLoginTemplate, {
    abTests: abTests,
    facebookAppId: facebookAppId,
    onRequireEmail: onRequireEmail,
    onMagicLinkClick: onMagicLinkClick,
    onSubmit: handleSubmit(onPasswordSubmit),
    onRegisterClick: onRegisterClick,
    onHelpLinkClick: onHelpLinkClick,
    onForgotPassword: onForgotPassword,
    onReactivationLinkClick: onReactivationLinkClick,
    onHelpLinkClose: onHelpLinkClose,
    onBackClick: onBackClick,
    onOauthCancel: onOauthCancel,
    onOauthError: onOauthError,
    onOauthSubmit: onOauthSubmit,
    onOauthSuccess: onOauthSuccess,
    isSubmitting: isSubmitting,
    shouldDisableSubmit: shouldDisableSubmit(),
    showHelpingModalLink: showHelpingModalLink,
    errorMsg: currentError ? getErrorAlertbox(currentError) : null,
    lurker: lurker$e,
    tracker: tracker$1,
    captchaChallenge: /*#__PURE__*/React.createElement(Turnstile, _extends({}, register('turnstileToken', {
      required: true
    }), {
      onVerify: onTurnstileVerify,
      hasError: !!errors.turnstileToken
    })),
    inputWrapper: function inputWrapper(renderComponent) {
      return /*#__PURE__*/React.createElement(Controller, {
        control: control,
        name: "password",
        rules: {
          required: 'Campo obrigatório. Informe sua senha.'
        },
        render: renderComponent
      });
    }
  });
};
SplitLoginPasswordPage.propTypes = {
  abTests: PropTypes__default.string,
  emailStorage: PropTypes__default.bool,
  facebookAppId: PropTypes__default.string.isRequired,
  onChallengePinCodeCall: PropTypes__default.func,
  onError: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onLoginSuccess: PropTypes__default.func,
  onMagicLinkEmailSentClick: PropTypes__default.func,
  onMagicLinkClick: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onBackClick: PropTypes__default.func,
  onPhoneNotValidatedError: PropTypes__default.func,
  onMaxPasswordAttemptsReached: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  showReactivationLink: PropTypes__default.bool,
  showHelpingModalLink: PropTypes__default.bool,
  passwordlessSignIn: PropTypes__default.bool,
  smartLockLogin: PropTypes__default.bool
};

var PAGES = {
  EMAIL_PAGE: 'EmailPage',
  PASSWORD_PAGE: 'PasswordPage'
};

var getInitialPage = function getInitialPage() {
  return PAGES.EMAIL_PAGE;
};

var SplitLoginPage = function SplitLoginPage(_ref) {
  var facebookAppId = _ref.facebookAppId,
      onChallengePinCodeCall = _ref.onChallengePinCodeCall,
      onError = _ref.onError,
      onForgotPassword = _ref.onForgotPassword,
      onLoginSuccess = _ref.onLoginSuccess,
      onMagicLinkClick = _ref.onMagicLinkClick,
      onMagicLinkEmailSentClick = _ref.onMagicLinkEmailSentClick,
      onReactivationLinkClick = _ref.onReactivationLinkClick,
      onRegisterClick = _ref.onRegisterClick,
      onPhoneNotValidated = _ref.onPhoneNotValidated,
      onRequireEmail = _ref.onRequireEmail,
      passwordlessSignIn = _ref.passwordlessSignIn,
      showReactivationLink = _ref.showReactivationLink,
      showHelpingModalLink = _ref.showHelpingModalLink,
      smartLockLogin = _ref.smartLockLogin,
      _ref$abTests = _ref.abTests,
      abTests = _ref$abTests === void 0 ? '' : _ref$abTests;

  var _React$useState = React.useState(''),
      email = _React$useState[0],
      setEmail = _React$useState[1];

  var _React$useState2 = React.useState(false),
      isLoading = _React$useState2[0],
      setIsLoading = _React$useState2[1];

  var _React$useState3 = React.useState(getInitialPage()),
      currentPage = _React$useState3[0],
      setCurrentPage = _React$useState3[1];

  var onEmailPageSubmit = function onEmailPageSubmit(email) {
    setEmail(email);
    setCurrentPage(PAGES.PASSWORD_PAGE);
  };

  var onPasswordSubmit = function onPasswordSubmit(password, turnstileToken) {
    var loginApiCaller = loginWithTurnstilev2(email, password, turnstileToken);
    return loginApiCaller.then(function (data) {
      onLoginSuccess(data);
      return data;
    });
  };

  var onMaxPasswordAttemptsReached = function onMaxPasswordAttemptsReached() {
    return passwordlessSendEmailApiCall(email);
  };

  var getBackToEmailPage = function getBackToEmailPage() {
    setIsLoading(true);
    setCurrentPage(PAGES.EMAIL_PAGE);
    setIsLoading(false);
  };

  return isLoading ? /*#__PURE__*/React.createElement(LoadingBackdrop$1, null) : currentPage === PAGES.EMAIL_PAGE ? /*#__PURE__*/React.createElement(SplitLoginEmailPage, {
    facebookAppId: facebookAppId,
    onChallengePinCodeCall: onChallengePinCodeCall,
    onError: onError,
    onForgotPassword: onForgotPassword,
    onLoginSuccess: onLoginSuccess,
    onMagicLinkClick: onMagicLinkClick,
    onMagicLinkEmailSentClick: onMagicLinkEmailSentClick,
    onReactivationLinkClick: onReactivationLinkClick,
    onRegisterClick: onRegisterClick,
    onRequireEmail: onRequireEmail,
    onSubmit: onEmailPageSubmit,
    showReactivationLink: showReactivationLink,
    showHelpingModalLink: showHelpingModalLink,
    smartLockLogin: smartLockLogin,
    abTests: abTests
  }) : /*#__PURE__*/React.createElement(SplitLoginPasswordPage, {
    passwordlessSignIn: passwordlessSignIn,
    onBackClick: getBackToEmailPage,
    facebookAppId: facebookAppId,
    onChallengePinCodeCall: onChallengePinCodeCall,
    onError: onError,
    onForgotPassword: onForgotPassword,
    onLoginSuccess: onLoginSuccess,
    onMagicLinkClick: onMagicLinkClick,
    onSubmit: onPasswordSubmit,
    onReactivationLinkClick: onReactivationLinkClick,
    onRegisterClick: onRegisterClick,
    onRequireEmail: onRequireEmail,
    onMaxPasswordAttemptsReached: onMaxPasswordAttemptsReached,
    showHelpingModalLink: showHelpingModalLink,
    onPhoneNotValidatedError: onPhoneNotValidated,
    abTests: abTests
  });
};

SplitLoginPage.propTypes = {
  abTests: PropTypes__default.string,
  emailStorage: PropTypes__default.bool,
  facebookAppId: PropTypes__default.string.isRequired,
  onChallengePinCodeCall: PropTypes__default.func,
  onError: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onLoginSuccess: PropTypes__default.func,
  onMagicLinkClick: PropTypes__default.func,
  onMagicLinkEmailSentClick: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onPhoneNotValidated: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  passwordlessSignIn: PropTypes__default.bool,
  showReactivationLink: PropTypes__default.bool,
  showHelpingModalLink: PropTypes__default.bool,
  smartLockLogin: PropTypes__default.bool
};

var _templateObject$1E;
var CrossWrapper = styled(View$1)(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-radius: 31px;\n  width: 31px;\n  height: 31px;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  :hover {\n    background-color: #e5e5e5;\n    transition: background-color 0.1s ease-in;\n  }\n"])));

var _templateObject$1F, _templateObject2$1c, _templateObject3$Q;
var Container$5 = styled(View$1)(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteralLoose(["\n  border-radius: 24px;\n  border: solid 0.5px #d2d2d2;\n  padding: 4px 4px 4px 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var Caption$1 = styled(Text$1)(_templateObject2$1c || (_templateObject2$1c = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  color: #4a4a4a;\n  flex: 1;\n  margin-right: 8px;\n  margin-top: 3px;\n  margin-bottom: 3px;\n"])));
var Link$1 = styled(link)(_templateObject3$Q || (_templateObject3$Q = _taggedTemplateLiteralLoose(["\n  font-size: 0;\n  text-decoration: none;\n"])));

var EmailChip = function EmailChip(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      children = _ref.children,
      size = _ref.size;

  if (href || onClick) {
    return /*#__PURE__*/React.createElement(Link$1, {
      href: href,
      onClick: onClick
    }, /*#__PURE__*/React.createElement(Container$5, null, /*#__PURE__*/React.createElement(Caption$1, {
      size: size
    }, children), /*#__PURE__*/React.createElement(CrossWrapper, null, /*#__PURE__*/React.createElement(Cross, {
      href: href,
      onClick: onClick
    }))));
  }

  return /*#__PURE__*/React.createElement(Container$5, null, /*#__PURE__*/React.createElement(Caption$1, {
    size: size
  }, children));
};

EmailChip.defaultProps = {
  size: 'body1'
};
EmailChip.propTypes = {
  href: PropTypes__default.string,
  onClick: PropTypes__default.func,
  children: PropTypes__default.node,
  size: PropTypes__default.string
};

var _templateObject$1G, _templateObject2$1d, _templateObject3$R, _templateObject4$B;
var Content$H = styled(View$1)(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var SubtitleWrapper$1 = styled(Subtitle)(_templateObject2$1d || (_templateObject2$1d = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-bottom: 16px;\n"])));
var PageForm$2 = styled(Form)(_templateObject3$R || (_templateObject3$R = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var EmailChipWrapper = styled(View$1)(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n  margin-bottom: 32px;\n"])));
var defaultEmailErrorMsg = 'Por favor, insira um endereço de e-mail válido.';

var getErrorMessage = function getErrorMessage(email) {
  if (email) {
    return defaultEmailErrorMsg;
  }

  return 'Este campo é obrigatório';
};

var EmailFormBaseTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(EmailFormBaseTemplate, _BaseForm);

  function EmailFormBaseTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.onEmailChange = function (event) {
      var value = event.target.value;

      _this.onFieldChange(event, 'email', isValidEmail, getErrorMessage(value), true);
    };

    _this.onEmailBlur = function (event) {
      var value = event.target.value;

      _this.onFieldChange(event, 'email', isValidEmail, getErrorMessage(value), false);
    };

    _this.onMailCheckSuggestionClick = function (suggestion) {
      var lurker = _this.props.lurker;

      if (typeof lurker === 'object') {
        lurker.viewMessageEvt('mailcheck_suggestion_accepted', {
          mailcheck_original: _this.state.fields.email.value,
          mailcheck_suggestion: suggestion
        });
      }

      var valid = isValidEmail(suggestion);

      _this.updateField('email', suggestion, valid, true);
    };

    _this.handleSubmit = function (event) {
      var _this$props = _this.props,
          lurker = _this$props.lurker,
          onSubmit = _this$props.onSubmit,
          submitEventName = _this$props.submitEventName;
      var email = _this.state.fields.email.value;
      event.preventDefault();

      _this.setState({
        isSubmitting: true
      });

      lurker.clickEvt(submitEventName);

      _this.validateBeforeSend().then(function () {
        _this.checkFormIsValid().then(function () {
          onSubmit(email).then(function () {
            return _this.setState({
              isSubmitting: false
            });
          })["catch"](function () {
            _this.setState({
              isSubmitting: false
            });
          });
        })["catch"](function () {
          if (typeof lurker === 'object') {
            lurker.viewMessageEvt('error', _extends({
              accounts_reason: 'invalid_fields'
            }, _this.getInvalidFields()));
          }

          _this.setState({
            isSubmitting: false
          });
        });
      });
    };

    var _props$email = props.email,
        _email = _props$email === void 0 ? '' : _props$email,
        editable = props.editable;

    var _valid = false;

    if (!editable) {
      _valid = true;
    } else {
      _valid = _email ? isValidEmail(_email) : false;
    }

    _this.state = _extends({}, _this.state, {
      validators: {
        email: {
          action: editable ? isValidEmail : function () {
            return true;
          },
          message: getErrorMessage
        }
      },
      fields: {
        email: {
          value: _email,
          pristine: !_email,
          valid: _valid
        }
      }
    });
    return _this;
  }

  EmailFormBaseTemplate.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var fields = state.fields;
    var hasError = props.hasError,
        fieldError = props.fieldError;

    if (hasError) {
      return {
        fields: _extends({}, fields, {
          email: {
            value: fields.email.value,
            msg: fieldError || ' ',
            valid: false,
            pristine: false
          }
        })
      };
    }

    return null;
  };

  var _proto = EmailFormBaseTemplate.prototype;

  _proto.renderTitle = function renderTitle() {
    var renderTitle = this.props.renderTitle;

    if (typeof renderTitle === 'string') {
      return /*#__PURE__*/React.createElement(SubtitleWrapper$1, null, renderTitle);
    }

    return renderTitle();
  };

  _proto.renderEmail = function renderEmail() {
    var _this2 = this;

    var _this$props2 = this.props,
        editable = _this$props2.editable,
        onSwitchEmail = _this$props2.onSwitchEmail;
    var _this$state = this.state,
        fields = _this$state.fields,
        isSubmitting = _this$state.isSubmitting;
    var email = fields.email;
    var emailHasError = !email.valid && !email.pristine;

    if (!editable) {
      return /*#__PURE__*/React.createElement(EmailChipWrapper, null, /*#__PURE__*/React.createElement(EmailChip, {
        href: "#",
        onClick: onSwitchEmail
      }, email.value));
    }

    return /*#__PURE__*/React.createElement(DsMailCheckFormItem, {
      label: this.label ? this.label : 'E-mail',
      value: email.value,
      onChange: function onChange(event) {
        return _this2.onEmailChange(event);
      },
      onBlur: function onBlur(event) {
        return _this2.onEmailBlur(event);
      },
      error: email.msg,
      hasError: emailHasError,
      inputRef: function inputRef(x) {
        _this2.inputs.email = x;
      },
      disabled: isSubmitting,
      onSuggestionClick: this.onMailCheckSuggestionClick
    });
  };

  _proto.render = function render() {
    var isSubmitting = this.state.isSubmitting;
    var _this$props3 = this.props,
        renderError = _this$props3.renderError,
        buttonText = _this$props3.buttonText,
        errorPosition = _this$props3.errorPosition,
        isLocked = _this$props3.isLocked;
    return /*#__PURE__*/React.createElement(Content$H, null, errorPosition === 'top' ? renderError() : this.renderTitle(), errorPosition === 'top' ? this.renderTitle() : renderError(), /*#__PURE__*/React.createElement(PageForm$2, {
      method: "POST",
      onSubmit: this.handleSubmit,
      noValidate: true
    }, this.renderEmail(), /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      disabled: isSubmitting || isLocked,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, buttonText)));
  };

  return EmailFormBaseTemplate;
}(BaseForm);

EmailFormBaseTemplate.defaultProps = {
  buttonText: 'Enviar',
  editable: true,
  isLocked: false,
  submitEventName: 'submit'
};
EmailFormBaseTemplate.propTypes = {
  buttonText: PropTypes__default.string,
  editable: PropTypes__default.bool,
  email: PropTypes__default.string,
  errorPosition: PropTypes__default.string,
  fieldError: PropTypes__default.string,
  hasError: PropTypes__default.bool,
  isLocked: PropTypes__default.bool,
  lurker: PropTypes__default.object,
  onSubmit: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func,
  renderError: PropTypes__default.func,
  renderTitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.func]),
  submitEventName: PropTypes__default.string
};

var _templateObject$1H, _templateObject2$1e, _templateObject3$S, _templateObject4$C, _templateObject5$v;
var lurker$f = new Lurker('login');
var ErrorMsgWrapper$3 = styled(View$1)(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0px;\n  margin-bottom: 16px;\n  margin-left: 0px;\n"])));
var Content$I = styled(View$1)(_templateObject2$1e || (_templateObject2$1e = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject3$S || (_templateObject3$S = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4px;\n    margin-bottom: 0;\n  "]))));
var HRuleWrapper$8 = styled(View$1)(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var FooterWrapper$2 = styled(View$1)(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var errors$1 = {
  showInactiveError: false,
  showInvalidEmailError: false,
  showGenericError: false,
  showRateLimitError: false,
  showAccountNotFoundError: false,
  showExpiredTokenError: false
};

var MagicLinkTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MagicLinkTemplate, _React$Component);

  function MagicLinkTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onLinkSent = function (email) {
      var onSuccess = _this.props.onSuccess;
      onSuccess(email);
    };

    _this.onApiCallError = function (error) {
      if (error === void 0) {
        error = {};
      }

      if (_this.props.onError) {
        _this.props.onError();
      }

      var _error = error,
          _error$response = _error.response,
          response = _error$response === void 0 ? {} : _error$response;
      var prefix = 'magiclink_';

      if (response.status === 401) {
        _this.onUnauthorizedError(response);
      } else if (response.status === 429) {
        lurker$f.viewMessageEvt('error', {
          accounts_reason: prefix + "rate_limit_exceeded",
          accounts_status_code: response.status
        });

        _this.showError('showRateLimitError');
      } else if (response.status === 410) {
        lurker$f.viewMessageEvt('error', {
          accounts_reason: prefix + "account_inactive",
          accounts_status_code: response.status
        });

        _this.showError('showInactiveError');
      } else if (response.status === 403) {
        lurker$f.viewMessageEvt('error', {
          accounts_reason: prefix + "recaptcha_invalid_token",
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status === 400) {
        if (response.data && response.data === 'Missing recaptcha response token') {
          lurker$f.viewMessageEvt('error', {
            accounts_reason: prefix + "recaptcha_missing_token",
            accounts_status_code: response.status
          });

          _this.showError('showGenericError');
        }
      } else if (response.status) {
        lurker$f.viewMessageEvt('error', {
          accounts_reason: prefix + "unexpected_status_code",
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else {
        lurker$f.viewMessageEvt('error', {
          accounts_reason: prefix + "unexpected_error",
          accounts_error_message: error && error.message || 'unknown'
        });

        _this.showError('showGenericError');
      }

      behaviors.scrollToTop();
    };

    _this.sendMagicLink = function (email) {
      return passwordlessSendEmailApiCall(email).then(function () {
        return _this.onLinkSent(email);
      })["catch"](function (e) {
        return _this.onApiCallError(e);
      });
    };

    _this.showError = function (error, extra) {
      var _extends2;

      _this.setState(_extends({}, errors$1, extra, (_extends2 = {}, _extends2[error] = true, _extends2)));
    };

    _this.renderError = function () {
      var onRegisterClick = _this.props.onRegisterClick;
      var _this$state = _this.state,
          showGenericError = _this$state.showGenericError,
          showInactiveError = _this$state.showInactiveError,
          showAccountNotFoundError = _this$state.showAccountNotFoundError,
          showExpiredTokenError = _this$state.showExpiredTokenError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$3, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel acessar sua conta. Por favor, tente novamente."
      })), showInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$3, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: true,
        contactUsLink: "https://ajuda.olx.com.br/s/article/reativar-conta-na-olx",
        text: "Este e-mail n\xE3o pode mais ser usado."
      })), showAccountNotFoundError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$3, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showAccountNotFoundError: true,
        errorAction: onRegisterClick,
        text: "N\xE3o existe uma conta com este e-mail."
      })), showExpiredTokenError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$3, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: false,
        text: "O link para acesso r\xE1pido expirou."
      })));
    };

    _this.state = _extends({}, errors$1);
    return _this;
  }

  var _proto = MagicLinkTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$f.pageLoadEvt('login_magiclink');
    this.checkTransientErrors();
  };

  _proto.checkTransientErrors = function checkTransientErrors() {
    var _this2 = this;

    transientErrorsStorage.get().then(function (error) {
      if (typeof error === 'string') {
        var _this2$setState;

        _this2.setState((_this2$setState = {}, _this2$setState[error] = true, _this2$setState));
      }
    });
  };

  _proto.render = function render() {
    var showInactiveError = this.state.showInactiveError;
    var onClickBackToLogin = this.props.onClickBackToLogin;
    return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$I, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(logoTitle, {
      title: "Entrar sem senha"
    }), /*#__PURE__*/React.createElement(EmailFormBaseTemplate, {
      buttonText: "Receber acesso por e-mail",
      hasError: showInactiveError,
      lurker: lurker$f,
      onSubmit: this.sendMagicLink,
      renderError: this.renderError,
      renderTitle: "Quer pular a parte da senha? Insira o seu e-mail e receba um acesso r\xE1pido.",
      submitEventName: "magiclink"
    }), /*#__PURE__*/React.createElement(HRuleWrapper$8, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
      linkText: "Escolher outra op\xE7\xE3o para entrar",
      href: "/cadastro",
      onClick: onClickBackToLogin
    })), /*#__PURE__*/React.createElement(FooterWrapper$2, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))));
  };

  return MagicLinkTemplate;
}(React.Component);

MagicLinkTemplate.propTypes = {
  onError: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onSuccess: PropTypes__default.func.isRequired,
  onClickBackToLogin: PropTypes__default.func
};

var MagicLinkPage = function MagicLinkPage(props) {
  var onClickBackToLogin = props.onClickBackToLogin,
      onSuccess = props.onSuccess,
      onError = props.onError;
  return /*#__PURE__*/React.createElement(MagicLinkTemplate, {
    onSuccess: onSuccess,
    onError: onError,
    onClickBackToLogin: onClickBackToLogin
  });
};
MagicLinkPage.propTypes = {
  onClickBackToLogin: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func
};

var _templateObject$1I;
var Wrapper$7 = styled.div(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n"])));

var PlaneIcon = function PlaneIcon(props) {
  return /*#__PURE__*/React.createElement(Wrapper$7, null, /*#__PURE__*/React.createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "step-3-v1---sem-senha",
    transform: "translate(-614.000000, -234.000000)",
    stroke: "#4A4A4A",
    strokeWidth: "1.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-sent",
    transform: "translate(615.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "50",
    y1: "0",
    x2: "22.3404255",
    y2: "27.6595745",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "50 0 32.5 50 22.5 27.5 0 17.5"
  }))))));
};

PlaneIcon.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
PlaneIcon.defaultProps = {
  width: 52,
  height: 52
};

var _templateObject$1J, _templateObject2$1f, _templateObject3$T, _templateObject4$D;
var Content$J = styled(View$1)(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var Description$8 = styled(Subtitle)(_templateObject2$1f || (_templateObject2$1f = _taggedTemplateLiteralLoose(["\n  margin-top: 19px;\n"])));
var DescriptionBottom = styled(Subtitle)(_templateObject3$T || (_templateObject3$T = _taggedTemplateLiteralLoose(["\n  margin-top: 23px;\n"])));
var Email = styled(Text$1)(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));

var MagicLinkEmailSentTemplate = function MagicLinkEmailSentTemplate(_ref) {
  var email = _ref.email;
  return /*#__PURE__*/React.createElement(Content$J, null, /*#__PURE__*/React.createElement(PlaneIcon, null), /*#__PURE__*/React.createElement(Description$8, null, "Enviamos um e-mail para"), /*#__PURE__*/React.createElement(Email, {
    fontWeight: 600
  }, email), /*#__PURE__*/React.createElement(DescriptionBottom, null, "Acesse seu e-mail e clique no bot\xE3o para entrar na sua conta rapidamente."));
};

MagicLinkEmailSentTemplate.propTypes = {
  email: PropTypes__default.string.isRequired
};

var _templateObject$1K, _templateObject2$1g, _templateObject3$U, _templateObject4$E;
var Content$K = styled(View$1)(_templateObject$1K || (_templateObject$1K = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.medium(_templateObject2$1g || (_templateObject2$1g = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var HRuleWrapper$9 = styled(View$1)(_templateObject3$U || (_templateObject3$U = _taggedTemplateLiteralLoose(["\n  margin-top: 34px;\n  margin-right: 0;\n  margin-bottom: 28px;\n  margin-left: 0;\n"])));
var FooterWrapper$3 = styled(View$1)(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var MagicLinkEmailSentPage = function MagicLinkEmailSentPage(_ref) {
  var email = _ref.email;
  return /*#__PURE__*/React.createElement(Content$K, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Acesso r\xE1pido enviado!"
  }), /*#__PURE__*/React.createElement(MagicLinkEmailSentTemplate, {
    email: email
  }), /*#__PURE__*/React.createElement(HRuleWrapper$9, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
    text: "Voltar para",
    linkText: "Acesse sua conta",
    href: "/acesso"
  })), /*#__PURE__*/React.createElement(FooterWrapper$3, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null)));
};
MagicLinkEmailSentPage.propTypes = {
  email: PropTypes__default.string.isRequired
};

var API_ENDPOINT$a = '/v0/user/passwordless_login';
var passwordlessLoginApiCall = (function (token) {
  return axios.post(API_ENDPOINT$a, {
    token: token,
    platform: platform
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
});

var lurker$g = new Lurker('login');

var MagicLinkValidateTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MagicLinkValidateTemplate, _React$Component);

  function MagicLinkValidateTemplate() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onSuccess = function (data) {
      lurker$g.viewMessageEvt('email_login_success', {
        accounts_method: 'passwordless',
        remote_addr: data.remoteAddress
      });

      if (_this.props.onSuccess) {
        _this.props.onSuccess(data);
      }
    };

    _this.onError = function (error) {
      if (error === void 0) {
        error = {};
      }

      try {
        var _error2 = error,
            _error$response3 = _error2.response,
            _error$response4 = _error$response3 === void 0 ? {} : _error$response3,
            status = _error$response4.status,
            _error$response2$data2 = _error$response4.data,
            data = _error$response2$data2 === void 0 ? {} : _error$response2$data2;

        if (status === 401) {
          var _data$message2 = data.message,
              message = _data$message2 === void 0 ? 'UNAUTHORIZED' : _data$message2;
          lurker$g.viewMessageEvt('error', {
            accounts_reason: "passwordless_rate_" + message.toLowerCase(),
            accounts_status_code: status
          });
        } else if (status === 429) {
          lurker$g.viewMessageEvt('error', {
            accounts_reason: 'passwordless_rate_limit_exceeded',
            accounts_status_code: status
          });
        } else if (status === 410) {
          var _data$message4 = data.message,
              _message = _data$message4 === void 0 ? 'ACCOUNT_INACTIVE' : _data$message4;

          lurker$g.viewMessageEvt('error', {
            accounts_reason: "passwordless_" + _message.toLowerCase(),
            accounts_status_code: status
          });
        } else if (status === 403) {
          lurker$g.viewMessageEvt('error', {
            accounts_reason: 'passwordless_recaptcha_invalid_token',
            accounts_status_code: status
          });
        } else if (status) {
          lurker$g.viewMessageEvt('error', {
            accounts_reason: 'passwordless_unexpected_status_code',
            accounts_status_code: status
          });
        } else {
          lurker$g.viewMessageEvt('error', {
            accounts_reason: 'passwordless_unexpected_error',
            accounts_error_message: error && error.message || 'unknown'
          });
        }

        return Promise.resolve(transientErrorsStorage.set('showExpiredTokenError')).then(function () {
          if (_this.props.onError) {
            _this.props.onError();
          }
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    return _this;
  }

  var _proto = MagicLinkValidateTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var token = this.props.token;
    lurker$g.pageLoadEvt();
    passwordlessLoginApiCall(token).then(this.onSuccess)["catch"](this.onError);
  };

  _proto.render = function render() {
    return null;
  };

  return MagicLinkValidateTemplate;
}(React.Component);

MagicLinkValidateTemplate.propTypes = {
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  token: PropTypes__default.string
};

var MagicLinkValidatePage = function MagicLinkValidatePage(props) {
  var token = props.token,
      onSuccess = props.onSuccess,
      onError = props.onError;
  return /*#__PURE__*/React.createElement(MagicLinkValidateTemplate, {
    onSuccess: onSuccess,
    onError: onError,
    token: token
  });
};
MagicLinkValidatePage.propTypes = {
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  token: PropTypes__default.string
};

var API_ENDPOINT$b = '/v1/accounts/recovery/captcha';
var forgotPasswordApiCall = (function (email, abTests, captchaToken) {
  return axios.post(API_ENDPOINT$b, {
    email: email
  }, {
    headers: {
      'X-TestAB-Groups': abTests || '',
      'X-Accounts-Recovery-Recaptcha': captchaToken
    },
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
});

var _templateObject$1L, _templateObject2$1h, _templateObject3$V, _templateObject4$F, _templateObject5$w, _templateObject6$l;
var Content$L = styled(View$1)(_templateObject$1L || (_templateObject$1L = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var SubtitleWrapper$2 = styled(Subtitle)(_templateObject2$1h || (_templateObject2$1h = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-bottom: 16px;\n"])));
var PageForm$3 = styled(Form)(_templateObject3$V || (_templateObject3$V = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var EmailChipWrapper$1 = styled(View$1)(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n  margin-bottom: 32px;\n"])));
var RecaptchaWrapper = styled(View$1)(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var CaptchaErrorMsgView = styled(View$1)(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 90%;\n"])));
var recaptchaSiteKey$1 = '6LfPClEUAAAAAD_O4ppsMM0r5EX5pcV5PH12rBIn';
var defaultEmailErrorMsg$1 = 'Por favor, insira um endereço de e-mail válido.';

var getErrorMessage$1 = function getErrorMessage(email) {
  if (email) {
    return defaultEmailErrorMsg$1;
  }

  return 'Este campo é obrigatório';
};

var DsEmailFormBaseTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(DsEmailFormBaseTemplate, _BaseForm);

  function DsEmailFormBaseTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.onEmailChange = function (event) {
      var value = event.target.value;

      _this.onFieldChange(event, 'email', isValidEmail, getErrorMessage$1(value), true);
    };

    _this.onEmailBlur = function (event) {
      var value = event.target.value;

      _this.onFieldChange(event, 'email', isValidEmail, getErrorMessage$1(value), false);
    };

    _this.onMailCheckSuggestionClick = function (suggestion) {
      var lurker = _this.props.lurker;

      if (typeof lurker === 'object') {
        lurker.viewMessageEvt('mailcheck_suggestion_accepted', {
          mailcheck_original: _this.state.fields.email.value,
          mailcheck_suggestion: suggestion
        });
      }

      var valid = isValidEmail(suggestion);

      _this.updateField('email', suggestion, valid, true);
    };

    _this.onRecaptchaLoad = function () {
      return _this.setState({
        recaptchaReady: true
      });
    };

    _this.onRecaptchaVerify = function (recaptchaToken) {
      if (recaptchaToken) {
        _this.updateField('recaptchaToken', recaptchaToken, true);
      } else {
        var lurker = _this.props.lurker;

        _this.setState({
          isSubmitting: false
        });

        _this.recaptcha.reset();

        lurker.viewMessageEvt('error', {
          accounts_reason: 'recaptcha_failed_token'
        });

        _this.showError('showGenericError');
      }
    };

    _this.onRecaptchaError = function (e) {
      var lurker = _this.props.lurker;
      lurker.viewMessageEvt('error', {
        accounts_reason: 'recaptcha_error',
        accounts_error_message: e && e.message || 'unknown'
      });
    };

    _this.onRecaptchaExpiration = function () {
      return _this.updateField('recaptchaToken', '', false);
    };

    _this.handleSubmit = function (event) {
      var _this$state$fields$re;

      var _this$props = _this.props,
          lurker = _this$props.lurker,
          onSubmit = _this$props.onSubmit,
          submitEventName = _this$props.submitEventName;
      var email = _this.state.fields.email.value;
      var recaptchaToken = (_this$state$fields$re = _this.state.fields.recaptchaToken) === null || _this$state$fields$re === void 0 ? void 0 : _this$state$fields$re.value;
      event.preventDefault();

      _this.setState({
        isSubmitting: true
      });

      lurker.clickEvt(submitEventName);

      _this.validateBeforeSend().then(function () {
        _this.checkFormIsValid().then(function () {
          onSubmit(email, recaptchaToken).then(function () {
            return _this.setState({
              isSubmitting: false
            });
          })["catch"](function () {
            _this.setState({
              isSubmitting: false
            });
          });
        })["catch"](function () {
          if (typeof lurker === 'object') {
            lurker.viewMessageEvt('error', _extends({
              accounts_reason: 'invalid_fields'
            }, _this.getInvalidFields()));
          }

          _this.setState({
            isSubmitting: false
          });
        });
      });
    };

    var _props$email = props.email,
        _email = _props$email === void 0 ? '' : _props$email,
        editable = props.editable;

    var _valid = false;

    if (!editable) {
      _valid = true;
    } else {
      _valid = _email ? isValidEmail(_email) : false;
    }

    _this.state = _extends({}, _this.state, {
      validators: {
        email: {
          action: editable ? isValidEmail : function () {
            return true;
          },
          message: getErrorMessage$1
        },
        recaptchaToken: {
          action: function action(value) {
            return !!value;
          },
          message: 'Captcha não preenchido.'
        }
      },
      fields: {
        email: {
          value: _email,
          pristine: !_email,
          valid: _valid
        },
        recaptchaToken: {
          value: '',
          pristine: true,
          valid: false
        }
      },
      recaptchaReady: false
    });
    return _this;
  }

  DsEmailFormBaseTemplate.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var fields = state.fields;
    var hasError = props.hasError,
        fieldError = props.fieldError;

    if (hasError) {
      return {
        fields: _extends({}, fields, {
          email: {
            value: fields.email.value,
            msg: fieldError || ' ',
            valid: false,
            pristine: false
          }
        })
      };
    }

    return null;
  };

  var _proto = DsEmailFormBaseTemplate.prototype;

  _proto.renderTitle = function renderTitle() {
    var renderTitle = this.props.renderTitle;

    if (typeof renderTitle === 'string') {
      return /*#__PURE__*/React.createElement(SubtitleWrapper$2, null, renderTitle);
    }

    return renderTitle();
  };

  _proto.renderEmail = function renderEmail() {
    var _this2 = this;

    var _this$props2 = this.props,
        editable = _this$props2.editable,
        onSwitchEmail = _this$props2.onSwitchEmail;
    var _this$state = this.state,
        fields = _this$state.fields,
        isSubmitting = _this$state.isSubmitting;
    var email = fields.email;
    var emailHasError = !email.valid && !email.pristine;

    if (!editable) {
      return /*#__PURE__*/React.createElement(EmailChipWrapper$1, null, /*#__PURE__*/React.createElement(EmailChip, {
        href: "#",
        onClick: onSwitchEmail
      }, email.value));
    }

    return /*#__PURE__*/React.createElement(DsMailCheckFormItem, {
      label: "E-mail",
      value: email.value,
      onChange: function onChange(event) {
        return _this2.onEmailChange(event);
      },
      onBlur: function onBlur(event) {
        return _this2.onEmailBlur(event);
      },
      error: email.msg,
      hasError: emailHasError,
      inputRef: function inputRef(x) {
        _this2.inputs.email = x;
      },
      disabled: isSubmitting,
      onSuggestionClick: this.onMailCheckSuggestionClick
    });
  };

  _proto.renderRecaptcha = function renderRecaptcha() {
    var _this3 = this;

    var recaptchaToken = this.state.fields.recaptchaToken;
    var captchaHasError = !recaptchaToken.valid && !recaptchaToken.pristine;
    return /*#__PURE__*/React.createElement(RecaptchaWrapper, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Reaptcha, {
      ref: function ref(e) {
        _this3.recaptcha = e;
      },
      sitekey: recaptchaSiteKey$1,
      onLoad: this.onRecaptchaLoad,
      onVerify: this.onRecaptchaVerify,
      onError: this.onRecaptchaError,
      onExpire: this.onRecaptchaExpiration
    }), captchaHasError && /*#__PURE__*/React.createElement(CaptchaErrorMsgView, null, /*#__PURE__*/React.createElement(errorMsg, null, "Captcha n\xE3o preenchido."))));
  };

  _proto.render = function render() {
    var isSubmitting = this.state.isSubmitting;
    var _this$props3 = this.props,
        renderError = _this$props3.renderError,
        buttonText = _this$props3.buttonText,
        errorPosition = _this$props3.errorPosition,
        isLocked = _this$props3.isLocked;
    return /*#__PURE__*/React.createElement(Content$L, null, errorPosition === 'top' ? renderError() : this.renderTitle(), errorPosition === 'top' ? this.renderTitle() : renderError(), /*#__PURE__*/React.createElement(PageForm$3, {
      method: "POST",
      onSubmit: this.handleSubmit,
      noValidate: true
    }, this.renderEmail(), this.renderRecaptcha(), /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      disabled: isSubmitting || isLocked,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, buttonText)));
  };

  return DsEmailFormBaseTemplate;
}(BaseForm);

DsEmailFormBaseTemplate.defaultProps = {
  buttonText: 'Enviar',
  editable: true,
  isLocked: false,
  submitEventName: 'submit'
};
DsEmailFormBaseTemplate.propTypes = {
  buttonText: PropTypes__default.string,
  editable: PropTypes__default.bool,
  email: PropTypes__default.string,
  errorPosition: PropTypes__default.string,
  fieldError: PropTypes__default.string,
  hasError: PropTypes__default.bool,
  isLocked: PropTypes__default.bool,
  lurker: PropTypes__default.object,
  onSubmit: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func,
  renderError: PropTypes__default.func,
  renderTitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.func]),
  submitEventName: PropTypes__default.string
};

var _templateObject$1M;
var lurker$h = new Lurker('forgot_password');
var ErrorMsgWrapper$4 = styled(View$1)(_templateObject$1M || (_templateObject$1M = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));

var ForgotPasswordTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ForgotPasswordTemplate, _React$Component);

  function ForgotPasswordTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onSubmit = function (email, recaptchaToken) {
      var abTests = _this.state.abTests;

      _this.setState({
        showGenericError: false,
        showRateLimitError: false,
        unregisteredEmail: false,
        showInactiveError: false
      });

      return forgotPasswordApiCall(email, abTests, recaptchaToken).then(function (data) {
        lurker$h.viewMessageEvt('success');

        if (_this.props.onSuccess) {
          _this.props.onSuccess(data, email);

          _this.setState({
            showGenericError: false,
            showRateLimitError: false,
            unregisteredEmail: false,
            showInactiveError: false
          });
        }
      })["catch"](function (data) {
        if (data === void 0) {
          data = {};
        }

        var _data = data,
            _data$response = _data.response,
            _data$response2 = _data$response === void 0 ? {} : _data$response,
            status = _data$response2.status,
            _data$response2$data = _data$response2.data,
            _data$response2$data2 = _data$response2$data === void 0 ? {} : _data$response2$data,
            message = _data$response2$data2.message,
            _data$message = _data.message,
            exceptionMessage = _data$message === void 0 ? 'unknown' : _data$message;

        behaviors.scrollToTop();
        if (status === 404) return _this.handle404();
        if (status === 429) return _this.handle429();
        if (status === 410) return _this.handle410();
        if (status) return _this.handleUnexpectedStatusCode(status, message);
        return _this.handleUnexpectedError(exceptionMessage);
      });
    };

    _this.handle410 = function () {
      lurker$h.viewMessageEvt('error', {
        accounts_reason: 'account_inactive',
        accounts_status_code: 410
      });

      _this.setState({
        showInactiveError: true
      });
    };

    _this.handle429 = function () {
      lurker$h.viewMessageEvt('error', {
        accounts_reason: 'rate_limit_exceeded',
        accounts_status_code: 429
      });

      _this.setState({
        showRateLimitError: true
      });
    };

    _this.handle404 = function () {
      lurker$h.viewMessageEvt('error', {
        accounts_reason: 'unregistered_account',
        accounts_status_code: 404
      });

      _this.setState({
        unregisteredEmail: true
      });
    };

    _this.handleUnexpectedStatusCode = function (status, message) {
      if (message === void 0) {
        message = 'unexpected_status_code';
      }

      lurker$h.viewMessageEvt('error', {
        accounts_reason: message.toLowerCase(),
        accounts_status_code: status
      });

      _this.setState({
        showGenericError: true
      });
    };

    _this.handleUnexpectedError = function (message) {
      if (message === void 0) {
        message = 'unknown';
      }

      lurker$h.viewMessageEvt('error', {
        accounts_reason: 'unexpected_error',
        accounts_error_message: message
      });

      _this.setState({
        showGenericError: true
      });
    };

    _this.renderError = function () {
      var _this$props = _this.props,
          onRegisterClick = _this$props.onRegisterClick,
          showAccountNotFoundTest = _this$props.showAccountNotFoundTest;
      var _this$state = _this.state,
          showRateLimitError = _this$state.showRateLimitError,
          showGenericError = _this$state.showGenericError,
          unregisteredEmail = _this$state.unregisteredEmail,
          showInactiveError = _this$state.showInactiveError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, unregisteredEmail && showAccountNotFoundTest && /*#__PURE__*/React.createElement(ErrorMsgWrapper$4, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showAccountNotFoundError: true,
        errorAction: onRegisterClick,
        text: "N\xE3o existe uma conta com este e-mail."
      })), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$4, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel solicitar a recupera\xE7\xE3o de senha."
      })), showInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$4, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: true,
        contactUsLink: "https://ajuda.olx.com.br/s/article/reativar-conta-na-olx",
        text: "Este e-mail n\xE3o pode mais ser usado."
      })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$4, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: false,
        text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
      })));
    };

    _this.state = {
      abTests: _this.props.abTests || '',
      showGenericError: false,
      showRateLimitError: false,
      unregisteredEmail: false,
      showInactiveError: false
    };
    return _this;
  }

  var _proto = ForgotPasswordTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$h.pageLoadEvt();
  };

  _proto.render = function render() {
    var unregisteredEmail = this.state.unregisteredEmail;
    var showAccountNotFoundTest = this.props.showAccountNotFoundTest;
    return /*#__PURE__*/React.createElement(DsEmailFormBaseTemplate, {
      buttonText: "Receber instru\xE7\xF5es",
      fieldError: !showAccountNotFoundTest && 'Este e-mail não possui uma conta na OLX',
      hasError: unregisteredEmail,
      lurker: lurker$h,
      onSubmit: this.onSubmit,
      renderError: this.renderError,
      renderTitle: "N\xE3o se preocupe! Insira o seu e-mail de cadastro e enviaremos instru\xE7\xF5es para voc\xEA."
    });
  };

  return ForgotPasswordTemplate;
}(React.Component);

ForgotPasswordTemplate.propTypes = {
  onSuccess: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  showAccountNotFoundTest: PropTypes__default.bool,
  abTests: PropTypes__default.string
};

var _templateObject$1N, _templateObject2$1i, _templateObject3$W;
var lurker$i = new Lurker('forgot_password');
var Content$M = styled(View$1)(_templateObject$1N || (_templateObject$1N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.medium(_templateObject2$1i || (_templateObject2$1i = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var HRuleWrapper$a = styled(View$1)(_templateObject3$W || (_templateObject3$W = _taggedTemplateLiteralLoose(["\n  margin-top: 34px;\n  margin-right: 0;\n  margin-bottom: 28px;\n  margin-left: 0;\n"])));
var ForgotPasswordPage = function ForgotPasswordPage(props) {
  var onSuccess = props.onSuccess,
      onSubmit = props.onSubmit,
      onError = props.onError,
      showAccountNotFoundTest = props.showAccountNotFoundTest,
      onRegisterClick = props.onRegisterClick,
      abTests = props.abTests;
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$M, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Esqueceu sua senha?"
  }), /*#__PURE__*/React.createElement(ForgotPasswordTemplate, {
    onSuccess: onSuccess,
    onSubmit: onSubmit,
    onError: onError,
    showAccountNotFoundTest: showAccountNotFoundTest,
    onRegisterClick: onRegisterClick,
    abTests: abTests
  }), /*#__PURE__*/React.createElement(HRuleWrapper$a, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
    text: "Voltar para",
    linkText: "Entrar",
    href: "/acesso",
    onClick: function onClick() {
      return lurker$i.clickEvt('back_to_login');
    },
    preventHrefOnClick: false
  }))));
};
ForgotPasswordPage.propTypes = {
  onSuccess: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onError: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  showAccountNotFoundTest: PropTypes__default.bool,
  abTests: PropTypes__default.string
};

var mailCheckConfig = {
  viewBox: '0 0 74 47',
  width: '74',
  height: '47',
  paths: [{
    path: 'M50,28.75 L50,43.75 C50,44.4403559 49.4403559,45 48.75,45 L2.75,45 C2.05964406,45 1.5,44.4403559 1.5,43.75 L1.5,13.75 C1.5,13.0596441 2.05964406,12.5 2.75,12.5 C20.3958333,12.5 33.6302083,12.5 42.453125,12.5 C43.1857639,12.5 41.6180556,12.5 37.75,12.5 C38.1642136,12.5 38.5,12.1642136 38.5,11.75 C38.5,11.3357864 38.1642136,11 37.75,11 L2.75,11 C1.23121694,11 0,12.2312169 0,13.75 L0,43.75 C0,45.2687831 1.23121694,46.5 2.75,46.5 L48.75,46.5 C50.2687831,46.5 51.5,45.2687831 51.5,43.75 L51.5,28.75 C51.5,28.3357864 51.1642136,28 50.75,28 C50.3357864,28 50,28.3357864 50,28.75 Z',
    color: '#4A4A4A'
  }, {
    path: 'M1.18016115,16.1356405 C0.840824183,15.8981046 0.373176337,15.9806307 0.135640456,16.3199676 C-0.101895424,16.6593046 -0.0193693338,17.1269525 0.319967638,17.3644883 L25.3199676,32.3644883 C25.5782078,32.5452564 25.921921,32.5452564 26.1801612,32.3644883 L41.1801612,24.3644883 C41.5194981,24.1269525 41.6020242,23.6593046 41.3644883,23.3199676 C41.1269525,22.9806307 40.6593046,22.8981046 40.3199676,23.1356405 L25.7500644,30.8345727 L1.18016115,16.1356405 Z',
    color: '#4A4A4A'
  }, {
    path: 'M14.5 29C6.492 29 0 22.508 0 14.5S6.492 0 14.5 0 29 6.492 29 14.5 22.508 29 14.5 29zm0-1.45c7.207 0 13.05-5.843 13.05-13.05 0-7.207-5.843-13.05-13.05-13.05-7.207 0-13.05 5.843-13.05 13.05 0 7.207 5.843 13.05 13.05 13.05zm-2.48-10.937l-2.87-3.83a.663.663 0 0 0-.906-.138.615.615 0 0 0-.145.878l3.06 4.084a.63.63 0 0 0 .11.114c.02.05.047.099.08.144a.662.662 0 0 0 .91.138l8.497-5.987a.619.619 0 0 0 .145-.881.662.662 0 0 0-.909-.138l-7.972 5.616z',
    color: '#7ED321',
    transform: 'translate(37,0)'
  }]
};

var _templateObject$1O;
var Wrapper$8 = styled(View$1)(_templateObject$1O || (_templateObject$1O = _taggedTemplateLiteralLoose(["\n  padding-left: 22px;\n"])));

var MailCheck = function MailCheck(props) {
  return /*#__PURE__*/React.createElement(Wrapper$8, null, /*#__PURE__*/React.createElement(Svg, {
    config: _extends({}, mailCheckConfig, props.config)
  }));
};

MailCheck.propTypes = {
  config: PropTypes__default.object
};

var _templateObject$1P, _templateObject2$1j, _templateObject3$X, _templateObject4$G;
var Content$N = styled(View$1)(_templateObject$1P || (_templateObject$1P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var Title$8 = styled(Text$1)(_templateObject2$1j || (_templateObject2$1j = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 24px;\n  font-size: 16px;\n"])));
var Email$1 = styled(Text$1)(_templateObject3$X || (_templateObject3$X = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-weight: bold;\n  font-size: 16px;\n"])));
var Description$9 = styled(Text$1)(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 24px;\n  font-size: 16px;\n"])));

var passwordRecoveryRequested = function passwordRecoveryRequested(props) {
  var email = props.email;
  return /*#__PURE__*/React.createElement(Content$N, null, /*#__PURE__*/React.createElement(MailCheck, null), /*#__PURE__*/React.createElement(Title$8, null, "Enviamos um e-mail para"), /*#__PURE__*/React.createElement(Email$1, {
    fontWeight: 700
  }, email), /*#__PURE__*/React.createElement(Description$9, null, "Dentro de instantes, acesse o seu e-mail e clique no link para redefinir sua senha."));
};

passwordRecoveryRequested.propTypes = {
  email: PropTypes__default.string.isRequired
};

var _templateObject$1Q, _templateObject2$1k, _templateObject3$Y, _templateObject4$H;
var Content$O = styled(View$1)(_templateObject$1Q || (_templateObject$1Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.medium(_templateObject2$1k || (_templateObject2$1k = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var HRuleWrapper$b = styled(View$1)(_templateObject3$Y || (_templateObject3$Y = _taggedTemplateLiteralLoose(["\n  margin-top: 34px;\n  margin-right: 0;\n  margin-bottom: 28px;\n  margin-left: 0;\n"])));
var TemplateWrapper = styled(View$1)(_templateObject4$H || (_templateObject4$H = _taggedTemplateLiteralLoose(["\n  margin: 16px 0;\n"])));
var PasswordResetEmailSentPage = function PasswordResetEmailSentPage(props) {
  var email = props.email,
      onSuccess = props.onSuccess,
      onSubmit = props.onSubmit,
      onError = props.onError;
  return /*#__PURE__*/React.createElement(Content$O, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Esqueceu sua senha?"
  }), /*#__PURE__*/React.createElement(TemplateWrapper, null, /*#__PURE__*/React.createElement(passwordRecoveryRequested, {
    email: email,
    onSuccess: onSuccess,
    onSubmit: onSubmit,
    onError: onError
  })), /*#__PURE__*/React.createElement(HRuleWrapper$b, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
    text: "Voltar para",
    linkText: "Entrar",
    href: "/acesso"
  })));
};
PasswordResetEmailSentPage.propTypes = {
  email: PropTypes__default.string.isRequired,
  onSuccess: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onError: PropTypes__default.func
};

var _templateObject$1R;

var IMG = function IMG(props) {
  return /*#__PURE__*/React.createElement("img", props);
};

var Loading = styled(IMG)(_templateObject$1R || (_templateObject$1R = _taggedTemplateLiteralLoose(["\n  width: 80px;\n  height: 80px;\n"])));
var LoadingIcon = (function () {
  return /*#__PURE__*/React.createElement(Loading, {
    src: "https://static.olx.com.br/accounts/loading.gif"
  });
});

var API_ENDPOINT$c = '/v1/accounts/validaterecoverytoken';
var tokenValidateApiCall = (function (token) {
  return axios.post(API_ENDPOINT$c, {
    token: token
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
});

var API_ENDPOINT$d = '/v1/accounts/changepassword';
var API_ENDPOINT_MY = '/v1/accounts/my/changepassword';

var changePasswordWithToken = function changePasswordWithToken(token, password, abTests) {
  return axios.post(API_ENDPOINT$d, {
    token: token,
    password: password
  }, {
    headers: {
      'X-TestAB-Groups': abTests || ''
    },
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};

var changePasswordWithCurrentPassword = function changePasswordWithCurrentPassword(currentPassword, password, abTests) {
  return axios.post(API_ENDPOINT_MY, {
    currentPassword: currentPassword,
    newPassword: password
  }, {
    headers: {
      'X-TestAB-Groups': abTests || ''
    },
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};

var changePasswordApiCall = (function (token, currentPassword, password, abTests) {
  if (token) {
    return changePasswordWithToken(token, password, abTests);
  }

  return changePasswordWithCurrentPassword(currentPassword, password, abTests);
});

var passwordSecurityVersionPropType = PropTypes__default.oneOf(['none', 'oldLayoutPasswordStrong', 'newLayoutPasswordWeak', 'newLayoutPasswordStrong']);
var recaptchaVersionPropType = PropTypes__default.oneOf(['none', 'useRecaptcha']);

var fake = function fake() {
  return Promise.resolve(false);
};

var SecureStorage = function SecureStorage() {
  this.saveCredential = fake;
  this.requestCredential = fake;
  this.hasBiometry = fake;
  this.resetCredential = fake;
};

var _templateObject$1S;
var strengthLevelColors = {
  0: '#ededed',
  1: '#ff4444',
  2: '#ee9e1a',
  3: '#75c232',
  4: '#008348'
};
var strengthRectangle = styled(View$1)(_templateObject$1S || (_templateObject$1S = _taggedTemplateLiteralLoose(["\n  flex-direction: row;\n  flex: 1;\n  background-color: ", ";\n  min-height: 6px;\n  max-height: 6px;\n  border-radius: 3px;\n"])), function (props) {
  return strengthLevelColors[props.level || 0];
});
strengthRectangle.defaultProps = {
  level: 0
};

var _templateObject$1T, _templateObject2$1l, _templateObject3$Z;
var Content$P = styled(View$1)(_templateObject$1T || (_templateObject$1T = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n  background-color: transparent;\n  justify-content: space-between;\n"])));
var Wrapper$9 = styled(View$1)(_templateObject2$1l || (_templateObject2$1l = _taggedTemplateLiteralLoose(["\n  margin-left: 5px;\n  flex: 1;\n"])));
var FirstRectangleWrapper = styled(View$1)(_templateObject3$Z || (_templateObject3$Z = _taggedTemplateLiteralLoose(["\n  flex: 1;\n"])));

var levelCalc = function levelCalc(index, level) {
  return level >= index ? level : 0;
};

var strengthMeter = function strengthMeter(props) {
  var level = props.level;
  return /*#__PURE__*/React.createElement(Content$P, null, /*#__PURE__*/React.createElement(FirstRectangleWrapper, null, /*#__PURE__*/React.createElement(strengthRectangle, {
    level: levelCalc(1, level)
  })), /*#__PURE__*/React.createElement(Wrapper$9, null, /*#__PURE__*/React.createElement(strengthRectangle, {
    level: levelCalc(2, level)
  })), /*#__PURE__*/React.createElement(Wrapper$9, null, /*#__PURE__*/React.createElement(strengthRectangle, {
    level: levelCalc(3, level)
  })), /*#__PURE__*/React.createElement(Wrapper$9, null, /*#__PURE__*/React.createElement(strengthRectangle, {
    level: levelCalc(4, level)
  })));
};

strengthMeter.defaultProps = {
  level: 0
};
strengthMeter.propTypes = {
  level: PropTypes__default.number
};

var _templateObject$1U, _templateObject2$1m;
var Content$Q = styled(View$1)(_templateObject$1U || (_templateObject$1U = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var TipWrapper$1 = styled(View$1)(_templateObject2$1m || (_templateObject2$1m = _taggedTemplateLiteralLoose(["\n  margin-left: 6px;\n  ", "\n"])), function (props) {
  return props.alignment === 'right' ? 'flex:1; text-align: right;' : '';
});

var formLabel$1 = function formLabel(_ref) {
  var label = _ref.label,
      tip = _ref.tip,
      tipAlignment = _ref.tipAlignment;
  return /*#__PURE__*/React.createElement(Content$Q, null, /*#__PURE__*/React.createElement(Label$1, null, label), /*#__PURE__*/React.createElement(TipWrapper$1, {
    alignment: tipAlignment
  }, /*#__PURE__*/React.createElement(caption, null, tip)));
};

formLabel$1.defaultProps = {
  tipAlignment: 'left'
};
formLabel$1.propTypes = {
  label: PropTypes__default.string.isRequired,
  tip: PropTypes__default.string
};

var _excluded$b = ["level", "label", "message", "tip", "tipAlignment", "value", "onChange", "onBlur", "hasError", "inputRef", "onSubmitEditing"];

var _templateObject$1V, _templateObject2$1n, _templateObject3$_, _templateObject4$I, _templateObject5$x;
var strengthLevelColors$1 = {
  '-3': '#ff4444',
  '-2': '#ff4444',
  '-1': '#ff4444',
  0: '#ff4444',
  1: '#ff4444',
  2: '#ee9e1a',
  3: '#75c232',
  4: '#008348'
};
var Content$R = styled(View$1)(_templateObject$1V || (_templateObject$1V = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var InputWrapper$1 = styled(View$1)(_templateObject2$1n || (_templateObject2$1n = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  margin-right: 0;\n  margin-bottom: 8px;\n  margin-left: 0;\n"])));
var MessageTipRow = styled(View$1)(_templateObject3$_ || (_templateObject3$_ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var Message$1 = styled(errorMsg)(_templateObject4$I || (_templateObject4$I = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  color: ", ";\n  margin-top: 8px;\n"])), function (props) {
  return strengthLevelColors$1[props.level];
});
var TipMessage = styled(Text$1)(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  font-size: 12px;\n  margin-top: 8px;\n  text-align: right;\n"])));

var eventHandler = function eventHandler(handler) {
  return function (event) {
    var value = event.target.value;

    var _checkStrength = checkStrength(value),
        strength = _checkStrength.strength,
        message = _checkStrength.message;

    if (handler) {
      handler(value, strength, message);
    }
  };
};

var passwordWithStrengthMeter = function passwordWithStrengthMeter(props) {
  var level = props.level,
      label = props.label,
      message = props.message,
      tip = props.tip,
      tipAlignment = props.tipAlignment,
      value = props.value,
      onChange = props.onChange,
      onBlur = props.onBlur,
      hasError = props.hasError,
      inputRef = props.inputRef,
      onSubmitEditing = props.onSubmitEditing,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded$b);

  return /*#__PURE__*/React.createElement(Content$R, null, /*#__PURE__*/React.createElement(formLabel$1, {
    label: label,
    tip: tip,
    tipAlignment: tipAlignment
  }), /*#__PURE__*/React.createElement(InputWrapper$1, null, /*#__PURE__*/React.createElement(DsPasswordInput, _extends({
    "aria-label": "senha",
    hasError: hasError,
    onChange: eventHandler(onChange),
    onBlur: eventHandler(onBlur),
    value: value,
    inputRef: inputRef,
    onSubmitEditing: onSubmitEditing
  }, otherProps))), /*#__PURE__*/React.createElement(strengthMeter, {
    level: level
  }), /*#__PURE__*/React.createElement(MessageTipRow, null, (hasError || level > 0) && /*#__PURE__*/React.createElement(Message$1, {
    level: level
  }, message), level === 0 && /*#__PURE__*/React.createElement(TipMessage, null, "8 ou mais caracteres")));
};

passwordWithStrengthMeter.defaultProps = {
  hasError: false,
  tipAlignment: 'left'
};
passwordWithStrengthMeter.propTypes = {
  level: PropTypes__default.number.isRequired,
  label: PropTypes__default.string.isRequired,
  tip: PropTypes__default.string,
  tipAlignment: PropTypes__default.string,
  hasError: PropTypes__default.bool,
  message: PropTypes__default.string,
  onChange: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  value: PropTypes__default.string,
  onSubmitEditing: PropTypes__default.func,
  inputRef: PropTypes__default.func
};

var _templateObject$1W;
var strengthLevelColors$2 = {
  0: '#ededed',
  1: '#ff4444',
  2: '#ee9e1a',
  3: '#75c232',
  4: '#75c232'
};
var strengthRectangle$1 = styled(View$1)(_templateObject$1W || (_templateObject$1W = _taggedTemplateLiteralLoose(["\n  flex-direction: row;\n  flex: 1;\n  background-color: ", ";\n  min-height: 6px;\n  max-height: 6px;\n  border-radius: 3px;\n"])), function (props) {
  return strengthLevelColors$2[props.level || 0];
});
strengthRectangle$1.defaultProps = {
  level: 0
};

var _templateObject$1X, _templateObject2$1o, _templateObject3$$;
var Content$S = styled(View$1)(_templateObject$1X || (_templateObject$1X = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n  background-color: transparent;\n  justify-content: space-between;\n"])));
var Wrapper$a = styled(View$1)(_templateObject2$1o || (_templateObject2$1o = _taggedTemplateLiteralLoose(["\n  margin-left: 5px;\n  flex: 1;\n"])));
var FirstRectangleWrapper$1 = styled(View$1)(_templateObject3$$ || (_templateObject3$$ = _taggedTemplateLiteralLoose(["\n  flex: 1;\n"])));

var levelCalc$1 = function levelCalc(index, level) {
  return level >= index ? level : 0;
};

var strengthMeterWithThree = function strengthMeterWithThree(props) {
  var level = props.level;
  var levelAjust = level > -3 && level < 0 ? 1 : level;
  return /*#__PURE__*/React.createElement(Content$S, null, /*#__PURE__*/React.createElement(FirstRectangleWrapper$1, null, /*#__PURE__*/React.createElement(strengthRectangle$1, {
    level: levelCalc$1(1, levelAjust)
  })), /*#__PURE__*/React.createElement(Wrapper$a, null, /*#__PURE__*/React.createElement(strengthRectangle$1, {
    level: levelCalc$1(2, levelAjust)
  })), /*#__PURE__*/React.createElement(Wrapper$a, null, /*#__PURE__*/React.createElement(strengthRectangle$1, {
    level: levelCalc$1(3, levelAjust)
  })));
};

strengthMeterWithThree.defaultProps = {
  level: 0
};
strengthMeterWithThree.propTypes = {
  level: PropTypes__default.number
};

var _excluded$c = ["level", "label", "message", "tip", "tipAlignment", "value", "onChange", "onBlur", "hasError", "inputRef", "onSubmitEditing"];

var _templateObject$1Y, _templateObject2$1p, _templateObject3$10, _templateObject4$J;
var strengthLevelColors$3 = {
  '-3': '#ff4444',
  '-2': '#ff4444',
  '-1': '#ff4444',
  0: '#ff4444',
  1: '#ff4444',
  2: '#ee9e1a',
  3: '#75c232',
  4: '#75c232'
};
var Content$T = styled(View$1)(_templateObject$1Y || (_templateObject$1Y = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var InputWrapper$2 = styled(View$1)(_templateObject2$1p || (_templateObject2$1p = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  margin-right: 0;\n  margin-bottom: 8px;\n  margin-left: 0;\n"])));
var MessageTipRow$1 = styled(View$1)(_templateObject3$10 || (_templateObject3$10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var Message$2 = styled(errorMsg)(_templateObject4$J || (_templateObject4$J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  color: ", ";\n  margin-top: 8px;\n"])), function (props) {
  return strengthLevelColors$3[props.level];
});

var eventHandler$1 = function eventHandler(handler) {
  return function (event) {
    var value = event.target.value;

    var _checkStrength = checkStrength(value),
        strength = _checkStrength.strength,
        message = _checkStrength.message;

    if (handler) {
      handler(value, strength, message);
    }
  };
};

var getNewMessage = function getNewMessage(level, message) {
  switch (level) {
    case -2:
      return 'Senha muito fraca';

    case -1:
      return 'Senha muito fraca. ' + message;

    case 2:
      return 'Senha fraca';

    case 3:
    case 4:
      return 'Senha Forte. Excelente!';

    default:
      return message;
  }
};

var PasswordWithStrengthMeterAndTips = function PasswordWithStrengthMeterAndTips(props) {
  var level = props.level,
      label = props.label,
      message = props.message,
      tip = props.tip,
      tipAlignment = props.tipAlignment,
      value = props.value,
      onChange = props.onChange,
      onBlur = props.onBlur,
      hasError = props.hasError,
      inputRef = props.inputRef,
      onSubmitEditing = props.onSubmitEditing,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded$c);

  return /*#__PURE__*/React.createElement(Content$T, null, /*#__PURE__*/React.createElement(formLabel$1, {
    label: label,
    tip: tip,
    tipAlignment: tipAlignment
  }), /*#__PURE__*/React.createElement(InputWrapper$2, null, /*#__PURE__*/React.createElement(DsPasswordInput, _extends({
    "aria-label": "senha",
    hasError: hasError,
    onChange: eventHandler$1(onChange),
    onBlur: eventHandler$1(onBlur),
    value: value,
    inputRef: inputRef,
    onSubmitEditing: onSubmitEditing
  }, otherProps))), (hasError || level > 0) && /*#__PURE__*/React.createElement(strengthMeterWithThree, {
    level: level
  }), /*#__PURE__*/React.createElement(MessageTipRow$1, null, (hasError || level > 0) && /*#__PURE__*/React.createElement(Message$2, {
    level: level
  }, getNewMessage(level, message))));
};

PasswordWithStrengthMeterAndTips.defaultProps = {
  hasError: false,
  tipAlignment: 'left'
};
PasswordWithStrengthMeterAndTips.propTypes = {
  level: PropTypes__default.number.isRequired,
  label: PropTypes__default.string.isRequired,
  tip: PropTypes__default.string,
  tipAlignment: PropTypes__default.string,
  hasError: PropTypes__default.bool,
  message: PropTypes__default.string,
  onChange: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  value: PropTypes__default.string,
  onSubmitEditing: PropTypes__default.func,
  inputRef: PropTypes__default.func
};

var _templateObject$1Z, _templateObject2$1q, _templateObject3$11, _templateObject4$K;
var Content$U = styled(View$1)(_templateObject$1Z || (_templateObject$1Z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 32px;\n"])));
var SubtitleWrapper$3 = styled(Subtitle)(_templateObject2$1q || (_templateObject2$1q = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-bottom: 16px;\n"])));
var PageForm$4 = styled(Form)(_templateObject3$11 || (_templateObject3$11 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var PasswordWrapper = styled(View$1)(_templateObject4$K || (_templateObject4$K = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  margin-right: 0;\n  margin-bottom: 8px;\n  margin-left: 0;\n"])));

var getPasswordExtraData = function getPasswordExtraData(key, password) {
  var field = {};
  var passwordLevel = password.level;

  if (passwordLevel === -1) {
    field[key] = 'sequential';
  } else if (passwordLevel === 1 || passwordLevel === 2) {
    field[key] = 'weak';
  } else if (passwordLevel === 3) {
    field[key] = 'good';
  } else if (passwordLevel === 4) {
    field[key] = 'strong';
  }

  return field;
};

var passwordConfirmationMsg = 'As senhas estão diferentes. Tente novamente.';

var ChangePasswordBaseTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(ChangePasswordBaseTemplate, _BaseForm);

  function ChangePasswordBaseTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.onCurrentPasswordChange = function (event) {
      var value = event.target.value;

      _this.updateField('currentPassword', value, !!value, false);
    };

    _this.onPasswordChange = function (value, level, msg) {
      var fields = _this.state.fields;
      var showPasswodConfirmationInput = _this.props.showPasswodConfirmationInput;
      var passwordConfirmation = fields.passwordConfirmation.value;

      _this.setState({
        fields: _extends({}, fields, {
          password: {
            value: value,
            valid: _this.isValidPassword(value, level),
            level: level,
            msg: msg,
            pristine: false
          }
        })
      });

      setTimeout(function () {
        if (showPasswodConfirmationInput && passwordConfirmation) {
          _this.updateField('passwordConfirmation', passwordConfirmation, _this.isValidPasswordConfirmation(passwordConfirmation), false, passwordConfirmationMsg);
        }
      }, 1);
    };

    _this.onPasswordConfirmationChange = function (event) {
      var value = event.target.value;

      var valid = _this.isValidPasswordConfirmation(value);

      var message = valid ? null : passwordConfirmationMsg;

      _this.updateField('passwordConfirmation', value, valid, false, message);
    };

    _this.isValidPasswordConfirmation = function (passwordConfirmation) {
      var showPasswodConfirmationInput = _this.props.showPasswodConfirmationInput;

      var fields = _extends({}, _this.state.fields);

      return showPasswodConfirmationInput ? passwordConfirmation === fields.password.value : true;
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      var _this$props = _this.props,
          lurker = _this$props.lurker,
          submitEventName = _this$props.submitEventName,
          onSubmit = _this$props.onSubmit;
      var fields = _this.state.fields;
      var currentPassword = fields.currentPassword,
          password = fields.password;

      _this.setState({
        isSubmitting: true
      });

      lurker.clickEvt(submitEventName);

      _this.validateBeforeSend().then(function () {
        _this.checkFormIsValid().then(function () {
          onSubmit({
            currentPassword: currentPassword,
            password: password
          }).then(function () {
            return _this.setState({
              isSubmitting: false
            });
          })["catch"](function () {
            _this.setState({
              isSubmitting: false
            });
          });
        })["catch"](function () {
          if (typeof lurker === 'object') {
            lurker.viewMessageEvt('error', _extends({
              accounts_reason: 'invalid_fields'
            }, _this.getInvalidFields(), getPasswordExtraData('invalid_password_reason', _this.state.fields.password)));
          }

          _this.setState({
            isSubmitting: false
          });
        });
      });
    };

    var showCurrentPasswodInput = props.showCurrentPasswodInput,
        _showPasswodConfirmationInput = props.showPasswodConfirmationInput;
    _this.state = {
      isSubmitting: false,
      validators: {
        currentPassword: {
          action: null,
          message: 'Este campo é obrigatório.'
        },
        password: {
          action: _this.isValidPassword,
          message: _this.getPasswordErrorMessage
        },
        passwordConfirmation: {
          action: _this.isValidPasswordConfirmation,
          message: passwordConfirmationMsg
        }
      },
      fields: {
        currentPassword: {
          value: !showCurrentPasswodInput || '',
          pristine: true,
          valid: !showCurrentPasswodInput
        },
        password: {
          value: '',
          pristine: true,
          valid: false,
          level: 0
        },
        passwordConfirmation: {
          value: !_showPasswodConfirmationInput || '',
          pristine: true,
          valid: !_showPasswodConfirmationInput
        }
      }
    };
    return _this;
  }

  var _proto = ChangePasswordBaseTemplate.prototype;

  _proto.renderTitle = function renderTitle() {
    var renderTitle = this.props.renderTitle;

    if (typeof renderTitle === 'string') {
      return /*#__PURE__*/React.createElement(SubtitleWrapper$3, null, renderTitle);
    }

    return renderTitle();
  };

  _proto.renderPassword = function renderPassword() {
    var _this2 = this;

    var _this$props2 = this.props,
        passwordSecurityVersion = _this$props2.passwordSecurityVersion,
        showPasswodConfirmationInput = _this$props2.showPasswodConfirmationInput;
    var fields = this.state.fields;
    var password = fields.password;
    var passwordHasError = !password.valid && !password.pristine;
    return passwordSecurityVersion === 'newLayoutPasswordWeak' || passwordSecurityVersion === 'newLayoutPasswordStrong' ? /*#__PURE__*/React.createElement(PasswordWithStrengthMeterAndTips, {
      label: "Nova senha",
      arialabel: "Digite sua nova senha",
      level: password.level,
      errorMsg: password.msg,
      hasError: passwordHasError,
      maxLength: 40,
      onChange: this.onPasswordChange,
      onBlur: this.onPasswordChange,
      value: password.value,
      blurOnSubmit: !showPasswodConfirmationInput,
      returnKeyType: showPasswodConfirmationInput ? 'next' : 'done',
      inputRef: function inputRef(x) {
        _this2.inputs.password = x;
      },
      onSubmitEditing: showPasswodConfirmationInput ? function () {
        return _this2.updateFocus('passwordConfirmation');
      } : this.handleSubmit
    }) : /*#__PURE__*/React.createElement(passwordWithStrengthMeter, {
      label: "Nova senha",
      tip: "Use letras, n\xFAmeros e caracteres especiais.",
      arialabel: "Digite sua nova senha",
      level: password.level,
      message: password.msg || REQUIRED_PASSWORD_MESSAGE,
      hasError: passwordHasError,
      maxLength: 40,
      onChange: this.onPasswordChange,
      onBlur: this.onPasswordChange,
      value: password.value,
      blurOnSubmit: !showPasswodConfirmationInput,
      returnKeyType: showPasswodConfirmationInput ? 'next' : 'done',
      inputRef: function inputRef(x) {
        _this2.inputs.password = x;
      },
      onSubmitEditing: showPasswodConfirmationInput ? function () {
        return _this2.updateFocus('passwordConfirmation');
      } : this.handleSubmit
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state = this.state,
        fields = _this$state.fields,
        isSubmitting = _this$state.isSubmitting;
    var currentPassword = fields.currentPassword,
        passwordConfirmation = fields.passwordConfirmation;
    var passwordConfirmationHasError = !passwordConfirmation.valid && !passwordConfirmation.pristine;
    var currentPasswordHasError = !currentPassword.valid && !currentPassword.pristine;
    var _this$props3 = this.props,
        renderError = _this$props3.renderError,
        showCurrentPasswodInput = _this$props3.showCurrentPasswodInput,
        showPasswodConfirmationInput = _this$props3.showPasswodConfirmationInput,
        buttonText = _this$props3.buttonText;
    return /*#__PURE__*/React.createElement(Content$U, null, renderError(), this.renderTitle(), /*#__PURE__*/React.createElement(PageForm$4, {
      noValidate: true
    }, showCurrentPasswodInput && /*#__PURE__*/React.createElement(PasswordWrapper, null, /*#__PURE__*/React.createElement(DsPasswordInput, {
      label: "Senha atual",
      arialabel: "Digite sua senha atual",
      hasError: currentPasswordHasError,
      errorMsg: currentPassword.msg || 'Campo obrigatório. Informe sua senha.',
      onChange: this.onCurrentPasswordChange,
      onBlur: this.onCurrentPasswordChange,
      value: currentPassword.value,
      disabled: isSubmitting,
      blurOnSubmit: false,
      returnKeyType: "next",
      onSubmitEditing: function onSubmitEditing() {
        return _this3.updateFocus('password');
      }
    })), /*#__PURE__*/React.createElement(PasswordWrapper, null, this.renderPassword()), showPasswodConfirmationInput && /*#__PURE__*/React.createElement(PasswordWrapper, null, /*#__PURE__*/React.createElement(DsPasswordInput, {
      label: "Confirme sua senha",
      arialabel: "Digite novamente sua senha",
      errorMsg: passwordConfirmation.msg,
      hasError: passwordConfirmationHasError,
      onChange: this.onPasswordConfirmationChange,
      onBlur: this.onPasswordConfirmationChange,
      value: passwordConfirmation.value,
      disabled: isSubmitting,
      inputRef: function inputRef(x) {
        _this3.inputs.passwordConfirmation = x;
      },
      onSubmitEditing: this.handleSubmit
    })), /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      disabled: isSubmitting,
      onClick: this.handleSubmit
    }, buttonText)));
  };

  return ChangePasswordBaseTemplate;
}(BaseForm);

ChangePasswordBaseTemplate.defaultProps = {
  buttonText: 'Enviar',
  showCurrentPasswodInput: false,
  showPasswodConfirmationInput: false,
  submitEventName: 'submit'
};
ChangePasswordBaseTemplate.propTypes = {
  buttonText: PropTypes__default.string,
  lurker: PropTypes__default.object,
  onSubmit: PropTypes__default.func,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  renderError: PropTypes__default.func,
  renderTitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.func]),
  showCurrentPasswodInput: PropTypes__default.bool,
  showPasswodConfirmationInput: PropTypes__default.bool,
  submitEventName: PropTypes__default.string
};

var _templateObject$1_, _templateObject2$1r;
var lurker$j = new Lurker('change_password');
var secureStorage = new SecureStorage('change_password');
var smartLock$2 = new SmartLock('change_password');
var Content$V = styled(View$1)(_templateObject$1_ || (_templateObject$1_ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var ErrorMsgWrapper$5 = styled(View$1)(_templateObject2$1r || (_templateObject2$1r = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));

var getPasswordExtraData$1 = function getPasswordExtraData(key, password) {
  var field = {};
  var passwordLevel = password.level;

  if (passwordLevel === -1) {
    field[key] = 'sequential';
  } else if (passwordLevel === 1 || passwordLevel === 2) {
    field[key] = 'weak';
  } else if (passwordLevel === 3) {
    field[key] = 'good';
  } else if (passwordLevel === 4) {
    field[key] = 'strong';
  }

  return field;
};

var errors$2 = {
  showGenericError: false,
  showRateLimitError: false
};

var ChangePasswordTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ChangePasswordTemplate, _React$Component);

  function ChangePasswordTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.validateToken = function () {
      var token = _this.props.token;

      if (_this.props.disableTokenExchange === true) {
        return;
      }

      if (_this.props.onTokenExchangeSubmit) {
        _this.props.onTokenExchangeSubmit();
      }

      tokenValidateApiCall(token).then(function () {
        _this.setState({
          changePasswordToken: token
        });
      })["catch"](function (data) {
        var responseStatus = data && data.response ? data.response.status : null;

        switch (responseStatus) {
          case 429:
            _this.setState({
              showRateLimitError: true
            });

            break;

          case 410:
            _this.props.onLinkExpired();

            break;

          default:
            behaviors.goToErrorPage("ErrorExchangingToken" + responseStatus);
        }
      })["finally"](function () {
        if (_this.props.onTokenExchangeFinish) {
          _this.props.onTokenExchangeFinish();
        }
      });
    };

    _this.handleSubmit = function (_ref) {
      var currentPassword = _ref.currentPassword,
          password = _ref.password;

      _this.setState(_extends({}, errors$2));

      if (_this.props.onSubmit) {
        _this.props.onSubmit();
      }

      var _this$state = _this.state,
          changePasswordToken = _this$state.changePasswordToken,
          abTests = _this$state.abTests;
      return changePasswordApiCall(changePasswordToken, currentPassword.value, password.value, abTests).then(function (data) {
        try {
          var _temp3 = function _temp3() {
            if (onSuccess) {
              onSuccess(data);
            }
          };

          var _this$props2 = _this.props,
              onSuccess = _this$props2.onSuccess,
              email = _this$props2.email;
          lurker$j.viewMessageEvt('success', _extends({}, getPasswordExtraData$1('password_strength', password)));

          var _temp4 = function () {
            if (email) {
              return Promise.resolve(smartLock$2.saveCredential(email, password.value)).then(function () {
                return Promise.resolve(secureStorage.saveCredential(email, password.value)).then(function () {});
              });
            }
          }();

          return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
        } catch (e) {
          return Promise.reject(e);
        }
      })["catch"](function (data) {
        if (_this.props.onError) {
          _this.props.onError();
        }

        var _data$response = data.response,
            _data$response2 = _data$response === void 0 ? {} : _data$response,
            status = _data$response2.status,
            _data$response2$data = _data$response2.data,
            _data$response2$data2 = _data$response2$data === void 0 ? {} : _data$response2$data,
            message = _data$response2$data2.message,
            _data$message = data.message,
            exceptionMessage = _data$message === void 0 ? 'unknown' : _data$message;

        behaviors.scrollToTop();
        if (status === 429) return _this.handle429();
        if (status) return _this.handleUnexpectedStatusCode(status, message);
        return _this.handleUnexpectedError(exceptionMessage);
      });
    };

    _this.handle429 = function () {
      lurker$j.viewMessageEvt('error', {
        accounts_reason: 'rate_limit_exceeded',
        accounts_status_code: 429
      });

      _this.setState({
        showRateLimitError: true
      });
    };

    _this.handleUnexpectedStatusCode = function (status, message) {
      if (message === void 0) {
        message = 'unexpected_status_code';
      }

      lurker$j.viewMessageEvt('error', {
        accounts_reason: message.toLowerCase(),
        accounts_status_code: status
      });

      _this.setState({
        showGenericError: true
      });
    };

    _this.handleUnexpectedError = function (message) {
      if (message === void 0) {
        message = 'unknown';
      }

      lurker$j.viewMessageEvt('error', {
        accounts_reason: 'unexpected_error',
        accounts_error_message: message
      });

      _this.setState({
        showGenericError: true
      });
    };

    _this.renderError = function () {
      var _this$state2 = _this.state,
          showGenericError = _this$state2.showGenericError,
          showRateLimitError = _this$state2.showRateLimitError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$5, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel salvar sua nova senha."
      })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$5, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: false,
        text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
      })));
    };

    var _token = props.token;
    _this.state = _extends({}, errors$2, {
      abTests: _this.props.abTests || '',
      changePasswordToken: null,
      showCurrentPasswodInput: !_token
    });
    return _this;
  }

  var _proto = ChangePasswordTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$j.pageLoadEvt();
    var token = this.props.token;

    if (token) {
      this.validateToken();
    }
  };

  _proto.render = function render() {
    var passwordSecurityVersion = this.props.passwordSecurityVersion;
    var showCurrentPasswodInput = this.state.showCurrentPasswodInput;
    return /*#__PURE__*/React.createElement(Content$V, null, /*#__PURE__*/React.createElement(logoTitle, {
      title: "Altere sua senha"
    }), /*#__PURE__*/React.createElement(ChangePasswordBaseTemplate, {
      lurker: lurker$j,
      onSubmit: this.handleSubmit,
      passwordSecurityVersion: passwordSecurityVersion,
      renderError: this.renderError,
      renderTitle: "Crie uma senha longa e complexa, com letras mai\xFAsculas, min\xFAsculas, n\xFAmeros e s\xEDmbolos.",
      showCurrentPasswodInput: showCurrentPasswodInput
    }));
  };

  return ChangePasswordTemplate;
}(React.Component);

ChangePasswordTemplate.propTypes = {
  disableTokenExchange: PropTypes__default.bool,
  onTokenExchangeSubmit: PropTypes__default.func,
  onTokenExchangeFinish: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  onLinkExpired: PropTypes__default.func,
  token: PropTypes__default.string,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  abTests: PropTypes__default.string
};

var _templateObject$1$, _templateObject2$1s;

var getTokenParam = function getTokenParam() {
  var querystring = window.location.search;
  var matches = querystring.match('[?&]token=([^&]*)');
  return matches ? matches[1] : null;
};

var Content$W = styled(Paper$1)(_templateObject$1$ || (_templateObject$1$ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.medium(_templateObject2$1s || (_templateObject2$1s = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var ChangePasswordPage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ChangePasswordPage, _React$Component);

  function ChangePasswordPage(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      token: getTokenParam(),
      isLoading: false
    };
    return _this;
  }

  var _proto = ChangePasswordPage.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onSuccess = _this$props.onSuccess,
        onSubmit = _this$props.onSubmit,
        onError = _this$props.onError,
        disableTokenExchange = _this$props.disableTokenExchange,
        onTokenExchangeSubmit = _this$props.onTokenExchangeSubmit,
        onTokenExchangeFinish = _this$props.onTokenExchangeFinish,
        passwordSecurityVersion = _this$props.passwordSecurityVersion,
        abTests = _this$props.abTests,
        onLinkExpired = _this$props.onLinkExpired;
    return /*#__PURE__*/React.createElement(Content$W, null, this.state.isLoading && /*#__PURE__*/React.createElement(LoadingIcon, null), /*#__PURE__*/React.createElement(ChangePasswordTemplate, {
      disableTokenExchange: disableTokenExchange,
      onTokenExchangeSubmit: onTokenExchangeSubmit,
      onTokenExchangeFinish: onTokenExchangeFinish,
      onSuccess: onSuccess,
      onSubmit: onSubmit,
      onError: onError,
      token: this.state.token,
      onLinkExpired: onLinkExpired,
      passwordSecurityVersion: passwordSecurityVersion,
      abTests: abTests
    }));
  };

  return ChangePasswordPage;
}(React.Component);
ChangePasswordPage.propTypes = {
  disableTokenExchange: PropTypes__default.bool,
  onTokenExchangeSubmit: PropTypes__default.func,
  onTokenExchangeFinish: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onError: PropTypes__default.func,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  abTests: PropTypes__default.string,
  onLinkExpired: PropTypes__default.func
};

var _templateObject$20, _templateObject2$1t, _templateObject3$12;
var Content$X = styled(View$1)(_templateObject$20 || (_templateObject$20 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var CheckCircleWrapper = styled(View$1)(_templateObject2$1t || (_templateObject2$1t = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n"])));
var Description$a = styled(Subtitle)(_templateObject3$12 || (_templateObject3$12 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var PasswordChangedTemplate = (function () {
  return /*#__PURE__*/React.createElement(Content$X, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Senha alterada com sucesso"
  }), /*#__PURE__*/React.createElement(CheckCircleWrapper, null, /*#__PURE__*/React.createElement(checkCircleSymbol, null)), /*#__PURE__*/React.createElement(Description$a, null, "Lembre-se: n\xE3o salve senhas em computadores ou aparelhos p\xFAblicos."), /*#__PURE__*/React.createElement(Description$a, null, "Renove suas senhas periodicamente, mas n\xE3o repita senhas antigas."));
});

var _templateObject$21, _templateObject2$1u, _templateObject3$13;
var Content$Y = styled(Paper)(_templateObject$21 || (_templateObject$21 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.medium(_templateObject2$1u || (_templateObject2$1u = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var HRuleWrapper$c = styled(View$2)(_templateObject3$13 || (_templateObject3$13 = _taggedTemplateLiteralLoose(["\n  margin-top: 48px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var ChangedPasswordPage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ChangedPasswordPage, _React$Component);

  function ChangedPasswordPage() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ChangedPasswordPage.prototype;

  _proto.render = function render() {
    var onAccessClick = this.props.onAccessClick;
    return /*#__PURE__*/React.createElement(Content$Y, null, /*#__PURE__*/React.createElement(PasswordChangedTemplate, null), /*#__PURE__*/React.createElement(HRuleWrapper$c, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
      text: "Comece a usar a OLX",
      linkText: "Entrar",
      href: "/acesso",
      onClick: onAccessClick
    }));
  };

  return ChangedPasswordPage;
}(React.Component);
ChangedPasswordPage.propTypes = {
  onAccessClick: PropTypes__default.func
};

var _templateObject$22, _templateObject2$1v, _templateObject3$14, _templateObject4$L, _templateObject5$y;
var lurker$k = new Lurker('change_password_expired_link');
var Content$Z = styled(View$1)(_templateObject$22 || (_templateObject$22 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var SubtitleWrapper$4 = styled(Subtitle)(_templateObject2$1v || (_templateObject2$1v = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var ButtonWrapper$5 = styled(Button$1)(_templateObject3$14 || (_templateObject3$14 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  flex: none;\n"])));
var SymbolWrapper = styled(View$1)(_templateObject4$L || (_templateObject4$L = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n"])));
var ErrorMsgWrapper$6 = styled(View$1)(_templateObject5$y || (_templateObject5$y = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-left: 0;\n"])));

var ChangePasswordExpiredLinkTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ChangePasswordExpiredLinkTemplate, _React$Component);

  function ChangePasswordExpiredLinkTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.state = {
      isSubmitting: false,
      showGenericError: false
    };
    return _this;
  }

  var _proto = ChangePasswordExpiredLinkTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$k.pageLoadEvt();
  };

  _proto.onClick = function onClick(event) {
    var _this2 = this;

    lurker$k.clickEvt('submit');
    event.preventDefault();
    this.setState({
      isSubmitting: true
    }, function () {
      return _this2.doRequestPasswordRecovery();
    });
  };

  _proto.doRequestPasswordRecovery = function doRequestPasswordRecovery() {
    var _this3 = this;

    var _this$props = this.props,
        email = _this$props.email,
        onForgotPasswordClick = _this$props.onForgotPasswordClick,
        onSuccess = _this$props.onSuccess;
    this.setState({
      showGenericError: false
    });

    if (email) {
      forgotPasswordApiCall(email).then(function () {
        lurker$k.viewMessageEvt('success');
        onSuccess(email);
      })["catch"](function (data) {
        if (data === void 0) {
          data = {};
        }

        var _data = data,
            _data$response = _data.response,
            response = _data$response === void 0 ? {} : _data$response;

        if (response.status) {
          lurker$k.viewMessageEvt('error', {
            accounts_reason: 'unexpected_status_code',
            accounts_status_code: response.status
          });
        } else {
          lurker$k.viewMessageEvt('error', {
            accounts_reason: 'unexpected_error',
            accounts_error_message: data && data.message || 'unknown'
          });
        }

        _this3.setState({
          showGenericError: true
        });
      })["finally"](function () {
        _this3.setState({
          isSubmitting: false
        });
      });
    } else {
      onForgotPasswordClick();
    }
  };

  _proto.render = function render() {
    var _this$state = this.state,
        isSubmitting = _this$state.isSubmitting,
        showGenericError = _this$state.showGenericError;
    return /*#__PURE__*/React.createElement(Content$Z, null, /*#__PURE__*/React.createElement(SymbolWrapper, null, /*#__PURE__*/React.createElement(AlertSymbol, null)), /*#__PURE__*/React.createElement(SubtitleWrapper$4, null, "Parece que o e-mail para recuperar sua senha n\xE3o est\xE1 mais v\xE1lido."), /*#__PURE__*/React.createElement(SubtitleWrapper$4, null, "Clique no bot\xE3o abaixo para receber um novo e-mail:"), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$6, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel reenviar o e-mail."
    })), /*#__PURE__*/React.createElement(ButtonWrapper$5, {
      fluid: true,
      size: "large",
      disabled: isSubmitting,
      isLoading: isSubmitting,
      onClick: this.onClick
    }, "Reenviar e-mail"));
  };

  return ChangePasswordExpiredLinkTemplate;
}(React.Component);

ChangePasswordExpiredLinkTemplate.propTypes = {
  onForgotPasswordClick: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  email: PropTypes__default.string
};

var _templateObject$23, _templateObject2$1w, _templateObject3$15;
var Content$_ = styled(View$1)(_templateObject$23 || (_templateObject$23 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.medium(_templateObject2$1w || (_templateObject2$1w = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var HRuleWrapper$d = styled(View$1)(_templateObject3$15 || (_templateObject3$15 = _taggedTemplateLiteralLoose(["\n  margin-top: 34px;\n  margin-right: 0;\n  margin-bottom: 28px;\n  margin-left: 0;\n"])));
var ChangePasswordExpiredLinkPage = function ChangePasswordExpiredLinkPage(_ref) {
  var email = _ref.email,
      onSuccess = _ref.onSuccess,
      onForgotPasswordClick = _ref.onForgotPasswordClick;
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$_, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Recuperar senha"
  }), /*#__PURE__*/React.createElement(ChangePasswordExpiredLinkTemplate, {
    email: email,
    onSuccess: onSuccess,
    onForgotPasswordClick: onForgotPasswordClick
  }), /*#__PURE__*/React.createElement(HRuleWrapper$d, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
    text: "Comece a usar a OLX",
    linkText: "Entrar",
    href: "/acesso",
    direction: "column",
    fontWeight: 700
  }))));
};
ChangePasswordExpiredLinkPage.propTypes = {
  onForgotPasswordClick: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  email: PropTypes__default.string
};

var sendPinCode = function sendPinCode(token) {
  return axios.post('/v1/user/send/pincode', {
    token: token,
    platform: platform
  }, {
    withCredentials: true,
    timeout: 20000
  });
};
var loginWithPinCode = function loginWithPinCode(token, code) {
  return axios.post('/v1/user/login/pincode', {
    token: token,
    code: code,
    platform: platform
  }, {
    withCredentials: true,
    timeout: 20000
  });
};

var _templateObject$24, _templateObject2$1x;
var lurker$l = new Lurker('score_pincode');
var ErrorMsgWrapper$7 = styled(View$1)(_templateObject$24 || (_templateObject$24 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-left: 0;\n"])));
var Description$b = styled(Subtitle)(_templateObject2$1x || (_templateObject2$1x = _taggedTemplateLiteralLoose(["\n  padding-top: 16px;\n  padding-bottom: 24px;\n"])));
var errors$3 = {
  showGenericError: false,
  showRateLimitError: false
};

var renderDescription = function renderDescription() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Description$b, null, "Para seguran\xE7a da sua conta, precisamos confirmar se voc\xEA \xE9 realmente voc\xEA."), /*#__PURE__*/React.createElement(Subtitle, null, "Enviaremos um c\xF3digo para"));
};

var ScorePinCodeTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ScorePinCodeTemplate, _React$Component);

  function ScorePinCodeTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onSendPinCodeError = function (error) {
      if (error === void 0) {
        error = {};
      }

      var _error = error,
          _error$response = _error.response,
          _error$response2 = _error$response === void 0 ? {} : _error$response,
          status = _error$response2.status,
          _error$response2$data = _error$response2.data,
          _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
          message = _error$response2$data2.message;

      var genericError = 'showGenericError';

      if (status === 401) {
        lurker$l.viewMessageEvt('error', {
          accounts_reason: 'unauthorized',
          accounts_status_code: status
        });

        _this.showError(genericError);
      } else if (status === 429) {
        lurker$l.viewMessageEvt('error', {
          accounts_reason: 'rate_limit_exceeded',
          accounts_status_code: status
        });

        _this.showError('showRateLimitError');
      } else if (status === 403) {
        if (message === 'ACCOUNT_LOCKED') {
          lurker$l.viewMessageEvt('error', {
            accounts_reason: message.toLowerCase(),
            accounts_status_code: status
          });

          _this.showError('showRateLimitError');
        } else {
          lurker$l.viewMessageEvt('error', {
            accounts_reason: message && typeof message === 'string' ? message.toLowerCase() : 'unexpected_message',
            accounts_status_code: status
          });

          _this.showError(genericError);
        }
      } else if (status) {
        lurker$l.viewMessageEvt('error', {
          accounts_reason: 'unexpected_status_code',
          accounts_status_code: status
        });

        _this.showError(genericError);
      } else {
        lurker$l.viewMessageEvt('error', {
          accounts_reason: 'unexpected_error',
          accounts_error_message: error && error.message || 'unknown'
        });

        _this.showError(genericError);
      }

      behaviors.scrollToTop();
    };

    _this.onSendPinCodeSuccess = function (data) {
      lurker$l.viewMessageEvt('success', {
        accounts_method: 'send_pincode',
        remote_addr: data.remoteAddress
      });

      if (_this.props.onSuccess) {
        _this.setState({
          showGenericError: false,
          showRateLimitError: false
        });

        _this.props.onSuccess(data);
      }
    };

    _this.onSendPinCode = function () {
      var token = _this.props.token;
      sendPinCode(token).then(_this.onSendPinCodeSuccess)["catch"](_this.onSendPinCodeError);
    };

    _this.handleSubmit = function () {
      _this.setState(_extends({}, errors$3), function () {
        return _this.onSendPinCode();
      });
    };

    _this.renderError = function () {
      var _this$state = _this.state,
          showGenericError = _this$state.showGenericError,
          showRateLimitError = _this$state.showRateLimitError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$7, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel enviar o c\xF3digo."
      })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$7, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: false,
        text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
      })));
    };

    _this.state = _extends({}, errors$3);
    return _this;
  }

  var _proto = ScorePinCodeTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$l.pageLoadEvt();
  };

  _proto.showError = function showError(error, extra) {
    var _extends2;

    this.setState(_extends({}, errors$3, extra, (_extends2 = {}, _extends2[error] = true, _extends2)));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        email = _this$props.email,
        isLocked = _this$props.isLocked,
        onSwitchEmail = _this$props.onSwitchEmail;
    return /*#__PURE__*/React.createElement(EmailFormBaseTemplate, {
      buttonText: "Enviar c\xF3digo",
      editable: false,
      email: email,
      errorPosition: "top",
      isLocked: isLocked,
      lurker: lurker$l,
      onSubmit: this.handleSubmit,
      onSwitchEmail: onSwitchEmail,
      renderError: this.renderError,
      renderTitle: renderDescription,
      submitEventName: "send_pincode"
    });
  };

  return ScorePinCodeTemplate;
}(React.Component);

ScorePinCodeTemplate["default"] = {
  isLocked: false
};
ScorePinCodeTemplate.propTypes = {
  token: PropTypes__default.string.isRequired,
  email: PropTypes__default.string.isRequired,
  onSuccess: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func,
  isLocked: PropTypes__default.bool
};

var _templateObject$25, _templateObject2$1y, _templateObject3$16;
var ContentWrapper = styled(View$1)(_templateObject$25 || (_templateObject$25 = _taggedTemplateLiteralLoose(["\n  padding: 24px 16px;\n  ", "\n"])), mediaQuery.desktop(_templateObject2$1y || (_templateObject2$1y = _taggedTemplateLiteralLoose(["\n    padding: 24px 56px;\n  "]))));
var HRuleWrapper$e = styled(View$1)(_templateObject3$16 || (_templateObject3$16 = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var ScorePinCodePage = function ScorePinCodePage(_ref) {
  var token = _ref.token,
      email = _ref.email,
      onSuccess = _ref.onSuccess,
      onSwitchEmail = _ref.onSwitchEmail;
  return /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Autentica\xE7\xE3o em duas etapas"
  }), /*#__PURE__*/React.createElement(ScorePinCodeTemplate, {
    token: token,
    email: email,
    onSuccess: onSuccess,
    onSwitchEmail: onSwitchEmail
  }), /*#__PURE__*/React.createElement(HRuleWrapper$e, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
    text: "",
    linkText: "Escolher outra op\xE7\xE3o para entrar",
    href: "/acesso",
    onClick: onSwitchEmail
  }));
};
ScorePinCodePage.propTypes = {
  token: PropTypes__default.string.isRequired,
  email: PropTypes__default.string.isRequired,
  onSuccess: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func
};

var _templateObject$26, _templateObject2$1z, _templateObject3$17, _templateObject4$M, _templateObject5$z;
var Content$$ = styled(View$1)(_templateObject$26 || (_templateObject$26 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"])));
var HelpText = styled(Subtitle)(_templateObject2$1z || (_templateObject2$1z = _taggedTemplateLiteralLoose(["\n  margin-top: 10px;\n"])));
var EmailChipWrapper$2 = styled(View$1)(_templateObject3$17 || (_templateObject3$17 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n  margin-bottom: 32px;\n"])));
var ButtonWrapper$6 = styled(View$1)(_templateObject4$M || (_templateObject4$M = _taggedTemplateLiteralLoose(["\n  margin-top: 32px;\n  margin-bottom: 16px;\n"])));
var FormContent$2 = styled(Form)(_templateObject5$z || (_templateObject5$z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));

var PinCodeValidationBaseTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(PinCodeValidationBaseTemplate, _BaseForm);

  function PinCodeValidationBaseTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.handleSubmit = function (event) {
      if (event) event.preventDefault();
      var onSubmit = _this.props.onSubmit;

      var _this$state$fields = _this.state.fields,
          _this$state$fields2 = _this$state$fields === void 0 ? {} : _this$state$fields,
          pincode = _this$state$fields2.pincode;

      if (!pincode.valid) return;

      _this.setState({
        isSubmitting: true
      });

      onSubmit(pincode.value).then(function () {
        return _this.setState({
          isSubmitting: false
        });
      })["catch"](function () {
        return _this.setState({
          isSubmitting: false
        });
      });
    };

    _this.onPinCodeChange = function (pincode, isValid) {
      _this.updateField('pincode', pincode, isValid, false, null, null);
    };

    _this.handleResendPinCode = function () {
      var onResend = _this.props.onResend;

      _this.setState({
        isResending: true
      });

      onResend().then(function () {
        return _this.setState(function (prevState) {
          return {
            resendCount: prevState.resendCount + 1,
            isResending: false,
            showResendCodeSuccessMessage: true
          };
        });
      })["catch"](function () {
        return _this.setState({
          isResending: false
        });
      });
    };

    _this.closeResendCodeSuccessMessage = function () {
      _this.setState({
        showResendCodeSuccessMessage: false
      });
    };

    _this.state = {
      resendCount: 0,
      isSubmitting: false,
      isResending: false,
      showResendCodeSuccessMessage: false,
      validators: {
        pincode: {
          action: null,
          message: ''
        }
      },
      fields: {
        pincode: {
          valid: false,
          pristine: true,
          value: null
        }
      }
    };
    return _this;
  }

  var _proto = PinCodeValidationBaseTemplate.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        renderError = _this$props.renderError,
        email = _this$props.email,
        onSwitchEmail = _this$props.onSwitchEmail,
        hasError = _this$props.hasError;
    var _this$state = this.state,
        isSubmitting = _this$state.isSubmitting,
        fields = _this$state.fields,
        isResending = _this$state.isResending,
        resendCount = _this$state.resendCount,
        showResendCodeSuccessMessage = _this$state.showResendCodeSuccessMessage;
    var pincode = fields.pincode;
    return /*#__PURE__*/React.createElement(Content$$, null, renderError(), /*#__PURE__*/React.createElement(HelpText, null, "Digite o c\xF3digo enviado para"), /*#__PURE__*/React.createElement(EmailChipWrapper$2, null, /*#__PURE__*/React.createElement(EmailChip, {
      onClick: onSwitchEmail
    }, email)), /*#__PURE__*/React.createElement(FormContent$2, {
      method: "POST",
      onSubmit: this.handleSubmit,
      noValidate: true
    }, /*#__PURE__*/React.createElement(PinCode, {
      disabled: isSubmitting,
      onSubmitEditing: this.handleSubmit,
      onChange: this.onPinCodeChange,
      hasError: hasError,
      pinCode: pincode
    }), /*#__PURE__*/React.createElement(ButtonWrapper$6, null, /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      disabled: !pincode.valid || isSubmitting,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, isSubmitting ? 'Confirmando o código...' : 'Confirmar código'))), resendCount < 3 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(formLabel, {
      text: "N\xE3o recebeu o c\xF3digo?",
      linkText: "Reenviar",
      onClick: this.handleResendPinCode,
      disabled: isResending
    })) : null, /*#__PURE__*/React.createElement(SuccessMessage, {
      text: "C\xF3digo reenviado com sucesso",
      show: showResendCodeSuccessMessage,
      onClose: this.closeResendCodeSuccessMessage
    }));
  };

  return PinCodeValidationBaseTemplate;
}(BaseForm);

PinCodeValidationBaseTemplate.propTypes = {
  email: PropTypes__default.string,
  hasError: PropTypes__default.bool,
  onResend: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func,
  renderError: PropTypes__default.func
};

var _templateObject$27;
var lurker$m = new Lurker('login');
var ErrorMsgWrapper$8 = styled(View$1)(_templateObject$27 || (_templateObject$27 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n  text-align: left;\n  width: 100%;\n"])));
var errors$4 = {
  showGenericError: false,
  showRateLimitError: false,
  showInvalidPinCodeError: false,
  showResendCodeError: false
};

var ScoreCheckPinCodeTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ScoreCheckPinCodeTemplate, _React$Component);

  function ScoreCheckPinCodeTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onResendPinCodeSuccess = function (eventName) {
      lurker$m.viewMessageEvt(eventName);
      var onResend = _this.props.onResend;

      if (typeof onResend === 'function') {
        onResend();
      }
    };

    _this.onGenericError = function (error, eventName) {
      if (error === void 0) {
        error = {};
      }

      if (eventName === void 0) {
        eventName = 'error';
      }

      var _error = error,
          _error$response = _error.response,
          _error$response2 = _error$response === void 0 ? {} : _error$response,
          status = _error$response2.status,
          _error$response2$data = _error$response2.data,
          _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
          message = _error$response2$data2.message;

      var genericError = 'showGenericError';

      if (eventName !== 'error') {
        genericError = 'showResendCodeError';
      }

      if (status === 401) {
        lurker$m.viewMessageEvt(eventName, {
          accounts_reason: 'pin_code_unauthorized',
          accounts_status_code: status
        });

        _this.showError(genericError);
      } else if (status === 429) {
        lurker$m.viewMessageEvt(eventName, {
          accounts_reason: 'pin_code_rate_limit_exceeded',
          accounts_status_code: status
        });

        _this.showError('showRateLimitError');
      } else if (status === 403) {
        switch (message) {
          case 'INVALID_PIN_CODE':
            lurker$m.viewMessageEvt(eventName, {
              accounts_reason: 'invalid_pin_code',
              accounts_status_code: status
            });

            _this.showError('showInvalidPinCodeError');

            break;

          case 'NO_PIN_CODE':
            lurker$m.viewMessageEvt(eventName, {
              accounts_reason: 'no_pin_code',
              accounts_status_code: status
            });

            _this.showError(genericError);

            break;

          case 'EXPIRED_PIN_CODE':
            lurker$m.viewMessageEvt(eventName, {
              accounts_reason: 'expired_pin_code',
              accounts_status_code: status
            });

            if (_this.props.onExpiredToken) {
              _this.props.onExpiredToken();
            }

            break;

          default:
            lurker$m.viewMessageEvt(eventName, {
              accounts_reason: message && typeof message === 'string' ? "pin_code_" + message.toLowerCase() : 'pin_code_unexpected_message',
              accounts_status_code: status
            });

            _this.showError(genericError);

        }
      } else if (status) {
        lurker$m.viewMessageEvt(eventName, {
          accounts_reason: 'pin_code_unexpected_status_code',
          accounts_status_code: status
        });

        _this.showError(genericError);
      } else {
        lurker$m.viewMessageEvt(eventName, {
          accounts_reason: 'pin_code_unexpected_error',
          accounts_error_message: error && error.message || 'unknown'
        });

        _this.showError(genericError);
      }

      behaviors.scrollToTop();
    };

    _this.onCheckPinCodeSuccess = function (data) {
      var onSuccess = _this.props.onSuccess;
      lurker$m.viewMessageEvt('email_login_success', {
        accounts_method: 'pin_code'
      });

      if (typeof onSuccess === 'function') {
        onSuccess(data);
      }
    };

    _this.handleResendPinCode = function () {
      var token = _this.props.token;

      _this.setState(_extends({}, errors$4));

      lurker$m.clickEvt('resend_email');
      return sendPinCode(token).then(function () {
        return _this.onResendPinCodeSuccess('resend_email_success');
      })["catch"](function (error) {
        _this.onGenericError(error, 'resend_email_error');

        throw error;
      });
    };

    _this.handleSubmit = function (pincode) {
      var token = _this.props.token;
      lurker$m.clickEvt('check_pincode');

      _this.setState(_extends({}, errors$4));

      return loginWithPinCode(token, pincode).then(function (response) {
        return _this.onCheckPinCodeSuccess(response.data);
      })["catch"](_this.onGenericError);
    };

    _this.showError = function (error) {
      var _extends2;

      _this.setState(_extends({}, errors$4, (_extends2 = {}, _extends2[error] = true, _extends2)));
    };

    _this.renderError = function () {
      var _this$state = _this.state,
          showGenericError = _this$state.showGenericError,
          showResendCodeError = _this$state.showResendCodeError,
          showInvalidPinCodeError = _this$state.showInvalidPinCodeError,
          showRateLimitError = _this$state.showRateLimitError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$8, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel validar seu c\xF3digo. Por favor, tente novamente."
      })), showResendCodeError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$8, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel reenviar o c\xF3digo. Por favor, tente novamente."
      })), showInvalidPinCodeError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$8, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "C\xF3digo inv\xE1lido! Confira o n\xFAmero que enviamos por e-mail e tente novamente."
      })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$8, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: false,
        text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
      })));
    };

    _this.state = _extends({}, errors$4);
    return _this;
  }

  var _proto = ScoreCheckPinCodeTemplate.prototype;

  _proto.render = function render() {
    var showInvalidPinCodeError = this.state.showInvalidPinCodeError;
    var _this$props = this.props,
        email = _this$props.email,
        onSwitchEmail = _this$props.onSwitchEmail;
    return /*#__PURE__*/React.createElement(PinCodeValidationBaseTemplate, {
      email: email,
      hasError: showInvalidPinCodeError,
      onResend: this.handleResendPinCode,
      onSubmit: this.handleSubmit,
      onSwitchEmail: onSwitchEmail,
      renderError: this.renderError
    });
  };

  return ScoreCheckPinCodeTemplate;
}(React.Component);

ScoreCheckPinCodeTemplate.propTypes = {
  email: PropTypes__default.string.isRequired,
  onExpiredToken: PropTypes__default.func,
  onResend: PropTypes__default.func,
  onSuccess: PropTypes__default.func.isRequired,
  onSwitchEmail: PropTypes__default.func,
  token: PropTypes__default.string.isRequired
};

var _templateObject$28, _templateObject2$1A;
var ContentWrapper$1 = styled(View$1)(_templateObject$28 || (_templateObject$28 = _taggedTemplateLiteralLoose(["\n  padding: 24px 16px;\n  ", "\n"])), mediaQuery.desktop(_templateObject2$1A || (_templateObject2$1A = _taggedTemplateLiteralLoose(["\n    padding: 24px 56px;\n  "]))));
var ScoreCheckPinCodePage = function ScoreCheckPinCodePage(_ref) {
  var email = _ref.email,
      token = _ref.token,
      onSuccess = _ref.onSuccess,
      onResend = _ref.onResend,
      onSwitchEmail = _ref.onSwitchEmail;
  return /*#__PURE__*/React.createElement(ContentWrapper$1, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Autentica\xE7\xE3o em duas etapas"
  }), /*#__PURE__*/React.createElement(ScoreCheckPinCodeTemplate, {
    email: email,
    token: token,
    onSuccess: onSuccess,
    onResend: onResend,
    onSwitchEmail: onSwitchEmail
  }));
};
ScoreCheckPinCodePage.propTypes = {
  email: PropTypes__default.string.isRequired,
  token: PropTypes__default.string.isRequired,
  onSuccess: PropTypes__default.func.isRequired,
  onResend: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func
};

var _templateObject$29, _templateObject2$1B, _templateObject3$18, _templateObject4$N, _templateObject5$A;
var Content$10 = styled(View$1)(_templateObject$29 || (_templateObject$29 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  overflow: hidden;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$1B || (_templateObject2$1B = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4px;\n    margin-bottom: 0;\n  "]))));
var CustomPaper = styled(Paper$1)(_templateObject3$18 || (_templateObject3$18 = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  ", "\n"])), mediaQuery.medium(_templateObject4$N || (_templateObject4$N = _taggedTemplateLiteralLoose(["\n    padding: 0;\n  "]))));
var FooterWrapper$4 = styled(View$1)(_templateObject5$A || (_templateObject5$A = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var ScorePinCodeStack = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ScorePinCodeStack, _React$Component);

  function ScorePinCodeStack(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onSendPinCodeSuccess = function () {
      var router = _this.state.router;

      _this.showSuccessMessage('E-mail enviado!');

      router.push('ScoreCheckPinCode');
    };

    _this.onResend = function () {};

    _this.showSuccessMessage = function (successMessage) {
      setTimeout(function () {
        return _this.setState({
          successMessage: successMessage,
          successMessageOpen: true
        });
      }, 100);
    };

    _this.renderScorePinCode = function () {
      var _this$props = _this.props,
          onSwitchEmail = _this$props.onSwitchEmail,
          email = _this$props.email,
          token = _this$props.token;
      return /*#__PURE__*/React.createElement(ScorePinCodePage, {
        onSuccess: _this.onSendPinCodeSuccess,
        token: token,
        email: email,
        onSwitchEmail: onSwitchEmail
      });
    };

    _this.renderScoreCheckPinCode = function () {
      var _this$props2 = _this.props,
          onSuccess = _this$props2.onSuccess,
          onSwitchEmail = _this$props2.onSwitchEmail,
          email = _this$props2.email,
          token = _this$props2.token;
      return /*#__PURE__*/React.createElement(ScoreCheckPinCodePage, {
        email: email,
        token: token,
        onSuccess: onSuccess,
        onResend: _this.onResend,
        onSwitchEmail: onSwitchEmail
      });
    };

    var _router = createNewRouter('ScorePinCode');

    _this.state = {
      router: _router
    };
    return _this;
  }

  var _proto = ScorePinCodeStack.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        router = _this$state.router,
        successMessage = _this$state.successMessage,
        successMessageOpen = _this$state.successMessageOpen;
    return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$10, null, /*#__PURE__*/React.createElement(CustomPaper, null, /*#__PURE__*/React.createElement(AccessNavigator, {
      router: router,
      routes: [{
        route: 'ScorePinCode',
        component: this.renderScorePinCode
      }, {
        route: 'ScoreCheckPinCode',
        component: this.renderScoreCheckPinCode
      }]
    }), /*#__PURE__*/React.createElement(SuccessMessage, {
      text: successMessage,
      show: successMessageOpen,
      onClose: function onClose() {
        return _this2.setState({
          successMessageOpen: false
        });
      }
    })), /*#__PURE__*/React.createElement(FooterWrapper$4, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))));
  };

  return ScorePinCodeStack;
}(React.Component);
ScorePinCodeStack.propTypes = {
  email: PropTypes__default.string,
  token: PropTypes__default.string,
  onSuccess: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func
};

var _templateObject$2a, _templateObject2$1C;
var Content$11 = styled(View$1)(_templateObject$2a || (_templateObject$2a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n"])));
var Callout = styled(link)(_templateObject2$1C || (_templateObject2$1C = _taggedTemplateLiteralLoose(["\n  margin-left: 6px;\n"])));

var errorMsgCallout = function errorMsgCallout(props) {
  return /*#__PURE__*/React.createElement(Content$11, null, /*#__PURE__*/React.createElement(errorMsg, null, props.text), /*#__PURE__*/React.createElement(Callout, {
    type: "primary",
    underline: true,
    href: props.href,
    onClick: props.onClick
  }, props.linkText));
};

errorMsgCallout.propTypes = {
  text: PropTypes__default.string.isRequired,
  linkText: PropTypes__default.string.isRequired,
  href: PropTypes__default.string,
  onClick: PropTypes__default.func
};

var emailAlreadyExists = (function () {
  return function () {
    return /*#__PURE__*/React.createElement(errorMsgCallout, {
      text: "Este e-mail j\xE1 possui cadastro.",
      linkText: "Esqueceu sua senha?",
      href: "/recuperacao-senha"
    });
  };
});

var _templateObject$2b;
var RuleWrapper = styled(View$1)(_templateObject$2b || (_templateObject$2b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-top: 24px;\n  margin-bottom: 16px;\n"])));

var _templateObject$2c;
var Content$12 = styled(View$1)(_templateObject$2c || (_templateObject$2c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));

var AlternativeRuler = function AlternativeRuler(props) {
  var subtitle = props.subtitle;
  return /*#__PURE__*/React.createElement(Content$12, null, /*#__PURE__*/React.createElement(RuleWrapper, null, /*#__PURE__*/React.createElement(ruleWithText, {
    text: "ou"
  })), !!subtitle && /*#__PURE__*/React.createElement(Subtitle, null, subtitle));
};

AlternativeRuler.propTypes = {
  subtitle: PropTypes__default.string
};

var API_ENDPOINT_WITH_TOKEN_AND_PHONE_VALIDATION = '/v4/accounts/create';
var API_ENDPOINT_CAPTCHA_REGISTRATION = '/v2/registration/captcha';
var secureStorage$1 = new SecureStorage('signup');
var smartLock$3 = new SmartLock('signup');
var registerWithCaptcha = function registerWithCaptcha(nickname, email, password, abTests, captchaToken) {
  return axios.post("" + API_ENDPOINT_CAPTCHA_REGISTRATION, {
    nickname: nickname,
    email: email.toLowerCase().trim(),
    password: password,
    platform: platform
  }, {
    headers: {
      'X-TestAB-Groups': abTests || '',
      'X-Accounts-Register-Recaptcha': captchaToken
    },
    withCredentials: true
  }).then(function (response) {
    try {
      var data = response.data,
          status = response.status;

      if (status !== 202) {
        lastLoginStorage.saveEmailLogin(data);
      }

      return Promise.resolve(smartLock$3.saveCredential(email, password, nickname)).then(function () {
        return Promise.resolve(secureStorage$1.saveCredential(email, password)).then(function () {
          return response;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  });
};
var registerAndValidateAccountWithToken = function registerAndValidateAccountWithToken(token, abTests) {
  return axios.post(API_ENDPOINT_WITH_TOKEN_AND_PHONE_VALIDATION, {
    token: token,
    platform: platform
  }, {
    headers: {
      'X-TestAB-Groups': abTests || ''
    },
    withCredentials: true
  }).then(function (response) {
    try {
      var data = response.data;
      lastLoginStorage.saveEmailLogin(data);
      return Promise.resolve(response);
    } catch (e) {
      return Promise.reject(e);
    }
  });
};

var _templateObject$2d, _templateObject2$1D, _templateObject3$19, _templateObject4$O, _templateObject5$B, _templateObject6$m;
var lurker$n = new Lurker('signup');
var tracker$2 = new Tracker('signup');
var Content$13 = styled(View$1)(_templateObject$2d || (_templateObject$2d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var PageForm$5 = styled(Form)(_templateObject2$1D || (_templateObject2$1D = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var ErrorMsgWrapper$9 = styled(View$1)(_templateObject3$19 || (_templateObject3$19 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var ButtonWrapper$7 = styled(View$1)(_templateObject4$O || (_templateObject4$O = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var RecaptchaWrapper$1 = styled(View$1)(_templateObject5$B || (_templateObject5$B = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var CaptchaErrorMsgView$1 = styled(View$1)(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 90%;\n"])));

var getPasswordExtraData$2 = function getPasswordExtraData(key, password) {
  var field = {};
  var passwordLevel = password.level;

  if (passwordLevel === -1) {
    field[key] = 'sequential';
  } else if (passwordLevel === 1 || passwordLevel === 2) {
    field[key] = 'weak';
  } else if (passwordLevel === 3) {
    field[key] = 'good';
  } else if (passwordLevel === 4) {
    field[key] = 'strong';
  }

  return field;
};

var ErrorEmailBlacklisted = function ErrorEmailBlacklisted() {
  return /*#__PURE__*/React.createElement(errorMsgCallout, {
    text: "Este e-mail n\xE3o pode ser utilizado."
  });
};

var ErrorNicknameBlacklisted = function ErrorNicknameBlacklisted() {
  return /*#__PURE__*/React.createElement(errorMsgCallout, {
    text: "Este apelido n\xE3o pode ser utilizado."
  });
};

var defaultEmailErrorMsg$2 = 'Por favor, insira um endereço de e-mail válido.';

var getErrorMessage$2 = function getErrorMessage(email) {
  if (email) {
    return defaultEmailErrorMsg$2;
  }

  return 'Este campo é obrigatório';
};

var getNickNameErrorMsg$1 = function getNickNameErrorMsg(value) {
  return value.length < 3 ? 'Por favor, preencha ao menos 3 caracteres' : 'Seu apelido não pode ter mais de 5 caracteres numéricos';
};

var maxRetriesReachedError = Error('REACHED_MAX_RETRIES');
var errors$5 = {
  showGenericError: false,
  showInactiveError: false,
  showNicknameBlacklistError: false,
  showEmailBlacklistError: false,
  showEmailNotFoundError: false,
  showGoogleInitializationError: false,
  showPasswordlessError: false
};
var recaptchaSiteKey$2 = '6LfPClEUAAAAAD_O4ppsMM0r5EX5pcV5PH12rBIn';

var RegisterTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(RegisterTemplate, _BaseForm);

  function RegisterTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.onNicknameChange = function (value, valid) {
      _this.updateField('nickname', value, valid, true);
    };

    _this.onNicknameBlur = function (value, valid) {
      var errorMsg = getNickNameErrorMsg$1(value);

      _this.updateField('nickname', value, valid, false, errorMsg);
    };

    _this.onEmailChange = function (event) {
      var value = event.target.value;

      _this.updateField('email', value, null, true);
    };

    _this.onEmailBlur = function (event) {
      var value = event.target.value;
      var valid = isValidEmail(value);
      var message = value.length > 0 && !valid ? 'Por favor, insira um endereço de e-mail válido.' : null;

      _this.updateField('email', value, valid, false, message);
    };

    _this.onPasswordChange = function (value, level, msg) {
      var fields = _extends({}, _this.state.fields);

      _this.setState({
        fields: _extends({}, fields, {
          password: {
            value: value,
            valid: _this.isValidPassword(value, level),
            level: level,
            msg: msg,
            pristine: false
          }
        })
      });
    };

    _this.onClickGoogleLoginContactLink = function () {
      lurker$n.clickEvt('test_click_fale_conosco');
    };

    _this.onOauthError = function (error) {
      if (_this.props.onError) {
        _this.props.onError(error);
      }

      var errorBox = 'showGenericError';

      if (error === 'google_initialization_error') {
        errorBox = 'showGoogleInitializationError';
      }

      _this.showError(errorBox, {
        isSubmitting: false
      });
    };

    _this.onCancel = function () {
      _this.setState({
        isSubmitting: false
      });
    };

    _this.onOauthSuccess = function (data) {
      if (_this.props.onRegisterSuccess) {
        _this.props.onRegisterSuccess(data);
      }

      _this.setState({
        isSubmitting: false
      });
    };

    _this.onOauthSubmit = function () {
      _this.setState({
        isSubmitting: true
      });
    };

    _this.sendEmailSignUpEventToGA = function () {
      if (window) {
        var _window2 = window,
            dataLayer = _window2.dataLayer;

        if (dataLayer) {
          dataLayer.push({
            event: 'email_signup_success'
          });
        }
      }
    };

    _this.doRegistration = function () {
      try {
        var _this$state2 = _this.state,
            fields = _this$state2.fields,
            abTests = _this$state2.abTests;
        var nickname = fields.nickname,
            email = fields.email,
            password = fields.password,
            recaptchaToken = fields.recaptchaToken;
        return Promise.resolve(registerWithCaptcha(nickname.value, email.value, password.value, abTests, recaptchaToken.value)).then(function (_ref) {
          var status = _ref.status,
              data = _ref.data;

          if (status === 202) {
            _this.sendEmailSignUpEventToGA();

            lurker$n.viewMessageEvt('send_email_success', _extends({}, getPasswordExtraData$2('password_strength', fields.password)));

            if (_this.props.onSendEmailSuccess) {
              _this.props.onSendEmailSuccess(email.value);
            }
          } else {
            _this.sendEmailSignUpEventToGA();

            lurker$n.viewMessageEvt('email_signup_success', _extends({
              remote_addr: data.remoteAddress
            }, getPasswordExtraData$2('password_strength', fields.password)));
            tracker$2.viewMessageEvt('sign_up_email', _extends({
              remote_addr: data.remoteAddress
            }, getPasswordExtraData$2('password_strength', fields.password)));

            if (_this.props.onRegisterSuccess) {
              _this.props.onRegisterSuccess(data);
            }
          }

          _this.setState({
            isSubmitting: false
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.doRegistrationStack = function () {
      try {
        var passwordlessSignIn = _this.props.passwordlessSignIn;
        var fields = _this.state.fields;

        _this.setState(errors$5);

        var _temp2 = _finallyRethrows(function () {
          return _catch(function () {
            return Promise.resolve(_this.doRegistration()).then(function () {});
          }, function (data) {
            if (_this.props.onError) {
              _this.props.onError();
            }

            var _data$response = data.response,
                response = _data$response === void 0 ? {} : _data$response;

            if (response.status === 409) {
              lurker$n.viewMessageEvt('error', {
                accounts_reason: 'already_signed_user',
                accounts_status_code: response.status
              });

              if (passwordlessSignIn) {
                passwordlessSendEmailApiCall(fields.email.value).then(function () {
                  fields.email.msg = 'Este e-mail já possui cadastro.';
                  fields.email.valid = false;

                  _this.showError('showPasswordlessError', {
                    passwordlessEmail: fields.email.value,
                    fields: fields
                  });
                })["catch"](function () {
                  return _this.showEmailAlreadyExistsError();
                });
              } else {
                _this.showEmailAlreadyExistsError();
              }
            } else if (response.status === 422) {
              lurker$n.viewMessageEvt('error', {
                accounts_reason: 'unprocessable_entity',
                accounts_status_code: response.status
              });

              _this.showError('showGenericError');
            } else if (response.status === 410) {
              lurker$n.viewMessageEvt('error', {
                accounts_reason: 'account_inactive',
                accounts_status_code: response.status
              });

              _this.showError('showInactiveError');
            } else if (response.status === 403) {
              if (response.data && response.data.message) {
                if (response.data.message === 'NICKNAME_IN_BLACKLIST') {
                  lurker$n.viewMessageEvt('error', {
                    accounts_reason: 'nickname_in_blacklist',
                    accounts_status_code: response.status
                  });
                  fields.nickname.msg = ErrorNicknameBlacklisted;
                  fields.nickname.valid = false;

                  _this.showError('showNicknameBlacklistError', {
                    fields: fields
                  });
                } else if (response.data.message === 'EMAIL_IN_BLACKLIST') {
                  lurker$n.viewMessageEvt('error', {
                    accounts_reason: 'email_in_blacklist',
                    accounts_status_code: response.status
                  });
                  fields.email.msg = ErrorEmailBlacklisted;
                  fields.email.valid = false;

                  _this.showError('showEmailBlacklistError', {
                    fields: fields
                  });
                } else if (response.data.message === 'BAD_EMAIL_RISK') {
                  lurker$n.viewMessageEvt('error', {
                    accounts_reason: 'bad_email_risk',
                    accounts_status_code: response.status
                  });
                  fields.email.msg = ' ';
                  fields.email.valid = false;

                  _this.showError('showEmailNotFoundError', {
                    fields: fields
                  });
                } else if (response.data.message === 'EMAIL_BOX_NOT_REACHABLE') {
                  lurker$n.viewMessageEvt('error', {
                    accounts_reason: 'email_box_not_reachable',
                    accounts_status_code: response.status
                  });
                  fields.email.msg = ' ';
                  fields.email.valid = false;

                  _this.showError('showEmailNotFoundError', {
                    fields: fields
                  });
                } else if (response.data.message === 'PROCESS_NOT_DONE_YET') {
                  lurker$n.viewMessageEvt('error', {
                    accounts_reason: 'pending_validation',
                    accounts_status_code: response.status
                  });
                  fields.email.msg = 'Ainda estamos procurando o seu email.';
                  fields.email.valid = false;
                } else if (_this.invalidRecaptchaToken(data)) {
                  lurker$n.viewMessageEvt('error', {
                    accounts_reason: 'register_recaptcha_invalid_token',
                    accounts_status_code: response.status
                  });

                  _this.showError('showGenericError');
                }
              } else {
                lurker$n.viewMessageEvt('error', {
                  accounts_reason: 'forbidden_without_reason',
                  accounts_status_code: response.status
                });

                _this.showError('showGenericError');
              }
            } else if (response.status === 400) {
              if (response.data && response.data.trim() === 'Missing recaptcha response token') {
                lurker$n.viewMessageEvt('error', {
                  accounts_reason: 'register_recaptcha_missing_token',
                  accounts_status_code: response.status
                });

                _this.showError('showGenericError');
              }
            } else if (response.status) {
              lurker$n.viewMessageEvt('error', {
                accounts_reason: 'unexpected_status_code',
                accounts_status_code: response.status
              });

              _this.showError('showGenericError');
            } else if (data === maxRetriesReachedError) {
              lurker$n.viewMessageEvt('error', {
                accounts_reason: 'reached_max_retries'
              });

              _this.showError('showGenericError');
            } else {
              lurker$n.viewMessageEvt('error', {
                accounts_reason: 'unexpected_error',
                accounts_error_message: data && data.message || 'unknown'
              });

              _this.showError('showGenericError');
            }

            _this.resetRecaptcha();

            behaviors.scrollToTop();
          });
        }, function (_wasThrown, _result) {
          _this.setState({
            isSubmitting: false
          });

          if (_wasThrown) throw _result;
          return _result;
        });

        return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.showEmailAlreadyExistsError = function () {
      var fields = _this.state.fields;
      fields.email.msg = emailAlreadyExists();
      fields.email.valid = false;

      _this.setState({
        fields: fields
      });
    };

    _this.handleSubmit = function (event) {
      try {
        event.preventDefault();
        lurker$n.clickEvt('email');
        return Promise.resolve(_this.validateBeforeSend()).then(function () {
          _this.setState(_extends({}, errors$5, {
            isSubmitting: true
          }));

          var fields = _this.state.fields;
          var password = fields.password;

          var _temp3 = _catch(function () {
            return Promise.resolve(_this.checkFormIsValid()).then(function () {
              return Promise.resolve(_this.doRegistrationStack()).then(function () {});
            });
          }, function () {
            lurker$n.viewMessageEvt('error', _extends({
              accounts_reason: 'invalid_fields'
            }, _this.getInvalidFields(), getPasswordExtraData$2('invalid_password_reason', password)));
          });

          if (_temp3 && _temp3.then) return _temp3.then(function () {});
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.onMailCheckSuggestionClick = function (suggestion) {
      lurker$n.viewMessageEvt('mailcheck_suggestion_accepted', {
        mailcheck_original: _this.state.fields.email.value,
        mailcheck_suggestion: suggestion
      });
      var valid = isValidEmail(suggestion);

      _this.updateField('email', suggestion, valid, true);

      _this.updateFocus('password');
    };

    _this.sendFacebookSignUpEventToGA = function () {
      if (window) {
        var _window4 = window,
            dataLayer = _window4.dataLayer;

        if (dataLayer) {
          dataLayer.push({
            event: 'facebook_signup_success'
          });
        }
      }
    };

    _this.onRecaptchaLoad = function () {
      return _this.setState({
        recaptchaReady: true
      });
    };

    _this.onRecaptchaVerify = function (recaptchaToken) {
      if (recaptchaToken) {
        _this.updateField('recaptchaToken', recaptchaToken, true);
      } else {
        _this.setState({
          isSubmitting: false
        });

        _this.recaptcha.reset();

        lurker$n.viewMessageEvt('error', {
          accounts_reason: 'recaptcha_failed_token'
        });

        _this.showError('showGenericError');
      }
    };

    _this.onRecaptchaError = function (e) {
      lurker$n.viewMessageEvt('error', {
        accounts_reason: 'recaptcha_error',
        accounts_error_message: e && e.message || 'unknown'
      });
    };

    _this.onRecaptchaExpiration = function () {
      return _this.updateField('recaptchaToken', '', false);
    };

    _this.state = _extends({}, errors$5, {
      abTests: _this.props.abTests || '',
      isSubmitting: false,
      validators: {
        nickname: {
          action: function action(value) {
            return isValidNickname(value);
          },
          message: function message(value) {
            return getNickNameErrorMsg$1(value);
          }
        },
        email: {
          action: isValidEmail,
          message: getErrorMessage$2
        },
        password: {
          action: _this.isValidPassword,
          message: _this.getPasswordErrorMessage
        },
        recaptchaToken: {
          action: function action(value) {
            return value;
          },
          message: 'Captcha não preenchido.'
        }
      },
      recaptchaReady: false,
      fields: {
        nickname: {
          value: '',
          pristine: true,
          valid: false
        },
        email: {
          value: '',
          pristine: true,
          valid: false
        },
        password: {
          value: '',
          pristine: true,
          valid: false,
          level: 0
        },
        recaptchaToken: {
          value: '',
          pristine: true,
          valid: false
        }
      }
    });
    return _this;
  }

  var _proto = RegisterTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$n.pageLoadEvt();
    tracker$2.pageLoadEvt();
  };

  _proto.showError = function showError(error, extra) {
    var _extends2;

    this.setState(_extends({}, errors$5, extra, (_extends2 = {}, _extends2[error] = true, _extends2)));
  };

  _proto.invalidRecaptchaToken = function invalidRecaptchaToken(error) {
    return error.data['error-codes'] && error.data['error-codes'][0] === 'invalid-input-response';
  };

  _proto.resetRecaptcha = function resetRecaptcha() {
    if (this.recaptcha) {
      this.recaptcha.reset();
    }
  };

  _proto.renderEmail = function renderEmail() {
    var _this2 = this;

    var _this$state3 = this.state,
        fields = _this$state3.fields,
        isSubmitting = _this$state3.isSubmitting;
    var email = fields.email;
    var emailHasError = !email.valid && !email.pristine;
    return /*#__PURE__*/React.createElement(DsMailCheckFormItem, {
      tip: "Enviaremos um e-mail de confirma\xE7\xE3o.",
      value: email.value,
      onChange: function onChange(event) {
        return _this2.onEmailChange(event);
      },
      onBlur: function onBlur(event) {
        return _this2.onEmailBlur(event);
      },
      error: email.msg,
      hasError: emailHasError,
      disabled: isSubmitting,
      onSubmitEditing: function onSubmitEditing() {
        return _this2.updateFocus('password');
      },
      onSuggestionClick: this.onMailCheckSuggestionClick,
      inputRef: function inputRef(x) {
        _this2.inputs.email = x;
      }
    });
  };

  _proto.renderPassword = function renderPassword() {
    var _this3 = this;

    var passwordSecurityVersion = this.props.passwordSecurityVersion;
    var fields = this.state.fields;
    var password = fields.password;
    var passwordHasError = !password.valid && !password.pristine;
    var pwdNewSecurityVersion = passwordSecurityVersion === 'newLayoutPasswordWeak' || passwordSecurityVersion === 'newLayoutPasswordStrong';
    return pwdNewSecurityVersion ? /*#__PURE__*/React.createElement(PasswordWithStrengthMeterAndTips, {
      label: "Senha",
      level: password.level,
      message: password.msg,
      hasError: passwordHasError,
      maxLength: 40,
      onChange: this.onPasswordChange,
      onBlur: this.onPasswordChange,
      value: password.value,
      inputRef: function inputRef(x) {
        _this3.inputs.password = x;
      },
      onSubmitEditing: this.handleSubmit
    }) : /*#__PURE__*/React.createElement(passwordWithStrengthMeter, {
      label: "Senha",
      tip: "Use letras, n\xFAmeros e caracteres especiais.",
      level: password.level,
      message: password.msg,
      hasError: passwordHasError,
      maxLength: 40,
      onChange: this.onPasswordChange,
      onBlur: this.onPasswordChange,
      value: password.value,
      inputRef: function inputRef(x) {
        _this3.inputs.password = x;
      },
      onSubmitEditing: this.handleSubmit
    });
  };

  _proto.renderRecaptcha = function renderRecaptcha() {
    var _this4 = this;

    var recaptchaToken = this.state.fields.recaptchaToken;
    var captchaHasError = !recaptchaToken.valid && !recaptchaToken.pristine;
    return /*#__PURE__*/React.createElement(RecaptchaWrapper$1, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Reaptcha, {
      ref: function ref(e) {
        _this4.recaptcha = e;
      },
      sitekey: recaptchaSiteKey$2,
      onLoad: this.onRecaptchaLoad,
      onVerify: this.onRecaptchaVerify,
      onError: this.onRecaptchaError,
      onExpire: this.onRecaptchaExpiration
    }), captchaHasError && /*#__PURE__*/React.createElement(CaptchaErrorMsgView$1, null, /*#__PURE__*/React.createElement(errorMsg, null, "Captcha n\xE3o preenchido."))));
  };

  _proto.render = function render() {
    var _this5 = this;

    var _this$props = this.props,
        facebookAppId = _this$props.facebookAppId,
        onRequireEmail = _this$props.onRequireEmail;
    var _this$state4 = this.state,
        showGenericError = _this$state4.showGenericError,
        showInactiveError = _this$state4.showInactiveError,
        showNicknameBlacklistError = _this$state4.showNicknameBlacklistError,
        showEmailBlacklistError = _this$state4.showEmailBlacklistError,
        showEmailNotFoundError = _this$state4.showEmailNotFoundError,
        showGoogleInitializationError = _this$state4.showGoogleInitializationError,
        showPasswordlessError = _this$state4.showPasswordlessError,
        fields = _this$state4.fields,
        isSubmitting = _this$state4.isSubmitting,
        passwordlessEmail = _this$state4.passwordlessEmail,
        abTests = _this$state4.abTests;
    var nickname = fields.nickname;
    var nicknameHasError = !nickname.valid && !nickname.pristine;
    return /*#__PURE__*/React.createElement(Content$13, null, /*#__PURE__*/React.createElement(OauthLoginCallout, {
      facebookAppId: facebookAppId,
      onCancel: this.onCancel,
      onError: this.onOauthError,
      onRequireEmail: onRequireEmail,
      onSubmit: this.onOauthSubmit,
      onUserLoggedIn: this.onOauthSuccess,
      onFacebookLoginCallback: this.sendFacebookSignUpEventToGA,
      lurker: lurker$n,
      tracker: tracker$2,
      hideDivider: true
    }), /*#__PURE__*/React.createElement(AlternativeRuler, null), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$9, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel criar sua conta. Por favor, tente novamente."
    })), showGoogleInitializationError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$9, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showGoogleInitializationError: true,
      text: "N\xE3o foi poss\xEDvel entrar com o Google."
    })), showNicknameBlacklistError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$9, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "Este apelido n\xE3o pode ser utilizado."
    })), showEmailBlacklistError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$9, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "Este e-mail n\xE3o pode ser utilizado."
    })), showEmailNotFoundError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$9, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showEmailNotFoundError: true,
      text: "Este e-mail n\xE3o existe."
    })), showInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$9, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: true,
      contactUsLink: "https://ajuda.olx.com.br/s/article/reativar-conta-na-olx",
      text: "Este e-mail n\xE3o pode mais ser usado"
    })), showPasswordlessError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$9, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Enviamos um e-mail " + (passwordlessEmail ? "para " + passwordlessEmail : '') + " \n              para ajudar a acessar sua conta rapidamente."
    })), /*#__PURE__*/React.createElement(PageForm$5, {
      method: "POST",
      onSubmit: this.handleSubmit
    }, /*#__PURE__*/React.createElement(NicknameFormItem, {
      onChange: function onChange(value, valid) {
        return _this5.onNicknameChange(value, valid);
      },
      onBlur: function onBlur(value, valid) {
        return _this5.onNicknameBlur(value, valid);
      },
      error: nickname.msg,
      hasError: nicknameHasError,
      value: nickname.value,
      blurOnSubmit: false,
      onSubmitEditing: function onSubmitEditing() {
        return _this5.updateFocus('email');
      },
      abTests: abTests
    }), this.renderEmail(), this.renderPassword(), this.renderRecaptcha(), /*#__PURE__*/React.createElement(ButtonWrapper$7, null, /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      disabled: isSubmitting,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, "Cadastre-se"))));
  };

  return RegisterTemplate;
}(BaseForm);

RegisterTemplate.defaultProps = {
  maxRetries: 10
};
RegisterTemplate.propTypes = {
  onRegisterSuccess: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  facebookAppId: PropTypes__default.string,
  maxRetries: PropTypes__default.number,
  onError: PropTypes__default.func,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  abTests: PropTypes__default.string,
  emailExistTest: PropTypes__default.bool
};

var _templateObject$2e, _templateObject2$1E, _templateObject3$1a, _templateObject4$P;
var Content$14 = styled(View$1)(_templateObject$2e || (_templateObject$2e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.medium(_templateObject2$1E || (_templateObject2$1E = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var HRuleWrapper$f = styled(View$1)(_templateObject3$1a || (_templateObject3$1a = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var FooterWrapper$5 = styled(View$1)(_templateObject4$P || (_templateObject4$P = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n"])));
var RegisterPage = function RegisterPage(props) {
  var onRegisterSuccess = props.onRegisterSuccess,
      onRequireEmail = props.onRequireEmail,
      onSubmit = props.onSubmit,
      onLoginClick = props.onLoginClick,
      onError = props.onError,
      facebookAppId = props.facebookAppId,
      passwordSecurityVersion = props.passwordSecurityVersion,
      abTests = props.abTests,
      emailExistTest = props.emailExistTest,
      passwordlessSignIn = props.passwordlessSignIn,
      onSendEmailSuccess = props.onSendEmailSuccess;
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$14, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Crie a sua conta. \xC9 gr\xE1tis!"
  }), /*#__PURE__*/React.createElement(RegisterTemplate, {
    onRegisterSuccess: onRegisterSuccess,
    onSubmit: onSubmit,
    onError: onError,
    facebookAppId: facebookAppId,
    onRequireEmail: onRequireEmail,
    passwordSecurityVersion: passwordSecurityVersion,
    abTests: abTests,
    emailExistTest: emailExistTest,
    passwordlessSignIn: passwordlessSignIn,
    onSendEmailSuccess: onSendEmailSuccess
  }), /*#__PURE__*/React.createElement(HRuleWrapper$f, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
    text: "J\xE1 tem uma conta?",
    linkText: "Entrar",
    href: "/acesso",
    onClick: onLoginClick
  })), /*#__PURE__*/React.createElement(FooterWrapper$5, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))));
};
RegisterPage.propTypes = {
  onRegisterSuccess: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onLoginClick: PropTypes__default.func,
  onError: PropTypes__default.func,
  facebookAppId: PropTypes__default.string.isRequired,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  abTests: PropTypes__default.string,
  emailExistTest: PropTypes__default.bool,
  passwordlessSignIn: PropTypes__default.bool,
  onSendEmailSuccess: PropTypes__default.func
};

var MailShieldIcon = function MailShieldIcon(props) {
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "0.1",
    d: "M48.1151 87.3105C69.7621 87.3105 87.3105 69.7621 87.3105 48.1151C87.3105 26.468 69.7621 8.91956 48.1151 8.91956C26.468 8.91956 8.91956 26.468 8.91956 48.1151C8.91956 69.7621 26.468 87.3105 48.1151 87.3105Z",
    fill: "#6E0AD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0587 24.6543L64.6549 17.2624C68.2709 16.7542 71.6453 19.2969 72.1535 22.9129L77.6974 62.3601C78.2056 65.9761 75.6628 69.3504 72.0469 69.8586L19.4506 77.2505C15.8346 77.7587 12.4603 75.216 11.9521 71.6L6.40818 32.1528C5.89999 28.5368 8.44273 25.1625 12.0587 24.6543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1656 25.6666C9.08684 26.0993 6.8832 28.8789 7.11251 31.9382L42.3902 49.9069L71.348 22.9108C70.7253 19.9067 67.8408 17.842 64.7619 18.2747L12.1656 25.6666ZM12.6974 71.7652L7.35389 33.7445L42.1772 51.4818C42.4581 51.6248 42.7985 51.577 43.029 51.362L71.6254 24.703L74.8224 46.0459C74.8838 46.4555 75.2656 46.7379 75.6753 46.6765C76.0849 46.6152 76.3672 46.2333 76.3059 45.8237L72.9011 23.0944C72.8995 23.0809 72.8976 23.0675 72.8953 23.0541C72.3179 19.0407 68.5712 16.2246 64.5531 16.7893L11.9569 24.1812C7.9307 24.7471 5.10218 28.5007 5.66802 32.5268L11.212 71.974C11.7778 76.0002 15.5314 78.8287 19.5576 78.2628L19.5593 78.2626L59.1061 72.6121C59.5161 72.5535 59.801 72.1736 59.7424 71.7635C59.6838 71.3535 59.3039 71.0686 58.8939 71.1272L19.3488 76.7774C16.143 77.228 13.1479 74.971 12.6974 71.7652ZM16.947 71.7634C16.709 72.1024 16.7909 72.5702 17.1299 72.8082C17.4689 73.0462 17.9367 72.9643 18.1747 72.6253L21.1437 68.3964C21.3817 68.0574 21.2999 67.5897 20.9609 67.3517C20.6219 67.1137 20.1541 67.1955 19.9161 67.5345L16.947 71.7634ZM21.969 64.6106C21.731 64.9496 21.8128 65.4173 22.1519 65.6553C22.4909 65.8934 22.9586 65.8115 23.1966 65.4725L32.5279 52.1818C32.7659 51.8428 32.6841 51.375 32.3451 51.137C32.0061 50.899 31.5383 50.9809 31.3003 51.3199L21.969 64.6106Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7259 49.9387C75.7259 49.9387 69.091 56.7795 62.8143 57.6617L64.879 72.3532C65.3056 75.3881 66.9349 77.9726 69.296 79.2585C71.6572 80.5444 78.8205 83.9689 79.1158 84.0681L80.6213 84.7709L81.8747 83.6803C82.1215 83.4346 88.0731 78.2373 90.0477 76.2717C91.9036 74.4635 92.8264 71.5203 92.3902 68.4164L90.3351 53.7939C83.9894 54.6857 75.7259 49.9387 75.7259 49.9387Z",
    fill: "#6E0AD6",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4062 67.3565L77.6672 71.2594L84.0696 62.7632",
    stroke: "white",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

MailShieldIcon.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
MailShieldIcon.defaultProps = {
  width: 96,
  height: 96
};

var _templateObject$2f, _templateObject2$1F, _templateObject3$1b, _templateObject4$Q, _templateObject5$C, _templateObject6$n, _templateObject7$j;
var lurker$o = new Lurker('email_confirmation_sent');
var Content$15 = styled(View$1)(_templateObject$2f || (_templateObject$2f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n"])));
var LabelBoxView$1 = styled(View$1)(_templateObject2$1F || (_templateObject2$1F = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var TitleWrapper$6 = styled(View$1)(_templateObject3$1b || (_templateObject3$1b = _taggedTemplateLiteralLoose(["\n  margin-top: 28px;\n"])));
var Description$c = styled(Text$1)(_templateObject4$Q || (_templateObject4$Q = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 24px;\n  margin-bottom: 8px;\n"])));
var SafetyTip = styled(View$1)(_templateObject5$C || (_templateObject5$C = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n  margin: 0;\n"])));
var BoxWrapper$1 = styled(GenericBox)(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteralLoose(["\n  justify-content: center;\n  min-height: 52px;\n  margin-top: 24px;\n  max-width: 305px;\n  height: 52px;\n  padding: 0;\n"])));
var IconWrapper$6 = styled(View$1)(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteralLoose(["\n  margin-right: 8px;\n  padding: 0;\n"])));

var EmailConfirmationSentTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EmailConfirmationSentTemplate, _React$Component);

  function EmailConfirmationSentTemplate() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.render = function () {
      var _this$props = _this.props,
          onEmailClick = _this$props.onEmailClick,
          email = _this$props.email;
      return /*#__PURE__*/React.createElement(Content$15, null, /*#__PURE__*/React.createElement(MailShieldIcon, null), /*#__PURE__*/React.createElement(TitleWrapper$6, null, /*#__PURE__*/React.createElement(Text$1, {
        size: "title2",
        weight: "semiBold"
      }, "Verifique seu e-mail")), /*#__PURE__*/React.createElement(Description$c, {
        size: "body1",
        weight: "regular"
      }, "Voc\xEA precisa concluir uma etapa r\xE1pida antes de criar sua conta. Clique no bot\xE3o do e-mail que enviamos para"), /*#__PURE__*/React.createElement(LabelBoxView$1, null, /*#__PURE__*/React.createElement(EmailChip, {
        href: "#",
        onClick: onEmailClick
      }, truncate(email))), /*#__PURE__*/React.createElement(BoxWrapper$1, {
        direction: "column"
      }, /*#__PURE__*/React.createElement(SafetyTip, null, /*#__PURE__*/React.createElement(IconWrapper$6, null, /*#__PURE__*/React.createElement(Icons.System.Award, {
        size: "16",
        color: "#999999"
      })), /*#__PURE__*/React.createElement(Text$1, {
        size: "body2",
        color: "grayscale.darker"
      }, "Conquistar\xE1 selo de e-mail verificado."))));
    };

    return _this;
  }

  var _proto = EmailConfirmationSentTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$o.pageLoadEvt();
  };

  return EmailConfirmationSentTemplate;
}(React.Component);

EmailConfirmationSentTemplate.propTypes = {
  email: PropTypes__default.string.isRequired,
  onEmailClick: PropTypes__default.func.isRequired
};

var _templateObject$2g, _templateObject2$1G, _templateObject3$1c, _templateObject4$R;
var Content$16 = styled(View$1)(_templateObject$2g || (_templateObject$2g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.small(_templateObject2$1G || (_templateObject2$1G = _taggedTemplateLiteralLoose(["\n    margin-top: 24px;\n    margin-bottom: 24px;\n    margin-left: 0px;\n    margin-right: 0px;\n  "]))));
var CustomPaper$1 = styled(Paper$1)(_templateObject3$1c || (_templateObject3$1c = _taggedTemplateLiteralLoose(["\n  padding: 40px 54px 44px 56px;\n"])));
var TermsAndPrivacyNoticeWrapper = styled(View$1)(_templateObject4$R || (_templateObject4$R = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n"])));
var EmailConfirmationSentPage = function EmailConfirmationSentPage(_ref) {
  var email = _ref.email,
      onEmailClick = _ref.onEmailClick;
  return /*#__PURE__*/React.createElement(Content$16, null, /*#__PURE__*/React.createElement(CustomPaper$1, null, /*#__PURE__*/React.createElement(EmailConfirmationSentTemplate, {
    email: email,
    onEmailClick: onEmailClick
  })), /*#__PURE__*/React.createElement(TermsAndPrivacyNoticeWrapper, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null)));
};
EmailConfirmationSentPage.propTypes = {
  email: PropTypes__default.string.isRequired,
  onEmailClick: PropTypes__default.func.isRequired
};

var LogoGreyMessage = function LogoGreyMessage() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "96",
    height: "96",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,86.18A38.18,38.18,0,1,0,9.82,48,38.18,38.18,0,0,0,48,86.18Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.06,23.65l52.59-7.39a6.66,6.66,0,0,1,7.5,5.65L77.7,61.36a6.66,6.66,0,0,1-5.65,7.5l-52.6,7.39A6.65,6.65,0,0,1,12,70.6L6.41,31.15A6.66,6.66,0,0,1,12.06,23.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.57,80.36a17.87,17.87,0,1,0-25.19-2A17.88,17.88,0,0,0,79.57,80.36Z",
    fill: "#999",
    stroke: "#4a4a4a",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.79,66.84a.47.47,0,0,0-.66,0,.49.49,0,0,0,0,.66l3.08,3.08a.46.46,0,0,0,.65,0l6.75-6.79a.46.46,0,0,0-.65-.65L66.53,69.6Z",
    fill: "#fff",
    stroke: "#fff",
    "stroke-width": "2.5",
    "fill-rule": "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "96",
    height: "96",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,86.2A38.2,38.2,0,1,0,9.76,48h0A38.2,38.2,0,0,0,48,86.2Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.09,23.7l52.6-7.4A6.66,6.66,0,0,1,72.16,22h0l5.5,39.4A6.66,6.66,0,0,1,72,68.9h0l-52.6,7.4a6.66,6.66,0,0,1-7.5-5.68h0L6.36,31.2a6.59,6.59,0,0,1,5.56-7.48h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.26,44.7,72.86,22a7.47,7.47,0,0,0-8.3-6.3L12,23.2a7.4,7.4,0,0,0-6.3,8.3L11.16,71a7.4,7.4,0,0,0,8.3,6.3l23.8-3.7a.76.76,0,1,0-.3-1.5h0l-23.8,3.7a5.82,5.82,0,0,1-6.5-5l-5.3-38,34.8,17.7a1,1,0,0,0,.9-.1l28.6-26.7L74.76,45a.76.76,0,1,0,1.5-.3ZM42.36,49,7.09,31a5.94,5.94,0,0,1,5.1-6.3l52.6-7.3a5.82,5.82,0,0,1,6.6,4.6Z",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.86,66.6l-3,4.2a.72.72,0,0,0,1.2.8h0l3-4.2a.72.72,0,1,0-1.2-.8Z",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.26,50.3,22,63.6a.72.72,0,0,0,1.2.8h0l9.3-13.3a.72.72,0,1,0-1.2-.8Z",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56,80.4a17.88,17.88,0,1,0-25.21-2h0A17.89,17.89,0,0,0,79.56,80.4Z",
    fill: "#999",
    stroke: "#4a4a4a",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25,66.78l3.43-3.43a1.62,1.62,0,0,0-2.29-2.28L68,64.5l-3.43-3.43a1.62,1.62,0,0,0-2.29,2.28l3.43,3.43-3.43,3.43a1.62,1.62,0,0,0,2.29,2.29L68,69.07l3.43,3.43a1.62,1.62,0,0,0,2.29-2.29Z",
    fill: "#fff"
  }));
};

var _templateObject$2h, _templateObject2$1H, _templateObject3$1d, _templateObject4$S, _templateObject5$D;
var lurker$p = new Lurker('signup');
var tracker$3 = new Tracker('signup');
var Content$17 = styled(View$1)(_templateObject$2h || (_templateObject$2h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n"])));
var initialErrors = {
  showGenericError: false,
  showInvalidTokenError: false,
  showRateLimitError: false
};
var LogoWrapper = styled(View$1)(_templateObject2$1H || (_templateObject2$1H = _taggedTemplateLiteralLoose(["\n  margin-bottom: 32px;\n"])));
var Description$d = styled(Text$1)(_templateObject3$1d || (_templateObject3$1d = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  width: 328px;\n  height: 72px;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n"])));
var TryAgain = styled(Text$1)(_templateObject4$S || (_templateObject4$S = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  width: 328px;\n  height: 24px;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n"])));
var ButtonWrapper$8 = styled(View$1)(_templateObject5$D || (_templateObject5$D = _taggedTemplateLiteralLoose(["\n  margin-top: 48px;\n  width: 100%;\n  height: 50px;\n"])));

var RegisterWithTokenTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RegisterWithTokenTemplate, _React$Component);

  function RegisterWithTokenTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.doRegistration = function () {
      try {
        var _this$props2 = _this.props,
            token = _this$props2.token,
            onRegisterSuccess = _this$props2.onRegisterSuccess,
            onError = _this$props2.onError;
        return Promise.resolve(_catch(function () {
          var registerCall = registerAndValidateAccountWithToken;
          return Promise.resolve(registerCall(token)).then(function (_ref) {
            var data = _ref.data;

            if (window) {
              var _window2 = window,
                  dataLayer = _window2.dataLayer;

              if (dataLayer) {
                dataLayer.push({
                  event: 'email_signup_success'
                });
              }
            }

            lurker$p.viewMessageEvt('email_signup_success', {
              remote_addr: data.remoteAddress
            });
            tracker$3.viewMessageEvt('sign_up_email', {
              remote_addr: data.remoteAddress
            });

            if (onRegisterSuccess) {
              console.log(data);
              onRegisterSuccess(data.token);
            }

            return null;
          });
        }, function (error) {
          var _error$response = error.response,
              _error$response2 = _error$response === void 0 ? {} : _error$response,
              status = _error$response2.status,
              _error$response2$data = _error$response2.data,
              _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
              message = _error$response2$data2.message,
              _error$message = error.message,
              exceptionMessage = _error$message === void 0 ? 'unknown' : _error$message;

          if (onError) {
            onError(error);
          }

          if (status === 429) return _this.handle429();
          return status ? _this.handleError(status, message) : _this.handleUnexpectedError(exceptionMessage);
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.handle429 = function () {
      _this.handleExpectedStatusCode(429, 'rate_limit_exceeded', 'showRateLimitError');
    };

    _this.handleError = function (status, message) {
      if (message === void 0) {
        message = 'unexpected_status_code';
      }

      switch (message) {
        case 'INVALID_TOKEN':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showInvalidTokenError');

          break;

        default:
          _this.handleUnexpectedStatusCode(status, message);

      }
    };

    _this.handleExpectedStatusCode = function (status, message, error) {
      lurker$p.viewMessageEvt('error', {
        accounts_reason: message,
        accounts_status_code: status
      });

      _this.showError(error);
    };

    _this.handleUnexpectedStatusCode = function (status, message) {
      lurker$p.viewMessageEvt('error', {
        accounts_reason: 'unexpected_status_code',
        accounts_status_code: status,
        accounts_error_message: message && typeof message === 'string' ? "" + message.toLowerCase() : 'unknown'
      });

      _this.showError('showGenericError');
    };

    _this.handleUnexpectedError = function (message) {
      if (message === void 0) {
        message = 'unknown';
      }

      lurker$p.viewMessageEvt('error', {
        accounts_reason: 'unexpected_error',
        accounts_error_message: message
      });

      _this.showError('showGenericError');
    };

    _this.showError = function (error) {
      var _extends2;

      _this.setState({
        errors: _extends({}, initialErrors, (_extends2 = {}, _extends2[error] = true, _extends2))
      });
    };

    _this.state = {
      errors: initialErrors
    };
    return _this;
  }

  var _proto = RegisterWithTokenTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.doRegistration();
  };

  _proto.render = function render() {
    var onRetryRegister = this.props.onRetryRegister;
    var errors = this.state.errors;

    if (Object.values(errors).some(function (i) {
      return i;
    })) {
      return /*#__PURE__*/React.createElement(Content$17, null, /*#__PURE__*/React.createElement(LogoWrapper, null, /*#__PURE__*/React.createElement(LogoGreyMessage, null)), /*#__PURE__*/React.createElement(Title, null, "N\xE3o foi poss\xEDvel criar a sua conta"), /*#__PURE__*/React.createElement(Description$d, null, "O bot\xE3o de verifica\xE7\xE3o enviado por e-mail possui validade, por isso n\xE3o conseguimos concluir a cria\xE7\xE3o de sua conta."), /*#__PURE__*/React.createElement(TryAgain, null, "Por favor, tente novamente."), /*#__PURE__*/React.createElement(ButtonWrapper$8, null, /*#__PURE__*/React.createElement(Button$1, {
        onClick: onRetryRegister,
        size: "large",
        fluid: true
      }, "Tentar novamente")));
    }

    return null;
  };

  return RegisterWithTokenTemplate;
}(React.Component);

RegisterWithTokenTemplate.propTypes = {
  abTests: PropTypes__default.string,
  onError: PropTypes__default.func.isRequired,
  onRegisterSuccess: PropTypes__default.func.isRequired,
  onRetryRegister: PropTypes__default.func.isRequired,
  token: PropTypes__default.string.isRequired
};

var _templateObject$2i, _templateObject2$1I;
var ContentWrapper$2 = styled(Paper$1)(_templateObject$2i || (_templateObject$2i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  padding: 32px 64px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.small(_templateObject2$1I || (_templateObject2$1I = _taggedTemplateLiteralLoose(["\n    margin: 24px 0;\n  "]))));
var RegisterWithTokenPage = function RegisterWithTokenPage(_ref) {
  var abTests = _ref.abTests,
      onError = _ref.onError,
      onRegisterSuccess = _ref.onRegisterSuccess,
      onRetryRegister = _ref.onRetryRegister,
      token = _ref.token;
  return /*#__PURE__*/React.createElement(ContentWrapper$2, null, /*#__PURE__*/React.createElement(RegisterWithTokenTemplate, {
    abTests: abTests,
    onError: onError,
    onRegisterSuccess: onRegisterSuccess,
    onRetryRegister: onRetryRegister,
    token: token
  }));
};
RegisterWithTokenPage.propTypes = {
  abTests: PropTypes__default.string,
  onError: PropTypes__default.func.isRequired,
  onRegisterSuccess: PropTypes__default.func.isRequired,
  onRetryRegister: PropTypes__default.func.isRequired,
  token: PropTypes__default.string.isRequired
};

var sendSMS$1 = function sendSMS(phone) {
  return axios.post('/v2/pincode/send/sms', {
    phone: phone,
    platform: platform
  }, {
    withCredentials: true
  });
};
var sendSMSv4 = function sendSMSv4(phone, token) {
  if (!token) return new Promise(function (resolve, reject) {
    return reject('No token');
  });
  return axios.post('/v4/pincode/send/sms', {
    phone: phone,
    platform: platform
  }, {
    withCredentials: true,
    headers: {
      Authorization: token
    }
  });
};
var makeCall$1 = function makeCall(phone) {
  return axios.post('/v2/pincode/make/call', {
    phone: phone,
    platform: platform
  }, {
    withCredentials: true
  });
};
var makeCallv4 = function makeCallv4(phone, token) {
  if (!token) return new Promise(function (resolve, reject) {
    return reject('No token');
  });
  return axios.post('/v3/pincode/make/call', {
    phone: phone,
    platform: platform
  }, {
    withCredentials: true,
    headers: {
      Authorization: token
    }
  });
};
var checkCode = function checkCode(phone, code) {
  return axios.post('/v1/pincode/check', {
    phone: phone,
    code: code,
    platform: platform,
    attemptsCheck: true
  }, {
    withCredentials: true
  });
};
var checkCodev4 = function checkCodev4(phone, code, token) {
  if (!token) return new Promise(function (resolve, reject) {
    return reject('No token');
  });
  return axios.post('/v2/user/login/verify_pincode', {
    phone: phone,
    code: code,
    platform: platform,
    token: token,
    type: 'PHONE'
  });
};
var phoneOverride = function phoneOverride(phone, code) {
  return axios.post('/v1/phone/override', {
    phone: phone,
    code: code,
    platform: platform
  }, {
    withCredentials: true
  });
};
var phoneOverridev4 = function phoneOverridev4(phone, code, token) {
  if (!token) return new Promise(function (resolve, reject) {
    return reject('No token');
  });
  return axios.post('/v2/user/login/phone_override', {
    phone: phone,
    code: code,
    platform: platform,
    token: token
  });
};
var phoneCheckReceivedCode = function phoneCheckReceivedCode(phone) {
  return axios.post('/v1/attempts/phone/check', {
    phone: phone,
    platform: platform
  }, {
    withCredentials: true
  });
};
var phoneCheckReceivedCodev4 = function phoneCheckReceivedCodev4(phone, token) {
  if (!token) return new Promise(function (resolve, reject) {
    return reject('No token');
  });
  return axios.post('/v2/attempts/phone/check', {
    phone: phone,
    platform: platform
  }, {
    withCredentials: true,
    headers: {
      Authorization: token
    }
  });
};

var BrazilFlag = function BrazilFlag() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2398_40882)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "8",
    fill: "#24A148"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3L15 7.99999L8 13L8 3ZM8 3.00012L1 8.00011L8 13.0001L8 3.00012Z",
    fill: "#F3D603"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "3",
    fill: "#012775"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2398_40882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
};

var _excluded$d = ["onChange", "stateMessage", "isDirty", "isTouched", "error", "clearErrors"];

var _templateObject$2j, _templateObject2$1J;
var PhoneLabel = styled.div(_templateObject$2j || (_templateObject$2j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 62px;\n  height: 48px;\n  border-radius: var(--border-radius-sm);\n  background-color: var(--color-neutral-80);\n"])));
var PhoneInputWrapper = styled(TextInput$1)(_templateObject2$1J || (_templateObject2$1J = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  margin-left: var(--spacing-stack-nano);\n"])));
var PhoneInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _onChange = _ref.onChange,
      isDirty = _ref.isDirty,
      error = _ref.error,
      clearErrors = _ref.clearErrors,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(PhoneLabel, null, /*#__PURE__*/React.createElement(BrazilFlag, null), /*#__PURE__*/React.createElement(Flex, {
    marginLeft: "--spacing-stack-quarck"
  }, "+55")), /*#__PURE__*/React.createElement(PhoneInputWrapper, _extends({
    ref: ref,
    placeholder: "(99) 99999-9999",
    "aria-label": "telefone",
    onChange: function onChange(e) {
      return _onChange(getMaskedValue(e.target.value).pretty);
    },
    state: isDirty && !!error && 'error',
    stateMessage: "Digite um telefone v\xE1lido com DDD.",
    onFocus: clearErrors,
    maxLength: 15
  }, rest)));
});
PhoneInput.propTypes = {
  onChange: PropTypes__default.func,
  isDirty: PropTypes__default.bool,
  isTouched: PropTypes__default.bool,
  error: PropTypes__default.any,
  stateMessage: PropTypes__default.string
};

var _templateObject$2k;
var StyledAlertbox = styled(Alertbox)(_templateObject$2k || (_templateObject$2k = _taggedTemplateLiteralLoose(["\n  ", "\n"])), withFlex);
var ErrorAlertbox = function ErrorAlertbox(_ref) {
  var title = _ref.title,
      customIcon = _ref.customIcon,
      children = _ref.children,
      _ref$showContactUs = _ref.showContactUs,
      showContactUs = _ref$showContactUs === void 0 ? true : _ref$showContactUs;
  return /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    marginBottom: "--spacing-stack-xxs"
  }, /*#__PURE__*/React.createElement(StyledAlertbox, {
    icon: customIcon ? customIcon : /*#__PURE__*/React.createElement(AlertTriangle$1, null),
    flex: "1",
    title: title,
    variant: "error"
  }, /*#__PURE__*/React.createElement(Text.BodyMedium, null, children), showContactUs && /*#__PURE__*/React.createElement(Flex, {
    marginTop: "--spacing-stack-quarck"
  }, /*#__PURE__*/React.createElement(ErrorLink, {
    href: faleConosco
  }, "Em caso de d\xFAvidas, fale com a gente."))));
};
ErrorAlertbox.propTypes = {
  title: PropTypes__default.string,
  customIcon: PropTypes__default.element,
  showContactUs: PropTypes__default.bool
};

function useWindowSize() {
  var _useState = useState({
    width: undefined,
    height: undefined,
    isMobile: undefined
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  useEffect(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < breakpoints['mobile'] + 1
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}

var _templateObject$2l, _templateObject2$1K, _templateObject3$1e;
var StyledFlex = styled(Flex)(_templateObject$2l || (_templateObject$2l = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n  }\n  flex-direction: column;\n"])), breakpoints['mobile']);
var Wrapper$b = styled.div(_templateObject2$1K || (_templateObject2$1K = _taggedTemplateLiteralLoose(["\n  color: red;\n  div[data-ds-component='DS-Modal'] {\n    div[role='dialog'] {\n      @media screen and (max-width: ", "px) {\n        padding: var(--spacing-stack-xxs);\n      }\n    }\n  }\n"])), breakpoints['mobile']);
var ButtonsWrapper = styled.div(_templateObject3$1e || (_templateObject3$1e = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: ", "px) {\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: flex-end;\n    margin-top: var(--spacing-stack-nano);\n  }\n"])), breakpoints['mobile'] + 1);
var ResponsiveModal = function ResponsiveModal(_ref) {
  var children = _ref.children,
      renderButtons = _ref.renderButtons,
      closeModal = _ref.closeModal,
      isOpen = _ref.isOpen;

  var _useWindowSize = useWindowSize(),
      isMobile = _useWindowSize.isMobile;

  return /*#__PURE__*/React.createElement(Wrapper$b, null, /*#__PURE__*/React.createElement(Modal$1, {
    preventCloseOnOutsideClick: true,
    open: isOpen,
    size: isMobile ? 'small' : 'medium',
    maxWidth: !isMobile ? '600px' : undefined,
    closeCallback: closeModal,
    desktopModalVariant: !isMobile
  }, /*#__PURE__*/React.createElement(StyledFlex, null, children, /*#__PURE__*/React.createElement(ButtonsWrapper, null, renderButtons))));
};
ResponsiveModal.propTypes = {
  renderButtons: PropTypes__default.element
};

var _templateObject$2m;
var StyledButton = styled(Button)(_templateObject$2m || (_templateObject$2m = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin-bottom: var(--spacing-stack-nano);\n  }\n  @media screen and (min-width: ", "px) {\n    margin-left: var(--spacing-stack-nano);\n  }\n"])), breakpoints['mobile'], breakpoints['mobile'] + 1);
var ConfirmPhoneNumberModal = function ConfirmPhoneNumberModal(_ref) {
  var onConfirm = _ref.onConfirm,
      closeModal = _ref.closeModal,
      isOpen = _ref.isOpen,
      isSubmitting = _ref.isSubmitting,
      phone = _ref.phone;

  var _useWindowSize = useWindowSize(),
      isMobile = _useWindowSize.isMobile;

  return /*#__PURE__*/React.createElement(ResponsiveModal, {
    isOpen: isOpen,
    closeModal: closeModal,
    renderButtons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledButton, {
      "aria-label": "Confirmar telefone",
      onClick: onConfirm,
      fullWidth: isMobile,
      isLoading: isSubmitting,
      disabled: isSubmitting
    }, "Confirmar"), /*#__PURE__*/React.createElement(StyledButton, {
      variant: "link-button",
      fullWidth: isMobile,
      onClick: closeModal,
      disabled: isSubmitting
    }, "Alterar n\xFAmero"))
  }, /*#__PURE__*/React.createElement(Text.TitleSmall, {
    marginBottom: "--spacing-stack-xxs"
  }, phone), /*#__PURE__*/React.createElement(Text.BodyMedium, {
    marginBottom: "--spacing-stack-xs"
  }, "Confirme se voc\xEA digitou o n\xFAmero corretamente."));
};
ConfirmPhoneNumberModal.propTypes = {
  onConfirm: PropTypes__default.func,
  isOpen: PropTypes__default.bool,
  isSubmitting: PropTypes__default.bool,
  closeModal: PropTypes__default.func,
  phone: PropTypes__default.string
};

var getPhoneValidationAtRegisterExperiment = function getPhoneValidationAtRegisterExperiment(abTests) {
  return abTests && abTests.indexOf('acc-force-phone-validation_enabled') > -1;
};

var _templateObject$2n, _templateObject2$1L, _templateObject3$1f, _templateObject4$T, _templateObject5$E;
var ButtonsWrapper$1 = styled.div(_templateObject$2n || (_templateObject$2n = _taggedTemplateLiteralLoose(["\n  margin-top: var(--spacing-stack-xxs);\n  display: flex;\n  justify-content: end;\n  @media screen and (max-width: ", "px) {\n    justify-content: center;\n    flex-direction: column-reverse;\n    align-items: center;\n    flex: 1;\n  }\n"])), breakpoints['mobile']);
var Form$1 = styled.form(_templateObject2$1L || (_templateObject2$1L = _taggedTemplateLiteralLoose([""])));
var ContainerWrapper = styled(Container$7)(_templateObject3$1f || (_templateObject3$1f = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    border: none;\n    padding: 0;\n  }\n"])), breakpoints['mobile']);
var StyledButton$1 = styled(Button)(_templateObject4$T || (_templateObject4$T = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin: 0;\n    width: 100%;\n    margin-bottom: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile']);
var StyledText$1 = styled(Text.BodyMedium)(_templateObject5$E || (_templateObject5$E = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    font-size: var(--font-size-xxs);\n  }\n"])), breakpoints['mobile']);
var lurker$q = new Lurker('phone_input');
var SendPinCodeTemplate = function SendPinCodeTemplate(_ref) {
  var onClickBounce = _ref.onClickBounce,
      onSuccess = _ref.onSuccess,
      onPinCodeSent = _ref.onPinCodeSent,
      onAlreadyHasCodeClick = _ref.onAlreadyHasCodeClick,
      lockTime = _ref.lockTime,
      showBounceLink = _ref.showBounceLink,
      abTests = _ref.abTests,
      token = _ref.token;

  var _useForm = useForm({
    reValidateMode: 'onBlur',
    mode: 'onBlur',
    defaultValues: {
      phone: ''
    }
  }),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      getValues = _useForm.getValues,
      _clearErrors = _useForm.clearErrors;

  var _useState = useState({
    showGenericError: false,
    showRateLimitError: false,
    showPhoneInUseError: false,
    showPhoneInBlackListError: false
  }),
      errors = _useState[0],
      setErrors = _useState[1];

  var _useState2 = useState(false),
      isSubmitting = _useState2[0],
      setIsSubmitting = _useState2[1];

  var _useState3 = useState(false),
      modalOpen = _useState3[0],
      setModalOpen = _useState3[1];

  var onSendCodeClick = function onSendCodeClick(e) {
    e.preventDefault();
    setModalOpen(true);
  };

  var isLocked = lockTime > 0;

  var showError = function showError(error) {
    setErrors(function (errors) {
      var _extends2;

      return _extends({}, errors, (_extends2 = {}, _extends2[error] = true, _extends2));
    });
    setIsSubmitting(false);
  };

  var bounceClick = function bounceClick(event) {
    lurker$q.clickEvt('bounce');
    if (event) event.preventDefault();
    onClickBounce();
  };

  var onValidatePhoneSuccess = function onValidatePhoneSuccess(phone, opts) {
    if (opts === void 0) {
      opts = {};
    }

    lurker$q.viewMessageEvt('success', opts);

    if (onPinCodeSent) {
      onPinCodeSent();
    }

    setIsSubmitting(false);

    if (onSuccess) {
      onSuccess(phone);
    }
  };

  var closeModal = function closeModal(e) {
    if (e) e.preventDefault();
    setModalOpen(false);
  };

  var onValidatePhoneError = function onValidatePhoneError(error, opts) {
    if (error === void 0) {
      error = {};
    }

    if (opts === void 0) {
      opts = {};
    }

    var _error = error,
        _error$response = _error.response,
        _error$response2 = _error$response === void 0 ? {} : _error$response,
        status = _error$response2.status,
        message = _error$response2.data.message;

    if (status === 401) {
      lurker$q.viewMessageEvt('error', _extends({
        accounts_reason: 'unauthorized',
        accounts_status_code: status
      }, opts));
      showError('showGenericError');
    } else if (status === 429) {
      lurker$q.viewMessageEvt('error', _extends({
        accounts_reason: 'rate_limit_exceeded',
        accounts_status_code: status
      }, opts));
      showError('showRateLimitError');
    } else if (status === 403) {
      switch (message) {
        case 'PHONE_IN_BLACKLIST':
          lurker$q.viewMessageEvt('error', _extends({
            accounts_reason: 'phone_number_in_blacklist',
            accounts_status_code: status
          }, opts));
          showError('showPhoneInBlackListError');
          break;

        case 'PHONE_IN_USE':
          lurker$q.viewMessageEvt('error', _extends({
            accounts_reason: 'phone_number_already_in_use',
            accounts_status_code: status
          }, opts));
          showError('showPhoneInUseError');
          break;

        case 'ACCOUNT_LOCKED':
          lurker$q.viewMessageEvt('error', _extends({
            accounts_reason: message.toLowerCase(),
            accounts_status_code: status
          }, opts));
          showError('showRateLimitError');
          break;

        default:
          lurker$q.viewMessageEvt('error', _extends({
            accounts_reason: message && typeof message === 'string' ? message.toLowerCase() : 'unexpected_status_code',
            accounts_status_code: status
          }, opts));
          showError('showGenericError');
      }
    } else if (status) {
      lurker$q.viewMessageEvt('error', _extends({
        accounts_reason: 'unexpected_status_code',
        accounts_status_code: status
      }, opts));
      showError('showGenericError');
    } else {
      lurker$q.viewMessageEvt('error', _extends({
        accounts_reason: 'unexpected_error',
        accounts_error_message: error && error.message || 'unknown'
      }, opts));
      showError('showGenericError');
    }
  };

  var phoneVerifyClick = function phoneVerifyClick(event) {
    if (event) event.preventDefault();
    lurker$q.clickEvt('phone_already_received_pincode_click');
    onAlreadyHasCodeClick(getValues('phone'));
  };

  var onSubmit = function onSubmit(data) {
    var phone = removeMask(data.phone);
    var landLine = isLandline(phone);
    var trackingOpts = {
      landLine: landLine,
      phone: phone
    };
    lurker$q.clickEvt('submit', trackingOpts);
    setIsSubmitting(true);
    var sendSMSCall = token && getPhoneValidationAtRegisterExperiment(abTests) ? function (phone) {
      return sendSMSv4(phone, token);
    } : sendSMS$1;
    var makePhoneCall = token && getPhoneValidationAtRegisterExperiment(abTests) ? function (phone) {
      return makeCallv4(phone, token);
    } : makeCall$1;
    var actionPromise = landLine ? makePhoneCall(phone) : sendSMSCall(phone);
    actionPromise.then(function () {
      onValidatePhoneSuccess(phone, trackingOpts);
    })["catch"](function (error) {
      return onValidatePhoneError(error, trackingOpts);
    })["finally"](closeModal);
  };

  useEffect(function () {
    lurker$q.pageLoadEvt();
  }, []);
  var shouldShowBounceLink = showBounceLink && !token && !getPhoneValidationAtRegisterExperiment(abTests);
  return /*#__PURE__*/React.createElement(Form$1, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(ContainerWrapper, {
    type: "outlined",
    paddingBottom: "--spacing-stack-xl",
    paddingTop: "--spacing-stack-xl",
    paddingLeft: "--spacing-stack-xl",
    paddingRight: "--spacing-stack-xl"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(StyledText$1, {
    marginBottom: "--spacing-stack-xs"
  }, "Enviaremos um c\xF3digo por SMS pra verificar seu n\xFAmero. Em caso de telefone fixo, ligaremos."), errors.showGenericError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    title: "Falha em nosso sistema",
    showContactUs: false
  }, "Estamos trabalhando pra resolver rapidinho. Tente novamente em alguns minutos."), errors.showPhoneInBlackListError && /*#__PURE__*/React.createElement(ErrorAlertbox, null, "Este n\xFAmero n\xE3o pode ser cadastrado novamente."), errors.showPhoneInUseError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    showContactUs: false,
    title: "Limite di\xE1rio atingido para este n\xFAmero"
  }, "Tente novamente daqui ", formatedTime(lockTime), ", ou use outro n\xFAmero de telefone."), /*#__PURE__*/React.createElement(Controller, {
    name: "phone",
    control: control,
    rules: {
      validate: function validate(phone) {
        return isValid(removeMask(phone));
      }
    },
    render: function render(_ref2) {
      var field = _ref2.field,
          fieldState = _ref2.fieldState;
      return /*#__PURE__*/React.createElement(PhoneInput, _extends({}, field, fieldState, {
        clearErrors: function clearErrors() {
          return _clearErrors('phone');
        }
      }));
    }
  }), isLocked && /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "link-button",
    marginTop: "--spacing-stack-nano",
    size: "small",
    onClick: phoneVerifyClick
  }, "J\xE1 tem um c\xF3digo?")), /*#__PURE__*/React.createElement(Flex, {
    marginBottom: "--spacing-stack-nano",
    marginTop: "--spacing-stack-xxs"
  }, /*#__PURE__*/React.createElement(Alertbox, null, /*#__PURE__*/React.createElement(StyledText$1, {
    weight: "semibold"
  }, "O mesmo n\xFAmero de telefone n\xE3o pode ser usado em mais de uma conta OLX."))), /*#__PURE__*/React.createElement(Alertbox, {
    icon: /*#__PURE__*/React.createElement(Lock, null)
  }, /*#__PURE__*/React.createElement(StyledText$1, {
    weight: "semibold"
  }, "Seu n\xFAmero n\xE3o ser\xE1 exibido para outros usu\xE1rios.")))), /*#__PURE__*/React.createElement(ButtonsWrapper$1, null, shouldShowBounceLink && /*#__PURE__*/React.createElement(StyledButton$1, {
    variant: "link-button",
    size: "large",
    onClick: bounceClick,
    disabled: isSubmitting,
    marginRight: "--spacing-stack-xxxs",
    type: "button"
  }, "Verificar depois"), /*#__PURE__*/React.createElement(StyledButton$1, {
    size: "large",
    disabled: !formState.isValid || isLocked,
    type: "button",
    role: "button",
    "aria-label": "Enviar c\xF3digo",
    onClick: onSendCodeClick
  }, isLocked ? "Enviar c\xF3digo em " + formatedTime(lockTime) : 'Enviar código'))), /*#__PURE__*/React.createElement(ConfirmPhoneNumberModal, {
    phone: getValues('phone'),
    closeModal: closeModal,
    isSubmitting: isSubmitting,
    isOpen: modalOpen,
    onConfirm: handleSubmit(onSubmit)
  }));
};

var accountLockedAttempts = 3;
var CountdownContext = /*#__PURE__*/createContext({
  lockTime: -1,
  checkAttemptLockTime: function checkAttemptLockTime(token, abTests) {},
  attempts: 0
});

var CountdownProvider = function CountdownProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(-1),
      lockTime = _useState[0],
      setLockTime = _useState[1];

  var _useState2 = useState(0),
      attempts = _useState2[0],
      setAttempts = _useState2[1];

  var countdown = function countdown() {
    if (lockTime >= -1) {
      return setTimeout(function () {
        setLockTime(function (lockTime) {
          return lockTime - 1;
        });
      }, 1000);
    }
  };

  var checkAttemptLockTime = function checkAttemptLockTime(token, abTests) {
    var getAttemptCheckCall = token ? function () {
      return getAttemptCheckv2(token);
    } : getAttemptCheck;
    getAttemptCheckCall().then(function (data) {
      var remaining = data.remaining_time,
          attempts = data.attempts;

      if (remaining > 0) {
        setLockTime(remaining);
      }

      setAttempts(attempts);
    });
  };

  var isAccountLocked = attempts >= accountLockedAttempts;
  useEffect(function () {
    var pid = countdown();
    return function () {
      return clearTimeout(pid);
    };
  }, [lockTime]);
  return /*#__PURE__*/React.createElement(CountdownContext.Provider, {
    value: {
      lockTime: lockTime,
      isAccountLocked: isAccountLocked,
      checkAttemptLockTime: checkAttemptLockTime
    }
  }, children);
};

var _templateObject$2o, _templateObject2$1M;
var PincodeWrapper$1 = styled.div(_templateObject$2o || (_templateObject$2o = _taggedTemplateLiteralLoose(["\n  max-width: 600px;\n  flex: 1;\n  flex-direction: column;\n  margin: auto;\n  @media screen and (min-width: ", "px) and (max-width: ", "px) {\n    width: 80vw;\n  }\n  @media screen and (max-width: ", "px) {\n    margin: 0 auto;\n    justify-content: center;\n    margin-left: var(--spacing-stack-xxxs);\n    margin-right: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile'] + 1, breakpoints['tablet'], breakpoints['mobile']);
var StyledTitle = styled(Text.TitleLarge)(_templateObject2$1M || (_templateObject2$1M = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin-bottom: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile']);
var SendPinCodePage = function SendPinCodePage(_ref) {
  var onSuccess = _ref.onSuccess,
      onClickBounce = _ref.onClickBounce,
      onAlreadyHasCodeClick = _ref.onAlreadyHasCodeClick,
      showBounceLink = _ref.showBounceLink,
      abTests = _ref.abTests,
      token = _ref.token;

  var _useContext = useContext(CountdownContext),
      lockTime = _useContext.lockTime,
      checkAttemptLockTime = _useContext.checkAttemptLockTime;

  useEffect(function () {
    checkAttemptLockTime(token, abTests);
  }, []);
  return /*#__PURE__*/React.createElement(PincodeWrapper$1, null, /*#__PURE__*/React.createElement(StyledTitle, {
    marginBottom: "--spacing-stack-xs"
  }, "Verifica\xE7\xE3o de telefone"), /*#__PURE__*/React.createElement(SendPinCodeTemplate, {
    onSuccess: onSuccess,
    onClickBounce: onClickBounce,
    onAlreadyHasCodeClick: onAlreadyHasCodeClick,
    showBounceLink: showBounceLink,
    lockTime: lockTime,
    abTests: abTests,
    token: token
  }));
};
SendPinCodePage.propTypes = {
  onSuccess: PropTypes__default.func,
  onClickBounce: PropTypes__default.func,
  onAlreadyHasCodeClick: PropTypes__default.func,
  showBounceLink: PropTypes__default.bool,
  lockTime: PropTypes__default.number,
  abTests: PropTypes__default.string,
  token: PropTypes__default.string
};

var _templateObject$2p, _templateObject2$1N;
var StyledFlex$1 = styled(Flex)(_templateObject$2p || (_templateObject$2p = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var PhoneText$1 = styled.span(_templateObject2$1N || (_templateObject2$1N = _taggedTemplateLiteralLoose(["\n  font-weight: var(--font-weight-bold);\n"])));
var ConfirmResendCodeModal = function ConfirmResendCodeModal(_ref) {
  var onConfirm = _ref.onConfirm,
      closeModal = _ref.closeModal,
      isOpen = _ref.isOpen,
      isSubmitting = _ref.isSubmitting,
      phone = _ref.phone;
  return /*#__PURE__*/React.createElement(Modal$1, {
    preventCloseOnOutsideClick: true,
    open: isOpen,
    size: "small",
    closeCallback: closeModal
  }, /*#__PURE__*/React.createElement(StyledFlex$1, {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Text.TitleSmall, {
    marginBottom: "--spacing-stack-xxs"
  }, "Reenviar c\xF3digo"), /*#__PURE__*/React.createElement(Text.BodyMedium, {
    marginBottom: "--spacing-stack-xs"
  }, "Deseja reenviar o c\xF3digo para o n\xFAmero", ' ', /*#__PURE__*/React.createElement(PhoneText$1, null, getMaskedValue(phone).pretty), "?"), /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm,
    fullWidth: true,
    isLoading: isSubmitting,
    disabled: isSubmitting,
    marginBottom: "--spacing-stack-nano"
  }, "Reenviar"), /*#__PURE__*/React.createElement(Button, {
    variant: "link-button",
    fullWidth: true,
    onClick: closeModal,
    disabled: isSubmitting
  }, "Cancelar")));
};
ConfirmResendCodeModal.propTypes = {
  onConfirm: PropTypes__default.func,
  isOpen: PropTypes__default.bool,
  isSubmitting: PropTypes__default.bool,
  closeModal: PropTypes__default.func,
  phone: PropTypes__default.string
};

var LoadingSpinner = function LoadingSpinner(_ref) {
  var label = _ref.label,
      ariaLabel = _ref['aria-label'],
      size = _ref.size;
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: size,
    "aria-label": ariaLabel
  }), label && /*#__PURE__*/React.createElement(Text.BodySmall, {
    marginTop: "--spacing-stack-xxxs"
  }, label));
};
LoadingSpinner.defaultProps = {
  size: 'large'
};
LoadingSpinner.propTypes = {
  label: PropTypes__default.string,
  size: PropTypes__default.string,
  'aria-label': PropTypes__default.string.isRequired
};

var _templateObject$2q, _templateObject2$1O;
var Content$18 = styled(View$1)(_templateObject$2q || (_templateObject$2q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"])));
var FormContent$3 = styled(Form)(_templateObject2$1O || (_templateObject2$1O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var defaultErrors = {
  showGenericError: false,
  showRateLimitError: false,
  showPhoneInUseError: false,
  showMaxPhoneValidationError: false,
  showPhoneInBlackListError: false,
  showInvalidPinCodeError: false,
  showResendCodeError: false,
  showMaxAccountCheckAttempts: false
};
var defaultRemainingAttempts = 4;

var CheckPinCodeTemplate = function CheckPinCodeTemplate(_ref) {
  var checkCode = _ref.checkCode,
      sendSMS = _ref.sendSMS,
      makeCall = _ref.makeCall,
      onSmsReceived = _ref.onSmsReceived,
      onSmsTimeout = _ref.onSmsTimeout,
      onResend = _ref.onResend,
      onSuccess = _ref.onSuccess,
      onPinCodeError = _ref.onPinCodeError,
      lockTime = _ref.lockTime,
      phone = _ref.phone,
      lurker = _ref.lurker;

  var _useState = useState(0),
      pincodeLocktime = _useState[0],
      setPincodeLocktime = _useState[1];

  var _useState2 = useState(defaultRemainingAttempts),
      remainingAttempts = _useState2[0],
      setRemainingAttempts = _useState2[1];

  var _useState3 = useState(defaultErrors),
      errors = _useState3[0],
      setErrors = _useState3[1];

  var _useState4 = useState(false),
      modalOpen = _useState4[0],
      setModalOpen = _useState4[1];

  var _useState5 = useState(false),
      isSubmitting = _useState5[0],
      setIsSubmitting = _useState5[1];

  var _useState6 = useState(false),
      isResending = _useState6[0],
      setIsResending = _useState6[1];

  var _useState7 = useState(''),
      customErrorMsg = _useState7[0],
      setCustomErrorMsg = _useState7[1];

  var _useState8 = useState(false),
      showResendCodeSuccessMessage = _useState8[0],
      setShowResendCodeSuccessMessage = _useState8[1];

  useEffect(function () {
    lurker.pageLoadEvt();

    if (onSmsReceived) {
      onSmsReceived(function (smsData) {
        lurker.viewMessageEvt('auto_sms_success');
        onPinCodeChange(smsData.pinCode, true);
      });
    }

    if (onSmsTimeout) {
      onSmsTimeout(function () {
        lurker.viewMessageEvt('auto_sms_error');
      });
    }
  }, []);

  var onMaxAccountCheckAttemptReached = function onMaxAccountCheckAttemptReached(locktime) {
    setPincodeLocktime(locktime);
  };

  var updateRemainingAttempts = function updateRemainingAttempts(remainingAttempts) {
    setRemainingAttempts(remainingAttempts);
  };

  var showError = function showError(error, customMsg) {
    var _extends2;

    if (customMsg === void 0) {
      customMsg = '';
    }

    setErrors(_extends({}, defaultErrors, (_extends2 = {}, _extends2[error] = true, _extends2)));
    setIsSubmitting(false);
    setIsResending(false);
    setCustomErrorMsg(customMsg);
  };

  var onPinCodeChange = function onPinCodeChange(pinCode, isValid) {
    if (isValid) {
      lurker.clickEvt('submit');
      setIsSubmitting(true);
      checkCode(phone, pinCode).then(onCheckPinCodeSuccess)["catch"](function (error) {
        return onPinCodeError(error, 'error', pinCode, showError, onMaxAccountCheckAttemptReached, updateRemainingAttempts);
      })["finally"](function () {
        return setIsSubmitting(false);
      });
    }
  };

  var resendCodeBySMS = function resendCodeBySMS() {
    setIsResending(true);
    lurker.clickEvt('resend_sms');

    if (isLandline(phone)) {
      makeCall(phone).then(function () {
        return onResendCodeSuccess('make_call_success');
      })["catch"](function (error) {
        return onPinCodeError(error, 'make_call_error', '', showError, onMaxAccountCheckAttemptReached, updateRemainingAttempts);
      })["finally"](function () {
        if (typeof onResend === 'function') {
          onResend();
        }
      });
    } else {
      sendSMS(phone).then(function () {
        return onResendCodeSuccess('resend_sms_success');
      })["catch"](function (error) {
        return onPinCodeError(error, 'resend_sms_error', '', showError, onMaxAccountCheckAttemptReached, updateRemainingAttempts);
      })["finally"](function () {
        if (typeof onResend === 'function') {
          onResend();
        }
      });
    }
  };

  var resendCodeByCall = function resendCodeByCall() {
    setIsResending(true);
    lurker.clickEvt('make_call');
    makeCall(phone).then(function () {
      return onResendCodeSuccess('make_call_success');
    })["catch"](function (error) {
      return onPinCodeError(error, 'make_call_error', '', showError, onMaxAccountCheckAttemptReached, updateRemainingAttempts);
    })["finally"](function () {
      if (typeof onResend === 'function') {
        onResend();
      }
    });
  };

  var closeResendCodeSuccessMessage = function closeResendCodeSuccessMessage() {
    setShowResendCodeSuccessMessage(true);
  };

  var onResendCodeSuccess = function onResendCodeSuccess(eventName) {
    lurker.viewMessageEvt(eventName);
    setShowResendCodeSuccessMessage(true);
    setIsResending(false);
  };

  var onCheckPinCodeSuccess = function onCheckPinCodeSuccess() {
    lurker.viewMessageEvt('success');
    setIsSubmitting(false);

    if (typeof onSuccess === 'function') {
      onSuccess(removeMask(phone));
    }
  };

  var closeModal = function closeModal(event) {
    if (event) event.preventDefault();
    setModalOpen(false);
  };

  var onResendClick = function onResendClick() {
    return setModalOpen(true);
  };

  var onResendConfirm = function onResendConfirm() {
    if (isLandline(phone)) {
      resendCodeByCall();
    } else {
      resendCodeBySMS();
    }

    closeModal();
  };

  var showGenericError = errors.showGenericError,
      showMaxPhoneValidationError = errors.showMaxPhoneValidationError,
      showPhoneInUseError = errors.showPhoneInUseError,
      showRateLimitError = errors.showRateLimitError,
      showPhoneInBlackListError = errors.showPhoneInBlackListError,
      showInvalidPinCodeError = errors.showInvalidPinCodeError,
      showResendCodeError = errors.showResendCodeError,
      showMaxAccountCheckAttempts = errors.showMaxAccountCheckAttempts;
  var maskedPhone = getMaskedValue(phone, false);
  return /*#__PURE__*/React.createElement(Content$18, null, isSubmitting ? /*#__PURE__*/React.createElement(LoadingSpinner, {
    label: "Concluindo verifica\xE7\xE3o",
    "aria-label": "Validando c\xF3digo"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.BodyMedium, {
    marginBottom: "--spacing-stack-xs",
    display: "inline"
  }, "Insira o c\xF3digo recebido no n\xFAmero", ' ', /*#__PURE__*/React.createElement(Text.BodyMedium, {
    weight: "semibold",
    display: "inline-block"
  }, maskedPhone.pretty)), showGenericError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    showContactUs: false
  }, "N\xE3o foi poss\xEDvel validar seu telefone. Por favor, tente novamente."), showResendCodeError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    showContactUs: false
  }, "N\xE3o foi poss\xEDvel reenviar o c\xF3digo. Por favor, tente novamente."), showPhoneInUseError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    showContactUs: false
  }, "Este n\xFAmero de telefone j\xE1 est\xE1 sendo usado na OLX."), showPhoneInBlackListError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    showContactUs: false
  }, "Este n\xFAmero n\xE3o pode ser cadastrado novamente."), showMaxPhoneValidationError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    showContactUs: false,
    title: "Limite di\xE1rio atingido para este n\xFAmero"
  }, customErrorMsg || 'Tente novamente amanhã ou use outro número de telefone.'), showRateLimitError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    showContactUs: false
  }, "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."), showMaxAccountCheckAttempts && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    title: "Limite di\xE1rio de tentativas atingido",
    showContactUs: false
  }, "Tente novamente em ", formatedTime(pincodeLocktime), "."), showInvalidPinCodeError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    title: "C\xF3digo incorreto",
    showContactUs: false
  }, "Voc\xEA tem mais", ' ', remainingAttempts + " " + (remainingAttempts === 1 ? 'tentativa' : 'tentativas'), ". Ao esgot\xE1-las, s\xF3 poder\xE1 tentar de novo em 24h."), /*#__PURE__*/React.createElement(FormContent$3, {
    method: "POST",
    noValidate: true
  }, /*#__PURE__*/React.createElement(PinCode, {
    disabled: isSubmitting || remainingAttempts === 0,
    onChange: function onChange(pincode, isValid) {
      onPinCodeChange(pincode, isValid);
    },
    onFocus: function onFocus() {
      setErrors(function (errors) {
        return _extends({}, errors, {
          showInvalidPinCodeError: false
        });
      });
    },
    hasError: showInvalidPinCodeError
  })), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    marginTop: "--spacing-stack-xs"
  }, lockTime <= 0 && remainingAttempts > 0 && /*#__PURE__*/React.createElement(Text.BodySmall, null, "N\xE3o recebeu?"), /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Reenviar c\xF3digo",
    disabled: lockTime > 0 || isResending || remainingAttempts === 0,
    onClick: onResendClick,
    marginLeft: "--spacing-stack-quarck",
    size: "small",
    variant: "link-button"
  }, lockTime > 0 ? "Reenviar c\xF3digo em " + formatedTime(lockTime) : 'Reenviar código')), /*#__PURE__*/React.createElement(SuccessMessage, {
    text: "C\xF3digo reenviado com sucesso",
    show: showResendCodeSuccessMessage,
    onClose: closeResendCodeSuccessMessage
  }), /*#__PURE__*/React.createElement(ConfirmResendCodeModal, {
    phone: phone,
    onConfirm: onResendConfirm,
    closeModal: closeModal,
    isSubmitting: isResending,
    isOpen: modalOpen
  })));
};

var _templateObject$2r, _templateObject2$1P, _templateObject3$1g, _templateObject4$U;
var lurker$r = new Lurker('phone_validation');
var Wrapper$c = styled.div(_templateObject$2r || (_templateObject$2r = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  margin: auto;\n  @media (max-width: ", "px) {\n    margin-left: var(--spacing-stack-xxxs);\n    margin-right: var(--spacing-stack-xxxs);\n  }\n  @media (min-width: 840px) {\n    max-width: 600px;\n  }\n  @media (min-width: ", "px) and (max-width: ", "px) {\n    width: 80vw;\n  }\n"])), breakpoints['mobile'], breakpoints['mobile'] + 1, breakpoints['tablet']);
var ContainerWrapper$1 = styled(Container$7)(_templateObject2$1P || (_templateObject2$1P = _taggedTemplateLiteralLoose(["\n  @media (max-width: ", "px) {\n    border: none !important;\n    padding: 0;\n  }\n"])), breakpoints['mobile']);
var StyledArrow = styled(ArrowLeft)(_templateObject3$1g || (_templateObject3$1g = _taggedTemplateLiteralLoose(["\n  color: var(--color-neutral-darkest);\n"])));
var ArrowContainer = styled.div(_templateObject4$U || (_templateObject4$U = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-bottom: var(--spacing-stack-xs);\n"])));

var CheckPinCodePage = function CheckPinCodePage(_ref) {
  var onBackClick = _ref.onBackClick,
      onSuccess = _ref.onSuccess,
      onPhoneConflict = _ref.onPhoneConflict,
      phone = _ref.phone,
      token = _ref.token,
      abTests = _ref.abTests;

  var _useContext = useContext(CountdownContext),
      lockTime = _useContext.lockTime,
      checkAttemptLockTime = _useContext.checkAttemptLockTime;

  var onPinCodeError = function onPinCodeError(error, eventName, pincode, showError, onMaxAccountCheckAttemptReached, updateRemainingAttempts) {
    if (error === void 0) {
      error = {};
    }

    if (eventName === void 0) {
      eventName = 'error';
    }

    if (pincode === void 0) {
      pincode = '';
    }

    if (showError === void 0) {
      showError = function showError() {};
    }

    if (onMaxAccountCheckAttemptReached === void 0) {
      onMaxAccountCheckAttemptReached = function onMaxAccountCheckAttemptReached() {};
    }

    if (updateRemainingAttempts === void 0) {
      updateRemainingAttempts = function updateRemainingAttempts() {};
    }

    var _error = error,
        _error$response = _error.response,
        _error$response2 = _error$response === void 0 ? {} : _error$response,
        status = _error$response2.status,
        _error$response2$data = _error$response2.data,
        _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
        _error$response2$data3 = _error$response2$data2.message,
        message = _error$response2$data3 === void 0 ? '' : _error$response2$data3,
        _error$response2$data4 = _error$response2$data2.current_email,
        email = _error$response2$data4 === void 0 ? '' : _error$response2$data4,
        _error$response2$data5 = _error$response2$data2.conflicts,
        emails = _error$response2$data5 === void 0 ? [] : _error$response2$data5,
        _error$response2$data6 = _error$response2$data2.details,
        details = _error$response2$data6 === void 0 ? {
      ttl: 0,
      attempts: 2,
      max_attempts: 4,
      remaining_attempts: 2
    } : _error$response2$data6;

    updateRemainingAttempts(details.remaining_attempts);
    var genericError = 'showGenericError';

    if (eventName !== 'error') {
      genericError = 'showResendCodeError';
    }

    if (status === 401) {
      lurker$r.viewMessageEvt(eventName, {
        accounts_reason: 'unauthorized',
        accounts_status_code: status
      });
      showError(genericError);
    } else if (status === 429) {
      if (message === 'MAX_PHONE_VALIDATION_ATTEMPTS_REACHED') {
        lurker$r.viewMessageEvt(eventName, {
          accounts_reason: 'max_phone_validation',
          accounts_status_code: status
        });
        showError('showMaxPhoneValidationError');
      } else if (message === 'MAX_ATTEMPTS_CHECK_PIN_CODE') {
        lurker$r.viewMessageEvt(eventName, {
          accounts_reason: 'max_account_check_attempts',
          accounts_status_code: status
        });
        onMaxAccountCheckAttemptReached(details.ttl);
        showError('showMaxAccountCheckAttempts');
      } else {
        lurker$r.viewMessageEvt(eventName, {
          accounts_reason: 'rate_limit_exceeded',
          accounts_status_code: status
        });
        showError('showRateLimitError');
      }
    } else if (status === 403) {
      switch (message) {
        case 'PHONE_IN_BLACKLIST':
          lurker$r.viewMessageEvt(eventName, {
            accounts_reason: 'phone_number_in_blacklist',
            accounts_status_code: status
          });
          showError('showPhoneInBlackListError');
          break;

        case 'PHONE_IN_USE':
          lurker$r.viewMessageEvt(eventName, {
            accounts_reason: 'phone_number_already_in_use',
            accounts_status_code: status
          });
          onPhoneConflict(email, emails, pincode);
          break;

        case 'INVALID_PIN_CODE':
          lurker$r.viewMessageEvt(eventName, {
            accounts_reason: 'invalid_pin_code',
            accounts_status_code: status
          });
          showError('showInvalidPinCodeError');
          break;

        case 'NO_PIN_CODE':
          lurker$r.viewMessageEvt(eventName, {
            accounts_reason: 'no_pin_code',
            accounts_status_code: status
          });
          showError(genericError);
          break;

        default:
          lurker$r.viewMessageEvt(eventName, {
            accounts_reason: message && typeof message === 'string' ? message.toLowerCase() : 'unexpected_status_code',
            accounts_status_code: status
          });
          showError(genericError);
      }
    } else if (status) {
      lurker$r.viewMessageEvt(eventName, {
        accounts_reason: 'unexpected_status_code',
        accounts_status_code: status,
        accounts_error_message: error && error.message || 'unknown'
      });
      showError(genericError);
    } else {
      lurker$r.viewMessageEvt(eventName, {
        accounts_reason: 'unexpected_error',
        accounts_error_message: error && error.message || 'unknown'
      });
      showError(genericError);
    }
  };

  useEffect(function () {
    checkAttemptLockTime(token, abTests);
  }, []);
  var sendSMSCall = token ? function (phone) {
    return sendSMSv4(phone, token);
  } : sendSMS$1;
  var makePhoneCall = token ? function (phone) {
    return makeCallv4(phone, token);
  } : makeCall$1;
  var checkCodeCall = token ? function (phone, code) {
    return checkCodev4(phone, code, token);
  } : checkCode;
  return /*#__PURE__*/React.createElement(Wrapper$c, null, /*#__PURE__*/React.createElement(ArrowContainer, {
    onClick: onBackClick
  }, /*#__PURE__*/React.createElement(StyledArrow, null)), /*#__PURE__*/React.createElement(Text.TitleLarge, {
    marginBottom: "--spacing-stack-xs"
  }, "C\xF3digo de verifica\xE7\xE3o"), /*#__PURE__*/React.createElement(ContainerWrapper$1, {
    type: "outlined",
    paddingBottom: "--spacing-stack-xl",
    paddingTop: "--spacing-stack-xl",
    paddingLeft: "--spacing-stack-xl",
    paddingRight: "--spacing-stack-xl"
  }, /*#__PURE__*/React.createElement(CheckPinCodeTemplate, {
    checkCode: checkCodeCall,
    sendSMS: sendSMSCall,
    makeCall: makePhoneCall,
    onResend: checkAttemptLockTime,
    onSuccess: onSuccess,
    onPinCodeError: onPinCodeError,
    phone: phone,
    lockTime: lockTime,
    lurker: lurker$r,
    token: token
  })));
};

CheckPinCodePage.propTypes = {
  onBackClick: PropTypes__default.func.isRequired,
  onResend: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  onPhoneConflict: PropTypes__default.func,
  phone: PropTypes__default.string,
  token: PropTypes__default.string
};

var _templateObject$2s, _templateObject2$1Q, _templateObject3$1h;
var HeaderWrapper$1 = styled.header(_templateObject$2s || (_templateObject$2s = _taggedTemplateLiteralLoose(["\n  height: 80px;\n  border-bottom: 1px solid var(--color-neutral-medium);\n  margin-bottom: var(--spacing-stack-xs);\n"])));
var LogoWrapper$1 = styled.span(_templateObject2$1Q || (_templateObject2$1Q = _taggedTemplateLiteralLoose(["\n  width: 48px;\n  height: 48px;\n  @media all and (max-width: 359px) {\n    width: 44px;\n    height: 44px;\n  }\n"])));
var StyledFlex$2 = styled(Flex)(_templateObject3$1h || (_templateObject3$1h = _taggedTemplateLiteralLoose(["\n  height: 100%;\n"])));

var SimpleHeader = function SimpleHeader() {
  return /*#__PURE__*/React.createElement(HeaderWrapper$1, null, /*#__PURE__*/React.createElement(StyledFlex$2, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Link$2, {
    href: home
  }, /*#__PURE__*/React.createElement(LogoWrapper$1, null, /*#__PURE__*/React.createElement(LogoOLX, null)))));
};

var _templateObject$2t, _templateObject2$1R, _templateObject3$1i, _templateObject4$V, _templateObject5$F, _templateObject6$o;
var ContainerWrapper$2 = styled(Container$7)(_templateObject$2t || (_templateObject$2t = _taggedTemplateLiteralLoose(["\n  @media (max-width: ", "px) {\n    border: none !important;\n    padding: 0;\n  }\n"])), breakpoints['mobile']);
var ContentWrapper$3 = styled.div(_templateObject2$1R || (_templateObject2$1R = _taggedTemplateLiteralLoose([""])));
var ButtonsWrapper$2 = styled.div(_templateObject3$1i || (_templateObject3$1i = _taggedTemplateLiteralLoose(["\n  margin-top: var(--spacing-stack-xxs);\n  display: flex;\n  justify-content: end;\n  @media screen and (max-width: ", "px) {\n    justify-content: center;\n    flex-direction: column-reverse;\n    align-items: center;\n    flex: 1;\n  }\n"])), breakpoints['mobile']);
var StyledButton$2 = styled(Button)(_templateObject4$V || (_templateObject4$V = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin: 0;\n    width: 100%;\n    margin-bottom: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile']);
var ContentText = styled(Text.BodyMedium)(_templateObject5$F || (_templateObject5$F = _taggedTemplateLiteralLoose(["\n  text-align: left;\n"])));
var Form$2 = styled.form(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteralLoose([""])));
var lurker$s = new Lurker('phone_verify_pincode_existent');
var initialErrors$1 = {
  showGenericError: false,
  showInvalidPhoneError: false
};
var errorsByStatusCode = {
  406: 'showInvalidPhoneError',
  500: 'showGenericError'
};

var PhoneVerifyConfirmationTemplate = function PhoneVerifyConfirmationTemplate(_ref) {
  var onPhoneVerifySubmit = _ref.onPhoneVerifySubmit,
      onBackClick = _ref.onBackClick,
      phone = _ref.phone,
      token = _ref.token;

  var _useState = useState(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var _useState2 = useState(initialErrors$1),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useForm = useForm({
    reValidateMode: 'onBlur',
    mode: 'onBlur',
    defaultValues: {
      phone: phone
    }
  }),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      _clearErrors = _useForm.clearErrors;

  var showError = function showError(error) {
    var _extends2;

    lurker$s.viewMessageEvt('error_at_phone_submit');
    setErrors(_extends({}, initialErrors$1, (_extends2 = {}, _extends2[error] = true, _extends2)));
    setIsSubmitting(false);
  };

  var onSubmit = function onSubmit(data) {
    var phone = data.phone;
    setIsSubmitting(true);
    lurker$s.clickEvt('phone_submit_button');
    var phoneCheckReceivedCodeCall = token ? function (phone) {
      return phoneCheckReceivedCodev4(phone, token);
    } : phoneCheckReceivedCode;
    phoneCheckReceivedCodeCall(phone).then(function () {
      setIsSubmitting(false);

      if (onPhoneVerifySubmit) {
        onPhoneVerifySubmit(phone);
      }
    })["catch"](function (err) {
      setIsSubmitting(false);
      showError(errorsByStatusCode[err.response.status]);
    });
  };

  useEffect(function () {
    lurker$s.pageLoadEvt();
  }, []);
  var showGenericError = errors.showGenericError,
      showInvalidPhoneError = errors.showInvalidPhoneError;
  return /*#__PURE__*/React.createElement(ContentWrapper$3, null, /*#__PURE__*/React.createElement(Form$2, {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(ContainerWrapper$2, {
    type: "outlined",
    paddingBottom: "--spacing-stack-xl",
    paddingTop: "--spacing-stack-xl",
    paddingLeft: "--spacing-stack-xl",
    paddingRight: "--spacing-stack-xl"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(ContentText, {
    marginTop: "--spacing-stack-xxxs",
    marginBottom: "--spacing-stack-xs"
  }, "Confirme o n\xFAmero de telefone em que voc\xEA recebeu o c\xF3digo."), showGenericError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    title: "Falha em nosso sistema",
    showContactUs: false
  }, "Estamos trabalhando pra resolver rapidinho. Tente novamente em alguns minutos."), showInvalidPhoneError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    title: "N\xE3o foi poss\xEDvel confirmar este telefone",
    showContactUs: false
  }, "Verifique o n\xFAmero digitado."), /*#__PURE__*/React.createElement(Controller, {
    name: "phone",
    control: control,
    rules: {
      validate: function validate(phone) {
        return isValid(removeMask(phone));
      }
    },
    render: function render(_ref2) {
      var field = _ref2.field,
          fieldState = _ref2.fieldState;
      return /*#__PURE__*/React.createElement(PhoneInput, _extends({}, field, fieldState, {
        clearErrors: function clearErrors() {
          return _clearErrors('phone');
        }
      }));
    }
  }))), /*#__PURE__*/React.createElement(ButtonsWrapper$2, {
    alignItems: "center",
    marginTop: "--spacing-stack-xxxs"
  }, /*#__PURE__*/React.createElement(StyledButton$2, {
    variant: "link-button",
    size: "large",
    marginRight: "--spacing-stack-xxxs",
    onClick: onBackClick
  }, "Voltar"), /*#__PURE__*/React.createElement(StyledButton$2, {
    size: "large",
    disabled: isSubmitting || !formState.isValid,
    isLoading: isSubmitting,
    onClick: handleSubmit(onSubmit)
  }, "Confirmar"))));
};

PhoneVerifyConfirmationTemplate.propTypes = {
  onPhoneVerifySubmit: PropTypes__default.func,
  onBackClick: PropTypes__default.func,
  phone: PropTypes__default.string,
  token: PropTypes__default.string,
  abTests: PropTypes__default.string
};

var _templateObject$2u, _templateObject2$1S, _templateObject3$1j;
var Wrapper$d = styled.div(_templateObject$2u || (_templateObject$2u = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  margin: auto;\n  @media (max-width: ", "px) {\n    margin-left: var(--spacing-stack-xxxs);\n    margin-right: var(--spacing-stack-xxxs);\n  }\n  @media (min-width: 840px) {\n    max-width: 600px;\n  }\n  @media (min-width: ", "px) and (max-width: ", "px) {\n    width: 80vw;\n  }\n"])), breakpoints['mobile'], breakpoints['mobile'] + 1, breakpoints['tablet']);
var StyledArrow$1 = styled(ArrowLeft)(_templateObject2$1S || (_templateObject2$1S = _taggedTemplateLiteralLoose(["\n  color: var(--color-neutral-darkest);\n"])));
var ArrowContainer$1 = styled.div(_templateObject3$1j || (_templateObject3$1j = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-bottom: var(--spacing-stack-xs);\n"])));

var PhoneVerifyConfirmationPage = function PhoneVerifyConfirmationPage(_ref) {
  var onPhoneVerifyConfirmationSuccess = _ref.onPhoneVerifyConfirmationSuccess,
      onBackClick = _ref.onBackClick,
      phone = _ref.phone,
      token = _ref.token,
      abTests = _ref.abTests;
  return /*#__PURE__*/React.createElement(Wrapper$d, null, /*#__PURE__*/React.createElement(ArrowContainer$1, {
    onClick: onBackClick
  }, /*#__PURE__*/React.createElement(StyledArrow$1, null)), /*#__PURE__*/React.createElement(Text.TitleLarge, {
    marginBottom: "--spacing-stack-xs"
  }, "J\xE1 tenho um c\xF3digo"), /*#__PURE__*/React.createElement(PhoneVerifyConfirmationTemplate, {
    phone: phone,
    onBackClick: onBackClick,
    onPhoneVerifySubmit: onPhoneVerifyConfirmationSuccess,
    token: token,
    abTests: abTests
  }));
};

PhoneVerifyConfirmationPage.propTypes = {
  onPhoneVerifyConfirmationSuccess: PropTypes__default.func,
  onBackClick: PropTypes__default.func,
  phone: PropTypes__default.string,
  token: PropTypes__default.string,
  abTests: PropTypes__default.string
};

var PhoneSecurityLockSymbol = function PhoneSecurityLockSymbol(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1414 11.0138L116.203 89.5997C119.93 92.6647 120.607 98.5495 117.671 102.473C116.316 104.312 114.396 105.538 112.25 105.905L30.5954 118.901C25.9649 119.636 21.6732 116.204 20.9956 111.055C20.9956 111.055 20.9956 111.055 20.9956 110.932L9.58883 19.4731C8.9112 14.4465 12.1864 9.78778 16.8169 9.05219C19.0757 8.80699 21.3344 9.41999 23.1414 11.0138Z",
    fill: "#DEF9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2623 41.5208L57.8545 52.8496L48.5766 54.1535L46.8197 41.6527C46.8197 41.6527 43.959 17.7546 67.1049 14.5017C90.2508 11.2487 94.3156 33.0854 94.3156 33.0854L96.347 47.5394L86.9714 48.857L84.9675 34.5984C84.9675 34.5984 81.9273 22.1784 69.1336 23.9765C56.3399 25.7745 55.8812 37.3915 56.2623 41.5208Z",
    fill: "#8CE563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.542 50.4502L51.9675 53.4777",
    stroke: "white",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3612 47.0157L46.8388 54.1161C36.9455 55.5065 33.3503 62.2596 34.4267 69.9181L39.0414 102.754C40.1043 110.317 47.2868 115.148 55.2588 114.027L105.781 106.927C113.653 105.82 119.713 101.939 117.273 91.7592L112.658 58.9234C111.347 49.5943 107.75 45.5557 97.3612 47.0157ZM80.7615 81.4662C80.5891 81.6857 80.4167 81.9052 80.4571 82.1924L81.6141 90.4252C81.8832 92.3399 80.5175 94.1914 78.4249 94.4855L77.2291 94.6535C75.2361 94.9336 73.3268 93.64 73.0443 91.6297L71.8872 83.3968C71.8469 83.1096 71.7203 82.9321 71.3944 82.7827C67.7104 81.1528 65.6236 77.1507 66.8657 72.9736C67.639 70.522 69.5756 68.395 72.0992 67.5522C77.4185 65.6332 82.8664 68.9677 83.5795 74.0414C83.9697 76.8176 82.8382 79.6124 80.7615 81.4662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.408 59.0097C38.9891 56.7957 41.5452 55.1418 44.475 54.73L100.533 46.8516C106.295 46.0418 111.642 50.0707 112.451 55.8328L117.9 94.6045C118.71 100.367 114.681 105.713 108.919 106.523L55.3029 114.058",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4312 47.428L94.6058 34.4389C92.7528 21.2546 80.5002 12.0216 67.3158 13.8745C54.1315 15.7274 44.8008 27.9938 46.6538 41.1781L48.4792 54.1672L58.0501 52.8221L56.2246 39.833C55.0991 31.8248 60.6389 24.4732 68.6472 23.3477C76.6555 22.2222 84.0071 27.762 85.1326 35.7703L86.958 48.7593",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0807 94.7233C76.1275 94.9978 74.2476 93.6686 73.9594 91.6177L72.779 83.2187C72.7378 82.9257 72.6127 82.7441 72.2923 82.59C68.6698 80.9081 66.601 76.8169 67.7961 72.5657C68.541 70.0708 70.4288 67.9133 72.8994 67.0681C78.1061 65.1412 83.468 68.5705 84.1954 73.7466C84.5935 76.5788 83.4991 79.4215 81.3748 81.3135C81.207 81.5363 81.0391 81.7591 81.0803 82.0521L82.2607 90.451C82.5352 92.4042 81.2059 94.2841 79.155 94.5723L78.0807 94.7233Z",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5646 66.4393C35.5646 66.4393 26.1701 76.1252 17.2828 77.3743L20.2064 98.1762C20.8103 102.473 23.1172 106.133 26.4604 107.954C29.8036 109.774 39.9462 114.623 40.3643 114.763L42.496 115.759L44.2708 114.214C44.6203 113.867 53.0472 106.508 55.8429 103.724C58.4708 101.164 59.7774 96.9969 59.1597 92.6021L56.2499 71.8978C47.265 73.1605 35.5646 66.4393 35.5646 66.4393Z",
    fill: "#8CE563",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8636 91.1013L38.3128 96.6274L47.3779 84.5976",
    stroke: "white",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5415 22.9576C51.7329 27.7167 49.3457 34.8243 50.4026 42.3443L51.0751 47.1297",
    stroke: "white",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.423 64.7881L110.485 86.574",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.319 92.5156L111.876 96.4767",
    stroke: "#4A4A4A",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

PhoneSecurityLockSymbol.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};

var _templateObject$2v, _templateObject2$1T, _templateObject3$1k;
var ContentWrapper$4 = styled.div(_templateObject$2v || (_templateObject$2v = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n"])));
var IconWrapper$7 = styled.div(_templateObject2$1T || (_templateObject2$1T = _taggedTemplateLiteralLoose(["\n  width: 110px;\n  height: 110px;\n  align-self: center;\n  margin-bottom: var(--spacing-stack-xxs);\n\n  @media all and (max-width: ", "px) {\n    width: 84px;\n    height: 84px;\n  }\n"])), breakpoints['mobile']);
var StyledButton$3 = styled(Button)(_templateObject3$1k || (_templateObject3$1k = _taggedTemplateLiteralLoose(["\n  margin-top: var(--spacing-stack-xxs);\n"])));

var PhoneValidationSuccessTemplate = function PhoneValidationSuccessTemplate(_ref) {
  var onSuccess = _ref.onSuccess,
      showRemovedAdsMessage = _ref.showRemovedAdsMessage;
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    flex: "1",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(ContentWrapper$4, null, /*#__PURE__*/React.createElement(IconWrapper$7, null, /*#__PURE__*/React.createElement(PhoneSecurityLockSymbol, null)), /*#__PURE__*/React.createElement(Text.TitleMedium, null, "Telefone verificado com sucesso"), showRemovedAdsMessage && /*#__PURE__*/React.createElement(Text.BodyMedium, {
    marginTop: "--spacing-stack-xxxs"
  }, "O desv\xEDnculo das demais contas tamb\xE9m foi conclu\xEDdo e os an\xFAncios nelas foram deletados."), /*#__PURE__*/React.createElement(StyledButton$3, {
    onClick: onSuccess,
    size: "large",
    fullWidth: true
  }, "Ok")));
};

PhoneValidationSuccessTemplate.propTypes = {
  onSuccess: PropTypes__default.func,
  showRemovedAdsMessage: PropTypes__default.bool
};

var _templateObject$2w;
var ContentWrapper$5 = styled.div(_templateObject$2w || (_templateObject$2w = _taggedTemplateLiteralLoose(["\n  @media (min-width: ", "px) and (max-width: ", "px) {\n    width: 80vw;\n  }\n"])), breakpoints['mobile'] + 1, breakpoints['tablet']);

var PhoneValidationSuccessPage = function PhoneValidationSuccessPage(_ref) {
  var onSuccess = _ref.onSuccess,
      showRemovedAdsMessage = _ref.showRemovedAdsMessage;
  return /*#__PURE__*/React.createElement(ContentWrapper$5, null, /*#__PURE__*/React.createElement(PhoneValidationSuccessTemplate, {
    onSuccess: onSuccess,
    showRemovedAdsMessage: showRemovedAdsMessage
  }));
};

PhoneValidationSuccessPage.propTypes = {
  onSuccess: PropTypes__default.func
};

var _templateObject$2x, _templateObject2$1U, _templateObject3$1l;
var WrapperCircle = styled(View$1)(_templateObject$2x || (_templateObject$2x = _taggedTemplateLiteralLoose(["\n  margin-left: var(--spacing-0-25);\n  margin-right: var(--spacing-0-25);\n  margin-top: 9px;\n"])));
var IconCircle = styled(View$1)(_templateObject2$1U || (_templateObject2$1U = _taggedTemplateLiteralLoose(["\n  width: 7px;\n  height: 7px;\n  border-radius: 100%;\n  background-color: var(--color-neutral-darkest);\n"])));
var WrapperEmailContainer = styled.div(_templateObject3$1l || (_templateObject3$1l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  width: 100%;\n  color: var(--color-neutral-darkest);\n  background-color: var(--color-neutral-80);\n  padding: var(--spacing-stack-xxxs);\n  margin-bottom: var(--spacing-stack-nano);\n  border-radius: var(--border-radius-sm);\n"])));

var replacePerIcon = function replacePerIcon(email) {
  var newEmail = [];
  Array.from(email).forEach(function (item) {
    if (item === '*') {
      newEmail.push( /*#__PURE__*/React.createElement(WrapperCircle, null, /*#__PURE__*/React.createElement(IconCircle, null)));
    } else {
      newEmail.push(item);
    }
  });
  return newEmail;
};

var EmailContainer = function EmailContainer(_ref) {
  var email = _ref.email;
  return /*#__PURE__*/React.createElement(WrapperEmailContainer, null, replacePerIcon(email));
};
EmailContainer.propTypes = {
  email: PropTypes__default.string.isRequired
};

var _templateObject$2y, _templateObject2$1V, _templateObject3$1m, _templateObject4$W;
var StyledFlex$3 = styled(Flex)(_templateObject$2y || (_templateObject$2y = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n  }\n  flex-direction: column;\n"])), breakpoints['mobile']);
var Wrapper$e = styled.div(_templateObject2$1V || (_templateObject2$1V = _taggedTemplateLiteralLoose(["\n  color: red;\n  div[data-ds-component='DS-Modal'] {\n    div[role='dialog'] {\n      padding: var(--spacing-stack-xxs);\n    }\n  }\n"])));
var StyledDeleteText = styled.span(_templateObject3$1m || (_templateObject3$1m = _taggedTemplateLiteralLoose(["\n  color: var(--color-feedback-error-medium);\n"])));
var StyledButton$4 = styled(Button)(_templateObject4$W || (_templateObject4$W = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin-bottom: var(--spacing-stack-nano);\n  }\n  @media screen and (min-width: ", "px) {\n    margin-left: var(--spacing-stack-nano);\n  }\n"])), breakpoints['mobile'], breakpoints['mobile'] + 1);
var ConfirmPhoneOverrideModal = function ConfirmPhoneOverrideModal(_ref) {
  var onConfirm = _ref.onConfirm,
      closeModal = _ref.closeModal,
      isOpen = _ref.isOpen,
      emails = _ref.emails,
      loading = _ref.loading,
      showGenericError = _ref.showGenericError;

  var _useState = useState(false),
      agreeCheck = _useState[0],
      setAgreeCheck = _useState[1];

  var _useWindowSize = useWindowSize(),
      isMobile = _useWindowSize.isMobile;

  return /*#__PURE__*/React.createElement(Wrapper$e, null, /*#__PURE__*/React.createElement(ResponsiveModal, {
    isOpen: isOpen,
    closeModal: closeModal,
    renderButtons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledButton$4, {
      variant: "danger",
      size: "medium",
      onClick: onConfirm,
      fullWidth: isMobile,
      isLoading: loading,
      disabled: loading || !agreeCheck
    }, "Continuar e deletar an\xFAncios"), /*#__PURE__*/React.createElement(StyledButton$4, {
      variant: "link-button",
      size: "medium",
      fullWidth: isMobile,
      onClick: closeModal,
      disabled: loading
    }, "Cancelar"))
  }, /*#__PURE__*/React.createElement(StyledFlex$3, null, /*#__PURE__*/React.createElement(Text.TitleSmall, {
    marginBottom: "--spacing-stack-xxs"
  }, "Ao concluir a verifica\xE7\xE3o e o desv\xEDnculo, os an\xFAncios das contas abaixo ser\xE3o", ' ', /*#__PURE__*/React.createElement(StyledDeleteText, null, "deletados")), showGenericError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    showContactUs: false
  }, "N\xE3o foi poss\xEDvel validar seu telefone."), emails.map(function (email) {
    return /*#__PURE__*/React.createElement(EmailContainer, {
      key: email,
      email: email
    });
  }), /*#__PURE__*/React.createElement(Flex, {
    marginBottom: "--spacing-stack-xxs",
    marginTop: "--spacing-stack-xxs"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onClick: function onClick(e) {
      return setAgreeCheck(e.target.checked);
    },
    "aria-label": "deletar-anuncios",
    label: "Concordo em deletar os an\xFAncios",
    checked: agreeCheck
  })))));
};
ConfirmPhoneOverrideModal.propTypes = {
  onConfirm: PropTypes__default.func,
  isOpen: PropTypes__default.bool,
  emails: PropTypes__default.arrayOf(PropTypes__default.string),
  loading: PropTypes__default.bool,
  showGenericError: PropTypes__default.bool
};

var _templateObject$2z, _templateObject2$1W, _templateObject3$1n, _templateObject4$X;
var lurker$t = new Lurker('phone_authorization_confirmation');
var ButtonsWrapper$3 = styled.div(_templateObject$2z || (_templateObject$2z = _taggedTemplateLiteralLoose(["\n  margin-top: var(--spacing-stack-xxs);\n  display: flex;\n  justify-content: end;\n  @media screen and (max-width: ", "px) {\n    justify-content: center;\n    flex-direction: column-reverse;\n    align-items: center;\n    flex: 1;\n  }\n"])), breakpoints['mobile']);
var StyledButton$5 = styled(Button)(_templateObject2$1W || (_templateObject2$1W = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin: 0;\n    width: 100%;\n    margin-bottom: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile']);
var StyledText$2 = styled(Text.BodyMedium)(_templateObject3$1n || (_templateObject3$1n = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    font-size: var(--font-size-xxs);\n  }\n"])), breakpoints['mobile']);
var ContainerWrapper$3 = styled(Container$7)(_templateObject4$X || (_templateObject4$X = _taggedTemplateLiteralLoose(["\n  padding: var(--spacing-stack-xl);\n  @media (max-width: ", "px) {\n    border: none !important;\n    padding: 0;\n  }\n"])), breakpoints['mobile']);
var RemovePhoneConfirmationTemplate = function RemovePhoneConfirmationTemplate(_ref) {
  var phone = _ref.phone,
      token = _ref.token,
      pincode = _ref.pincode,
      emails = _ref.emails,
      onSuccess = _ref.onSuccess,
      onCancel = _ref.onCancel;

  var _useState = useState(false),
      modalOpen = _useState[0],
      setModalOpen = _useState[1];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState({
    showGenericError: false
  }),
      errors = _useState3[0],
      setErrors = _useState3[1];

  var onOverrideClick = function onOverrideClick(e) {
    e.preventDefault();
    setModalOpen(true);
  };

  var closeModal = function closeModal(e) {
    e.preventDefault();
    setModalOpen(false);
  };

  var onPhoneOverrideSuccess = function onPhoneOverrideSuccess() {
    lurker$t.viewMessageEvt('success');

    if (typeof onSuccess === 'function') {
      onSuccess();
    }
  };

  var showError = function showError(error) {
    var _extends2;

    return setErrors(_extends({}, errors, (_extends2 = {}, _extends2[error] = true, _extends2)));
  };

  var onGenericError = function onGenericError(error, eventName) {
    if (error === void 0) {
      error = {};
    }

    if (eventName === void 0) {
      eventName = 'error';
    }

    var genericError = 'showGenericError';
    lurker$t.viewMessageEvt(eventName, {
      accounts_reason: 'unexpected_error',
      accounts_error_message: error && error.message || 'unknown'
    });
    showError(genericError);
  };

  var onPhoneOverrideClick = function onPhoneOverrideClick() {
    setLoading(true);
    var phoneOverrideCall = token ? function (phone, pincode) {
      return phoneOverridev4(phone, pincode, token);
    } : phoneOverride;
    phoneOverrideCall(phone, pincode).then(onPhoneOverrideSuccess)["catch"](function (err) {
      return onGenericError(err, 'error');
    })["finally"](function () {
      return setLoading(false);
    });
  };

  useEffect(function () {
    lurker$t.pageLoadEvt();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContainerWrapper$3, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, emails.map(function (email) {
    return /*#__PURE__*/React.createElement(EmailContainer, {
      key: email,
      email: email
    });
  }), /*#__PURE__*/React.createElement(StyledText$2, {
    marginTop: "--spacing-stack-xxs"
  }, "S\xF3 \xE9 permitido um telefone vinculado a uma conta. Ao continuar a verifica\xE7\xE3o, ele ser\xE1 desvinculado dessas contas e os an\xFAncios nelas ser\xE3o deletados."))), /*#__PURE__*/React.createElement(ButtonsWrapper$3, null, /*#__PURE__*/React.createElement(StyledButton$5, {
    onClick: onCancel,
    variant: "link-button",
    size: "large",
    marginRight: "--spacing-stack-xxxs"
  }, "Usar outro n\xFAmero"), /*#__PURE__*/React.createElement(StyledButton$5, {
    size: "large",
    type: "button",
    onClick: onOverrideClick
  }, "Continuar verifica\xE7\xE3o e desv\xEDnculo")), /*#__PURE__*/React.createElement(ConfirmPhoneOverrideModal, _extends({
    loading: loading,
    isOpen: modalOpen,
    emails: emails,
    onConfirm: onPhoneOverrideClick,
    closeModal: closeModal
  }, errors)));
};
RemovePhoneConfirmationTemplate.propTypes = {
  onSuccess: PropTypes__default.func,
  onCancel: PropTypes__default.func,
  phone: PropTypes__default.string,
  emails: PropTypes__default.arrayOf(PropTypes__default.string),
  abTests: PropTypes__default.string,
  token: PropTypes__default.string
};

var _templateObject$2A, _templateObject2$1X, _templateObject3$1o, _templateObject4$Y;
var ContentWrapper$6 = styled.div(_templateObject$2A || (_templateObject$2A = _taggedTemplateLiteralLoose(["\n  max-width: 600px;\n  flex: 1;\n  flex-direction: column;\n  margin: auto;\n  @media screen and (min-width: ", "px) and (max-width: ", "px) {\n    width: 80vw;\n  }\n  @media screen and (max-width: ", "px) {\n    margin: 0 auto;\n    justify-content: center;\n    margin-left: var(--spacing-stack-xxxs);\n    margin-right: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile'] + 1, breakpoints['tablet'], breakpoints['mobile']);
var StyledTitle$1 = styled(Text.TitleLarge)(_templateObject2$1X || (_templateObject2$1X = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin-bottom: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile']);
var StyledArrow$2 = styled(ArrowLeft)(_templateObject3$1o || (_templateObject3$1o = _taggedTemplateLiteralLoose(["\n  color: var(--color-neutral-darkest);\n"])));
var ArrowContainer$2 = styled.div(_templateObject4$Y || (_templateObject4$Y = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-bottom: var(--spacing-stack-xs);\n"])));
var RemovePhoneConfirmationPage = function RemovePhoneConfirmationPage(_ref) {
  var phone = _ref.phone,
      token = _ref.token,
      pincode = _ref.pincode,
      emails = _ref.emails,
      onSuccess = _ref.onSuccess,
      onBackClick = _ref.onBackClick,
      abTests = _ref.abTests;
  return /*#__PURE__*/React.createElement(ContentWrapper$6, null, /*#__PURE__*/React.createElement(ArrowContainer$2, {
    onClick: onBackClick
  }, /*#__PURE__*/React.createElement(StyledArrow$2, null)), /*#__PURE__*/React.createElement(StyledTitle$1, {
    marginBottom: "--spacing-stack-xs"
  }, "Seu telefone " + getMaskedValue(phone).pretty + " j\xE1 est\xE1 vinculado " + (emails.length > 1 ? 'às seguintes contas' : 'à seguinte conta')), /*#__PURE__*/React.createElement(RemovePhoneConfirmationTemplate, {
    phone: phone,
    pincode: pincode,
    emails: emails,
    onSuccess: onSuccess,
    onCancel: onBackClick,
    abTests: abTests,
    token: token
  }));
};
RemovePhoneConfirmationPage.propTypes = {
  onSuccess: PropTypes__default.func,
  onBackClick: PropTypes__default.func,
  phone: PropTypes__default.string,
  emails: PropTypes__default.arrayOf(PropTypes__default.string),
  abTests: PropTypes__default.string,
  token: PropTypes__default.string
};

var router = createNewRouter('SendPinCode');

var PhoneValidation = function PhoneValidation(_ref) {
  var onClickBounce = _ref.onClickBounce,
      onSuccess = _ref.onSuccess,
      showBounceLink = _ref.showBounceLink,
      abTests = _ref.abTests,
      token = _ref.token;

  var _useState = useState(''),
      phone = _useState[0],
      setPhone = _useState[1];

  var _useState2 = useState([]),
      emails = _useState2[0],
      setEmails = _useState2[1];

  var _useState3 = useState(''),
      pincode = _useState3[0],
      setPincode = _useState3[1];

  var _useState4 = useState(false),
      showRemovedAdsMessage = _useState4[0],
      setShowRemovedAdsMessage = _useState4[1];

  var onSendCodeSuccess = function onSendCodeSuccess(newPhone) {
    setPhone(newPhone);
    router.push('CheckPinCode');
  };

  var onAlreadyHasCodeClick = function onAlreadyHasCodeClick(phone) {
    setPhone(phone);
    router.push('PhoneVerifyConfirmation');
  };

  var goBack = function goBack(e) {
    if (e) e.preventDefault();

    if (router.canPop()) {
      router.pop();
    } else {
      router.push('SendPinCode');
    }
  };

  var goBackToBeginning = function goBackToBeginning() {
    return router.push('SendPinCode');
  };

  var onPhoneVerifySuccess = function onPhoneVerifySuccess(newPhone) {
    setPhone(newPhone);
    router.push('CheckPinCode');
  };

  var onCheckPinCodeSuccess = function onCheckPinCodeSuccess() {
    return router.push('PhoneValidationSuccess');
  };

  var onPhoneOverrideSuccess = function onPhoneOverrideSuccess() {
    return router.push('PhoneValidationSuccess');
  };

  var onPhoneConflict = function onPhoneConflict(_, emails, pincode) {
    setEmails(emails);
    setPincode(pincode);
    setShowRemovedAdsMessage(true);
    router.push('RemovePhoneConfirmationPage');
  };

  return /*#__PURE__*/React.createElement(CountdownProvider, null, /*#__PURE__*/React.createElement(SimpleHeader, null), /*#__PURE__*/React.createElement(AccessNavigator, {
    router: router,
    routes: [{
      route: 'SendPinCode',
      component: function component() {
        return /*#__PURE__*/React.createElement(SendPinCodePage, {
          onClickBounce: onClickBounce,
          showBounceLink: showBounceLink,
          onSuccess: onSendCodeSuccess,
          onAlreadyHasCodeClick: onAlreadyHasCodeClick,
          token: token,
          abTests: abTests
        });
      }
    }, {
      route: 'CheckPinCode',
      component: function component() {
        return /*#__PURE__*/React.createElement(CheckPinCodePage, {
          phone: phone,
          onBackClick: goBack,
          onSuccess: onCheckPinCodeSuccess,
          onPhoneConflict: onPhoneConflict,
          abTests: abTests,
          token: token
        });
      }
    }, {
      route: 'PhoneVerifyConfirmation',
      component: function component() {
        return /*#__PURE__*/React.createElement(PhoneVerifyConfirmationPage, {
          phone: phone,
          onPhoneVerifyConfirmationSuccess: onPhoneVerifySuccess,
          onBackClick: goBack,
          token: token,
          abTests: abTests
        });
      }
    }, {
      route: 'PhoneValidationSuccess',
      component: function component() {
        return /*#__PURE__*/React.createElement(PhoneValidationSuccessPage, {
          showRemovedAdsMessage: showRemovedAdsMessage,
          onSuccess: onSuccess
        });
      }
    }, {
      route: 'RemovePhoneConfirmationPage',
      component: function component() {
        return /*#__PURE__*/React.createElement(RemovePhoneConfirmationPage, {
          onSuccess: onPhoneOverrideSuccess,
          onBackClick: goBackToBeginning,
          phone: phone,
          emails: emails,
          pincode: pincode,
          token: token,
          abTests: abTests
        });
      }
    }]
  }));
};

var _templateObject$2B;

var TextInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TextInput, _Component);

  function TextInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleOnKeyDown = _this.handleOnKeyDown.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = TextInput.prototype;

  _proto.handleChange = function handleChange(event) {
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  _proto.handleOnKeyDown = function handleOnKeyDown(event) {
    var _this$props = this.props,
        onKeyDown = _this$props.onKeyDown,
        onKeyPress = _this$props.onKeyPress;

    if (onKeyDown) {
      onKeyDown(event);
    } else if (onKeyPress) {
      onKeyPress(event);
    }
  };

  _proto.handleBlur = function handleBlur(event) {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  };

  _proto.handleFocus = function handleFocus(event) {
    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        secureTextEntry = _this$props2.secureTextEntry,
        keyboardType = _this$props2.keyboardType,
        multiline = _this$props2.multiline,
        className = _this$props2.className,
        placeholder = _this$props2.placeholder,
        type = _this$props2.type,
        pattern = _this$props2.pattern,
        step = _this$props2.step,
        maxLength = _this$props2.maxLength,
        max = _this$props2.max,
        min = _this$props2.min,
        disabled = _this$props2.disabled,
        autoComplete = _this$props2.autoComplete,
        autoCapitalize = _this$props2.autoCapitalize,
        _this$props2$hidden = _this$props2.hidden,
        hidden = _this$props2$hidden === void 0 ? false : _this$props2$hidden,
        inputRef = _this$props2.inputRef,
        value = _this$props2.value,
        rows = _this$props2.rows;
    var keyboardTypeDict = {
      'email-address': 'email'
    };
    var inputType = keyboardType in keyboardTypeDict ? keyboardTypeDict[keyboardType] : type || 'text';

    if (multiline) {
      return /*#__PURE__*/React.createElement("textarea", {
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onKeyDown: this.handleOnKeyDown,
        onFocus: this.handleFocus,
        className: className,
        placeholder: placeholder,
        value: value,
        autoComplete: autoComplete,
        hidden: hidden,
        ref: inputRef,
        maxLength: maxLength,
        rows: rows
      });
    }

    return /*#__PURE__*/React.createElement("input", {
      type: secureTextEntry ? 'password' : inputType,
      value: value,
      pattern: pattern,
      maxLength: maxLength,
      step: step,
      max: max,
      min: min,
      className: className,
      placeholder: placeholder,
      onChange: this.handleChange,
      onKeyDown: this.handleOnKeyDown,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      disabled: disabled,
      autoComplete: autoComplete,
      hidden: hidden,
      autoCapitalize: autoCapitalize,
      ref: inputRef
    });
  };

  return TextInput;
}(Component$2);

var Input$1 = styled(TextInput)(_templateObject$2B || (_templateObject$2B = _taggedTemplateLiteralLoose(["\n  position: relative !important;\n  border-style: solid !important;\n  border-color: ", ";\n  border-width: 1px !important;\n  border-radius: 4px !important;\n  width: 100% !important;\n  min-height: 48px !important;\n  padding-top: 11px !important;\n  padding-bottom: 12px !important;\n  padding-left: 16px !important;\n  color: ", ";\n  font-size: 16px !important;\n  box-sizing: border-box !important;\n  background-color: ", ";\n  font-family: 'Nunito Sans' !important;\n  &::-webkit-input-placeholder {\n    color: #d2d2d2 !important;\n  }\n  &::placeholder {\n    color: #d2d2d2 !important;\n  }\n  outline: none;\n  :focus {\n    border-color: #999 !important;\n  }\n"])), function (props) {
  return props.hasError ? '#ff4444 !important' : '#d2d2d2 !important';
}, function (props) {
  return props.disabled ? '#d2d2d2 !important' : '#4a4a4a !important';
}, function (props) {
  return props.disabled ? '#f6f6f6 !important' : '';
});

var _templateObject$2C, _templateObject2$1Y;
var Content$19 = styled(View$1)(_templateObject$2C || (_templateObject$2C = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 1 0;\n"])));
var ShowPasswordPlacement$1 = styled(Clickable)(_templateObject2$1Y || (_templateObject2$1Y = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n"])));

var PasswordInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PasswordInput, _React$Component);

  function PasswordInput(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.state = {
      showingPassword: props.visiblePassword
    };
    return _this;
  }

  var _proto = PasswordInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var visiblePassword = this.props.visiblePassword;
    var previousVisiblePassword = prevProps.visiblePassword;

    if (previousVisiblePassword !== visiblePassword) {
      this.setState({
        showingPassword: visiblePassword
      });
    }
  };

  _proto.handleClick = function handleClick() {
    var showingPassword = this.state.showingPassword;
    this.setState({
      showingPassword: !showingPassword
    });
  };

  _proto.render = function render() {
    var props = this.props;
    var showingPassword = this.state.showingPassword;
    return /*#__PURE__*/React.createElement(Content$19, null, /*#__PURE__*/React.createElement(Input$1, _extends({
      secureTextEntry: !showingPassword,
      autoCapitalize: "none",
      autoComplete: "none",
      autoCorrect: false
    }, props)), /*#__PURE__*/React.createElement(ShowPasswordPlacement$1, {
      onPress: this.handleClick
    }, /*#__PURE__*/React.createElement(showPassword, {
      enabled: showingPassword
    })));
  };

  return PasswordInput;
}(React.Component);

PasswordInput.defaultProps = {
  hasError: false,
  visiblePassword: false
};
PasswordInput.propTypes = {
  onChange: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  hasError: PropTypes__default.bool,
  value: PropTypes__default.string,
  visiblePassword: PropTypes__default.bool
};

var API_ENDPOINT_NEW = '/2fa/v1/login';
var secureStorage$2 = new SecureStorage('login');
var smartLock$4 = new SmartLock('login');
var v4 = function v4(email, password, abTests) {
  return axios.post(API_ENDPOINT_NEW, {
    email: email.toLowerCase().trim(),
    password: password,
    platform: platform
  }, {
    headers: {
      'X-TestAB-Groups': abTests || ''
    },
    withCredentials: true
  }).then(function (_ref2) {
    var data = _ref2.data;

    try {
      var _data$fullName4 = data.fullName,
          fullName = _data$fullName4 === void 0 ? '' : _data$fullName4;
      lastLoginStorage.saveEmailLogin(data);
      return Promise.resolve(smartLock$4.saveCredential(email, password, fullName)).then(function () {
        return Promise.resolve(secureStorage$2.saveCredential(email, password)).then(function () {
          return data;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  });
};

var _templateObject$2D, _templateObject2$1Z, _templateObject3$1p, _templateObject4$Z, _templateObject5$G, _templateObject6$p;
var lurker$u = new Lurker('login');
var secureStorage$3 = new SecureStorage('login');
var Content$1a = styled(View$1)(_templateObject$2D || (_templateObject$2D = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var PageForm$6 = styled(Form)(_templateObject2$1Z || (_templateObject2$1Z = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var ErrorMsgWrapper$a = styled(View$1)(_templateObject3$1p || (_templateObject3$1p = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var HRuleWrapper$g = styled(View$1)(_templateObject4$Z || (_templateObject4$Z = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var CenteredContent = styled(Content$1a)(_templateObject5$G || (_templateObject5$G = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  margin-top: 16px;\n  margin-bottom: 8px;\n"])));

var Heading = function Heading(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(CenteredContent, null, /*#__PURE__*/React.createElement(OLXLogo, null), /*#__PURE__*/React.createElement(Title, null, text));
};

var EmailChipWrapper$3 = styled(View$1)(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 4px;\n  margin-bottom: 12px;\n"])));

var getInvalidFields = function getInvalidFields(fields) {
  var invalidFields = {};
  Object.keys(fields).forEach(function (key) {
    if (!fields[key].valid) invalidFields["invalid_" + key] = true;
  });
  return invalidFields;
};

var errors$6 = {
  showUnauthorizedError: false,
  showInactiveError: false,
  showGenericError: false,
  showRateLimitError: false,
  showAccountNotFoundError: false,
  showPasswordMismatchError: false,
  showBiometryError: false,
  showPasswordlessError: false,
  showExpiredTokenError: false
};
var ATTEMPTS_COUNT = 2;

var SplitLoginPasswordTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SplitLoginPasswordTemplate, _React$Component);

  function SplitLoginPasswordTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onLoginSuccess = function (data) {
      var biometry = _this.state.biometry;
      var method = biometry ? 'biometry' : 'password_only';
      lurker$u.viewMessageEvt('email_login_success', {
        accounts_method: method,
        remote_addr: data.remoteAddress
      });

      if (_this.props.onLoginSuccess) {
        _this.setState({
          showUnauthorizedError: false,
          showInactiveError: false,
          showGenericError: false,
          showRateLimitError: false,
          showAccountNotFoundError: false,
          showPasswordMismatchError: false
        });

        _this.props.onLoginSuccess(data);
      }
    };

    _this.onLoginError = function (data) {
      if (data === void 0) {
        data = {};
      }

      var biometry = _this.state.biometry;
      var prefix = biometry ? 'biometry_' : '';
      var _this$props = _this.props,
          onChallengePinCodeCall = _this$props.onChallengePinCodeCall,
          email = _this$props.email;

      if (_this.props.onError) {
        _this.props.onError();
      }

      var _data = data,
          _data$response = _data.response,
          response = _data$response === void 0 ? {} : _data$response;

      if (response.status === 401) {
        var _ref3 = response.data || {},
            _ref2$message2 = _ref3.message,
            message = _ref2$message2 === void 0 ? 'UNAUTHORIZED' : _ref2$message2;

        if (message === 'PIN_CODE') {
          var _ref5 = response.data || {},
              _ref4$token2 = _ref5.token,
              token = _ref4$token2 === void 0 ? '' : _ref4$token2;

          if (typeof onChallengePinCodeCall === 'function') {
            onChallengePinCodeCall(token, email);
            return;
          }
        }

        lurker$u.viewMessageEvt('error', {
          accounts_reason: "" + prefix + message.toLowerCase(),
          accounts_status_code: response.status
        });

        if (biometry) {
          secureStorage$3.resetCredential();

          _this.showError('showBiometryError', {
            biometry: false
          });
        } else if (message === 'ACCOUNT_NOT_FOUND') {
          _this.showError('showAccountNotFoundError');
        } else if (message === 'PASSWORD_MISMATCH') {
          _this.onPasswordMismatchError();
        } else {
          _this.showError('showUnauthorizedError');
        }
      } else if (response.status === 429) {
        lurker$u.viewMessageEvt('error', {
          accounts_reason: prefix + "rate_limit_exceeded",
          accounts_status_code: response.status
        });

        _this.showError('showRateLimitError');
      } else if (response.status === 410) {
        lurker$u.viewMessageEvt('error', {
          accounts_reason: prefix + "account_inactive",
          accounts_status_code: response.status
        });

        _this.showError('showInactiveError');
      } else if (response.status) {
        lurker$u.viewMessageEvt('error', {
          accounts_reason: prefix + "unexpected_status_code",
          accounts_status_code: response.status
        });

        _this.setState({
          showGenericError: true
        });
      } else {
        lurker$u.viewMessageEvt('error', {
          accounts_reason: prefix + "unexpected_error",
          accounts_error_message: data && data.message || 'unknown'
        });

        _this.setState({
          showGenericError: true
        });
      }

      behaviors.scrollToTop();
    };

    _this.onPasswordMismatchError = function () {
      var _this$props2 = _this.props,
          passwordlessSignIn = _this$props2.passwordlessSignIn,
          email = _this$props2.email;
      var attempts = _this.state.attempts;

      if (!attempts) {
        passwordlessSendEmailApiCall(email).then(function () {
          return _this.showError('showPasswordlessError', {
            attempts: ATTEMPTS_COUNT
          });
        })["catch"](function () {
          return _this.showError('showPasswordMismatchError');
        });
      } else {
        _this.showError('showPasswordMismatchError', passwordlessSignIn ? {
          attempts: attempts - 1
        } : {});
      }
    };

    _this.onReactivationLinkClick = function () {
      var _this$props3 = _this.props,
          onReactivationLinkClick = _this$props3.onReactivationLinkClick,
          email = _this$props3.email;

      if (typeof onReactivationLinkClick === 'function') {
        onReactivationLinkClick(email);
      }
    };

    var _biometry = props.biometry;
    _this.validateBeforeSend = _this.validateBeforeSend.bind(_assertThisInitialized(_this));
    _this.checkFormIsValid = _this.checkFormIsValid.bind(_assertThisInitialized(_this));
    _this.doLogin = _this.doLogin.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.onTryLogin = _this.onTryLogin.bind(_assertThisInitialized(_this));
    _this.state = _extends({}, errors$6, {
      biometry: _biometry,
      abTests: _this.props.abTests || '',
      isSubmitting: false,
      autoFocusPassword: false,
      suggestion: '',
      attempts: ATTEMPTS_COUNT,
      validators: {
        password: {
          action: null,
          message: ''
        }
      },
      fields: {
        password: {
          value: null,
          pristine: true,
          valid: false
        }
      }
    });
    return _this;
  }

  var _proto = SplitLoginPasswordTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$u.pageLoadEvt();
    this.checkTransientErrors();
  };

  _proto.onFieldChange = function onFieldChange(event, field, validator, msg, pristine) {
    if (pristine === void 0) {
      pristine = false;
    }

    var value = event.target.value;

    var fields = _extends({}, this.state.fields);

    if (event.type === 'change' && event.isTrusted) {
      var _extends2;

      this.setState({
        fields: _extends({}, fields, (_extends2 = {}, _extends2[field] = {
          value: value
        }, _extends2))
      });
    } else {
      var _extends3;

      this.setState({
        fields: _extends({}, fields, (_extends3 = {}, _extends3[field] = {
          value: value,
          msg: value ? msg : '',
          valid: value && typeof validator === 'function' ? validator(value) : !!value,
          pristine: pristine
        }, _extends3))
      });
    }
  };

  _proto.onTryLogin = function onTryLogin() {
    var _this2 = this;

    var _this$state = this.state,
        fields = _this$state.fields,
        abTests = _this$state.abTests;
    var email = this.props.email;
    this.setState({
      showGenericError: false,
      isSubmitting: true
    });
    v4(email, fields.password.value, abTests).then(this.onLoginSuccess)["catch"](this.onLoginError)["finally"](function () {
      _this2.setState({
        isSubmitting: false
      });
    });
  };

  _proto.getButtonText = function getButtonText() {
    var biometry = this.state.biometry;

    switch (biometry) {
      case 'TouchID':
        return 'Entrar com Touch ID';

      case 'FaceID':
        return 'Entrar com Face ID';

      case 'Fingerprint':
        return 'Entrar com impressão digital';

      default:
        return 'Entrar';
    }
  };

  _proto.getBiometryTextError = function getBiometryTextError() {
    var biometry = this.props.biometry;

    switch (biometry) {
      case 'TouchID':
        return 'Não foi possível acessar com o Touch ID';

      case 'FaceID':
        return 'Não foi possível acessar com o Face ID';

      default:
        return 'Não foi possível acessar com a impressão digital';
    }
  };

  _proto.checkTransientErrors = function checkTransientErrors() {
    var _this3 = this;

    transientErrorsStorage.get().then(function (error) {
      if (typeof error === 'string') {
        var _this3$setState;

        _this3.setState((_this3$setState = {}, _this3$setState[error] = true, _this3$setState));
      }
    });
  };

  _proto.showError = function showError(error, extra) {
    var _extends4;

    this.setState(_extends({}, errors$6, extra, (_extends4 = {}, _extends4[error] = true, _extends4)));
  };

  _proto.validateBeforeSend = function validateBeforeSend() {
    var _this4 = this;

    return new Promise(function (resolve) {
      var _this4$state = _extends({}, _this4.state),
          fields = _this4$state.fields,
          validators = _this4$state.validators;

      Object.keys(fields).forEach(function (currentField) {
        var _validators$currentFi = validators[currentField],
            action = _validators$currentFi.action,
            message = _validators$currentFi.message;
        var value = fields[currentField].value;
        fields[currentField] = {
          value: value,
          msg: value ? message : '',
          valid: value && typeof action === 'function' ? action(value) : !!value,
          pristine: false
        };
      });

      _this4.setState({
        fields: fields
      }, resolve);
    });
  };

  _proto.checkFormIsValid = function checkFormIsValid() {
    var _this5 = this;

    return new Promise(function (resolve, reject) {
      var allValid = true;

      var updatedFields = _extends({}, _this5.state.fields);

      Object.keys(_this5.state.fields).forEach(function (key) {
        if (!_this5.state.fields[key].valid) {
          updatedFields[key].pristine = false;
          allValid = false;
        }
      });

      if (allValid) {
        resolve();
      } else {
        _this5.setState({
          fields: updatedFields,
          isSubmitting: false
        }, reject);
      }
    });
  };

  _proto.doLogin = function doLogin() {
    var _this6 = this;

    this.checkFormIsValid().then(function () {
      return _this6.onTryLogin();
    })["catch"](function () {
      lurker$u.viewMessageEvt('error', _extends({
        accounts_reason: 'invalid_fields'
      }, getInvalidFields(_this6.state.fields)));
    });
  };

  _proto.handleSubmit = function handleSubmit(event) {
    var _this7 = this;

    var biometry = this.state.biometry;
    event.preventDefault();
    lurker$u.clickEvt('email');

    if (biometry) {
      secureStorage$3.requestCredential().then(function (credentials) {
        if (credentials) {
          var email = credentials.email,
              password = credentials.password;
          var abTests = _this7.state.abTests;

          _this7.setState(_extends({}, errors$6, {
            isSubmitting: true
          }));

          v4(email, password, abTests).then(_this7.onLoginSuccess)["catch"](_this7.onLoginError)["finally"](function () {
            _this7.setState({
              isSubmitting: false
            });
          });
          return;
        }

        _this7.showError('showBiometryError', {
          biometry: false
        });
      });
    } else {
      this.validateBeforeSend().then(function () {
        return _this7.setState({
          isSubmitting: true
        }, function () {
          return _this7.doLogin();
        });
      })["catch"](function () {
        _this7.setState({
          isSubmitting: false
        });
      });
    }
  };

  _proto.render = function render() {
    var _this8 = this;

    var _this$props4 = this.props,
        email = _this$props4.email,
        onForgotPassword = _this$props4.onForgotPassword,
        onSwitchEmail = _this$props4.onSwitchEmail,
        showReactivationLink = _this$props4.showReactivationLink;
    var password = this.state.fields.password;
    var _this$state2 = this.state,
        biometry = _this$state2.biometry,
        isSubmitting = _this$state2.isSubmitting,
        showAccountNotFoundError = _this$state2.showAccountNotFoundError,
        showBiometryError = _this$state2.showBiometryError,
        showExpiredTokenError = _this$state2.showExpiredTokenError,
        showGenericError = _this$state2.showGenericError,
        showInactiveError = _this$state2.showInactiveError,
        showPasswordMismatchError = _this$state2.showPasswordMismatchError,
        showPasswordlessError = _this$state2.showPasswordlessError,
        showRateLimitError = _this$state2.showRateLimitError,
        showUnauthorizedError = _this$state2.showUnauthorizedError;
    var passwordErrorMessage = showPasswordMismatchError ? '' : 'Este campo é obrigatório.';
    var passwordHasError = password.hasOwnProperty('valid') && !password.valid && !password.pristine || showPasswordMismatchError;
    return /*#__PURE__*/React.createElement(Content$1a, null, /*#__PURE__*/React.createElement(Heading, {
      text: "Que bom te ver de novo"
    }), /*#__PURE__*/React.createElement(EmailChipWrapper$3, null, /*#__PURE__*/React.createElement(EmailChip, {
      href: "#",
      onClick: onSwitchEmail
    }, email)), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel acessar sua conta."
    })), showUnauthorizedError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Oops! E-mail ou senha incorretos. Por favor, tente novamente."
    })), !showUnauthorizedError && showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
    })), showInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      contactUsLink: "https://ajuda.olx.com.br/s/article/reativar-conta-na-olx",
      showInactiveError: showReactivationLink,
      errorAction: showReactivationLink ? this.onReactivationLinkClick : null,
      text: "Esta conta foi desativada."
    })), showAccountNotFoundError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showAccountNotFoundError: true,
      errorAction: onSwitchEmail,
      text: "N\xE3o existe uma conta com este e-mail."
    })), showPasswordMismatchError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showPasswordMismatchError: true,
      errorAction: onForgotPassword,
      text: "Sua senha est\xE1 incorreta."
    })), showBiometryError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showBiometryError: true,
      text: this.getBiometryTextError()
    })), showPasswordlessError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Enviamos um e-mail para " + email + " para ajudar a acessar sua conta rapidamente."
    })), showExpiredTokenError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$a, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "O link para acesso r\xE1pido expirou."
    })), /*#__PURE__*/React.createElement(PageForm$6, {
      method: "POST",
      onSubmit: this.handleSubmit,
      noValidate: true
    }, /*#__PURE__*/React.createElement(Input$1, {
      autoComplete: "email",
      disabled: true,
      hidden: true,
      value: email
    }), !biometry && /*#__PURE__*/React.createElement(formItem, {
      label: "Senha",
      error: passwordErrorMessage,
      hasError: passwordHasError,
      linkText: "Esqueceu sua senha?",
      onClick: onForgotPassword
    }, /*#__PURE__*/React.createElement(PasswordInput, {
      hasError: passwordHasError,
      value: password.value,
      onChange: function onChange(event) {
        return _this8.onFieldChange(event, 'password');
      },
      onBlur: function onBlur(event) {
        return _this8.onFieldChange(event, 'password');
      },
      disabled: isSubmitting,
      blurOnSubmit: true,
      onSubmitEditing: this.handleSubmit,
      inputRef: function inputRef(x) {
        _this8.input = x;
      },
      visiblePassword: false
    })), /*#__PURE__*/React.createElement(Button$1, {
      fluid: true,
      size: "large",
      disabled: isSubmitting,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, this.getButtonText())), /*#__PURE__*/React.createElement(HRuleWrapper$g, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
      text: "N\xE3o \xE9 voc\xEA? ",
      linkText: "Entre com outra conta",
      href: "/acesso",
      onClick: onSwitchEmail
    }));
  };

  return SplitLoginPasswordTemplate;
}(React.Component);

SplitLoginPasswordTemplate.propTypes = {
  abTests: PropTypes__default.string,
  biometry: PropTypes__default.string,
  email: PropTypes__default.string.isRequired,
  onChallengePinCodeCall: PropTypes__default.func,
  onError: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onLoginSuccess: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func,
  passwordlessSignIn: PropTypes__default.bool,
  showReactivationLink: PropTypes__default.bool
};

var _templateObject$2E, _templateObject2$1_, _templateObject3$1q;
var Content$1b = styled(View$1)(_templateObject$2E || (_templateObject$2E = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$1_ || (_templateObject2$1_ = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4px;\n    margin-bottom: 0;\n  "]))));
var FooterWrapper$6 = styled(View$1)(_templateObject3$1q || (_templateObject3$1q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var EmailLoginPage = function EmailLoginPage(_ref) {
  var abTests = _ref.abTests,
      email = _ref.email,
      onChallengePinCodeCall = _ref.onChallengePinCodeCall,
      onForgotPassword = _ref.onForgotPassword,
      onLoginSuccess = _ref.onLoginSuccess,
      onReactivationLinkClick = _ref.onReactivationLinkClick,
      onSwitchEmail = _ref.onSwitchEmail,
      passwordlessSignIn = _ref.passwordlessSignIn,
      showReactivationLink = _ref.showReactivationLink,
      visiblePassword = _ref.visiblePassword;
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$1b, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(SplitLoginPasswordTemplate, {
    abTests: abTests,
    email: email,
    onChallengePinCodeCall: onChallengePinCodeCall,
    onForgotPassword: onForgotPassword,
    onLoginSuccess: onLoginSuccess,
    onReactivationLinkClick: onReactivationLinkClick,
    onSwitchEmail: onSwitchEmail,
    passwordlessSignIn: passwordlessSignIn,
    showReactivationLink: showReactivationLink,
    visiblePassword: visiblePassword
  })), /*#__PURE__*/React.createElement(FooterWrapper$6, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))));
};
EmailLoginPage.propTypes = {
  abTests: PropTypes__default.string,
  email: PropTypes__default.string,
  onChallengePinCodeCall: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onLoginSuccess: PropTypes__default.func,
  onReactivationLinkClick: PropTypes__default.func,
  onSwitchEmail: PropTypes__default.func,
  passwordlessSignIn: PropTypes__default.bool,
  showReactivationLink: PropTypes__default.bool,
  visiblePassword: PropTypes__default.bool
};

var _templateObject$2F, _templateObject2$1$, _templateObject3$1r;
var ButtonView = styled(Button)(_templateObject$2F || (_templateObject$2F = _taggedTemplateLiteralLoose(["\n  background-color: #3a5998 !important;\n  color: #fff !important;\n  font-size: var(--font-size-xs) !important;\n  border: none !important;\n  cursor: pointer;\n\n  :hover {\n    opacity: 0.9;\n    background-color: #3a5998 !important;\n    border: none !important;\n    color: #fff !important;\n  }\n"])));
var FacebookIcon$1 = styled(SVG)(_templateObject2$1$ || (_templateObject2$1$ = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 24px;\n  transform: translateY(-50%);\n"])));
var ButtonText = styled(Text$1)(_templateObject3$1r || (_templateObject3$1r = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  font-size: var(--font-size-xs) !important;\n  text-align: center !important;\n  color: #fff !important;\n"])));

var FacebookButton = function FacebookButton(_ref) {
  var text = _ref.text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      onCancel = _ref.onCancel,
      onError = _ref.onError,
      onRequireEmail = _ref.onRequireEmail,
      onSubmit = _ref.onSubmit,
      onUserLoggedIn = _ref.onUserLoggedIn,
      lurker = _ref.lurker,
      tracker = _ref.tracker,
      facebookAppId = _ref.facebookAppId;
  return /*#__PURE__*/React.createElement(FacebookSignIn$1, {
    onCancel: onCancel,
    facebookAppId: facebookAppId,
    onError: onError,
    onRequireEmail: onRequireEmail,
    onSubmit: onSubmit,
    onSuccess: onUserLoggedIn,
    lurker: lurker,
    tracker: tracker,
    render: function render(_ref2) {
      var onClick = _ref2.onClick;
      return /*#__PURE__*/React.createElement(ButtonView, {
        onClick: onClick,
        fullWidth: true,
        size: size,
        "aria-label": "Login Facebook"
      }, /*#__PURE__*/React.createElement(FacebookIcon$1, {
        width: 12.4,
        height: 24,
        svgPath: facebookSvgPath,
        viewBox: "0 0 12.4 24",
        color: "#fff"
      }), /*#__PURE__*/React.createElement(ButtonText, null, text));
    }
  });
};

FacebookButton.propTypes = {
  text: PropTypes__default.string.isRequired,
  facebookAppId: PropTypes__default.string,
  onRequireEmail: PropTypes__default.func.isRequired,
  onUserLoggedIn: PropTypes__default.func.isRequired,
  onSubmit: PropTypes__default.func.isRequired,
  onError: PropTypes__default.func,
  onCancel: PropTypes__default.func,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object
};

var _excluded$e = ["fill", "d"];

var _templateObject$2G;
var StyledSVGEl$1 = styled.svg(_templateObject$2G || (_templateObject$2G = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  cursor: ", ";\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.onClick ? 'pointer' : 'unset';
}, function (props) {
  return props.width && "\n    width: " + props.width + "px\n  ";
}, function (props) {
  return props.height && "\n    height: " + props.height + "px\n  ";
});

var SVG$1 = function SVG(_ref) {
  var width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox,
      paths = _ref.paths,
      onClick = _ref.onClick,
      className = _ref.className;
  var widthParam = width ? width + "px" : undefined;
  var heightParam = height ? height + "px" : undefined;
  return /*#__PURE__*/React.createElement(StyledSVGEl$1, {
    onClick: onClick,
    className: className,
    width: widthParam,
    height: heightParam,
    viewBox: viewBox
  }, paths.map(function (path, i) {
    var fill = path.fill,
        d = path.d,
        other = _objectWithoutPropertiesLoose(path, _excluded$e);

    return /*#__PURE__*/React.createElement("path", _extends({
      key: i,
      fill: fill,
      d: d
    }, other));
  }));
};

SVG$1.propTypes = {
  className: PropTypes__default.string,
  onClick: PropTypes__default.func,
  width: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  height: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  viewBox: PropTypes__default.string.isRequired,
  paths: PropTypes__default.array.isRequired
};

var variants$1 = {
  gray: {
    background: 'background-color: #ececec;',
    text: 'color: #4a4a4a;',
    icon: colored
  },
  blue: {
    background: 'background-color: #4285f4;',
    text: 'color: #ffffff;',
    icon: white
  },
  red: {
    background: 'background-color: #d43427;',
    text: 'color: #ffffff;',
    icon: white
  }
};

var _templateObject$2H, _templateObject2$20, _templateObject3$1s;
var ButtonView$1 = styled(Button)(_templateObject$2H || (_templateObject$2H = _taggedTemplateLiteralLoose(["\n  color: #fff !important;\n  font-size: 16px !important;\n  ", "\n\n  :hover {\n    opacity: 0.9;\n    ", "\n  }\n"])), function (props) {
  return variants$1[props.variant].background.replace(';', '') + " !important;";
}, function (props) {
  return variants$1[props.variant].background.replace(';', '') + " !important;";
});
var GoogleIcon = styled(SVG$1)(_templateObject2$20 || (_templateObject2$20 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 24px;\n  transform: translateY(-50%);\n"])));
var EntrarText = styled(Text$1)(_templateObject3$1s || (_templateObject3$1s = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  font-size: 16px !important;\n  text-align: center !important;\n  color: #fff !important;\n"])));
var VARIANT = 'blue';

var GoogleButton = function GoogleButton(_ref) {
  var text = _ref.text,
      onSubmit = _ref.onSubmit,
      onError = _ref.onError,
      onCancel = _ref.onCancel,
      onUserLoggedIn = _ref.onUserLoggedIn,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      lurker = _ref.lurker,
      tracker = _ref.tracker;
  return /*#__PURE__*/React.createElement(GoogleSignIn$1, {
    onCancel: onCancel,
    onError: onError,
    onSubmit: onSubmit,
    onSuccess: onUserLoggedIn,
    lurker: lurker,
    tracker: tracker,
    render: function render(_ref2) {
      var onClick = _ref2.onClick;
      return /*#__PURE__*/React.createElement(ButtonView$1, {
        variant: VARIANT,
        onClick: onClick,
        size: size,
        fullWidth: true,
        "aria-label": "Login Google"
      }, /*#__PURE__*/React.createElement(GoogleIcon, {
        width: 24,
        height: 24,
        paths: variants$1[VARIANT].icon,
        viewBox: "0 0 512 512"
      }), /*#__PURE__*/React.createElement(EntrarText, null, text));
    }
  });
};

GoogleButton.propTypes = {
  onCancel: PropTypes__default.func,
  onError: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onUserLoggedIn: PropTypes__default.func,
  text: PropTypes__default.string.isRequired,
  lurker: PropTypes__default.object,
  tracker: PropTypes__default.object
};

var _templateObject$2I, _templateObject2$21, _templateObject3$1t, _templateObject4$_;

var _excluded$f = ["backgroundColor"];

var _View = function _View(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  return /*#__PURE__*/React.createElement(View$1, props);
};

var Content$1c = styled(_View)(_templateObject$2I || (_templateObject$2I = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  max-height: 96px;\n  flex-direction: row;\n  align-items: center;\n  background-color: ", ";\n  padding-top: 16px;\n  padding-right: 16px;\n  padding-bottom: 16px;\n  padding-left: 16px;\n"])), function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
});
var InfoBox$1 = styled(View$1)(_templateObject2$21 || (_templateObject2$21 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-left: 24px;\n"])));
var UserName = styled(function (props) {
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    weight: "semiBold"
  }, props));
})(_templateObject3$1t || (_templateObject3$1t = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n"])));
var UserEmail = styled(function (props) {
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    size: "caption"
  }, props));
})(_templateObject4$_ || (_templateObject4$_ = _taggedTemplateLiteralLoose(["\n  color: #999999;\n"])));

var UserToConnect = function UserToConnect(props) {
  var name = props.name,
      imageUrl = props.imageUrl,
      className = props.className,
      email = props.email,
      backgroundColor = props.backgroundColor;
  return /*#__PURE__*/React.createElement(Content$1c, {
    className: className,
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    imageUrl: imageUrl,
    alt: name
  }), /*#__PURE__*/React.createElement(InfoBox$1, null, /*#__PURE__*/React.createElement(UserName, null, name), /*#__PURE__*/React.createElement(UserEmail, null, email)));
};

UserToConnect["default"] = {
  backgroundColor: '#f9f9f9'
};
UserToConnect.propTypes = {
  name: PropTypes__default.string.isRequired,
  email: PropTypes__default.string.isRequired,
  imageUrl: PropTypes__default.string,
  className: PropTypes__default.string,
  backgroundColor: PropTypes__default.string
};

var API_ENDPOINT$e = '/v1/user/profile';
var apiCall = (function () {
  return axios.get(API_ENDPOINT$e).then(function (response) {
    return response.data;
  });
});

var _templateObject$2J, _templateObject2$22, _templateObject3$1u, _templateObject4$$;
var lurker$v = new Lurker('login');
var Content$1d = styled(View$1)(_templateObject$2J || (_templateObject$2J = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var UserWrapper = styled(View$1)(_templateObject2$22 || (_templateObject2$22 = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-bottom: 24px;\n"])));
var ErrorMsgWrapper$b = styled(View$1)(_templateObject3$1u || (_templateObject3$1u = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var HRuleWrapper$h = styled(View$1)(_templateObject4$$ || (_templateObject4$$ = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));
var errors$7 = {
  showGenericError: false,
  showGoogleInitializationError: false
};

var OauthLoginTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(OauthLoginTemplate, _React$Component);

  function OauthLoginTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onFacebookSubmit = function () {
      _this.setState(errors$7);
    };

    _this.onGoogleSubmit = function () {
      _this.setState(errors$7);
    };

    _this.onSuccess = function (data) {
      _this.setState(errors$7, function () {
        if (_this.props.onLoginSuccess) {
          _this.props.onLoginSuccess(data);
        }
      });
    };

    _this.onError = function (error) {
      var errorBox = 'showGenericError';

      if (error === 'google_initialization_error') {
        errorBox = 'showGoogleInitializationError';
      }

      _this.showError(errorBox, function () {
        if (_this.props.onError) {
          _this.props.onError(error);
        }
      });
    };

    _this.showError = function (error, callback) {
      var _extends2;

      _this.setState(_extends({}, errors$7, (_extends2 = {}, _extends2[error] = true, _extends2)), callback);
    };

    _this.state = _extends({}, errors$7, {
      email: '',
      imageUrl: '',
      name: ''
    });
    return _this;
  }

  var _proto = OauthLoginTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$v.pageLoadEvt();
    this.loadUserProfile();
  };

  _proto.loadUserProfile = function loadUserProfile() {
    var _this2 = this;

    apiCall().then(function (_ref) {
      var email = _ref.email,
          imageUrl = _ref.imageUrl,
          name = _ref.nickname;

      _this2.setState({
        email: email,
        imageUrl: imageUrl,
        name: name
      });
    })["catch"](function (error) {
      if (error === void 0) {
        error = {};
      }

      var onError = _this2.props.onError;

      var _error = error,
          _error$response = _error.response,
          _error$response2 = _error$response === void 0 ? {} : _error$response,
          status = _error$response2.status,
          _error$message = _error.message,
          message = _error$message === void 0 ? 'unknown' : _error$message;

      if (status) {
        lurker$v.viewMessageEvt('error', {
          accounts_reason: 'load_user_profile_unexpected_status_code',
          accounts_status_code: status
        });
      } else {
        lurker$v.viewMessageEvt('error', {
          accounts_reason: 'load_user_profile_unexpected_error',
          accounts_error_message: message
        });
      }

      if (onError) {
        onError('LOAD_USER_PROFILE_ERROR');
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        facebookAppId = _this$props.facebookAppId,
        onRequireEmail = _this$props.onRequireEmail,
        onLoginClick = _this$props.onLoginClick,
        type = _this$props.type;
    var _this$state = this.state,
        showGenericError = _this$state.showGenericError,
        showGoogleInitializationError = _this$state.showGoogleInitializationError,
        email = _this$state.email,
        imageUrl = _this$state.imageUrl,
        name = _this$state.name;
    var firstName = name && typeof name === 'string' ? name.split(' ')[0] + ", que" : 'Que';
    return /*#__PURE__*/React.createElement(Content$1d, null, /*#__PURE__*/React.createElement(logoTitle, {
      title: firstName + " bom te ver aqui de novo"
    }), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$b, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel acessar sua conta. Por favor, tente novamente."
    })), showGoogleInitializationError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$b, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showGoogleInitializationError: true,
      text: "N\xE3o foi poss\xEDvel entrar com o Google."
    })), /*#__PURE__*/React.createElement(UserWrapper, null, /*#__PURE__*/React.createElement(UserToConnect, {
      email: email,
      imageUrl: imageUrl,
      name: name
    })), type === 'google' ? /*#__PURE__*/React.createElement(GoogleButton, {
      onError: this.onError,
      onSubmit: this.onGoogleSubmit,
      onUserLoggedIn: this.onSuccess,
      text: "Continuar com Google",
      lurker: lurker$v
    }) : /*#__PURE__*/React.createElement(FacebookButton, {
      facebookAppId: facebookAppId,
      onError: this.onError,
      onRequireEmail: onRequireEmail,
      onSubmit: this.onFacebookSubmit,
      onUserLoggedIn: this.onSuccess,
      text: "Continuar com Facebook",
      lurker: lurker$v
    }), /*#__PURE__*/React.createElement(HRuleWrapper$h, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
      text: "N\xE3o \xE9 voc\xEA?",
      linkText: "Entre com outra conta",
      href: "/acesso",
      onClick: onLoginClick
    }));
  };

  return OauthLoginTemplate;
}(React.Component);

OauthLoginTemplate.propTypes = {
  facebookAppId: PropTypes__default.string,
  onError: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  onLoginSuccess: PropTypes__default.func.isRequired,
  onLoginClick: PropTypes__default.func.isRequired,
  type: PropTypes__default.oneOf(['facebook', 'google']).isRequired
};

var _templateObject$2K, _templateObject2$23, _templateObject3$1v;
var Content$1e = styled(View$1)(_templateObject$2K || (_templateObject$2K = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$23 || (_templateObject2$23 = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4px;\n    margin-bottom: 0;\n  "]))));
var FooterWrapper$7 = styled(View$1)(_templateObject3$1v || (_templateObject3$1v = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var FacebookLoginPage = function FacebookLoginPage(_ref) {
  var facebookAppId = _ref.facebookAppId,
      onError = _ref.onError,
      onLoginClick = _ref.onLoginClick,
      onRequireEmail = _ref.onRequireEmail,
      onLoginSuccess = _ref.onLoginSuccess;
  return /*#__PURE__*/React.createElement(Content$1e, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(OauthLoginTemplate, {
    facebookAppId: facebookAppId,
    onError: onError,
    onLoginClick: onLoginClick,
    onLoginSuccess: onLoginSuccess,
    onRequireEmail: onRequireEmail,
    type: "facebook"
  })), /*#__PURE__*/React.createElement(FooterWrapper$7, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null)));
};
FacebookLoginPage.propTypes = {
  facebookAppId: PropTypes__default.string,
  onError: PropTypes__default.func,
  onLoginClick: PropTypes__default.func.isRequired,
  onLoginSuccess: PropTypes__default.func.isRequired,
  onRequireEmail: PropTypes__default.func.isRequired
};

var _templateObject$2L, _templateObject2$24, _templateObject3$1w;
var Content$1f = styled(View$1)(_templateObject$2L || (_templateObject$2L = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$24 || (_templateObject2$24 = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4px;\n    margin-bottom: 0;\n  "]))));
var FooterWrapper$8 = styled(View$1)(_templateObject3$1w || (_templateObject3$1w = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var GoogleLoginPage = function GoogleLoginPage(_ref) {
  var onError = _ref.onError,
      onLoginClick = _ref.onLoginClick,
      onLoginSuccess = _ref.onLoginSuccess;
  return /*#__PURE__*/React.createElement(Content$1f, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(OauthLoginTemplate, {
    onError: onError,
    onLoginClick: onLoginClick,
    onLoginSuccess: onLoginSuccess,
    type: "google"
  })), /*#__PURE__*/React.createElement(FooterWrapper$8, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null)));
};
GoogleLoginPage.propTypes = {
  onError: PropTypes__default.func,
  onLoginClick: PropTypes__default.func.isRequired,
  onLoginSuccess: PropTypes__default.func.isRequired
};

var _templateObject$2M, _templateObject2$25, _templateObject3$1x, _templateObject4$10, _templateObject5$H;
var domains$1 = ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com', 'yahoo.com.br', 'icloud.com', 'bol.com.br', 'live.com', 'outlook.com.br', 'uol.com.br', 'terra.com.br', 'ig.com.br'];
var secondLevelDomains$1 = ['yahoo', 'hotmail', 'live', 'outlook'];
var topLevelDomains$1 = ['com', 'com.br'];
var Wrapper$f = styled(View$1)(_templateObject$2M || (_templateObject$2M = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  margin-top: 4px;\n"])));
var Suggestion$1 = styled(function (props) {
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    size: "body2"
  }, props));
})(_templateObject2$25 || (_templateObject2$25 = _taggedTemplateLiteralLoose(["\n  color: #4a4a4a;\n"])));
var EmailWrapper$1 = styled(View$1)(_templateObject3$1x || (_templateObject3$1x = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  margin-left: 4px;\n"])));
var Address = styled(function (props) {
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    size: "body2"
  }, props));
})(_templateObject4$10 || (_templateObject4$10 = _taggedTemplateLiteralLoose(["\n  color: #9027b0 !important;\n"])));
var Domain = styled(function (props) {
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    size: "body2",
    weight: "bold"
  }, props));
})(_templateObject5$H || (_templateObject5$H = _taggedTemplateLiteralLoose(["\n  color: #9027b0 !important;\n"])));

var DidYouMean$1 = function DidYouMean(_ref) {
  var address = _ref.address,
      domain = _ref.domain,
      _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Wrapper$f, null, /*#__PURE__*/React.createElement(Suggestion$1, null, "Voc\xEA quis dizer"), /*#__PURE__*/React.createElement(link, {
    type: "primary",
    onClick: function onClick() {
      return _onClick && _onClick(address + "@" + domain);
    }
  }, /*#__PURE__*/React.createElement(EmailWrapper$1, null, /*#__PURE__*/React.createElement(Address, null, address + "@"), /*#__PURE__*/React.createElement(Domain, null, domain))), /*#__PURE__*/React.createElement(Suggestion$1, null, "?"));
};

var MailCheckFormItem = function MailCheckFormItem(_ref2) {
  var value = _ref2.value,
      label = _ref2.label,
      labelweight = _ref2.labelweight,
      error = _ref2.error,
      hasError = _ref2.hasError,
      tip = _ref2.tip,
      inputRef = _ref2.inputRef,
      disabled = _ref2.disabled,
      onSubmitEditing = _ref2.onSubmitEditing,
      onBlur = _ref2.onBlur,
      onChange = _ref2.onChange,
      onSuggestionClick = _ref2.onSuggestionClick;
  return /*#__PURE__*/React.createElement(MailCheck$1, {
    email: value,
    domains: domains$1,
    domainThreshold: 4,
    secondLevelDomains: secondLevelDomains$1,
    secondLevelThreshold: 3,
    topLevelDomains: topLevelDomains$1,
    topLevelThreshold: 1
  }, function (suggestion) {
    return /*#__PURE__*/React.createElement(formItem, {
      label: label || 'E-mail',
      labelweight: labelweight,
      error: error || 'Este campo é obrigatório',
      hasError: hasError,
      tip: tip
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input$1, {
      inputRef: inputRef,
      autoCapitalize: "none",
      autoComplete: "email",
      blurOnSubmit: false,
      disabled: disabled,
      keyboardType: "email-address",
      onBlur: onBlur,
      hasError: hasError,
      onChange: onChange,
      onSubmitEditing: onSubmitEditing,
      returnKeyType: "next",
      value: value
    }), suggestion && /*#__PURE__*/React.createElement(DidYouMean$1, {
      address: suggestion.address,
      domain: suggestion.domain,
      onClick: onSuggestionClick
    })));
  });
};

var postUserEmail = (function (email) {
  return axios.get('/v1/accounts/verify', {
    params: {
      email: email.toLowerCase().trim()
    },
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
});

var _templateObject$2N, _templateObject2$26, _templateObject3$1y, _templateObject4$11, _templateObject5$I, _templateObject6$q;
var lurker$w = new Lurker('login');
var tracker$4 = new Tracker('login');
var Content$1g = styled(View$1)(_templateObject$2N || (_templateObject$2N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var PageForm$7 = styled(Form)(_templateObject2$26 || (_templateObject2$26 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var ErrorMsgWrapper$c = styled(View$1)(_templateObject3$1y || (_templateObject3$1y = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var CenteredContent$1 = styled(Content$1g)(_templateObject4$11 || (_templateObject4$11 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  margin-top: 16px;\n  margin-bottom: 8px;\n"])));

var Heading$1 = function Heading(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(CenteredContent$1, null, /*#__PURE__*/React.createElement(OLXLogo, null), /*#__PURE__*/React.createElement(Title, null, text));
};

var RuleWrapper$1 = styled(View$1)(_templateObject5$I || (_templateObject5$I = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin: 24px 0 8px;\n"])));
var TextCalloutWrapper = styled(View$1)(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));

var getInvalidFields$1 = function getInvalidFields(fields) {
  var invalidFields = {};
  Object.keys(fields).forEach(function (key) {
    if (!fields[key].valid) invalidFields["invalid_" + key] = true;
  });
  return invalidFields;
};

var defaultEmailErrorMsg$3 = 'Por favor, insira um endereço de e-mail válido.';
var errors$8 = {
  showInactiveError: false,
  showGenericError: false,
  showRateLimitError: false,
  showGoogleInitializationError: false
};

var SplitLoginEmailTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(SplitLoginEmailTemplate, _BaseForm);

  function SplitLoginEmailTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.onCancel = function () {
      _this.setState({
        isSubmitting: false
      });
    };

    _this.onMailCheckSuggestionClick = function (suggestion) {
      lurker$w.viewMessageEvt('mailcheck_suggestion_accepted', {
        mailcheck_original: _this.state.fields.email.value,
        mailcheck_suggestion: suggestion
      });
      var valid = isValidEmail(suggestion);

      _this.updateField('email', suggestion, valid, true);
    };

    _this.checkFormIsValid = _this.checkFormIsValid.bind(_assertThisInitialized(_this));
    _this.doLogin = _this.doLogin.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.onClickGoogleLogin = _this.onClickGoogleLogin.bind(_assertThisInitialized(_this));
    _this.onFacebookLoginSubmit = _this.onFacebookLoginSubmit.bind(_assertThisInitialized(_this));
    _this.onOauthError = _this.onOauthError.bind(_assertThisInitialized(_this));
    _this.onOauthSuccess = _this.onOauthSuccess.bind(_assertThisInitialized(_this));
    _this.onTryLogin = _this.onTryLogin.bind(_assertThisInitialized(_this));
    _this.validateBeforeSend = _this.validateBeforeSend.bind(_assertThisInitialized(_this));
    _this.state = _extends({}, errors$8, {
      isSubmitting: false,
      suggestion: '',
      validators: {
        email: {
          action: isValidEmail,
          message: defaultEmailErrorMsg$3
        }
      },
      fields: {
        email: {
          value: null,
          pristine: true,
          valid: false
        }
      }
    });
    return _this;
  }

  var _proto = SplitLoginEmailTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$w.pageLoadEvt();
    tracker$4.pageLoadEvt();
    this.checkStoredEmail();
  };

  _proto.onFieldChange = function onFieldChange(event, field, validator, msg, pristine) {
    if (pristine === void 0) {
      pristine = false;
    }

    var value = event.target.value;

    var fields = _extends({}, this.state.fields);

    if (event.type === 'change' && event.isTrusted) {
      var _extends2;

      this.setState({
        fields: _extends({}, fields, (_extends2 = {}, _extends2[field] = {
          value: value
        }, _extends2))
      });
    } else {
      var _extends3;

      this.setState({
        fields: _extends({}, fields, (_extends3 = {}, _extends3[field] = {
          value: value,
          msg: value ? msg : '',
          valid: value && typeof validator === 'function' ? validator(value) : !!value,
          pristine: pristine
        }, _extends3))
      });
    }
  };

  _proto.onEmailChange = function onEmailChange(event) {
    this.onFieldChange(event, 'email', isValidEmail, defaultEmailErrorMsg$3, true);
  };

  _proto.onEmailBlur = function onEmailBlur(event) {
    this.onFieldChange(event, 'email', isValidEmail, defaultEmailErrorMsg$3, false);
  };

  _proto.onTryLogin = function onTryLogin() {
    var _this2 = this;

    var fields = this.state.fields;
    var _this$props = this.props,
        onEmailSuccess = _this$props.onEmailSuccess,
        onAccountNotFound = _this$props.onAccountNotFound,
        splitLoginVariant = _this$props.splitLoginVariant;
    var email = fields.email.value;
    this.setState({
      showGenericError: false,
      isSubmitting: true
    });
    postUserEmail(email).then(function () {
      lurker$w.viewMessageEvt('verify_email_success');
      storage.set('loggedInEmail', email);

      if (onEmailSuccess) {
        onEmailSuccess(email);
      }
    })["catch"](function (data) {
      if (data === void 0) {
        data = {};
      }

      var _data = data,
          _data$response = _data.response,
          response = _data$response === void 0 ? {} : _data$response;

      if (response.status === 404) {
        if (splitLoginVariant === 2) {
          _this2.setState(_extends({}, errors$8, {
            fields: _extends({}, fields, {
              email: _extends({}, fields.email, {
                msg: 'Não existe uma conta com este e-mail.',
                valid: false,
                pristine: false
              })
            })
          }));
        } else if (onAccountNotFound) {
          onAccountNotFound(email);
        }

        return;
      }

      if (response.status === 429) {
        lurker$w.viewMessageEvt('error', {
          accounts_reason: 'rate_limit_exceeded',
          accounts_status_code: response.status
        });

        _this2.showError('showRateLimitError');
      } else if (response.status === 410) {
        lurker$w.viewMessageEvt('error', {
          accounts_reason: 'account_inactive',
          accounts_status_code: response.status
        });

        _this2.showError('showInactiveError');
      } else if (response.status) {
        lurker$w.viewMessageEvt('error', {
          accounts_reason: 'unexpected_status_code',
          accounts_status_code: response.status
        });

        _this2.setState({
          showGenericError: true
        });
      } else {
        lurker$w.viewMessageEvt('error', {
          accounts_reason: 'unexpected_error',
          accounts_error_message: data && data.message || 'unknown'
        });

        _this2.setState({
          showGenericError: true
        });
      }

      if (_this2.props.onError) {
        _this2.props.onError();
      }

      behaviors.scrollToTop();
    })["finally"](function () {
      _this2.setState({
        isSubmitting: false
      });
    });
  };

  _proto.onOauthSuccess = function onOauthSuccess(data) {
    if (this.props.onLoginSuccess) {
      this.props.onLoginSuccess(data);
    }

    this.setState({
      isSubmitting: false
    });
  };

  _proto.onOauthError = function onOauthError(error) {
    if (this.props.onError) {
      this.props.onError(error);
    }

    var errorBox = 'showGenericError';

    if (error === 'google_initialization_error') {
      errorBox = 'showGoogleInitializationError';
    }

    this.showError(errorBox, {
      isSubmitting: false
    });
  };

  _proto.onFacebookLoginSubmit = function onFacebookLoginSubmit() {
    lurker$w.clickEvt('facebook');
    this.setState({
      isSubmitting: true
    });
  };

  _proto.onClickGoogleLogin = function onClickGoogleLogin() {
    lurker$w.clickEvt('google');
    this.setState({
      isSubmitting: true
    });
  };

  _proto.checkStoredEmail = function checkStoredEmail() {
    var _this3 = this;

    storage.get('loggedInEmail').then(function (value) {
      if (typeof value === 'string') {
        _this3.setState(function (prevState) {
          return {
            fields: _extends({}, prevState.fields, {
              email: {
                value: value,
                pristine: false,
                valid: true
              }
            })
          };
        });
      }
    });
  };

  _proto.showError = function showError(error, extra) {
    var _extends4;

    this.setState(_extends({}, errors$8, extra, (_extends4 = {}, _extends4[error] = true, _extends4)));
  };

  _proto.validateBeforeSend = function validateBeforeSend() {
    var _this4 = this;

    return new Promise(function (resolve) {
      var _this4$state = _extends({}, _this4.state),
          fields = _this4$state.fields,
          validators = _this4$state.validators;

      Object.keys(fields).forEach(function (currentField) {
        var _validators$currentFi = validators[currentField],
            action = _validators$currentFi.action,
            message = _validators$currentFi.message;
        var value = fields[currentField].value;
        fields[currentField] = {
          value: value,
          msg: value ? message : '',
          valid: value && typeof action === 'function' ? action(value) : !!value,
          pristine: false
        };
      });

      _this4.setState({
        fields: fields
      }, resolve);
    });
  };

  _proto.checkFormIsValid = function checkFormIsValid() {
    var _this5 = this;

    return new Promise(function (resolve, reject) {
      var allValid = true;

      var updatedFields = _extends({}, _this5.state.fields);

      Object.keys(_this5.state.fields).forEach(function (key) {
        if (!_this5.state.fields[key].valid) {
          updatedFields[key].pristine = false;
          allValid = false;
        }
      });

      if (allValid) {
        resolve();
      } else {
        _this5.setState({
          fields: updatedFields,
          isSubmitting: false
        }, reject);
      }
    });
  };

  _proto.doLogin = function doLogin() {
    var _this6 = this;

    this.checkFormIsValid().then(function () {
      return _this6.onTryLogin();
    })["catch"](function () {
      _this6.setState(_extends({}, errors$8));

      lurker$w.viewMessageEvt('error', _extends({
        accounts_reason: 'invalid_fields'
      }, getInvalidFields$1(_this6.state.fields)));
    });
  };

  _proto.handleSubmit = function handleSubmit(event) {
    var _this7 = this;

    event.preventDefault();
    lurker$w.clickEvt('verify_email');
    this.validateBeforeSend().then(function () {
      return _this7.setState({
        isSubmitting: true
      }, function () {
        return _this7.doLogin();
      });
    })["catch"](function () {
      _this7.setState({
        isSubmitting: false
      });
    });
  };

  _proto.renderEmail = function renderEmail() {
    var _this8 = this;

    var _this$state = this.state,
        fields = _this$state.fields,
        isSubmitting = _this$state.isSubmitting,
        showInactiveError = _this$state.showInactiveError;
    var email = fields.email;
    var emailHasError = !email.valid && !email.pristine || showInactiveError;
    return /*#__PURE__*/React.createElement(MailCheckFormItem, {
      value: email.value,
      onChange: function onChange(event) {
        return _this8.onEmailChange(event);
      },
      onBlur: function onBlur(event) {
        return _this8.onEmailBlur(event);
      },
      error: email.msg,
      hasError: emailHasError,
      inputRef: function inputRef(x) {
        _this8.inputs.email = x;
      },
      disabled: isSubmitting,
      onSubmitEditing: function onSubmitEditing() {
        return _this8.updateFocus('password');
      },
      onSuggestionClick: this.onMailCheckSuggestionClick
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        facebookAppId = _this$props2.facebookAppId,
        onRegisterClick = _this$props2.onRegisterClick;
    var _this$state2 = this.state,
        isSubmitting = _this$state2.isSubmitting,
        showGenericError = _this$state2.showGenericError,
        showInactiveError = _this$state2.showInactiveError,
        showRateLimitError = _this$state2.showRateLimitError,
        showGoogleInitializationError = _this$state2.showGoogleInitializationError;
    return /*#__PURE__*/React.createElement(Content$1g, null, /*#__PURE__*/React.createElement(Heading$1, {
      text: "Acesse a sua conta"
    }), /*#__PURE__*/React.createElement(OauthLoginCallout, {
      facebookAppId: facebookAppId,
      facebookButtonText: "Acessar com Facebook",
      onCancel: this.onCancel,
      onClickGoogleLogin: this.onClickGoogleLogin,
      onError: this.onOauthError,
      onRequireEmail: this.props.onRequireEmail,
      onSubmit: this.onFacebookLoginSubmit,
      onUserLoggedIn: this.onOauthSuccess,
      lurker: lurker$w,
      tracker: tracker$4
    }), /*#__PURE__*/React.createElement(AlternativeRuler, {
      subtitle: "Acessar com e-mail:"
    }), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$c, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel acessar sua conta."
    })), showGoogleInitializationError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$c, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showGoogleInitializationError: true,
      text: "N\xE3o foi poss\xEDvel entrar com o Google."
    })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$c, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
    })), showInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$c, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: true,
      contactUsLink: "https://ajuda.olx.com.br/s/article/reativar-conta-na-olx",
      text: "Este e-mail n\xE3o pode mais ser usado."
    })), /*#__PURE__*/React.createElement(PageForm$7, {
      method: "POST",
      onSubmit: this.handleSubmit,
      noValidate: true
    }, this.renderEmail(), /*#__PURE__*/React.createElement(Button$1, {
      fluid: true,
      size: "large",
      disabled: isSubmitting,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, "Continuar"), /*#__PURE__*/React.createElement(TextCalloutWrapper, null, /*#__PURE__*/React.createElement(formLabel, {
      text: "N\xE3o tem uma conta?",
      linkText: "Cadastre-se",
      href: "/cadastro",
      onClick: onRegisterClick
    }))));
  };

  return SplitLoginEmailTemplate;
}(BaseForm);

SplitLoginEmailTemplate.propTypes = {
  facebookAppId: PropTypes__default.string,
  onAccountNotFound: PropTypes__default.func,
  onEmailSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  onLoginSuccess: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  splitLoginVariant: PropTypes__default.number
};

var API_ENDPOINT$f = '/v3/accounts';
var registerApiCall = (function (nickname, email, password, abTests) {
  return axios.post(API_ENDPOINT$f, {
    nickname: nickname,
    email: email.toLowerCase().trim(),
    password: password,
    platform: platform
  }, {
    headers: {
      'X-TestAB-Groups': abTests || ''
    },
    withCredentials: true
  }).then(function (response) {
    return {
      data: response.data,
      email: email
    };
  });
});

var emailAlreadyExists$1 = (function () {
  return function () {
    return /*#__PURE__*/React.createElement(errorMsgCallout, {
      text: "Este e-mail j\xE1 possui cadastro.",
      linkText: "Esqueceu sua senha?",
      href: "/recuperacao-senha"
    });
  };
});

var _templateObject$2O, _templateObject2$27, _templateObject3$1z, _templateObject4$12, _templateObject5$J, _templateObject6$r;
var lurker$x = new Lurker('signup');
var tracker$5 = new Tracker('signup');
var Content$1h = styled(View$1)(_templateObject$2O || (_templateObject$2O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var PageForm$8 = styled(Form)(_templateObject2$27 || (_templateObject2$27 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var ErrorMsgWrapper$d = styled(View$1)(_templateObject3$1z || (_templateObject3$1z = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var CadastrarButton = styled(Button$1)(_templateObject4$12 || (_templateObject4$12 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var CenteredContent$2 = styled(Content$1h)(_templateObject5$J || (_templateObject5$J = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  margin-top: 16px;\n  margin-bottom: 8px;\n"])));
var HRuleWrapper$i = styled(View$1)(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 24px;\n  margin-left: 0;\n"])));

var Heading$2 = function Heading(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(CenteredContent$2, null, /*#__PURE__*/React.createElement(OLXLogo, null), /*#__PURE__*/React.createElement(Title, null, text));
};

var getInvalidFields$2 = function getInvalidFields(fields) {
  var invalidFields = {};
  Object.keys(fields).forEach(function (key) {
    if (!fields[key].valid) invalidFields["invalid_" + key] = true;
  });
  return invalidFields;
};

var getPasswordExtraData$3 = function getPasswordExtraData(key, password) {
  var field = {};
  var passwordLevel = password.level;

  if (passwordLevel === -1) {
    field[key] = 'sequential';
  } else if (passwordLevel === 1 || passwordLevel === 2) {
    field[key] = 'weak';
  } else if (passwordLevel === 3) {
    field[key] = 'good';
  } else if (passwordLevel === 4) {
    field[key] = 'strong';
  }

  return field;
};

var ErrorEmailBlacklisted$1 = function ErrorEmailBlacklisted() {
  return /*#__PURE__*/React.createElement(errorMsgCallout, {
    text: "Este e-mail n\xE3o pode ser utilizado."
  });
};

var ErrorNicknameBlacklisted$1 = function ErrorNicknameBlacklisted() {
  return /*#__PURE__*/React.createElement(errorMsgCallout, {
    text: "Este apelido n\xE3o pode ser utilizado."
  });
};

var SplitLoginRegisterTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SplitLoginRegisterTemplate, _React$Component);

  function SplitLoginRegisterTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onCancel = function () {
      _this.setState({
        isSubmitting: false
      });
    };

    _this.onOauthError = function (error) {
      if (_this.props.onError) {
        _this.props.onError(error);
      }

      var errorBox = 'showGenericError';

      if (error === 'google_initialization_error') {
        errorBox = 'showGoogleInitializationError';
      }

      _this.showError(errorBox, {
        isSubmitting: false
      });
    };

    _this.onOauthSuccess = function (data) {
      if (_this.props.onRegisterSuccess) {
        _this.props.onRegisterSuccess(data);
      }

      _this.setState({
        isSubmitting: false
      });
    };

    _this.onClickGoogleLogin = function () {
      lurker$x.clickEvt('google');

      _this.setState({
        isSubmitting: true
      });
    };

    _this.onFacebookLoginSubmit = function () {
      lurker$x.clickEvt('facebook');

      _this.setState({
        isSubmitting: true
      });
    };

    _this.renderPassword = function () {
      var passwordSecurityVersion = _this.props.passwordSecurityVersion;
      var fields = _this.state.fields;
      var password = fields.password;
      var passwordHasError = !password.valid && !password.pristine;
      return passwordSecurityVersion === 'newLayoutPasswordWeak' || passwordSecurityVersion === 'newLayoutPasswordStrong' ? /*#__PURE__*/React.createElement(PasswordWithStrengthMeterAndTips, {
        label: "Senha",
        tipAlignment: "right",
        level: password.level,
        message: password.msg,
        hasError: passwordHasError,
        maxLength: 40,
        onChange: _this.onPasswordChange,
        onBlur: _this.onPasswordChange,
        value: password.value,
        inputRef: function inputRef(x) {
          _this.inputs.password = x;
        },
        onSubmitEditing: _this.handleSubmit
      }) : /*#__PURE__*/React.createElement(passwordWithStrengthMeter, {
        label: "Senha",
        tip: "Use letras, n\xFAmeros e caracteres especiais.",
        tipAlignment: "right",
        level: password.level,
        message: password.msg || REQUIRED_PASSWORD_MESSAGE,
        hasError: passwordHasError,
        maxLength: 40,
        onChange: _this.onPasswordChange,
        onBlur: _this.onPasswordChange,
        value: password.value,
        inputRef: function inputRef(x) {
          _this.inputs.password = x;
        },
        onSubmitEditing: _this.handleSubmit
      });
    };

    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.onEmailBlur = _this.onEmailBlur.bind(_assertThisInitialized(_this));
    _this.onEmailChange = _this.onEmailChange.bind(_assertThisInitialized(_this));
    _this.onNicknameBlur = _this.onNicknameBlur.bind(_assertThisInitialized(_this));
    _this.onNicknameChange = _this.onNicknameChange.bind(_assertThisInitialized(_this));
    _this.onPasswordChange = _this.onPasswordChange.bind(_assertThisInitialized(_this));
    _this.updateField = _this.updateField.bind(_assertThisInitialized(_this));
    _this.updateFocus = _this.updateFocus.bind(_assertThisInitialized(_this));
    _this.inputs = {};
    var _props$email = props.email,
        email = _props$email === void 0 ? null : _props$email;
    _this.state = {
      abTests: _this.props.abTests || '',
      isSubmitting: false,
      showGenericError: false,
      showInactiveError: false,
      showNicknameBlacklistError: false,
      showEmailBlacklistError: false,
      showGoogleInitializationError: false,
      fields: {
        email: {
          value: email,
          pristine: true,
          valid: isValidEmail(email)
        },
        nickname: {
          value: null,
          pristine: true,
          valid: false
        },
        password: {
          value: null,
          pristine: true,
          valid: false,
          level: 0
        }
      }
    };
    return _this;
  }

  var _proto = SplitLoginRegisterTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$x.pageLoadEvt();
    tracker$5.pageLoadEvt();
  };

  _proto.onNicknameChange = function onNicknameChange(value, valid) {
    this.updateField('nickname', value, valid, true);
  };

  _proto.onNicknameBlur = function onNicknameBlur(value, valid) {
    this.updateField('nickname', value, valid, false);
  };

  _proto.onEmailChange = function onEmailChange(event) {
    var value = event.target.value;
    this.updateField('email', value, null, true);
  };

  _proto.onEmailBlur = function onEmailBlur(event) {
    var value = event.target.value;
    var valid = isValidEmail(value);
    var message = value.length > 0 && !valid ? 'Por favor, insira um endereço de e-mail válido.' : null;
    this.updateField('email', value, valid, false, message);
  };

  _proto.onPasswordChange = function onPasswordChange(value, level, msg) {
    var fields = _extends({}, this.state.fields);

    var passwordSecurityVersion = this.props.passwordSecurityVersion;
    this.setState({
      fields: _extends({}, fields, {
        password: {
          value: value,
          valid: isValidPasswordByTest(passwordSecurityVersion) ? level > 2 : level > 0,
          level: level,
          msg: msg,
          pristine: false
        }
      })
    });
  };

  _proto.doSubmitRequest = function doSubmitRequest() {
    var _this2 = this;

    var _this$state = this.state,
        fields = _this$state.fields,
        abTests = _this$state.abTests;
    var nickname = fields.nickname,
        email = fields.email,
        password = fields.password;
    this.setState({
      showGenericError: false,
      showEmailBlacklistError: false,
      showNicknameBlacklistError: false,
      showGoogleInitializationError: false
    });
    return registerApiCall(nickname.value, email.value, password.value, abTests).then(function (_ref2) {
      var data = _ref2.data;
      lurker$x.viewMessageEvt('email_signup_success', _extends({
        remote_addr: data.remoteAddress
      }, getPasswordExtraData$3('password_strength', fields.password)));
      tracker$5.viewMessageEvt('sign_up_email', _extends({
        remote_addr: data.remoteAddress
      }, getPasswordExtraData$3('password_strength', fields.password)));

      _this2.setState({
        isSubmitting: false
      });

      if (_this2.props.onRegisterSuccess) {
        _this2.props.onRegisterSuccess(data);
      }
    })["catch"](function (data) {
      if (data === void 0) {
        data = {};
      }

      if (_this2.props.onError) {
        _this2.props.onError();
      }

      var _data = data,
          _data$response = _data.response,
          response = _data$response === void 0 ? {} : _data$response;

      if (response.status === 409) {
        lurker$x.viewMessageEvt('error', {
          accounts_reason: 'already_signed_user',
          accounts_status_code: response.status
        });
        fields.email.msg = emailAlreadyExists$1();
        fields.email.valid = false;

        _this2.setState({
          fields: fields
        });
      } else if (response.status === 422) {
        lurker$x.viewMessageEvt('error', {
          accounts_reason: 'unprocessable_entity',
          accounts_status_code: response.status
        });

        _this2.setState({
          showGenericError: true
        });
      } else if (response.status === 410) {
        lurker$x.viewMessageEvt('error', {
          accounts_reason: 'account_inactive',
          accounts_status_code: response.status
        });

        _this2.setState({
          showInactiveError: true
        });
      } else if (response.status === 403) {
        if (response.data && response.data.message) {
          if (response.data.message === 'NICKNAME_IN_BLACKLIST') {
            lurker$x.viewMessageEvt('error', {
              accounts_reason: 'nickname_in_blacklist',
              accounts_status_code: response.status
            });
            fields.nickname.msg = ErrorNicknameBlacklisted$1;
            fields.nickname.valid = false;

            _this2.setState({
              fields: fields,
              showNicknameBlacklistError: true
            });
          } else if (response.data.message === 'EMAIL_IN_BLACKLIST') {
            lurker$x.viewMessageEvt('error', {
              accounts_reason: 'email_in_blacklist',
              accounts_status_code: response.status
            });
            fields.email.msg = ErrorEmailBlacklisted$1;
            fields.email.valid = false;

            _this2.setState({
              fields: fields,
              showEmailBlacklistError: true
            });
          }
        } else {
          lurker$x.viewMessageEvt('error', {
            accounts_reason: 'forbidden_without_reason',
            accounts_status_code: response.status
          });

          _this2.setState({
            showGenericError: true
          });
        }
      } else if (response.status) {
        lurker$x.viewMessageEvt('error', {
          accounts_reason: 'unexpected_status_code',
          accounts_status_code: response.status
        });

        _this2.setState({
          showGenericError: true
        });
      } else {
        lurker$x.viewMessageEvt('error', {
          accounts_reason: 'unexpected_error',
          accounts_error_message: data && data.message || 'unknown'
        });

        _this2.setState({
          showGenericError: true
        });
      }

      behaviors.scrollToTop();
    })["finally"](function () {
      _this2.setState({
        isSubmitting: false
      });
    });
  };

  _proto.checkFormIsValid = function checkFormIsValid() {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var allValid = true;
      var fields = _this3.state.fields;
      var updatedFields = Object.keys(fields).reduce(function (obj, field) {
        var _extends2;

        var newField = _extends({}, fields[field]);

        if (!fields[field].valid) {
          newField.pristine = false;
          allValid = false;
        }

        return _extends({}, obj, (_extends2 = {}, _extends2[field] = newField, _extends2));
      }, {});

      if (allValid) {
        resolve();
      } else {
        _this3.setState({
          fields: updatedFields,
          isSubmitting: false
        }, reject);
      }
    });
  };

  _proto.handleSubmit = function handleSubmit(event) {
    var _this4 = this;

    event.preventDefault();
    lurker$x.clickEvt('email');
    this.setState({
      isSubmitting: true
    }, function () {
      _this4.checkFormIsValid().then(function () {
        return _this4.doSubmitRequest();
      })["catch"](function () {
        lurker$x.viewMessageEvt('error', _extends({
          accounts_reason: 'invalid_fields'
        }, getInvalidFields$2(_this4.state.fields), getPasswordExtraData$3('invalid_password_reason', _this4.state.fields.password)));
      });
    });
  };

  _proto.updateFocus = function updateFocus(input) {
    if (this.inputs && this.inputs[input] && this.inputs[input].focus) {
      this.inputs[input].focus();
    }
  };

  _proto.updateField = function updateField(field, value, valid, pristine, message, callback) {
    var _extends3;

    var fields = _extends({}, this.state.fields);

    var newField = _extends({}, fields[field], {
      value: value
    });

    if (typeof valid === 'boolean') {
      newField.valid = valid;
    }

    if (typeof pristine === 'boolean') {
      newField.pristine = pristine;
    }

    if (typeof message === 'string') {
      newField.msg = message;
    }

    this.setState({
      fields: _extends({}, fields, (_extends3 = {}, _extends3[field] = newField, _extends3))
    }, callback);
  };

  _proto.render = function render() {
    var _this5 = this;

    var _this$props = this.props,
        onLoginClick = _this$props.onLoginClick,
        facebookAppId = _this$props.facebookAppId,
        onRequireEmail = _this$props.onRequireEmail;
    var _this$state2 = this.state,
        showGenericError = _this$state2.showGenericError,
        showInactiveError = _this$state2.showInactiveError,
        showNicknameBlacklistError = _this$state2.showNicknameBlacklistError,
        showEmailBlacklistError = _this$state2.showEmailBlacklistError,
        showGoogleInitializationError = _this$state2.showGoogleInitializationError,
        fields = _this$state2.fields,
        isSubmitting = _this$state2.isSubmitting;
    var nickname = fields.nickname,
        email = fields.email;
    var nicknameHasError = !nickname.valid && !nickname.pristine;
    var emailHasError = !email.valid && !email.pristine;
    return /*#__PURE__*/React.createElement(Content$1h, null, /*#__PURE__*/React.createElement(Heading$2, {
      text: "Crie a sua conta"
    }), /*#__PURE__*/React.createElement(OauthLoginCallout, {
      facebookAppId: facebookAppId,
      onCancel: this.onCancel,
      onClickGoogleLogin: this.onClickGoogleLogin,
      onError: this.onOauthError,
      onRequireEmail: onRequireEmail,
      onSubmit: this.onFacebookLoginSubmit,
      onUserLoggedIn: this.onOauthSuccess,
      lurker: lurker$x,
      tracker: tracker$5
    }), /*#__PURE__*/React.createElement(AlternativeRuler, {
      subtitle: "Cadastrar com e-mail:"
    }), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$d, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel criar sua conta."
    })), showGoogleInitializationError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$d, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showGoogleInitializationError: true,
      text: "N\xE3o foi poss\xEDvel entrar com o Google."
    })), showNicknameBlacklistError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$d, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "Este apelido n\xE3o pode ser utilizado."
    })), showEmailBlacklistError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$d, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "Este e-mail n\xE3o pode ser utilizado."
    })), showInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$d, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: true,
      contactUsLink: "https://ajuda.olx.com.br/s/article/reativar-conta-na-olx",
      text: "Este e-mail n\xE3o est\xE1 mais cadastrado na OLX."
    })), /*#__PURE__*/React.createElement(PageForm$8, {
      method: "POST",
      onSubmit: this.handleSubmit
    }, /*#__PURE__*/React.createElement(NicknameFormItem, {
      onChange: function onChange(value, valid) {
        return _this5.onNicknameChange(value, valid);
      },
      onBlur: function onBlur(value, valid) {
        return _this5.onNicknameBlur(value, valid);
      },
      error: nickname.msg,
      hasError: nicknameHasError,
      value: nickname.value,
      blurOnSubmit: false,
      returnKeyType: "next",
      inputRef: function inputRef(x) {
        _this5.inputs.nickname = x;
      },
      onSubmitEditing: function onSubmitEditing() {
        return _this5.updateFocus('email');
      },
      tip: "",
      autoComplete: "none"
    }), /*#__PURE__*/React.createElement(formItem, {
      label: "E-mail",
      error: email.msg || 'Este campo é obrigatório.',
      hasError: emailHasError
    }, /*#__PURE__*/React.createElement(Input$1, {
      value: email.value,
      onChange: function onChange(event) {
        return _this5.onEmailChange(event);
      },
      onBlur: function onBlur(event) {
        return _this5.onEmailBlur(event);
      },
      disabled: isSubmitting,
      keyboardType: "email-address",
      autoCapitalize: "none",
      autoComplete: "email",
      returnKeyType: "next",
      blurOnSubmit: false,
      inputRef: function inputRef(x) {
        _this5.inputs.email = x;
      },
      onSubmitEditing: function onSubmitEditing() {
        return _this5.updateFocus('password');
      }
    })), this.renderPassword(), /*#__PURE__*/React.createElement(CadastrarButton, {
      fluid: true,
      disabled: isSubmitting,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, "Criar cadastro")), /*#__PURE__*/React.createElement(HRuleWrapper$i, null, /*#__PURE__*/React.createElement(ruleWithText, null)), /*#__PURE__*/React.createElement(formLabel, {
      text: "J\xE1 tem uma conta?",
      linkText: "Entrar",
      href: "/acesso",
      onClick: onLoginClick
    }));
  };

  return SplitLoginRegisterTemplate;
}(React.Component);

SplitLoginRegisterTemplate.propTypes = {
  onRegisterSuccess: PropTypes__default.func,
  onLoginClick: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onError: PropTypes__default.func,
  email: PropTypes__default.string,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  abTests: PropTypes__default.string,
  facebookAppId: PropTypes__default.string,
  onRequireEmail: PropTypes__default.string
};

var _templateObject$2P, _templateObject2$28, _templateObject3$1A;
var Content$1i = styled(View$1)(_templateObject$2P || (_templateObject$2P = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$28 || (_templateObject2$28 = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4;\n    margin-bottom: 0;\n  "]))));
var FooterWrapper$9 = styled(View$1)(_templateObject3$1A || (_templateObject3$1A = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var SplitLoginStack = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SplitLoginStack, _React$Component);

  function SplitLoginStack(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onEmailSuccess = function (email) {
      var router = _this.state.router;

      _this.setState({
        email: email
      }, function () {
        return router.push('LoginByEmail');
      });
    };

    _this.onAccountNotFound = function (email) {
      var router = _this.state.router;

      _this.setState({
        email: email
      }, function () {
        return router.push('Register');
      });
    };

    _this.onRegisterClick = function () {
      var router = _this.state.router;
      router.push('Register');
    };

    _this.renderLogin = function () {
      var _this$props = _this.props,
          emailStorage = _this$props.emailStorage,
          facebookAppId = _this$props.facebookAppId,
          onLoginSuccess = _this$props.onLoginSuccess,
          onRequireEmail = _this$props.onRequireEmail,
          abTests = _this$props.abTests,
          splitLoginVariant = _this$props.splitLoginVariant;
      return /*#__PURE__*/React.createElement(SplitLoginEmailTemplate, {
        emailStorage: emailStorage,
        facebookAppId: facebookAppId,
        onAccountNotFound: _this.onAccountNotFound,
        onEmailSuccess: _this.onEmailSuccess,
        onLoginSuccess: onLoginSuccess,
        onRequireEmail: onRequireEmail,
        abTests: abTests,
        onRegisterClick: _this.onRegisterClick,
        splitLoginVariant: splitLoginVariant
      });
    };

    _this.renderRegister = function () {
      var _this$props2 = _this.props,
          abTests = _this$props2.abTests,
          facebookAppId = _this$props2.facebookAppId,
          onError = _this$props2.onError,
          onRegisterSuccess = _this$props2.onRegisterSuccess,
          onRequireEmail = _this$props2.onRequireEmail;
      var _this$state = _this.state,
          email = _this$state.email,
          router = _this$state.router;
      return /*#__PURE__*/React.createElement(SplitLoginRegisterTemplate, {
        abTests: abTests,
        email: email,
        facebookAppId: facebookAppId,
        onLoginClick: router.pop,
        onRegisterSuccess: onRegisterSuccess,
        onRequireEmail: onRequireEmail,
        onError: onError
      });
    };

    _this.renderLoginByEmail = function () {
      var _this$props3 = _this.props,
          onForgotPassword = _this$props3.onForgotPassword,
          onLoginSuccess = _this$props3.onLoginSuccess,
          abTests = _this$props3.abTests;
      var _this$state2 = _this.state,
          email = _this$state2.email,
          router = _this$state2.router;
      return /*#__PURE__*/React.createElement(SplitLoginPasswordTemplate, {
        email: email,
        onForgotPassword: onForgotPassword,
        onLoginSuccess: onLoginSuccess,
        onSwitchEmail: router.pop,
        abTests: abTests
      });
    };

    var _router = createNewRouter('Login');

    _this.state = {
      router: _router,
      email: ''
    };
    return _this;
  }

  var _proto = SplitLoginStack.prototype;

  _proto.render = function render() {
    var router = this.state.router;
    return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$1i, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(AccessNavigator, {
      router: router,
      routes: [{
        route: 'Login',
        component: this.renderLogin
      }, {
        route: 'Register',
        component: this.renderRegister
      }, {
        route: 'LoginByEmail',
        component: this.renderLoginByEmail
      }]
    })), /*#__PURE__*/React.createElement(FooterWrapper$9, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))));
  };

  return SplitLoginStack;
}(React.Component);
SplitLoginStack.propTypes = {
  abTests: PropTypes__default.string,
  emailStorage: PropTypes__default.bool,
  facebookAppId: PropTypes__default.string,
  onError: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  onLoginSuccess: PropTypes__default.func,
  onRegisterSuccess: PropTypes__default.func,
  onRequireEmail: PropTypes__default.func,
  splitLoginVariant: PropTypes__default.number
};

var _templateObject$2Q, _templateObject2$29, _templateObject3$1B, _templateObject4$13, _templateObject5$K, _templateObject6$s, _templateObject7$k;
var TitleWrapper$7 = styled(View$1)(_templateObject$2Q || (_templateObject$2Q = _taggedTemplateLiteralLoose(["\n  margin-top: 27px;\n  margin-bottom: 24px;\n"])));
var EmailChipWrapper$4 = styled(View$1)(_templateObject2$29 || (_templateObject2$29 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 32px;\n"])));
var SubtitleWrapper$5 = styled(Subtitle)(_templateObject3$1B || (_templateObject3$1B = _taggedTemplateLiteralLoose(["\n  margin-bottom: 24px;\n"])));
var ButtonWrapper$9 = styled(Button$1)(_templateObject4$13 || (_templateObject4$13 = _taggedTemplateLiteralLoose(["\n  flex: none;\n"])));
var Content$1j = styled(View$1)(_templateObject5$K || (_templateObject5$K = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var Description$e = styled(View$1)(_templateObject6$s || (_templateObject6$s = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n"])));
var LinkWrapper$3 = styled(link)(_templateObject7$k || (_templateObject7$k = _taggedTemplateLiteralLoose(["\n  font-size: 16px !important;\n"])));

var AccountTakeoutConfirmationTemplate = function AccountTakeoutConfirmationTemplate(_ref) {
  var onSuccess = _ref.onSuccess,
      email = _ref.email;
  return /*#__PURE__*/React.createElement(Content$1j, null, /*#__PURE__*/React.createElement(DownloadStatusWaitingIcon, null), /*#__PURE__*/React.createElement(TitleWrapper$7, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "title3",
    weight: "semiBold"
  }, "Estamos criando seu arquivo")), /*#__PURE__*/React.createElement(Description$e, null, /*#__PURE__*/React.createElement(SubtitleWrapper$5, null, "A c\xF3pia de seus dados pode levar at\xE9 15 dias para ser conclu\xEDda. Enquanto isso, voc\xEA pode", ' ', /*#__PURE__*/React.createElement(LinkWrapper$3, {
    onClick: onSuccess,
    type: "primary"
  }, "acompanhar o status"), ' ', "do seu pedido."), /*#__PURE__*/React.createElement(Subtitle, null, "Quando tudo estiver pronto, voc\xEA receber\xE1 um link para baixar o arquivo no seu e-mail:")), /*#__PURE__*/React.createElement(EmailChipWrapper$4, null, /*#__PURE__*/React.createElement(EmailChip, {
    size: "body2"
  }, email)), /*#__PURE__*/React.createElement(ButtonWrapper$9, {
    fluid: true,
    size: "large",
    onClick: onSuccess
  }, "Entendi"));
};

AccountTakeoutConfirmationTemplate.propTypes = {
  email: PropTypes__default.string.isRequired,
  onSuccess: PropTypes__default.func.isRequired
};

var _templateObject$2R, _templateObject2$2a;
var ContentWrapper$7 = styled(Paper$1)(_templateObject$2R || (_templateObject$2R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  padding: 32px 56px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.small(_templateObject2$2a || (_templateObject2$2a = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var AccountTakeoutConfirmationPage = function AccountTakeoutConfirmationPage(_ref) {
  var email = _ref.email,
      onSuccess = _ref.onSuccess;
  return /*#__PURE__*/React.createElement(ContentWrapper$7, null, /*#__PURE__*/React.createElement(AccountTakeoutConfirmationTemplate, {
    email: email,
    onSuccess: onSuccess
  }));
};
AccountTakeoutConfirmationPage.propTypes = {
  email: PropTypes__default.string.isRequired,
  onSuccess: PropTypes__default.func.isRequired
};

var Separator$1 = function Separator(_ref) {
  var turns = _ref.turns,
      style = _ref.style;
  return /*#__PURE__*/React.createElement(View$1, {
    style: {
      position: 'absolute',
      height: '100%',
      transform: "rotate(" + turns + "turn)"
    }
  }, /*#__PURE__*/React.createElement(View$1, {
    style: style
  }));
};

var RadialProgressSeparator$1 = function RadialProgressSeparator(_ref2) {
  var count = _ref2.count,
      style = _ref2.style;
  var turns = 1 / count;
  var separators = [];

  for (var i = 1; i <= count; i++) {
    separators.push( /*#__PURE__*/React.createElement(Separator$1, {
      key: i,
      turns: i * turns,
      style: style
    }));
  }

  return separators;
};

var _templateObject$2S;
var Container$6 = styled.div(_templateObject$2S || (_templateObject$2S = _taggedTemplateLiteralLoose(["\n  .CircularProgressbar {\n    width: 100%;\n    vertical-align: middle;\n  }\n\n  .CircularProgressbar .CircularProgressbar-path {\n    stroke: #3e98c7;\n    stroke-linecap: round;\n    transition: stroke-dashoffset 0.5s ease 0s;\n  }\n\n  .CircularProgressbar .CircularProgressbar-trail {\n    stroke: #d6d6d6;\n    stroke-linecap: round;\n  }\n\n  .CircularProgressbar .CircularProgressbar-text {\n    fill: #3e98c7;\n    font-size: 20px;\n    dominant-baseline: middle;\n    text-anchor: middle;\n  }\n\n  .CircularProgressbar .CircularProgressbar-background {\n    fill: #d6d6d6;\n  }\n\n  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-background {\n    fill: #3e98c7;\n  }\n\n  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-text {\n    fill: #fff;\n  }\n\n  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-path {\n    stroke: #fff;\n  }\n\n  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-trail {\n    stroke: transparent;\n  }\n"])));

var CircularIntegerProgress$1 = function CircularIntegerProgress(_ref) {
  var styles = _ref.styles,
      steps = _ref.steps,
      stepsCompleted = _ref.stepsCompleted,
      strokeWidth = _ref.strokeWidth,
      children = _ref.children;
  var completed = stepsCompleted > steps ? steps : stepsCompleted;
  var percentage = Math.round(completed / steps * 100);
  var hasChildren = !!children;
  var text = !hasChildren ? percentage + "%" : '';
  return /*#__PURE__*/React.createElement(Container$6, null, /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    value: percentage,
    text: text,
    strokeWidth: strokeWidth,
    styles: _extends({
      strokeLinecap: 'butt'
    }, styles)
  }, hasChildren && children, /*#__PURE__*/React.createElement(RadialProgressSeparator$1, {
    count: steps,
    style: {
      background: '#fff',
      width: '3px',
      height: strokeWidth + "%"
    }
  })));
};

CircularIntegerProgress$1.propTypes = {
  styles: PropTypes__default.object,
  steps: PropTypes__default.number,
  stepsCompleted: PropTypes__default.number,
  strokeWidth: PropTypes__default.number,
  children: PropTypes__default.element
};

var _templateObject$2T, _templateObject2$2b;
var Content$1k = styled(View$1)(_templateObject$2T || (_templateObject$2T = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  height: 84px;\n  justify-content: space-between;\n  border: 1px solid #e5e5e5;\n  box-sizing: border-box;\n  align-content: center;\n  border-radius: 8px;\n  padding: 16px;\n"])));
var BoxContent$1 = styled(View$1)(_templateObject2$2b || (_templateObject2$2b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding-left: 16px;\n  padding-right: 16px;\n"])));

var BoxShortInfo = function BoxShortInfo(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      icon = _ref.icon,
      extraOptions = _ref.extraOptions;
  return /*#__PURE__*/React.createElement(Content$1k, null, icon, /*#__PURE__*/React.createElement(BoxContent$1, null, /*#__PURE__*/React.createElement(Text$1, {
    size: "body2",
    fontWeight: 600,
    color: "dark"
  }, title), /*#__PURE__*/React.createElement(Text$1, {
    size: "caption",
    color: "grayscale.darker"
  }, subtitle)), extraOptions);
};

BoxShortInfo.propTypes = {
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  icon: PropTypes__default.object,
  extraOptions: PropTypes__default.object
};

var _excluded$g = ["onClick", "title"],
    _excluded2$1 = ["title"];

var _templateObject$2U, _templateObject2$2c, _templateObject3$1C, _templateObject4$14;
var BoxWrapper$2 = styled(View$1)(_templateObject$2U || (_templateObject$2U = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  align-items: flex-start;\n  text-align: left;\n"])));
var CalloutTouchable$1 = styled(link)(_templateObject2$2c || (_templateObject2$2c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  &:hover {\n    background-color: #f6f6f6;\n  }\n"])));
var IconWrapper$8 = styled(View$1)(_templateObject3$1C || (_templateObject3$1C = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-radius: 32px;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n"])), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
});

var Verification = function Verification(_ref2) {
  var verified = _ref2.verified,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      Icon = _ref2.Icon,
      customExtraOptions = _ref2.customExtraOptions;
  return /*#__PURE__*/React.createElement(BoxWrapper$2, null, /*#__PURE__*/React.createElement(BoxShortInfo, {
    title: title,
    subtitle: subtitle,
    icon: /*#__PURE__*/React.createElement(IconWrapper$8, {
      backgroundColor: verified ? '#F1FCF6' : '#F6F6F6'
    }, /*#__PURE__*/React.createElement(Icon, {
      color: verified ? '#8CE563' : '#999999',
      size: "18"
    })),
    extraOptions: customExtraOptions || (verified ? /*#__PURE__*/React.createElement(Icons.System.Check, {
      color: "#8CE563"
    }) : /*#__PURE__*/React.createElement(Icons.System.ChevronRight, {
      color: "#999999"
    }))
  }));
};

Verification.propTypes = {
  title: PropTypes__default.string.isRequired,
  subtitle: PropTypes__default.string.isRequired,
  Icon: PropTypes__default.elementType.isRequired,
  verified: PropTypes__default.bool.isRequired,
  customExtraOptions: PropTypes__default.element
};
var VerificationWrapper = styled(View$1)(_templateObject4$14 || (_templateObject4$14 = _taggedTemplateLiteralLoose(["\n  margin: 8px 0;\n  width: 100%;\n"])));

var ConditionalWrapper = function ConditionalWrapper(_ref3) {
  var condition = _ref3.condition,
      wrapper = _ref3.wrapper,
      children = _ref3.children;
  return condition ? wrapper(children) : children;
};

var VerificationRenderer = function VerificationRenderer(_ref4) {
  var verifications = _ref4.verifications;

  var _verifications$reduce = verifications.reduce(function (acc, item) {
    if (item.verified) {
      acc.verified.push(item);
    } else {
      acc.pending.push(item);
    }

    return acc;
  }, {
    pending: [],
    verified: []
  }),
      pending = _verifications$reduce.pending,
      verified = _verifications$reduce.verified;

  return /*#__PURE__*/React.createElement(React.Fragment, null, pending.map(function (_ref5) {
    var onClick = _ref5.onClick,
        title = _ref5.title,
        verification = _objectWithoutPropertiesLoose(_ref5, _excluded$g);

    return /*#__PURE__*/React.createElement(VerificationWrapper, {
      key: title
    }, /*#__PURE__*/React.createElement(ConditionalWrapper, {
      condition: !verification.disabled,
      wrapper: function wrapper(children) {
        return /*#__PURE__*/React.createElement(CalloutTouchable$1, {
          onClick: onClick
        }, children);
      }
    }, /*#__PURE__*/React.createElement(Verification, _extends({
      title: title
    }, verification))));
  }), verified.map(function (_ref6) {
    var title = _ref6.title,
        verification = _objectWithoutPropertiesLoose(_ref6, _excluded2$1);

    return /*#__PURE__*/React.createElement(VerificationWrapper, {
      key: title
    }, /*#__PURE__*/React.createElement(Verification, _extends({
      title: title
    }, verification)));
  }));
};

VerificationRenderer.propTypes = {
  verifications: PropTypes__default.arrayOf(PropTypes__default.shape({
    title: PropTypes__default.string.isRequired,
    subtitle: PropTypes__default.string.isRequired,
    Icon: PropTypes__default.elementType.isRequired,
    verified: PropTypes__default.bool.isRequired,
    onClick: PropTypes__default.func.isRequired,
    customExtraOptions: PropTypes__default.element
  }))
};

var API_ENDPOINT$g = '/v1/accounts/my/email/send';
var sendVerifyEmailApiCall = (function () {
  return axios.post(API_ENDPOINT$g, {}, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
});

var iconFail = 'M9.71359506,3.58264725 C10.1959664,2.75648501 11.0619105,2.25 12,2.25 C12.9380895,2.25 13.8040336,2.75648501 14.2864049,3.58264725 L22.3990136,17.6526538 C22.8643765,18.4898832 22.8671453,19.5171668 22.4063387,20.3570247 C21.9404483,21.2061484 21.0686569,21.739066 20.1068,21.75 L3.88463673,21.75 C2.93134308,21.739066 2.05955169,21.2061484 1.5936613,20.3570247 C1.13285475,19.5171668 1.13562352,18.4898832 1.60679506,17.6423942 L9.71359506,3.58264725 Z M2.91206578,18.3813999 C2.697188,18.7679842 2.69589534,19.2475938 2.90872192,19.6354878 C3.11646466,20.0141161 3.49482206,20.2454023 3.8932,20.2500489 L20.0982367,20.2500489 C20.5051779,20.2454023 20.8835353,20.0141161 21.0912781,19.6354878 C21.3041047,19.2475938 21.302812,18.7679842 21.0937429,18.3916594 L12.9889955,4.33544999 C12.7752771,3.96942216 12.4001281,3.75 12,3.75 C11.6004402,3.75 11.2257887,3.96879928 11.0119162,4.33389117 L2.91206578,18.3813999 Z M11.25,10 L11.25,14 C11.25,14.4142136 11.5857864,14.75 12,14.75 C12.4142136,14.75 12.75,14.4142136 12.75,14 L12.75,10 C12.75,9.58578644 12.4142136,9.25 12,9.25 C11.5857864,9.25 11.25,9.58578644 11.25,10 Z M12,18 C12.5522847,18 13,17.5522847 13,17 C13,16.4477153 12.5522847,16 12,16 C11.4477153,16 11,16.4477153 11,17 C11,17.5522847 11.4477153,18 12,18 Z';

var ODIN_ENDPOINT = '/v4/me';
var WALLET_ENDPOINT = 'https://wallet-api.olx.com.br/wallet';
var getAccountInfo = function getAccountInfo() {
  return axios.get(ODIN_ENDPOINT);
};
var getWalletInfo = function getWalletInfo() {
  return axios.get(WALLET_ENDPOINT);
};

var _templateObject$2V, _templateObject2$2d, _templateObject3$1D, _templateObject4$15;
var lurker$y = new Lurker('verification_incentive');
var Content$1l = styled(View$1)(_templateObject$2V || (_templateObject$2V = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"])));
var TitleWrapper$8 = styled(View$1)(_templateObject2$2d || (_templateObject2$2d = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n  align-items: center;\n  text-align: center;\n"])));
var BounceLink = styled(Link$3)(_templateObject3$1D || (_templateObject3$1D = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n"])));
var ProgressCircleWrapper$2 = styled(View$1)(_templateObject4$15 || (_templateObject4$15 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 16px;\n  width: 96px;\n  height: 96px;\n"])));

var getStepColor = function getStepColor(steps) {
  if (steps === 4) return '#8CE563';
  if (steps === 3) return '#FFE19A';
  if (steps === 2) return '#FFBB73';
  return '#F48787';
};

var emailSentText = /*#__PURE__*/React.createElement(Text$1, {
  size: "caption",
  color: "grayscale.darker"
}, "Reenviado");

var VerificationIncentiveTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(VerificationIncentiveTemplate, _React$Component);

  function VerificationIncentiveTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onPhoneClick = function (event) {
      var onVerifyPhoneClick = _this.props.onVerifyPhoneClick;
      lurker$y.clickEvt('verify_phone');
      if (event) event.preventDefault();
      onVerifyPhoneClick();
    };

    _this.onEmailClick = function (event) {
      try {
        var verifications = _this.state.verifications;
        lurker$y.clickEvt('verify_email');
        if (event) event.preventDefault();

        var _temp2 = _catch(function () {
          return Promise.resolve(sendVerifyEmailApiCall()).then(function () {
            lurker$y.viewMessageEvt('send_email_success');

            _this.setState({
              toastMessage: 'E-mail de verificação reenviado',
              toastMessageOpen: true,
              toastIcon: '',
              toastColor: undefined,
              verifications: verifications.map(function (verification) {
                if (verification.title === 'Verifique seu e-mail') {
                  return _extends({}, verification, {
                    disabled: true,
                    customExtraOptions: emailSentText
                  });
                }

                return verification;
              })
            });
          });
        }, function (error) {
          var _error$response = error.response,
              _error$response2 = _error$response === void 0 ? {} : _error$response,
              status = _error$response2.status,
              _error$response2$data = _error$response2.data,
              _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
              _error$response2$data3 = _error$response2$data2.message,
              message = _error$response2$data3 === void 0 ? 'unexpected_error' : _error$response2$data3,
              _error$message = error.message,
              exceptionMessage = _error$message === void 0 ? 'unknown' : _error$message;

          lurker$y.viewMessageEvt('send_email_error', {
            accounts_reason: message.toLowerCase(),
            accounts_status_code: status,
            accounts_error_message: exceptionMessage
          });

          _this.setState({
            toastMessage: 'Não foi possível reenviar o e-mail de verificação',
            toastMessageOpen: true,
            toastIcon: iconFail,
            toastColor: '#FF4444'
          });
        });

        return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.onWalletClick = function (event) {
      var onActivateWalletClick = _this.props.onActivateWalletClick;
      lurker$y.clickEvt('activate_wallet');
      if (event) event.preventDefault();
      onActivateWalletClick();
    };

    _this.getAccountVerifications = function () {
      try {
        var _temp5 = function _temp5() {
          return [{
            title: emailVerified ? 'E-mail verificado' : 'Verifique seu e-mail',
            subtitle: 'Receba as comunicações da conta e alertas de segurança.',
            Icon: Icons.System.Mail,
            verified: emailVerified,
            onClick: _this.onEmailClick
          }, {
            title: phoneVerified ? 'Telefone verificado' : 'Verifique seu telefone',
            subtitle: 'Conta segura para anunciar e interagir com outros usuários.',
            Icon: Icons.System.Phone,
            verified: phoneVerified,
            onClick: _this.onPhoneClick
          }];
        };

        var emailVerified = false;
        var phoneVerified = false;

        var _temp6 = _catch(function () {
          return Promise.resolve(getAccountInfo()).then(function (_ref) {
            var data = _ref.data;
            emailVerified = data.emailVerified;
            phoneVerified = data.phoneVerified;
          });
        }, function () {});

        return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(_temp5) : _temp5(_temp6));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.getWalletVerifications = function () {
      try {
        var _temp9 = function _temp9() {
          return [{
            title: hasWallet ? 'OLX Pay ativada' : 'Ative a OLX Pay',
            subtitle: 'Compre e venda com mais segurança e praticidade.',
            Icon: Icons.System.Wallet,
            verified: hasWallet,
            onClick: _this.onWalletClick
          }];
        };

        var hasWallet = false;

        var _temp10 = _catch(function () {
          return Promise.resolve(getWalletInfo()).then(function (_ref2) {
            var status = _ref2.data.status;
            hasWallet = status === 'ACTIVE';
          });
        }, function () {});

        return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(_temp9) : _temp9(_temp10));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.bounceClick = function (event) {
      var onBounceClick = _this.props.onBounceClick;
      lurker$y.clickEvt('bounce');
      if (event) event.preventDefault();
      onBounceClick();
    };

    _this.state = {
      verifications: [],
      toastMessage: '',
      toastMessageOpen: false,
      toastIcon: '',
      toastColor: ''
    };
    return _this;
  }

  var _proto = VerificationIncentiveTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$y.pageLoadEvt();
    this.fetchData();
  };

  _proto.fetchData = function fetchData() {
    try {
      var _this3 = this;

      var onVerificationCompleted = _this3.props.onVerificationCompleted;
      return Promise.resolve(_this3.getWalletVerifications()).then(function (walletVerification) {
        return Promise.resolve(_this3.getAccountVerifications()).then(function (accountVerifications) {
          var verifications = [].concat(accountVerifications, walletVerification);

          _this3.setState({
            verifications: verifications
          }, function () {
            onVerificationCompleted(verifications.every(function (_ref3) {
              var verified = _ref3.verified;
              return verified;
            }));
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$state = this.state,
        verifications = _this$state.verifications,
        toastMessage = _this$state.toastMessage,
        toastMessageOpen = _this$state.toastMessageOpen,
        toastIcon = _this$state.toastIcon,
        toastColor = _this$state.toastColor;
    var steps = (verifications.length || 3) + 1;
    var stepsCompleted = verifications.filter(function (_ref4) {
      var verified = _ref4.verified;
      return verified;
    }).length + 1 || 0;
    var stepColor = getStepColor(stepsCompleted);
    return /*#__PURE__*/React.createElement(Content$1l, null, /*#__PURE__*/React.createElement(ProgressCircleWrapper$2, null, /*#__PURE__*/React.createElement(CircularIntegerProgress$1, {
      strokeWidth: 6,
      steps: steps,
      stepsCompleted: stepsCompleted,
      styles: {
        path: {
          strokeLinecap: 'butt',
          stroke: stepColor
        },
        text: {
          fontFamily: 'Nunito Sans',
          fill: '#999',
          fontSize: 18,
          fontWeight: 600,
          lineHeight: 16,
          textAlign: 'center'
        }
      }
    }, /*#__PURE__*/React.createElement(Icons.System.Award, {
      color: stepColor,
      size: "24"
    }))), /*#__PURE__*/React.createElement(TitleWrapper$8, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title3",
      weight: "semiBold"
    }, "Vamos aumentar o n\xEDvel de seguran\xE7a da sua conta?")), /*#__PURE__*/React.createElement(VerificationRenderer, {
      verifications: verifications
    }), /*#__PURE__*/React.createElement(BounceLink, {
      onClick: this.bounceClick,
      fontWeight: 600,
      type: "primary",
      underline: false
    }, "Fazer isso depois"), /*#__PURE__*/React.createElement(ToastMessage, {
      text: toastMessage,
      show: toastMessageOpen,
      iconPath: toastIcon,
      iconColor: toastColor,
      onClose: function onClose() {
        return _this4.setState({
          toastMessageOpen: false
        });
      }
    }));
  };

  return VerificationIncentiveTemplate;
}(React.Component);

VerificationIncentiveTemplate.propTypes = {
  onActivateWalletClick: PropTypes__default.func.isRequired,
  onBounceClick: PropTypes__default.func.isRequired,
  onVerificationCompleted: PropTypes__default.func.isRequired,
  onVerifyPhoneClick: PropTypes__default.func.isRequired
};

var _templateObject$2W, _templateObject2$2e;
var Content$1m = styled(View$1)(_templateObject$2W || (_templateObject$2W = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.medium(_templateObject2$2e || (_templateObject2$2e = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var VerificationIncentivePage = function VerificationIncentivePage(_ref) {
  var onBounceClick = _ref.onBounceClick,
      onVerifyPhoneClick = _ref.onVerifyPhoneClick,
      onActivateWalletClick = _ref.onActivateWalletClick,
      onVerificationCompleted = _ref.onVerificationCompleted;
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$1m, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(VerificationIncentiveTemplate, {
    onActivateWalletClick: onActivateWalletClick,
    onBounceClick: onBounceClick,
    onVerificationCompleted: onVerificationCompleted,
    onVerifyPhoneClick: onVerifyPhoneClick
  }))));
};
VerificationIncentivePage.propTypes = {
  onActivateWalletClick: PropTypes__default.func.isRequired,
  onBounceClick: PropTypes__default.func.isRequired,
  onVerificationCompleted: PropTypes__default.func.isRequired,
  onVerifyPhoneClick: PropTypes__default.func.isRequired
};

var rngBrowser = createCommonjsModule(function (module) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}
});

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

var bytesToUuid_1 = bytesToUuid;

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rngBrowser();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid_1(b);
}

var v1_1 = v1;

function v4$1(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rngBrowser)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid_1(rnds);
}

var v4_1 = v4$1;

var uuid = v4_1;
uuid.v1 = v1_1;
uuid.v4 = v4_1;

var uuid_1 = uuid;

var _templateObject$2X, _templateObject2$2f, _templateObject3$1E, _templateObject4$16, _templateObject5$L;
var Content$1n = styled(View$1)(_templateObject$2X || (_templateObject$2X = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"])));
var LabelText = styled(Text$1)(_templateObject2$2f || (_templateObject2$2f = _taggedTemplateLiteralLoose(["\n  margin-left: 16px;\n  font-size: 16px;\n  font-weight: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n"])), function (props) {
  return props.fontWeight;
}, function (props) {
  return props.disabled ? '#999999' : 'inherit';
});

var basicRadio$1 = function basicRadio(props) {
  return /*#__PURE__*/React.createElement("input", {
    id: props.id,
    className: props.className,
    value: props.value,
    name: props.name,
    checked: props.checked,
    onChange: props.onChange,
    disabled: props.disabled,
    type: "radio"
  });
};

var Input$2 = styled(basicRadio$1)(_templateObject3$1E || (_templateObject3$1E = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n"])));
var InputWrapper$3 = styled.label(_templateObject4$16 || (_templateObject4$16 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  cursor: ", ";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 20px;\n  height: 20px;\n"])), function (props) {
  return props.disabled ? 'initial' : 'pointer';
});
var Checkmark$1 = styled.span(_templateObject5$L || (_templateObject5$L = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  box-sizing: content-box;\n  border-radius: 50%;\n  border-color: ", ";\n  border-width: 2px;\n  border-style: solid;\n  opacity: ", ";\n  background-color: ", ";\n\n  &:after {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #6e0ad6;\n    content: '';\n    display: ", ";\n  }\n"])), function (props) {
  return props.checked ? '#6E0AD6' : '#999999';
}, function (props) {
  return props.disabled ? 0.3 : 1;
}, function (props) {
  return props.disabled && !props.checked ? '#d2d2d2' : '#ffffff';
}, function (props) {
  return props.checked ? 'block' : 'none';
});

var RadioInput = function RadioInput(props) {
  var elementId = uuid_1();
  return /*#__PURE__*/React.createElement(Content$1n, null, /*#__PURE__*/React.createElement(InputWrapper$3, {
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement(Input$2, {
    id: elementId,
    value: props.value,
    name: props.name,
    checked: props.checked,
    onChange: props.onChange,
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement(Checkmark$1, {
    checked: props.checked,
    disabled: props.disabled
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: elementId
  }, /*#__PURE__*/React.createElement(LabelText, {
    disabled: props.disabled,
    fontWeight: props.fontWeight
  }, props.label)));
};

RadioInput.defaultProps = {
  fontWeight: 600
};
RadioInput.propTypes = {
  disabled: PropTypes__default.bool,
  checked: PropTypes__default.bool,
  label: PropTypes__default.string,
  fontWeight: PropTypes__default.number,
  name: PropTypes__default.string,
  value: PropTypes__default.string,
  onChange: PropTypes__default.func
};

var nullifierUrl$1 = process.env.REACT_APP_NULLIFIER_URL || 'https://nullifier.olx.com.br';
var VALIDATE_ENDPOINT = nullifierUrl$1 + "/deactivation/validate";
var START_ENDPOINT = nullifierUrl$1 + "/deactivation/start";
var CONFIRM_ENDPOINT = nullifierUrl$1 + "/deactivation/confirm";
var validate = function validate(email, recaptchaToken) {
  return axios.post(VALIDATE_ENDPOINT, {
    email: email.toLowerCase().trim()
  }, {
    headers: {
      'X-Accounts-Deactivation-Recaptcha': recaptchaToken
    },
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};
var start = function start(email, reason, comments, recaptchaToken) {
  if (comments === void 0) {
    comments = '';
  }

  return axios.post(START_ENDPOINT, {
    email: email.toLowerCase().trim(),
    reason: reason,
    comments: comments
  }, {
    headers: {
      'X-Accounts-Deactivation-Recaptcha': recaptchaToken
    },
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};
var confirm = function confirm(token) {
  return axios.post(CONFIRM_ENDPOINT, {
    token: token
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};

var _templateObject$2Y, _templateObject2$2g, _templateObject3$1F, _templateObject4$17, _templateObject5$M, _templateObject6$t, _templateObject7$l, _templateObject8$c, _templateObject9$7, _templateObject10$7, _templateObject11$3, _templateObject12$3, _templateObject13$2, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject17$1, _templateObject18$1;
var lurker$z = new Lurker();
var Content$1o = styled(View$1)(_templateObject$2Y || (_templateObject$2Y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: 768px;\n  padding: 16px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$2g || (_templateObject2$2g = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    padding: 0;\n  "]))));
var ContentWrapper$8 = styled(View$1)(_templateObject3$1F || (_templateObject3$1F = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: start;\n  padding: 48px;\n  ", "\n"])), mediaQuery.small(_templateObject4$17 || (_templateObject4$17 = _taggedTemplateLiteralLoose(["\n    padding: 32px 32px 32px 0px;\n  "]))));
var VerticalContent = styled(View$1)(_templateObject5$M || (_templateObject5$M = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 64px;\n  ", "\n"])), mediaQuery.small(_templateObject6$t || (_templateObject6$t = _taggedTemplateLiteralLoose(["\n    margin-left: 24px;\n    padding: 0;\n  "]))));
var TitleRow$1 = styled.div(_templateObject7$l || (_templateObject7$l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 8px;\n"])));
var TitleWrapper$9 = styled(Text$1)(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteralLoose(["\n  font-size: 24px;\n  display: flex;\n  margin-top: 0;\n  margin-bottom: 16px;\n  align-items: start;\n  ", "\n"])), mediaQuery.small(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteralLoose(["\n    font-size: 20px;\n  "]))));
var SubtitleRow = styled.div(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-top: 16px;\n"])));
var RecaptchaWrapper$2 = styled(View$1)(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-bottom: 16px;\n"])));
var RadioInputWrapper = styled(View$1)(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 200px;\n  justify-content: space-between;\n"])));
var CommentView = styled(View$1)(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));
var InputTextarea = styled(Input$1)(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteralLoose(["\n  padding-right: 16px;\n"])));
var ErrorMsgView = styled(View$1)(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 90%;\n"])));
var FormItemWrapper = styled(View$1)(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 32px;\n"])));
var ButtonWrapper$a = styled(View$1)(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteralLoose(["\n  width: 220px;\n"])));
var HorizontalLine = styled(View$1)(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteralLoose(["\n  border-top: 1px solid #d2d2d2;\n  margin: 24px 0 12px 0;\n"])));
var defaultEmailErrorMsg$4 = 'Por favor, insira um endereço de e-mail válido.';
var recaptchaSiteKey$3 = '6LfPClEUAAAAAD_O4ppsMM0r5EX5pcV5PH12rBIn';

var getEmailErrorMessage = function getEmailErrorMessage(email) {
  if (!email.valid && !email.pristine) {
    return defaultEmailErrorMsg$4;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, "Para inativar esta conta,", ' ', /*#__PURE__*/React.createElement(link, {
    fontAdjust: "font-size: 12px !important",
    type: "primary",
    href: faleConosco$1
  }, "fale com a gente."));
};

var errors$9 = {
  showGenericError: false
};

var AccountDeactivationTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(AccountDeactivationTemplate, _BaseForm);

  function AccountDeactivationTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.onEmailChange = function (event) {
      _this.onFieldChange(event, 'email', isValidEmail, defaultEmailErrorMsg$4, true);
    };

    _this.onEmailBlur = function (event) {
      _this.onFieldChange(event, 'email', isValidEmail, defaultEmailErrorMsg$4, false);
    };

    _this.onReasonChange = function (event) {
      _this.onFieldChange(event, 'reason');
    };

    _this.onCommentChange = function (event) {
      _this.onFieldChange(event, 'comments');
    };

    _this.showError = function (error, extra) {
      var _extends2;

      return _this.setState(_extends({}, errors$9, extra, (_extends2 = {}, _extends2[error] = true, _extends2)));
    };

    _this.onRecaptchaLoad = function () {
      return _this.setState({
        recaptchaReady: true
      });
    };

    _this.onRecaptchaError = function (e) {
      lurker$z.viewMessageEvt('error', {
        accounts_reason: 'recaptcha_error',
        accounts_error_message: e && e.message || 'unknown'
      });
    };

    _this.onRecaptchaExpiration = function () {
      return _this.updateField('recaptchaToken', '', false);
    };

    _this.onRecaptchaVerify = function (recaptchaToken) {
      if (recaptchaToken) {
        _this.updateField('recaptchaToken', recaptchaToken, true);
      } else {
        _this.setState({
          submitting: false
        });

        _this.recaptcha.reset();

        lurker$z.viewMessageEvt('error', {
          accounts_reason: 'recaptcha_failed_token'
        });

        _this.showError('showGenericError');
      }
    };

    _this.onSuccess = function () {
      _this.setState({
        isSubmitting: false,
        emailSent: true
      });

      if (_this.props.onSuccess) {
        _this.props.onSuccess();
      }
    };

    _this.onApiCallError = function (error) {
      if (error === void 0) {
        error = {};
      }

      _this.setState({
        isSubmitting: false
      });

      if (_this.props.onError) {
        _this.props.onError();
      }

      var _error = error,
          _error$response = _error.response,
          response = _error$response === void 0 ? {} : _error$response;

      if (response.status === 401) {
        lurker$z.viewMessageEvt('error', {
          accounts_reason: 'unauthorized',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status === 429) {
        lurker$z.viewMessageEvt('error', {
          accounts_reason: 'rate_limit_exceeded',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status === 403) {
        lurker$z.viewMessageEvt('error', {
          accounts_reason: 'recaptcha_invalid_token',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status === 409) {
        lurker$z.viewMessageEvt('error', {
          accounts_reason: 'conflict_error',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status === 400 && response.data && response.data === 'Missing recaptcha response token') {
        lurker$z.viewMessageEvt('error', {
          accounts_reason: 'recaptcha_missing_token',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status) {
        lurker$z.viewMessageEvt('error', {
          accounts_reason: 'unexpected_status_code',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else {
        lurker$z.viewMessageEvt('error', {
          accounts_reason: 'unexpected_error',
          accounts_error_message: error && error.message || 'unknown'
        });

        _this.showError('showGenericError');
      }

      behaviors.scrollToTop();
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      lurker$z.clickEvt('submit');

      _this.checkSomeFieldsIsValid(['email', 'reason', 'recaptchaToken']).then(function () {
        return _this.setState(_extends({}, errors$9, {
          isSubmitting: true
        }), _this.validateInactivation);
      })["catch"](function () {
        return _this.setState({
          isSubmitting: false
        });
      })["finally"](behaviors.scrollToTop);
    };

    _this.validateInactivation = function () {
      var _this$state$fields = _this.state.fields,
          email = _this$state$fields.email,
          recaptchaToken = _this$state$fields.recaptchaToken;
      validate(email.value, recaptchaToken.value).then(_this.startInactivation)["catch"](function (e) {
        return _this.onApiCallError(e);
      });
    };

    _this.startInactivation = function () {
      var _this$state$fields2 = _this.state.fields,
          email = _this$state$fields2.email,
          reason = _this$state$fields2.reason,
          comments = _this$state$fields2.comments,
          recaptchaToken = _this$state$fields2.recaptchaToken;
      start(email.value, reason.value, comments.value, recaptchaToken.value).then(_this.onSuccess)["catch"](function (e) {
        return _this.onApiCallError(e);
      });
    };

    _this.state = _extends({}, errors$9, {
      submitting: false,
      recaptchaReady: false,
      emailSent: false,
      validators: {
        email: {
          action: isValidEmail,
          message: defaultEmailErrorMsg$4
        },
        reason: {
          action: function action(value) {
            return !!value;
          },
          message: 'Por favor, selecione uma opção.'
        },
        recaptchaToken: {
          action: function action(value) {
            return !!value;
          },
          message: 'Captcha não preenchido.'
        }
      },
      fields: {
        email: {
          value: '',
          pristine: true,
          valid: false
        },
        reason: {
          value: '',
          pristine: true,
          valid: false
        },
        comments: {
          value: '',
          pristine: true,
          valid: true
        },
        recaptchaToken: {
          value: '',
          pristine: true,
          valid: false
        }
      }
    });
    return _this;
  }

  var _proto = AccountDeactivationTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$z.pageLoadEvt('account_deactivation');
  };

  _proto.renderRecaptcha = function renderRecaptcha() {
    var _this2 = this;

    var recaptchaToken = this.state.fields.recaptchaToken;
    var captchaHasError = !recaptchaToken.valid && !recaptchaToken.pristine;
    return /*#__PURE__*/React.createElement(RecaptchaWrapper$2, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Reaptcha, {
      ref: function ref(e) {
        _this2.recaptcha = e;
      },
      sitekey: recaptchaSiteKey$3,
      onLoad: this.onRecaptchaLoad,
      onVerify: this.onRecaptchaVerify,
      onError: this.onRecaptchaError,
      onExpire: this.onRecaptchaExpiration
    }), captchaHasError && /*#__PURE__*/React.createElement(ErrorMsgView, null, /*#__PURE__*/React.createElement(errorMsg, null, "Captcha n\xE3o preenchido."))));
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state = this.state,
        _this$state$fields3 = _this$state.fields,
        email = _this$state$fields3.email,
        reason = _this$state$fields3.reason,
        comments = _this$state$fields3.comments,
        isSubmitting = _this$state.isSubmitting,
        showGenericError = _this$state.showGenericError,
        emailSent = _this$state.emailSent;
    var emailHasError = !email.valid && !email.pristine || showGenericError;

    if (emailSent) {
      return /*#__PURE__*/React.createElement(ContentWrapper$8, null, /*#__PURE__*/React.createElement(MailCheck, {
        config: {
          width: '53',
          height: '38'
        }
      }), /*#__PURE__*/React.createElement(VerticalContent, null, /*#__PURE__*/React.createElement(TitleWrapper$9, null, "Confirme a desativa\xE7\xE3o"), /*#__PURE__*/React.createElement(Text$1, {
        size: "body1"
      }, "Enviamos para o email ", /*#__PURE__*/React.createElement(Text$1, {
        weight: "bold"
      }, email.value), " um link para a confirma\xE7\xE3o. Acesse o seu e-mail para completar a desativa\xE7\xE3o da sua conta.")));
    }

    return /*#__PURE__*/React.createElement(Content$1o, null, /*#__PURE__*/React.createElement(TitleRow$1, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title1"
    }, "Desativa\xE7\xE3o de conta")), /*#__PURE__*/React.createElement(SubtitleRow, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title4"
    }, "Ao desativar a sua conta, seu perfil ser\xE1 desabilitado e an\xFAncios exclu\xEDdos."), /*#__PURE__*/React.createElement(Text$1, {
      size: "title4",
      color: "grayscale.darker"
    }, "Os campos marcados com asterisco (*) s\xE3o obrigat\xF3rios.")), /*#__PURE__*/React.createElement(HorizontalLine, null), /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(FormItemWrapper, null, /*#__PURE__*/React.createElement(formItem, {
      label: "E-mail cadastrado na OLX",
      tip: "*",
      hasError: emailHasError,
      error: getEmailErrorMessage(email)
    }, /*#__PURE__*/React.createElement(Input$1, {
      onBlur: this.onEmailBlur,
      onChange: this.onEmailChange,
      returnKeyType: "next",
      blurOnSubmit: false,
      maxLength: 200,
      placeholder: "E-mail"
    }))), /*#__PURE__*/React.createElement(FormItemWrapper, null, /*#__PURE__*/React.createElement(formItem, {
      label: "Qual \xE9 o motivo da desativa\xE7\xE3o?",
      tip: "*",
      hasError: !reason.valid && reason.value,
      error: reason.msg
    }, /*#__PURE__*/React.createElement(RadioInputWrapper, null, /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "J\xE1 vendi meu produto",
      name: "reason",
      value: "already_sold_product",
      checked: reason.value === 'already_sold_product',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "N\xE3o tenho retorno nos meus an\xFAncios",
      name: "reason",
      value: "without_olx_returning",
      checked: reason.value === 'without_olx_returning',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "N\xE3o quero mais usar a OLX",
      name: "reason",
      value: "do_not_want_olx",
      checked: reason.value === 'do_not_want_olx',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "N\xE3o tenho cadastro na OLX",
      name: "reason",
      value: "do_not_have_olx_account",
      checked: reason.value === 'do_not_have_olx_account',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "Motivos pessoais",
      name: "reason",
      value: "personal_reasons",
      checked: reason.value === 'personal_reasons',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "N\xE3o sinto seguran\xE7a na OLX",
      name: "reason",
      value: "do_not_feel_safe_in_olx",
      checked: reason.value === 'do_not_feel_safe_in_olx',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "Outro motivo",
      name: "reason",
      value: "other_reasons",
      checked: reason.value === 'other_reasons',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    })))), /*#__PURE__*/React.createElement(FormItemWrapper, null, /*#__PURE__*/React.createElement(formItem, {
      label: "Coment\xE1rios"
    }, /*#__PURE__*/React.createElement(CommentView, null, /*#__PURE__*/React.createElement(InputTextarea, {
      multiline: true,
      rows: 6,
      placeholder: "Escreva aqui...",
      onChange: this.onCommentChange,
      disabled: isSubmitting,
      returnKeyType: "done",
      maxLength: 200,
      onSubmitEditing: function onSubmitEditing() {
        return _this3.updateFocus('comments');
      },
      value: comments.value,
      inputRef: function inputRef(x) {
        _this3.inputs.comments = x;
      }
    })))), this.renderRecaptcha(), /*#__PURE__*/React.createElement(ButtonWrapper$a, null, /*#__PURE__*/React.createElement(Button$1, {
      onClick: this.handleSubmit,
      disabled: Object.keys(this.getInvalidFields()).length > 0 || isSubmitting,
      isLoading: isSubmitting,
      size: "large",
      fluid: true
    }, "Continuar"))));
  };

  return AccountDeactivationTemplate;
}(BaseForm);

AccountDeactivationTemplate.propTypes = {
  onSuccess: PropTypes__default.func
};

var _templateObject$2Z, _templateObject2$2h;
var Content$1p = styled(Paper$1)(_templateObject$2Z || (_templateObject$2Z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin: 64px auto;\n  max-width: 768px;\n  padding: 16px;\n  ", "\n"])), mediaQuery.small(_templateObject2$2h || (_templateObject2$2h = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var AccountDeactivationPage = function AccountDeactivationPage(_ref) {
  var onSuccess = _ref.onSuccess;
  return /*#__PURE__*/React.createElement(Content$1p, null, /*#__PURE__*/React.createElement(AccountDeactivationTemplate, {
    onSuccess: onSuccess
  }));
};
AccountDeactivationPage.propTypes = {
  onSuccess: PropTypes__default.func
};

var _templateObject$2_, _templateObject2$2i, _templateObject3$1G, _templateObject4$18, _templateObject5$N, _templateObject6$u;
var lurker$A = new Lurker('account_deactivation_confirmation');
var ContentWrapper$9 = styled(View$1)(_templateObject$2_ || (_templateObject$2_ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  min-height: 128px;\n"])));
var Content$1q = styled(View$1)(_templateObject2$2i || (_templateObject2$2i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 64px;\n"])));
var TitleWrapper$a = styled(View$1)(_templateObject3$1G || (_templateObject3$1G = _taggedTemplateLiteralLoose(["\n  margin-top: 0;\n  margin-bottom: 16px;\n"])));
var SymbolWrapper$1 = styled(View$1)(_templateObject4$18 || (_templateObject4$18 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n"])));
var SubtitleWrapper$6 = styled(View$1)(_templateObject5$N || (_templateObject5$N = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var LinkWrapper$4 = styled(link)(_templateObject6$u || (_templateObject6$u = _taggedTemplateLiteralLoose(["\n  font-size: 16px !important;\n  font-weight: 400;\n"])));

var AccountDeactivationConfirmationTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountDeactivationConfirmationTemplate, _React$Component);

  function AccountDeactivationConfirmationTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.confirmInactivation = function () {
      _this.setState({
        status: 'loading'
      });

      var token = _this.props.token;
      confirm(token).then(function () {
        lurker$A.viewMessageEvt('success');

        _this.setState({
          status: 'success'
        });
      })["catch"](function (error) {
        if (error === void 0) {
          error = {};
        }

        var _error = error,
            _error$response = _error.response,
            _error$response2 = _error$response === void 0 ? {} : _error$response,
            status = _error$response2.status;

        if (status === 410) {
          lurker$A.viewMessageEvt('error', {
            accounts_reason: 'invalid_token',
            accounts_status_code: status
          });

          _this.setState({
            status: 'invalid_token'
          });
        } else if (status) {
          lurker$A.viewMessageEvt('error', {
            accounts_reason: 'unexpected_status_code',
            accounts_status_code: status
          });

          _this.setState({
            status: 'error'
          });
        } else {
          lurker$A.viewMessageEvt('error', {
            accounts_reason: 'unexpected_error',
            accounts_error_message: error && error.message || 'unknown'
          });

          _this.setState({
            status: 'error'
          });
        }
      });
    };

    _this.state = {
      status: 'loading'
    };
    return _this;
  }

  var _proto = AccountDeactivationConfirmationTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$A.pageLoadEvt();
    this.confirmInactivation();
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === 'loading') {
      return /*#__PURE__*/React.createElement(LoadingBackdrop$1, null);
    }

    if (status === 'success') {
      return /*#__PURE__*/React.createElement(ContentWrapper$9, null, /*#__PURE__*/React.createElement(SymbolWrapper$1, null, /*#__PURE__*/React.createElement(checkCircleSymbol, {
        width: 64,
        height: 64
      })), /*#__PURE__*/React.createElement(Content$1q, null, /*#__PURE__*/React.createElement(TitleWrapper$a, null, /*#__PURE__*/React.createElement(Text$1, {
        size: "title2",
        weight: "bold"
      }, "Em breve sua conta ser\xE1 desativada")), /*#__PURE__*/React.createElement(Text$1, null, "Obrigado por usar a OLX. Esperamos v\xEA-lo em breve!"), /*#__PURE__*/React.createElement(Text$1, null, "- Time OLX")));
    }

    return /*#__PURE__*/React.createElement(ContentWrapper$9, null, /*#__PURE__*/React.createElement(SymbolWrapper$1, null, /*#__PURE__*/React.createElement(AlertSymbol, {
      width: 64,
      height: 64
    })), /*#__PURE__*/React.createElement(Content$1q, null, /*#__PURE__*/React.createElement(TitleWrapper$a, null, /*#__PURE__*/React.createElement(Text$1, {
      size: "title2",
      weight: "bold"
    }, "Link expirado")), /*#__PURE__*/React.createElement(SubtitleWrapper$6, null, /*#__PURE__*/React.createElement(Subtitle, null, "O link para inativa\xE7\xE3o de conta n\xE3o \xE9 v\xE1lido ou j\xE1 foi usado.")), /*#__PURE__*/React.createElement(SubtitleWrapper$6, null, /*#__PURE__*/React.createElement(Text$1, {
      color: "grayscale.darker"
    }, "Precisa da", ' ', /*#__PURE__*/React.createElement(LinkWrapper$4, {
      type: "primary",
      href: ajuda
    }, "nossa ajuda"), "? Ou ainda gostaria de", ' ', /*#__PURE__*/React.createElement(LinkWrapper$4, {
      type: "primary",
      href: deactivateAccount$1
    }, "inativar sua conta?")))));
  };

  return AccountDeactivationConfirmationTemplate;
}(React.Component);

AccountDeactivationConfirmationTemplate.propTypes = {
  token: PropTypes__default.string
};

var _templateObject$2$, _templateObject2$2j;
var Content$1r = styled(Paper$1)(_templateObject$2$ || (_templateObject$2$ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin: 64px auto;\n  max-width: 768px;\n  ", "\n"])), mediaQuery.small(_templateObject2$2j || (_templateObject2$2j = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var AccountDeactivationConfirmationPage = function AccountDeactivationConfirmationPage(_ref) {
  var token = _ref.token;
  return /*#__PURE__*/React.createElement(Content$1r, null, /*#__PURE__*/React.createElement(AccountDeactivationConfirmationTemplate, {
    token: token
  }));
};
AccountDeactivationConfirmationPage.propTypes = {
  token: PropTypes__default.string
};

var _templateObject$30, _templateObject2$2k, _templateObject3$1H, _templateObject4$19;
var Content$1s = styled(View$1)(_templateObject$30 || (_templateObject$30 = _taggedTemplateLiteralLoose(["\n  background: #6e0ad6;\n"])));
var HeaderWrapper$2 = styled(View$1)(_templateObject2$2k || (_templateObject2$2k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 55px;\n  padding-right: 15px;\n  padding-left: 18px;\n"])));
var HeaderText = styled(Text$1)(_templateObject3$1H || (_templateObject3$1H = _taggedTemplateLiteralLoose(["\n  line-height: 22px;\n  color: #fff;\n  font-weight: 100;\n  width: 100%;\n  max-width: 1095px;\n  margin: auto;\n"])));
var WhiteSpace = styled(View$1)(_templateObject4$19 || (_templateObject4$19 = _taggedTemplateLiteralLoose(["\n  background: #fff;\n  height: 10px;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n"])));

var HeaderBar = function HeaderBar(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(Content$1s, null, /*#__PURE__*/React.createElement(HeaderWrapper$2, null, /*#__PURE__*/React.createElement(HeaderText, null, text)), /*#__PURE__*/React.createElement(WhiteSpace, null));
};

HeaderBar.propTypes = {
  text: PropTypes__default.string
};

var nullifierUrl$2 = process.env.REACT_APP_NULLIFIER_URL || 'https://nullifier.olx.com.br';
var VALIDATE_ENDPOINT$1 = nullifierUrl$2 + "/deletion/validate";
var VALIDATE_NOCAPTCHA_ENDPOINT = nullifierUrl$2 + "/nocaptcha/deletion/validate";
var START_ENDPOINT$1 = nullifierUrl$2 + "/deletion/start";
var validateEmailBeforeProccess = function validateEmailBeforeProccess(email, recaptchaToken) {
  return axios.post(VALIDATE_ENDPOINT$1, {
    email: email.toLowerCase().trim()
  }, {
    headers: {
      'X-Accounts-Delete-Recaptcha': recaptchaToken
    },
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};
var validateEmailBeforeProccessNoCaptcha = function validateEmailBeforeProccessNoCaptcha(email) {
  return axios.post(VALIDATE_NOCAPTCHA_ENDPOINT, {
    email: email.toLowerCase().trim()
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};
var startDeletionProccess = function startDeletionProccess(email, reason, comments) {
  return axios.post(START_ENDPOINT$1, {
    email: email.toLowerCase().trim(),
    reason: reason,
    comments: comments
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};

var _templateObject$31, _templateObject2$2l, _templateObject3$1I, _templateObject4$1a, _templateObject5$O, _templateObject6$v, _templateObject7$m, _templateObject8$d, _templateObject9$8, _templateObject10$8, _templateObject11$4, _templateObject12$4, _templateObject13$3, _templateObject14$2, _templateObject15$2, _templateObject16$2, _templateObject17$2, _templateObject18$2, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28;
var lurker$B = new Lurker();
var ContentPage = styled(View$1)(_templateObject$31 || (_templateObject$31 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  max-width: 338px;\n  padding-top: 32px;\n  padding-bottom: 32px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$2l || (_templateObject2$2l = _taggedTemplateLiteralLoose(["\n    padding-top: 24px;\n    padding-bottom: 24px;\n  "]))));
var TitlePage = styled(Title)(_templateObject3$1I || (_templateObject3$1I = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 24px;\n  line-height: 32px;\n"])));
var PageForm$9 = styled(Form)(_templateObject4$1a || (_templateObject4$1a = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n"])));
var TitleStart = styled(View$1)(_templateObject5$O || (_templateObject5$O = _taggedTemplateLiteralLoose(["\n  margin-bottom: 24px;\n"])));
var MailCheckFormItemWrapper = styled(View$1)(_templateObject6$v || (_templateObject6$v = _taggedTemplateLiteralLoose(["\n  margin-bottom: 32px;\n  ", "\n"])), mediaQuery.medium(_templateObject7$m || (_templateObject7$m = _taggedTemplateLiteralLoose(["\n    margin-bottom: 16px;\n  "]))));
var ErrorMsgStartView = styled(View$1)(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteralLoose(["\n  margin-bottom: 24px;\n"])));
var RecaptchaWrapper$3 = styled(View$1)(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin-top: 24px;\n  margin-bottom: 56px;\n  flex-direction: column;\n"])));
var TitleReason = styled(View$1)(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var ErrorMsgWrapper$e = styled(View$1)(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var RadioInputWrapper$1 = styled(View$1)(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  height: 264px;\n  justify-content: space-between;\n"])));
var CommentWrapper = styled(View$1)(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  margin-top: 24px;\n  margin-bottom: 24px;\n"])));
var CommentView$1 = styled(View$1)(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  width: 100%;\n"])));
var InputTextarea$1 = styled(Input$1)(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteralLoose(["\n  padding-right: 16px;\n"])));
var ErrorMsgView$1 = styled(View$1)(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 90%;\n"])));
var ContentSuccess = styled(ContentPage)(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var SuccessTitle = styled(View$1)(_templateObject18$2 || (_templateObject18$2 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  margin-bottom: 13px;\n  ", "\n"])), mediaQuery.medium(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n    margin-bottom: 8px;\n  "]))));
var Description$f = styled(Text$1)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 39px;\n  margin-bottom: 18px;\n  font-size: 16px;\n  ", "\n"])), mediaQuery.medium(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n    margin-top: 31px;\n    margin-bottom: 8px;\n  "]))));
var LabelBoxView$2 = styled(View$1)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding-left: 34px;\n  padding-right: 34px;\n"])));
var SuportView = styled(View$1)(_templateObject23 || (_templateObject23 = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  text-align: center;\n  line-height: 20px;\n  ", "\n"])), mediaQuery.medium(_templateObject24 || (_templateObject24 = _taggedTemplateLiteralLoose(["\n    margin-top: 16px;\n  "]))));
var SuportText = styled(Text$1)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-left: 3.5px;\n  margin-right: 3.5px;\n  font-size: 14px;\n  color: #999999;\n  font-weight: 600;\n"])));
var SuportTextBold = styled(Text$1)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  color: #999999;\n  font-weight: 900;\n"])));
var Center = styled(View$1)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n"])));
var RemindText = styled(Text$1)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var defaultEmailErrorMsg$5 = 'Por favor, insira um endereço de e-mail válido.';
var recaptchaSiteKey$4 = '6LfPClEUAAAAAD_O4ppsMM0r5EX5pcV5PH12rBIn';
var errors$a = {
  showRateLimitError: false,
  showGenericError: false,
  showGenericErrorEmail: false
};

var AccountEliminationTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(AccountEliminationTemplate, _BaseForm);

  function AccountEliminationTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.checkTransientErrors = function () {
      transientErrorsStorage.get().then(function (error) {
        if (typeof error === 'string') {
          var _this$setState;

          _this.setState((_this$setState = {}, _this$setState[error] = true, _this$setState));
        }
      });
    };

    _this.pageLoadEvent = function (page) {
      return lurker$B.pageLoadEvt("account_elimination_" + page);
    };

    _this.onEmailChange = function (event) {
      _this.onFieldChange(event, 'email', isValidEmail, defaultEmailErrorMsg$5, true);
    };

    _this.onEmailBlur = function (event) {
      _this.onFieldChange(event, 'email', isValidEmail, defaultEmailErrorMsg$5, false);
    };

    _this.onMailCheckSuggestionClick = function (suggestion) {
      lurker$B.viewMessageEvt('mailcheck_suggestion_accepted', {
        mailcheck_original: _this.state.fields.email.value,
        mailcheck_suggestion: suggestion
      });
      var valid = isValidEmail(suggestion);

      _this.updateField('email', suggestion, valid, true);
    };

    _this.handleStartSubmit = function (event) {
      event.preventDefault();
      lurker$B.clickEvt('submit');
      var prepare = Promise.resolve(undefined);
      prepare.then(function () {
        return _this.validateSomeFieldsBeforeSend(['email']).then(function () {
          return _this.setState(_extends({}, errors$a, {
            isSubmitting: true
          }), function () {
            return _this.doSendEmail();
          });
        })["catch"](function () {
          _this.setState({
            isSubmitting: false
          });
        });
      });
    };

    _this.doSendEmail = function () {
      var fieldsToValidate = _this.state.useRecaptcha ? ['email', 'recaptchaToken'] : ['email'];

      _this.checkSomeFieldsIsValid(fieldsToValidate).then(function () {
        return _this.onValidateEmail();
      })["catch"](function () {
        lurker$B.viewMessageEvt('error', _extends({
          accounts_reason: 'invalid_fields'
        }, _this.getInvalidFields()));
      });
    };

    _this.onValidateEmail = function () {
      var _this$state$fields = _this.state.fields,
          email = _this$state$fields.email,
          recaptchaToken = _this$state$fields.recaptchaToken;
      var validateMethod = _this.state.useRecaptcha ? validateEmailBeforeProccess : validateEmailBeforeProccessNoCaptcha;
      validateMethod(email.value, recaptchaToken.value).then(function () {
        return _this.onEmailSended();
      })["catch"](function (e) {
        return _this.onApiCallError(e);
      });
    };

    _this.onEmailSended = function () {
      _this.setState({
        isSubmitting: false,
        emailSended: true
      });

      _this.pageLoadEvent('reason');
    };

    _this.onReasonChange = function (event) {
      _this.onFieldChange(event, 'reason');
    };

    _this.onCommentChange = function (event) {
      _this.onFieldChange(event, 'comments');
    };

    _this.showError = function (error, extra) {
      var _extends2;

      return _this.setState(_extends({}, errors$a, extra, (_extends2 = {}, _extends2[error] = true, _extends2)));
    };

    _this.onRecaptchaLoad = function () {
      return _this.setState({
        recaptchaReady: true
      });
    };

    _this.onRecaptchaError = function (e) {
      lurker$B.viewMessageEvt('error', {
        accounts_reason: 'recaptcha_error',
        accounts_error_message: e && e.message || 'unknown'
      });
    };

    _this.onRecaptchaVerify = function (recaptchaToken) {
      if (recaptchaToken) {
        _this.updateField('recaptchaToken', recaptchaToken, true);
      } else {
        _this.setState({
          isSubmitting: false
        });

        _this.recaptcha.reset();

        lurker$B.viewMessageEvt('error', {
          accounts_reason: 'recaptcha_failed_token'
        });

        _this.showError('showGenericError');
      }
    };

    _this.handleReasonSubmit = function (event) {
      event.preventDefault();
      lurker$B.clickEvt('submit');
      var prepare = Promise.resolve(undefined);
      prepare.then(function () {
        return _this.setState(_extends({}, errors$a, {
          isSubmitting: true
        }), function () {
          return _this.doSendReason();
        });
      })["catch"](function () {
        _this.setState({
          isSubmitting: false
        });
      });
    };

    _this.doSendReason = function () {
      _this.checkSomeFieldsIsValid(['reason']).then(function () {
        return _this.onTryEraserAccount();
      })["catch"](function () {
        lurker$B.viewMessageEvt('error', _extends({
          accounts_reason: 'invalid_fields'
        }, _this.getInvalidFields()));
      });
    };

    _this.onTryEraserAccount = function () {
      var _this$state$fields2 = _this.state.fields,
          reason = _this$state$fields2.reason,
          email = _this$state$fields2.email,
          comments = _this$state$fields2.comments;
      startDeletionProccess(email.value, reason.value, comments.value).then(function () {
        return _this.onReasonSended();
      })["catch"](function (e) {
        return _this.onApiCallError(e);
      });
    };

    _this.onReasonSended = function () {
      var onSuccess = _this.props.onSuccess;

      _this.setState({
        isSubmitting: false,
        reasonSended: true
      });

      _this.pageLoadEvent('success');

      if (typeof onSuccess === 'function') {
        onSuccess();
      }
    };

    _this.onApiCallError = function (error) {
      if (error === void 0) {
        error = {};
      }

      _this.setState({
        isSubmitting: false
      });

      if (_this.props.onError) {
        _this.props.onError();
      }

      var _error = error,
          _error$response = _error.response,
          response = _error$response === void 0 ? {} : _error$response;

      if (response.status === 401) {
        lurker$B.viewMessageEvt('error', {
          accounts_reason: 'unauthorized',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status === 429) {
        lurker$B.viewMessageEvt('error', {
          accounts_reason: 'rate_limit_exceeded',
          accounts_status_code: response.status
        });

        _this.showError('showRateLimitError');
      } else if (response.status === 403) {
        lurker$B.viewMessageEvt('error', {
          accounts_reason: 'recaptcha_invalid_token',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status === 409) {
        lurker$B.viewMessageEvt('error', {
          accounts_reason: 'conflict_email_error',
          accounts_status_code: response.status
        });

        _this.showError('showGenericErrorEmail');
      } else if (response.status === 400 && response.data && response.data === 'Missing recaptcha response token') {
        lurker$B.viewMessageEvt('error', {
          accounts_reason: 'recaptcha_missing_token',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status) {
        lurker$B.viewMessageEvt('error', {
          accounts_reason: 'unexpected_status_code',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else {
        lurker$B.viewMessageEvt('error', {
          accounts_reason: 'unexpected_error',
          accounts_error_message: error && error.message || 'unknown'
        });

        _this.showError('showGenericError');
      }

      behaviors.scrollToTop();
    };

    _this.state = _extends({}, errors$a, {
      isSubmitting: false,
      suggestion: '',
      emailSended: false,
      reasonSended: false,
      recaptchaReady: false,
      useRecaptcha: true,
      validators: {
        email: {
          action: isValidEmail,
          message: defaultEmailErrorMsg$5
        }
      },
      fields: {
        email: {
          value: '',
          pristine: true,
          valid: false
        },
        reason: {
          value: '',
          pristine: true,
          valid: false
        },
        comments: {
          value: '',
          pristine: true,
          valid: true
        },
        recaptchaToken: {
          value: '',
          pristine: true,
          valid: false
        }
      }
    });
    return _this;
  }

  var _proto = AccountEliminationTemplate.prototype;

  _proto.checkRecaptcha = function checkRecaptcha() {
    var useRecaptcha = this.props.useRecaptcha;
    this.setState({
      useRecaptcha: useRecaptcha
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    this.pageLoadEvent('start');
    var email = this.props.email;

    if (email) {
      this.updateField('email', email, isValidEmail(email), false, defaultEmailErrorMsg$5, undefined);
    }

    this.checkTransientErrors();
  };

  _proto.componentWillMount = function componentWillMount() {
    this.checkRecaptcha();
  };

  _proto.disableSend = function disableSend(isSubmitting, validEmail, recaptchaToken) {
    return this.state.useRecaptcha ? isSubmitting || !validEmail || !recaptchaToken.valid : isSubmitting || !validEmail;
  };

  _proto.renderStartView = function renderStartView() {
    var _this2 = this;

    var _this$state = this.state,
        showGenericError = _this$state.showGenericError,
        showRateLimitError = _this$state.showRateLimitError,
        showGenericErrorEmail = _this$state.showGenericErrorEmail;
    var _this$state$fields3 = this.state.fields,
        email = _this$state$fields3.email,
        isSubmitting = _this$state$fields3.isSubmitting,
        recaptchaToken = _this$state$fields3.recaptchaToken;
    var emailHasError = !email.valid && !email.pristine;
    return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(HeaderBar, {
      text: "Etapa 1 de 3"
    }), /*#__PURE__*/React.createElement(ContentPage, null, /*#__PURE__*/React.createElement(TitleStart, null, /*#__PURE__*/React.createElement(TitlePage, null, "Exclus\xE3o de conta definitiva")), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgStartView, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel continuar com a exclus\xE3o de conta. Por favor, tente novamente mais tarde."
    })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgStartView, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
    })), showGenericErrorEmail && /*#__PURE__*/React.createElement(ErrorMsgStartView, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showDeleteAccount: true,
      text: "N\xE3o foi poss\xEDvel continuar com a exclus\xE3o da conta."
    })), /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(RemindText, null, /*#__PURE__*/React.createElement(Text$1, {
      weight: "semiBold"
    }, "Lembre-se:"), " Seus dados da conta, an\xFAncios, chat e perfil ser\xE3o exclu\xEDdos definitivamente e n\xE3o ser\xE1 poss\xEDvel recuperar esta conta.")), /*#__PURE__*/React.createElement(PageForm$9, {
      method: "POST",
      onSubmit: this.handleStartSubmit,
      noValidate: true
    }, /*#__PURE__*/React.createElement(MailCheckFormItemWrapper, null, /*#__PURE__*/React.createElement(MailCheckFormItem, {
      tip: "Necess\xE1rio acesso ao e-mail de cadastro",
      labelweight: "600",
      value: email.value,
      onChange: function onChange(event) {
        return _this2.onEmailChange(event);
      },
      onBlur: function onBlur(event) {
        return _this2.onEmailBlur(event);
      },
      error: email.msg,
      hasError: emailHasError,
      inputRef: function inputRef(x) {
        _this2.inputs.email = x;
      },
      disabled: isSubmitting,
      onSuggestionClick: this.onMailCheckSuggestionClick
    })), this.state.useRecaptcha && this.renderRecaptcha(), /*#__PURE__*/React.createElement(Button$1, {
      fluid: true,
      size: "large",
      disabled: this.disableSend(isSubmitting, email.valid, recaptchaToken),
      isLoading: isSubmitting,
      onClick: this.handleStartSubmit
    }, "Continuar"))));
  };

  _proto.renderRecaptcha = function renderRecaptcha() {
    var _this3 = this;

    var recaptchaToken = this.state.fields.recaptchaToken;
    var captchaHasError = recaptchaToken.hasOwnProperty('valid') && !recaptchaToken.valid && !recaptchaToken.pristine;
    return /*#__PURE__*/React.createElement(RecaptchaWrapper$3, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Reaptcha, {
      ref: function ref(e) {
        _this3.recaptcha = e;
      },
      sitekey: recaptchaSiteKey$4,
      onLoad: this.onRecaptchaLoad,
      onVerify: this.onRecaptchaVerify,
      onError: this.onRecaptchaError
    }), captchaHasError && /*#__PURE__*/React.createElement(ErrorMsgView$1, null, /*#__PURE__*/React.createElement(errorMsg, null, "Captcha n\xE3o preenchido."))));
  };

  _proto.renderReasonView = function renderReasonView() {
    var _this4 = this;

    var _this$state$fields4 = this.state.fields,
        reason = _this$state$fields4.reason,
        comments = _this$state$fields4.comments;
    var _this$state2 = this.state,
        showGenericError = _this$state2.showGenericError,
        showRateLimitError = _this$state2.showRateLimitError,
        showGenericErrorEmail = _this$state2.showGenericErrorEmail,
        isSubmitting = _this$state2.isSubmitting;
    return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(HeaderBar, {
      text: "Etapa 2 de 3"
    }), /*#__PURE__*/React.createElement(ContentPage, null, /*#__PURE__*/React.createElement(TitleReason, null, /*#__PURE__*/React.createElement(TitlePage, null, "Qual motivo da exclus\xE3o?")), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$e, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel continuar com a exclus\xE3o de conta. Por favor, tente novamente mais tarde."
    })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$e, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showContactUs: false,
      text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
    })), showGenericErrorEmail && /*#__PURE__*/React.createElement(ErrorMsgWrapper$e, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      showDeleteAccount: true,
      text: "N\xE3o foi poss\xEDvel continuar com a exclus\xE3o da conta."
    })), /*#__PURE__*/React.createElement(PageForm$9, {
      method: "POST",
      onSubmit: this.handleReasonSubmit,
      noValidate: true
    }, /*#__PURE__*/React.createElement(RadioInputWrapper$1, null, /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "J\xE1 vendi meu produto",
      name: "reason",
      value: "already_sold_product",
      checked: reason.value === 'already_sold_product',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "N\xE3o tenho retorno nos meus an\xFAncios",
      name: "reason",
      value: "without_olx_returning",
      checked: reason.value === 'without_olx_returning',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "N\xE3o quero mais usar a OLX",
      name: "reason",
      value: "do_not_want_olx",
      checked: reason.value === 'do_not_want_olx',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "N\xE3o tenho cadastro na OLX",
      name: "reason",
      value: "do_not_have_olx_account",
      checked: reason.value === 'do_not_have_olx_account',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "Motivos pessoais",
      name: "reason",
      value: "personal_reasons",
      checked: reason.value === 'personal_reasons',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "N\xE3o sinto seguran\xE7a na OLX",
      name: "reason",
      value: "do_not_feel_safe_in_olx",
      checked: reason.value === 'do_not_feel_safe_in_olx',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(RadioInput, {
      fontWeight: 300,
      label: "Outro motivo",
      name: "reason",
      value: "other_reasons",
      checked: reason.value === 'other_reasons',
      onChange: this.onReasonChange,
      disabled: isSubmitting
    })), /*#__PURE__*/React.createElement(CommentWrapper, null, /*#__PURE__*/React.createElement(formLabel$1, {
      label: "Coment\xE1rios",
      tip: "200 caracteres"
    }), /*#__PURE__*/React.createElement(CommentView$1, null, /*#__PURE__*/React.createElement(InputTextarea$1, {
      multiline: true,
      rows: 6,
      placeholder: "Escreva um pouco mais sobre o motivo...",
      onBlur: this.onCommentBlur,
      onChange: this.onCommentChange,
      disabled: isSubmitting,
      returnKeyType: "done",
      maxLength: 200,
      onSubmitEditing: function onSubmitEditing() {
        return _this4.updateFocus('comments');
      },
      value: comments.value,
      inputRef: function inputRef(x) {
        _this4.inputs.comments = x;
      }
    }))), /*#__PURE__*/React.createElement(Button$1, {
      fluid: true,
      size: "large",
      disabled: isSubmitting || !reason.valid,
      isLoading: isSubmitting,
      onClick: this.handleReasonSubmit
    }, "Continuar"))));
  };

  _proto.renderSuccessView = function renderSuccessView() {
    var email = this.state.fields.email;
    return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(HeaderBar, {
      text: "Etapa 3 de 3"
    }), /*#__PURE__*/React.createElement(ContentSuccess, null, /*#__PURE__*/React.createElement(SuccessTitle, null, /*#__PURE__*/React.createElement(TitlePage, null, "Confirme a exclus\xE3o")), /*#__PURE__*/React.createElement(PlaneIcon, {
      width: 48,
      height: 48
    }), /*#__PURE__*/React.createElement(Description$f, {
      fontWeight: 300
    }, "Para confirmar a exclus\xE3o definitiva da sua conta, um e-mail foi enviado para:"), /*#__PURE__*/React.createElement(LabelBoxView$2, null, /*#__PURE__*/React.createElement(LabelBox, null, email.value)), /*#__PURE__*/React.createElement(SuportView, null, /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(SuportText, null, "Procure o e-mail com assunto", /*#__PURE__*/React.createElement(SuportTextBold, null, " Excluir conta OLX."))), /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(SuportText, null, "N\xE3o esque\xE7a de conferir sua pasta de spam.")))));
  };

  _proto.render = function render() {
    var _this$state3 = this.state,
        emailSended = _this$state3.emailSended,
        reasonSended = _this$state3.reasonSended;

    if (reasonSended) {
      return this.renderSuccessView();
    }

    if (emailSended) {
      return this.renderReasonView();
    }

    return this.renderStartView();
  };

  return AccountEliminationTemplate;
}(BaseForm);

AccountEliminationTemplate.defaultProps = {};
AccountEliminationTemplate.propTypes = {
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  email: PropTypes__default.string,
  useRecaptcha: PropTypes__default.bool
};
AccountEliminationTemplate.defaultProps = {
  useRecaptcha: true
};

var _templateObject$32;
var Content$1t = styled(View$1)(_templateObject$32 || (_templateObject$32 = _taggedTemplateLiteralLoose(["\n  background-color: #ffffff;\n"])));
var AccountEliminationPage = function AccountEliminationPage(_ref) {
  var onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      email = _ref.email;
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$1t, null, /*#__PURE__*/React.createElement(AccountEliminationTemplate, {
    onSuccess: onSuccess,
    onError: onError,
    email: email
  })));
};
AccountEliminationPage.propTypes = {
  onSuccess: PropTypes__default.func,
  onError: PropTypes__default.func,
  email: PropTypes__default.string
};

var trashCheckConfig = {
  viewBox: '0 0 48 53',
  width: '48',
  height: '53',
  fill: 'none',
  paths: [{
    color: '#4A4A4A',
    path: 'M33.5 10.5H42C42.8284 10.5 43.5 11.1716 43.5 12C43.5 12.8284 42.8284 13.5 42 13.5H39.5V40C39.5 43.0376 37.0376 45.5 34 45.5H14C10.9624 45.5 8.5 43.0376 8.5 40V13.5H6C5.17157 13.5 4.5 12.8284 4.5 12C4.5 11.1716 5.17157 10.5 6 10.5H14.5V8C14.5 4.96243 16.9624 2.5 20 2.5H28C31.0376 2.5 33.5 4.96243 33.5 8V10.5ZM30.5 10.5V8C30.5 6.61929 29.3807 5.5 28 5.5H20C18.6193 5.5 17.5 6.61929 17.5 8V10.5H30.5ZM36.5 13.5H11.5V40C11.5 41.3807 12.6193 42.5 14 42.5H34C35.3807 42.5 36.5 41.3807 36.5 40V13.5Z'
  }, {
    color: 'white',
    path: 'M37.5 53C43.0228 53 47.5 48.5228 47.5 43C47.5 37.4772 43.0228 33 37.5 33C31.9772 33 27.5 37.4772 27.5 43C27.5 48.5228 31.9772 53 37.5 53Z'
  }, {
    color: '#8CE563',
    path: 'M44.0004 42.3839C44.0004 42.1077 44.2242 41.8839 44.5004 41.8839C44.7765 41.8839 45.0004 42.1077 45.0004 42.3839V43.0041C44.9986 46.178 42.9093 48.9727 39.8657 49.8726C36.8221 50.7725 33.549 49.5633 31.8216 46.9007C30.0941 44.2381 30.3237 40.7564 32.3858 38.3437C34.4479 35.931 37.8514 35.162 40.7505 36.4538C41.0028 36.5662 41.1161 36.8618 41.0037 37.114C40.8914 37.3663 40.5958 37.4796 40.3435 37.3672C37.8489 36.2557 34.9204 36.9174 33.146 38.9934C31.3716 41.0695 31.174 44.0654 32.6605 46.3564C34.1469 48.6475 36.9632 49.688 39.5822 48.9136C42.2011 48.1393 43.9988 45.7346 44.0004 43.0039V42.3839ZM37.8337 43.6301L44.8135 36.6503C45.0087 36.455 45.3253 36.455 45.5206 36.6503C45.7158 36.8456 45.7158 37.1621 45.5206 37.3574L38.1873 44.6907C37.992 44.886 37.6754 44.886 37.4801 44.6907L35.4801 42.6907C35.2849 42.4955 35.2849 42.1789 35.4801 41.9836C35.6754 41.7884 35.992 41.7884 36.1873 41.9836L37.8337 43.6301Z'
  }, {
    color: '#8CE563',
    path: 'M45.0004 43.0041L45.5004 43.0044V43.0041H45.0004ZM40.7505 36.4538L40.547 36.9105L40.7505 36.4538ZM40.3435 37.3672L40.14 37.824L40.3435 37.3672ZM44.0004 43.0039L44.5004 43.0041V43.0039H44.0004ZM37.8337 43.6301L37.4801 43.9836L37.8337 44.3372L38.1873 43.9836L37.8337 43.6301ZM44.8135 36.6503L45.167 37.0039L44.8135 36.6503ZM45.5206 37.3574L45.167 37.0039L45.5206 37.3574ZM38.1873 44.6907L38.5408 45.0443L38.1873 44.6907ZM37.4801 44.6907L37.1266 45.0443L37.4801 44.6907ZM35.4801 42.6907L35.8337 42.3372L35.4801 42.6907ZM36.1873 41.9836L35.8337 42.3372L36.1873 41.9836ZM44.5004 42.3839V41.3839C43.9481 41.3839 43.5004 41.8316 43.5004 42.3839H44.5004ZM44.5004 42.3839H44.5004H45.5004C45.5004 41.8316 45.0527 41.3839 44.5004 41.3839V42.3839ZM44.5004 42.3839V43.0041H45.5004V42.3839H44.5004ZM44.5004 43.0039C44.4987 45.9563 42.5552 48.556 39.7239 49.3931L40.0075 50.3521C43.2635 49.3894 45.4984 46.3998 45.5004 43.0044L44.5004 43.0039ZM39.7239 49.3931C36.8926 50.2302 33.848 49.1054 32.241 46.6286L31.4021 47.1728C33.2501 50.0212 36.7515 51.3148 40.0075 50.3521L39.7239 49.3931ZM32.241 46.6286C30.634 44.1517 30.8476 40.9129 32.7659 38.6686L32.0057 38.0189C29.7997 40.5999 29.5541 44.3245 31.4021 47.1728L32.241 46.6286ZM32.7659 38.6686C34.6842 36.4242 37.8502 35.7089 40.547 36.9105L40.954 35.9971C37.8526 34.6152 34.2117 35.4378 32.0057 38.0189L32.7659 38.6686ZM40.547 36.9105L41.4605 37.3175C41.6852 36.8131 41.4585 36.2219 40.954 35.9971L40.547 36.9105ZM40.547 36.9105H40.547L40.14 37.824C40.6445 38.0487 41.2357 37.822 41.4605 37.3175L40.547 36.9105ZM40.547 36.9105C37.8502 35.7089 34.6842 36.4242 32.7659 38.6686L33.5261 39.3183C35.1566 37.4106 37.8477 36.8025 40.14 37.824L40.547 36.9105ZM32.7659 38.6686C30.8476 40.9129 30.634 44.1517 32.241 46.6286L33.0799 46.0843C31.714 43.979 31.8955 41.226 33.5261 39.3183L32.7659 38.6686ZM32.241 46.6286C33.848 49.1054 36.8926 50.2302 39.7239 49.3931L39.4404 48.4342C37.0338 49.1457 34.4458 48.1896 33.0799 46.0843L32.241 46.6286ZM39.7239 49.3931C42.5552 48.556 44.4987 45.9563 44.5004 43.0041L43.5004 43.0036C43.4989 45.5129 41.847 47.7226 39.4404 48.4342L39.7239 49.3931ZM44.5004 43.0039V42.3839H43.5004V43.0039H44.5004ZM38.1873 43.9836L45.167 37.0039L44.4599 36.2967L37.4801 43.2765L38.1873 43.9836ZM45.167 37.0039H45.167L45.8741 36.2967C45.4836 35.9062 44.8504 35.9062 44.4599 36.2967L45.167 37.0039ZM45.167 37.0039L45.8741 37.711C46.2647 37.3204 46.2647 36.6873 45.8741 36.2967L45.167 37.0039ZM45.167 37.0039L37.8337 44.3372L38.5408 45.0443L45.8741 37.711L45.167 37.0039ZM37.8337 44.3372L37.1266 45.0443C37.5171 45.4348 38.1503 45.4348 38.5408 45.0443L37.8337 44.3372ZM37.8337 44.3372L35.8337 42.3372L35.1266 43.0443L37.1266 45.0443L37.8337 44.3372ZM35.8337 42.3372V42.3372L35.1266 41.6301C34.7361 42.0206 34.7361 42.6538 35.1266 43.0443L35.8337 42.3372ZM35.8337 42.3372L36.5408 41.6301C36.1503 41.2396 35.5171 41.2396 35.1266 41.6301L35.8337 42.3372ZM35.8337 42.3372L37.4801 43.9836L38.1873 43.2765L36.5408 41.6301L35.8337 42.3372Z'
  }]
};

var TrashCheckIcon = (function () {
  return /*#__PURE__*/React.createElement(Svg, {
    config: trashCheckConfig
  });
});

var nullifierUrl$3 = process.env.REACT_APP_NULLIFIER_URL || 'https://nullifier.olx.com.br';
var API_ENDPOINT$h = nullifierUrl$3 + "/deletion/confirm";
var deleteAccountApiCall = (function (token) {
  return axios.post(API_ENDPOINT$h, {
    token: token
  });
});

var _templateObject$33, _templateObject2$2m, _templateObject3$1J, _templateObject4$1b, _templateObject5$P, _templateObject6$w;
var lurker$C = new Lurker('account_elimination_confirmation');
var Content$1u = styled(View$1)(_templateObject$33 || (_templateObject$33 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TitleWrapper$b = styled(View$1)(_templateObject2$2m || (_templateObject2$2m = _taggedTemplateLiteralLoose(["\n  margin-top: 32px;\n  margin-bottom: 16px;\n"])));
var EmailChipWrapper$5 = styled(View$1)(_templateObject3$1J || (_templateObject3$1J = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"])));
var SymbolWrapper$2 = styled(View$1)(_templateObject4$1b || (_templateObject4$1b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n"])));
var SubtitleWrapper$7 = styled(Subtitle)(_templateObject5$P || (_templateObject5$P = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));
var ButtonWrapper$b = styled(Button$1)(_templateObject6$w || (_templateObject6$w = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  flex: none;\n"])));

var AccountEliminationConfirmationTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountEliminationConfirmationTemplate, _React$Component);

  function AccountEliminationConfirmationTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.deleteAccount = function () {
      _this.setState({
        status: 'loading'
      });

      var token = _this.props.token;
      deleteAccountApiCall(token).then(function () {
        lurker$C.viewMessageEvt('success');

        _this.setState({
          status: 'success'
        });
      })["catch"](function (error) {
        if (error === void 0) {
          error = {};
        }

        var _error = error,
            _error$response = _error.response,
            _error$response2 = _error$response === void 0 ? {} : _error$response,
            status = _error$response2.status;

        if (status === 410) {
          lurker$C.viewMessageEvt('error', {
            accounts_reason: 'invalid_token',
            accounts_status_code: status
          });

          _this.setState({
            status: 'invalid_token'
          });
        } else if (status) {
          lurker$C.viewMessageEvt('error', {
            accounts_reason: 'unexpected_status_code',
            accounts_status_code: status
          });

          _this.setState({
            status: 'error'
          });
        } else {
          lurker$C.viewMessageEvt('error', {
            accounts_reason: 'unexpected_error',
            accounts_error_message: error && error.message || 'unknown'
          });

          _this.setState({
            status: 'error'
          });
        }
      });
    };

    _this.state = {
      status: 'loading'
    };
    return _this;
  }

  var _proto = AccountEliminationConfirmationTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$C.pageLoadEvt();
    this.deleteAccount();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        email = _this$props.email,
        onExpiredLink = _this$props.onExpiredLink;
    var status = this.state.status;

    if (status === 'loading') {
      return /*#__PURE__*/React.createElement(LoadingBackdrop$1, null);
    }

    if (status === 'success') {
      return /*#__PURE__*/React.createElement(Content$1u, null, /*#__PURE__*/React.createElement(TrashCheckIcon, null), /*#__PURE__*/React.createElement(TitleWrapper$b, null, /*#__PURE__*/React.createElement(Text$1, {
        size: "title3",
        weight: "semiBold"
      }, "Em breve sua conta ser\xE1 exclu\xEDda")), /*#__PURE__*/React.createElement(EmailChipWrapper$5, null, /*#__PURE__*/React.createElement(EmailChip, null, email)), /*#__PURE__*/React.createElement(Text$1, null, "Agradecemos o seu tempo com a OLX."), /*#__PURE__*/React.createElement(formLabel, {
        text: "Crie uma",
        linkText: "nova conta",
        remainingText: "quando quiser!",
        href: "/cadastro"
      }));
    }

    if (status === 'invalid_token') {
      return /*#__PURE__*/React.createElement(Content$1u, null, /*#__PURE__*/React.createElement(SymbolWrapper$2, null, /*#__PURE__*/React.createElement(AlertSymbol, null)), /*#__PURE__*/React.createElement(SubtitleWrapper$7, null, "Parece que o e-mail para exclus\xE3o de conta n\xE3o est\xE1 mais v\xE1lido."), /*#__PURE__*/React.createElement(SubtitleWrapper$7, null, "Clique no bot\xE3o abaixo para tentar novamente:"), /*#__PURE__*/React.createElement(ButtonWrapper$b, {
        fluid: true,
        size: "large",
        onClick: onExpiredLink
      }, "Tentar novamente"));
    }

    return /*#__PURE__*/React.createElement(Content$1u, null, /*#__PURE__*/React.createElement(SymbolWrapper$2, null, /*#__PURE__*/React.createElement(AlertSymbol, null)), /*#__PURE__*/React.createElement(SubtitleWrapper$7, null, "N\xE3o foi poss\xEDvel excluir sua conta."), /*#__PURE__*/React.createElement(SubtitleWrapper$7, null, "Clique no bot\xE3o abaixo para tentar novamente:"), /*#__PURE__*/React.createElement(ButtonWrapper$b, {
      fluid: true,
      size: "large",
      onClick: this.deleteAccount
    }, "Tentar novamente"));
  };

  return AccountEliminationConfirmationTemplate;
}(React.Component);

AccountEliminationConfirmationTemplate.propTypes = {
  token: PropTypes__default.string,
  email: PropTypes__default.string,
  onExpiredLink: PropTypes__default.func
};

var _templateObject$34, _templateObject2$2n;
var Content$1v = styled(View$1)(_templateObject$34 || (_templateObject$34 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$2n || (_templateObject2$2n = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4px;\n    margin-bottom: 0;\n  "]))));
var AccountEliminationConfirmationPage = function AccountEliminationConfirmationPage(props) {
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$1v, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(AccountEliminationConfirmationTemplate, props))));
};

var _templateObject$35, _templateObject2$2o;
var Content$1w = styled(View$1)(_templateObject$35 || (_templateObject$35 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n"])));
var LoadingWrapper = styled(View$1)(_templateObject2$2o || (_templateObject2$2o = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"])));

var LoadingBackdrop = function LoadingBackdrop() {
  return /*#__PURE__*/React.createElement(Content$1w, null, /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement(LoadingIcon, {
    src: "https://static.olx.com.br/accounts/loading.gif"
  })));
};

var EMAIL_CHANGER_BASE_URL$1 = 'https://email-changer.olx.com.br';
var validateConfirmationToken = function validateConfirmationToken(token) {
  return axios.post(EMAIL_CHANGER_BASE_URL$1 + "/validate", {
    token: token
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.status === 200;
  });
};
var sendEmailChangeRequest = function sendEmailChangeRequest(email, token) {
  return axios.post(EMAIL_CHANGER_BASE_URL$1 + "/activate/send", {
    email: email.toLowerCase().trim(),
    token: token
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};
var activateEmailChangeRequest = function activateEmailChangeRequest(token, confirmationToken) {
  return axios.post(EMAIL_CHANGER_BASE_URL$1 + "/activate", {
    token: token,
    confirmationToken: confirmationToken
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};

var _templateObject$36, _templateObject2$2p, _templateObject3$1K, _templateObject4$1c, _templateObject5$Q, _templateObject6$x;
var lurker$D = new Lurker('email_change_activation');
var Content$1x = styled(View$1)(_templateObject$36 || (_templateObject$36 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var LabelBoxView$3 = styled(View$1)(_templateObject2$2p || (_templateObject2$2p = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 7px 51px 8px 51px;\n  margin-bottom: 32px;\n"])));
var PageTitle = styled(Title)(_templateObject3$1K || (_templateObject3$1K = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  line-height: 32px;\n  margin-top: 28px;\n  padding: 0 16px;\n"])));
var TitleStart$1 = styled(View$1)(_templateObject4$1c || (_templateObject4$1c = _taggedTemplateLiteralLoose(["\n  margin-bottom: 8px;\n"])));
var Description$g = styled(Text$1)(_templateObject5$Q || (_templateObject5$Q = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 24px;\n  margin-bottom: 32px;\n  line-height: 24px;\n  font-size: 16px;\n"])));
var DescriptionWrapper = styled(Description$g)(_templateObject6$x || (_templateObject6$x = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"])));

var EmailChangeActivationTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EmailChangeActivationTemplate, _React$Component);

  function EmailChangeActivationTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.confirmChange = function () {
      var _this$props = _this.props,
          token = _this$props.token,
          confirmationToken = _this$props.confirmationToken;
      activateEmailChangeRequest(token, confirmationToken).then(function () {
        lurker$D.viewMessageEvt('success');

        _this.setState({
          status: 'success'
        });
      })["catch"](function (error) {
        if (error === void 0) {
          error = {};
        }

        var _error = error,
            _error$response = _error.response,
            _error$response2 = _error$response === void 0 ? {} : _error$response,
            status = _error$response2.status,
            data = _error$response2.data;

        if (status === 422) {
          lurker$D.viewMessageEvt('error', {
            accounts_reason: 'missing_token',
            accounts_status_code: status
          });

          _this.setState({
            status: 'missing_token'
          });
        } else if (status === 409) {
          if (!!data && data.message && data.message === 'EMAIL_IN_USE') {
            lurker$D.viewMessageEvt('error', {
              accounts_reason: 'EMAIL_IN_USE',
              accounts_status_code: status
            });

            _this.setState({
              status: 'error',
              showErrorEmail: true
            });
          } else {
            lurker$D.viewMessageEvt('error', {
              accounts_reason: 'invalid_token',
              accounts_status_code: status
            });

            _this.setState({
              status: 'error'
            });
          }
        } else if (status) {
          lurker$D.viewMessageEvt('error', {
            accounts_reason: 'unexpected_status_code',
            accounts_status_code: status
          });

          _this.setState({
            status: 'error'
          });
        } else {
          lurker$D.viewMessageEvt('error', {
            accounts_reason: 'unexpected_error',
            accounts_error_message: error && error.message || 'unknown'
          });

          _this.setState({
            status: 'error'
          });
        }
      });
    };

    _this.retryChange = function () {
      var onRetryChange = _this.props.onRetryChange;
      lurker$D.clickEvt('retry_change');

      if (onRetryChange && typeof onRetryChange === 'function') {
        onRetryChange();
      }
    };

    _this.renderErrorView = function () {
      var showErrorEmail = _this.state.showErrorEmail;
      return /*#__PURE__*/React.createElement(Content$1x, null, /*#__PURE__*/React.createElement(TitleStart$1, null, /*#__PURE__*/React.createElement(PageTitle, null, "N\xE3o foi poss\xEDvel ativar seu novo e-mail")), /*#__PURE__*/React.createElement(Description$g, {
        fontWeight: 400
      }, showErrorEmail ? 'O e-mail informado já possui cadastro' : 'Para segurança da sua conta, a ativação enviada por e-mail possui validade.'), !showErrorEmail && /*#__PURE__*/React.createElement(DescriptionWrapper, {
        fontWeight: 400
      }, "Por favor, tente novamente!"), /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        size: "large",
        onClick: _this.retryChange
      }, "Tentar novamente"));
    };

    _this.state = {
      status: 'loading',
      showErrorEmail: false
    };
    return _this;
  }

  var _proto = EmailChangeActivationTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$D.pageLoadEvt();
    this.confirmChange();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        newEmail = _this$props2.newEmail,
        onSuccess = _this$props2.onSuccess;
    var status = this.state.status;

    if (status === 'loading') {
      return /*#__PURE__*/React.createElement(LoadingBackdrop, null);
    }

    if (status === 'success') {
      return /*#__PURE__*/React.createElement(Content$1x, null, /*#__PURE__*/React.createElement(MailIcon, null), /*#__PURE__*/React.createElement(TitleStart$1, null, /*#__PURE__*/React.createElement(PageTitle, null, "Estamos alterando o seu e-mail")), /*#__PURE__*/React.createElement(Description$g, {
        fontWeight: 400
      }, "Aguarde a conclus\xE3o para usar o novo e-mail na sua conta. Assim que a altera\xE7\xE3o for conclu\xEDda, ser\xE1 enviado um aviso para:"), /*#__PURE__*/React.createElement(LabelBoxView$3, null, /*#__PURE__*/React.createElement(LabelBox, null, newEmail)), /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        size: "large",
        onClick: onSuccess
      }, "Entendi"));
    }

    return this.renderErrorView();
  };

  return EmailChangeActivationTemplate;
}(React.Component);

EmailChangeActivationTemplate.propTypes = {
  confirmationToken: PropTypes__default.string.isRequired,
  newEmail: PropTypes__default.string.isRequired,
  onRetryChange: PropTypes__default.func.isRequired,
  onSuccess: PropTypes__default.func.isRequired,
  token: PropTypes__default.string.isRequired
};

var _templateObject$37, _templateObject2$2q;
var ContentWrapper$a = styled(Paper$1)(_templateObject$37 || (_templateObject$37 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  max-width: 466px;\n  padding: 32px 64px;\n  ", "\n"])), function () {
  return '64px auto';
}, mediaQuery.small(_templateObject2$2q || (_templateObject2$2q = _taggedTemplateLiteralLoose(["\n    margin: 0;\n  "]))));
var EmailChangeActivationPage = function EmailChangeActivationPage(_ref) {
  var confirmationToken = _ref.confirmationToken,
      newEmail = _ref.newEmail,
      onRetryChange = _ref.onRetryChange,
      onSuccess = _ref.onSuccess,
      token = _ref.token;
  return /*#__PURE__*/React.createElement(ContentWrapper$a, null, /*#__PURE__*/React.createElement(EmailChangeActivationTemplate, {
    confirmationToken: confirmationToken,
    newEmail: newEmail,
    onRetryChange: onRetryChange,
    onSuccess: onSuccess,
    token: token
  }));
};
EmailChangeActivationPage.propTypes = {
  newEmail: PropTypes__default.string.isRequired,
  token: PropTypes__default.string.isRequired,
  onSuccess: PropTypes__default.func.isRequired,
  onRetryChange: PropTypes__default.func.isRequired,
  confirmationToken: PropTypes__default.string.isRequired
};

var PurplePlaneIcon = function PurplePlaneIcon(props) {
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "0.1",
    d: "M48.1149 87.3109C69.762 87.3109 87.3104 69.7625 87.3104 48.1154C87.3104 26.4683 69.762 8.91992 48.1149 8.91992C26.4679 8.91992 8.91943 26.4683 8.91943 48.1154C8.91943 69.7625 26.4679 87.3109 48.1149 87.3109Z",
    fill: "#6E0AD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7273 47.9471C16.3415 49.1988 16.4405 51.032 18.9418 52.0218L26.3529 54.9541C28.8562 55.948 32.6442 55.4056 34.7661 53.7498L66.9488 28.3699C69.0645 26.7058 69.2913 26.9512 67.454 28.9184L42.0122 56.15C40.1687 58.1111 40.7131 60.5196 43.2247 61.4908L44.0928 61.829C46.6044 62.8002 50.6976 64.4313 53.1927 65.4459L61.4122 68.7926C63.9093 69.8071 66.5776 68.6111 67.287 66.0129L79.8141 19.9669C80.5213 17.3687 79.148 16.2655 76.7622 17.5151L18.7273 47.9471Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0655 78.0928C38.9191 78.532 44.134 70.5415 44.134 70.5415C45.6084 68.2897 44.7712 65.6028 42.2802 64.5842L36.593 62.2561C34.1021 61.2374 32.9081 62.4334 33.9392 64.9223C33.9392 64.9223 39.216 77.6412 39.0655 78.0928Z",
    fill: "#6E0AD6"
  })));
};

PurplePlaneIcon.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number
};
PurplePlaneIcon.defaultProps = {
  width: 96,
  height: 96
};

var _templateObject$38, _templateObject2$2r, _templateObject3$1L, _templateObject4$1d, _templateObject5$R, _templateObject6$y, _templateObject7$n, _templateObject8$e;
var lurker$E = new Lurker('email_change_activation_sent');
var Content$1y = styled(View$1)(_templateObject$38 || (_templateObject$38 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var LabelBoxView$4 = styled(View$1)(_templateObject2$2r || (_templateObject2$2r = _taggedTemplateLiteralLoose(["\n  padding: 7px 50px;\n"])));
var TitleWrapper$c = styled(View$1)(_templateObject3$1L || (_templateObject3$1L = _taggedTemplateLiteralLoose(["\n  margin-top: 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var Description$h = styled(Text$1)(_templateObject4$1d || (_templateObject4$1d = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 24px;\n  margin-bottom: 8px;\n"])));
var SafetyTip$1 = styled(View$1)(_templateObject5$R || (_templateObject5$R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"])));
var Divider$1 = styled(View$1)(_templateObject6$y || (_templateObject6$y = _taggedTemplateLiteralLoose(["\n  height: 16px;\n"])));
var BoxWrapper$3 = styled(View$1)(_templateObject7$n || (_templateObject7$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-top: 32px;\n"])));
var IconWrapper$9 = styled(View$1)(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteralLoose(["\n  margin-right: 8px;\n"])));

var modalClose$3 = function modalClose(onClose) {
  return function () {
    lurker$E.clickEvt('modal_close');

    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };
};

var EmailChangeActivationSentModal = function EmailChangeActivationSentModal(_ref) {
  var email = _ref.email,
      onClose = _ref.onClose,
      open = _ref.open;
  return /*#__PURE__*/React.createElement(Modal$1, {
    onClose: modalClose$3(onClose),
    maxWidth: "400px",
    maxHeight: "550px",
    open: open
  }, /*#__PURE__*/React.createElement(Content$1y, null, /*#__PURE__*/React.createElement(PurplePlaneIcon, null), /*#__PURE__*/React.createElement(TitleWrapper$c, null, /*#__PURE__*/React.createElement(Text.TitleMedium, {
    weight: "semibold"
  }, "Ative o"), /*#__PURE__*/React.createElement(Text.TitleMedium, {
    weight: "bold"
  }, "novo e-mail")), /*#__PURE__*/React.createElement(Description$h, {
    size: "body1",
    weight: "regular"
  }, "O e-mail de ativa\xE7\xE3o foi enviado para"), /*#__PURE__*/React.createElement(LabelBoxView$4, null, /*#__PURE__*/React.createElement(LabelBox, null, truncate(email))), /*#__PURE__*/React.createElement(BoxWrapper$3, null, /*#__PURE__*/React.createElement(GenericBox, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(SafetyTip$1, null, /*#__PURE__*/React.createElement(IconWrapper$9, null, /*#__PURE__*/React.createElement(Icons.System.Lock, {
    size: "16",
    color: "#999999"
  })), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: "--color-neutral-120"
  }, "N\xE3o ser\xE1 compartilhado no seu perfil.")), /*#__PURE__*/React.createElement(Divider$1, null), /*#__PURE__*/React.createElement(SafetyTip$1, null, /*#__PURE__*/React.createElement(IconWrapper$9, null, /*#__PURE__*/React.createElement(Icons.System.Award, {
    size: "16",
    color: "#999999"
  })), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: "--color-neutral-120"
  }, "Conquistar\xE1 selo de e-mail verificado."))))));
};

EmailChangeActivationSentModal.propTypes = {
  email: PropTypes__default.string.isRequired,
  onClose: PropTypes__default.func.isRequired,
  open: PropTypes__default.bool.isRequired
};

var _templateObject$39, _templateObject2$2s, _templateObject3$1M, _templateObject4$1e, _templateObject5$S, _templateObject6$z, _templateObject7$o, _templateObject8$f, _templateObject9$9;
var lurker$F = new Lurker('email_change_send_mail');
var CenterWrapper = styled(View$1)(_templateObject$39 || (_templateObject$39 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n"])));
var PageTitle$1 = styled(Title)(_templateObject2$2s || (_templateObject2$2s = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 24px;\n  line-height: 32px;\n"])));
var Description$i = styled(View$1)(_templateObject3$1M || (_templateObject3$1M = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding-top: 16px;\n"])));
var DescriptionWrapper$1 = styled(Description$i)(_templateObject4$1e || (_templateObject4$1e = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-bottom: 32px;\n"])));
var PageForm$a = styled(Form)(_templateObject5$S || (_templateObject5$S = _taggedTemplateLiteralLoose(["\n  margin-top: 12px;\n"])));
var TitleStart$2 = styled(View$1)(_templateObject6$z || (_templateObject6$z = _taggedTemplateLiteralLoose(["\n  margin-bottom: 8px;\n"])));
var MailCheckFormItemWrapper$1 = styled(View$1)(_templateObject7$o || (_templateObject7$o = _taggedTemplateLiteralLoose(["\n  margin-bottom: 32px;\n  ", "\n"])), mediaQuery.medium(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteralLoose(["\n    margin-bottom: 16px;\n  "]))));
var ErrorMsgStartView$1 = styled(View$1)(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-bottom: 8px;\n"])));
var defaultEmailErrorMsg$6 = 'Por favor, insira um endereço de e-mail válido.';
var errors$b = {
  showRateLimitError: false,
  showEmailInBlackListError: false,
  showGenericError: false,
  showGenericErrorEmail: false,
  showInvalidTokenError: false
};

var EmailChangeSendMailTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(EmailChangeSendMailTemplate, _BaseForm);

  function EmailChangeSendMailTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;

    _this.onEmailChange = function (event) {
      _this.onFieldChange(event, 'email', isValidEmail, defaultEmailErrorMsg$6, true);
    };

    _this.onEmailBlur = function (event) {
      _this.onFieldChange(event, 'email', isValidEmail, defaultEmailErrorMsg$6, false);
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      lurker$F.clickEvt('submit');

      _this.setState({
        isSubmitting: true
      });

      _this.checkFormIsValid().then(_this.doSendEmail)["catch"](function () {
        lurker$F.viewMessageEvt('error', _extends({
          accounts_reason: 'invalid_fields'
        }, _this.getInvalidFields()));
      })["finally"](function () {
        return _this.setState({
          isSubmitting: false
        });
      });
    };

    _this.doSendEmail = function () {
      var email = _this.state.fields.email;
      var token = _this.props.token;
      sendEmailChangeRequest(email.value, token).then(_this.onEmailSent)["catch"](function (e) {
        return _this.onApiCallError(e);
      })["finally"](function () {
        return _this.setState({
          isSubmitting: false
        });
      });
    };

    _this.renderErrorView = function (onRetryConfirmation) {
      return /*#__PURE__*/React.createElement(Flex, {
        flexDirection: "column",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(TitleStart$2, null, /*#__PURE__*/React.createElement(PageTitle$1, null, "N\xE3o foi poss\xEDvel confirmar seu e-mail")), /*#__PURE__*/React.createElement(Description$i, {
        fontWeight: 400
      }, /*#__PURE__*/React.createElement(Subtitle, null, "Para seguran\xE7a da sua conta, a confirma\xE7\xE3o enviada por e-mail possui validade.")), /*#__PURE__*/React.createElement(DescriptionWrapper$1, {
        fontWeight: 400
      }, /*#__PURE__*/React.createElement(Subtitle, null, "Por favor, tente novamente!")), /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        size: "large",
        onClick: onRetryConfirmation
      }, "Tentar novamente"));
    };

    _this.onEmailSent = function () {
      var email = _this.state.fields.email;
      lurker$F.viewMessageEvt('success');

      _this.setState({
        showMailSentModal: true
      });

      if (_this.props.onEmailSent) {
        _this.props.onEmailSent(email.value);
      }
    };

    _this.changeMailCancel = function (onClose) {
      return function () {
        lurker$F.clickEvt('cancel_link');

        if (onClose && typeof onClose === 'function') {
          onClose();
        }
      };
    };

    _this.showError = function (error, extra) {
      var _extends2;

      return _this.setState(_extends({}, errors$b, extra, (_extends2 = {}, _extends2[error] = true, _extends2)));
    };

    _this.showEmailAlreadyExistsError = function () {
      var fields = _this.state.fields;
      fields.email.msg = emailAlreadyExists();
      fields.email.valid = false;

      _this.setState({
        fields: fields
      });
    };

    _this.onApiCallError = function (error) {
      if (error === void 0) {
        error = {};
      }

      if (_this.props.onError) {
        _this.props.onError();
      }

      var _error = error,
          _error$response = _error.response,
          response = _error$response === void 0 ? {} : _error$response;

      if (response.status === 401) {
        lurker$F.viewMessageEvt('error', {
          accounts_reason: 'unauthorized',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else if (response.status === 403) {
        lurker$F.viewMessageEvt('error', {
          accounts_reason: 'email_in_blacklist',
          accounts_status_code: response.status
        });

        _this.showError('showEmailInBlackListError');
      } else if (response.status === 429) {
        lurker$F.viewMessageEvt('error', {
          accounts_reason: 'rate_limit_exceeded',
          accounts_status_code: response.status
        });

        _this.showError('showRateLimitError');
      } else if (response.status === 409) {
        lurker$F.viewMessageEvt('error', {
          accounts_reason: 'email_already_exists',
          accounts_status_code: response.status
        });

        _this.showEmailAlreadyExistsError();
      } else if (response.status === 404 && response.data.message === 'INVALID_TOKEN') {
        lurker$F.viewMessageEvt('error', {
          accounts_reason: 'invalid_token',
          accounts_status_code: response.status
        });

        _this.showError('showInvalidTokenError');
      } else if (response.status) {
        lurker$F.viewMessageEvt('error', {
          accounts_reason: 'unexpected_status_code',
          accounts_status_code: response.status
        });

        _this.showError('showGenericError');
      } else {
        lurker$F.viewMessageEvt('error', {
          accounts_reason: 'unexpected_error',
          accounts_error_message: error && error.message || 'unknown'
        });

        _this.showError('showGenericError');
      }

      behaviors.scrollToTop();
    };

    _this.closeModal = function () {
      _this.setState({
        showMailSentModal: false
      });
    };

    _this.state = _extends({}, errors$b, {
      isSubmitting: false,
      showMailSentModal: false,
      loading: true,
      validators: {
        email: {
          action: isValidEmail,
          message: defaultEmailErrorMsg$6
        }
      },
      fields: {
        email: {
          value: '',
          pristine: true,
          valid: false
        }
      }
    });
    return _this;
  }

  var _proto = EmailChangeSendMailTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    lurker$F.pageLoadEvt();
    validateConfirmationToken(this.props.token).then(function (isConfirmationTokenValid) {
      _this2.setState({
        showInvalidTokenError: !isConfirmationTokenValid
      });
    })["catch"](function () {
      return _this2.setState({
        showInvalidTokenError: true
      });
    })["finally"](function () {
      return _this2.setState({
        loading: false
      });
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state = this.state,
        showGenericError = _this$state.showGenericError,
        showEmailInBlackListError = _this$state.showEmailInBlackListError,
        showInvalidTokenError = _this$state.showInvalidTokenError,
        showMailSentModal = _this$state.showMailSentModal,
        loading = _this$state.loading,
        isSubmitting = _this$state.isSubmitting,
        email = _this$state.fields.email;
    var onCancel = this.props.onCancel;
    var emailHasError = !email.valid && !email.pristine;

    if (loading) {
      return /*#__PURE__*/React.createElement(LoadingBackdrop, null);
    }

    if (showInvalidTokenError) {
      return this.renderErrorView(onCancel);
    }

    return /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(CenterWrapper, null, /*#__PURE__*/React.createElement(MailIcon, null)), /*#__PURE__*/React.createElement(TitleStart$2, null, /*#__PURE__*/React.createElement(PageTitle$1, null, "Altera\xE7\xE3o de e-mail")), /*#__PURE__*/React.createElement(Description$i, null, /*#__PURE__*/React.createElement(Subtitle, null, "Cadastre o e-mail que voc\xEA costuma usar.")), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgStartView$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel continuar com a altera\xE7\xE3o de e-mail. Por favor, tente novamente mais tarde."
    })), showEmailInBlackListError && /*#__PURE__*/React.createElement(ErrorMsgStartView$1, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "Este e-mail n\xE3o pode ser utilizado."
    })), /*#__PURE__*/React.createElement(PageForm$a, {
      method: "POST",
      onSubmit: this.handleSubmit,
      noValidate: true
    }, /*#__PURE__*/React.createElement(MailCheckFormItemWrapper$1, null, /*#__PURE__*/React.createElement(DsMailCheckFormItem, {
      labelweight: "600",
      onChange: function onChange(event) {
        return _this3.onEmailChange(event);
      },
      onBlur: function onBlur(event) {
        return _this3.onEmailBlur(event);
      },
      error: email.msg,
      hasError: emailHasError,
      inputRef: function inputRef(x) {
        _this3.inputs.email = x;
      },
      disabled: isSubmitting,
      label: "Novo e-mail",
      tip: "Enviaremos um e-mail de ativa\xE7\xE3o.",
      value: email.value
    })), /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      disabled: isSubmitting || !email.valid,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, "Solicitar altera\xE7\xE3o"), /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      marginTop: "--spacing-2",
      size: "small",
      variant: "link-button",
      onClick: this.changeMailCancel(onCancel)
    }, "Cancelar")), /*#__PURE__*/React.createElement(EmailChangeActivationSentModal, {
      onClose: this.closeModal,
      email: email.value,
      open: showMailSentModal
    }));
  };

  return EmailChangeSendMailTemplate;
}(BaseForm);

EmailChangeSendMailTemplate.propTypes = {
  onEmailSent: PropTypes__default.func,
  onCancel: PropTypes__default.func,
  onForgotPassword: PropTypes__default.func,
  token: PropTypes__default.string
};

var _templateObject$3a, _templateObject2$2t, _templateObject3$1N;
var CustomPaper$2 = styled(Paper$1)(_templateObject$3a || (_templateObject$3a = _taggedTemplateLiteralLoose(["\n  padding: 32px 64px;\n"])));
var ContentWrapper$b = styled(View$1)(_templateObject2$2t || (_templateObject2$2t = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: 64px auto;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.small(_templateObject3$1N || (_templateObject3$1N = _taggedTemplateLiteralLoose(["\n    margin-top: 24px;\n    margin-bottom: 24px;\n    margin-left: 0px;\n    margin-right: 0px;\n  "]))));
var EmailChangeSendMailPage = function EmailChangeSendMailPage(_ref) {
  var onCancel = _ref.onCancel,
      onEmailSent = _ref.onEmailSent,
      token = _ref.token;
  return /*#__PURE__*/React.createElement(ContentWrapper$b, null, /*#__PURE__*/React.createElement(CustomPaper$2, null, /*#__PURE__*/React.createElement(EmailChangeSendMailTemplate, {
    onEmailSent: onEmailSent,
    token: token,
    onCancel: onCancel
  })));
};
EmailChangeSendMailPage.propTypes = {
  onEmailSent: PropTypes__default.func,
  token: PropTypes__default.string,
  onCancel: PropTypes__default.func
};

var API_ENDPOINT$i = function API_ENDPOINT(path) {
  return "/reactivate/v1/" + path;
};

var sendPinCode$1 = function sendPinCode(email) {
  return axios.post(API_ENDPOINT$i('pincode/send'), {
    email: email,
    platform: platform
  }).then(function (response) {
    return response.data;
  });
};
var validatePinCode = function validatePinCode(token, pincode) {
  return axios.post(API_ENDPOINT$i('pincode/validate'), {
    token: token,
    pincode: pincode,
    platform: platform
  }).then(function (response) {
    return response.data;
  });
};
var reactivateAccount = function reactivateAccount(token, password) {
  return axios.post(API_ENDPOINT$i('change-password'), {
    token: token,
    password: password,
    platform: platform
  }).then(function (response) {
    return response.data;
  });
};

var _templateObject$3b, _templateObject2$2u;
var lurker$G = new Lurker('account_reactivation_change_password');
var secureStorage$4 = new SecureStorage('account_reactivation_change_password');
var smartLock$5 = new SmartLock('account_reactivation_change_password');
var ErrorMsgWrapper$f = styled(View$1)(_templateObject$3b || (_templateObject$3b = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));

var getPasswordExtraData$4 = function getPasswordExtraData(key, password) {
  var field = {};
  var passwordLevel = password.level;

  if (passwordLevel === -1) {
    field[key] = 'sequential';
  } else if (passwordLevel === 1 || passwordLevel === 2) {
    field[key] = 'weak';
  } else if (passwordLevel === 3) {
    field[key] = 'good';
  } else if (passwordLevel === 4) {
    field[key] = 'strong';
  }

  return field;
};

var errors$c = {
  showInvalidTokenError: false,
  showAccountNotFoundError: false,
  showAccountNotInactiveError: false,
  showSamePasswordError: false,
  showInvalidCredentialsError: false,
  showGenericError: false,
  showRateLimitError: false
};
var Description$j = styled(View$1)(_templateObject2$2u || (_templateObject2$2u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding-top: 16px;\n  padding-bottom: 24px;\n"])));

var renderDescription$1 = function renderDescription() {
  return /*#__PURE__*/React.createElement(Description$j, null, /*#__PURE__*/React.createElement(Subtitle, null, "Para proteger sua conta, crie uma nova senha."), /*#__PURE__*/React.createElement(Subtitle, null, "Quanto mais forte, mais segura."));
};

var AccountReactivationChangePasswordTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountReactivationChangePasswordTemplate, _React$Component);

  function AccountReactivationChangePasswordTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onGenericError = function (error) {
      if (error === void 0) {
        error = {};
      }

      var _error = error,
          _error$response = _error.response,
          _error$response2 = _error$response === void 0 ? {} : _error$response,
          status = _error$response2.status,
          _error$response2$data = _error$response2.data,
          _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
          message = _error$response2$data2.message,
          _error$message = _error.message,
          exceptionMessage = _error$message === void 0 ? 'unknown' : _error$message;

      if (_this.props.onError) {
        _this.props.onError();
      }

      if (status === 429) return _this.handle429();
      if (status) return _this.handleError(status, message);
      return _this.handleUnexpectedError(exceptionMessage);
    };

    _this.handle429 = function () {
      _this.handleExpectedStatusCode(429, 'rate_limit_exceeded', 'showRateLimitError');
    };

    _this.handleError = function (status, message) {
      switch (message) {
        case 'ACCOUNT_NOT_FOUND':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showAccountNotFoundError');

          break;

        case 'ACCOUNT_NOT_INACTIVE':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showAccountNotInactiveError');

          break;

        case 'INVALID_CREDENTIALS':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showInvalidCredentialsError');

          break;

        case 'INVALID_TOKEN':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showInvalidTokenError');

          break;

        case 'SAME_PASSWORD':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showSamePasswordError');

          break;

        default:
          _this.handleUnexpectedStatusCode(status, message);

      }
    };

    _this.handleExpectedStatusCode = function (status, message, error) {
      lurker$G.viewMessageEvt('error', {
        accounts_reason: message,
        accounts_status_code: status
      });

      _this.showError(error);
    };

    _this.handleUnexpectedStatusCode = function (status, message) {
      if (message === void 0) {
        message = 'unknown';
      }

      lurker$G.viewMessageEvt('error', {
        accounts_reason: 'unexpected_status_code',
        accounts_status_code: status,
        accounts_error_message: message.toLowerCase()
      });

      _this.showError('showGenericError');
    };

    _this.handleUnexpectedError = function (message) {
      if (message === void 0) {
        message = 'unknown';
      }

      lurker$G.viewMessageEvt('error', {
        accounts_reason: 'unexpected_error',
        accounts_error_message: message
      });

      _this.showError('showGenericError');
    };

    _this.showError = function (error) {
      var _extends2;

      _this.setState(_extends({}, errors$c, (_extends2 = {}, _extends2[error] = true, _extends2)));
    };

    _this.handleSubmit = function (_ref) {
      var password = _ref.password;
      var _this$props = _this.props,
          token = _this$props.token,
          onSuccess = _this$props.onSuccess,
          email = _this$props.email;

      _this.setState(_extends({}, errors$c));

      if (_this.props.onSubmit) {
        _this.props.onSubmit();
      }

      return reactivateAccount(token, password.value).then(function (data) {
        try {
          var _temp3 = function _temp3() {
            if (onSuccess) {
              onSuccess(data);
            }
          };

          lurker$G.viewMessageEvt('success', _extends({}, getPasswordExtraData$4('password_strength', password)));

          var _temp4 = function () {
            if (email) {
              return Promise.resolve(smartLock$5.saveCredential(email, password.value)).then(function () {
                return Promise.resolve(secureStorage$4.saveCredential(email, password.value)).then(function () {});
              });
            }
          }();

          return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
        } catch (e) {
          return Promise.reject(e);
        }
      })["catch"](_this.onGenericError);
    };

    _this.renderError = function () {
      var _this$props2 = _this.props,
          email = _this$props2.email,
          onReactivateClick = _this$props2.onReactivateClick,
          onRegisterClick = _this$props2.onRegisterClick,
          onLoginClick = _this$props2.onLoginClick;
      var _this$state = _this.state,
          showInvalidTokenError = _this$state.showInvalidTokenError,
          showAccountNotFoundError = _this$state.showAccountNotFoundError,
          showAccountNotInactiveError = _this$state.showAccountNotInactiveError,
          showSamePasswordError = _this$state.showSamePasswordError,
          showInvalidCredentialsError = _this$state.showInvalidCredentialsError,
          showGenericError = _this$state.showGenericError,
          showRateLimitError = _this$state.showRateLimitError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showInvalidTokenError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$f, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        errorAction: function errorAction() {
          return onReactivateClick(email);
        },
        text: "Sua sess\xE3o expirou.",
        info: "Quer reativar sua conta? ",
        linkText: "Tente novamente."
      })), showAccountNotFoundError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$f, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showAccountNotFoundError: true,
        errorAction: onRegisterClick,
        text: "N\xE3o existe uma conta com este e-mail."
      })), showAccountNotInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$f, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        errorAction: onLoginClick,
        text: "Essa conta j\xE1 est\xE1 ativa.",
        linkText: "Acesse a sua conta."
      })), showSamePasswordError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$f, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "Digite uma senha diferente da senha atual."
      })), showInvalidCredentialsError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$f, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel acessar sua conta."
      })), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$f, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel salvar sua nova senha."
      })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$f, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: false,
        text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
      })));
    };

    _this.state = _extends({}, errors$c);
    return _this;
  }

  var _proto = AccountReactivationChangePasswordTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$G.pageLoadEvt();
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        passwordSecurityVersion = _this$props3.passwordSecurityVersion,
        showPasswodConfirmationInput = _this$props3.showPasswodConfirmationInput;
    return /*#__PURE__*/React.createElement(ChangePasswordBaseTemplate, {
      buttonText: "Salvar nova senha",
      lurker: lurker$G,
      onSubmit: this.handleSubmit,
      passwordSecurityVersion: passwordSecurityVersion,
      renderError: this.renderError,
      renderTitle: renderDescription$1,
      showPasswodConfirmationInput: showPasswodConfirmationInput
    });
  };

  return AccountReactivationChangePasswordTemplate;
}(React.Component);

AccountReactivationChangePasswordTemplate.defaultProps = {
  showPasswodConfirmationInput: true
};
AccountReactivationChangePasswordTemplate.propTypes = {
  email: PropTypes__default.string,
  onError: PropTypes__default.func,
  onLoginClick: PropTypes__default.isRequired,
  onReactivateClick: PropTypes__default.isRequired,
  onRegisterClick: PropTypes__default.isRequired,
  onSubmit: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  showPasswodConfirmationInput: PropTypes__default.bool,
  token: PropTypes__default.string
};

var _templateObject$3c, _templateObject2$2v;
var ContentWrapper$c = styled(View$1)(_templateObject$3c || (_templateObject$3c = _taggedTemplateLiteralLoose(["\n  padding: 24px 16px;\n  ", "\n"])), mediaQuery.desktop(_templateObject2$2v || (_templateObject2$2v = _taggedTemplateLiteralLoose(["\n    padding: 24px 56px;\n  "]))));

var AccountReactivationChangePasswordPage = function AccountReactivationChangePasswordPage(_ref) {
  var email = _ref.email,
      onError = _ref.onError,
      onLoginClick = _ref.onLoginClick,
      onReactivateClick = _ref.onReactivateClick,
      onRegisterClick = _ref.onRegisterClick,
      onSubmit = _ref.onSubmit,
      onSuccess = _ref.onSuccess,
      passwordSecurityVersion = _ref.passwordSecurityVersion,
      token = _ref.token;
  return /*#__PURE__*/React.createElement(ContentWrapper$c, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Altere sua senha"
  }), /*#__PURE__*/React.createElement(AccountReactivationChangePasswordTemplate, {
    email: email,
    onError: onError,
    onLoginClick: onLoginClick,
    onReactivateClick: onReactivateClick,
    onRegisterClick: onRegisterClick,
    onSubmit: onSubmit,
    onSuccess: onSuccess,
    passwordSecurityVersion: passwordSecurityVersion,
    token: token
  }));
};

AccountReactivationChangePasswordPage.propTypes = {
  email: PropTypes__default.string.isRequired,
  onError: PropTypes__default.func,
  onLoginClick: PropTypes__default.isRequired,
  onReactivateClick: PropTypes__default.isRequired,
  onRegisterClick: PropTypes__default.isRequired,
  onSubmit: PropTypes__default.func,
  onSuccess: PropTypes__default.func.isRequired,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  token: PropTypes__default.string.isRequired
};

var _templateObject$3d;
var lurker$H = new Lurker('account_reactivation_check_pincode');
var ErrorMsgWrapper$g = styled(View$1)(_templateObject$3d || (_templateObject$3d = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n  text-align: left;\n  width: 100%;\n"])));
var errors$d = {
  showAccountNotFoundError: false,
  showAccountNotInactiveError: false,
  showGenericError: false,
  showInvalidPinCodeError: false,
  showInvalidTokenError: false,
  showRateLimitError: false,
  showResendCodeError: false
};

var AccountReactivationCheckPinCodeTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountReactivationCheckPinCodeTemplate, _React$Component);

  function AccountReactivationCheckPinCodeTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onGenericError = function (error, eventName) {
      if (error === void 0) {
        error = {};
      }

      if (eventName === void 0) {
        eventName = 'error';
      }

      var _error = error,
          _error$response = _error.response,
          _error$response2 = _error$response === void 0 ? {} : _error$response,
          status = _error$response2.status,
          _error$response2$data = _error$response2.data,
          _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
          message = _error$response2$data2.message,
          _error$message = _error.message,
          exceptionMessage = _error$message === void 0 ? 'unknown' : _error$message;

      var genericError = eventName === 'error' ? 'showGenericError' : 'showResendCodeError';
      if (status === 429) return _this.handle429(eventName);
      if (status) return _this.handleError(eventName, status, message, genericError);
      return _this.handleUnexpectedError(eventName, exceptionMessage, genericError);
    };

    _this.handle429 = function (eventName) {
      _this.handleExpectedStatusCode(eventName, 429, 'rate_limit_exceeded', 'showRateLimitError');
    };

    _this.handleError = function (eventName, status, message, genericError) {
      if (message === void 0) {
        message = 'unexpected_401_message';
      }

      switch (message) {
        case 'ACCOUNT_NOT_FOUND':
          _this.handleExpectedStatusCode(eventName, status, message.toLowerCase(), 'showAccountNotFoundError');

          break;

        case 'ACCOUNT_NOT_INACTIVE':
          _this.handleExpectedStatusCode(eventName, status, message.toLowerCase(), 'showAccountNotInactiveError');

          break;

        case 'INVALID_CODE':
          _this.handleExpectedStatusCode(eventName, status, message.toLowerCase(), 'showInvalidPinCodeError');

          break;

        case 'INVALID_TOKEN':
          _this.handleExpectedStatusCode(eventName, status, message.toLowerCase(), 'showInvalidTokenError');

          break;

        default:
          _this.handleUnexpectedStatusCode(eventName, status, message, genericError);

      }
    };

    _this.handleExpectedStatusCode = function (eventName, status, message, error) {
      lurker$H.viewMessageEvt(eventName, {
        accounts_reason: message,
        accounts_status_code: status
      });

      _this.showError(error);
    };

    _this.handleUnexpectedStatusCode = function (eventName, status, message, genericError) {
      lurker$H.viewMessageEvt(eventName, {
        accounts_reason: 'unexpected_status_code',
        accounts_status_code: status,
        accounts_error_message: message && typeof message === 'string' ? "" + message.toLowerCase() : 'unknown'
      });

      _this.showError(genericError);
    };

    _this.handleUnexpectedError = function (eventName, message, genericError) {
      if (message === void 0) {
        message = 'unknown';
      }

      lurker$H.viewMessageEvt(eventName, {
        accounts_reason: 'unexpected_error',
        accounts_error_message: message
      });

      _this.showError(genericError);
    };

    _this.handleSubmit = function (pincode) {
      var onSuccess = _this.props.onSuccess;
      var token = _this.state.token;
      lurker$H.clickEvt('check_pincode');

      _this.setState(_extends({}, errors$d));

      return validatePinCode(token, pincode).then(function (_ref) {
        var changePasswordToken = _ref.token;
        lurker$H.viewMessageEvt('success');

        if (typeof onSuccess === 'function') {
          onSuccess(changePasswordToken);
        }
      })["catch"](_this.onGenericError);
    };

    _this.handleResendPinCode = function () {
      var _this$props = _this.props,
          email = _this$props.email,
          onResend = _this$props.onResend;
      lurker$H.clickEvt('resend_pincode');

      _this.setState(_extends({}, errors$d));

      return sendPinCode$1(email).then(function () {
        lurker$H.viewMessageEvt('resend_pincode_success');

        if (typeof onResend === 'function') {
          onResend();
        }
      })["catch"](function (error) {
        _this.onGenericError(error, 'resend_pincode_error');

        throw error;
      });
    };

    _this.showError = function (error) {
      var _extends2;

      _this.setState(_extends({}, errors$d, (_extends2 = {}, _extends2[error] = true, _extends2)));
    };

    _this.renderError = function () {
      var _this$props2 = _this.props,
          email = _this$props2.email,
          onReactivateClick = _this$props2.onReactivateClick,
          onRegisterClick = _this$props2.onRegisterClick,
          onLoginClick = _this$props2.onLoginClick;
      var _this$state = _this.state,
          showAccountNotFoundError = _this$state.showAccountNotFoundError,
          showAccountNotInactiveError = _this$state.showAccountNotInactiveError,
          showGenericError = _this$state.showGenericError,
          showInvalidPinCodeError = _this$state.showInvalidPinCodeError,
          showInvalidTokenError = _this$state.showInvalidTokenError,
          showRateLimitError = _this$state.showRateLimitError,
          showResendCodeError = _this$state.showResendCodeError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$g, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel validar seu c\xF3digo. Por favor, tente novamente."
      })), showResendCodeError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$g, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel reenviar o c\xF3digo. Por favor, tente novamente."
      })), showInvalidTokenError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$g, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        errorAction: function errorAction() {
          return onReactivateClick(email);
        },
        text: "Sua sess\xE3o expirou.",
        info: "Quer reativar sua conta? ",
        linkText: "Tente novamente."
      })), showAccountNotFoundError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$g, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showAccountNotFoundError: true,
        errorAction: onRegisterClick,
        text: "N\xE3o existe uma conta com este e-mail."
      })), showAccountNotInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$g, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        errorAction: onLoginClick,
        text: "Essa conta j\xE1 est\xE1 ativa.",
        linkText: "Acesse a sua conta."
      })), showInvalidPinCodeError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$g, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "C\xF3digo inv\xE1lido! Confira o n\xFAmero que enviamos por e-mail e tente novamente."
      })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$g, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: false,
        text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
      })));
    };

    var _token = props.token;
    _this.state = _extends({}, errors$d, {
      token: _token
    });
    return _this;
  }

  var _proto = AccountReactivationCheckPinCodeTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$H.pageLoadEvt();
  };

  _proto.render = function render() {
    var showInvalidPinCodeError = this.state.showInvalidPinCodeError;
    var _this$props3 = this.props,
        email = _this$props3.email,
        onSwitchEmail = _this$props3.onSwitchEmail;
    return /*#__PURE__*/React.createElement(PinCodeValidationBaseTemplate, {
      email: email,
      hasError: showInvalidPinCodeError,
      renderError: this.renderError,
      onSwitchEmail: onSwitchEmail,
      onSubmit: this.handleSubmit,
      onResend: this.handleResendPinCode
    });
  };

  return AccountReactivationCheckPinCodeTemplate;
}(React.Component);

AccountReactivationCheckPinCodeTemplate.propTypes = {
  email: PropTypes__default.string.isRequired,
  onLoginClick: PropTypes__default.isRequired,
  onReactivateClick: PropTypes__default.isRequired,
  onRegisterClick: PropTypes__default.isRequired,
  onResend: PropTypes__default.func,
  onSuccess: PropTypes__default.func.isRequired,
  onSwitchEmail: PropTypes__default.func,
  token: PropTypes__default.string.isRequired
};

var _templateObject$3e, _templateObject2$2w;
var ContentWrapper$d = styled(View$1)(_templateObject$3e || (_templateObject$3e = _taggedTemplateLiteralLoose(["\n  padding: 24px 16px;\n  ", "\n"])), mediaQuery.desktop(_templateObject2$2w || (_templateObject2$2w = _taggedTemplateLiteralLoose(["\n    padding: 24px 56px;\n  "]))));

var AccountReactivationCheckPinCodePage = function AccountReactivationCheckPinCodePage(_ref) {
  var email = _ref.email,
      onLoginClick = _ref.onLoginClick,
      onReactivateClick = _ref.onReactivateClick,
      onRegisterClick = _ref.onRegisterClick,
      onResend = _ref.onResend,
      onSuccess = _ref.onSuccess,
      onSwitchEmail = _ref.onSwitchEmail,
      token = _ref.token;
  return /*#__PURE__*/React.createElement(ContentWrapper$d, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Confirme a reativa\xE7\xE3o"
  }), /*#__PURE__*/React.createElement(AccountReactivationCheckPinCodeTemplate, {
    email: email,
    onLoginClick: onLoginClick,
    onReactivateClick: onReactivateClick,
    onRegisterClick: onRegisterClick,
    onResend: onResend,
    onSuccess: onSuccess,
    onSwitchEmail: onSwitchEmail,
    token: token
  }));
};

AccountReactivationCheckPinCodePage.propTypes = {
  email: PropTypes__default.string.isRequired,
  onLoginClick: PropTypes__default.isRequired,
  onReactivateClick: PropTypes__default.isRequired,
  onRegisterClick: PropTypes__default.isRequired,
  onResend: PropTypes__default.func,
  onSuccess: PropTypes__default.func.isRequired,
  onSwitchEmail: PropTypes__default.func,
  token: PropTypes__default.string.isRequired
};

var _templateObject$3f;
var lurker$I = new Lurker('account_reactivation_send_pincode');
var ErrorMsgWrapper$h = styled(View$1)(_templateObject$3f || (_templateObject$3f = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var errors$e = {
  showAccountNotFoundError: false,
  showAccountNotInactiveError: false,
  showAccountReactivationReasonError: false,
  showGenericError: false,
  showRateLimitError: false
};

var AccountReactivationSendEmailTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountReactivationSendEmailTemplate, _React$Component);

  function AccountReactivationSendEmailTemplate(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onSubmit = function (email) {
      var onSuccess = _this.props.onSuccess;

      _this.setState(_extends({}, errors$e));

      return sendPinCode$1(email).then(function (_ref) {
        var token = _ref.token;
        lurker$I.viewMessageEvt('success');

        if (typeof onSuccess === 'function') {
          onSuccess(email, token);
        }
      })["catch"](_this.onError);
    };

    _this.onError = function (error) {
      if (error === void 0) {
        error = {};
      }

      var _error = error,
          _error$response = _error.response,
          _error$response2 = _error$response === void 0 ? {} : _error$response,
          status = _error$response2.status,
          _error$response2$data = _error$response2.data,
          _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
          message = _error$response2$data2.message,
          _error$message = _error.message,
          exceptionMessage = _error$message === void 0 ? 'unknown' : _error$message;

      if (status === 429) return _this.handle429();
      if (status) return _this.handleError(status, message);
      return _this.handleUnexpectedError(exceptionMessage);
    };

    _this.handle429 = function () {
      _this.handleExpectedStatusCode(429, 'rate_limit_exceeded', 'showRateLimitError');
    };

    _this.handleError = function (status, message) {
      switch (message) {
        case 'ACCOUNT_NOT_FOUND':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showAccountNotFoundError');

          break;

        case 'ACCOUNT_NOT_INACTIVE':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showAccountNotInactiveError');

          break;

        case 'ACCOUNT_REACTIVATION_REASON':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showAccountReactivationReasonError');

          break;

        case 'ACCOUNT_DISABLED':
          _this.handleExpectedStatusCode(status, message.toLowerCase(), 'showAccountReactivationReasonError');

          break;

        default:
          _this.handleUnexpectedStatusCode(status, message);

      }
    };

    _this.handleExpectedStatusCode = function (status, message, error) {
      lurker$I.viewMessageEvt('error', {
        accounts_reason: message,
        accounts_status_code: status
      });

      _this.showError(error);
    };

    _this.handleUnexpectedStatusCode = function (status, message) {
      if (message === void 0) {
        message = 'unknown';
      }

      lurker$I.viewMessageEvt('error', {
        accounts_reason: 'unexpected_status_code',
        accounts_status_code: status,
        accounts_error_message: message.toLowerCase()
      });

      _this.showError('showGenericError');
    };

    _this.handleUnexpectedError = function (message) {
      if (message === void 0) {
        message = 'unknown';
      }

      lurker$I.viewMessageEvt('error', {
        accounts_reason: 'unexpected_error',
        accounts_error_message: message
      });

      _this.showError('showGenericError');
    };

    _this.showError = function (error) {
      var _extends2;

      _this.setState(_extends({}, errors$e, (_extends2 = {}, _extends2[error] = true, _extends2)));
    };

    _this.renderError = function () {
      var _this$props = _this.props,
          onLoginClick = _this$props.onLoginClick,
          onRegisterClick = _this$props.onRegisterClick;
      var _this$state = _this.state,
          showAccountNotFoundError = _this$state.showAccountNotFoundError,
          showAccountNotInactiveError = _this$state.showAccountNotInactiveError,
          showAccountReactivationReasonError = _this$state.showAccountReactivationReasonError,
          showGenericError = _this$state.showGenericError,
          showRateLimitError = _this$state.showRateLimitError;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showAccountNotFoundError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$h, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showAccountNotFoundError: true,
        errorAction: onRegisterClick,
        text: "N\xE3o existe uma conta com este e-mail."
      })), showAccountNotInactiveError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$h, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        errorAction: onLoginClick,
        text: "Essa conta j\xE1 est\xE1 ativa.",
        linkText: "Acesse a sua conta."
      })), showAccountReactivationReasonError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$h, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "Conta temporariamente bloqueada."
      })), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$h, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        text: "N\xE3o foi poss\xEDvel solicitar a reativa\xE7\xE3o de sua conta."
      })), showRateLimitError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$h, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
        showContactUs: false,
        text: "Voc\xEA excedeu o n\xFAmero de tentativas. Por favor, tente novamente mais tarde."
      })));
    };

    _this.state = _extends({}, errors$e);
    return _this;
  }

  var _proto = AccountReactivationSendEmailTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$I.pageLoadEvt();
  };

  _proto.render = function render() {
    var email = this.props.email;
    return /*#__PURE__*/React.createElement(EmailFormBaseTemplate, {
      buttonText: "Continuar",
      email: email,
      lurker: lurker$I,
      onSubmit: this.onSubmit,
      renderError: this.renderError,
      renderTitle: "Que bom que est\xE1 de volta. Enviaremos um e-mail para ajudar voc\xEA a reativar sua conta.",
      submitEventName: "send_email"
    });
  };

  return AccountReactivationSendEmailTemplate;
}(React.Component);

AccountReactivationSendEmailTemplate.propTypes = {
  email: PropTypes__default.string,
  onLoginClick: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onSuccess: PropTypes__default.func.isRequired
};

var _templateObject$3g, _templateObject2$2x;
var ContentWrapper$e = styled(View$1)(_templateObject$3g || (_templateObject$3g = _taggedTemplateLiteralLoose(["\n  padding: 24px 16px;\n  ", "\n"])), mediaQuery.desktop(_templateObject2$2x || (_templateObject2$2x = _taggedTemplateLiteralLoose(["\n    padding: 24px 56px;\n  "]))));

var AccountReactivationSendEmailPage = function AccountReactivationSendEmailPage(_ref) {
  var email = _ref.email,
      onSuccess = _ref.onSuccess,
      onRegisterClick = _ref.onRegisterClick,
      onLoginClick = _ref.onLoginClick;
  return /*#__PURE__*/React.createElement(ContentWrapper$e, null, /*#__PURE__*/React.createElement(logoTitle, {
    title: "Reativa\xE7\xE3o da conta"
  }), /*#__PURE__*/React.createElement(AccountReactivationSendEmailTemplate, {
    email: email,
    onSuccess: onSuccess,
    onRegisterClick: onRegisterClick,
    onLoginClick: onLoginClick
  }));
};

AccountReactivationSendEmailPage.propTypes = {
  email: PropTypes__default.string,
  onLoginClick: PropTypes__default.func,
  onRegisterClick: PropTypes__default.func,
  onSuccess: PropTypes__default.func.isRequired
};

var _templateObject$3h, _templateObject2$2y, _templateObject3$1O, _templateObject4$1f;
var lurker$J = new Lurker('account_reactivation_confirmation');
var CheckCircleWrapper$1 = styled(View$1)(_templateObject$3h || (_templateObject$3h = _taggedTemplateLiteralLoose(["\n  margin-bottom: 34.5px;\n  margin-top: 26.5px;\n"])));
var EmailChipWrapper$6 = styled(View$1)(_templateObject2$2y || (_templateObject2$2y = _taggedTemplateLiteralLoose(["\n  justify-content: center;\n  margin-bottom: 16px;\n"])));
var Description$k = styled(View$1)(_templateObject3$1O || (_templateObject3$1O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 42px;\n"])));
var Content$1z = styled(View$1)(_templateObject4$1f || (_templateObject4$1f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));

var AccountReactivationConfirmationTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountReactivationConfirmationTemplate, _React$Component);

  function AccountReactivationConfirmationTemplate() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = AccountReactivationConfirmationTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$J.pageLoadEvt();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        email = _this$props.email,
        onSuccess = _this$props.onSuccess,
        subtitleText = _this$props.subtitleText;
    return /*#__PURE__*/React.createElement(Content$1z, null, /*#__PURE__*/React.createElement(CheckCircleWrapper$1, null, /*#__PURE__*/React.createElement(CheckCircle, {
      color: "var(--color-feedback-success-medium)",
      size: 36
    })), /*#__PURE__*/React.createElement(Text.TitleMedium, null, "Conta reativada com sucesso!"), /*#__PURE__*/React.createElement(EmailChipWrapper$6, null, /*#__PURE__*/React.createElement(EmailChip, null, email)), /*#__PURE__*/React.createElement(Description$k, null, /*#__PURE__*/React.createElement(Subtitle, null, "Que bom te ver de novo :)"), /*#__PURE__*/React.createElement(Subtitle, null, subtitleText)), /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      size: "large",
      onClick: onSuccess
    }, "Entendi"));
  };

  return AccountReactivationConfirmationTemplate;
}(React.Component);

AccountReactivationConfirmationTemplate.defaultProps = {
  subtitleText: 'Aproveite para atualizar o seu cadastro.'
};
AccountReactivationConfirmationTemplate.propTypes = {
  email: PropTypes__default.string,
  onSuccess: PropTypes__default.func.isRequired,
  subtitleText: PropTypes__default.string
};

var _templateObject$3i, _templateObject2$2z;
var ContentWrapper$f = styled(View$1)(_templateObject$3i || (_templateObject$3i = _taggedTemplateLiteralLoose(["\n  padding: 24px 16px;\n  ", "\n"])), mediaQuery.desktop(_templateObject2$2z || (_templateObject2$2z = _taggedTemplateLiteralLoose(["\n    padding: 24px 56px;\n  "]))));

var AccountReactivationConfirmationPage = function AccountReactivationConfirmationPage(_ref) {
  var email = _ref.email,
      onSuccess = _ref.onSuccess;
  return /*#__PURE__*/React.createElement(ContentWrapper$f, null, /*#__PURE__*/React.createElement(AccountReactivationConfirmationTemplate, {
    email: email,
    onSuccess: onSuccess
  }));
};

AccountReactivationConfirmationPage.propTypes = {
  email: PropTypes__default.string,
  onSuccess: PropTypes__default.func.isRequired
};

var _templateObject$3j, _templateObject2$2A, _templateObject3$1P, _templateObject4$1g, _templateObject5$T;
var Content$1A = styled(View$1)(_templateObject$3j || (_templateObject$3j = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  overflow: hidden;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$2A || (_templateObject2$2A = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4px;\n    margin-bottom: 0;\n  "]))));
var CustomPaper$3 = styled(Paper$1)(_templateObject3$1P || (_templateObject3$1P = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  ", "\n"])), mediaQuery.medium(_templateObject4$1g || (_templateObject4$1g = _taggedTemplateLiteralLoose(["\n    padding: 0;\n  "]))));
var FooterWrapper$a = styled(View$1)(_templateObject5$T || (_templateObject5$T = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var PAGES$1 = {
  SEND_PIN_CODE: 'SendPinCode',
  CHECK_PIN_CODE: 'CheckPinCode',
  CHANGE_PASSWORD: 'ChangePassword',
  CONFIRMATION: 'Confirmation'
};

var isLoading = function isLoading(_ref) {
  var email = _ref.email,
      changePasswordToken = _ref.changePasswordToken,
      checkPinCodeToken = _ref.checkPinCodeToken,
      success = _ref.success;
  return !!email && !changePasswordToken && !checkPinCodeToken && !success;
};

var AccountReactivationStack = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccountReactivationStack, _React$Component);

  function AccountReactivationStack(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onSendPinCodeSuccess = function (email, checkPinCodeToken) {
      var onSendPinCodeSuccess = _this.props.onSendPinCodeSuccess;
      var router = _this.state.router;

      _this.setState({
        checkPinCodeToken: checkPinCodeToken,
        email: email
      });

      _this.showSuccessMessage('E-mail enviado!');

      router.push(PAGES$1.CHECK_PIN_CODE);

      if (typeof onSendPinCodeSuccess === 'function') {
        onSendPinCodeSuccess(email, checkPinCodeToken);
      }
    };

    _this.onCheckPinCodeSuccess = function (changePasswordToken) {
      var onCheckPinCodeSuccess = _this.props.onCheckPinCodeSuccess;
      var _this$state = _this.state,
          router = _this$state.router,
          email = _this$state.email;

      _this.setState({
        changePasswordToken: changePasswordToken
      });

      _this.showSuccessMessage('Código validado com sucesso!');

      router.push(PAGES$1.CHANGE_PASSWORD);

      if (typeof onCheckPinCodeSuccess === 'function') {
        onCheckPinCodeSuccess(email, changePasswordToken);
      }
    };

    _this.onChangePasswordSuccess = function () {
      var onChangePasswordSuccess = _this.props.onChangePasswordSuccess;
      var _this$state2 = _this.state,
          router = _this$state2.router,
          email = _this$state2.email;

      _this.showSuccessMessage('Senha alterada com sucesso!');

      router.push(PAGES$1.CONFIRMATION);

      if (typeof onChangePasswordSuccess === 'function') {
        onChangePasswordSuccess(email);
      }
    };

    _this.onResend = function () {};

    _this.getInitialPage = function (checkPinCodeToken, changePasswordToken, success) {
      if (success) return PAGES$1.CONFIRMATION;
      if (changePasswordToken) return PAGES$1.CHANGE_PASSWORD;
      if (checkPinCodeToken) return PAGES$1.CHECK_PIN_CODE;
      return PAGES$1.SEND_PIN_CODE;
    };

    _this.shouldSendPinCode = function () {
      var _this$state3 = _this.state,
          email = _this$state3.email,
          changePasswordToken = _this$state3.changePasswordToken,
          checkPinCodeToken = _this$state3.checkPinCodeToken,
          success = _this$state3.success;
      return email && !changePasswordToken && !checkPinCodeToken && !success;
    };

    _this.showSuccessMessage = function (successMessage) {
      setTimeout(function () {
        return _this.setState({
          successMessage: successMessage,
          successMessageOpen: true
        });
      }, 100);
    };

    _this.renderSendPinCode = function () {
      var email = _this.state.email;
      var _this$props = _this.props,
          onLoginClick = _this$props.onLoginClick,
          onRegisterClick = _this$props.onRegisterClick;
      return /*#__PURE__*/React.createElement(AccountReactivationSendEmailPage, {
        email: email,
        onLoginClick: onLoginClick,
        onRegisterClick: onRegisterClick,
        onSuccess: _this.onSendPinCodeSuccess
      });
    };

    _this.renderCheckPinCode = function () {
      var _this$state4 = _this.state,
          email = _this$state4.email,
          checkPinCodeToken = _this$state4.checkPinCodeToken;
      var _this$props2 = _this.props,
          onLoginClick = _this$props2.onLoginClick,
          onRegisterClick = _this$props2.onRegisterClick,
          onReactivateClick = _this$props2.onReactivateClick;
      return /*#__PURE__*/React.createElement(AccountReactivationCheckPinCodePage, {
        email: email,
        onLoginClick: onLoginClick,
        onReactivateClick: onReactivateClick,
        onRegisterClick: onRegisterClick,
        onResend: _this.onResend,
        onSuccess: _this.onCheckPinCodeSuccess,
        token: checkPinCodeToken
      });
    };

    _this.renderChangePassword = function () {
      var _this$props3 = _this.props,
          passwordSecurityVersion = _this$props3.passwordSecurityVersion,
          onLoginClick = _this$props3.onLoginClick,
          onRegisterClick = _this$props3.onRegisterClick,
          onReactivateClick = _this$props3.onReactivateClick;
      var _this$state5 = _this.state,
          email = _this$state5.email,
          changePasswordToken = _this$state5.changePasswordToken;
      return /*#__PURE__*/React.createElement(AccountReactivationChangePasswordPage, {
        email: email,
        onLoginClick: onLoginClick,
        onReactivateClick: onReactivateClick,
        onRegisterClick: onRegisterClick,
        onSuccess: _this.onChangePasswordSuccess,
        passwordSecurityVersion: passwordSecurityVersion,
        token: changePasswordToken
      });
    };

    _this.renderConfirmation = function () {
      var onSuccess = _this.props.onSuccess;
      var email = _this.state.email;
      return /*#__PURE__*/React.createElement(AccountReactivationConfirmationPage, {
        email: email,
        onSuccess: onSuccess
      });
    };

    var _email = props.email,
        _checkPinCodeToken = props.checkPinCodeToken,
        _changePasswordToken = props.changePasswordToken,
        _success = props.success;

    var _router = createNewRouter(_this.getInitialPage(_checkPinCodeToken, _changePasswordToken, _success));

    _this.state = {
      changePasswordToken: _changePasswordToken,
      checkPinCodeToken: _checkPinCodeToken,
      email: _email,
      loading: isLoading(props),
      router: _router,
      success: _success
    };
    return _this;
  }

  var _proto = AccountReactivationStack.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _this$state6 = this.state,
        email = _this$state6.email,
        router = _this$state6.router;

    if (this.shouldSendPinCode()) {
      return sendPinCode$1(email).then(function (_ref2) {
        var token = _ref2.token;

        _this2.setState({
          loading: false
        }, function () {
          _this2.onSendPinCodeSuccess(email, token);
        });
      })["catch"](function () {
        _this2.setState({
          loading: false
        }, function () {
          router.push(PAGES$1.SEND_PIN_CODE);
        });
      });
    }

    return null;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state7 = this.state,
        router = _this$state7.router,
        successMessage = _this$state7.successMessage,
        successMessageOpen = _this$state7.successMessageOpen,
        loading = _this$state7.loading;
    return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$1A, null, /*#__PURE__*/React.createElement(CustomPaper$3, null, loading ? /*#__PURE__*/React.createElement(LoadingBackdrop$1, null) : /*#__PURE__*/React.createElement(AccessNavigator, {
      router: router,
      routes: [{
        route: PAGES$1.SEND_PIN_CODE,
        component: this.renderSendPinCode
      }, {
        route: PAGES$1.CHECK_PIN_CODE,
        component: this.renderCheckPinCode
      }, {
        route: PAGES$1.CHANGE_PASSWORD,
        component: this.renderChangePassword
      }, {
        route: PAGES$1.CONFIRMATION,
        component: this.renderConfirmation
      }]
    }), /*#__PURE__*/React.createElement(SuccessMessage, {
      text: successMessage,
      show: successMessageOpen,
      onClose: function onClose() {
        return _this3.setState({
          successMessageOpen: false
        });
      }
    })), /*#__PURE__*/React.createElement(FooterWrapper$a, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))));
  };

  return AccountReactivationStack;
}(React.Component);
AccountReactivationStack.propTypes = {
  changePasswordToken: PropTypes__default.string,
  checkPinCodeToken: PropTypes__default.string,
  email: PropTypes__default.string,
  onChangePasswordSuccess: PropTypes__default.func,
  onCheckPinCodeSuccess: PropTypes__default.func,
  onLoginClick: PropTypes__default.isRequired,
  onReactivateClick: PropTypes__default.isRequired,
  onRegisterClick: PropTypes__default.isRequired,
  onSendPinCodeSuccess: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  passwordSecurityVersion: passwordSecurityVersionPropType,
  success: PropTypes__default.string
};

var _templateObject$3k, _templateObject2$2B, _templateObject3$1Q, _templateObject4$1h, _templateObject5$U;
var lurker$K = new Lurker('signup');
var Content$1B = styled(View$1)(_templateObject$3k || (_templateObject$3k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var PageForm$b = styled(Form)(_templateObject2$2B || (_templateObject2$2B = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"])));
var AskForEmailText = styled(Subtitle)(_templateObject3$1Q || (_templateObject3$1Q = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));
var FacebookConnectedAsWrapper = styled(View$1)(_templateObject4$1h || (_templateObject4$1h = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n"])));
var ErrorMsgWrapper$i = styled(View$1)(_templateObject5$U || (_templateObject5$U = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  margin-right: 0;\n  margin-bottom: 16px;\n  margin-left: 0;\n"])));

var getInvalidFields$3 = function getInvalidFields(fields) {
  var invalidFields = {};
  Object.keys(fields).forEach(function (key) {
    if (!fields[key].valid) invalidFields["invalid_" + key] = true;
  });
  return invalidFields;
};

var normalizedFacebookName = function normalizedFacebookName(facebookName) {
  if (typeof facebookName !== 'string') {
    return '';
  }

  var splitedName = facebookName.split(' ');
  return splitedName.length > 1 ? splitedName[0] + " " + splitedName.pop().substring(0, 1) + "." : facebookName;
};

var ErrorEmailAlreadyExists = function ErrorEmailAlreadyExists(onForgotPassword) {
  return function () {
    return /*#__PURE__*/React.createElement(errorMsgCallout, {
      text: "Este e-mail j\xE1 possui cadastro.",
      linkText: "Esqueceu sua senha?",
      onClick: onForgotPassword
    });
  };
};

var defaultEmailErrorMsg$7 = 'Por favor, insira um endereço de e-mail válido.';

var CompleteFacebookInfoTemplate = /*#__PURE__*/function (_BaseForm) {
  _inheritsLoose(CompleteFacebookInfoTemplate, _BaseForm);

  function CompleteFacebookInfoTemplate(props) {
    var _this;

    _this = _BaseForm.call(this, props) || this;
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.onNicknameChange = _this.onNicknameChange.bind(_assertThisInitialized(_this));
    _this.onEmailChange = _this.onEmailChange.bind(_assertThisInitialized(_this));
    _this.onNicknameBlur = _this.onNicknameBlur.bind(_assertThisInitialized(_this));
    _this.onEmailBlur = _this.onEmailBlur.bind(_assertThisInitialized(_this));
    var value = normalizedFacebookName(props.name);
    _this.state = {
      isSubmitting: false,
      validators: {
        nickname: {
          action: null,
          message: 'Por favor, preencha ao menos 3 caracteres'
        },
        email: {
          action: isValidEmail,
          message: defaultEmailErrorMsg$7
        }
      },
      fields: {
        nickname: {
          valid: !!value,
          pristine: true,
          value: value
        },
        email: {
          valid: false,
          pristine: true,
          value: ''
        }
      }
    };
    return _this;
  }

  var _proto = CompleteFacebookInfoTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    lurker$K.pageLoadEvt();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var name = this.props.name;
    var previousName = prevProps.name;

    if (previousName !== name) {
      var fields = this.state.fields;
      var nickname = fields.nickname;
      var value = normalizedFacebookName(name);
      this.setState({
        fields: _extends({}, fields, {
          nickname: _extends({}, nickname, {
            value: value,
            valid: !!value
          })
        })
      });
    }
  };

  _proto.onNicknameChange = function onNicknameChange(value, valid) {
    this.updateField('nickname', value, valid, true);
  };

  _proto.onNicknameBlur = function onNicknameBlur(value, valid) {
    this.updateField('nickname', value, valid, false);
  };

  _proto.onEmailChange = function onEmailChange(event) {
    var value = event.target.value;
    this.updateField('email', value, null, true);
  };

  _proto.onEmailBlur = function onEmailBlur(event) {
    var value = event.target.value;
    var valid = isValidEmail(value);
    var message = value.length > 0 && !valid ? 'Por favor, insira um endereço de e-mail válido.' : null;
    this.updateField('email', value, valid, false, message);
  };

  _proto.handleSubmit = function handleSubmit(event) {
    try {
      var _this3 = this;

      event.preventDefault();
      return Promise.resolve(_this3.validateBeforeSend()).then(function () {
        lurker$K.clickEvt('facebook');

        _this3.setState({
          isSubmitting: true,
          showGenericError: false
        });

        var fields = _this3.state.fields;

        _this3.checkFormIsValid().then(function () {
          return _this3.doRegister();
        })["catch"](function () {
          lurker$K.viewMessageEvt('error', _extends({
            accounts_reason: 'complete_fb_invalid_fields'
          }, getInvalidFields$3(fields)));
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.doRegister = function doRegister() {
    var _this4 = this;

    var fields = this.state.fields;
    var _this$props = this.props,
        accessToken = _this$props.accessToken,
        onForgotPassword = _this$props.onForgotPassword,
        onError = _this$props.onError,
        onRegisterSuccess = _this$props.onRegisterSuccess;
    var nickname = fields.nickname,
        email = fields.email;

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }

    facebookLoginApiCall(accessToken, email.value, nickname.value).then(function (_ref) {
      var data = _ref.data;

      if (window) {
        var _window2 = window,
            dataLayer = _window2.dataLayer;

        if (dataLayer) {
          dataLayer.push({
            event: 'facebook_signup_success'
          });
        }
      }

      lurker$K.viewMessageEvt('facebook_signup_success');

      if (typeof onRegisterSuccess === 'function') {
        onRegisterSuccess(data);
      }
    })["catch"](function (error) {
      if (typeof onError === 'function') {
        onError();
      }

      var _ref2 = error || {},
          _ref2$response = _ref2.response,
          _ref2$response2 = _ref2$response === void 0 ? {} : _ref2$response,
          status = _ref2$response2.status;

      if (status === 409) {
        lurker$K.viewMessageEvt('error', {
          accounts_reason: 'complete_fb_already_signed_user',
          accounts_status_code: status
        });

        _this4.setState({
          fields: _extends({}, fields, {
            email: _extends({}, email, {
              msg: ErrorEmailAlreadyExists(onForgotPassword),
              valid: false
            })
          })
        });

        return;
      }

      if (status) {
        lurker$K.viewMessageEvt('error', {
          accounts_reason: 'complete_fb_unexpected_status_code',
          accounts_status_code: status
        });
      } else {
        lurker$K.viewMessageEvt('error', {
          accounts_reason: 'complete_fb_unexpected_error',
          accounts_error_message: error && error.message || 'unknown'
        });
      }

      _this4.setState({
        showGenericError: true
      }, behaviors.scrollToTop);
    })["finally"](function () {
      return _this4.setState({
        isSubmitting: false
      });
    });
  };

  _proto.renderNickname = function renderNickname() {
    var _this5 = this;

    var fields = this.state.fields;
    var nickname = fields.nickname;
    var nicknameHasError = !nickname.valid && !nickname.pristine;
    return /*#__PURE__*/React.createElement(NicknameFormItem, {
      onChange: function onChange(value, valid) {
        return _this5.onNicknameChange(value, valid);
      },
      onBlur: function onBlur(value, valid) {
        return _this5.onNicknameBlur(value, valid);
      },
      hasError: nicknameHasError,
      value: nickname.value,
      onSubmitEditing: function onSubmitEditing() {
        return _this5.input.focus();
      }
    });
  };

  _proto.renderEmail = function renderEmail() {
    var _this6 = this;

    var _this$state = this.state,
        fields = _this$state.fields,
        isSubmitting = _this$state.isSubmitting;
    var email = fields.email;
    var emailHasError = !email.valid && !email.pristine;
    return /*#__PURE__*/React.createElement(formItem, {
      label: "E-mail",
      error: email.msg || 'Este campo é obrigatório.',
      tip: "Enviaremos um e-mail de confirma\xE7\xE3o.",
      hasError: emailHasError
    }, /*#__PURE__*/React.createElement(Input$1, {
      maxLength: 80,
      onChange: this.onEmailChange,
      onBlur: this.onEmailBlur,
      value: email.value,
      disabled: isSubmitting,
      keyboardType: "email-address",
      autoCapitalize: "none",
      autoComplete: "email",
      blurOnSubmit: false,
      returnKeyType: "next",
      onSubmitEditing: this.handleSubmit,
      inputRef: function inputRef(x) {
        _this6.input = x;
      }
    }));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        name = _this$props2.name,
        imageUrl = _this$props2.imageUrl,
        userFacebookId = _this$props2.userFacebookId;
    var _this$state2 = this.state,
        showGenericError = _this$state2.showGenericError,
        isSubmitting = _this$state2.isSubmitting;
    return /*#__PURE__*/React.createElement(Content$1B, null, /*#__PURE__*/React.createElement(logoTitle, {
      title: "Calma, falta pouco!"
    }), /*#__PURE__*/React.createElement(FacebookConnectedAsWrapper, null, /*#__PURE__*/React.createElement(facebookConnectedAs, {
      name: name,
      imageUrl: imageUrl || "https://graph.facebook.com/" + userFacebookId + "/picture"
    })), /*#__PURE__*/React.createElement(AskForEmailText, null, "Voc\xEA precisa colocar um e-mail v\xE1lido para completar a sua conta."), showGenericError && /*#__PURE__*/React.createElement(ErrorMsgWrapper$i, null, /*#__PURE__*/React.createElement(GenericErrorBox, {
      text: "N\xE3o foi poss\xEDvel criar sua conta."
    })), /*#__PURE__*/React.createElement(PageForm$b, {
      method: "POST",
      onSubmit: this.handleSubmit
    }, this.renderNickname(), this.renderEmail(), /*#__PURE__*/React.createElement(Button$1, {
      fluid: true,
      size: "large",
      disabled: isSubmitting,
      isLoading: isSubmitting,
      onClick: this.handleSubmit
    }, "Criar conta")));
  };

  return CompleteFacebookInfoTemplate;
}(BaseForm);

CompleteFacebookInfoTemplate.propTypes = {
  accessToken: PropTypes__default.string.isRequired,
  userFacebookId: PropTypes__default.string.isRequired,
  name: PropTypes__default.string.isRequired,
  imageUrl: PropTypes__default.string,
  onRegisterSuccess: PropTypes__default.func.isRequired,
  onForgotPassword: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onError: PropTypes__default.func
};

var _templateObject$3l, _templateObject2$2C, _templateObject3$1R;
var Content$1C = styled(View$1)(_templateObject$3l || (_templateObject$3l = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: auto;\n  margin-top: 64px;\n  margin-bottom: 64px;\n  max-width: 466px;\n  ", "\n"])), mediaQuery.medium(_templateObject2$2C || (_templateObject2$2C = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 4px;\n    margin-bottom: 0;\n  "]))));
var FooterWrapper$b = styled(View$1)(_templateObject3$1R || (_templateObject3$1R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 24px;\n"])));
var CompleteFacebookInfoPage = function CompleteFacebookInfoPage(props) {
  var accessToken = props.accessToken,
      name = props.name,
      onError = props.onError,
      onForgotPassword = props.onForgotPassword,
      onRegisterSuccess = props.onRegisterSuccess,
      onSubmit = props.onSubmit,
      userFacebookId = props.userFacebookId;
  return /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Content$1C, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(CompleteFacebookInfoTemplate, {
    accessToken: accessToken,
    name: name,
    onError: onError,
    onForgotPassword: onForgotPassword,
    onRegisterSuccess: onRegisterSuccess,
    onSubmit: onSubmit,
    userFacebookId: userFacebookId
  })), /*#__PURE__*/React.createElement(FooterWrapper$b, null, /*#__PURE__*/React.createElement(termsAndPrivacyNotice, null))));
};
CompleteFacebookInfoPage.propTypes = {
  onRegisterSuccess: PropTypes__default.func.isRequired,
  onForgotPassword: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  onError: PropTypes__default.func,
  accessToken: PropTypes__default.string,
  name: PropTypes__default.string,
  userFacebookId: PropTypes__default.string
};

var _templateObject$3m, _templateObject2$2D, _templateObject3$1S, _templateObject4$1i, _templateObject5$V, _templateObject6$A;
var ButtonsWrapper$4 = styled.div(_templateObject$3m || (_templateObject$3m = _taggedTemplateLiteralLoose(["\n  margin-top: var(--spacing-stack-xxs);\n  display: flex;\n  justify-content: end;\n  @media screen and (max-width: ", "px) {\n    justify-content: center;\n    flex-direction: column-reverse;\n    align-items: center;\n    flex: 1;\n  }\n"])), breakpoints['mobile']);
var Form$3 = styled.form(_templateObject2$2D || (_templateObject2$2D = _taggedTemplateLiteralLoose([""])));
var ContainerWrapper$4 = styled(Container$7)(_templateObject3$1S || (_templateObject3$1S = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    border: none;\n    padding: 0;\n  }\n"])), breakpoints['mobile']);
var StyledButton$6 = styled(Button)(_templateObject4$1i || (_templateObject4$1i = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin: 0;\n    width: 100%;\n    margin-bottom: var(--spacing-2);\n  }\n"])), breakpoints['mobile']);
var StyledText$3 = styled(Text.BodyMedium)(_templateObject5$V || (_templateObject5$V = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    font-size: var(--font-size-xxs);\n  }\n"])), breakpoints['mobile']);
var WrapperPhoneContainer = styled.div(_templateObject6$A || (_templateObject6$A = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  width: 100%;\n  color: var(--color-neutral-darkest);\n  background-color: var(--color-neutral-80);\n  padding: var(--spacing-2);\n  margin-bottom: var(--spacing-stack-nano);\n  border-radius: var(--border-radius-sm);\n"])));
var lurker$L = new Lurker('phone_input');
var SendPhone2FATemplate = function SendPhone2FATemplate(_ref) {
  var onChooseAnotherMethodClick = _ref.onChooseAnotherMethodClick,
      onSuccess = _ref.onSuccess,
      sendSMS = _ref.sendSMS,
      lockTime = _ref.lockTime,
      phone = _ref.phone,
      token = _ref.token;

  var _useState = useState({
    showGenericError: false,
    showRateLimitError: false,
    showPhoneInUseError: false,
    showPhoneInBlackListError: false
  }),
      errors = _useState[0],
      setErrors = _useState[1];

  var _useState2 = useState(false),
      isSubmitting = _useState2[0],
      setIsSubmitting = _useState2[1];

  var isLocked = lockTime > 0;

  var showError = function showError(error) {
    setErrors(function (errors) {
      var _extends2;

      return _extends({}, errors, (_extends2 = {}, _extends2[error] = true, _extends2));
    });
    setIsSubmitting(false);
  };

  useEffect(function () {
    lurker$L.pageLoadEvt();
  }, []);

  var onSubmit = function onSubmit() {
    sendSMS(phone, token).then(onSuccess)["catch"](function () {
      showError('showGenericError');
    });
  };

  return /*#__PURE__*/React.createElement(Form$3, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(ContainerWrapper$4, {
    type: "outlined",
    paddingBottom: "--spacing-stack-xl",
    paddingTop: "--spacing-stack-xl",
    paddingLeft: "--spacing-stack-xl",
    paddingRight: "--spacing-stack-xl"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(StyledText$3, {
    marginBottom: "--spacing-stack-xs"
  }, "Enviaremos um c\xF3digo por SMS para seu n\xFAmero. Em caso de telefone fixo, ligaremos."), errors.showGenericError && /*#__PURE__*/React.createElement(ErrorAlertbox, {
    title: "Falha em nosso sistema",
    showContactUs: false
  }, "Estamos trabalhando pra resolver rapidinho. Tente novamente em alguns minutos."), /*#__PURE__*/React.createElement(WrapperPhoneContainer, null, /*#__PURE__*/React.createElement(Phone, null), /*#__PURE__*/React.createElement(Text.BodyMedium, {
    marginLeft: "--spacing-2"
  }, getMaskedValue(removeMask(phone)).pretty)))), /*#__PURE__*/React.createElement(ButtonsWrapper$4, null, /*#__PURE__*/React.createElement(StyledButton$6, {
    variant: "link-button",
    size: "large",
    onClick: onChooseAnotherMethodClick,
    disabled: isSubmitting,
    marginRight: "--spacing-2"
  }, "Escolher outra op\xE7\xE3o para entrar"), /*#__PURE__*/React.createElement(StyledButton$6, {
    size: "large",
    disabled: isSubmitting || isLocked,
    type: "button",
    role: "button",
    "aria-label": "Enviar c\xF3digo",
    onClick: onSubmit
  }, isLocked ? "Enviar c\xF3digo em " + formatedTime(lockTime) : 'Enviar código'))));
};

var _templateObject$3n, _templateObject2$2E;
var PincodeWrapper$2 = styled.div(_templateObject$3n || (_templateObject$3n = _taggedTemplateLiteralLoose(["\n  max-width: 600px;\n  flex: 1;\n  flex-direction: column;\n  margin: auto;\n  @media screen and (min-width: ", "px) and (max-width: ", "px) {\n    width: 80vw;\n  }\n  @media screen and (max-width: ", "px) {\n    margin: 0 auto;\n    justify-content: center;\n    margin-left: var(--spacing-stack-xxxs);\n    margin-right: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile'] + 1, breakpoints['tablet'], breakpoints['mobile']);
var StyledTitle$2 = styled(Text.TitleLarge)(_templateObject2$2E || (_templateObject2$2E = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: ", "px) {\n    margin-bottom: var(--spacing-stack-xxxs);\n  }\n"])), breakpoints['mobile']);
var smsType = 'PHONE';
var issuer = 'AccountsValhallaGreyLogin';
var SendPhone2FAPage = function SendPhone2FAPage(_ref) {
  var onSuccess = _ref.onSuccess,
      onChooseAnotherMethodClick = _ref.onChooseAnotherMethodClick,
      phone = _ref.phone,
      token = _ref.token,
      abTests = _ref.abTests;

  var _useContext = useContext(CountdownContext),
      lockTime = _useContext.lockTime,
      checkAttemptLockTime = _useContext.checkAttemptLockTime;

  var onSendSMS = function onSendSMS() {
    return sendSMSV3(smsType, issuer, token);
  };

  useEffect(function () {
    checkAttemptLockTime();
  }, []);
  return /*#__PURE__*/React.createElement(PincodeWrapper$2, null, /*#__PURE__*/React.createElement(StyledTitle$2, {
    marginBottom: "--spacing-stack-xs"
  }, "Verifica\xE7\xE3o de Telefone"), /*#__PURE__*/React.createElement(SendPhone2FATemplate, {
    onSuccess: onSuccess,
    onChooseAnotherMethodClick: onChooseAnotherMethodClick,
    sendSMS: onSendSMS,
    lockTime: lockTime,
    phone: phone,
    token: token,
    abTests: abTests
  }));
};
SendPhone2FAPage.propTypes = {
  onSuccess: PropTypes__default.func.isRequired,
  onChooseAnotherMethodClick: PropTypes__default.func.isRequired,
  phone: PropTypes__default.string.isRequired,
  abTests: PropTypes__default.string
};

var _templateObject$3o, _templateObject2$2F, _templateObject3$1T, _templateObject4$1j;
var lurker$M = new Lurker('phone_2fa');
var Wrapper$g = styled.div(_templateObject$3o || (_templateObject$3o = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  flex-direction: column;\n  margin: auto;\n  @media (max-width: ", "px) {\n    margin-left: var(--spacing-stack-xxxs);\n    margin-right: var(--spacing-stack-xxxs);\n  }\n  @media (min-width: 840px) {\n    max-width: 600px;\n  }\n  @media (min-width: ", "px) and (max-width: ", "px) {\n    width: 80vw;\n  }\n"])), breakpoints['mobile'], breakpoints['mobile'] + 1, breakpoints['tablet']);
var ContainerWrapper$5 = styled(Container$7)(_templateObject2$2F || (_templateObject2$2F = _taggedTemplateLiteralLoose(["\n  @media (max-width: ", "px) {\n    border: none !important;\n    padding: 0;\n  }\n"])), breakpoints['mobile']);
var StyledArrow$3 = styled(ArrowLeft)(_templateObject3$1T || (_templateObject3$1T = _taggedTemplateLiteralLoose(["\n  color: var(--color-neutral-darkest);\n"])));
var ArrowContainer$3 = styled.div(_templateObject4$1j || (_templateObject4$1j = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-bottom: var(--spacing-stack-xs);\n"])));
var LOGIN_TYPE = 'PHONE';

var CheckPhone2FAPage = function CheckPhone2FAPage(_ref) {
  var onBackClick = _ref.onBackClick,
      onSuccess = _ref.onSuccess,
      phone = _ref.phone,
      token = _ref.token;

  var _useContext = useContext(CountdownContext),
      lockTime = _useContext.lockTime,
      checkAttemptLockTime = _useContext.checkAttemptLockTime;

  var onPinCodeError = function onPinCodeError(error, eventName, _, showError, onMaxAccountCheckAttemptReached, updateRemainingAttempts) {
    if (error === void 0) {
      error = {};
    }

    if (eventName === void 0) {
      eventName = 'error';
    }

    if (showError === void 0) {
      showError = function showError(error, customMsg) {
      };
    }

    if (onMaxAccountCheckAttemptReached === void 0) {
      onMaxAccountCheckAttemptReached = function onMaxAccountCheckAttemptReached() {};
    }

    if (updateRemainingAttempts === void 0) {
      updateRemainingAttempts = function updateRemainingAttempts() {};
    }

    var _error = error,
        _error$response = _error.response,
        _error$response2 = _error$response === void 0 ? {} : _error$response,
        status = _error$response2.status,
        _error$response2$data = _error$response2.data,
        _error$response2$data2 = _error$response2$data === void 0 ? {} : _error$response2$data,
        message = _error$response2$data2.message,
        _error$response2$data3 = _error$response2$data2.details,
        details = _error$response2$data3 === void 0 ? {
      ttl: 0,
      attempts: 2,
      max_attempts: 4,
      remaining_attempts: 2
    } : _error$response2$data3;

    updateRemainingAttempts(details.remaining_attempts);
    var genericError = 'showGenericError';

    if (eventName !== 'error') {
      genericError = 'showResendCodeError';
    }

    if (status === 401) {
      lurker$M.viewMessageEvt(eventName, {
        accounts_reason: 'unauthorized',
        accounts_status_code: status
      });
      showError(genericError);
    } else if (status === 429) {
      if (message === 'MAX_PHONE_VALIDATION_ATTEMPTS_REACHED') {
        lurker$M.viewMessageEvt(eventName, {
          accounts_reason: 'max_phone_validation',
          accounts_status_code: status
        });
        showError('showMaxPhoneValidationError');
      } else if (message === 'MAX_ATTEMPTS_CHECK_PIN_CODE') {
        lurker$M.viewMessageEvt(eventName, {
          accounts_reason: 'max_account_check_attempts',
          accounts_status_code: status
        });
        onMaxAccountCheckAttemptReached(details.ttl);
        showError('showMaxAccountCheckAttempts');
      } else {
        lurker$M.viewMessageEvt(eventName, {
          accounts_reason: 'rate_limit_exceeded',
          accounts_status_code: status
        });
        showError('showRateLimitError');
      }
    } else if (status === 403) {
      switch (message) {
        case 'INVALID_PIN_CODE':
          lurker$M.viewMessageEvt(eventName, {
            accounts_reason: 'invalid_pin_code',
            accounts_status_code: status
          });
          showError('showInvalidPinCodeError');
          break;

        case 'NO_PIN_CODE':
          lurker$M.viewMessageEvt(eventName, {
            accounts_reason: 'no_pin_code',
            accounts_status_code: status
          });
          showError(genericError);
          break;

        default:
          lurker$M.viewMessageEvt(eventName, {
            accounts_reason: message && typeof message === 'string' ? message.toLowerCase() : 'unexpected_status_code',
            accounts_status_code: status
          });
          showError(genericError);
      }
    } else if (status) {
      lurker$M.viewMessageEvt(eventName, {
        accounts_reason: 'unexpected_status_code',
        accounts_status_code: status,
        accounts_error_message: error && error.message || 'unknown'
      });
      showError(genericError);
    } else {
      lurker$M.viewMessageEvt(eventName, {
        accounts_reason: 'unexpected_error',
        accounts_error_message: error && error.message || 'unknown'
      });
      showError(genericError);
    }
  };

  var checkCode = function checkCode(_, pinCode) {
    return loginWith2FA(pinCode, token, LOGIN_TYPE).then(function (response) {
      lurker$M.viewMessageEvt('email_login_success');
      return response;
    });
  };

  useEffect(function () {
    checkAttemptLockTime();
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper$g, null, /*#__PURE__*/React.createElement(ArrowContainer$3, {
    onClick: onBackClick
  }, /*#__PURE__*/React.createElement(StyledArrow$3, null)), /*#__PURE__*/React.createElement(Text.TitleLarge, {
    marginBottom: "--spacing-stack-xs"
  }, "C\xF3digo de verifica\xE7\xE3o"), /*#__PURE__*/React.createElement(ContainerWrapper$5, {
    type: "outlined",
    paddingBottom: "--spacing-stack-xl",
    paddingTop: "--spacing-stack-xl",
    paddingLeft: "--spacing-stack-xl",
    paddingRight: "--spacing-stack-xl"
  }, /*#__PURE__*/React.createElement(CheckPinCodeTemplate, {
    checkCode: checkCode,
    sendSMS: sendSMS$1,
    makeCall: makeCall$1,
    onResend: checkAttemptLockTime,
    onSuccess: onSuccess,
    onPinCodeError: onPinCodeError,
    phone: phone,
    lockTime: lockTime,
    lurker: lurker$M
  })));
};

CheckPhone2FAPage.propTypes = {
  onBackClick: PropTypes__default.func.isRequired,
  onResend: PropTypes__default.func,
  onSuccess: PropTypes__default.func,
  phone: PropTypes__default.string
};

var router$1 = createNewRouter('SendPhone2FAPage');

var Phone2FALoginChallenge = function Phone2FALoginChallenge(_ref) {
  var phone = _ref.phone,
      token = _ref.token,
      onChooseAnotherMethodClick = _ref.onChooseAnotherMethodClick,
      onSuccess = _ref.onSuccess,
      abTests = _ref.abTests;

  var onSendCodeSuccess = function onSendCodeSuccess() {
    router$1.push('CheckPhone2FAPage');
  };

  var goBack = function goBack(e) {
    if (e) e.preventDefault();

    if (router$1.canPop()) {
      router$1.pop();
    } else {
      router$1.push('SendPhone2FAPage');
    }
  };

  return /*#__PURE__*/React.createElement(CountdownProvider, null, /*#__PURE__*/React.createElement(SimpleHeader, null), /*#__PURE__*/React.createElement(AccessNavigator, {
    router: router$1,
    routes: [{
      route: 'SendPhone2FAPage',
      component: function component() {
        return /*#__PURE__*/React.createElement(SendPhone2FAPage, {
          phone: phone,
          onSuccess: onSendCodeSuccess,
          onChooseAnotherMethodClick: onChooseAnotherMethodClick,
          token: token,
          abTests: abTests
        });
      }
    }, {
      route: 'CheckPhone2FAPage',
      component: function component() {
        return /*#__PURE__*/React.createElement(CheckPhone2FAPage, {
          phone: phone,
          token: token,
          onSuccess: onSuccess,
          onBackClick: goBack,
          abTests: abTests
        });
      }
    }]
  }));
};

var urlAuhorize = 'https://auth.olx.com.br/oauth/v2/authorize';
var grantAccessToUser = function grantAccessToUser(accessData) {
  try {
    var data = _extends({
      decision: 'Aceitar'
    }, accessData);

    return axios.post(urlAuhorize, data, {
      withCredentials: true
    });
  } catch (error) {
    console.error(error);
  }
};
var declineAccessToUser = function declineAccessToUser(accessData) {
  try {
    var data = _extends({
      decision: 'Cancelar'
    }, accessData);

    return axios.post(urlAuhorize, data, {
      withCredentials: true
    });
  } catch (error) {
    console.error(error);
  }
};
var getClientNameById = function getClientNameById(clientId, accessData) {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(axios.get("https://apigw.olx.com.br/oauth/clients/" + clientId + "/name", {
        params: _extends({}, accessData)
      })).then(function (response) {
        return response.data[0].name;
      });
    }, function (error) {
      console.error(error);
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$3p, _templateObject2$2G, _templateObject3$1U, _templateObject4$1k, _templateObject5$W;
var ContentWrapper$g = styled.div(_templateObject$3p || (_templateObject$3p = _taggedTemplateLiteralLoose(["\n  padding-left: 25px;\n"])));
var MainContent = styled.div(_templateObject2$2G || (_templateObject2$2G = _taggedTemplateLiteralLoose([""])));
var List = styled.ul(_templateObject3$1U || (_templateObject3$1U = _taggedTemplateLiteralLoose(["\n  margin-left: 30px;\n"])));
var ListItems = styled.li(_templateObject4$1k || (_templateObject4$1k = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n"])));
var ButtonsWrapper$5 = styled.div(_templateObject5$W || (_templateObject5$W = _taggedTemplateLiteralLoose(["\n  margin-right: 100px;\n"])));

var getScopeDescriptions = function getScopeDescriptions(scopeFromQueryString) {
  var basicUserInfo = scopeFromQueryString === null || scopeFromQueryString === void 0 ? void 0 : scopeFromQueryString.includes('basic_user_info');
  var autoUpload = scopeFromQueryString === null || scopeFromQueryString === void 0 ? void 0 : scopeFromQueryString.includes('autoupload');
  var descriptions = [];

  if (basicUserInfo) {
    descriptions.push('Obter informações da sua conta de usuário');
  }

  if (autoUpload) {
    descriptions.push('Poder inserir anúncios na sua conta de usuário');
  }

  return descriptions;
};

var OauthPage = function OauthPage(props) {
  var accessData = {
    scope: props.scope,
    state: props.state,
    redirect_uri: props.redirectUri,
    response_type: props.responseType,
    client_id: props.clientId
  };

  var redirectToErrorPage = function redirectToErrorPage(errorMenssage) {
    window.location.href = "/error?errorMessage=" + encodeURIComponent(errorMenssage);
    return;
  };

  var validateAccessData = function validateAccessData(accessData) {
    var keys = Object.keys(accessData);
    var emptyValue = keys.find(function (key) {
      return !accessData[key] && key != 'response_type';
    });

    if (emptyValue) {
      redirectToErrorPage('Erro ao obter as Query Strings');
    }
  };

  var _useState = useState(''),
      clientName = _useState[0],
      setClientName = _useState[1];

  var descriptions = getScopeDescriptions(props.scope);
  useEffect(function () {
    validateAccessData(accessData);

    var fetchData = function fetchData() {
      try {
        return Promise.resolve(getClientNameById(props.clientId, accessData)).then(function (name) {
          if (!name) {
            redirectToErrorPage('Erro ao obter o nome do cliente');
          }

          setClientName(name.replace(/\b\w/g, function (firstchar) {
            return firstchar.toUpperCase();
          }));
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    if (!!props.clientId) {
      fetchData();
    }

    fetchData();
  }, [props.clientId]);
  return /*#__PURE__*/React.createElement(ContentWrapper$g, null, /*#__PURE__*/React.createElement(MainContent, null, /*#__PURE__*/React.createElement(Text.TitleMedium, {
    marginTop: "--spacing-5",
    marginBottom: "--spacing-2"
  }, clientName), /*#__PURE__*/React.createElement(Text.BodyMedium, {
    weight: "bold",
    marginBottom: "--spacing-1-5"
  }, clientName, " gostaria de:")), /*#__PURE__*/React.createElement(List, null, descriptions.map(function (description, index) {
    return /*#__PURE__*/React.createElement(ListItems, {
      key: index
    }, /*#__PURE__*/React.createElement(Text.BodyMedium, null, description));
  })), /*#__PURE__*/React.createElement(Text.BodyMedium, {
    marginBottom: "--spacing-10"
  }, clientName, " e a OLX utilizar\xE3o essas informa\xE7\xF5es em conformidade com seus respectivos Termos de Servi\xE7os e Pol\xEDticas de privacidade."), /*#__PURE__*/React.createElement(ButtonsWrapper$5, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    marginBottom: "--spacing-6",
    onClick: function onClick() {
      try {
        var _declineAccessToUser;

        (_declineAccessToUser = declineAccessToUser(accessData)) === null || _declineAccessToUser === void 0 ? void 0 : _declineAccessToUser.then(function (response) {
          window.location.replace(response.data.redirect);
        });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, "Cancelar"), /*#__PURE__*/React.createElement(Button, {
    marginLeft: "--spacing-1",
    marginBottom: "--spacing-6",
    onClick: function onClick() {
      try {
        var _grantAccessToUser;

        (_grantAccessToUser = grantAccessToUser(accessData)) === null || _grantAccessToUser === void 0 ? void 0 : _grantAccessToUser.then(function (response) {
          window.location.replace(response.data.redirect);
        });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, "Aceitar"))));
};

export { AccountDeactivationConfirmationPage, AccountDeactivationPage, AccountEliminationConfirmationPage, AccountEliminationPage, AccountLevelPage, AccountReactivationStack, AccountTakeoutConfirmationPage, AddressForm, AddressManager, AddressSideSheet, CONFIRM_EMAIL_PATH, CONFIRM_PHONE_PATH, ChangePasswordExpiredLinkPage, ChangePasswordPage, ChangedPasswordPage, CircularIntegerProgress, CompleteFacebookInfoPage, EmailChangeActivationPage, EmailChangeSendMailPage, EmailConfirmationSentPage, EmailLoginPage, EmailValidationTemplate, FacebookIconButton, FacebookLoginPage, ForgotPasswordPage, GenericErrorBox, GoogleIconButton, GoogleLoginPage, HelpModalTemplate, IconButton, LevelProgress, LevelProgressSkeleton, LevelSteps, LevelStepsSkeleton, MagicLinkEmailSentPage, MagicLinkPage, MagicLinkValidatePage, MyAccountPage, OauthPage, PROFILE_URL, PasswordResetEmailSentPage, Phone2FALoginChallenge, PhoneValidation, RadialProgressSeparator, RegisterPage, RegisterWithTokenPage, ScoreCheckPinCodePage, ScorePinCodePage, ScorePinCodeStack, SecurityCentralPage, SentryWrapper, SideMenu, Skeleton, SkeletonAnimation, SplitLoginPage, SplitLoginStack, StepButton, StepButtonSkeleton, Turnstile, VerificationIncentivePage, WALLET_URL, axios, createNewRouter, removeAuthHeader, setAuthHeader, setDefaultUrl };
//# sourceMappingURL=index.modern.js.map
